"use strict";

/* exported app*/
var app = angular.module("swolApp", [
  "ngCookies",
  "ngResource",
  "ngSanitize",
  "btford.socket-io",
  "ui.router",
  "ui.utils",
  "ui.bootstrap",
  "ui-rangeSlider",
  "angularFileUpload",
  "treeControl",
  "ngKookies",
  "gettext",
  "ui.tree",
  "ui.select",
  "ngPDFViewer",
  "datatables",
  "datatables.bootstrap",
  "LocalStorageModule",
  "angular-svg-round-progress",
  "jsonFormatter",
  "treeGrid",
  "ngDragDrop",
  "ng.deviceDetector",
  "angular-google-analytics",
  "vcRecaptcha",
]).config(["$stateProvider", "$urlRouterProvider", "$locationProvider", "$httpProvider", "localStorageServiceProvider", "AnalyticsProvider", function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, localStorageServiceProvider, AnalyticsProvider) {
  $urlRouterProvider.otherwise("/");
  $locationProvider.html5Mode(true);
  $httpProvider.interceptors.push("authInterceptor");
  localStorageServiceProvider.setPrefix("swol-ls");

  // configure google analytics
  AnalyticsProvider.setAccount("UA-73389856-1");
  AnalyticsProvider.trackUrlParams(true);
  AnalyticsProvider.trackPages(true);

  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }
}]).factory("authInterceptor", ["$q", "$location", "$cookies", "$injector", function ($q, $location, $cookies, $injector) {
  var csrfToken;

  return {
    request: function (config) {
      if (config.url.indexOf("/api/") === 0) {
        config.withCredentials = true;
        if (!/^(GET|HEAD|OPTIONS)$/i.test(config.method)) {
          config.headers = config.headers || {};
          // $cookies.get returns the raw string. $cookieStore.get would JSON.parse the token and throw.
          config.headers["X-CSRF-Token"] = csrfToken || $cookies.get("swol.csrf");
        }
      }

      return config;
    },

    // Intercept 401s and redirect you to login
    responseError: function (response) {
      var config = response.config;
      if (response.status === 403 && response.data && response.data.code === "INVALID_CSRF_TOKEN" &&
          typeof response.data.csrfToken === "string" && response.data.csrfToken &&
          config && !config.csrfRetried && config.url.indexOf("/api/") === 0 &&
          !/^(GET|HEAD|OPTIONS)$/i.test(config.method)) {
        csrfToken = response.data.csrfToken;
        config.csrfRetried = true;
        return $injector.get("$http")(config);
      }

      if (response.status === 401) {
        $location.path("/login");
        return $q.reject(response);
      } else {
        return $q.reject(response);
      }
    }
  };
  }]).run(["$rootScope", "deviceDetector", "$location", "$window", "$log", "$sce", "$cookieStore", "LocalStorage", "Lookups", "Auth", "Analytics", "ExchangeModal", "Env", function ($rootScope, deviceDetector, $location, $window, $log, $sce, $cookieStore, LocalStorage, Lookups, Auth, Analytics, ExchangeModal, Env) {
  $rootScope.asHtml = function (html) {
    return $sce.trustAsHtml(html);
  };

  $rootScope.isInRole = Auth.isInRole;

  var browser = deviceDetector.browser;
  var version = parseInt(deviceDetector.browser_version);
  var os = deviceDetector.os;

  $rootScope.client = browser + " v" + version + " " + os;
  $rootScope.isIE = (browser || "").toLowerCase() === "ie";
  $rootScope.isIE11 = $rootScope.isIE && version === 11;

  Lookups.countries().then(function (data) {
    // save countries into local storage
    LocalStorage.save("countries", data, true);
    $rootScope.countries = data;
  });

  Lookups.languages().then(function (data) {
    // save languages into local storage
    LocalStorage.save("languages", data, true);
    $rootScope.languages = data;
  });

  Lookups.products().then(function (data) {
    // save products into local storage
    LocalStorage.save("products", data, true);
    $rootScope.products = data;
  });

  $rootScope.tabletIsOpen = false;
  $rootScope.toggleTabletSide = function (argument) {
    $rootScope.tabletIsOpen = !$rootScope.tabletIsOpen;
  };

  var nonAdminRedirectUrl = "https://www.siemens-specwriter.com";
  var isRedirectingNonAdmin = false;

  function redirectIfNeeded(user) {
    if (!isRedirectingNonAdmin && user && user.role && user.role !== "admin") {
      isRedirectingNonAdmin = true;
      $window.location.href = nonAdminRedirectUrl;
    }
  }

  function redirectNonAdminUser() {
    redirectIfNeeded(Auth.getCurrentUser());
  }

  $rootScope.$watch(function () {
    var currentUser = Auth.getCurrentUser();
    return currentUser && currentUser.role;
  }, function (role) {
    if (role) {
      redirectNonAdminUser();
    }
  });

  redirectNonAdminUser();

  // Redirect to login if route requires auth and you're not logged in
  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
    Analytics.trackPage(toState.url.replace(/:/g, ""));

    if (toState.name === "signup" || toState.name === "create" || toState.name === "change-email") {
      event.preventDefault();
      $location.path("/login");
      return;
    }

    Auth.isLoggedInAsync(function (loggedIn) {
      if (toState.authenticate && !loggedIn) {
        $location.path("/login");
        return;
      }

      if (loggedIn) {
        redirectNonAdminUser();
      }
    });

    if (toState.roles && !Auth.isInRole(toState.roles)) {
      event.preventDefault();
      $location.path("/login");
    }
  });

  function getOrigin(url, fallbackOrigin) {
    if (!url) return fallbackOrigin;

    var anchor = document.createElement("a");
    anchor.href = url;

    if (!anchor.protocol || !anchor.host) return fallbackOrigin;
    return anchor.protocol + "//" + anchor.host;
  }

  function isWebpackMessage(event) {
    return !!(event && event.data && typeof event.data.type === "string" && event.data.type.indexOf("webpack") === 0);
  }

  function isTrustedAdminMessage(event) {
    return !!(event && event.origin === adminAppOrigin && event.source && event.data && typeof event.data.action === "string");
  }

  function postToAdmin(targetWindow, data) {
    if (!targetWindow) return;
    targetWindow.postMessage(data, adminAppOrigin);
  }

  var currentOrigin = $window.location.protocol + "//" + $window.location.host;
  var adminAppOrigin = getOrigin(Env.adminAppUrl, currentOrigin);

  // postMessage event listener
  var exchangeMessageHandlers = {
    setExchangeBuffer: function (event) {
      if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
      window.EXCHANGE_BUFFER[event.data.key] = event.data.value;
    },

    getExchangeBuffer: function (event) {
      event.data.value = window.EXCHANGE_BUFFER && window.EXCHANGE_BUFFER[event.data.key];
      postToAdmin(event.source, event.data);
    },

    deleteExchangeBuffer: function (event) {
      if (window.EXCHANGE_BUFFER) delete window.EXCHANGE_BUFFER[event.data.key];
    },

    openModal: function (event) {
      ExchangeModal.open(event.data.url, event.data.data, event.data.config)
        .then(function (result) {
          event.data.value = result;
          postToAdmin(event.source, event.data);
        });
    },

    registerModal: function (event) {
      window.CURRENT_MODAL = event.source;
      window.CURRENT_MODAL_ORIGIN = event.origin;
    },

    closeModal: function (event) {
      window.CURRENT_MODAL_INSTANCE.close(event.data);
    },

    default: function (event) {
      console.log("UNKNOWN EXCHANGE MESSAGE:", event);
    }
  };

  function handleExchangeMessage(event) {
    if (!isTrustedAdminMessage(event)) {
      if (!isWebpackMessage(event)) console.log("REJECTED EXCHANGE MESSAGE:", event);
      return;
    }

    (exchangeMessageHandlers[event.data.action] || exchangeMessageHandlers.default)(event);
  }

  // Internet Explorer
  window.attachEvent && window.attachEvent("onmessage", handleExchangeMessage);

  // Opera/Mozilla/Webkit
  window.addEventListener && window.addEventListener("message", handleExchangeMessage, false);
}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("login", {
        url: "/login",
        templateUrl: "app/account/login/login.html",
        controller: "LoginCtrl"
      })
      .state("signup", {
        url: "/signup",
        templateUrl: "app/account/signup/signup.html",
        controller: "SignupCtrl",
        authenticate: false
      })
      .state("forgot-password", {
        url: "/login/forgot-password",
        templateUrl: "app/account/forgot-password/forgot-password.html",
        controller: "ForgotPasswordCtrl",
        authenticate: false
      })
      .state("reset-password", {
        url: "/login/reset-password/:token",
        templateUrl: "app/account/reset-password/reset-password.html",
        controller: "ResetPasswordCtrl",
        authenticate: false
      })
      .state("create", {
        url: "/signup/:token",
        templateUrl: "app/account/create/create.html",
        controller: "CreateUserCtrl",
        authenticate: false
      })
      .state("settings", {
        url: "/settings",
        templateUrl: "app/account/settings/settings.html",
        controller: "SettingsCtrl",
        authenticate: true
      }).state("change-email", {
        url: "/change-email/:token",
        templateUrl: "app/account/change-email/change-email.html",
        controller: "ChangeEmailCtrl"
      })
      .state("video-tutorial", {
        url: "/video-tutorial/:video",
        templateUrl: "app/account/video-tutorial/video-tutorial.html",
        controller: "VideoTutorialCtrl"
      })
      .state("contact-us", {
        url: "/contact-us",
        templateUrl: "app/account/contact-us/contact-us.html",
        controller: "ContactUsCtrl"
      });
  }]);

/* global angular */
"use strict";

angular.module("swolApp")
  .controller("ChangeEmailCtrl", ["$location", function ($location) {
    $location.path("/login");
  }]);

"use strict";

angular.module("swolApp")
  .controller("ContactUsCtrl", ["$scope", "$log", "User", "Auth", "$http", "vcRecaptchaService", function ($scope, $log, User, Auth, $http, vcRecaptchaService) {
    $scope.response = null;
    $scope.widgetId = null;
    $scope.alerts = [
      // {type:'success',msg:'test msg'},
      // {type:'danger',msg:'test msg'},
    ];
    $scope.closeAlert = function (index) {
      $scope.alerts.splice(index, 1);
    };
    $scope.model = {
      key: "6Le6c54rAAAAAJydyxSCsxqhUgI0PCddfIfrbIf6"
    };
    $scope.message = {};
    $scope.setResponse = function (response) {
      $scope.response = response;
    };
    $scope.setWidgetId = function (widgetId) {
      $scope.widgetId = widgetId;
    };
    $scope.cbExpiration = function () {
      vcRecaptchaService.reload($scope.widgetId);
      $scope.response = null;
    };
    $scope.submit = function () {
      var valid;
      /**
       * SERVER SIDE VALIDATION
       *
       * You need to implement your server side validation here.
       * Send the reCaptcha response to the server and use some of the server side APIs to validate it
       * See https://developers.google.com/recaptcha/docs/verify
       */
      $scope.alerts = [];
      if ($scope.messageForm.$invalid) {
        $scope.alerts.push({ type: "danger", msg: "All fields on the form are required." });
        angular.forEach($scope.messageForm.$error.required, function (field) {
          field.$setDirty();
        });
        return;

      }

      $http.post("/api/contact-us", {
        response: $scope.response,
        message: $scope.message
      }).then(function (response) {
        $scope.response = null;
        vcRecaptchaService.reload($scope.widgetId);
        $scope.alerts.push({ type: "success", msg: "We received your message and will get back to you shortly." });
      },
      function (err) {
        $scope.response = null;
        vcRecaptchaService.reload($scope.widgetId);
        $scope.alerts.push({ type: "danger", msg: "Something went wrong! Try again later!" });
      });
    };
  }]);

"use strict";

app.controller("CreateUserCtrl", ["$scope", "$location", "$stateParams", "TermsOfDialog", "Signup", function ($scope, $location, $stateParams, TermsOfDialog, Signup) {
  $scope.user = {};
  $scope.user.consent = false;
  $scope.errors = {};
  $scope.loading = true;
  $scope.tokenIsValid = false;
  $scope.usernameIsUnique = true;
  $scope.text = "";

  $scope.termsOfUseOpen = function () {
    TermsOfDialog.open($scope.text).then(function (accepted) {
      $scope.user.consent = accepted;
    });
  };

  Signup.validateToken($stateParams.token).then(function (response) {
    $scope.user.username = response.data.token.email;
    $scope.user.email = response.data.token.email;
    $scope.tokenIsValid = true;
    $scope.loading = false;

    if (response.data.axios.text) $scope.text = response.data.axios.text;
    if (response.data.axios.token) $scope.user.consentToken = response.data.axios.token;

    TermsOfDialog.open($scope.text).then(function (accepted) {
      $scope.user.consent = accepted;
    });
  }, function () {
    $scope.errors = {};
    $scope.loading = false;
    $scope.tokenIsValid = false;
  });

  $scope.register = function (form) {
    $scope.errors = {};

    if (form.username.$error.mongoose) form.username.$setValidity("mongoose", true);
    if (form.username.$error.email) form.email.$setValidity("mongoose", true);

    if (form.$valid) {
      Signup.createUser($stateParams.token, $scope.user).then(function () {
        // Account created, redirect to home
        $location.path("/");
      }, function (data, status) {
        switch (status) {
          case 409:
            $scope.tokenIsValid = false;
            $scope.loading = false;
            break;

          default:
            angular.forEach(data.errors, function (error, field) {
              form[field].$setValidity("mongoose", false);
              $scope.errors[field] = error.message;
            });
            break;
        }
      });
    }
  };
}]);

"use strict";

angular.module("swolApp")
  .controller("ForgotPasswordCtrl", ["$scope", "$log", "User", "Auth", function ($scope, $log, User, Auth) {
    $scope.errors = {};

    $scope.forgotPassword = function (form) {
      $scope.submitted = true;

      if (form.$valid) {
        Auth.forgotPassword($scope.email).then(function () {
          $scope.message = "We have sent an email to that address with instructions. Thank you.";
        }, function () {
          $scope.errors = {};
        });
      }
    };
  }]);

"use strict";

angular.module("swolApp")
  .controller("LoginCtrl", ["$scope", "Auth", "$location", function ($scope, Auth, $location) {
    $scope.authError = $location.search().authError;

    $scope.login = function () {
      Auth.login();
    };
  }]);

"use strict";

angular.module("swolApp")
  .controller("ResetPasswordCtrl", ["$scope", "$stateParams", "$location", "$log", "User", "Auth", function ($scope, $stateParams, $location, $log, User, Auth) {
    $scope.errors = {};
    $scope.tokenIsValid = false;
    $scope.userForeName = "";

    Auth.resetPasswordValidate($stateParams.token).then(function (data) {
      $scope.tokenIsValid = true;
      $scope.userForeName = data.name;
    });

    $scope.resetPassword = function (form) {
      $scope.submitted = true;

      if (form.$valid) {
        Auth.resetPassword($stateParams.token, $scope.newPassword).then(function (response) {
          Auth.tmpUserEmail = response.data.userEmail;
          $scope.message = "Password successfully changed.";
          $scope.isPasswordExists = true;
          $location.path("/login");
        }).catch(function () {
          form.password.$setValidity("mongoose", false);
          $scope.errors.other = "Bad Request";
        });
      }
    };
  }]);

"use strict";

angular.module("swolApp")
  .controller("SettingsCtrl", ["$scope", "$location", "$log", "User", "Auth", function ($scope, $location, $log, User, Auth) {
    $scope.errors = {};

    Auth.getCurrentUser().$promise.then(function (user) {
      updateUserInfo(user);
    });

    $scope.updateUser = function (form) {
      $scope.errors = {};

      if (form.username.$error.mongoose) form.username.$setValidity("mongoose", true);
      if (form.username.$error.email) form.email.$setValidity("mongoose", true);

      if (form.$valid) {
        Auth.updateUser($scope.userCopy)
          .then(function (user) {
            // user updated, refresh current user
            Auth.refreshCurrentUser().$promise.then(function (user) {
              updateUserInfo(user);
            });
          }).catch(function (err) {
            angular.forEach(err.data.errors, function (error, field) {
              form[field].$setValidity("mongoose", false);
              $scope.errors[field] = error.message;
            });
          });
      }
    };

    $scope.changePassword = function (form) {
      $scope.submitted = true;
      if (form.$valid) {
        Auth.changePassword( $scope.user.oldPassword, $scope.user.newPassword )
          .then( function () {
            $scope.message = "Password successfully changed.";
          })
          .catch( function () {
            form.password.$setValidity("mongoose", false);
            $scope.errors.other = "Incorrect password";
            $scope.message = "";
          });
      }
    };

    $scope.removeSocialAccount = function (u) {
      Auth.removeOAuthAccount(u.provider, u.id)
        .then(function (user) {
          updateUserInfo(user);
        });
    };

    $scope.removeSocialAccount = function (u) {
      Auth.removeOAuthAccount(u.provider, u.id)
        .then(function (user) {
          updateUserInfo(user);
        });
    };

    // privates
    function updateUserInfo(user) {
      $scope.isPasswordExists = (user.provider === "local");

      $scope.user = user;
      $scope.userCopy = angular.copy($scope.user);

      $scope.OAuth = {
        facebook: user.facebook,
        twitter: user.twitter,
        github: user.github,
        google: user.google,
        linkedin: user.linkedin
      };
      $scope.hasSocialAccounts = user.twitter.length + user.facebook.length + user.google.length + user.linkedin.length > 0;
    }
  }]);

"use strict";

app.controller("SignupCtrl", ["$scope", "$location", "$window", "$stateParams", "Signup", "TermsOfUseDialog", function ($scope, $location, $window, $stateParams, Signup, TermsOfUseDialog) {
  $scope.user = {};
  $scope.errors = {};
  $scope.isSocialSignup = false;

  $scope.register = function (form) {
    $scope.submitted = true;
    $scope.errors = {};

    if (form.$valid) {
      Signup.sendRequest($scope.user.email, "local").then(function () {
        $scope.done = true;
      }, function (data, status) {
        $scope.errors = {};

        switch (data.status) {
          case 409:
            $scope.errors.emailExists = true;
            break;
        }
      });
    }
  };

  $scope.loginOauth = function (provider) {
    if (!$scope.user.termsAccepted) return;

    $window.location.href = "/auth/" + provider + "?intent=signup";
  };

  $scope.termsOfUseOpen = function (event) {
    TermsOfUseDialog.open().then(function (accepted) {
      $scope.user.termsAccepted = accepted;
    });

    $scope.user.termsClickAccepted = $scope.user.termsAccepted;
  };
}]);

"use strict";

app.controller("TermsOfUseCtrl", ["$scope", "$modalInstance", "options", function ($scope, $modalInstance, options) {
  $scope.options = options;

  $scope.accept = function () {
    $modalInstance.close(true);
  };

  $scope.cancel = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("TermsOfUseDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "app/account/signup/terms-of-use/terms-of-use.html",
      controller: "TermsOfUseCtrl",
      size: "lg",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("termsController", ["$scope", "$modalInstance", "options", "$sce", function ($scope, $modalInstance, options, $sce) {
  $scope.htmlBind = $sce.trustAsHtml(('<span>'+options +'</span> '));

  $scope.accept = function () {
    $modalInstance.close(true);
  };

  $scope.cancel = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("TermsOfDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "app/account/create/terms/terms.html",
      controller: "termsController",
      size: "lg",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };
}]);

"use strict";

angular.module("swolApp")
  .controller("VideoTutorialCtrl", ["$scope", "$log", "User", "Auth", "$stateParams", function ($scope, $log, User, Auth, $stateParams) {
    $scope.errors = {};
    console.log($stateParams);
    $scope.params = $stateParams;
    $scope.forgotPassword = function (form) {
      $scope.submitted = true;

      if (form.$valid) {
        Auth.forgotPassword($scope.email).then(function () {
          $scope.message = "We have sent an email to that address with instructions. Thank you.";
        }, function () {
          $scope.errors = {};
        });
      }
    };
  }]);

"use strict";

app.controller("AbandonedRegistrationsCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/abandoned-registration");
}]);



// "use strict";

// app.controller("AbandonedRegistrationsCtrl", function (
//   $scope,
//   $compile,
//   $http,
//   $q,
//   Auth,
//   Confirm,
//   DTOptionsBuilder,
//   DTColumnBuilder
// ) {

//   // TABLE OPTIONS
//   $scope.tableID = "users-data-table";
//   $scope.dt = { instance: null };
  
//   $scope.select = {
//     selectAll: true
//   }

//   $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
//     // return promise that resolves into array of rows for data table
//     return $q(function (resolve, reject) {
//       $http.get("/api/signup/signup-tokens").then(
//         function (response) {
//           $scope.data = response.data;
//           resolve(response.data);
//         },
//         function (err) {
//           reject(err);
//         }
//       );
//     });
//   })
//     .withBootstrap() // Add Bootstrap compatibility
//     .withPaginationType("full_numbers")
//     .withOption("createdRow", createdRow)
//     .withDOM("<\"top\"f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

//   function createdRow(row, data, dataIndex) {
//     // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
//     var rowScope = $scope.$new(false);
//     // set file with row data same way as it happns with ng-repeat
//     rowScope.token = data;
//     // mimic ng-repeat $index
//     rowScope.$index = dataIndex;

//     // Recompiling so we can bind Angular directive to the DT
//     $compile(angular.element(row).contents())(rowScope);
//   }

//   $scope.dtColumns = [
//     DTColumnBuilder.newColumn(null).withTitle("Actions").notSortable().renderWith(actionsHtml),
//     DTColumnBuilder.newColumn(null).withTitle(" ").notSortable().renderWith(checkboxHtml),
//     DTColumnBuilder.newColumn(null).withTitle("Email").renderWith(function (token) {
//       return token.email;
//     }),
//     DTColumnBuilder.newColumn(null).withTitle("Created").renderWith(function (token, type) {
//       if (type === "display") // formatted date for display
//         return moment(new Date(token.created)).format("MM-DD-YYYY HH:mm");
//       else
//         return token.created; // raw for the rest so sorting will work properly
//     }),
//     DTColumnBuilder.newColumn(null).withTitle("Registration Age").renderWith(function (token, type) {
//       if (type === "display") // formatted date for display
//         return moment(new Date(token.created)).fromNow(true);
//       else
//         return token.created; // raw for the rest so sorting will work properly
//     })
//   ];

//   // ACTIONS
//   $scope.resendToken = function (token) {
//     console.log("resend", token);
//     $http.post("/api/signup/signup-tokens/" + token._id + "/resend");
//   };
//   $scope.resendTokenToMe = function (token) {
//     console.log("resend to me", token);
//     $http.post("/api/signup/signup-tokens/" + token._id + "/resend-to-me");
//   };

//   $scope.selected = function () {
//     console.log("Select all")
//     $scope.data.forEach(token => {
//       token.isSelected = $scope.selectAll;
//     })
//   }

//   $scope.deleteToken = function (token) {
//     console.log("delete", token);
//     Confirm.open("Are you sure you want to delete registration request", "Delete Registration", "md").then(
//       function (result) {
//         if (!result) return;
//         $http.delete("/api/signup/signup-tokens/" + token._id).then(function () {
//           reloadData();
//         });
//       }
//     );
//   };

//   $scope.deleteSelected = function() {
//     var deleteArray = [];
//     Confirm.open("Are you sure you want to delete registration request", "Delete Registration", "md").then(
//       function(result) {
//         if(!result) return;
//         $scope.data.forEach(token => {
//           if(token.isSelected) deleteArray.push(new Promise((resolve, reject) => {
//             $http.delete("/api/signup/signup-tokens/" + token._id).then(function () {
//               resolve();
//             })
//           }))
//         })
//         Promise.all(deleteArray).then(function() {
//           reloadData();
//         });
//       })
//   }
  
//   // checkbox
//   function checkboxHtml(token) {
//     return "<input type=\"checkbox\" name=\"selected\" ng-model=\"token.isSelected\"> </input>"
//   }
//   // PRIVATE METHODS
//   function actionsHtml(token) {
//     return "<div class=\"btn-group dropdown\">" +
//         "<a class=\"btn btn-default btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a>" +
//         "<ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\">" +
//           "<li><a class=\"btn-lg\", ng-click=\"resendToken(token)\", title=\"Edit user info\"><i class=\"fa fa-envelope\"></i> Resend Invitation to " + token.email + "</a></li>" +
//           "<li><a class=\"btn-lg\", ng-click=\"resendTokenToMe(token)\", title=\"Edit user info\"><i class=\"fa fa-envelope\"></i> Resend Invitation to " + Auth.getCurrentUser().email + "</a></li>" +
//           "<li><a class=\"btn-lg\", ng-click=\"deleteToken(token, $index)\", title=\"Delete user\"><i class=\"fa fa-trash-o\"></i> Delete </a></li>" +
//         "</ul>" +
//         "</div>";
//   }

//   function reloadData() {
//     console.log($scope.dt.instance)
//     if ($scope.dt.instance) $scope.dt.instance.reloadData();
//   }

//   $scope.downloadAsCsv = function () {
//     var data = "E-mail,Created,Token\r\n" + $scope.data.map(function (x) {
//       return x.email + "," + x.created + "," + x.token;
//     }).join("\r\n");

//     var blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
//     var url = URL.createObjectURL(blob);

//     var a = document.createElement("a");
//     a.download = "pending-registrations.csv";
//     a.target = "_blank";
//     a.href = url;

//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };
// });

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("abandoned_registrations", {
    url: "/admin/abandoned-registrations",
    templateUrl: "app/admin/admin-ext.html",
    controller: "AbandonedRegistrationsCtrl"
  });
}]);

"use strict";

angular.module("swolApp")
  .controller("AdminCtrl", ["$scope", "$http", "Auth", "User", function ($scope, $http, Auth, User) {

    // Use the User $resource to fetch all users
    $scope.users = User.query();

    $scope.delete = function (user) {
      User.remove({ id: user._id });
      angular.forEach($scope.users, function (u, i) {
        if (u === user) {
          $scope.users.splice(i, 1);
        }
      });
    };
  }]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("admin", {
        url: "/admin",
        templateUrl: "app/admin/admin.html",
        controller: "AdminCtrl"
      });
  }]);

"use strict";

app.controller("CountriesCtrl", ["$scope", "$rootScope", "$log", "$filter", "$window", "$stateParams", "$compile", "Auth", "User", "Lookups", "Confirm", "Message", "DTOptionsBuilder", "DTColumnBuilder", "DTInstances", "SaveCountryDialog", "LocalStorage", function (
  $scope,
  $rootScope,
  $log,
  $filter,
  $window,
  $stateParams,
  $compile,
  Auth,
  User,
  Lookups,
  Confirm,
  Message,
  DTOptionsBuilder,
  DTColumnBuilder,
  DTInstances,
  SaveCountryDialog,
  LocalStorage
) {
  // TABLE OPTIONS
  $scope.tableID = "countries-data-table";

  $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
    // return promise that resolves into array of rows for data table
    return Lookups.countries(true);
  })
    .withBootstrap() // Add Bootstrap compatibility
    .withPaginationType("full_numbers")
    .withOption("createdRow", createdRow)
    .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-1\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

  function createdRow(row, data, dataIndex) {
    // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
    var rowScope = $scope.$new(false);
    // set file with row data same way as it happns with ng-repeat
    rowScope.country = data;
    // mimic ng-repeat $index
    rowScope.$index = dataIndex;

    // Recompiling so we can bind Angular directive to the DT
    $compile(angular.element(row).contents())(rowScope);
  }

  $scope.dtColumns = [
    DTColumnBuilder.newColumn(null).withTitle("Actions").notSortable().renderWith(actionsHtml),
    DTColumnBuilder.newColumn(null).withTitle("Name").renderWith(function (country) {
      return country.name;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Code").renderWith(function (country) {
      return country.code;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Translations").renderWith(function (country) {
      return country.translations.length;
    })
  ];

  // ACTIONS
  $scope.save = function (country) {
    SaveCountryDialog.open(country).then(function (countryData) {
      Lookups.saveCountry(countryData).then(reloadData, reloadData);
    });
  };

  $scope.delete = function (country) {
    Confirm.open("Are you sure you want to delete country?", "Delete Country", "md").then(
      function (result) {
        if (!result) return;
        Lookups.deleteCountry(country._id).then(reloadData, reloadData);
      }
    );
  };

  // PRIVATE METHODS
  function actionsHtml() {
    return "<div class=\"btn-group dropdown\"><a class=\"btn btn-default btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\"><li><a ng-click=\"save(country)\", title=\"Edit country info\"><i class=\"fa fa-pencil\"></i> Edit </a></li><li><a ng-click=\"delete(country)\", title=\"Delete country\"><i class=\"fa fa-trash-o\"></i> Delete </a></li></ul></div>";
  }

  function reloadData() {
    Lookups.countries(true).then(function (data) {
      // save countries into local storage
      LocalStorage.save("countries", data, true);
      $rootScope.countries = data;

      DTInstances.getList().then(function (dtInstances) {
        console.log(dtInstances, $scope.tableID, dtInstances[$scope.tableID]);
        dtInstances[$scope.tableID].reloadData();
      });
    });
  }
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_countries", {
    url: "/admin/countries",
    templateUrl: "app/admin/countries/countries.html",
    controller: "CountriesCtrl"
  });
}]);

"use strict";

app.controller("SaveCountryCtrl", ["$scope", "$modalInstance", "country", function ($scope, $modalInstance, country) {
  $scope.country = angular.copy(country || { translations: [] });
  $scope.isEdit = !!country;
  $scope.languageList = angular.copy($scope.languages);

  function initLang() {
    $scope.country.translations.forEach(function (translation) {
      var index = 0;
      translation.lang = _.find($scope.languageList, function (lang, ind) {
        index = ind;
        return lang.code === translation.code;
      });

      if (translation.lang) $scope.languageList.splice(index, 1);
    });
  } initLang();

  $scope.save = function () {
    $modalInstance.close($scope.country);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.addTranslation = function () {
    $scope.autoFocusName = true;
    $scope.country.translations.push({});
  };

  $scope.deleteTranslation = function (index) {
    $scope.country.translations.splice(index, 1);
  };

  $scope.disableSave = function (form) {
    if (!form.$valid) return true;
    var countryCopy = country || {};

    if ($scope.country.name !== countryCopy.name || $scope.country.code !== countryCopy.code) return false;

    if (country.translations) {
      for (var i = 0; i < $scope.country.translations.length; i++) {
        var current = $scope.country.translations[i];

        var exists = _.find(country.translations, function (item) {
          return item.code === current.code && item.name === current.name;
        });

        if (!exists) return false;
      }
    }

    return true;
  };

  // language

  $scope.onLanguageSelected = function (item, translation) {
    translation.code = item.code;
    translation.lang = item;

    var index = $scope.languageList.indexOf(item);
    $scope.languageList.splice(index, 1);
  };

  // fixes text box if user edit language text without changing to specific language
  $scope.languageBlur = function (translation) {
    if (!translation.lang) {
      translation.lang = _.find($scope.languages, function (lang) {
        return lang.code === translation.code;
      });
    }
  };
}]);

"use strict";

app.service("SaveCountryDialog", ["$modal", function ($modal) {
  this.open = function (country) {
    return $modal.open({
      templateUrl: "app/admin/countries/save/save.html",
      controller: "SaveCountryCtrl",
      size: "md",
      resolve: {
        country: function () { return country; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("LanguagesCtrl", ["$scope", "$rootScope", "$log", "$filter", "$window", "$stateParams", "$compile", "Auth", "User", "Lookups", "Confirm", "Message", "DTOptionsBuilder", "DTColumnBuilder", "DTInstances", "SaveLanguageDialog", "LocalStorage", function (
  $scope,
  $rootScope,
  $log,
  $filter,
  $window,
  $stateParams,
  $compile,
  Auth,
  User,
  Lookups,
  Confirm,
  Message,
  DTOptionsBuilder,
  DTColumnBuilder,
  DTInstances,
  SaveLanguageDialog,
  LocalStorage
) {
  // TABLE OPTIONS
  $scope.tableID = "languages-data-table";

  $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
    // return promise that resolves into array of rows for data table
    return Lookups.languages(true);
  })
    .withBootstrap() // Add Bootstrap compatibility
    .withPaginationType("full_numbers")
    .withOption("createdRow", createdRow)
    .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-1\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

  function createdRow(row, data, dataIndex) {
    // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
    var rowScope = $scope.$new(false);
    // set file with row data same way as it happns with ng-repeat
    rowScope.language = data;
    // mimic ng-repeat $index
    rowScope.$index = dataIndex;

    // Recompiling so we can bind Angular directive to the DT
    $compile(angular.element(row).contents())(rowScope);
  }

  $scope.dtColumns = [
    DTColumnBuilder.newColumn(null).withTitle("Actions").notSortable().renderWith(actionsHtml),
    DTColumnBuilder.newColumn(null).withTitle("Name").renderWith(function (language) {
      return language.name;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Native Name").renderWith(function (language) {
      return language.nativeName;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Code").renderWith(function (language) {
      return language.code;
    })
  ];

  // ACTIONS
  $scope.save = function (language) {
    SaveLanguageDialog.open(language).then(function (languageData) {
      Lookups.saveLanguage(languageData).then(reloadData, reloadData);
    });
  };

  $scope.delete = function (language) {
    Confirm.open("Are you sure you want to delete language?", "Delete Language", "md").then(
      function (result) {
        if (!result) return;
        Lookups.deleteLanguage(language._id).then(reloadData, reloadData);
      }
    );
  };

  // PRIVATE METHODS
  function actionsHtml() {
    return "<div class=\"btn-group dropdown\"><a class=\"btn btn-default btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\"><li><a ng-click=\"save(language)\", title=\"Edit language info\"><i class=\"fa fa-pencil\"></i> Edit </a></li><li><a ng-click=\"delete(language)\", title=\"Delete language\"><i class=\"fa fa-trash-o\"></i> Delete </a></li></ul></div>";
  }

  function reloadData() {
    Lookups.languages(true).then(function (data) {
      // save languages into local storage
      LocalStorage.save("languages", data, true);
      $rootScope.languages = data;

      DTInstances.getList().then(function (dtInstances) {
        console.log(dtInstances, $scope.tableID, dtInstances[$scope.tableID]);
        dtInstances[$scope.tableID].reloadData();
      });
    });
  }
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_languages", {
    url: "/admin/languages",
    templateUrl: "app/admin/languages/languages.html",
    controller: "LanguagesCtrl"
  });
}]);

"use strict";

app.controller("SaveLanguageCtrl", ["$scope", "$modalInstance", "language", function ($scope, $modalInstance, language) {
  $scope.language = angular.copy(language || { translations: [] });
  $scope.isEdit = !!language;
  $scope.languageList = angular.copy($scope.languages);

  $scope.save = function () {
    $modalInstance.close($scope.language);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.disableSave = function (form) {
    if (!form.$valid) return true;
    var languageCopy = language || {};

    if ($scope.language.name !== languageCopy.name || $scope.language.nativeName !== languageCopy.nativeName || $scope.language.code !== languageCopy.code) return false;
    return true;
  };
}]);

"use strict";

app.service("SaveLanguageDialog", ["$modal", function ($modal) {
  this.open = function (language) {
    return $modal.open({
      templateUrl: "app/admin/languages/save/save.html",
      controller: "SaveLanguageCtrl",
      size: "md",
      resolve: {
        language: function () { return language; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("ProductLinesCtrl", ["$scope", "$rootScope", "$log", "$filter", "$window", "$stateParams", "$compile", "Auth", "User", "Lookups", "Confirm", "Message", "DTOptionsBuilder", "DTColumnBuilder", "DTInstances", "SaveProductLineDialog", "LocalStorage", function (
  $scope,
  $rootScope,
  $log,
  $filter,
  $window,
  $stateParams,
  $compile,
  Auth,
  User,
  Lookups,
  Confirm,
  Message,
  DTOptionsBuilder,
  DTColumnBuilder,
  DTInstances,
  SaveProductLineDialog,
  LocalStorage
) {
  // TABLE OPTIONS
  $scope.tableID = "products-data-table";

  $scope.deletedItems = [];

  $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
    // return promise that resolves into array of rows for data table
    return Lookups.products(true);
  })
    .withBootstrap() // Add Bootstrap compatibility
    .withPaginationType("full_numbers")
    .withOption("createdRow", createdRow)
    .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-3\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

  function createdRow(row, data, dataIndex) {
    // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
    var rowScope = $scope.$new(false);
    // set file with row data same way as it happens with ng-repeat
    rowScope.product = data;
    // mimic ng-repeat $index
    rowScope.$index = dataIndex;

    // Recompiling so we can bind Angular directive to the DT
    $compile(angular.element(row).contents())(rowScope);
  }

  $scope.dtColumns = [
    DTColumnBuilder.newColumn(null).withTitle("Actions").notSortable().renderWith(actionsHtml),
    DTColumnBuilder.newColumn(null).withTitle("Name").renderWith(function (product) {
      return product.name;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Code").renderWith(function (product) {
      return product.code;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Translations").renderWith(function (product) {
      return product.translations.length;
    })
  ];

  // ACTIONS
  $scope.save = function (product) {
    SaveProductLineDialog.open(product).then(function (productData) {
      Lookups.saveProduct(productData).then(reloadData, reloadData);
    });
  };

  $scope.delete = function (product) {
    Confirm.open("Are you sure you want to delete product line?", "Delete Product Line", "md").then(
      function (result) {
        if (!result) return;
        $scope.deletedItems.push({ translations: product.translations, name: product.name, code: product.code });
        Lookups.deleteProduct(product._id).then(reloadData, reloadData);
      }
    );
  };

  $scope.undo = function () {
    $scope.deletedItems.forEach(
      function(item) {
        Lookups.saveProduct(item).then(reloadData, reloadData);
      }
    );
    $scope.deletedItems = [];
  };

  // PRIVATE METHODS
  function actionsHtml() {
    return "<div class=\"btn-group dropdown\"><a class=\"btn btn-default btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\"><li><a ng-click=\"save(product)\", title=\"Edit Product Line\"><i class=\"fa fa-pencil\"></i> Edit </a></li><li><a ng-click=\"delete(product)\", title=\"Delete Product Line\"><i class=\"fa fa-trash-o\"></i> Delete </a></li></ul></div>";
  }

  function reloadData() {
    Lookups.products(true).then(function (data) {
      // save products into local storage
      LocalStorage.save("products", data, true);
      $rootScope.products = data;

      DTInstances.getList().then(function (dtInstances) {
        console.log(dtInstances, $scope.tableID, dtInstances[$scope.tableID]);
        dtInstances[$scope.tableID].reloadData();
      });
    });
  }
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_product_lines", {
    url: "/admin/product-lines",
    templateUrl: "app/admin/product-lines/product-lines.html",
    controller: "ProductLinesCtrl"
  });
}]);

"use strict";

app.controller("SaveProductLineCtrl", ["$scope", "$modalInstance", "product", function ($scope, $modalInstance, product) {
  $scope.product = angular.copy(product || { translations: [] });
  $scope.isEdit = !!product;
  $scope.languageList = angular.copy($scope.languages);

  function initLang() {
    $scope.product.translations.forEach(function (translation) {
      var index = 0;
      translation.lang = _.find($scope.languageList, function (lang, ind) {
        index = ind;
        return lang.code === translation.code;
      });

      if (translation.lang) $scope.languageList.splice(index, 1);
    });
  } initLang();

  $scope.save = function () {
    $modalInstance.close($scope.product);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.addTranslation = function () {
    $scope.autoFocusName = true;
    $scope.product.translations.push({});
  };

  $scope.deleteTranslation = function (index) {
    $scope.product.translations.splice(index, 1);
  };

  $scope.disableSave = function (form) {
    if (!form.$valid) return true;
    var productCopy = product || {};

    if ($scope.product.name !== productCopy.name || $scope.product.code !== productCopy.code) return false;

    if (product.translations) {
      for (var i = 0; i < $scope.product.translations.length; i++) {
        var current = $scope.product.translations[i];

        var exists = _.find(product.translations, function (item) {
          return item.code === current.code && item.name === current.name;
        });

        if (!exists) return false;
      }
    }

    return true;
  };

  // language

  $scope.onLanguageSelected = function (item, translation) {
    translation.code = item.code;
    translation.lang = item;

    var index = $scope.languageList.indexOf(item);
    $scope.languageList.splice(index, 1);
  };

  // fixes text box if user edit language text without changing to specific language
  $scope.languageBlur = function (translation) {
    if (!translation.lang) {
      translation.lang = _.find($scope.languages, function (lang) {
        return lang.code === translation.code;
      });
    }
  };
}]);

"use strict";

app.service("SaveProductLineDialog", ["$modal", function ($modal) {
  this.open = function (product) {
    return $modal.open({
      templateUrl: "app/admin/product-lines/save/save.html",
      controller: "SaveProductLineCtrl",
      size: "md",
      resolve: {
        product: function () { return product; }
      }
    }).result;
  };
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_files", {
    url: "/admin/files",
    templateUrl: "app/admin/files-repository/files-repository.html",
    controller: "FilesRepositoryCtrl"
  });
}]);

"use strict";

app.controller("BomsTabCtrl", ["$scope", "$log", "$q", "Confirm", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "BillOfMaterialService", "SpecConfigService", "SpecConfigFileUploadService", function ($scope, $log, $q, Confirm, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, BillOfMaterialService, SpecConfigService, SpecConfigFileUploadService ) {
  $scope.bomItemsList = [];
  $scope.queue = SpecConfigFileUploadService.bomQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.bomItemsList.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.bomItemsList, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.bomItemsList, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {

    UploadSpecDataDialog.open("bom").then(function (result) {

      console.log("result ", result);
      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:bom", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (bom) {
    $scope.hideErrors();

    EditSpecDataDialog.open("bill of material", bom.name).then(function (result) {
      if (result.isRename)
        BillOfMaterialService.rename(bom._id, result.name).then(function (response) {
          $scope.bomItemsList[$scope.bomItemsList.indexOf(bom)] = response.data;
          successCallback();
        });
      else
        doUpload(bom._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.bomItemsList, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "bom"
    );
  }

  $scope.delete = function (bom) {
    Confirm.open("Are you sure you want to delete bill of material?", "Delete Bill of Material", "md").then(
      function(result) {
        if (result) {
          var target = $scope.bomItemsList.indexOf(bom);
          $scope.bomItemsList.splice(target, 1);
          bom.isSelected = false;
          $scope.deletedItems.push(bom);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected bills of materials?", "Delete Bills of Materials", "md").then(
      function (result) {
        if (result) {
          var selectedFiles = $scope.bomItemsList.filter(function(item) { item.isSelected });
          $scope.deletedItems.push(...selectedFiles);
          $scope.bomItemsList = $scope.bomItemsList.filter(function(item)  { !item.isSelected });
          $scope.deletedItems.forEach(function(file) { file.isSelected = false });
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(function(file) { file._id });
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(function(itemId) {
      queue = queue.then(() => BillOfMaterialService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.bomItemsList.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.hideErrors = function () {
    $scope.errors = null;
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = angular.toJson(err, true);
  }

  function load() {
    BillOfMaterialService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.bomItemsList = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("PreviewBillOfMaterialCtrl", ["$scope", "$log", "$stateParams", "SpecConfigService", "BillOfMaterialService", function ($scope, $log, $stateParams, SpecConfigService, BillOfMaterialService) {
  $scope.treeOptions = {
    dirSelectable: false
  };

  BillOfMaterialService.fetch($stateParams.id).then(function (response) {
    $scope.billOfMaterials = response;
    $scope.jsonPreview = BillOfMaterialService.transformToTreeData(response);

    SpecConfigService.fetch(response.specConfigID).then(function (response) {
      $scope.specConfig = response;
    });
  });
}]);

"use strict";

app.controller("BuildSpecCtrl", ["$scope", "$rootScope", "$log", "$stateParams", "$location", "Auth", "ProjectService", "$window", function ($scope, $rootScope, $log, $stateParams, $location, Auth, ProjectService, $window) {
  $scope.current = ProjectService.current;

  $scope.isAdmin = Auth.isAdmin;
  $scope.event = null;

  $scope.navigateTo = function (node) {
    if (node.isDisabled) return;
    if (event) $scope.event = event;

    $rootScope.tabletIsOpen = false;

    if (node.questionSetID && node.questionSetID !== $scope.current.questionSet.questions._id) {
      // save latest progress
      $scope.current.saveLatestProgressInfo();

      var full = [];

      full = full.concat($scope.current.progress.questionSets).concat([$scope.current.questionSet]).concat($scope.current.progress.questionSetsNext);

      var qs = _.find(full, function (item) {
        return item.questions._id === node.questionSetID;
      });

      // switch to question set
      $scope.current.switchToQuestionSet(qs, true);
    }

    if ($scope.current.menuItem && (node.type === "MenuItem" || node.path.length > 1)) {
      var current = node;

      while (current.type !== "MenuItem") {
        current = current.parent;
      }

      if ($scope.current.menuItem.id.toString() === current.id.toString()) {
        if (node.type === "MenuItem") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0].children[0] });
        if (node.type === "Group") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0] });
        if (node.type === "Label") $rootScope.$broadcast("qs:navigate:label", { label: node });
        if (node.type === "Question") $rootScope.$broadcast("qs:navigate:question", { question: node });

        $scope.event.stopPropagation();
        return;
      }
    }

    switch (node.type) {
      case "Group":
        // Navigate to group first label
        if (node.children && node.children.length) {
          var labelNode = node.children[0];
          $scope.navigateTo(labelNode);
        }
        break;

      case "Menu":
        // Go to menu tab
        $rootScope.$broadcast("qs:navigate:menu", { id: node.id, tab: "menu" });
        break;

      case "MenuItem":
        $rootScope.$broadcast("qs:navigate:menu:item", { menuItem: node });
        break;

      case "Label":
        if (node.path.length > 0) {
          // Navigate to menu item if is in m enu
          $scope.navigateTo(node.parent.parent);
        }

        // Go to label start page
        $rootScope.$broadcast("qs:navigate:label", { label: node });
        break;

      case "Question":
        if (node.path.length > 1) {
          // Navigate to menu item if is in menu
          $scope.navigateTo(node.parent.parent.parent);
        }

        // Go to question page
        $rootScope.$broadcast("qs:navigate:question", { question: node });
        break;
    }
  };

  // if not current project redirect to open project page
  if (!$scope.current || !$scope.current.project) {
    $location.path("/admin/project/open/" + $stateParams.projectID).replace();
  }

  $scope.getStyles = function (nav) {
    if (!nav.styles) return;

    return {
      "background-color": nav.styles.enabled.background,
      "color": nav.styles.enabled.foreground
    };
  };

  $scope.getProgressColor = function (nav) {
    if (!nav.styles) return;

    if (nav.type === "Menu") {
      return nav.styles.enabled.background;
    } else {
      var state = nav.isDisabled ? "disabled" : "enabled";
      return nav.styles.enabled.background;
    }
  };

  $scope.getProgressValue = function (nav) {
    if (nav.isDisabled || !nav.progress) return;
    return nav.progress.reached / nav.progress.total;
  };

  $scope.manageProjects = function () {
    $location.path("/").replace();
  };

  $scope.goToFolder = function () {
    $location.path("/folder/" + $scope.current.folder._id).replace();
  };

  function saveProject() {
    return new Promise(function (resolve, reject) {
      var data = {
        specConfigID: $scope.current.spec._id,
        name: $scope.current.project.name,
        id: $scope.current.project._id,
        answers: $scope.current.project.answers,
        download: $scope.current.downloads,
        location: $scope.current.project.location,
        progress: $scope.current.project.progress,
        groupsProgress: $scope.current.project.groupsProgress
      };

      ProjectService.save(data).then(function (response) {
        $scope.current.project.version = response.version;
        // callback(response.data._id);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
}]);

"use strict";

app.directive("progressbarHelper", function () {
  return {
    link: function (scope, element, attrs) {
      scope.$watch(element, function () {
        if (element && element.length && element[0].children && element[0].children.length) {
          element[0].children[0].style.backgroundColor = attrs.color;
        }
      });
    }
  };
});

"use strict";

app.controller("ComplianceTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "ComplianceService", "SpecConfigService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, ComplianceService, SpecConfigService, Confirm, SpecConfigFileUploadService ) {
  $scope.list = [];
  $scope.queue = SpecConfigFileUploadService.complianceQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.list.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.list, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.list, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("compliance").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:compliance", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (item, index) {
    EditSpecDataDialog.open("compliance", item.name).then(function (result) {
      if (result.isRename)
        ComplianceService.rename(item._id, result.name).then(function (response) {
          $scope.list[index] = response.data;
          successCallback();
        });
      else
        doUpload(item._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.list, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "compliance"
    );
  }

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete compliance?", "Delete Compliance", "md").then(
      result => {
        if (result) {
          let target = $scope.list.indexOf(item);
          $scope.list.splice(target, 1);
          item.isSelected = false;
          $scope.deletedItems.push(item);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected compliances?", "Delete Compliances", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.list.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.list = $scope.list.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => ComplianceService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.list.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.getTagModalLink = function (file) {
    return $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + "/tag/validate/" + file._id + "/config").toString();
  };

  $scope.validateTags = file => {
    const link = $scope.getTagModalLink(file);
    ExchangeModal.open(
      link,
      { },
      {
        title: "Warnings for " + file.name,
        icon: "fa fa-exclamation-triangle text-danger",
        size: "lg"
      }
    );
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
    $log.error(err);
  }

  function load() {
    ComplianceService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.list = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("SpecDataConflictsCtrl", ["$scope", "$modalInstance", "$log", "files", function ($scope, $modalInstance, $log, files) {
  $scope.files = files;

  $scope.replaceAll = function () {
    $modalInstance.close({
      files: $scope.files
    });
  };

  $scope.declineAll = function () {
    $modalInstance.close({
      files: []
    });
  };

  $scope.decline = function (index) {
    $scope.files.splice(index, 1);

    if (!$scope.files.length) $scope.cancel();
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.service("SpecDataConflictsDialog", ["$modal", function ($modal) {
  this.open = function (files) {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/conflicts/conflicts.html",
      controller: "SpecDataConflictsCtrl",
      size: "md",
      resolve: {
        files: function () { return files; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("ConsistencyTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "ConsistencyService", "SpecConfigService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, ConsistencyService, SpecConfigService, Confirm, SpecConfigFileUploadService ) {
  $scope.list = [];
  $scope.queue = SpecConfigFileUploadService.consistencyQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.list.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.list, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.list, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("consistency").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:consistency", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (item, index) {
    EditSpecDataDialog.open("consistency", item.name).then(function (result) {
      if (result.isRename)
        ConsistencyService.rename(item._id, result.name).then(function (response) {
          $scope.list[index] = response.data;
          successCallback();
        });
      else
        doUpload(item._id, result.files, result.name);
    });
  };

  $scope.getTagModalLink = function (file) {
    return $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + "/tag/validate/" + file._id + "/config").toString();
  };

  $scope.validateTags = file => {
    const link = $scope.getTagModalLink(file);
    ExchangeModal.open(
      link,
      { },
      {
        title: "Warnings for " + file.name,
        icon: "fa fa-exclamation-triangle text-danger",
        size: "lg"
      }
    );
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.list, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "consistency"
    );
  }

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete consistency?", "Delete Consistency", "md").then(
      result => {
        if (result) {
          let target = $scope.list.indexOf(item);
          $scope.list.splice(target, 1);
          item.isSelected = false;
          $scope.deletedItems.push(item);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected consistencies?", "Delete Consistencies", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.list.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.list = $scope.list.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => ConsistencyService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.list.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
    $log.error(err);
  }

  function load() {
    ConsistencyService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.list = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("CreateProjectCtrl", ["$scope", "$log", "$stateParams", "$location", "localStorageService", "ProjectService", "ProjectGroupingService", function ($scope, $log, $stateParams, $location, localStorageService, ProjectService, ProjectGroupingService) {
  if ($stateParams.uuid) {
    // load project info from local storage
    var project = localStorageService.get($stateParams.uuid);

    if (!project) $scope.errorMessage = true;

    ProjectService.create(project).then(function (result) {
      // fetch back all project data from server

      /*
      * determine if we are creating new folder or putting in existing
      *   if project.forNewFolder = true, then project.folderName should be present
      *   else project.folderId should be present
      * */

      ProjectGroupingService.createForProject(result._id, project.forNewFolder, project.folderName, project.folderId).then(function (res) {
        ProjectService.fetch(result._id).then(function () {
          // remove project info from local storage
          localStorageService.remove($stateParams.uuid);

          // redirect to build URL
          $location.path("/admin/specs/build/" + project.specID + "/" + result._id).replace();
        });

      });

    }, function (err) {
      $scope.errorMessage = true;
    });
  } else {
    $scope.errorMessage = true;
  }
}]);

"use strict";

app.controller("SpecConfigCreateCtrl", ["$scope", "$modalInstance", "$log", "SpecConfigService", "Lookups", "data", "Auth", function ($scope, $modalInstance, $log, SpecConfigService, Lookups, data, Auth) {
  $scope.data = data || { key: {} };

  Lookups.userGroups().then(function (groups) {
    $scope.groups = groups;
  });

  if (Auth.isMaster()) {
    $scope.countries = $scope.countries.filter(function (obj) {
      return Auth.getCurrentUser().managedCountries.includes(obj.code);
    });
  }

  $scope.onLanguageSelected = function ($item, $model, $label) {
    console.log("on lang selected");
    $scope.data.key.language = $item.code;
  };

  // fixes text box if user edit language text without changing to specific language
  $scope.languageBlur = function () {
    console.log("languages are", $scope.languages);
    if (!$scope.selectedLanguage) {
      $scope.selectedLanguage = _.find($scope.languages, function (lang) {
        return lang.code === $scope.data.key.language;
      });
    }
  };

  $scope.onProductSelected = function ($item, $model, $label) {
    $scope.data.key.product = $item.code;
  };

  // fixes text box if user edit product text without changing to specific product
  $scope.productBlur = function (event) {
    $scope.data.key.product = event.target.value;
  };

  $scope.save = function () {
    if (!isValid()) return;

    if (data && data._id)
      SpecConfigService.edit($scope.data).then(function (response) {
        $modalInstance.close(response.data);
      });
    else
      SpecConfigService.create($scope.data).then(function (response) {
        $modalInstance.close(response.data);
      });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  function isValid() {
    $scope.errors = [];

    if (!$scope.data.key.country) $scope.errors.push("Country is required");
    if (!$scope.data.key.language) $scope.errors.push("Language is required");
    if (!$scope.data.key.product) $scope.errors.push("Product is required");

    return $scope.errors.length === 0;
  }
}]);

"use strict";

app.service("SpecConfigCreateDialog", ["$modal", function ($modal) {
  this.open = function (data, Auth) {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/create/create.html",
      controller: "SpecConfigCreateCtrl",
      size: "lg",
      resolve: {
        data: function () { return data; },
        Auth: function () { return Auth; },
      }
    }).result;
  };
}]);

"use strict";

app.controller("DataSheetsTabCtrl", ["$scope", "$log", "$q", "Confirm", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "DataSheetsService", "SpecConfigService", "SpecConfigFileUploadService", function ($scope, $log, $q, Confirm, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, DataSheetsService, SpecConfigService, SpecConfigFileUploadService ) {
  $scope.dataSheets = [];
  $scope.queue = SpecConfigFileUploadService.dataSheetQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.dataSheets.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.dataSheets, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.dataSheets, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("dataSheet").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:dataSheet", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (dataSheet) {
    $scope.hideErrors();

    EditSpecDataDialog.open("data sheets", dataSheet.name).then(function (result) {
      if (result.isRename)
        DataSheetsService.rename(dataSheet._id, result.name).then(function (response) {
          $scope.dataSheets[$scope.dataSheets.indexOf(dataSheet)] = response.data;
          successCallback();
        });
      else
        doUpload(dataSheet._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.dataSheets, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "dataSheet"
    );
  }

  $scope.delete = function (dataSheet) {
    Confirm.open("Are you sure you want to delete data sheet?", "Delete Data Sheet", "md").then(
      result => {
        if (result) {
          let target = $scope.dataSheets.indexOf(dataSheet);
          $scope.dataSheets.splice(target, 1);
          dataSheet.isSelected = false;
          $scope.deletedItems.push(dataSheet);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected data sheets?", "Delete Data Sheets", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.dataSheets.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.dataSheets = $scope.dataSheets.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => DataSheetsService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.dataSheets.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.hideErrors = function () {
    $scope.errors = null;
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = angular.toJson(err, true);
  }

  function load() {
    DataSheetsService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.dataSheets = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("PreviewDataSheetCtrl", ["$scope", "$log", "$stateParams", "SpecConfigService", "DataSheetsService", function ($scope, $log, $stateParams, SpecConfigService, DataSheetsService) {
  $scope.treeOptions = {
    dirSelectable: false
  };

  DataSheetsService.fetch($stateParams.id).then(function (response) {
    $scope.dataSheets = response;
    $scope.jsonPreview = DataSheetsService.transformToTreeData(response);
    SpecConfigService.fetch(response.specConfigID).then(function (response) {
      $scope.specConfig = response;
    });
  });
}]);

"use strict";

app.controller("DrawingTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "DrawingService", "SpecConfigService", "QuestionSetService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, DrawingService, SpecConfigService, QuestionSetService, Confirm, SpecConfigFileUploadService ) {
  $scope.list = [];
  $scope.queue = SpecConfigFileUploadService.drawingQueue;
  $scope.deletedItems = [];
  $scope.drawingLinks = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.list.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.list, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.list, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("drawing").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:drawing", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (item, index) {
    EditSpecDataDialog.open("drawing", item.name).then(function (result) {
      if (result.isRename)
        DrawingService.rename(item._id, result.name).then(function (response) {
          $scope.list[index] = response.data;
          successCallback();
        });
      else
        doUpload(item._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.list, function (oldFile) {
        var fileName = newFile.name;
        if (fileName.toLowerCase() === (oldFile.name + "." + oldFile.extension).toLowerCase()) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "drawing"
    );
  }

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete drawing?", "Delete Drawing", "md").then(
      result => {
        if (result) {
          let target = $scope.list.indexOf(item);
          $scope.list.splice(target, 1);
          item.isSelected = false;
          $scope.deletedItems.push(item);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected drawings?", "Delete Drawings", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.list.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.list = $scope.list.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => DrawingService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.list.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getDownloadLink = function (item) {
    if(item._id) return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, item._id);
    else return item.url
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name + "." + item.extension;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
    $log.error(err);
  }

  function load() {
    DrawingService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.list = data;

    QuestionSetService.load($scope.selectedSpecConfig._id).then(function (data){
      data.entryQuestionSet.pages.forEach(x => {
        x.questions.forEach(y => {
          if(y.fileUrl && y.type === "Drawing") {
            $scope.drawingLinks.push({
              extension: "",
              fileName: y.fileUrl,
              specConfigID: $scope.selectedSpecConfig._id,
              url: y.fileUrl
            })
          }
        })
      })
      $scope.list = $scope.list.concat($scope.drawingLinks)
      $scope.selectedSpecConfig.history = $scope.selectedSpecConfig.history.concat($scope.drawingLinks)
    })
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("EditSpecDataCtrl", ["$scope", "$modalInstance", "$log", "title", "name", function ($scope, $modalInstance, $log, title, name) {
  $scope.files = [];
  $scope.title = title;
  $scope.name = name;

  $scope.save = function () {
    if ($scope.saveDisabled()) return;

    $modalInstance.close({
      files: $scope.files,
      name: $scope.name,
      isRename: !$scope.files.length && ($scope.name !== name)
    });
  };

  $scope.fileSelectChanged = function () {
    $scope.isMultiple = $scope.files.length > 1;
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.noChanges = function () {
    if ($scope.isEdit) {
      return !$scope.files.length && $scope.name === name;
    } else {
      return !$scope.name || !$scope.files.length;
    }
  };

  $scope.saveDisabled = function () {
    if (!$scope.name) return true;

    return !$scope.files.length && $scope.name === name;
  };

  $scope.removeFile = function (index) {
    $scope.files.splice(index, 1);
  };

  $scope.setName = function () {
    $scope.name = $scope.files[0] ? $scope.files[0].name : "";
  };

  $scope.showCopyName = function () {
    if (!$scope.files.length) return;

    return $scope.name !== $scope.files[0].name;
  };
}]);

"use strict";

app.service("EditSpecDataDialog", ["$modal", function ($modal) {
  this.open = function (title, name, isEntry) {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/edit/edit.html",
      controller: "EditSpecDataCtrl",
      size: "md",
      resolve: {
        title: function () { return title; },
        name: function () { return name; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("QuestionSetHistoryCtrl", ["$scope", "$modalInstance", "QuestionSetService", "Lookups", "questionSet", function ($scope, $modalInstance, QuestionSetService, Lookups, questionSet) {
  $scope.questionSet = questionSet;

  $scope.revert = function (history) {
    QuestionSetService.revert(questionSet._id, history._id, history.fileName).then(function (response) {
      $scope.questionSet = response.data;
    });
  };

  $scope.delete = function (history) {
    QuestionSetService.forget(questionSet._id, history._id).then(function () {
      var index = questionSet.history.indexOf(history);
      questionSet.history.splice(index, 1);
    });
  };

  $scope.close = function () {
    $modalInstance.close($scope.questionSet);
  };
}]);

"use strict";

app.service("QuestionSetHistoryDialog", ["$modal", function ($modal) {
  this.open = function (questionSet) {
    return $modal.open({
      templateUrl: "app/admin/question-sets/history/history.html",
      controller: "QuestionSetHistoryCtrl",
      size: "lg",
      resolve: {
        questionSet: function () { return questionSet; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("OpenProjectCtrl", ["$scope", "$log", "$stateParams", "$location", "localStorageService", "ProjectService", "PointListService", "RestoreDraftDialog", function ($scope, $log, $stateParams, $location, localStorageService, ProjectService, PointListService, RestoreDraftDialog) {
  $scope.current = ProjectService.current;

  if ($stateParams.projectID) {
    // fetch back all project data from server
    ProjectService.fetch($stateParams.projectID).then(function (project) {
      PointListService.undo = {}; // reset previous saved undo points

      // check if user has draft answers, if it exists ask for restore
      // if($scope.current.project.draft && $scope.current.project.draft.answers && Object.keys($scope.current.project.draft.answers).length) {
      //  RestoreDraftDialog.open().then(function (restore) {
      //
      //    // if user want to restore draft answers set it to current answers and delete draft, after redirect to building page
      //    if(restore){
      //      $scope.current.project.answers = $scope.current.project.draft.answers;
      //      $scope.current.project.location = $scope.current.project.draft.location;
      //      $scope.current.project.progress = $scope.current.project.draft.progress;
      //      $scope.current.project.groupsProgress = $scope.current.project.draft.groupsProgress;
      //    }
      //
      //    // redirect to build URL
      //    redirectToBuild();
      //  }, function(){
      //    // redirect to build URL
      //    redirectToBuild();
      //  });
      // } else {
      // redirect to build URL
      redirectToBuild();
      // }
    }, function (err) { $scope.showError = true;} );
  } else {
    $scope.showError = true;
  }

  function redirectToBuild() {
    // remove draft anyway
    $scope.current.project.draft = {};

    // set current question set
    $scope.current.setCurrentQuestionSet();

    // redirect to build URL
    $location.path("/admin/specs/build/" + ProjectService.current.spec._id + "/" + $stateParams.projectID).replace();
  }
}]);

"use strict";

app.controller("PointListsTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "PointListService", "SpecConfigService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, PointListService, SpecConfigService, Confirm, SpecConfigFileUploadService) {
  $scope.pointLists = [];
  $scope.queue = SpecConfigFileUploadService.pointListQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.pointLists.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.pointLists, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.pointLists, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("pointList").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:pointList", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (pointList) {
    $scope.hideErrors();

    EditSpecDataDialog.open("point list", pointList.name).then(function (result) {
      if (result.isRename)
        PointListService.rename(pointList._id, result.name).then(function (response) {
          $scope.pointLists[$scope.pointLists.indexOf(pointList)] = response.data;
          successCallback();
        });
      else
        doUpload(pointList._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.pointLists, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "pointList"
    );
  }

  $scope.delete = function (pointList) {
    Confirm.open("Are you sure you want to delete point list?", "Delete Point List", "md").then(
      result => {
        if (result) {
          let target = $scope.pointLists.indexOf(pointList);
          $scope.pointLists.splice(target, 1);
          pointList.isSelected = false;
          $scope.deletedItems.push(pointList);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected point lists?", "Delete Point Lists", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.pointLists.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.pointLists = $scope.pointLists.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => PointListService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.pointLists.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.hideErrors = function () {
    $scope.errors = null;
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = angular.toJson(err, true);
  }

  function load() {
    PointListService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.pointLists = data.filter(function (point) { return $scope.selectedSpecConfig.pointLists.indexOf(point._id) >= 0; });
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("PreviewPointListCtrl", ["$scope", "$log", "$stateParams", "PointListService", "SpecConfigService", function ($scope, $log, $stateParams, PointListService, SpecConfigService) {
  $scope.treeOptions = {
    dirSelectable: false
  };
  PointListService.fetch($stateParams.id).then(function (response) {
    $scope.pointList = response;
    $scope.jsonPreview = PointListService.transformToTreeData(response);
    $scope.nonParsedPreview = response.nonParsed ? JSON.stringify(response.nonParsed, null, 2) : "";

    SpecConfigService.fetch(response.specConfigID).then(function (response) {
      $scope.specConfig = response;
    });
  });
}]);

"use strict";

app.controller("PreviewSpecConfigCtrl", ["$scope", "$log", "$stateParams", "Confirm", "SpecConfigService", "QuestionSetService", "ProjectService", "PointListService", "DataSheetsService", "SaveProjectDialog", function ($scope, $log, $stateParams, Confirm, SpecConfigService, QuestionSetService, ProjectService, PointListService, DataSheetsService, SaveProjectDialog) {
  $scope.path = [];
  $scope.answerSets = [];
  $scope.treeData = {};

  SpecConfigService.fetch($stateParams.id).then(function (spec) {
    $scope.spec = spec;

    if (!spec.entryQuestionSetID) return;

    ProjectService.loadBySpec($scope.spec.entryQuestionSetID).then(function (data) {
      $scope.answerSets = data;
    });

    QuestionSetService.fetch(spec.entryQuestionSetID).then(function (response) {
      $scope.questionSet = response;
      $scope.path.push(response._id);
    });
  });

  if ($stateParams.answersID) {
    ProjectService.fetch($stateParams.answersID).then(function (data) {
      $scope.currentAnswerSet = data;
      if (data && data.answers) $scope.renderPreview.doc = data.answers;
    });
  }

  $scope.$on("redirect", function (e, type, name) {
    switch (type) {
      case "QuestionSet":
        QuestionSetService.fetchByName($stateParams.id, name).then(function (response) {
          $scope.questionSet = response;
          $scope.path.push(response._id);
        });

        break;
    }
  });

  $scope.back = function () {
    $scope.renderPreview.pageIndex = 0;
    $scope.path.pop();

    QuestionSetService.fetch($scope.path.pop()).then(function (response) {
      $scope.questionSet = response;
      $scope.path.push(response._id);
    });
  };

  $scope.renderPreview = {
    doc: {},
    docStr: "",
    pageIndex: 0,
    showConfig: true,

    prev: function () {
      this.pageIndex--;
    },

    next: function () {
      this.pageIndex++;
    },

    save: function () {
      var newAnswers = normalizeAnswersJson(this.doc);
      var currentAnswersID = $scope.currentAnswerSet ? $scope.currentAnswerSet._id : null;
      SaveProjectDialog.open($scope.currentAnswerSet).then(function (results) {
        ProjectService.save($scope.questionSet.specConfigID, newAnswers, currentAnswersID, this.pageIndex, results.comments, results.asNew).then(function (response) {
          if (!$scope.currentAnswerSet || results.asNew) {
            $scope.answerSets.push(response.data);
          } else {
            angular.forEach($scope.answerSets, function (answerSet) {
              if (answerSet._id === $scope.currentAnswerSet._id)
                $scope.answerSets[$scope.answerSets.indexOf(answerSet)] = response.data;
            });
          }

          $scope.currentAnswerSet = response.data;
        });
      });
    }
  };

  $scope.$watch("renderPreview.doc", function () {
    $scope.renderPreview.docStr = JSON.stringify($scope.renderPreview.doc, null, 2);
  }, true);

  $scope.$watch("questionSet", function () {
    if ($scope.questionSet && $scope.questionSet.pages && $scope.questionSet.pages.length) {
      $scope.pointLists = PointListService.loadByPages($scope.questionSet.pages, $scope.spec._id);
      $scope.dataSheets = DataSheetsService.loadByPages($scope.questionSet.pages, $scope.spec._id);
    }
  }, true);

  $scope.deleteAnswersSet = function (item) {
    Confirm.open("Are you sure you want to delete answers set?", "Delete Answers Set", "md").then(
      function (result) {
        if (!result) return;

        ProjectService.delete(item._id).then(function () {
          $scope.answerSets.splice($scope.answerSets.indexOf(item), 1);
        });
      }
    );
  };

  function normalizeAnswersJson(answers) {
    answers = angular.copy(answers);
    Object.getOwnPropertyNames(answers).forEach(function (name) {
      var docs = answers[name];
      if (docs instanceof Array) {
        if (docs.length > 0 && docs[0].tempID) {
          angular.forEach(docs, function (doc) {
            delete doc.tempID;
          });
        }
      }
    });

    return answers;
  }

}]);

"use strict";

app.controller("ProjectTabCtrl", ["$scope", "$log", "$q", "$location", "$window", "ProjectService", "ProjectGroupingService", "QuestionSetService", "SpecConfigService", "Confirm", function ($scope, $log, $q, $location, $window, ProjectService, ProjectGroupingService, QuestionSetService, SpecConfigService, Confirm) {
  $scope.projects = null;

  $scope.selectAll = function () {
    var selectedItems = $scope.projects.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.projects, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.projects, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.open = function (project) {
    $window.location.href = "/admin/project/open/" + project._id;
  };

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete project?", "Delete Project", "md").then(
      function (result) {
        if (!result) return;
        var userId = "";
        var folderId = "";
        var projectId = item._id;

        ProjectService.fetchById(item._id)
          .then(function (response) {

            userId = response.createdBy.id;

          })
          .then( function () {
            ProjectGroupingService.folderByProjectAndUserId(userId, projectId)
              .then(function (response) {
                folderId = response._id;

              })
              .then(function () {

                ProjectService.adminDelete(userId, folderId, projectId )
                  .then(function (response) {
                    $scope.projects.splice($scope.projects.indexOf(item), 1);

                    // emit event to update spec's tree
                    $scope.$emit("specDataChanged");
                  })
                  .catch(function (err) {
                    console.log(err);
                  });
              });

          });

      }
    )
      .catch(function (err) {
        console.log(err);
      })
    ;
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete projects?", "Delete Projects", "md").then(
      function (result) {
        if (result) {
          var selectedFiles = $scope.projects.filter(function (item) {
            return item.isSelected;
          });
          // var selectedIds = selectedFiles.map(function(file) { return file._id })
          var queueEntryPoint = $q.defer();
          // create a waiting queue
          var queue = queueEntryPoint.promise;
          // this queues up the asynchronous functions
          selectedFiles.forEach(function (item) {
            queue = queue.then(function () {
              var userId = "";
              var folderId = "";
              var projectId = item._id;

              ProjectService.fetchById(item._id)
                .then(function (response) {

                  userId = response.createdBy.id;

                })
                .then( function () {
                  ProjectGroupingService.folderByProjectAndUserId(userId, projectId)
                    .then(function (response) {
                      folderId = response._id;

                    })
                    .then(function () {
                      return ProjectService.adminDelete(userId, folderId, projectId )
                        .catch(function (err) {
                          console.log(err);
                        });
                    });

                });

            });
          });
          // start processing the queue by resolving our queueEntryPoint
          queueEntryPoint.resolve();
          // All promises are done
          queue.then(function (result) {
            $scope.projects.forEach(function (file) {
              $scope.projects.splice($scope.projects.indexOf(file), 1);
            });
            $scope.$emit("specDataChanged");
          });
        }
      }
    );
  };

  function load() {
    if (!$scope.selectedSpecConfig || !$scope.selectedSpecConfig._id) {
      $scope.projects = null;
      return;
    }

    ProjectService.loadBySpec($scope.selectedSpecConfig._id).then(function (data) {
      $scope.projects = data;
    });
  }

  $scope.$watch("selectedSpecConfig", load);
}]);

"use strict";

app.service("SaveProjectDialog", ["$modal", function ($modal) {
  this.open = function (answers) {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/project/save-project/save-project.html",
      controller: "SaveProjectCtrl",
      size: "md",
      resolve: {
        answers: function () { return answers; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("SaveProjectCtrl", ["$scope", "$modalInstance", "$log", "answers", function ($scope, $modalInstance, $log, answers) {
  $scope.answers = answers;
  if (answers) $scope.comments = answers.comments;

  $scope.save = function () {
    $modalInstance.close({
      comments: $scope.comments,
      asNew: $scope.asNew ? $scope.asNew : false
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.controller("PreviewQuestionSetCtrl", ["$scope", "$log", "$stateParams", "QuestionSetService", "SpecConfigService", function ($scope, $log, $stateParams, QuestionSetService, SpecConfigService) {
  QuestionSetService.fetch($stateParams.id).then(function (response) {
    $scope.questionSet = response;

    $scope.jsonPreview = QuestionSetService.transformToTreeData(response);
    $scope.errorsPreview = JSON.parse(response.validationError);

    SpecConfigService.fetch(response.specConfigID).then(function (response) {
      $scope.specConfig = response;
    });
  });
}]);

"use strict";

app.controller("QuestionSetsTabCtrl", ["$scope", "$stateParams", "$window", "$q", "$rootScope", "$log", "orderByFilter", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "SpecConfigService", "QuestionSetService", "OfficePreviewDialog", "Confirm", "SpecConfigFileUploadService", "SignatureService", function ($scope, $stateParams, $window, $q, $rootScope, $log, orderByFilter, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, SpecConfigService, QuestionSetService, OfficePreviewDialog, Confirm, SpecConfigFileUploadService, SignatureService) {
  $scope.questionSets = [];
  $scope.queue = SpecConfigFileUploadService.questionsSetQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.questionSets.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.questionSets, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.questionSets, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.export = function () {
    $window.open("api/specs-file/" + $stateParams.id, "_blank");
  };

  $scope.upload = function (isEntry) {
    $scope.hideErrors();

    UploadSpecDataDialog.open(isEntry ? "entry question set" : "question set", null, isEntry).then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name, isEntry);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name, isEntry);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:questionsSet", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (questionSet, isEntry) {
    $scope.hideErrors();

    EditSpecDataDialog.open(isEntry ? "entry question set" : "question set", questionSet.name).then(function (result) {
      if (result.isRename)
        QuestionSetService.rename(questionSet._id, result.name).then(function (response) {
          $scope.questionSets[$scope.questionSets.indexOf(questionSet)] = response.data;
          successCallback();
        });
      else
        doUpload(questionSet._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];
    var questionSets = $scope.questionSets;
    if ($scope.entryQuestionSet) questionSets.push($scope.entryQuestionSet);

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach(questionSets, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name, isEntry) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "questionsSet",
      isEntry
    );
  }

  $scope.delete = function (questionSet) {
    Confirm.open("Are you sure you want to delete question set configuration?", "Delete Question Set", "md").then(
      result => {
        if (result) {
          let target = $scope.questionSets.indexOf(questionSet);
          $scope.questionSets.splice(target, 1);
          questionSet.isSelected = false;
          $scope.deletedItems.push(questionSet);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected question set configurations?", "Delete Question Sets", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.questionSets.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.questionSets = $scope.questionSets.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => QuestionSetService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.questionSets.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.previewEntry = function () {
    var tmpList = [];
    angular.forEach($scope.selectedSpecConfig.history, function (history) {
      if (history.refID === $scope.entryQuestionSet._id) tmpList.push(history);
    });

    $scope.current = orderByFilter(tmpList, "-uploaded")[0];

    if (!$scope.current) return;

    SignatureService.directUrl($scope.current).then(function (response) {
      OfficePreviewDialog.open($scope.current.fileName, response, $scope.current.extension).then();
    });
  };

  $scope.hideErrors = function () {
    $scope.errors = null;
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = angular.toJson(err, true);
  }

  function load() {
    QuestionSetService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.questionSets = data.questionSets;
      $scope.entryQuestionSet = data.entryQuestionSet;
    });
  }

  $scope.$watch("selectedSpecConfig", function ( val ) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("ReferredFilesTabCtrl", ["$scope", "$log", "$q", "Confirm", "orderByFilter", "SpecConfigService", "SpecConfigFileUploadService", "FilesRepositoryService", "UploadSpecDataDialog", "EditSpecDataDialog", "QuestionSetService", "BillOfMaterialService", "DataSheetsService", "PointListService", "DrawingService", "SequenceService", "ComplianceService", "ConsistencyService", "SpecificationService", "UploadFileDialog", "OfficePreviewDialog", "SignatureService", function ($scope,
  $log,
  $q,
  Confirm,
  orderByFilter,
  SpecConfigService,
  SpecConfigFileUploadService,
  FilesRepositoryService,
  UploadSpecDataDialog,
  EditSpecDataDialog,
  QuestionSetService,
  BillOfMaterialService,
  DataSheetsService,
  PointListService,
  DrawingService,
  SequenceService,
  ComplianceService,
  ConsistencyService,
  SpecificationService,
  UploadFileDialog,
  OfficePreviewDialog,
  SignatureService) {
  $scope.referredFiles = [];
  $scope.order = {
    fields: ["exists", "-xxx"],
    showMissing: true,
    isDesc: false
  };

  $scope.selectAll = function () {
    var selectedItems = $scope.referredFiles.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.referredFiles, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.referredFiles, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.sortBy = function (order) {
    $scope.order.isDesc = !$scope.order.isDesc;
    $scope.order.fields.pop();
    $scope.order.fields.push($scope.order.isDesc ? order : "-" + order);
  };

  $scope.showMissingChanged = function () {
    if ($scope.order.showMissing) $scope.order.fields.unshift("exists");
    else $scope.order.fields.shift();
  };

  $scope.upload = function (item) {
    if (item.type === "File") {
      UploadFileDialog.open().then(function (result) {
        FilesRepositoryService.upload(null, result.name, result.file, result.description, result.tags, result.mimeType, result.extension)
          .then(successCallback, uploadError);
      });
      return;
    }

    var title = item.type.toLowerCase();
    var type = title;

    switch (item.type) {
      case "Questionnaire":
        title = "question set";
        type = "questionsSet";
        break;
      case "Points List":
        type = "pointList";
        break;
      case "Data Sheets":
      case "Datasheet":
        type = "dataSheet";
        break;
    }

    UploadSpecDataDialog.open(title, item.fileName).then(function (result) {
      doUpload(null, result.files, result.name, type, {
        name: result.referenceName,
        questionSetID: item.questionSetID
      });
    });
  };

  $scope.edit = function (item) {
    if (item.type === "File") {
      UploadFileDialog.open(item.fileName, item.description, item.tags).then(function (result) {
        if (result.isRename)
          FilesRepositoryService.editInfo(item.id, result.name, result.description, result.tags).then(successCallback, uploadError);
        else
          FilesRepositoryService.upload(item._id, result.name, result.file, result.description, result.tags, result.mimeType, result.extension).then(successCallback, uploadError);
      });
      return;
    }

    var service = {};
    var type = item.type.toLowerCase();

    switch (item.type) {
      case "Questionnaire":
        EditSpecDataDialog.open("question set", item.fileName).then(function (result) {
          if (result.isRename)
            QuestionSetService.rename(item.id, result.name).then(successCallback, uploadError);
          else
            QuestionSetService.upload($scope.selectedSpecConfig._id, null, null, result.name, result.file).then(successCallback, uploadError);
        });
        return;
      case "Points List":
        service = PointListService;
        type = "pointList";
        break;
      case "BOM":
        service = BillOfMaterialService;
        type = "bill of material";
        break;
      case "Datasheet":
        service = DataSheetsService;
        type = "dataSheet";
        break;
      case "Drawing":
        service = DrawingService;
        type = "drawing";
        break;
      case "Sequence":
        service = SequenceService;
        type = "sequence";
        break;
      case "Compliance":
        service = ComplianceService;
        type = "compliance";
        break;
      case "Consistency":
        service = ConsistencyService;
        type = "consistency";
        break;
      case "Specification":
        service = SpecificationService;
        type = "specification";
        break;
    }

    EditSpecDataDialog.open(item.type.toLowerCase(), item.fileName).then(function (result) {
      if (result.isRename)
        service.rename(item.id, result.name).then(successCallback, uploadError);
      else
        doUpload(item.id, result.files, result.name, type, {
          name: item.fileName,
          questionSetID: item.questionSetID
        });
    });
  };

  function doUpload(id, files, name, type, reference) {
    if (!angular.isArray(files)) files = [files];

    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      type,
      undefined,
      reference
    );
  }

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.preview = function (item) {
    if (item.type === "File") {
      SignatureService.directUrl(item).then(function (response) {
        OfficePreviewDialog.open(item.fileName, response, item.extension).then();
      });
      return;
    }

    var tmpList = [];
    angular.forEach($scope.selectedSpecConfig.history, function (history) {
      if (history.refID === item.id)
        tmpList.push(history);
    });
    var current = orderByFilter(tmpList, "-uploaded")[0];

    if (!current) return;

    SignatureService.directUrl(current).then(function (response) {
      OfficePreviewDialog.open(current.fileName, response, current.extension).then();
    });
  };

  $scope.delete = function (item) {
    if (item.type === "File") {
      Confirm.open("Are you sure you want to delete file?", "Delete File", "md").then(
        function (result) {
          if (result) FilesRepositoryService.delete(item.id).then(successCallback);
        }
      );
      return;
    }

    var service = {};
    var type = "";

    switch (item.type) {
      case "Questionnaire":
        service = QuestionSetService;
        type = "Question Set";
        break;
      case "Points List":
        service = PointListService;
        type = "Point List";
        break;
      case "BOM":
        service = BillOfMaterialService;
        type = "Bill of Material";
        break;
      case "Datasheet":
        service = DataSheetsService;
        type = "Data Sheet";
        break;
      case "Drawing":
        service = DrawingService;
        type = "drawing";
        break;
      case "Sequence":
        service = SequenceService;
        type = "sequence";
        break;
      case "Compliance":
        service = ComplianceService;
        type = "compliance";
        break;
      case "Consistency":
        service = ConsistencyService;
        type = "consistency";
        break;
      case "Specification":
        service = SpecificationService;
        type = "specification";
        break;
    }

    Confirm.open("Are you sure you want to " + type + "?", "Delete " + type, "md").then(
      function (result) {
        if (result) service.delete(item.id).then(successCallback);
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected Referred Files?", "Delete Referred Files", "md").then(
      function (result) {
        if (result) {
          var selectedFiles = $scope.referredFiles.filter(function (item) {
            return item.isSelected;
          });

          var queueEntryPoint = $q.defer();
          // create a waiting queue
          var queue = queueEntryPoint.promise;
          // this queues up the asynchronous functions
          selectedFiles.forEach(function (item) {
            console.log("selected refs", item);
            queue = queue.then(function () {

              var service = {};
              var type = "";

              switch (item.type) {
                case "Questionnaire":
                  service = QuestionSetService;
                  type = "Question Set";
                  break;
                case "Points List":
                  service = PointListService;
                  type = "Point List";
                  break;
                case "BOM":
                  service = BillOfMaterialService;
                  type = "Bill of Material";
                  break;
                case "Datasheet":
                  service = DataSheetsService;
                  type = "Data Sheet";
                  break;
                case "Drawing":
                  service = DrawingService;
                  type = "drawing";
                  break;
                case "Sequence":
                  service = SequenceService;
                  type = "sequence";
                  break;
                case "Compliance":
                  service = ComplianceService;
                  type = "compliance";
                  break;
                case "Consistency":
                  service = ConsistencyService;
                  type = "consistency";
                  break;
                case "Specification":
                  service = SpecificationService;
                  type = "specification";
                  break;
              }

              if (item.type === "File") {
                console.log("its FIle");
                return FilesRepositoryService.delete(item.id);
              } else {
                console.log("delegating service");
                return service.delete(item.id);
              }
            });
          });
          // start processing the queue by resolving our queueEntryPoint
          queueEntryPoint.resolve();
          // All promises are done
          queue.then(successCallback);
        }
      }
    );
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
  }

  function load() {
    SpecConfigService.referredFiles($scope.selectedSpecConfig._id).then(function (data) {
      $scope.referredFiles = data;
      $scope.selectedSpecConfig.referredFiles = $scope.referredFiles;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.service("QuestionSetHistoryDialog", ["$modal", function ($modal) {
  this.open = function (questionSet) {
    return $modal.open({
      templateUrl: "app/admin/question-sets/history/history.html",
      controller: "QuestionSetHistoryCtrl",
      size: "lg",
      resolve: {
        questionSet: function () { return questionSet; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("SequenceTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "SequenceService", "SpecConfigService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, SequenceService, SpecConfigService, Confirm, SpecConfigFileUploadService ) {
  $scope.list = [];
  $scope.queue = SpecConfigFileUploadService.sequenceQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.list.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.list, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.list, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("sequence").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:sequence", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (item, index) {
    EditSpecDataDialog.open("sequence", item.name).then(function (result) {
      if (result.isRename)
        SequenceService.rename(item._id, result.name).then(function (response) {
          $scope.list[index] = response.data;
          successCallback();
        });
      else
        doUpload(item._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.list, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "sequence"
    );
  }

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete sequence?", "Delete Sequence", "md").then(
      result => {
        if (result) {
          let target = $scope.list.indexOf(item);
          $scope.list.splice(target, 1);
          item.isSelected = false;
          $scope.deletedItems.push(item);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected sequences?", "Delete Sequences", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.list.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.list = $scope.list.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => SequenceService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.list.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.getTagModalLink = function (file) {
    return $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + "/tag/validate/" + file._id + "/config").toString();
  };

  $scope.validateTags = file => {
    const link = $scope.getTagModalLink(file);
    ExchangeModal.open(
      link,
      { },
      {
        title: "Warnings for " + file.name,
        icon: "fa fa-exclamation-triangle text-danger",
        size: "lg"
      }
    );
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
    $log.error(err);
  }

  function load() {
    SequenceService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.list = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("SnapshotsTabCtrl", ["$scope", "$q", "$log", "SpecConfigService", "Confirm", function ($scope, $q, $log, SpecConfigService, Confirm) {
  $scope.snapshots = null;

  $scope.selectAll = function () {
    var selectedItems = $scope.snapshots.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.snapshots, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.snapshots, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.activate = function (snapshot) {
    SpecConfigService.setActiveSnapshot(snapshot._id).then(function () {
      load();
    }, function (err) {
      if (!err) load();
    });
  };

  $scope.delete = function (snapshot) {
    Confirm.open("Are you sure you want to delete spec config snapshot?", "Delete Spec Configuration Snapshot", "md").then(
      function (result) {
        if (!result) return;
        SpecConfigService.delete(snapshot._id).then(load);
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected spec config snapshots?", "Delete Spec Configuration Snapshots", "md").then(
      function (result) {
        if (result) {
          var selectedFiles = $scope.snapshots.filter(function (item) {
            return item.isSelected;
          });
          var selectedIds = selectedFiles.map(function (file) { return file._id; });
          var queueEntryPoint = $q.defer();
          // create a waiting queue
          var queue = queueEntryPoint.promise;
          // this queues up the asynchronous functions
          selectedIds.forEach(function (itemId) {
            queue = queue.then(function () {
              return SpecConfigService.delete(itemId);
            });
          });
          // start processing the queue by resolving our queueEntryPoint
          queueEntryPoint.resolve();
          // All promises are done
          queue.then(successCallback);
        }
      }
    );
  };

  function load() {
    if (!$scope.selectedSpecConfig) {
      $scope.snapshots = null;
      return;
    }

    SpecConfigService.loadSnapshots($scope.selectedSpecConfig._id).then(function (data) {
      $scope.snapshots = data;
    });
  }

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  $scope.$watch("selectedSpecConfig", load);
}]);

"use strict";

app.controller("SpecConfigsCtrl", ["$scope", "$rootScope", "$log", "$sce", "$filter", "$upload", "$window", "$stateParams", "$location", "orderByFilter", "Env", "Auth", "Lookups", "localStorageService", "SpecConfigService", "SpecConfigCreateDialog", "QuestionSetService", "Confirm", "Message", "UnpublishSpecDialog", "CreateProjectDialog", function (
  $scope,
  $rootScope,
  $log,
  $sce,
  $filter,
  $upload,
  $window,
  $stateParams,
  $location,
  orderByFilter,
  Env,
  Auth,
  Lookups,
  localStorageService,
  SpecConfigService,
  SpecConfigCreateDialog,
  QuestionSetService,
  Confirm,
  Message,
  UnpublishSpecDialog,
  CreateProjectDialog
) {
  function initRouts() {
    // check if spec id provided and redirect

    var latest = localStorageService.get("currentSpec");
    var currentID = $stateParams.id || latest;

    if (currentID) $location.path("/admin/specs/" + currentID);
  }

  initRouts();
  // $scope.search = "";
  $scope.sidebarCollapsed = false;
  $scope.showTab = "config";

  $scope.specConfigs = [];
  $scope.selectedSpecConfig = null;

  $scope.treeData = [];
  $scope.colDefs = [
    { field: "Type" },
    { field: "Projects" },
  ];

  $scope.nodeSelected = function (node) {
    if (!node.data) {
      node.exp = !node.exp;
    } else {
      node.selected = !node.selected;

      if (node.selected) changeRoute(node.data);
      else changeRoute();
    }
  };

  $scope.create = function () {
    SpecConfigCreateDialog.open(null, Auth).then(
      function (newSpec) {
        Lookups.products(true).then(function (data) {
          $rootScope.products = data;
        });

        changeRoute(newSpec);
      }
    );
  };

  $scope.edit = function () {
    SpecConfigCreateDialog.open($scope.selectedSpecConfig).then(
      function (spec) {
        var productExists = false;
        $scope.products.forEach(function (item) {
          if (item.code === spec.key.product)
            productExists = true;
        });

        if (productExists) return specConfigsModified(spec, true);

        Lookups.products(true).then(function (data) {
          $scope.products = data;
          specConfigsModified(spec, true);
        });
      }
    );
  };

  $scope.downloadZip = function () {
    var url = SpecConfigService.buildDownloadZipUrl($scope.selectedSpecConfig._id);
    $window.open(url);
  };

  $scope.publish = function () {
    QuestionSetService.load($scope.selectedSpecConfig._id).then(function (data) {
      var all = angular.copy(data.questionSets);
      if (data.entryQuestionSet) all.push(data.entryQuestionSet);
      var message = null;
      if (!data.entryQuestionSet) message = "You can not publish spec config without entry question set";

      var invalid = _.find(all, function (item) {
        return !item.isCompleted;
      });

      if (invalid) message = "Spec config contains invalid question set(s), publishing is not allowed";

      if (message) {
        Message.open(message, "Publishing Denied", "md", "warning");
      } else {
        Confirm.open("Are you sure you want to publish spec configuration?", "Publish Spec Configuration", "md").then(
          function (result) {
            if (!result) return;
            console.log("publishing spec", $scope.selectedSpecConfig);
            SpecConfigService.publish($scope.selectedSpecConfig._id).then(function (data) {
              $scope.selectedSpecConfig = data;
            });
          });
      }
    }
    );
  };

  $scope.unpublish = function () {
    UnpublishSpecDialog.open().then(
      function (result) {
        if (!result) return;

        SpecConfigService.unpublish($scope.selectedSpecConfig._id, result.keepActive).then(function (data) {
          console.log("recived data after unpablishing", data);
          $scope.selectedSpecConfig = data;
        });
      }
    );
  };

  $scope.delete = function (specConfig) {
    if (specConfig.projectCount > 0) {
      Message.open("You can not delete, spec configuration contains " + specConfig.projectCount + " project", "Delete Denied", "md").then();
    } else {
      Confirm.open("Are you sure you want to delete spec configuration?", "Delete Spec Configuration", "md").then(
        function (result) {
          if (!result) return;
          SpecConfigService.delete(specConfig._id).then(function () {
            changeRoute();
          });
        }
      );
    }
  };

  $scope.createProject = function () {
    var options = {
      spec: $scope.selectedSpecConfig,
      specs: $scope.specConfigs
    };

    CreateProjectDialog.open(options).then();
  };

  $scope.getHistoryLink = function (item) {
    var fileName = item.fileName;

    if (item.entity === "Drawing") fileName += "." + item.extension;

    return "api/file/download/" + item._id + "/" + fileName;
  };

  $scope.tableNodeClick = function (node) {
    if (node.Type !== "Spec" && node.selected) {
      node.selected = false;
      return;
    }

    node.expanded = !node.expanded;

    if (node.Type === "Spec") {
      node.selected = !node.selected;

      if (node.selected) changeRoute(node.data);
      else changeRoute();
    }
  };

  // check if file is referred
  $scope.isReferredItem = function (file, type) {
    if (!$scope.selectedSpecConfig || !$scope.selectedSpecConfig.referredFiles) return true;

    var fileName = file.name;
    if (type === "Drawing")
      fileName += "." + file.extension;

    var res = _.find($scope.selectedSpecConfig.referredFiles, function (item) {
      return item.fileName === fileName && item.type === type;
    });

    return res;
  };

  // private methods
  function specConfigsModified(item, isEdited) {
    if (isEdited) $scope.specConfigs[$scope.specConfigs.indexOf($scope.selectedSpecConfig)] = item;
    else $scope.specConfigs.push(item);

    setCurrentSpec();
  }

  function setCurrentSpec() {

    if ($stateParams.id) {
      $scope.selectedSpecConfig = _.find($scope.specConfigs, function (item) {
        return item._id === $stateParams.id;
      });

      var queryParams = "?host=" + window.location.origin;
      if ($location.search().sectionId) queryParams = queryParams + "&sectionId=" + $location.search().sectionId;
      if ($location.search().moduleId) queryParams = queryParams + "&moduleId=" + $location.search().moduleId;
      if ($location.search().pageId) queryParams = queryParams + "&pageId=" + $location.search().pageId;
      if ($location.search().questionId) queryParams = queryParams + "&questionId=" + $location.search().questionId;

      if ($location.search().sectionId) queryParams = queryParams + "&sectionId=" + $location.search().sectionId;
      if ($location.search().equipmentId) queryParams = queryParams + "&equipmentId=" + $location.search().equipmentId;
      if ($location.search().categoryId) queryParams = queryParams + "&categoryId=" + $location.search().categoryId;
      $scope.sidebarCollapsed = !!$scope.selectedSpecConfig;

      if ($scope.selectedSpecConfig) {
        $scope.specConfigUrl = $sce.trustAsResourceUrl(Env.adminAppUrl + "/spec-config/" + $scope.selectedSpecConfig._id + queryParams);
        $scope.specConfigDataSheetsUrl = $sce.trustAsResourceUrl(Env.adminAppUrl + "/spec-config/" + $scope.selectedSpecConfig._id + "/data-sheets");
        $scope.specConfigLogicUrl = $sce.trustAsResourceUrl(Env.adminAppUrl + "/spec-config/" + $scope.selectedSpecConfig._id + "/control-logic");
        $scope.specConfigUsersUrl = $sce.trustAsResourceUrl(Env.adminAppUrl + "/spec-config/" + $scope.selectedSpecConfig._id + "/users");
        $scope.specConfigReportsUrl = $sce.trustAsResourceUrl(Env.adminAppUrl + "/spec-config/" + $scope.selectedSpecConfig._id + "/reports");
      }

      if (!$scope.selectedSpecConfig) changeRoute();
      else localStorageService.set("currentSpec", $scope.selectedSpecConfig._id);
    } else {
      // remove current spec from storage
      localStorageService.remove("currentSpec");
    }

    buildTreeData();
  }

  function changeRoute(specConfig) {
    if (specConfig) {
      // redirect to spec
      $location.path("/admin/specs/" + specConfig._id);
    } else {
      // remove current spec from storage
      localStorageService.remove("currentSpec");

      $location.path("/admin/specs");
    }
  }

  function load() {
    SpecConfigService.list().then(
      function (data) {
        $scope.specConfigs = data;
        $scope.selectedSpecConfig = null;
        $scope.showTree = true;

        setCurrentSpec();
      }
    );
  }

  load();

  function buildTreeData() {
    $scope.treeData = [];
    var tmpIndexes = [];

    $scope.specConfigs.forEach(function (item) {
      var countryIndex = tmpIndexes.indexOf(item.key.country);
      var countryNode = countryIndex >= 0 ? $scope.treeData[countryIndex] : null;

      if (!countryNode) {
        countryNode = {
          Name: $scope.countries.getName(item.key.country),
          Type: "Country",
          Projects: item.projectCount,
          // Active: item.isActive,
          // Published: item.isPublished,
          index: [],
          children: []
        };

        tmpIndexes.push(item.key.country);
        $scope.treeData.push(countryNode);
      } else countryNode.Projects += item.projectCount;

      // console.log(countryNode, countryIndex)

      if ($scope.selectedSpecConfig && item._id === $scope.selectedSpecConfig._id) countryNode.expanded = true;
      var productIndex = countryNode.index.indexOf(item.key.product);
      var productNode = productIndex >= 0 ? countryNode.children[productIndex] : null;

      if (!productNode) {
        productNode = {
          Name: $scope.products.getName(item.key.product),
          Type: "Product",
          Projects: item.projectCount,
          // Active: item.isActive,
          // Published: item.isPublished,
          index: [],
          children: []
        };

        countryNode.index.push(item.key.product);
        countryNode.children.push(productNode);
      } else productNode.Projects += item.projectCount;

      if ($scope.selectedSpecConfig && item._id === $scope.selectedSpecConfig._id) productNode.expanded = true;
      var languageIndex = productNode.index.indexOf(item.key.language);
      var languageNode = languageIndex >= 0 ? productNode.children[languageIndex] : null;

      if (!languageNode) {
        languageNode = {
          Name: $scope.languages.getName(item.key.language),
          Type: "Language",
          Projects: item.projectCount,
          // Active: item.isActive,
          // Published: item.isPublished,
          index: [],
          children: []
        };

        productNode.index.push(item.key.language);
        productNode.children.push(languageNode);
      } else languageNode.Projects += item.projectCount;

      if ($scope.selectedSpecConfig && item._id === $scope.selectedSpecConfig._id) languageNode.expanded = true;
      var aliasIndex = languageNode.index.indexOf(item.key.language);
      var aliasNode = aliasIndex >= 0 ? languageNode.children[aliasIndex] : null;

      if (!aliasNode) {
        var alias = item.alias ? item.alias : "(unnamed)";

        aliasNode = {
          Name: alias,
          Type: "Spec",
          Projects: item.projectCount,
          selected: $scope.selectedSpecConfig && item._id === $scope.selectedSpecConfig._id,
          // Active: item.isActive,
          // Published: item.isPublished,
          data: item
        };

        languageNode.index.push(alias);
        languageNode.children.push(aliasNode);
      }

    });

    $scope.treeData = orderByFilter($scope.treeData, "Name");
  }

  // watches, catch emits, broadcasts
  $scope.$on("specDataChanged", function () {
    if (!$scope.selectedSpecConfig) return;

    SpecConfigService.fetch($scope.selectedSpecConfig._id).then(function (data) {
      $scope.selectedSpecConfig = data;

      // update specs tree
      $scope.specConfigs.forEach(function (item, index) {
        if (data._id === item._id) $scope.specConfigs[index] = $scope.selectedSpecConfig;
      });

      buildTreeData();
    });
  });

  $scope.uploadFile = function () {
    $scope.$broadcast("file:upload:dialog");
  };

  $scope.$on("filesChanged", function (e, a) {
    $scope.filesCount = a.count;
  });

  // show/hide accordion
  $scope.$on("http:completedAll", function (e) {
    $scope.readyToShow = true;
  });

  $scope.logger = function () {
    console.log($scope.treeData);
  };
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_specs", {
    url: "/admin/specs",
    templateUrl: "app/admin/spec-configs/spec-config.html",
    controller: "SpecConfigsCtrl"
  }).state("admin_specs_preview_question_set", {
    url: "/admin/specs/preview/question-set/:id",
    templateUrl: "app/admin/spec-configs/question-sets/preview/preview-question-set.html",
    controller: "PreviewQuestionSetCtrl"
  }).state("admin_specs_preview_point_list", {
    url: "/admin/specs/preview/point-list/:id",
    templateUrl: "app/admin/spec-configs/point-lists/preview/preview-point-list.html",
    controller: "PreviewPointListCtrl"
  }).state("admin_specs_preview_bom", {
    url: "/admin/specs/preview/boms/:id",
    templateUrl: "app/admin/spec-configs/boms/preview/preview-boms.html",
    controller: "PreviewBillOfMaterialCtrl"
  }).state("admin_specs_preview_data-sheet", {
    url: "/admin/specs/preview/data-sheet/:id",
    templateUrl: "app/admin/spec-configs/data-sheets/preview/preview-data-sheet.html",
    controller: "PreviewDataSheetCtrl"
  }).state("admin_specs_preview", {
    url: "/admin/specs/preview/:id/:answersID?",
    templateUrl: "app/admin/spec-configs/preview/preview-spec-config.html",
    controller: "PreviewSpecConfigCtrl"
  }).state("admin_project_create", {
    url: "/admin/project/create/:uuid",
    templateUrl: "app/admin/spec-configs/create-project/create-project.html",
    controller: "CreateProjectCtrl"
  }).state("admin_project_open", {
    url: "/admin/project/open/:projectID",
    templateUrl: "app/admin/spec-configs/open-project/open-project.html",
    controller: "OpenProjectCtrl"
  }).state("admin_project_build", {
    url: "/admin/specs/build/:id/:projectID",
    templateUrl: "app/admin/spec-configs/build/build-spec-config.html",
    controller: "BuildSpecCtrl"
  }).state("admin_specs_selected", {
    url: "/admin/specs/:id",
    templateUrl: "app/admin/spec-configs/spec-config.html",
    controller: "SpecConfigsCtrl"
  }).state("folder_list", {
    url: "/folder/:folderId",
    templateUrl: "components/project-grouping/folder-list.html",
    controller: "FolderListController",
  }).state("shared_specs", {
    url: "/shared-specs",
    templateUrl: "components/project-grouping/folder-list.html",
    controller: "FolderListController",
  });
}]);

"use strict";

app.controller("SpecificationTabCtrl", ["$scope", "$log", "$q", "$sce", "ExchangeModal", "UploadSpecDataDialog", "EditSpecDataDialog", "SpecDataConflictsDialog", "SpecificationService", "SpecConfigService", "Confirm", "SpecConfigFileUploadService", function ($scope, $log, $q, $sce, ExchangeModal, UploadSpecDataDialog, EditSpecDataDialog, SpecDataConflictsDialog, SpecificationService, SpecConfigService, Confirm, SpecConfigFileUploadService ) {
  $scope.list = [];
  $scope.queue = SpecConfigFileUploadService.specificationQueue;
  $scope.deletedItems = [];

  $scope.selectAll = function () {
    var selectedItems = $scope.list.filter(function (element) { return element.isSelected; });
    if (selectedItems.length) {
      angular.forEach($scope.list, function (item) {
        item.isSelected = false;
      });
    } else {
      angular.forEach($scope.list, function (item) {
        item.isSelected = true;
      });
    }
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadSpecDataDialog.open("specification").then(function (result) {
      checkExists(result.files);

      if (!$scope.conflicts.length) {
        doUpload(null, $scope.valids, result.name);
      }
      else {
        SpecDataConflictsDialog.open($scope.conflicts).then(function (solved) {
          var files = solved.files.concat($scope.valids);
          if (files.length) doUpload(null, files, result.name);
        });
      }
    });
  };

  $scope.cancelUpload = function (item) {
    SpecConfigFileUploadService.cancelUpload(item);
  };

  $scope.$on("upload:all:specification", function (e, a) {
    $scope.$emit("specDataChanged");
  });

  $scope.edit = function (item, index) {
    EditSpecDataDialog.open("specification", item.name).then(function (result) {
      if (result.isRename)
        SpecificationService.rename(item._id, result.name).then(function (response) {
          $scope.list[index] = response.data;
          successCallback();
        });
      else
        doUpload(item._id, result.files, result.name);
    });
  };

  function checkExists(files) {
    if (!Array.isArray(files)) files = [files];
    $scope.conflicts = [];
    $scope.valids = [];

    angular.forEach(files, function (newFile) {
      var added = false;
      angular.forEach($scope.list, function (oldFile) {
        if (newFile.name === oldFile.name) {
          $scope.conflicts.push(newFile);
          added = true;
        }
      });
      if (!added) $scope.valids.push(newFile);
    });
  }

  function doUpload(id, files, name) {
    SpecConfigFileUploadService.upload(
      id,
      files,
      (name || ""),
      $scope.selectedSpecConfig._id,
      "specification"
    );
  }

  $scope.delete = function (item) {
    Confirm.open("Are you sure you want to delete specification?", "Delete Specification", "md").then(
      result => {
        if (result) {
          let target = $scope.list.indexOf(item);
          $scope.list.splice(target, 1);
          item.isSelected = false;
          $scope.deletedItems.push(item);
        }
      }
    );
  };

  $scope.deleteSelected = function () {
    Confirm.open("Are you sure you want to delete selected specifications?", "Delete Specifications", "md").then(
      result => {
        if (result) {
          let selectedFiles = $scope.list.filter(item => item.isSelected);
          $scope.deletedItems.push(...selectedFiles);
          $scope.list = $scope.list.filter(item => !item.isSelected);
          $scope.deletedItems.forEach(file => file.isSelected = false);
        }
      }
    );
  };

  $scope.save = function () {
    let selectedIds = $scope.deletedItems.map(file => file._id);
    $scope.deletedItems = [];
    let queueEntryPoint = $q.defer();
    // create a waiting queue
    let queue = queueEntryPoint.promise;
    // this queues up the asynchronous functions
    selectedIds.forEach(itemId => {
      queue = queue.then(() => SpecificationService.delete(itemId));
    });
    // start processing the queue by resolving our queueEntryPoint
    queueEntryPoint.resolve();
    // All promises are done
    queue.then(successCallback);
  };

  $scope.undo = function () {
    $scope.list.push(...$scope.deletedItems);
    $scope.deletedItems = [];
  };

  $scope.getControlLogicLink = function (cl) {
    var ending = cl ? "/logic/" + cl.id : "/logic";
    var currentUrl = $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + ending);
    return currentUrl.toString();
  };

  $scope.openModal = function (item) {
    var edit = item && item.controlLogic;
    var name = item.name;
    var link = $scope.getControlLogicLink(item.controlLogic);

    if (!window.EXCHANGE_BUFFER) window.EXCHANGE_BUFFER = {};
    window.EXCHANGE_BUFFER["fileFunction"] = item.name;

    ExchangeModal.open(
      link,
      { },
      { title: (edit ? "Edit Control Logic " : "Add Control Logic ") + "For " + name, icon: "fa fa-edit", size: "lg" }
    ).then(() => setTimeout(() => load(), 1000));
  };

  $scope.getDownloadLink = function (id) {
    return SpecConfigService.itemDownloadUrl($scope.selectedSpecConfig, id);
  };

  $scope.getTagModalLink = function (file) {
    return $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + "/tag/validate/" + file._id + "/config").toString();
  };

  $scope.validateTags = file => {
    const link = $scope.getTagModalLink(file);
    ExchangeModal.open(
      link,
      { },
      {
        title: "Warnings for " + file.name,
        icon: "fa fa-exclamation-triangle text-danger",
        size: "lg"
      }
    );
  };

  $scope.getRefFilesLink = function (file) {
    return $sce.trustAsResourceUrl("/spec-content/" + $scope.selectedSpecConfig._id + "/referred/" + $scope.selectedSpecConfig._id + "?fileName=" + encodeURIComponent(file.name)).toString();
  };

  $scope.showReferred = function (file) {
    const link = $scope.getRefFilesLink(file);

    ExchangeModal.open(
      link,
      { },
      {
        title: "Questions that reference the file: " + file.name,
        icon: "fa fa-file",
        size: "lg"
      }
    );
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  function successCallback(data) {
    $scope.$emit("specDataChanged");
  }

  function uploadError(err) {
    $scope.errors = err.errors;
    $log.error(err);
  }

  function load() {
    SpecificationService.load($scope.selectedSpecConfig._id).then(function (data) {
      $scope.list = data;
    });
  }

  $scope.$watch("selectedSpecConfig", function (val) {
    if (!val) return;
    load();
  });
}]);

"use strict";

app.controller("UnpublishSpecCtrl", ["$scope", "$modalInstance", function ($scope, $modalInstance) {
  $scope.yes = function () {
    $modalInstance.close(
      { keepActive: $scope.keepActive }
    );
  };

  $scope.no = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("UnpublishSpecDialog", ["$modal", function ($modal) {
  this.open = function () {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/unpublish/unpublish-spec.html",
      controller: "UnpublishSpecCtrl",
      size: "md"
    }).result;
  };
}]);

"use strict";

app.controller("UploadSpecDataCtrl", ["$scope", "$modalInstance", "$log", "title", "name", "isEntry", function ($scope, $modalInstance, $log, title, name, isEntry) {
  $scope.files = [];
  $scope.title = title;
  $scope.name = name;
  $scope.isReferred = name;
  $scope.enableMultiple = isEntry || $scope.isReferred ? false : true;
  $scope.isMultiple = false;
  $scope.agreement = { accepted: false };

  $scope.save = function () {
    if ($scope.saveDisabled()) return;

    $modalInstance.close({
      files: $scope.files,
      name: $scope.isReferred && $scope.agreement.accepted ? $scope.files[0].name : $scope.name,
      referenceName: $scope.isReferred || undefined
    });
  };

  $scope.fileSelectChanged = function () {
    $scope.isMultiple = $scope.files.length > 1;
    $scope.agreement.accepted = false;

    if (!$scope.isReferred)
      setName();
    else $scope.disRef = false;
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.saveDisabled = function () {
    if ($scope.isReferred && $scope.disRef) return true;

    if ($scope.isMultiple) return false;
    return !$scope.name || !$scope.files.length;
  };

  $scope.removeFile = function (index) {
    $scope.files.splice(index, 1);
    $scope.isMultiple = $scope.files.length > 1;
    $scope.agreement.accepted = false;
    setName();

    if ($scope.isReferred) {
      $scope.name = name;
      $scope.disRef = true;
    }
  };

  $scope.showAgreeName = function () {
    if (!$scope.isReferred || !$scope.files.length) return;

    return $scope.name !== $scope.files[0].name;
  };

  function setName() {
    if ($scope.isMultiple) {
      $scope.name = "";
      return;
    }

    $scope.name = $scope.files[0] ? $scope.files[0].name : "";
  }
}]);

"use strict";

app.service("UploadSpecDataDialog", ["$modal", function ($modal) {
  this.open = function (title, name, isEntry) {
    return $modal.open({
      templateUrl: "app/admin/spec-configs/upload/upload.html",
      controller: "UploadSpecDataCtrl",
      size: "md",
      resolve: {
        title: function () { return title; },
        name: function () { return name; },
        isEntry: function () { return isEntry; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("EditUserCtrl", ["$scope", "$modalInstance", "Config", "user", function ($scope, $modalInstance, Config, user) {
  $scope.user = user;
  $scope.userCopy = angular.copy($scope.user);
  $scope.roles = Config.roles;
  $scope.france = true;

  $scope.managedCountriesObj = {};

  (user.managedCountries || []).forEach(function (key) {
    $scope.managedCountriesObj[key] = true;
  });

  $scope.save = function () {
    var toSave = {
      _id: $scope.user._id
    };

    for (var key in $scope.userCopy) {
      var current = $scope.userCopy[key];

      if ($scope.user[key] !== current) toSave[key] = current;
    }

    toSave.managedCountries = [];

    Object.keys($scope.managedCountriesObj).forEach(function (key) {
      if ($scope.managedCountriesObj[key] === true) {
        toSave.managedCountries.push(key);
      }
    });

    // remove social data from update
    delete toSave.facebook;
    delete toSave.twitter;
    delete toSave.google;
    delete toSave.linkedin;

    $modalInstance.close(toSave);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.disableSave = function (form) {
    if (!form.$valid) return true;

    // remove non required fields if they are empty
    if ($scope.userCopy.midname === "") delete $scope.userCopy.midname;
    if ($scope.userCopy.password === "") delete $scope.userCopy.password;

    return $scope.user.forename === $scope.userCopy.forename
            && $scope.user.surname === $scope.userCopy.surname
            && $scope.user.midname === $scope.userCopy.midname
            && $scope.user.email === $scope.userCopy.email
            && $scope.user.username === $scope.userCopy.username
            && $scope.user.company === $scope.userCopy.company
            && $scope.user.country === $scope.userCopy.country
            && $scope.user.language === $scope.userCopy.language
            && $scope.user.password === $scope.userCopy.password
            && $scope.user.managedCountries === $scope.userCopy.managedCountries
            && $scope.user.role === $scope.userCopy.role;
  };

  $scope.updateValues = function () {
    Object.keys($scope.managedCountriesObj).forEach(function (key) {
      if ($scope.userCopy.managedCountries.includes(key))
        $scope.managedCountriesObj[key] = true;
    });
  };
}]);

"use strict";

app.service("EditUserDialog", ["$modal", function ($modal) {
  this.open = function (user) {
    return $modal.open({
      templateUrl: "app/admin/users/edit/edit.html",
      controller: "EditUserCtrl",
      size: "md",
      resolve: {
        user: function () { return user; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("UsersCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/users");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_users", {
    url: "/admin/users",
    templateUrl: "app/admin/admin-ext.html",
    controller: "UsersCtrl"
  });
}]);

"use strict";

app.controller("UsageReportCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/usage-report");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_usage_report", {
    url: "/admin/usage-report",
    templateUrl: "app/admin/admin-ext.html",
    controller: "UsageReportCtrl"
  });
}]);

"use strict";

app.controller("UserActivityCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/user-activity");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_user_activity", {
    url: "/admin/user-activity",
    templateUrl: "app/admin/admin-ext.html",
    controller: "UserActivityCtrl"
  });
}]);

"use strict";

app.controller("SpecificationReportCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/specification-report");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_specification-report", {
    url: "/admin/specification-report",
    templateUrl: "app/admin/admin-ext.html",
    controller: "SpecificationReportCtrl"
  });
}]);

"use strict";

app.controller("NotificationCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/notifications");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_notifications", {
    url: "/admin/notifications",
    templateUrl: "app/admin/admin-ext.html",
    controller: "NotificationCtrl"
  });
}]);

"use strict";

app.controller("AdminManualCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/manual");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_manual", {
    url: "/admin/manual",
    templateUrl: "app/admin/admin-ext.html",
    controller: "AdminManualCtrl"
  });
}]);

"use strict";

app.controller("DashboardManualCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/dashboard");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("admin_dashboard", {
    url: "/admin/dashboard",
    templateUrl: "app/admin/admin-ext.html",
    controller: "DashboardManualCtrl"
  });
}]);

"use strict";

app.controller("UserNotificationCtrl", ["$scope", "$sce", "Env", function ($scope, $sce, Env) {
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + "/user/notifications");
}]);

"use strict";

app.config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("user_notifications", {
    url: "/admin/user/notifications",
    templateUrl: "app/admin/admin-ext.html",
    controller: "UserNotificationCtrl"
  });
}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorial", {
        url: "/tutorial",
        templateUrl: "app/tutorial/tutorial.html",
        controller: "TutorialCtrl"
      });
  }]);

"use strict";

app.controller("TutorialCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialRegistration", {
        url: "/tutorial/registration",
        templateUrl: "app/tutorial/registration/tutorial.html",
        controller: "TutorialRegistrationCtrl"
      });
  }]);

"use strict";

app.controller("TutorialRegistrationCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialMarketing", {
        url: "/tutorial/marketing",
        templateUrl: "app/tutorial/marketing/tutorial.html",
        controller: "TutorialMarketingCtrl"
      });
  }]);

"use strict";

app.controller("TutorialMarketingCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialFire", {
        url: "/tutorial/fire",
        templateUrl: "app/tutorial/fire/tutorial.html",
        controller: "TutorialFireCtrl"
      });
  }]);

"use strict";

app.controller("TutorialFireCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAutomation", {
        url: "/tutorial/building-automation",
        templateUrl: "app/tutorial/automation/tutorial.html",
        controller: "TutorialAutomationCtrl"
      });
  }]);

"use strict";

app.controller("TutorialAutomationCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAdminUI", {
        url: "/tutorial/admin/ui-walk-through",
        templateUrl: "app/tutorial/admin/ui-walk-through/tutorial.html",
        controller: "TutorialAdminUICtrl"
      });
  }]);

"use strict";

app.controller("TutorialAdminUICtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAdminCL", {
        url: "/tutorial/admin/control-logic",
        templateUrl: "app/tutorial/admin/control-logic/tutorial.html",
        controller: "TutorialAdminCLCtrl"
      });
  }]);

"use strict";

app.controller("TutorialAdminCLCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAdminTG", {
        url: "/tutorial/admin/tags",
        templateUrl: "app/tutorial/admin/tags/tutorial.html",
        controller: "TutorialAdminTGCtrl"
      });
  }]);

"use strict";

app.controller("TutorialAdminTGCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAdminPDS", {
        url: "/tutorial/admin/product-data-sheets",
        templateUrl: "app/tutorial/admin/product-data-sheets/tutorial.html",
        controller: "TutorialAdminPDSCtrl"
      });
  }]);

"use strict";

app.controller("TutorialAdminPDSCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialAdminWP", {
        url: "/tutorial/admin/word-plugin",
        templateUrl: "app/tutorial/admin/word-plugin/tutorial.html",
        controller: "TutorialAdminWPCtrl"
      });
  }]);

"use strict";

app.controller("TutorialAdminWPCtrl", ["$scope", function ($scope) {

}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialPowerCreate", {
        url: "/tutorial/power-distribution/create-spec",
        templateUrl: "app/tutorial/power/create-spec/tutorial.html",
        controller: "TutorialPowerCreateCtrl"
      });
  }]);

"use strict";

app.controller("TutorialPowerCreateCtrl", function () {

});

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("tutorialPowerShare", {
        url: "/tutorial/power-distribution/share-spec",
        templateUrl: "app/tutorial/power/share-spec/tutorial.html",
        controller: "TutorialPowerShareCtrl"
      });
  }]);

"use strict";

app.controller("TutorialPowerShareCtrl", function () {

});

app.constant("Config", {
  // list of available languages
  languages: {
    en: "English US",
    es: "Spanish",
    fr: "French"
  },

  treeColors: 5,

  roles: ["admin", "master", "user", "tester", "translator"]
});

"use strict";

app.controller("MainCtrl", ["$scope", "$compile", "$templateCache", "$filter", "$location", "$window", "orderByFilter", "Confirm", "Lookups", "Auth", "ProjectService", "ProjectGroupingService", "SpecConfigService", "CreateProjectDialog", "ProjectNameDialog", "DTOptionsBuilder", "DTColumnBuilder", "DTInstances", "gettextCatalog", "Message", function ($scope,
  $compile,
  $templateCache,
  $filter,
  $location,
  $window,
  orderByFilter,
  Confirm,
  Lookups,
  Auth,
  ProjectService,
  ProjectGroupingService,
  SpecConfigService,
  CreateProjectDialog,
  ProjectNameDialog,
  DTOptionsBuilder,
  DTColumnBuilder,
  DTInstances,
  gettextCatalog,
  Message) {
  $scope.specConfigs = null;
  $scope.tableID = "projects-data-table";

  SpecConfigService.list().then(function (data) {
    $scope.specConfigs = data;
    Lookups.countries().then(function (data) {
      $scope.countries = data;
      Lookups.languages().then(function (data) {
        $scope.languages = data;
        Lookups.products().then(function (data) {
          $scope.products = data;
          $scope.dt = { instance: null };

          // $scope.copy = function (project) {
          //   ProjectNameDialog.open(project.name).then(function (result) {
          //     ProjectService.copy(project._id, result).then(function () {
          //       reloadData();
          //     });
          //   });
          // };

          $scope.rename = function (project) {
            ProjectNameDialog.open(project.name).then(function (newName) {
              ProjectGroupingService.rename(project._id, newName).then(function () {
                reloadData();
              });
            });
          };

          $scope.delete = function (node) {
            Confirm.open("Are you sure you want to delete project?", "Delete Project", "md").then(
              function (result) {
                if (!result) return;

                // node is a node to remove
                if (node.nodes && node.nodes instanceof Array && node.nodes.length > 0) {
                  Message.open("This folder is not empty", "Removal denied", "md", "error");

                  return false;
                }

                ProjectGroupingService.removeRootFolder(node._id).then(function (data) {
                  reloadData();
                });

              }
            );
          };

          $scope.create = function () {

            ProjectService.load().then(function (list) {

              var options = {
                specs: $scope.specConfigs,
                table: $scope.dt
              };

              if (list && list.length) {
                $scope.latestProject = orderByFilter(list, "-created")[0];

                var latestSpec = _.find($scope.specConfigs, function (item) {
                  return item._id === $scope.latestProject.specConfigID;
                });

                if (latestSpec)
                  options.previous = {
                    specID: latestSpec._id,
                    key: latestSpec.key,
                  };
              }

              CreateProjectDialog.open(options).then();
            });

          };

          // $scope.addRootFolder = function() {
          //   ProjectNameDialog.open('new root folder', true).then(function(newName) {
          //     return newName
          //   }).then(function(newName) {
          //     return ProjectGroupingService.addRootFolder(newName)
          //   }).then(function(result) {
          //     reloadData();
          //
          //   })
          // }

          $scope.open = function (project) {
            $location.path("/folder/" + project._id);
            // $window.location.href = '/admin/project/open/' + project._id;
          };

          function reloadData() {
            if ($scope.dt.instance) $scope.dt.instance.reloadData();
          }

          $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            // return promise that resolves into array of rows for data table

            // ProjectService.load().then(function(data){ console.log('data is', data); debugger })

            return ProjectGroupingService.loadPopulated();

          }).withBootstrap() // Add Bootstrap compatibility
            .withPaginationType("full_numbers")
            .withOption("createdRow", createdRow)
            .withOption("order", [1, "asc"])
            .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-4\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

          function createdRow(row, data, dataIndex) {
            // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
            var rowScope = $scope.$new(false);
            // set file with row data same way as it happns with ng-repeat
            rowScope.project = data;
            // mimic ng-repeat $index
            rowScope.$index = dataIndex;

            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())(rowScope);
          }

          $scope.$on("lang-changed", function () {
            console.log("lang changed");
            var strings = document.querySelectorAll(".dt-title");

            Array.from(strings).forEach(function (string) {
              var id = string.getAttribute("id");

              document.getElementById(id).textContent = gettextCatalog.getString(document.getElementById(id).textContent);
            });
          });

          $scope.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("<span class=\"dt-title\" id=\"dt-title-actions\">Actions</span>").notSortable().renderWith(actionsHtml),
            DTColumnBuilder.newColumn(null).withTitle("<span class=\"dt-title\" id=\"dt-title-actions\">Project Name</span>").renderWith(function (project, type) {
              return "<a ng-click=\"open(project)\" href=\"#\">" + project.name + "</a>";
            }),

            DTColumnBuilder.newColumn(null).withTitle("<span class=\"dt-title\" translate id=\"dt-title-actions\">Specification count</span>").renderWith(function (project, type) {
              var children = ProjectGroupingService.collectChildren(project, []);
              return children.length;
            }),

            DTColumnBuilder.newColumn(null).withTitle("<span class=\"dt-title\" translate id=\"dt-title-actions\">Level</span>").renderWith(function (project, type) {
              return project.level;
            }),

            DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("<span class=\"dt-title\" id=\"dt-title-actions\">Date Created</span>")).renderWith(function (project) {
              return moment(project.created_at).format("YYYY/MM/DD");
            }),
          ];

          function actionsHtml() {
            return "<div class=\"btn-group dropdown\">" +
              "<a class=\"btn btn-default btn-primary dropdown-toggle\">" +
              "<span translate >Actions</span>&nbsp;" +
              "<i class=\"fa fa-caret-down\"></i>" +
              "</a>" +
              "<ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\">" +
              "<li><a class=\"btn-lg\", ng-click=\"open(project)\", title=\"Open Project\"><i class=\"fa fa-folder-open-o\"></i> <span translate >Open</span> </a></li>" +
              "<!--<li><a class=\"btn-lg\", ng-click=\"copy(project)\", title=\"Copy Project\"><i class=\"fa fa-copy\"></i> <span translate >Copy</span></a></li>-->" +
              "<li><a class=\"btn-lg\", ng-click=\"rename(project)\", title=\"Rename Project\"><i style=\"margin-right:5px\" class=\"fa fa-pencil\"></i> <span translate >Rename Project</span></a></li>" +
              "<li><a class=\"btn-lg\", ng-click=\"delete(project, $index)\", title=\"Delete Project\"><i style=\"margin-right:5px\" class=\"fa fa-trash-o\"></i> <span translate >Delete</span></a></li>" +
              "</ul>" +
              "</div>";
          }

          function getSpecInfo(project) {

            if (project) {

              for (var i = 0; i < $scope.specConfigs.length; i++) {
                var spec = $scope.specConfigs[i];

                if (project && project.project.specConfigID === spec._id) {
                  var data = {
                    alias: spec.alias,
                    country: $scope.countries.getName(spec.key.country),
                    language: $scope.languages.getName(spec.key.language),
                    product: $scope.products.getName(spec.key.product)
                  };

                  return data;
                }
              }
            } else return {};

          }
        });
      });
    });
  });
}]);

"use strict";

angular.module("swolApp")
  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state("main", {
        url: "/",
        templateUrl: "app/main/main.html",
        controller: "MainCtrl"
      });
  }]);

"use strict";

app.directive("eqAndSysQstTree", function () {
  return {
    restrict: "E",
    templateUrl: "components/eq-and-sys-qst-tree/eq-and-sys-qst-tree.html",
    // replace: true,

    scope: true,

    link: function (scope) {

      scope.trees = function () {
        if (!scope.current.questionSet) return;
        var treePages = scope.current.questionSet.menus[0].pages.slice(0, 2);
        var trees = [];
        treePages[0].questions.forEach(function (question) {
          trees.push(question);
        });

        trees.forEach(function (tree) {
          tree.answers.forEach(function (answer) {
            answer.subQuestion = _.find(treePages[1].questions, function (question) {
              question.answers.forEach(function (subAnswer) {
                var id = "(" + tree.id + "-" + answer.id + ")" + "(" + question.id + "-" + subAnswer.id + ")";

                scope.$parent.questionAnswerGroups[id] = {
                  q1: tree,
                  a1: answer,
                  q2: question,
                  a2: subAnswer
                };
              });
              return question.controlLogic === "(" + tree.id + "-" + answer.id + ")";
            });
          });
        });
        return trees;
      }();

    }
  };

});

"use strict";

app.controller("RenameProjectCtrl", ["$scope", "$modalInstance", "name", "isNewName", function ($scope, $modalInstance, name, isNewName) {
  $scope.name = name;
  $scope.isRename = name;
  $scope.isNewName = isNewName || false;
  $scope.save = function () {
    $modalInstance.close($scope.name);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.disableSave = function () {
    if (!$scope.name) return true;

    if (!$scope.isRename) return !$scope.name;

  };
}]);

"use strict";

app.service("ProjectNameDialog", ["$modal", function ($modal) {
  this.open = function (name, isNewName) {
    return $modal.open({
      templateUrl: "app/main/rename-project/rename-project.html",
      controller: "RenameProjectCtrl",
      size: "md",
      resolve: {
        name: function () { return name; },
        isNewName: function () { return isNewName; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("InviteProjectCtrl", ["$scope", "$modalInstance", "ProjectService", "project", "Auth", function ($scope, $modalInstance, ProjectService, project, Auth) {
  $scope.project = project;
  $scope.users = [];
  $scope.selectedUsers = [];
  $scope.filteredUsers = [];
  $scope.teamUsers = [];
  $scope.search = "";
  $scope.modifyFlag = false;
  $scope.modifyTab = false;

  const currentUser = Auth.getCurrentUser();

  $scope.notification = {
    subject: "Specification has been shared with you",
    text: currentUser.forename + " " + currentUser.surname + " has shared specification \"" + project.name + "\" with you.",
    published: false,
    usersFor: [],
    report: [],
    toEmail: true,
    audience: {
      role: [],
      language: [],
      country: [],
      company: ""
    }
  };

  ProjectService.invite().then(function (result) {
    var currentUserId = Auth.getCurrentUser()._id;

    $scope.users = result.data.filter(x => {
      return x._id !== currentUserId;
    });

    $scope.filteredUsers = $scope.users;
    $scope.modifyTab = true;
  });

  $scope.filter = function () {
    $scope.filteredUsers = $scope.users.filter(x =>
      (!$scope.search || [
        x.username
      ].some(v => {
        if (v)
          return v.toLowerCase().includes($scope.search.toLowerCase());
      }))
    );
  };

  $scope.select = function () {
    $scope.selectedUsers = $scope.users.filter(user => {
      return user.isSelected;
    });
  };

  $scope.enableModifyTeam = function () {
    $scope.modifyFlag = true;
    $scope.filteredUsers = $scope.users.filter(user => {
      return $scope.project.access.some(accessItem => accessItem._id === user._id);
    });
    $scope.filteredUsers = $scope.filteredUsers.map(user => {
      user.isSelected = true;
      return user;
    });
  };

  $scope.disableModifyTeam = function () {
    $scope.modifyFlag = false;
    $scope.filter();
  };

  $scope.save = function () {
    if ($scope.selectedUsers.length == 0 && $scope.filteredUsers.length != 0) {
      $scope.filteredUsers.forEach(x => {
        if (x.isSelected) $scope.selectedUsers.push(x);
      });
    }

    ProjectService.shareToUsers($scope.project, $scope.selectedUsers.map(x => x._id), $scope.modifyFlag).then(function () {
      if ($scope.selectedUsers) {
        $scope.selectedUsers.forEach(user => {
          $scope.notification.usersFor.push(user.email);
        });
      }

      if ($scope.notification.usersFor.length > 0) {
        ProjectService.getSharedNotification($scope.notification);
      }

      $modalInstance.close();
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.service("ProjectSharingDialog", ["$modal", function ($modal) {
  this.open = function (project) {
    return $modal.open({
      templateUrl: "app/main/invite-team/invite-team.html",
      controller: "InviteProjectCtrl",
      size: "md",
      resolve: {
        project: function () { return project; },
      }
    }).result;
  };
}]);

"use strict";

app.controller("SpecHistoryCtrl", ["$scope", "$modalInstance", "ProjectService", "project", "QuestionSetService", "Auth", function ($scope, $modalInstance, ProjectService, project, QuestionSetService, Auth) {

    ProjectService.getSpecHistory(project._id).then(function(result) {
        result.data.forEach(function(x) {
            var newDate = new Date(x.timestamp);
            var convertedDate = newDate.getFullYear() + "/" + String(newDate.getMonth() + 1).padStart(2, "0") + "/" + String(newDate.getDate()).padStart(2, "0");
            return x.timestamp = convertedDate;
        })
        $scope.projectHistory = result.data;
    });

    
    $scope.fetch = function(changelog) {
        $scope.finalResult = [];
        if(changelog.expanded) return $scope.toggleExpand(changelog);
        ProjectService.getDetailedHistory(changelog._id).then(function(result) {
            $scope.detailedHistory = result;
            return result
        }).then(function(result) {
            if(!$scope.qs) { 
                QuestionSetService.fetch(changelog.questionSet).then(function(result) {
                    $scope.qs = result;
                    $scope.indexedQs = $scope.qs.pages.reduce(appendQuestion, { })
                    fillHistory();
                })

            } else {
                fillHistory();
            }
        }).then(function() {
            $scope.toggleExpand(changelog);
        })
        
    };

    function fillHistory() {
        if($scope.detailedHistory.data.added) $scope.specChanges = $scope.detailedHistory.data.added;
                    else $scope.specChanges = $scope.detailedHistory.data.updated;

                    for(const key in $scope.specChanges) {
                        var qId = "";
                        var aId = "";
                        if(key === "filteredTags") return;
                        if(typeof $scope.specChanges[key] === 'object') {
                            var objKeys = Object.keys($scope.specChanges[key])
                            qId = key;
                            aId = objKeys[0];
                        } else {
                            qId = key;
                            aId =  $scope.specChanges[key];
                        }
                        var qaPair = getQuestionAndAnswerTexts(qId, aId);
                        $scope.finalResult.push(qaPair);
                    }
    }


    function getQuestionAndAnswerTexts(qId, aId) {
        var question = $scope.indexedQs[qId];
        var answer = question && question.answers[aId];

        if (question && answer) return question.text + " - " + answer;
        else if (question) return question.text
        else return "";
    }

    function appendQuestion(qr, q) {
        if (q.questions) {
            q.questions.reduce(appendQuestion, qr);
        } else
            qr[q.id] = {
                text: q.text,
                answers: q.answers.reduce(function (ar, a) {
                    ar[a.id] = a.text;
                    return ar;
                }, {})
            };

        return qr;
    } 

    $scope.toggleExpand = function (item) {
        $scope.projectHistory.forEach(function(x){
           if(x.expanded && x!== item) x.expanded = !x.expanded;
        })
        item.expanded = !item.expanded;
    };
    
    $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
    };

}]);

"use strict";

app.service("SpecHistoryDialog", ["$modal", function ($modal) {
  this.open = function (project) {
    return $modal.open({
      templateUrl: "app/main/spec-history/spec-history.html",
      controller: "SpecHistoryCtrl",
      size: "lg",
      resolve: {
        project: function () { return project; },
      }
    }).result;
  };
}]);

angular.module("gettext").run(["gettextCatalog", function (gettextCatalog) {
  gettextCatalog.setStrings("string", {
    "Select file to upload...": "Select file to upload...",
    "Add country": "Add country",
    "Edit country information": "Edit country information",
    "Edit file": "Edit file",
    "Enter equipment name": "Enter equipment name",
    "Rename Project": "Rename Project",
    "Restore Unsaved Answers": "Restore Unsaved Answers",
    "Saving conflict": "Saving conflict",
    "Select item and enter name": "Select item and enter name",
    "Set copy name": "Set copy name",
    "Upload entry question set...": "Upload entry question set...",
    "Back": "Back",
    "Cancel": "Cancel",
    "Close": "Close",
    "Decline all": "Decline all",
    "Drop": "Drop",
    "File history": "File history",
    "No": "No",
    "Question set configuration history": "Question set configuration history",
    "Replace all": "Replace all",
    "Resave": "Resave",
    "Save": "Save",
    "Save As Copy": "Save As Copy",
    "Save project": "Save project",
    "Solve replace conflicts": "Solve replace conflicts",
    "Unpublish Spec Configuration": "Unpublish Spec Configuration",
    "Use Mine": "Use Mine",
    "Use Newer": "Use Newer",
    "Yes": "Yes",
    "(select language)": "(select language)",
    "Actions": "Actions",
    "Activate": "Activate",
    "Add": "Add",
    "Add Configuration": "Add Configuration",
    "Add Country": "Add Country",
    "Add new": "Add new",
    "Add new point": "Add new point",
    "Add translation": "Add translation",
    "Admin": "Admin",
    "All / None": "All / None",
    "Are you sure you want to unpublish spec configuration": "Are you sure you want to unpublish spec configuration",
    "Bill of Materials": "Bill of Materials",
    "Cannot create spec configuration": "Cannot create spec configuration",
    "Cannot upload": "Cannot upload",
    "Cannot upload file": "Cannot upload file",
    "Cannot upload question set configuration": "Cannot upload question set configuration",
    "Client": "Client",
    "Column": "Column",
    "Comments": "Comments",
    "Completed": "Completed",
    "Compliances": "Compliances",
    "Consistences": "Consistences",
    "Contact Us": "Contact Us",
    "Copy": "Copy",
    "Copy menu item": "Copy menu item",
    "Counter": "Counter",
    "Countries": "Countries",
    "Country": "Country",
    "Country Code (ISO 2)": "Country Code (ISO 2)",
    "Country:": "Country:",
    "Create": "Create",
    "Create By": "Create By",
    "Create New Project": "Create New Project",
    "Create spec configuration": "Create spec configuration",
    "Created By": "Created By",
    "Currency": "Currency",
    "Data Sheets": "Data Sheets",
    "DataSheets": "DataSheets",
    "Decline files replace:": "Decline files replace:",
    "Delete": "Delete",
    "Delete compliance": "Delete compliance",
    "Delete consistency": "Delete consistency",
    "Delete data sheet": "Delete data sheet",
    "Delete drawing": "Delete drawing",
    "Delete file": "Delete file",
    "Delete menu item": "Delete menu item",
    "Delete point list": "Delete point list",
    "Delete question set": "Delete question set",
    "Delete sequence": "Delete sequence",
    "Delete spec configuration": "Delete spec configuration",
    "Delete specification": "Delete specification",
    "Description": "Description",
    "Display": "Display",
    "Download": "Download",
    "Download Full Spec as Zip": "Download Full Spec as Zip",
    "Download compliance": "Download compliance",
    "Download configuration data": "Download configuration data",
    "Download consistency": "Download consistency",
    "Download data sheet": "Download data sheet",
    "Download drawing": "Download drawing",
    "Download file": "Download file",
    "Download latest version": "Download latest version",
    "Download original": "Download original",
    "Download point list": "Download point list",
    "Download processed": "Download processed",
    "Download question set": "Download question set",
    "Download selected files": "Download selected files",
    "Download sequence": "Download sequence",
    "Download specification": "Download specification",
    "Drawings": "Drawings",
    "Duplicate": "Duplicate",
    "Duplicates": "Duplicates",
    "Edit": "Edit",
    "Edit Spec Configuration": "Edit Spec Configuration",
    "Edit menu item": "Edit menu item",
    "Edit menu item name": "Edit menu item name",
    "Edit name": "Edit name",
    "Edit point": "Edit point",
    "Equipment Schematics": "Equipment Schematics",
    "File ID": "File ID",
    "File Name": "File Name",
    "File is not uploaded": "File is not uploaded",
    "Files Repository": "Files Repository",
    "Header": "Header",
    "Header label": "Header label",
    "Hello": "Hello",
    "Hide empty sections": "Hide empty sections",
    "History": "History",
    "Home": "Home",
    "Invalid": "Invalid",
    "Invalid Lines": "Invalid Lines",
    "Invalid Question set": "Invalid Question set",
    "Json Preview": "Json Preview",
    "Label": "Label",
    "Language": "Language",
    "Language:": "Language:",
    "Languages": "Languages",
    "Last Updated": "Last Updated",
    "Legend": "Legend",
    "Logic": "Logic",
    "Login": "Login",
    "Logout": "Logout",
    "Model Number": "Model Number",
    "Name": "Name",
    "Name is required": "Name is required",
    "New Project": "New Project",
    "Open": "Open",
    "Open project": "Open project",
    "Original": "Original",
    "Params": "Params",
    "Part. No": "Part. No",
    "Pending Registrations": "Pending Registrations",
    "Point Lists": "Point Lists",
    "PreSelected": "PreSelected",
    "Preview": "Preview",
    "Preview answers": "Preview answers",
    "Preview file": "Preview file",
    "Preview latest version": "Preview latest version",
    "Preview original": "Preview original",
    "Preview processed": "Preview processed",
    "Preview question set": "Preview question set",
    "Price": "Price",
    "Product": "Product",
    "Product:": "Product:",
    "Projects": "Projects",
    "Projects Count": "Projects Count",
    "Publish": "Publish",
    "Publish Spec Configuration": "Publish Spec Configuration",
    "Published": "Published",
    "Quantity": "Quantity",
    "Question Sets": "Question Sets",
    "Questions in tree": "Questions in tree",
    "Referred Files": "Referred Files",
    "Referred by ": "Referred by ",
    "Register": "Register",
    "Restore unsaved answers drafts?": "Restore unsaved answers drafts?",
    "Result": "Result",
    "Save Changes": "Save Changes",
    "Save point": "Save point",
    "Save project as new": "Save project as new",
    "Seems project is deleted from other user, drop if resave it?": "Seems project is deleted from other user, drop if resave it?",
    "Select": "Select",
    "Select Language": "Select Language",
    "Select tag": "Select tag",
    "Selected files:": "Selected files:",
    "Send": "Send",
    "Sequences": "Sequences",
    "Server": "Server",
    "Settings": "Settings",
    "Show configuration details": "Show configuration details",
    "Show file history": "Show file history",
    "Show missing first": "Show missing first",
    "Show questions JSON representation": "Show questions JSON representation",
    "Snapshots": "Snapshots",
    "Something went wrong, please try again": "Something went wrong, please try again",
    "Spec Configs": "Spec Configs",
    "Spec Information": "Spec Information",
    "Specifications": "Specifications",
    "Status": "Status",
    "Suffix": "Suffix",
    "Tags": "Tags",
    "Test Coverage Reports": "Test Coverage Reports",
    "Test if processable": "Test if processable",
    "The name you entered is already in use, please enter a different name.": "The name you entered is already in use, please enter a different name.",
    "There are conflict between project versions, how to solve it?": "There are conflict between project versions, how to solve it?",
    "Token is not valid, go to your settings page and try change email again": "Token is not valid, go to your settings page and try change email again",
    "Translations": "Translations",
    "Type": "Type",
    "Type Name": "Type Name",
    "UnitPrice": "UnitPrice",
    "Unpublish": "Unpublish",
    "Updated by": "Updated by",
    "Upload": "Upload",
    "Upload file": "Upload file",
    "Upload file with different name": "Upload file with different name",
    "Uploaded": "Uploaded",
    "Uploaded at": "Uploaded at",
    "Uploaded by": "Uploaded by",
    "Uploading": "Uploading",
    "Users": "Users",
    "Version": "Version",
    "available": "available",
    "create new spec config": "create new spec config",
    "delete answers set": "delete answers set",
    "delete point": "delete point",
    "delete snapshot": "delete snapshot",
    "download question set": "download question set",
    "edit menu": "edit menu",
    "preview compliance": "preview compliance",
    "preview consistency": "preview consistency",
    "preview data sheet": "preview data sheet",
    "preview drawing": "preview drawing",
    "preview point list": "preview point list",
    "preview question set": "preview question set",
    "preview sequence": "preview sequence",
    "preview spec config": "preview spec config",
    "preview specification": "preview specification",
    "project name": "project name",
    "revert question set": "revert question set",
    "select country": "select country",
    "select language": "select language",
    "select menu item": "select menu item",
    "select product": "select product",
    "select project": "select project",
    "select spec": "select spec",
    "set active snapshot": "set active snapshot",
    "translate": "translate",
    "upload mandatory question set": "upload mandatory question set",
    "upload new compliance": "upload new compliance",
    "upload new consistency": "upload new consistency",
    "upload new data sheet": "upload new data sheet",
    "upload new drawing": "upload new drawing",
    "upload new file": "upload new file",
    "upload new point list": "upload new point list",
    "upload new question set": "upload new question set",
    "view answers set": "view answers set",
    "Level": "Level",
    "Date Created": "Date Created",
    "Rename": "Rename",
    "Create specification": "Create specification",
    "download files": "download files",
    "get sharable link": "get sharable link",
    "General Project information": "General Project information",
    "Equipment and systems,": "Equipment and Systems",
    "specification Options": "Specification Options",
    "Proposal requirements": "Proposal requirements",
    "Software and User Interfaces": "Software and User Interfaces",
    "Network Architecture": "Network Architecture",
    "Protocols and integration": "Protocols and integration",
    "Graphic options": "Graphic options",
    "Project Execution": "Project Execution",
    "Documents": "Documents",
    "Fire": "Fire",
    "Security": "Security",
    "Building Automation": "Building Automation",
    "Test only": "Test only",
    "Next": "Next",
    "Add sub folder": "Add sub folder",
    "not available": "not available",
    "Rename specification": "Rename specification",
    "Progress": "Progress",
    "Search": "Search",
    "Last": "Last",
    "Previous": "Previous",
    "First": "First",
    "Show 10 Entries": "Show 10 Entries",
    "Showing 1 to 3 of 3 entries": "Showing 1 to 3 of 3 entries",
    "Project Sharing": "Project Sharing",
    "Specification Name": "Specification Name",
    "undefined": "Edit File"
  });
  gettextCatalog.setStrings("en_us", {
    "Select file to upload...": "Select file to upload...",
    "Add country": "Add country",
    "Edit country information": "Edit country information",
    "Edit file": "Edit file",
    "Enter equipment name": "Enter equipment name",
    "Rename Project": "Rename Project",
    "Restore Unsaved Answers": "Restore Unsaved Answers",
    "Saving conflict": "Saving conflict",
    "Select item and enter name": "Select item and enter name",
    "Set copy name": "Set copy name",
    "Upload entry question set...": "Upload entry question set...",
    "Back": "Back",
    "Cancel": "Cancel",
    "Close": "Close",
    "Decline all": "Decline all",
    "Drop": "Drop",
    "File history": "File history",
    "No": "No",
    "Question set configuration history": "Question set configuration history",
    "Replace all": "Replace all",
    "Resave": "Resave",
    "Save": "Save",
    "Save As Copy": "Save As Copy",
    "Save project": "Save project",
    "Solve replace conflicts": "Solve replace conflicts",
    "Unpublish Spec Configuration": "Unpublish Spec Configuration",
    "Use Mine": "Use Mine",
    "Use Newer": "Use Newer",
    "Yes": "Yes",
    "(select language)": "(select language)",
    "Actions": "Actions",
    "Activate": "Activate",
    "Add": "Add",
    "Add Configuration": "Add Configuration",
    "Add Country": "Add Country",
    "Add new": "Add new",
    "Add new point": "Add new point",
    "Add translation": "Add translation",
    "Admin": "Admin",
    "All / None": "All / None",
    "Are you sure you want to unpublish spec configuration": "Are you sure you want to unpublish spec configuration",
    "Bill of Materials": "Bill of Materials",
    "Cannot create spec configuration": "Cannot create spec configuration",
    "Cannot upload": "Cannot upload",
    "Cannot upload file": "Cannot upload file",
    "Cannot upload question set configuration": "Cannot upload question set configuration",
    "Client": "Client",
    "Column": "Column",
    "Comments": "Comments",
    "Completed": "Completed",
    "Compliances": "Compliances",
    "Consistences": "Consistences",
    "Contact Us": "Contact Us",
    "Copy": "Copy",
    "Copy menu item": "Copy menu item",
    "Counter": "Counter",
    "Countries": "Countries",
    "Country": "Country",
    "Country Code (ISO 2)": "Country Code (ISO 2)",
    "Country:": "Country:",
    "Create": "Create",
    "Create By": "Create By",
    "Create New Project": "Create New Project",
    "Create spec configuration": "Create spec configuration",
    "Created By": "Created By",
    "Currency": "Currency",
    "Data Sheets": "Data Sheets",
    "DataSheets": "DataSheets",
    "Decline files replace:": "Decline files replace:",
    "Delete": "Delete",
    "Delete compliance": "Delete compliance",
    "Delete consistency": "Delete consistency",
    "Delete data sheet": "Delete data sheet",
    "Delete drawing": "Delete drawing",
    "Delete file": "Delete file",
    "Delete menu item": "Delete menu item",
    "Delete point list": "Delete point list",
    "Delete question set": "Delete question set",
    "Delete sequence": "Delete sequence",
    "Delete spec configuration": "Delete spec configuration",
    "Delete specification": "Delete specification",
    "Description": "Description",
    "Display": "Display",
    "Download": "Download",
    "Download Full Spec as Zip": "Download Full Spec as Zip",
    "Download compliance": "Download compliance",
    "Download configuration data": "Download configuration data",
    "Download consistency": "Download consistency",
    "Download data sheet": "Download data sheet",
    "Download drawing": "Download drawing",
    "Download file": "Download file",
    "Download latest version": "Download latest version",
    "Download original": "Download original",
    "Download point list": "Download point list",
    "Download processed": "Download processed",
    "Download question set": "Download question set",
    "Download selected files": "Download selected files",
    "Download sequence": "Download sequence",
    "Download specification": "Download specification",
    "Drawings": "Drawings",
    "Duplicate": "Duplicate",
    "Duplicates": "Duplicates",
    "Edit": "Edit",
    "Edit Spec Configuration": "Edit Spec Configuration",
    "Edit menu item": "Edit menu item",
    "Edit menu item name": "Edit menu item name",
    "Edit name": "Edit name",
    "Edit point": "Edit point",
    "Equipment Schematics": "Equipment Schematics",
    "File ID": "File ID",
    "File Name": "File Name",
    "File is not uploaded": "File is not uploaded",
    "Files Repository": "Files Repository",
    "Header": "Header",
    "Header label": "Header label",
    "Hello": "Hello",
    "Hide empty sections": "Hide empty sections",
    "History": "History",
    "Home": "Home",
    "Invalid": "Invalid",
    "Invalid Lines": "Invalid Lines",
    "Invalid Question set": "Invalid Question set",
    "Json Preview": "Json Preview",
    "Label": "Label",
    "Language": "Language",
    "Language:": "Language:",
    "Languages": "Languages",
    "Last Updated": "Last Updated",
    "Legend": "Legend",
    "Logic": "Logic",
    "Login": "Login",
    "Logout": "Logout",
    "Model Number": "Model Number",
    "Name": "Name",
    "Name is required": "Name is required",
    "New Project": "New Project",
    "Open": "Open",
    "Open project": "Open project",
    "Original": "Original",
    "Params": "Params",
    "Part. No": "Part. No",
    "Pending Registrations": "Pending Registrations",
    "Point Lists": "Point Lists",
    "PreSelected": "PreSelected",
    "Preview": "Preview",
    "Preview answers": "Preview answers",
    "Preview file": "Preview file",
    "Preview latest version": "Preview latest version",
    "Preview original": "Preview original",
    "Preview processed": "Preview processed",
    "Preview question set": "Preview question set",
    "Price": "Price",
    "Product": "Product",
    "Product:": "Product:",
    "Projects": "Projects",
    "Projects Count": "Projects Count",
    "Publish": "Publish",
    "Publish Spec Configuration": "Publish Spec Configuration",
    "Published": "Published",
    "Quantity": "Quantity",
    "Question Sets": "Question Sets",
    "Questions in tree": "Questions in tree",
    "Referred Files": "Referred Files",
    "Referred by ": "Referred by ",
    "Register": "Register",
    "Restore unsaved answers drafts?": "Restore unsaved answers drafts?",
    "Result": "Result",
    "Save Changes": "Save Changes",
    "Save point": "Save point",
    "Save project as new": "Save project as new",
    "Seems project is deleted from other user, drop if resave it?": "Seems project is deleted from other user, drop if resave it?",
    "Select": "Select",
    "Select Language": "Select Language",
    "Select tag": "Select tag",
    "Selected files:": "Selected files:",
    "Send": "Send",
    "Sequences": "Sequences",
    "Server": "Server",
    "Settings": "Settings",
    "Show configuration details": "Show configuration details",
    "Show file history": "Show file history",
    "Show missing first": "Show missing first",
    "Show questions JSON representation": "Show questions JSON representation",
    "Snapshots": "Snapshots",
    "Something went wrong, please try again": "Something went wrong, please try again",
    "Spec Configs": "Spec Configs",
    "Spec Information": "Spec Information",
    "Specifications": "Specifications",
    "Status": "Status",
    "Suffix": "Suffix",
    "Tags": "Tags",
    "Test Coverage Reports": "Test Coverage Reports",
    "Test if processable": "Test if processable",
    "The name you entered is already in use, please enter a different name.": "The name you entered is already in use, please enter a different name.",
    "There are conflict between project versions, how to solve it?": "There are conflict between project versions, how to solve it?",
    "Token is not valid, go to your settings page and try change email again": "Token is not valid, go to your settings page and try change email again",
    "Translations": "Translations",
    "Type": "Type",
    "Type Name": "Type Name",
    "UnitPrice": "UnitPrice",
    "Unpublish": "Unpublish",
    "Updated by": "Updated by",
    "Upload": "Upload",
    "Upload file": "Upload file",
    "Upload file with different name": "Upload file with different name",
    "Uploaded": "Uploaded",
    "Uploaded at": "Uploaded at",
    "Uploaded by": "Uploaded by",
    "Uploading": "Uploading",
    "Users": "Users",
    "Version": "Version",
    "available": "available",
    "create new spec config": "create new spec config",
    "delete answers set": "delete answers set",
    "delete point": "delete point",
    "delete snapshot": "delete snapshot",
    "download question set": "download question set",
    "edit menu": "edit menu",
    "preview compliance": "preview compliance",
    "preview consistency": "preview consistency",
    "preview data sheet": "preview data sheet",
    "preview drawing": "preview drawing",
    "preview point list": "preview point list",
    "preview question set": "preview question set",
    "preview sequence": "preview sequence",
    "preview spec config": "preview spec config",
    "preview specification": "preview specification",
    "project name": "project name",
    "revert question set": "revert question set",
    "select country": "select country",
    "select language": "select language",
    "select menu item": "select menu item",
    "select product": "select product",
    "select project": "select project",
    "select spec": "select spec",
    "set active snapshot": "set active snapshot",
    "translate": "translate",
    "upload mandatory question set": "upload mandatory question set",
    "upload new compliance": "upload new compliance",
    "upload new consistency": "upload new consistency",
    "upload new data sheet": "upload new data sheet",
    "upload new drawing": "upload new drawing",
    "upload new file": "upload new file",
    "upload new point list": "upload new point list",
    "upload new question set": "upload new question set",
    "view answers set": "view answers set",
    "Level": "Level",
    "Date Created": "Date Created",
    "Rename": "Rename",
    "Create specification": "Create specification",
    "download files": "download files",
    "get sharable link": "get sharable link",
    "General Project information": "General Project information",
    "Equipment and systems,": "Equipment and systems,",
    "specification Options": "specification Options",
    "Proposal requirements": "Proposal requirements",
    "Software and User Interfaces": "Software and User Interfaces",
    "Network Architecture": "Network Architecture",
    "Protocols and integration": "Protocols and integration",
    "Graphic options": "Graphic options",
    "Project Execution": "Project Execution",
    "Documents": "Documents",
    "Fire": "Fire",
    "Security": "Security",
    "Building Automation": "Building Automation",
    "Test only": "Test only",
    "Next": "Next",
    "Add sub folder": "Add sub folder",
    "not available": "not available",
    "Rename specification": "Rename specification",
    "Progress": "Progress",
    "Search": "Search",
    "Last": "Last",
    "Previous": "Previous",
    "First": "First",
    "Show 10 Entries": "Show 10 Entries",
    "Showing 1 to 3 of 3 entries": "Showing 1 to 3 of 3 entries",
    "Project Sharing": "Project Sharing",
    "Specification Name": "Specification Name"
  });
  gettextCatalog.setStrings("en_ca", {
    "Select file to upload...": "Select file to upload...",
    "Add country": "Add country",
    "Edit country information": "Edit country information",
    "Edit file": "Edit file",
    "Enter equipment name": "Enter equipment name",
    "Rename Project": "Rename Project",
    "Restore Unsaved Answers": "Restore Unsaved Answers",
    "Saving conflict": "Saving conflict",
    "Select item and enter name": "Select item and enter name",
    "Set copy name": "Set copy name",
    "Upload entry question set...": "Upload entry question set...",
    "Back": "Back",
    "Cancel": "Cancel",
    "Close": "Close",
    "Decline all": "Decline all",
    "Drop": "Drop",
    "File history": "File history",
    "No": "No",
    "Question set configuration history": "Question set configuration history",
    "Replace all": "Replace all",
    "Resave": "Resave",
    "Save": "Save",
    "Save As Copy": "Save As Copy",
    "Save project": "Save project",
    "Solve replace conflicts": "Solve replace conflicts",
    "Unpublish Spec Configuration": "Unpublish Spec Configuration",
    "Use Mine": "Use Mine",
    "Use Newer": "Use Newer",
    "Yes": "Yes",
    "(select language)": "(select language)",
    "Actions": "Actions",
    "Activate": "Activate",
    "Add": "Add",
    "Add Configuration": "Add Configuration",
    "Add Country": "Add Country",
    "Add new": "Add new",
    "Add new point": "Add new point",
    "Add translation": "Add translation",
    "Admin": "Admin",
    "All / None": "All / None",
    "Are you sure you want to unpublish spec configuration": "Are you sure you want to unpublish spec configuration",
    "Bill of Materials": "Bill of Materials",
    "Cannot create spec configuration": "Cannot create spec configuration",
    "Cannot upload": "Cannot upload",
    "Cannot upload file": "Cannot upload file",
    "Cannot upload question set configuration": "Cannot upload question set configuration",
    "Client": "Client",
    "Column": "Column",
    "Comments": "Comments",
    "Completed": "Completed",
    "Compliances": "Compliances",
    "Consistences": "Consistences",
    "Contact Us": "Contact Us",
    "Copy": "Copy",
    "Copy menu item": "Copy menu item",
    "Counter": "Counter",
    "Countries": "Countries",
    "Country": "Country",
    "Country Code (ISO 2)": "Country Code (ISO 2)",
    "Country:": "Country:",
    "Create": "Create",
    "Create By": "Create By",
    "Create New Project": "Create New Project",
    "Create spec configuration": "Create spec configuration",
    "Created By": "Created By",
    "Currency": "Currency",
    "Data Sheets": "Data Sheets",
    "DataSheets": "DataSheets",
    "Decline files replace:": "Decline files replace:",
    "Delete": "Delete",
    "Delete compliance": "Delete compliance",
    "Delete consistency": "Delete consistency",
    "Delete data sheet": "Delete data sheet",
    "Delete drawing": "Delete drawing",
    "Delete file": "Delete file",
    "Delete menu item": "Delete menu item",
    "Delete point list": "Delete point list",
    "Delete question set": "Delete question set",
    "Delete sequence": "Delete sequence",
    "Delete spec configuration": "Delete spec configuration",
    "Delete specification": "Delete specification",
    "Description": "Description",
    "Display": "Display",
    "Download": "Download",
    "Download Full Spec as Zip": "Download Full Spec as Zip",
    "Download compliance": "Download compliance",
    "Download configuration data": "Download configuration data",
    "Download consistency": "Download consistency",
    "Download data sheet": "Download data sheet",
    "Download drawing": "Download drawing",
    "Download file": "Download file",
    "Download latest version": "Download latest version",
    "Download original": "Download original",
    "Download point list": "Download point list",
    "Download processed": "Download processed",
    "Download question set": "Download question set",
    "Download selected files": "Download selected files",
    "Download sequence": "Download sequence",
    "Download specification": "Download specification",
    "Drawings": "Drawings",
    "Duplicate": "Duplicate",
    "Duplicates": "Duplicates",
    "Edit": "Edit",
    "Edit Spec Configuration": "Edit Spec Configuration",
    "Edit menu item": "Edit menu item",
    "Edit menu item name": "Edit menu item name",
    "Edit name": "Edit name",
    "Edit point": "Edit point",
    "Equipment Schematics": "Equipment Schematics",
    "File ID": "File ID",
    "File Name": "File Name",
    "File is not uploaded": "File is not uploaded",
    "Files Repository": "Files Repository",
    "Header": "Header",
    "Header label": "Header label",
    "Hello": "Hello",
    "Hide empty sections": "Hide empty sections",
    "History": "History",
    "Home": "Home",
    "Invalid": "Invalid",
    "Invalid Lines": "Invalid Lines",
    "Invalid Question set": "Invalid Question set",
    "Json Preview": "Json Preview",
    "Label": "Label",
    "Language": "Language",
    "Language:": "Language:",
    "Languages": "Languages",
    "Last Updated": "Last Updated",
    "Legend": "Legend",
    "Logic": "Logic",
    "Login": "Login",
    "Logout": "Logout",
    "Model Number": "Model Number",
    "Name": "Name",
    "Name is required": "Name is required",
    "New Project": "New Project",
    "Open": "Open",
    "Open project": "Open project",
    "Original": "Original",
    "Params": "Params",
    "Part. No": "Part. No",
    "Pending Registrations": "Pending Registrations",
    "Point Lists": "Point Lists",
    "PreSelected": "PreSelected",
    "Preview": "Preview",
    "Preview answers": "Preview answers",
    "Preview file": "Preview file",
    "Preview latest version": "Preview latest version",
    "Preview original": "Preview original",
    "Preview processed": "Preview processed",
    "Preview question set": "Preview question set",
    "Price": "Price",
    "Product": "Product",
    "Product:": "Product:",
    "Projects": "Projects",
    "Projects Count": "Projects Count",
    "Publish": "Publish",
    "Publish Spec Configuration": "Publish Spec Configuration",
    "Published": "Published",
    "Quantity": "Quantity",
    "Question Sets": "Question Sets",
    "Questions in tree": "Questions in tree",
    "Referred Files": "Referred Files",
    "Referred by ": "Referred by ",
    "Register": "Register",
    "Restore unsaved answers drafts?": "Restore unsaved answers drafts?",
    "Result": "Result",
    "Save Changes": "Save Changes",
    "Save point": "Save point",
    "Save project as new": "Save project as new",
    "Seems project is deleted from other user, drop if resave it?": "Seems project is deleted from other user, drop if resave it?",
    "Select": "Select",
    "Select Language": "Select Language",
    "Select tag": "Select tag",
    "Selected files:": "Selected files:",
    "Send": "Send",
    "Sequences": "Sequences",
    "Server": "Server",
    "Settings": "Settings",
    "Show configuration details": "Show configuration details",
    "Show file history": "Show file history",
    "Show missing first": "Show missing first",
    "Show questions JSON representation": "Show questions JSON representation",
    "Snapshots": "Snapshots",
    "Something went wrong, please try again": "Something went wrong, please try again",
    "Spec Configs": "Spec Configs",
    "Spec Information": "Spec Information",
    "Specifications": "Specifications",
    "Status": "Status",
    "Suffix": "Suffix",
    "Tags": "Tags",
    "Test Coverage Reports": "Test Coverage Reports",
    "Test if processable": "Test if processable",
    "The name you entered is already in use, please enter a different name.": "The name you entered is already in use, please enter a different name.",
    "There are conflict between project versions, how to solve it?": "There are conflict between project versions, how to solve it?",
    "Token is not valid, go to your settings page and try change email again": "Token is not valid, go to your settings page and try change email again",
    "Translations": "Translations",
    "Type": "Type",
    "Type Name": "Type Name",
    "UnitPrice": "UnitPrice",
    "Unpublish": "Unpublish",
    "Updated by": "Updated by",
    "Upload": "Upload",
    "Upload file": "Upload file",
    "Upload file with different name": "Upload file with different name",
    "Uploaded": "Uploaded",
    "Uploaded at": "Uploaded at",
    "Uploaded by": "Uploaded by",
    "Uploading": "Uploading",
    "Users": "Users",
    "Version": "Version",
    "available": "available",
    "create new spec config": "create new spec config",
    "delete answers set": "delete answers set",
    "delete point": "delete point",
    "delete snapshot": "delete snapshot",
    "download question set": "download question set",
    "edit menu": "edit menu",
    "preview compliance": "preview compliance",
    "preview consistency": "preview consistency",
    "preview data sheet": "preview data sheet",
    "preview drawing": "preview drawing",
    "preview point list": "preview point list",
    "preview question set": "preview question set",
    "preview sequence": "preview sequence",
    "preview spec config": "preview spec config",
    "preview specification": "preview specification",
    "project name": "project name",
    "revert question set": "revert question set",
    "select country": "select country",
    "select language": "select language",
    "select menu item": "select menu item",
    "select product": "select product",
    "select project": "select project",
    "select spec": "select spec",
    "set active snapshot": "set active snapshot",
    "translate": "translate",
    "upload mandatory question set": "upload mandatory question set",
    "upload new compliance": "upload new compliance",
    "upload new consistency": "upload new consistency",
    "upload new data sheet": "upload new data sheet",
    "upload new drawing": "upload new drawing",
    "upload new file": "upload new file",
    "upload new point list": "upload new point list",
    "upload new question set": "upload new question set",
    "view answers set": "view answers set",
    "Level": "Level",
    "Date Created": "Date Created",
    "Rename": "Rename",
    "Create specification": "Create specification",
    "download files": "download files",
    "get sharable link": "get shareable link",
    "General Project information": "General Project information",
    "Equipment and systems,": "Equipment and systems,",
    "specification Options": "specification Options",
    "Proposal requirements": "Proposal requirements",
    "Software and User Interfaces": "Software and User Interfaces",
    "Network Architecture": "Network Architecture",
    "Protocols and integration": "Protocols and integration",
    "Graphic options": "Graphic options",
    "Project Execution": "Project Execution",
    "Documents": "Documents",
    "Fire": "Fire",
    "Security": "Security",
    "Building Automation": "Building Automation",
    "Test only": "Test only",
    "Next": "Next",
    "Add sub folder": "Add subfolder",
    "not available": "not available",
    "Rename specification": "Rename specification",
    "Progress": "Progress",
    "Search": "Search",
    "Last": "Last",
    "Previous": "Previous",
    "First": "First",
    "Show 10 Entries": "Show 10 Entries",
    "Showing 1 to 3 of 3 entries": "Showing 1 to 3 of 3 entries",
    "Project Sharing": "Project Sharing",
    "Specification Name": "Specification Name"
  });
  gettextCatalog.setStrings("en_uk", {
    "Select file to upload...": "Select file to upload...",
    "Add country": "Add country",
    "Edit country information": "Edit country information",
    "Edit file": "Edit file",
    "Enter equipment name": "Enter equipment name",
    "Rename Project": "Rename Project",
    "Restore Unsaved Answers": "Restore Unsaved Answers",
    "Saving conflict": "Saving conflict",
    "Select item and enter name": "Select item and enter name",
    "Set copy name": "Set copy name",
    "Upload entry question set...": "Upload entry question set...",
    "Back": "Back",
    "Cancel": "Cancel",
    "Close": "Close",
    "Decline all": "Decline all",
    "Drop": "Drop",
    "File history": "File history",
    "No": "No",
    "Question set configuration history": "Question set configuration history",
    "Replace all": "Replace all",
    "Resave": "Resave",
    "Save": "Save",
    "Save As Copy": "Save As Copy",
    "Save project": "Save project",
    "Solve replace conflicts": "Solve replace conflicts",
    "Unpublish Spec Configuration": "Unpublish Spec Configuration",
    "Use Mine": "Use Mine",
    "Use Newer": "Use Newer",
    "Yes": "Yes",
    "(select language)": "(select language)",
    "Actions": "Actions",
    "Activate": "Activate",
    "Add": "Add",
    "Add Configuration": "Add Configuration",
    "Add Country": "Add Country",
    "Add new": "Add new",
    "Add new point": "Add new point",
    "Add translation": "Add translation",
    "Admin": "Admin",
    "All / None": "All / None",
    "Are you sure you want to unpublish spec configuration": "Are you sure you want to unpublish spec configuration",
    "Bill of Materials": "Bill of Materials",
    "Cannot create spec configuration": "Cannot create spec configuration",
    "Cannot upload": "Cannot upload",
    "Cannot upload file": "Cannot upload file",
    "Cannot upload question set configuration": "Cannot upload question set configuration",
    "Client": "Client",
    "Column": "Column",
    "Comments": "Comments",
    "Completed": "Completed",
    "Compliances": "Compliances",
    "Consistences": "Consistencies",
    "Contact Us": "Contact Us",
    "Copy": "Copy",
    "Copy menu item": "Copy menu item",
    "Counter": "Counter",
    "Countries": "Countries",
    "Country": "Country",
    "Country Code (ISO 2)": "Country Code (ISO 2)",
    "Country:": "Country:",
    "Create": "Create",
    "Create By": "Created By",
    "Create New Project": "Create New Project",
    "Create spec configuration": "Create spec configuration",
    "Created By": "Created By",
    "Currency": "Currency",
    "Data Sheets": "Data Sheets",
    "DataSheets": "DataSheets",
    "Decline files replace:": "Decline files replace:",
    "Delete": "Delete",
    "Delete compliance": "Delete compliance",
    "Delete consistency": "Delete consistency",
    "Delete data sheet": "Delete data sheet",
    "Delete drawing": "Delete drawing",
    "Delete file": "Delete file",
    "Delete menu item": "Delete menu item",
    "Delete point list": "Delete point list",
    "Delete question set": "Delete question set",
    "Delete sequence": "Delete sequence",
    "Delete spec configuration": "Delete spec configuration",
    "Delete specification": "Delete specification",
    "Description": "Description",
    "Display": "Display",
    "Download": "Download",
    "Download Full Spec as Zip": "Download Full Spec as Zip",
    "Download compliance": "Download compliance",
    "Download configuration data": "Download configuration data",
    "Download consistency": "Download consistency",
    "Download data sheet": "Download data sheet",
    "Download drawing": "Download drawing",
    "Download file": "Download file",
    "Download latest version": "Download latest version",
    "Download original": "Download original",
    "Download point list": "Download point list",
    "Download processed": "Download processed",
    "Download question set": "Download question set",
    "Download selected files": "Download selected files",
    "Download sequence": "Download sequence",
    "Download specification": "Download specification",
    "Drawings": "Drawings",
    "Duplicate": "Duplicate",
    "Duplicates": "Duplicates",
    "Edit": "Edit",
    "Edit Spec Configuration": "Edit Spec Configuration",
    "Edit menu item": "Edit menu item",
    "Edit menu item name": "Edit menu item name",
    "Edit name": "Edit name",
    "Edit point": "Edit point",
    "Equipment Schematics": "Equipment Schematics",
    "File ID": "File ID",
    "File Name": "File Name",
    "File is not uploaded": "File is not uploaded",
    "Files Repository": "Files Repository",
    "Header": "Header",
    "Header label": "Header label",
    "Hello": "Hello",
    "Hide empty sections": "Hide empty sections",
    "History": "History",
    "Home": "Home",
    "Invalid": "Invalid",
    "Invalid Lines": "Invalid Lines",
    "Invalid Question set": "Invalid Question set",
    "Json Preview": "Json Preview",
    "Label": "Label",
    "Language": "Language",
    "Language:": "Language:",
    "Languages": "Languages",
    "Last Updated": "Last Updated",
    "Legend": "Legend",
    "Logic": "Logic",
    "Login": "Login",
    "Logout": "Logout",
    "Model Number": "Model Number",
    "Name": "Name",
    "Name is required": "Name is required",
    "New Project": "New Project",
    "Open": "Open",
    "Open project": "Open project",
    "Original": "Original",
    "Params": "Params",
    "Part. No": "Part No.",
    "Pending Registrations": "Pending Registrations",
    "Point Lists": "Point Lists",
    "PreSelected": "PreSelected",
    "Preview": "Preview",
    "Preview answers": "Preview answers",
    "Preview file": "Preview file",
    "Preview latest version": "Preview latest version",
    "Preview original": "Preview original",
    "Preview processed": "Preview processed",
    "Preview question set": "Preview question set",
    "Price": "Price",
    "Product": "Product",
    "Product:": "Product:",
    "Projects": "Projects",
    "Projects Count": "Projects Count",
    "Publish": "Publish",
    "Publish Spec Configuration": "Publish Spec Configuration",
    "Published": "Published",
    "Quantity": "Quantity",
    "Question Sets": "Question Sets",
    "Questions in tree": "Questions in tree",
    "Referred Files": "Referred Files",
    "Referred by ": "Referred by ",
    "Register": "Register",
    "Restore unsaved answers drafts?": "Restore unsaved answers drafts?",
    "Result": "Result",
    "Save Changes": "Save Changes",
    "Save point": "Save point",
    "Save project as new": "Save project as new",
    "Seems project is deleted from other user, drop if resave it?": "Seems project is deleted from other user, drop it and resave it?",
    "Select": "Select",
    "Select Language": "Select Language",
    "Select tag": "Select tag",
    "Selected files:": "Selected files:",
    "Send": "Send",
    "Sequences": "Sequences",
    "Server": "Server",
    "Settings": "Settings",
    "Show configuration details": "Show configuration details",
    "Show file history": "Show file history",
    "Show missing first": "Show missing first",
    "Show questions JSON representation": "Show questions JSON representation",
    "Snapshots": "Snapshots",
    "Something went wrong, please try again": "Something went wrong, please try again",
    "Spec Configs": "Spec Configs",
    "Spec Information": "Spec Information",
    "Specifications": "Specifications",
    "Status": "Status",
    "Suffix": "Suffix",
    "Tags": "Tags",
    "Test Coverage Reports": "Test Coverage Reports",
    "Test if processable": "Test if processable",
    "The name you entered is already in use, please enter a different name.": "The name you entered is already in use. Please enter a different name.",
    "There are conflict between project versions, how to solve it?": "There are conflict between project versions, how to solve it?",
    "Token is not valid, go to your settings page and try change email again": "Token is not valid, go to your settings page and try change email again",
    "Translations": "Translations",
    "Type": "Type",
    "Type Name": "Type Name",
    "UnitPrice": "UnitPrice",
    "Unpublish": "Unpublish",
    "Updated by": "Updated by",
    "Upload": "Upload",
    "Upload file": "Upload file",
    "Upload file with different name": "Upload file with different name",
    "Uploaded": "Uploaded",
    "Uploaded at": "Uploaded at",
    "Uploaded by": "Uploaded by",
    "Uploading": "Uploading",
    "Users": "Users",
    "Version": "Version",
    "available": "available",
    "create new spec config": "create new spec config",
    "delete answers set": "delete answers set",
    "delete point": "delete point",
    "delete snapshot": "delete snapshot",
    "download question set": "download question set",
    "edit menu": "edit menu",
    "preview compliance": "preview compliance",
    "preview consistency": "preview consistency",
    "preview data sheet": "preview data sheet",
    "preview drawing": "preview drawing",
    "preview point list": "preview point list",
    "preview question set": "preview question set",
    "preview sequence": "preview sequence",
    "preview spec config": "preview spec config",
    "preview specification": "preview specification",
    "project name": "project name",
    "revert question set": "revert question set",
    "select country": "select country",
    "select language": "select language",
    "select menu item": "select menu item",
    "select product": "select product",
    "select project": "select project",
    "select spec": "select spec",
    "set active snapshot": "set active snapshot",
    "translate": "translate",
    "upload mandatory question set": "upload mandatory question set",
    "upload new compliance": "upload new compliance",
    "upload new consistency": "upload new consistency",
    "upload new data sheet": "upload new data sheet",
    "upload new drawing": "upload new drawing",
    "upload new file": "upload new file",
    "upload new point list": "upload new point list",
    "upload new question set": "upload new question set",
    "view answers set": "view answers set",
    "Level": "Level",
    "Date Created": "Date Created",
    "Rename": "Rename",
    "Create specification": "Create specification",
    "download files": "download files",
    "get sharable link": "get shareable link",
    "General Project information": "General Project information",
    "Equipment and systems,": "Equipment and systems,",
    "specification Options": "specification Options",
    "Proposal requirements": "Proposal requirements",
    "Software and User Interfaces": "Software and User Interfaces",
    "Network Architecture": "Network Architecture",
    "Protocols and integration": "Protocols and integration",
    "Graphic options": "Graphic options",
    "Project Execution": "Project Execution",
    "Documents": "Documents",
    "Fire": "Fire",
    "Security": "Security",
    "Building Automation": "Building Automation",
    "Test only": "Test only",
    "Next": "Next",
    "Add sub folder": "Add subfolder",
    "not available": "not available",
    "Rename specification": "Rename specification",
    "Progress": "Progress",
    "Search": "Search",
    "Last": "Last",
    "Previous": "Previous",
    "First": "First",
    "Show 10 Entries": "Show 10 Entries",
    "Showing 1 to 3 of 3 entries": "Showing 1 to 3 of 3 entries",
    "Project Sharing": "Project Sharing",
    "Specification Name": "Specification Name"
  });
  gettextCatalog.setStrings("fr_ca", {
    "Select file to upload...": "Sélectionner un fichier à télécharger...",
    "Add country": "Ajouter un pays",
    "Edit country information": "Modifier les informations du pays",
    "Edit file": "Modifier le fichier",
    "Enter equipment name": "Entrer le nom de l’équipement",
    "Rename Project": "Renommer le projet",
    "Restore Unsaved Answers": "Restaurer les réponses non enregistrées",
    "Saving conflict": "Enregistrement du conflit en cours",
    "Select item and enter name": "Sélectionner l’élément et entrer le nom",
    "Set copy name": "Définir le nom de la copie",
    "Upload entry question set...": "Télécharger l’ensemble de questions de saisie",
    "Back": "Retour",
    "Cancel": "Annuler",
    "Close": "Fermer",
    "Decline all": "Refuser tout",
    "Drop": "Abandonner",
    "File history": "Historique des fichiers",
    "No": "Non",
    "Question set configuration history": "Historique de la configuration de l’ensemble de questions",
    "Replace all": "Remplacer tout",
    "Resave": "Enregistrer à nouveau",
    "Save": "Enregistrer",
    "Save As Copy": "Enregistrer sous une copie",
    "Save project": "Enregistrer le projet",
    "Solve replace conflicts": "Résoudre les conflits de remplacement",
    "Unpublish Spec Configuration": "Annuler la publication de la configuration de la spéc.",
    "Use Mine": "Utiliser le mien",
    "Use Newer": "Utiliser le plus récent",
    "Yes": "Oui",
    "(select language)": "(Sélectionner la langue)",
    "Actions": "Actions",
    "Activate": "Activer",
    "Add": "Ajouter",
    "Add Configuration": "Ajouter la configuration",
    "Add Country": "Ajouter un pays",
    "Add new": "Ajouter nouveau",
    "Add new point": "Ajouter un nouveau point",
    "Add translation": "Ajouter la traduction",
    "Admin": "Admin.",
    "All / None": "Tous / Aucun",
    "Are you sure you want to unpublish spec configuration": "Voulez-vous vraiment annuler la publication de la configuration de la spéc.?",
    "Bill of Materials": "Nomenclatures",
    "Cannot create spec configuration": "Impossible de créer la configuration de la spéc.",
    "Cannot upload": "Impossible de télécharger",
    "Cannot upload file": "Impossible de télécharger le fichier",
    "Cannot upload question set configuration": "Impossible de télécharger la configuration de l'ensemble de questions",
    "Client": "Client",
    "Column": "Colonne",
    "Comments": "Commentaires",
    "Completed": "Terminé",
    "Compliances": "Conformité",
    "Consistences": "Cohérence",
    "Contact Us": "Pour nous contacter",
    "Copy": "Copier",
    "Copy menu item": "Copier l’élément de menu",
    "Counter": "Compteur",
    "Countries": "Pays",
    "Country": "Pays",
    "Country Code (ISO 2)": "Code du pays (ISO 2)",
    "Country:": "Pays :",
    "Create": "Créer",
    "Create By": "Créé par :",
    "Create New Project": "Créer un nouveau projet",
    "Create spec configuration": "Créer une configuration de spéc.",
    "Created By": "Créateur",
    "Currency": "Devise",
    "Data Sheets": "Fiches techniques",
    "DataSheets": "Fiches techniques",
    "Decline files replace:": "Refuser de remplacer les fichiers :",
    "Delete": "Supprimer",
    "Delete compliance": "Supprimer la conformité",
    "Delete consistency": "Supprimer la cohérence",
    "Delete data sheet": "Supprimer la fiche technique",
    "Delete drawing": "Supprimer le dessin",
    "Delete file": "Supprimer le fichier",
    "Delete menu item": "Supprimer l’élément de menu",
    "Delete point list": "Supprimer la liste de points",
    "Delete question set": "Supprimer l'ensemble de questions",
    "Delete sequence": "Supprimer une séquence",
    "Delete spec configuration": "Supprimer une configuration de spéc.",
    "Delete specification": "Supprimer la spécification",
    "Description": "Description",
    "Display": "Afficher",
    "Download": "Télécharger",
    "Download Full Spec as Zip": "Télécharger la spéc. complète sous zip",
    "Download compliance": "Télécharger la conformité",
    "Download configuration data": "Télécharger les données de configuration",
    "Download consistency": "Télécharger la cohérence",
    "Download data sheet": "Télécharger la fiche technique",
    "Download drawing": "Télécharger le dessin",
    "Download file": "Télécharger le fichier",
    "Download latest version": "Télécharger la dernière version",
    "Download original": "Télécharger l’originale",
    "Download point list": "Télécharger la liste de points",
    "Download processed": "Télécharger les éléments traités",
    "Download question set": "Télécharger l'ensemble de questions",
    "Download selected files": "Télécharger les fichiers sélectionnés",
    "Download sequence": "Télécharger la séquence",
    "Download specification": "Télécharger la spécification",
    "Drawings": "Dessins",
    "Duplicate": "Doublon",
    "Duplicates": "Doublons",
    "Edit": "Modifier",
    "Edit Spec Configuration": "Modifier la configuration de la spéc.",
    "Edit menu item": "Modifier l’élément de menu",
    "Edit menu item name": "Modifier le nom de l’élément de menu",
    "Edit name": "Modifier le nom",
    "Edit point": "Modifier le point",
    "Equipment Schematics": "Schéma de l’équipement",
    "File ID": "ID du fichier",
    "File Name": "Nom de fichier",
    "File is not uploaded": "Fichier n’a pas été téléchargé",
    "Files Repository": "Référentiel de fichiers",
    "Header": "En-tête",
    "Header label": "Étiquette de l'en-tête",
    "Hello": "Bonjour",
    "Hide empty sections": "Masquer les sections vides",
    "History": "Historique",
    "Home": "Accueil",
    "Invalid": "Non valide",
    "Invalid Lines": "Lignes non valides",
    "Invalid Question set": "Ensemble de questions non valide",
    "Json Preview": "Aperçu de Json",
    "Label": "Étiquette",
    "Language": "Langue",
    "Language:": "Langue :",
    "Languages": "Langues",
    "Last Updated": "Date de la dernière mise à jour",
    "Legend": "Légende",
    "Logic": "Logique",
    "Login": "Connexion",
    "Logout": "Déconnexion",
    "Model Number": "Numéro de modèle",
    "Name": "Nom",
    "Name is required": "Le nom est obligatoire",
    "New Project": "Nouveau projet",
    "Open": "Ouvrir",
    "Open project": "Ouvrir le projet",
    "Original": "Original",
    "Params": "Param.",
    "Part. No": "Nº de pièce",
    "Pending Registrations": "En attente des enregistrements",
    "Point Lists": "Listes de points",
    "PreSelected": "Présélectionné",
    "Preview": "Aperçu",
    "Preview answers": "Aperçu des réponses",
    "Preview file": "Aperçu du fichier",
    "Preview latest version": "Aperçu de la dernière version",
    "Preview original": "Aperçu de l’originale",
    "Preview processed": "Aperçu de l’élément traité",
    "Preview question set": "Aperçu de l'ensemble de questions",
    "Price": "Prix",
    "Product": "Produit",
    "Product:": "Produit :",
    "Projects": "Projets",
    "Projects Count": "Nombre de projets",
    "Publish": "Publier",
    "Publish Spec Configuration": "Publier la configuration de la spéc.",
    "Published": "Publiée",
    "Quantity": "Quantité",
    "Question Sets": "Ensembles de questions",
    "Questions in tree": "Questions dans l’arborescence",
    "Referred Files": "Fichiers référencés",
    "Referred by ": "Référé par ",
    "Register": "Enregistrer",
    "Restore unsaved answers drafts?": "Restaurer les ébauches de réponses non enregistrées?",
    "Result": "Résultat",
    "Save Changes": "Enregistrer les modifications",
    "Save point": "Enregistrer le point",
    "Save project as new": "Enregistrer le projet comme nouveau",
    "Seems project is deleted from other user, drop if resave it?": "Le projet semble avoir été supprimé par un autre utilisateur; l’abandonner s’il est enregistré à nouveau?",
    "Select": "Sélectionner",
    "Select Language": "Sélectionner la langue",
    "Select tag": "Sélectionner la balise",
    "Selected files:": "Fichiers sélectionnés :",
    "Send": "Envoyer",
    "Sequences": "Séquences",
    "Server": "Serveur",
    "Settings": "Paramètres",
    "Show configuration details": "Afficher les détails de configuration",
    "Show file history": "Afficher l'historique des fichiers",
    "Show missing first": "Afficher manquant d’abord",
    "Show questions JSON representation": "Afficher la représentation JSON des questions",
    "Snapshots": "Instantanés",
    "Something went wrong, please try again": "Un problème s’est produit, essayez à nouveau",
    "Spec Configs": "Config. des spéc.",
    "Spec Information": "Informations sur les spéc.",
    "Specifications": "Spécifications",
    "Status": "État",
    "Suffix": "Suffixe",
    "Tags": "Balises",
    "Test Coverage Reports": "Tester les rapports de couverture",
    "Test if processable": "Tester si traitable",
    "The name you entered is already in use, please enter a different name.": "Le nom saisi est déjà utilisé; veuillez entrer un nom différent.",
    "There are conflict between project versions, how to solve it?": "Il y a des conflits entre les versions de projet; comment les résoudre?",
    "Token is not valid, go to your settings page and try change email again": "Le jeton n’est pas valide; allez à votre page de paramètres et tentez de changer l’adresse courriel à nouveau.",
    "Translations": "Traductions",
    "Type": "Type",
    "Type Name": "Nom type",
    "UnitPrice": "PrixUnitaire",
    "Unpublish": "Annuler la publication",
    "Updated by": "Mis à jour par",
    "Upload": "Télécharger",
    "Upload file": "Télécharger un fichier",
    "Upload file with different name": "Télécharger le fichier sous un nom différent",
    "Uploaded": "Téléchargé",
    "Uploaded at": "Téléchargé à",
    "Uploaded by": "Téléchargé par",
    "Uploading": "Téléchargement...",
    "Users": "Utilisateurs",
    "Version": "Version",
    "available": "disponible",
    "create new spec config": "créer une nouvelle config de spéc.",
    "delete answers set": "supprimer l'ensemble de questions",
    "delete point": "supprimer point",
    "delete snapshot": "supprimer l’instantané",
    "download question set": "télécharger l'ensemble de questions",
    "edit menu": "menu edition",
    "preview compliance": "aperçu de la conformité",
    "preview consistency": "aperçu de la cohérence",
    "preview data sheet": "aperçu de la fiche technique",
    "preview drawing": "aperçu du dessin",
    "preview point list": "aperçu de la liste de points",
    "preview question set": "aperçu de l'ensemble de questions",
    "preview sequence": "aperçu de la séquence",
    "preview spec config": "aperçu de la config. de spéc.",
    "preview specification": "aperçu de la spécification",
    "project name": "nom du projet",
    "revert question set": "rétablir l'ensemble de questions",
    "select country": "sélectionner le pays",
    "select language": "sélectionner la langue",
    "select menu item": "sélectionner l’élément de menu",
    "select product": "sélectionner le produit",
    "select project": "sélectionner le projet",
    "select spec": "sélectionner la spéc.",
    "set active snapshot": "définir l’instantané actif",
    "translate": "traduire",
    "upload mandatory question set": "télécharger l’ensemble de questions obligatoires",
    "upload new compliance": "télécharger une nouvelle conformité",
    "upload new consistency": "télécharger une nouvelle cohérence",
    "upload new data sheet": "télécharger une nouvelle fiche technique",
    "upload new drawing": "télécharger un nouveau dessin",
    "upload new file": "télécharger un nouveau fichier",
    "upload new point list": "télécharger une nouvelle liste de points",
    "upload new question set": "télécharger le nouvel ensemble de questions",
    "view answers set": "afficher l'ensemble de questions",
    "Level": "Niveau",
    "Date Created": "Date créée",
    "Rename": "Renommer",
    "Create specification": "Créer une spécification",
    "download files": "Télécharger les fichiers",
    "get sharable link": "Obtenir un lien partageable",
    "General Project information": "Renseignements généraux sur le projet",
    "Equipment and systems,": "Équipement et systèmes,",
    "specification Options": "Options de la spécification",
    "Proposal requirements": "Exigences de la proposition",
    "Software and User Interfaces": "Logiciel et interfaces utilisateur",
    "Network Architecture": "Architecture de réseau",
    "Protocols and integration": "Protocoles et intégration",
    "Graphic options": "Options graphiques",
    "Project Execution": "Exécution de projets",
    "Documents": "Documents",
    "Fire": "Incendie",
    "Security": "Sécurité",
    "Building Automation": "Immotique",
    "Test only": "Essai seulement",
    "Next": "Suivant",
    "Add sub folder": "Ajouter sous-dossier",
    "not available": "Non disponible",
    "Rename specification": "Renommer la spécification",
    "Progress": "Progression",
    "Search": "Recherche",
    "Last": "Dernier",
    "Previous": "Précédent",
    "First": "Premier",
    "Show 10 Entries": "Montrer 10 entrées",
    "Showing 1 to 3 of 3 entries": "Montrant 1 à 3 de 3 entrées",
    "Project Sharing": "Partage de projet",
    "Specification Name": "nom du spécification"
  });
  gettextCatalog.setStrings("de", {
    "Select file to upload...": "Datei zum Hochladen wählen...",
    "Add country": "Land hinzufügen",
    "Edit country information": "Landinformation bearbeiten",
    "Edit file": "Datei bearbeiten",
    "Enter equipment name": "Name des Betriebsmittels eingeben",
    "Rename Project": "Projekt umbenennen",
    "Restore Unsaved Answers": "Ungespeicherte Antworten wiederherstellen",
    "Saving conflict": "Konflikt wird gespeichert",
    "Select item and enter name": "Element wählen und Namen eingeben",
    "Set copy name": "Name der Kopie festlegen",
    "Upload entry question set...": "Fragensatz-Eintrag hochladen...",
    "Back": "Zurück",
    "Cancel": "Abbrechen",
    "Close": "Schließen",
    "Decline all": "Alle ablehnen",
    "Drop": "Ablegen",
    "File history": "Dateiversionsverlauf",
    "No": "Nein",
    "Question set configuration history": "Konfigurationsverlauf Fragensatz",
    "Replace all": "Alle ersetzen",
    "Resave": "Neu speichern",
    "Save": "Speichern",
    "Save As Copy": "Als Kopie speichern",
    "Save project": "Projekt speichern",
    "Solve replace conflicts": "Ersetzungskonflikte lösen",
    "Unpublish Spec Configuration": "Veröffentlichung der Spezifikationskonfig. aufheben",
    "Use Mine": "Meine verwenden",
    "Use Newer": "Neuere verwenden",
    "Yes": "Ja",
    "(select language)": "(Sprache auswählen)",
    "Actions": "Aktionen",
    "Activate": "Aktivieren",
    "Add": "Hinzufügen",
    "Add Configuration": "Konfiguration hinzufügen",
    "Add Country": "Land hinzufügen",
    "Add new": "Neu hinzufügen",
    "Add new point": "Neuen Punkt hinzufügen",
    "Add translation": "Übersetzung hinzufügen",
    "Admin": "Admin",
    "All / None": "Alle / Keine",
    "Are you sure you want to unpublish spec configuration": "Möchten Sie die Veröffentlichung der Spezifikationskonfig. wirklich aufheben?",
    "Bill of Materials": "Materialliste",
    "Cannot create spec configuration": "Spezifikationskonfiguration kann nicht erstellt werden",
    "Cannot upload": "Hochladen nicht möglich",
    "Cannot upload file": "Hochladen der Datei nicht möglich",
    "Cannot upload question set configuration": "Hochladen der Fragensatz-Konfiguration nicht möglich",
    "Client": "Kunde",
    "Column": "Spalte",
    "Comments": "Kommentare",
    "Completed": "Abgeschlossen",
    "Compliances": "Konformitäten",
    "Consistences": "Konsistenzen",
    "Contact Us": "Kontakt",
    "Copy": "Kopieren",
    "Copy menu item": "Menüelement kopieren",
    "Counter": "Zähler",
    "Countries": "Länder",
    "Country": "Land",
    "Country Code (ISO 2)": "Ländercode (ISO 2)",
    "Country:": "Land:",
    "Create": "Erstellen",
    "Create By": "Erstellt von",
    "Create New Project": "Neues Projekt erstellen",
    "Create spec configuration": "Spezifikationskonfiguration erstellen",
    "Created By": "Erstellt von",
    "Currency": "Währung",
    "Data Sheets": "Datenblätter",
    "DataSheets": "Datenblätter",
    "Decline files replace:": "Dateiersetzung ablehnen:",
    "Delete": "Löschen",
    "Delete compliance": "Konformität löschen",
    "Delete consistency": "Konsistenz löschen",
    "Delete data sheet": "Datenblatt löschen",
    "Delete drawing": "Zeichnung löschen",
    "Delete file": "Datei löschen",
    "Delete menu item": "Menüelement löschen",
    "Delete point list": "Punktliste löschen",
    "Delete question set": "Fragensatz löschen",
    "Delete sequence": "Abfolge löschen",
    "Delete spec configuration": "Spezifikationskonfiguration löschen",
    "Delete specification": "Spezifikation löschen",
    "Description": "Beschreibung",
    "Display": "Anzeigen",
    "Download": "Herunterladen",
    "Download Full Spec as Zip": "Vollständige Spez. als ZIP herunterladen",
    "Download compliance": "Konformität herunterladen",
    "Download configuration data": "Konfigurationsdaten herunterladen",
    "Download consistency": "Konsistenz herunterladen",
    "Download data sheet": "Datenblatt herunterladen",
    "Download drawing": "Zeichnung herunterladen",
    "Download file": "Datei herunterladen",
    "Download latest version": "Aktuelle Version herunterladen",
    "Download original": "Original herunterladen",
    "Download point list": "Punktliste herunterladen",
    "Download processed": "Download wurde verarbeitet",
    "Download question set": "Fragensatz herunterladen",
    "Download selected files": "Ausgewählte Dateien herunterladen",
    "Download sequence": "Abfolge herunterladen",
    "Download specification": "Spezifikation herunterladen",
    "Drawings": "Zeichnungen",
    "Duplicate": "Duplikat",
    "Duplicates": "Duplikate",
    "Edit": "Bearbeiten",
    "Edit Spec Configuration": "Spezifikationskonfiguration bearbeiten",
    "Edit menu item": "Menüelement bearbeiten",
    "Edit menu item name": "Menüelementname bearbeiten",
    "Edit name": "Name bearbeiten",
    "Edit point": "Punkt bearbeiten",
    "Equipment Schematics": "Betriebsmittel-Schaltpläne",
    "File ID": "Datei-ID",
    "File Name": "Dateiname",
    "File is not uploaded": "Datei wird nicht hochgeladen",
    "Files Repository": "Dateiablage",
    "Header": "Kopfzeile",
    "Header label": "Überschrift",
    "Hello": "Hallo",
    "Hide empty sections": "Leere Bereiche ausblenden",
    "History": "Verlauf",
    "Home": "Startseite",
    "Invalid": "Ungültig",
    "Invalid Lines": "Ungültige Zeilen",
    "Invalid Question set": "Ungültiger Fragensatz",
    "Json Preview": "JSON-Vorschau",
    "Label": "Bezeichnung",
    "Language": "Sprache",
    "Language:": "Sprache:",
    "Languages": "Sprachen",
    "Last Updated": "Letzte Aktualisierung",
    "Legend": "Legende",
    "Logic": "Logik",
    "Login": "Anmelden",
    "Logout": "Abmelden",
    "Model Number": "Modellnummer",
    "Name": "Name",
    "Name is required": "Name ist erforderlich",
    "New Project": "Neues Projekt",
    "Open": "Öffnen",
    "Open project": "Projekt öffnen",
    "Original": "Original",
    "Params": "Parameter",
    "Part. No": "Teile-Nr.",
    "Pending Registrations": "Registrierungen ausstehend",
    "Point Lists": "Punktlisten",
    "PreSelected": "Vorausgewählt",
    "Preview": "Vorschau",
    "Preview answers": "Vorschau für Antworten",
    "Preview file": "Dateivorschau",
    "Preview latest version": "Vorschau für aktuelle Version",
    "Preview original": "Vorschau für Original",
    "Preview processed": "Vorschau wurde verarbeitet",
    "Preview question set": "Vorschau für Fragensatz",
    "Price": "Preis",
    "Product": "Produkt",
    "Product:": "Produkt:",
    "Projects": "Projekte",
    "Projects Count": "Projektanzahl",
    "Publish": "Veröffentlichen",
    "Publish Spec Configuration": "Spezifikationskonfiguration veröffentlichen",
    "Published": "Veröffentlicht",
    "Quantity": "Anzahl",
    "Question Sets": "Fragensätze",
    "Questions in tree": "Fragen in der Baumstruktur",
    "Referred Files": "Referenzierte Dateien",
    "Referred by ": "Referenziert von ",
    "Register": "Registrieren",
    "Restore unsaved answers drafts?": "Ungespeicherte Antwortenentwürfe wiederherstellen?",
    "Result": "Ergebnis",
    "Save Changes": "Änderungen speichern",
    "Save point": "Punkt speichern",
    "Save project as new": "Als neues Projekt speichern",
    "Seems project is deleted from other user, drop if resave it?": "Projekt anscheinend durch anderen Benutzer gelöscht. Verwerfen und speichern?",
    "Select": "auswählen",
    "Select Language": "Sprache auswählen",
    "Select tag": "Kennzeichen auswählen",
    "Selected files:": "Ausgewählte Dateien:",
    "Send": "Senden",
    "Sequences": "Abfolgen",
    "Server": "Server",
    "Settings": "Einstellungen",
    "Show configuration details": "Konfigurationsdetails anzeigen",
    "Show file history": "Dateiversionsverlauf anzeigen",
    "Show missing first": "Fehlende zuerst anzeigen",
    "Show questions JSON representation": "Fragen als JSON-Darstellung anzeigen",
    "Snapshots": "Momentaufnahmen",
    "Something went wrong, please try again": "Fehler, bitte versuchen Sie es erneut.",
    "Spec Configs": "Spezifikationskonfigurationen",
    "Spec Information": "Spezifikationsinformation",
    "Specifications": "Spezifikationen",
    "Status": "Status",
    "Suffix": "Suffix",
    "Tags": "Kennzeichen",
    "Test Coverage Reports": "Berichte des Testumfangs",
    "Test if processable": "Testen, wenn Verarbeitung möglich",
    "The name you entered is already in use, please enter a different name.": "Der eingegebene Name wird bereits verwendet. Geben Sie einen anderen Namen ein.",
    "There are conflict between project versions, how to solve it?": "Konflikt zwischen Projektversionen. Wie möchten Sie ihn lösen?",
    "Token is not valid, go to your settings page and try change email again": "Token ungültig. Gehen Sie zur Seite \"Einstellungen\" und ändern Sie die E-Mail-Adresse.",
    "Translations": "Übersetzungen",
    "Type": "Typ",
    "Type Name": "Name des Typs",
    "UnitPrice": "Stückpreis",
    "Unpublish": "Veröffentlichung aufheben",
    "Updated by": "Aktualisiert von",
    "Upload": "Hochladen",
    "Upload file": "Datei hochladen",
    "Upload file with different name": "Datei mit anderem Namen hochladen",
    "Uploaded": "Wurde hochgeladen",
    "Uploaded at": "Wurde hochgeladen um",
    "Uploaded by": "Wurde hochgeladen von",
    "Uploading": "Wird hochgeladen",
    "Users": "Benutzer",
    "Version": "Version",
    "available": "Verfügbar",
    "create new spec config": "Neue Spez.konfig. erstellen",
    "delete answers set": "Antwortensatz löschen",
    "delete point": "Punkt löschen",
    "delete snapshot": "Momentaufnahme löschen",
    "download question set": "Fragensatz herunterladen",
    "edit menu": "Menü Bearbeiten",
    "preview compliance": "Vorschau für Konformität",
    "preview consistency": "Vorschau für Konsistenz",
    "preview data sheet": "Vorschau für Datenblatt",
    "preview drawing": "Vorschau für Zeichnung",
    "preview point list": "Vorschau für Punktliste",
    "preview question set": "Vorschau für Fragensatz",
    "preview sequence": "Vorschau für Abfolge",
    "preview spec config": "Vorschau für Spezifikationskonfig.",
    "preview specification": "Vorschau für Spezifikation",
    "revert question set": "Fragensatz zurücksetzen",
    "select country": "Land auswählen",
    "select language": "Sprache auswählen",
    "select menu item": "Menüelement auswählen",
    "select product": "Produkt auswählen",
    "select project": "Projekt auswählen",
    "select spec": "Spezifikation auswählen",
    "set active snapshot": "Aktive Momentaufnahme einstellen",
    "translate": "Übersetzen",
    "upload mandatory question set": "Obligatischen Fragensatz hochladen",
    "upload new compliance": "Neue Konformität hochladen",
    "upload new consistency": "Neue Konsistenz hochladen",
    "upload new data sheet": "Neues Datenblatt hochladen",
    "upload new drawing": "Neue Zeichnung hochladen",
    "upload new file": "Neue Datei hochladen",
    "upload new point list": "Neue Punktliste hochladen",
    "upload new question set": "Neuen Fragensatz hochladen",
    "view answers set": "Antwortensatz anzeigen",
    "Level": "Niveau",
    "Date Created": "Datum erstellt",
    "Rename": "Umbenennen",
    "Create specification": "Spezifikation anlegen",
    "download files": "Download-Dateien",
    "get sharable link": "teilbaren Link erhalten",
    "General Project information": "Allgemeine Projektinformationen",
    "Equipment and systems,": "Geräte und Systeme,",
    "specification Options": "Spezifikations-Optionen",
    "Proposal requirements": "Anforderungen an den Vorschlag",
    "Software and User Interfaces": "Software und Benutzeroberflächen",
    "Network Architecture": "Netzwerk-Architektur",
    "Protocols and integration": "Protokolle und Integration",
    "Graphic options": "Grafische Optionen",
    "Project Execution": "Projektdurchführung",
    "Documents": "Dokumente",
    "Fire": "Feuer",
    "Security": "Sicherheit",
    "Building Automation": "Gebäudeautomation",
    "Test only": "Nur Test",
    "Next": "Nächster",
    "Add sub folder": "Unterordner hinzufügen",
    "not available": "nicht erhältlich",
    "Rename specification": "Spezifikation umbenennen",
    "Progress": "Fortschritt",
    "Search": "Suche",
    "Last": "Letzte",
    "Previous": "Bisherige",
    "First": "Zuerst",
    "Show 10 Entries": "Zeige 10 Einträge",
    "Showing 1 to 3 of 3 entries": "Zeige 1 bis 3 von 3 Einträgen",
    "Project Sharing": "Projektfreigabe",
    "Specification Name": "Spezifikationsname"
  });
  gettextCatalog.setStrings("es_gen", {
    "Select file to upload...": "Seleccionar archivo para cargar...",
    "Add country": "Agregar país",
    "Edit country information": "Editar información de país",
    "Edit file": "Editar archivo",
    "Enter equipment name": "Introducir nombre del equipo",
    "Rename Project": "Cambiar nombre de proyecto",
    "Restore Unsaved Answers": "Restaurar respuestas no guardadas",
    "Saving conflict": "Conflicto al guardar",
    "Select item and enter name": "Seleccionar elemento e introducir nombre",
    "Set copy name": "Establecer nombre de copia",
    "Upload entry question set...": "Cargar conjunto de preguntas de entrada...",
    "Back": "Atrás",
    "Cancel": "Cancelar",
    "Close": "Cerrar",
    "Decline all": "Rechazar todo",
    "Drop": "Soltar",
    "File history": "Historial de archivos",
    "No": "No",
    "Question set configuration history": "Historial de configuración de conjunto de preguntas",
    "Replace all": "Reemplazar todo",
    "Resave": "Volver a guardar",
    "Save": "Guardar",
    "Save As Copy": "Guardar como copia",
    "Save project": "Guardar proyecto",
    "Solve replace conflicts": "Resolver conflictos de sustitución",
    "Unpublish Spec Configuration": "Cancelar publicación de configuración de especificaciones",
    "Use Mine": "Usar la mía",
    "Use Newer": "Usar la más reciente",
    "Yes": "Sí",
    "(select language)": "(seleccionar idioma)",
    "Actions": "Acciones",
    "Activate": "Activar",
    "Add": "Agregar",
    "Add Configuration": "Agregar configuración",
    "Add Country": "Agregar país",
    "Add new": "Agregar nuevo",
    "Add new point": "Agregar punto nuevo",
    "Add translation": "Agregar traducción",
    "Admin": "Admin",
    "All / None": "Todo/Nada",
    "Are you sure you want to unpublish spec configuration": "¿Seguro que desea cancelar la publicación de la configuración de especificaciones?",
    "Bill of Materials": "Lista de materiales",
    "Cannot create spec configuration": "No se puede crear la configuración de especificaciones",
    "Cannot upload": "No se puede cargar",
    "Cannot upload file": "No se puede cargar archivo",
    "Cannot upload question set configuration": "No se puede cargar la configuración del conjunto de preguntas",
    "Client": "Cliente",
    "Column": "Columna",
    "Comments": "Comentarios",
    "Completed": "Completado",
    "Compliances": "Cumplimiento",
    "Consistences": "Coherencias",
    "Contact Us": "Contacto",
    "Copy": "Copiar",
    "Copy menu item": "Copiar elemento de menú",
    "Counter": "Contador",
    "Countries": "Países",
    "Country": "País",
    "Country Code (ISO 2)": "Código de país (ISO 2)",
    "Country:": "País:",
    "Create": "Crear",
    "Create By": "Creado por",
    "Create New Project": "Crear proyecto nuevo",
    "Create spec configuration": "Crear configuración de especificaciones",
    "Created By": "Creado por",
    "Currency": "Moneda",
    "Data Sheets": "Hojas de datos",
    "DataSheets": "Hojas de datos",
    "Decline files replace:": "Rechazar sustitución de archivos:",
    "Delete": "Eliminar",
    "Delete compliance": "Eliminar cumplimiento",
    "Delete consistency": "Eliminar coherencia",
    "Delete data sheet": "Eliminar hoja de datos",
    "Delete drawing": "Eliminar plano",
    "Delete file": "Eliminar archivo",
    "Delete menu item": "Eliminar elemento de menú",
    "Delete point list": "Eliminar lista de puntos",
    "Delete question set": "Eliminar conjunto de preguntas",
    "Delete sequence": "Eliminar secuencia",
    "Delete spec configuration": "Eliminar configuración de especificaciones",
    "Delete specification": "Eliminar especificación",
    "Description": "Descripción",
    "Display": "Mostrar",
    "Download": "Descargar",
    "Download Full Spec as Zip": "Descargar especificación completa como zip",
    "Download compliance": "Descargar cumplimiento",
    "Download configuration data": "Descargar datos de configuración",
    "Download consistency": "Descargar coherencia",
    "Download data sheet": "Descargar hoja de datos",
    "Download drawing": "Descargar plano",
    "Download file": "Descargar archivo",
    "Download latest version": "Descargar versión más reciente",
    "Download original": "Descargar original",
    "Download point list": "Descargar lista de puntos",
    "Download processed": "Descargar procesados",
    "Download question set": "Descargar conjunto de preguntas",
    "Download selected files": "Descargar archivos seleccionados",
    "Download sequence": "Descargar secuencia",
    "Download specification": "Descargar especificación",
    "Drawings": "Planos",
    "Duplicate": "Duplicado",
    "Duplicates": "Duplicados",
    "Edit": "Editar",
    "Edit Spec Configuration": "Editar configuración de especificación",
    "Edit menu item": "Editar elemento de menú",
    "Edit menu item name": "Editar nombre de elemento de menú",
    "Edit name": "Editar nombre",
    "Edit point": "Editar punto",
    "Equipment Schematics": "Esquemas de equipo",
    "File ID": "ID de archivo",
    "File Name": "Nombre de archivo",
    "File is not uploaded": "No se ha cargado el archivo",
    "Files Repository": "Repositorio de archivos",
    "Header": "Encabezado",
    "Header label": "Etiqueta de encabezado",
    "Hello": "Hola",
    "Hide empty sections": "Ocultar secciones vacías",
    "History": "Historial",
    "Home": "Inicio",
    "Invalid": "No válido",
    "Invalid Lines": "Líneas no válidas",
    "Invalid Question set": "Conjunto de preguntas no válido",
    "Json Preview": "Vista previa JSON",
    "Label": "Etiqueta",
    "Language": "Idioma",
    "Language:": "Idioma:",
    "Languages": "Idiomas",
    "Last Updated": "Última actualización",
    "Legend": "Leyenda",
    "Logic": "Lógica",
    "Login": "Inicio de sesión",
    "Logout": "Cierre de sesión",
    "Model Number": "Número de modelo",
    "Name": "Nombre",
    "Name is required": "El nombre es obligatorio",
    "New Project": "Proyecto nuevo",
    "Open": "Abrir",
    "Open project": "Abrir proyecto",
    "Original": "Original",
    "Params": "Parámetros",
    "Part. No": "N.º de pieza",
    "Pending Registrations": "Registros pendientes",
    "Point Lists": "Listas de puntos",
    "PreSelected": "Preseleccionado",
    "Preview": "Vista previa",
    "Preview answers": "Vista previa de respuestas",
    "Preview file": "Vista previa de archivo",
    "Preview latest version": "Vista previa de versión más reciente",
    "Preview original": "Vista previa de original",
    "Preview processed": "Vista previa de procesados",
    "Preview question set": "Vista previa de conjunto de preguntas",
    "Price": "Precio",
    "Product": "Producto",
    "Product:": "Producto:",
    "Projects": "Proyectos",
    "Projects Count": "Recuento de proyectos",
    "Publish": "Publicar",
    "Publish Spec Configuration": "Publicar configuración de especificación",
    "Published": "Publicado",
    "Quantity": "Cantidad",
    "Question Sets": "Conjuntos de preguntas",
    "Questions in tree": "Preguntas en árbol",
    "Referred Files": "Archivos remitidos",
    "Referred by ": "Remitidos por ",
    "Register": "Registro",
    "Restore unsaved answers drafts?": "¿Restaurar borradores de respuestas no guardados?",
    "Result": "Resultado",
    "Save Changes": "Guardar cambios",
    "Save point": "Guardar punto",
    "Save project as new": "Guardar proyecto como nuevo",
    "Seems project is deleted from other user, drop if resave it?": "Parece que otro usuario ha eliminado el proyecto; ¿desea descartar la eliminación y guardar el proyecto?",
    "Select": "Seleccionar",
    "Select Language": "Seleccionar idioma",
    "Select tag": "Seleccionar etiqueta",
    "Selected files:": "Archivos seleccionados:",
    "Send": "Enviar",
    "Sequences": "Secuencias",
    "Server": "Servidor",
    "Settings": "Ajustes",
    "Show configuration details": "Mostrar detalles de configuración",
    "Show file history": "Mostrar historial de archivos",
    "Show missing first": "Mostrar primero los que faltan",
    "Show questions JSON representation": "Mostrar representación JSON de las preguntas",
    "Snapshots": "Instantáneas",
    "Something went wrong, please try again": "Se ha producido un error, vuelva a intentarlo",
    "Spec Configs": "Configuraciones de especificaciones",
    "Spec Information": "Información de especificaciones",
    "Specifications": "Especificaciones",
    "Status": "Estado",
    "Suffix": "Sufijo",
    "Tags": "Etiquetas",
    "Test Coverage Reports": "Informes de cobertura del test",
    "Test if processable": "Probar si se puede procesar",
    "The name you entered is already in use, please enter a different name.": "El nombre especificado ya está en uso, especifique otro nombre.",
    "There are conflict between project versions, how to solve it?": "Hay un conflicto entre versiones del proyecto, ¿cómo desea resolverlo?",
    "Token is not valid, go to your settings page and try change email again": "Token no válido; vaya a la página de ajustes y pruebe a volver a cambiar el correo electrónico",
    "Translations": "Traducciones",
    "Type": "Tipo",
    "Type Name": "Nombre de tipo",
    "UnitPrice": "Precio unitario",
    "Unpublish": "Cancelar publicación",
    "Updated by": "Actualizado por",
    "Upload": "Cargar",
    "Upload file": "Cargar archivo",
    "Upload file with different name": "Cargar archivo con otro nombre",
    "Uploaded": "Cargado",
    "Uploaded at": "Cargado a las",
    "Uploaded by": "Cargado por",
    "Uploading": "Cargando",
    "Users": "Usuarios",
    "Version": "Versión",
    "available": "disponible",
    "create new spec config": "crear nueva configuración de especificación",
    "delete answers set": "eliminar conjunto de respuestas",
    "delete point": "eliminar punto",
    "delete snapshot": "eliminar instantánea",
    "download question set": "descargar conjunto de preguntas",
    "edit menu": "menú Editar",
    "preview compliance": "vista previa de cumplimiento",
    "preview consistency": "vista previa de coherencia",
    "preview data sheet": "vista previa de hoja de datos",
    "preview drawing": "vista previa de plano",
    "preview point list": "vista previa de lista de puntos",
    "preview question set": "vista previa de conjunto de preguntas",
    "preview sequence": "vista previa de secuencia",
    "preview spec config": "vista previa de configuración de especificaciones",
    "preview specification": "vista previa de especificación",
    "revert question set": "revertir conjunto de preguntas",
    "select country": "seleccionar país",
    "select language": "seleccionar idioma",
    "select menu item": "seleccionar elemento de menú",
    "select product": "seleccionar producto",
    "select project": "seleccionar proyecto",
    "select spec": "seleccionar especificación",
    "set active snapshot": "establecer instantánea activa",
    "translate": "traducir",
    "upload mandatory question set": "cargar conjunto de preguntas obligatorio",
    "upload new compliance": "cargar nuevo cumplimiento",
    "upload new consistency": "cargar nueva coherencia",
    "upload new data sheet": "cargar nueva hoja de datos",
    "upload new drawing": "cargar nuevo plano",
    "upload new file": "cargar nuevo archivo",
    "upload new point list": "cargar nueva lista de puntos",
    "upload new question set": "cargar nuevo conjunto de preguntas",
    "view answers set": "ver conjunto de respuestas",
    "Level": "Nível",
    "Date Created": "fecha de creacion",
    "Rename": "Cambiar nombre",
    "Create specification": "Crear especificación",
    "download files": "descargar archivos",
    "get sharable link": "obtener un enlace para compartir",
    "General Project information": "Información general del proyecto",
    "Equipment and systems,": "Equipos y sistemas,",
    "specification Options": "Opciones de especificación",
    "Proposal requirements": "Requisitos de propuesta",
    "Software and User Interfaces": "Interfaces de usuario y software",
    "Network Architecture": "Arquitectura de red",
    "Protocols and integration": "Protocolos e integración",
    "Graphic options": "Opciones gráficas",
    "Project Execution": "Ejecución del proyecto",
    "Documents": "Documentos",
    "Fire": "Fuego",
    "Security": "Seguridad",
    "Building Automation": "Automatización de edificios",
    "Test only": "Únicamente prueba",
    "Next": "Siguiente",
    "Add sub folder": "Añadir subcarpeta",
    "not available": "no disponible",
    "Rename specification": "Renombrar especificación",
    "Progress": "Progreso",
    "Search": "Buscar",
    "Last": "Último",
    "Previous": "Anterior",
    "First": "primero",
    "Show 10 Entries": "Mostrar 10 entradas",
    "Showing 1 to 3 of 3 entries": "Mostrando de 1 a 3 de 3 entradas",
    "Project Sharing": "Compartir proyectos",
    "Specification Name": "Nombre de especificación"
  });
  gettextCatalog.setStrings("es_mex", {
    "Select file to upload...": "Seleccionar archivo para cargar...",
    "Add country": "Agregar país",
    "Edit country information": "Editar información de país",
    "Edit file": "Editar archivo",
    "Enter equipment name": "Especificar nombre del equipo",
    "Rename Project": "Cambiar nombre de proyecto",
    "Restore Unsaved Answers": "Restaurar respuestas sin guardar",
    "Saving conflict": "Conflicto al guardar",
    "Select item and enter name": "Seleccione el elemento y especifique el nombre",
    "Set copy name": "Establecer nombre de copia",
    "Upload entry question set...": "Cargar conjunto de preguntas de entrada...",
    "Back": "Atrás",
    "Cancel": "Cancelar",
    "Close": "Cerrar",
    "Decline all": "Rechazar todo",
    "Drop": "Soltar",
    "File history": "Historial de archivos",
    "No": "No",
    "Question set configuration history": "Historial de configuración de conjunto de preguntas",
    "Replace all": "Reemplazar todo",
    "Resave": "Volver a guardar",
    "Save": "Guardar",
    "Save As Copy": "Guardar como copia",
    "Save project": "Guardar proyecto",
    "Solve replace conflicts": "Resolver conflictos de sustitución",
    "Unpublish Spec Configuration": "Cancelar publicación de configuración de especificaciones",
    "Use Mine": "Utilizar mía",
    "Use Newer": "Utilizar más nueva",
    "Yes": "Sí",
    "(select language)": "(seleccionar idioma)",
    "Actions": "Acciones",
    "Activate": "Activar",
    "Add": "Agregar",
    "Add Configuration": "Agregar configuración",
    "Add Country": "Agregar país",
    "Add new": "Agregar nuevo",
    "Add new point": "Agregar nuevo punto",
    "Add translation": "Agregar traducción",
    "Admin": "Admin",
    "All / None": "Todo/nada",
    "Are you sure you want to unpublish spec configuration": "¿Seguro que quiere cancelar la publicación de la configuración de especificaciones?",
    "Bill of Materials": "Lista de materiales",
    "Cannot create spec configuration": "No se puede crear la configuración de especificaciones",
    "Cannot upload": "No se puede cargar",
    "Cannot upload file": "No se puede cargar el archivo",
    "Cannot upload question set configuration": "No se puede cargar la configuración del conjunto de preguntas",
    "Client": "Cliente",
    "Column": "Columna",
    "Comments": "Comentarios",
    "Completed": "Completado",
    "Compliances": "Cumplimiento",
    "Consistences": "Coherencias",
    "Contact Us": "Contacto",
    "Copy": "Copiar",
    "Copy menu item": "Copiar elemento de menú",
    "Counter": "Contador",
    "Countries": "Países",
    "Country": "País",
    "Country Code (ISO 2)": "Código de país (ISO 2)",
    "Country:": "País:",
    "Create": "Crear",
    "Create By": "Creado por",
    "Create New Project": "Crear nuevo proyecto",
    "Create spec configuration": "Crear configuración de especificaciones",
    "Created By": "Creado por",
    "Currency": "Moneda",
    "Data Sheets": "Hojas de datos",
    "DataSheets": "Hojas de datos",
    "Decline files replace:": "Rechazar sustitución de archivos:",
    "Delete": "Eliminar",
    "Delete compliance": "Eliminar cumplimiento",
    "Delete consistency": "Eliminar coherencia",
    "Delete data sheet": "Eliminar hojas de datos",
    "Delete drawing": "Eliminar dibujo",
    "Delete file": "Eliminar archivo",
    "Delete menu item": "Eliminar elemento de menú",
    "Delete point list": "Eliminar lista de puntos",
    "Delete question set": "Eliminar conjunto de preguntas",
    "Delete sequence": "Eliminar secuencia",
    "Delete spec configuration": "Eliminar configuración de especificaciones",
    "Delete specification": "Eliminar especificación",
    "Description": "Descripción",
    "Display": "Mostrar",
    "Download": "Descargar",
    "Download Full Spec as Zip": "Descargar especificaciones completas como zip",
    "Download compliance": "Descargar cumplimiento",
    "Download configuration data": "Descargar datos de configuración",
    "Download consistency": "Descargar coherencia",
    "Download data sheet": "Descargar hoja de datos",
    "Download drawing": "Descargar dibujo",
    "Download file": "Descargar archivo",
    "Download latest version": "Descargar versión más reciente",
    "Download original": "Descargar original",
    "Download point list": "Descargar lista de puntos",
    "Download processed": "Descargar procesado",
    "Download question set": "Descargar conjunto de preguntas",
    "Download selected files": "Descargar archivos seleccionados",
    "Download sequence": "Descargar secuencia",
    "Download specification": "Descargar especificación",
    "Drawings": "Dibujos",
    "Duplicate": "Duplicado",
    "Duplicates": "Duplicados",
    "Edit": "Editar",
    "Edit Spec Configuration": "Editar configuración de especificaciones",
    "Edit menu item": "Editar elemento de menú",
    "Edit menu item name": "Editar nombre del elemento de menú",
    "Edit name": "Editar nombre",
    "Edit point": "Editar punto",
    "Equipment Schematics": "Esquemas de equipo",
    "File ID": "ID de archivo",
    "File Name": "Nombre de archivo",
    "File is not uploaded": "No se cargó el archivo",
    "Files Repository": "Repositorio de archivos",
    "Header": "Encabezado",
    "Header label": "Etiqueta de encabezado",
    "Hello": "Hola",
    "Hide empty sections": "Ocultar secciones vacías",
    "History": "Historial",
    "Home": "Inicio",
    "Invalid": "No válido",
    "Invalid Lines": "Líneas no válidas",
    "Invalid Question set": "Conjunto de preguntas no válido",
    "Json Preview": "Vista previa JSON",
    "Label": "Etiqueta",
    "Language": "Idioma",
    "Language:": "Idioma:",
    "Languages": "Idiomas",
    "Last Updated": "Última actualización",
    "Legend": "Leyenda",
    "Logic": "Lógica",
    "Login": "Iniciar sesión",
    "Logout": "Cerrar sesión",
    "Model Number": "Número de modelo",
    "Name": "Nombre",
    "Name is required": "El nombre es obligatorio",
    "New Project": "Nuevo proyecto",
    "Open": "Abrir",
    "Open project": "Abrir proyecto",
    "Original": "Original",
    "Params": "Parámetros",
    "Part. No": "N.º de pieza",
    "Pending Registrations": "Registros pendientes",
    "Point Lists": "Listas de puntos",
    "PreSelected": "Preseleccionado",
    "Preview": "Vista previa",
    "Preview answers": "Vista previa de respuestas",
    "Preview file": "Vista previa de archivo",
    "Preview latest version": "Vista previa de versión más reciente",
    "Preview original": "Vista previa de original",
    "Preview processed": "Vista previa de procesado",
    "Preview question set": "Vista previa de conjunto de preguntas",
    "Price": "Precio",
    "Product": "Producto",
    "Product:": "Producto:",
    "Projects": "Proyectos",
    "Projects Count": "Recuento de proyectos",
    "Publish": "Publicar",
    "Publish Spec Configuration": "Publicar configuración de especificaciones",
    "Published": "Publicado",
    "Quantity": "Cantidad",
    "Question Sets": "Conjuntos de preguntas",
    "Questions in tree": "Preguntas en árbol",
    "Referred Files": "Archivos remitidos",
    "Referred by ": "Remitido por ",
    "Register": "Registrarse",
    "Restore unsaved answers drafts?": "¿Restaurar borradores de respuestas no guardados?",
    "Result": "Resultado",
    "Save Changes": "Guardar cambios",
    "Save point": "Guardar punto",
    "Save project as new": "Guardar proyecto como nuevo",
    "Seems project is deleted from other user, drop if resave it?": "Parece que otro usuario eliminó el proyecto; ¿descartar eliminación y volver a guardar?",
    "Select": "Seleccionar",
    "Select Language": "Seleccionar idioma",
    "Select tag": "Seleccionar etiqueta",
    "Selected files:": "Archivos seleccionados:",
    "Send": "Enviar",
    "Sequences": "Secuencias",
    "Server": "Servidor",
    "Settings": "Configuración",
    "Show configuration details": "Mostrar detalles de configuración",
    "Show file history": "Mostrar historial de archivos",
    "Show missing first": "Mostrar primero los que faltan",
    "Show questions JSON representation": "Mostrar preguntas como representación JSON",
    "Snapshots": "Instantáneas",
    "Something went wrong, please try again": "Hubo un error, vuelva a intentarlo",
    "Spec Configs": "Configuraciones de especificaciones",
    "Spec Information": "Información de especificaciones",
    "Specifications": "Especificaciones",
    "Status": "Estado",
    "Suffix": "Sufijo",
    "Tags": "Etiquetas",
    "Test Coverage Reports": "Informes de cobertura de pruebas",
    "Test if processable": "Probar si es procesable",
    "The name you entered is already in use, please enter a different name.": "El nombre especificado ya está en uso, especifique otro nombre.",
    "There are conflict between project versions, how to solve it?": "Hay un conflicto entre las versiones del proyecto, ¿cómo se va a resolver?",
    "Token is not valid, go to your settings page and try change email again": "Token no válido; vaya a la página de configuración e intente volver a cambiar el correo electrónico",
    "Translations": "Traducciones",
    "Type": "Tipo",
    "Type Name": "Nombre de tipo",
    "UnitPrice": "Precio unitario",
    "Unpublish": "Cancelar publicación",
    "Updated by": "Actualizado por",
    "Upload": "Cargar",
    "Upload file": "Cargar archivo",
    "Upload file with different name": "Cargar archivo con otro nombre",
    "Uploaded": "Cargado",
    "Uploaded at": "Cargado a las",
    "Uploaded by": "Cargado por",
    "Uploading": "Cargando",
    "Users": "Usuarios",
    "Version": "Versión",
    "available": "disponible",
    "create new spec config": "crear nueva configuración de especificaciones",
    "delete answers set": "eliminar conjunto de respuestas",
    "delete point": "eliminar punto",
    "delete snapshot": "eliminar instantánea",
    "download question set": "descargar conjunto de preguntas",
    "edit menu": "Menú Editar",
    "preview compliance": "vista previa de cumplimiento",
    "preview consistency": "vista previa de coherencia",
    "preview data sheet": "vista previa de hoja de datos",
    "preview drawing": "vista previa de dibujo",
    "preview point list": "vista previa de lista de puntos",
    "preview question set": "vista previa de conjunto de preguntas",
    "preview sequence": "vista previa de secuencia",
    "preview spec config": "vista previa de configuración de especificaciones",
    "preview specification": "vista previa de especificación",
    "revert question set": "revertir conjunto de preguntas",
    "select country": "seleccionar país",
    "select language": "seleccionar idioma",
    "select menu item": "seleccionar elemento de menú",
    "select product": "seleccionar producto",
    "select project": "seleccionar proyecto",
    "select spec": "seleccionar especificación",
    "set active snapshot": "establecer instantánea activa",
    "translate": "traducir",
    "upload mandatory question set": "cargar conjunto de preguntas obligatorio",
    "upload new compliance": "cargar nuevo cumplimiento",
    "upload new consistency": "cargar nueva coherencia",
    "upload new data sheet": "cargar nueva hoja de datos",
    "upload new drawing": "cargar nuevo dibujo",
    "upload new file": "cargar nuevo archivo",
    "upload new point list": "cargar nueva lista de puntos",
    "upload new question set": "cargar nuevo conjunto de preguntas",
    "view answers set": "ver conjunto de respuestas",
    "Level": "Nível",
    "Date Created": "fecha de creacion",
    "Rename": "Renombrar",
    "Create specification": "Crear especificación",
    "download files": "descargar archivos",
    "get sharable link": "obtener un enlace para compartir",
    "Equipment and systems,": "Equipos y sistemas",
    "specification Options": "Opciones de especificación",
    "Proposal requirements": "Requisitos de propuesta",
    "Software and User Interfaces": "Interfaces de usuario y software",
    "Network Architecture": "Arquitectura de red",
    "Protocols and integration": "Protocolos e integración",
    "Graphic options": "Opciones gráficas",
    "Project Execution": "Ejecución del proyecto",
    "Documents": "Documentos",
    "Fire": "Fuego",
    "Security": "Seguridad",
    "Building Automation": "Automatización de edificios",
    "Test only": "Solamente prueba",
    "Next": "Siguiente",
    "Add sub folder": "Añadir subcarpeta",
    "not available": "no disponible",
    "Rename specification": "Renombrar especificación",
    "Progress": "Progreso",
    "Search": "Buscar",
    "Last": "Último",
    "Previous": "Anterior",
    "First": "primero",
    "Show 10 Entries": "Mostrar 10 entradas",
    "Showing 1 to 3 of 3 entries": "Mostrando de 1 a 3 de 3 entradas",
    "Project Sharing": "Compartir proyectos",
    "Specification Name": "Nombre de especificación"
  });
  gettextCatalog.setStrings("por_brz", {
    "Select file to upload...": "Selecionar arquivo para fazer upload...",
    "Add country": "Adicionar país",
    "Edit country information": "Editar informações do país",
    "Edit file": "Editar arquivo",
    "Enter equipment name": "Inserir nome do equipamento",
    "Rename Project": "Renomear projeto",
    "Restore Unsaved Answers": "Restaurar respostas não salvas",
    "Saving conflict": "Conflito ao salvar",
    "Select item and enter name": "Selecionar item e inserir nome",
    "Set copy name": "Definir nome da cópia",
    "Upload entry question set...": "Fazer upload do conjunto de perguntas de inserção...",
    "Back": "Voltar",
    "Cancel": "Cancelar",
    "Close": "Fechar",
    "Decline all": "Rejeitar tudo",
    "Drop": "Soltar",
    "File history": "Histórico do arquivo",
    "No": "Não",
    "Question set configuration history": "Histórico de configuração do conjunto de perguntas",
    "Replace all": "Substituir tudo",
    "Resave": "Salvar novamente",
    "Save": "Salvar",
    "Save As Copy": "Salvar como cópia",
    "Save project": "Salvar projeto",
    "Solve replace conflicts": "Resolver conflitos de substituição",
    "Unpublish Spec Configuration": "Desfazer publicação da configuração das especificações",
    "Use Mine": "Usar a minha",
    "Use Newer": "Usar mais nova",
    "Yes": "Sim",
    "(select language)": "(escolha o idioma)",
    "Actions": "Ações",
    "Activate": "Ativar",
    "Add": "Adicionar",
    "Add Configuration": "Adicionar configuração",
    "Add Country": "Adicionar país",
    "Add new": "Adicionar novo",
    "Add new point": "Adicionar novo ponto",
    "Add translation": "Adicionar tradução",
    "Admin": "Administrador",
    "All / None": "Todos/Nenhum",
    "Are you sure you want to unpublish spec configuration": "Você tem certeza de que deseja desfazer a publicação da configuração de especificações",
    "Bill of Materials": "Lista de materiais",
    "Cannot create spec configuration": "Não é possível criar uma configuração de especificações",
    "Cannot upload": "Não é possível fazer upload",
    "Cannot upload file": "Não é possível fazer upload do arquivo",
    "Cannot upload question set configuration": "Não é possível fazer upload da configuração do conjunto de perguntas",
    "Client": "Cliente",
    "Column": "Coluna",
    "Comments": "Comentários",
    "Completed": "Concluído",
    "Compliances": "Conformidades",
    "Consistences": "Consistências",
    "Contact Us": "Entre em contato conosco",
    "Copy": "Copiar",
    "Copy menu item": "Copiar item do menu",
    "Counter": "Contador",
    "Countries": "Países",
    "Country": "País",
    "Country Code (ISO 2)": "Código do país (ISO 2)",
    "Country:": "País:",
    "Create": "Criar",
    "Create By": "Criado por",
    "Create New Project": "Criar novo projeto",
    "Create spec configuration": "Criar configuração de especificações",
    "Created By": "Criado por",
    "Currency": "Moeda",
    "Data Sheets": "Folhas de dados",
    "DataSheets": "Folhas de dados",
    "Decline files replace:": "Rejeitar substituição de arquivos:",
    "Delete": "Excluir",
    "Delete compliance": "Excluir conformidade",
    "Delete consistency": "Excluir consistência",
    "Delete data sheet": "Excluir folhas de dados",
    "Delete drawing": "Excluir desenho",
    "Delete file": "Excluir arquivo",
    "Delete menu item": "Excluir item do menu",
    "Delete point list": "Excluir lista de pontos",
    "Delete question set": "Excluir conjunto de perguntas",
    "Delete sequence": "Excluir sequência",
    "Delete spec configuration": "Excluir configuração de especificações",
    "Delete specification": "Excluir especificação",
    "Description": "Descrição",
    "Display": "Exibir",
    "Download": "Fazer download",
    "Download Full Spec as Zip": "Fazer download das especificações completas como zip",
    "Download compliance": "Fazer download da conformidade",
    "Download configuration data": "Fazer download dos dados de configuração",
    "Download consistency": "Fazer download da consistência",
    "Download data sheet": "Fazer download das folhas de dados",
    "Download drawing": "Fazer download do desenho",
    "Download file": "Fazer download do arquivo",
    "Download latest version": "Fazer download da versão mais recente",
    "Download original": "Fazer download do original",
    "Download point list": "Fazer download da lista de pontos",
    "Download processed": "Download processado",
    "Download question set": "Fazer download do conjunto de perguntas",
    "Download selected files": "Fazer download dos arquivos selecionados",
    "Download sequence": "Fazer download da sequência",
    "Download specification": "Fazer download da especificação",
    "Drawings": "Desenhos",
    "Duplicate": "Duplicata",
    "Duplicates": "Duplicados",
    "Edit": "Editar",
    "Edit Spec Configuration": "Editar configuração de especificações",
    "Edit menu item": "Editar item do menu",
    "Edit menu item name": "Editar nome do item do menu",
    "Edit name": "Editar nome",
    "Edit point": "Editar ponto",
    "Equipment Schematics": "Esquema do equipamento",
    "File ID": "ID do arquivo",
    "File Name": "Nome do arquivo",
    "File is not uploaded": "Não foi realizado o upload do arquivo",
    "Files Repository": "Repositório de arquivos",
    "Header": "Cabeçalho",
    "Header label": "Rótulo do cabeçalho",
    "Hello": "Olá",
    "Hide empty sections": "Ocultar seções vazias",
    "History": "Histórico",
    "Home": "Início",
    "Invalid": "Inválido",
    "Invalid Lines": "Linhas inválidas",
    "Invalid Question set": "Conjunto de perguntas inválido",
    "Json Preview": "Visualização Json",
    "Label": "Rótulo",
    "Language": "Idioma",
    "Language:": "Idioma:",
    "Languages": "Idiomas",
    "Last Updated": "Atualizado pela última vez",
    "Legend": "Legenda",
    "Logic": "Lógica",
    "Login": "Login",
    "Logout": "Logout",
    "Model Number": "Número do modelo",
    "Name": "Nome",
    "Name is required": "O nome é obrigatório",
    "New Project": "Novo projeto",
    "Open": "Abrir",
    "Open project": "Abrir projeto",
    "Original": "Original",
    "Params": "Parâmetros",
    "Part. No": "Nº da peça",
    "Pending Registrations": "Registros pendentes",
    "Point Lists": "Listas de pontos",
    "PreSelected": "Pré-selecionado",
    "Preview": "Visualização",
    "Preview answers": "Visualizar respostas",
    "Preview file": "Visualizar arquivo",
    "Preview latest version": "Visualizar versão mais recente",
    "Preview original": "Visualizar original",
    "Preview processed": "Visualização processada",
    "Preview question set": "Visualizar conjunto de perguntas",
    "Price": "Preço",
    "Product": "Produto",
    "Product:": "Produto:",
    "Projects": "Projetos",
    "Projects Count": "Contagem de projetos",
    "Publish": "Publicar",
    "Publish Spec Configuration": "Publicar configuração das especificações",
    "Published": "Publicado",
    "Quantity": "Quantidade",
    "Question Sets": "Conjuntos de perguntas",
    "Questions in tree": "Perguntas em árvore",
    "Referred Files": "Arquivos referidos",
    "Referred by ": "Referidos por ",
    "Register": "Registro",
    "Restore unsaved answers drafts?": "Restaurar rascunhos de respostas não salvas?",
    "Result": "Resultado",
    "Save Changes": "Salvar alterações",
    "Save point": "Salvar ponto",
    "Save project as new": "Salvar projeto como novo",
    "Seems project is deleted from other user, drop if resave it?": "Parece que o projeto foi excluído por outro usuário, você deseja ignorar e salvá-lo novamente?",
    "Select": "Selecionar",
    "Select Language": "Selecionar idioma",
    "Select tag": "Selecionar etiqueta",
    "Selected files:": "Arquivos selecionados:",
    "Send": "Enviar",
    "Sequences": "Sequências",
    "Server": "Servidor",
    "Settings": "Configurações",
    "Show configuration details": "Mostrar detalhes das configurações",
    "Show file history": "Mostrar histórico do arquivo",
    "Show missing first": "Mostrar primeiro os ausentes",
    "Show questions JSON representation": "Mostrar perguntas como representação JSON",
    "Snapshots": "Imagens instantâneas",
    "Something went wrong, please try again": "Algo deu errado, tente novamente",
    "Spec Configs": "Configurações de especificações",
    "Spec Information": "Informações de especificações",
    "Specifications": "Especificações",
    "Status": "Status",
    "Suffix": "Sufixo",
    "Tags": "Etiquetas",
    "Test Coverage Reports": "Relatórios de cobertura de teste",
    "Test if processable": "Testar se for processável",
    "The name you entered is already in use, please enter a different name.": "O nome que você inseriu já está em uso, insira um nome diferente.",
    "There are conflict between project versions, how to solve it?": "Existem conflitos entre as versões do projeto, como resolvê-los?",
    "Token is not valid, go to your settings page and try change email again": "O token não é válido, acesse a página de configurações e tente alterar o e-mail novamente",
    "Translations": "Traduções",
    "Type": "Tipo",
    "Type Name": "Digite o nome",
    "UnitPrice": "Preço unitário",
    "Unpublish": "Desfazer publicação",
    "Updated by": "Atualizado por",
    "Upload": "Atualizar",
    "Upload file": "Fazer upload do arquivo",
    "Upload file with different name": "Fazer upload do arquivo com um nome diferente",
    "Uploaded": "Upload realizado",
    "Uploaded at": "Upload realizado às",
    "Uploaded by": "Upload realizado por",
    "Uploading": "Fazendo upload",
    "Users": "Usuários",
    "Version": "Versão",
    "available": "disponível",
    "create new spec config": "criar nova configuração de especificações",
    "delete answers set": "excluir conjunto de respostas",
    "delete point": "excluir ponto",
    "delete snapshot": "excluir imagem instantânea",
    "download question set": "fazer download do conjunto de perguntas",
    "edit menu": "menu editar",
    "preview compliance": "visualizar conformidade",
    "preview consistency": "visualizar consistência",
    "preview data sheet": "visualizar folha de dados",
    "preview drawing": "visualizar desenho",
    "preview point list": "visualizar lista de pontos",
    "preview question set": "visualizar conjunto de perguntas",
    "preview sequence": "visualizar sequência",
    "preview spec config": "visualizar configuração de especificações",
    "preview specification": "visualizar especificação",
    "revert question set": "reverter conjunto de perguntas",
    "select country": "selecionar país",
    "select language": "selecionar idioma",
    "select menu item": "selecionar item do menu",
    "select product": "selecionar produto",
    "select project": "selecionar projeto",
    "select spec": "selecionar especificação",
    "set active snapshot": "definir imagem instantânea ativa",
    "translate": "traduzir",
    "upload mandatory question set": "fazer upload do conjunto de perguntas obrigatórias",
    "upload new compliance": "fazer upload da nova conformidade",
    "upload new consistency": "fazer upload da nova consistência",
    "upload new data sheet": "fazer upload da nova folha de dados",
    "upload new drawing": "fazer upload do novo desenho",
    "upload new file": "fazer upload do novo arquivo",
    "upload new point list": "fazer upload da nova lista de pontos",
    "upload new question set": "fazer upload do novo conjunto de perguntas",
    "view answers set": "visualizar conjunto de respostas",
    "Level": "Nível",
    "Date Created": "Data Criada",
    "Rename": "Renomear",
    "Create specification": "Criar especificação",
    "download files": "baixar arquivos",
    "get sharable link": "obter link compartilhável",
    "Equipment and systems,": "Equipamento e sistemas,",
    "specification Options": "Opções da especificação",
    "Proposal requirements": "Requisitos da proposta",
    "Software and User Interfaces": "Software e interfaces do usuário",
    "Network Architecture": "Arquitetura de rede",
    "Protocols and integration": "Protocolos e integração",
    "Graphic options": "Opções gráficas",
    "Project Execution": "Execução do projeto",
    "Documents": "Documentos",
    "Fire": "Incêndio",
    "Security": "Segurança",
    "Building Automation": "Automação do prédio",
    "Test only": "Somente teste",
    "Next": "Próximo",
    "Add sub folder": "Adicionar subpasta",
    "not available": "não disponível",
    "Rename specification": "Renomear especificação",
    "Progress": "Progresso",
    "Search": "Pesquisa",
    "Last": "Último",
    "Previous": "Anterior",
    "First": "Primeiro",
    "Show 10 Entries": "Mostrar 10 entradas",
    "Showing 1 to 3 of 3 entries": "Mostrando 1 a 3 de 3 inscrições",
    "Project Sharing": "Compartilhamento de Projetos",
    "Specification Name": "Nome da Especificação"
  });
  gettextCatalog.setStrings("el", {
    "Select file to upload...": "Επιλέξτε αρχείο για μεταφόρτωση…",
    "Add country": "Προσθήκη χώρας",
    "Edit country information": "Προσθήκη πληροφοριών χώρας",
    "Edit file": "Επεξεργασία αρχείου",
    "Enter equipment name": "Εισαγωγή ονομασίας εξοπλισμού",
    "Rename Project": "Μετονομασία έργου",
    "Restore Unsaved Answers": "Επαναφορά μη αποθηκευμένων απαντήσεων",
    "Saving conflict": "Αποθήκευση της διένεξης",
    "Select item and enter name": "Επιλογή στοιχείου και πληκτρολόγιση ονομασίας",
    "Set copy name": "Ορισμός ονόματος αντιγράφου",
    "Upload entry question set...": "Μεταφόρτωση συνόλου ερωτήσεων εισόδου...",
    "Back": "Πίσω",
    "Cancel": "Ακύρωση",
    "Close": "Κλείσιμο",
    "Decline all": "Απόρριψη όλων",
    "Drop": "Εγκατάλειψη",
    "File history": "Αρχείο ιστορικού",
    "No": "Όχι",
    "Question set configuration history": "Ιστορικό διαμόρφωσης συνόλου ερωτήσεων",
    "Replace all": "Αντικατάσταση όλων",
    "Resave": "Αποθήκευση ξανά",
    "Save": "Αποθήκευση",
    "Save As Copy": "Αποθήκευση ως αντίγραφο",
    "Save project": "Αποθήκευση έργου",
    "Solve replace conflicts": "Επίλυση αντικατάστασης διενέξης",
    "Unpublish Spec Configuration": "Κατάργηση δημοσίευσης των προδιαγραφών",
    "Use Mine": "Χρήση δικού μου",
    "Use Newer": "Χρήση νέου",
    "Yes": "Ναι",
    "(select language)": "(επιλέξτε γλώσσα)",
    "Actions": "Ενέργειες",
    "Activate": "Ενεργοποίηση",
    "Add": "Προσθήκη",
    "Add Configuration": "Προσθήκη Διαμόρφωσης",
    "Add Country": "Προσθήκη Χώρας",
    "Add new": "Προσθήκη νέου",
    "Add new point": "Προσθήκη νέου σημείου",
    "Add translation": "Προσθήκη μετάφρασης",
    "Admin": "Διαχειριστής",
    "All / None": "Όλα / Κανένα",
    "Are you sure you want to unpublish spec configuration": "Είστε βέβαιοι ότι θέλετε να καταργήσετε τη δημοσίευση της διαμόρφωσης προδιαγραφών",
    "Bill of Materials": "Λίστα υλικών",
    "Cannot create spec configuration": "Δεν είναι δυνατή η δημιουργία προδιαγραφών",
    "Cannot upload": "Δεν είναι δυνατή η μεταφόρτωση",
    "Cannot upload file": "Δεν είναι δυνατή η μεταφόρτωση του αρχείου",
    "Cannot upload question set configuration": "Δεν είναι δυνατή η μεταφόρτωση για τη διαμόρφωση των παραμέτρων",
    "Client": "Πελάτης",
    "Column": "Στήλη",
    "Comments": "Σχόλια",
    "Completed": "Ολοκληρώθηκε",
    "Compliances": "Συμμόρφωση",
    "Consistences": "Συνέπειες",
    "Contact Us": "Επικοινωνήστε μαζί μας",
    "Copy": "Αντιγραφή",
    "Copy menu item": "Αντιγραφή στοιχείου μενού",
    "Counter": "Μετρητής",
    "Countries": "Χώρες",
    "Country": "Χώρα",
    "Country Code (ISO 2)": "Κωδικός χώρας (ISO 2)",
    "Country:": "Χώρα:",
    "Create": "Δημιουργήστε",
    "Create By": "Δημιουργήθηκε από",
    "Create New Project": "Δημιουργία νέου έργου",
    "Create spec configuration": "Δημιουργία διαμορφώσιμων προδιαγραφών",
    "Created By": "Δημιουργήθηκε από",
    "Currency": "Νόμισμα",
    "Data Sheets": "Τεχνικά φυλλάδια",
    "DataSheets": "Τεχνικάφυλλάδια",
    "Decline files replace:": "Απόρριψη αντικατάστασης αρχείων:",
    "Delete": "Διαγραφή",
    "Delete compliance": "Διαγραφή συμμόρφωσης",
    "Delete consistency": "Διαγραφή συνέπειας",
    "Delete data sheet": "Διαγραφή τεχνικών φυλλαδίων",
    "Delete drawing": "Διαγραφή σχεδίου",
    "Delete file": "Διαγραφή αρχείου",
    "Delete menu item": "Διαγραφή στοιχείου μενού",
    "Delete point list": "Διαγραφή λίστας σημείων",
    "Delete question set": "Διαγραφή συνόλου ερωτήσεων",
    "Delete sequence": "Διαγραφή ακολουθίας",
    "Delete spec configuration": "Διαγραφή διαμόρφωσης προδιαγραφών",
    "Delete specification": "Διαγραφή προδιαγραφών",
    "Description": "Περιγραφή",
    "Display": "Απεικόνιση",
    "Download": "Λήψη",
    "Download Full Spec as Zip": "Λήψη των προδιαγραφών ως αρχείο Zip",
    "Download compliance": "Λήψη συμμόρφωσης",
    "Download configuration data": "Λήψη δεδομένων διαμόρφωσης",
    "Download consistency": "Λήψη συνέπειας",
    "Download data sheet": "Λήψη τεχνικού φυλλαδίου",
    "Download drawing": "Λήψη σχεδίου",
    "Download file": "Λήψη αρχείου",
    "Download latest version": "Λήψη της τελευταίας έκδοσης",
    "Download original": "Λήψη πρωτότυπου",
    "Download point list": "Λήψη λίστας σημείων",
    "Download processed": "Η λήψη πραγματοποιήθηκε",
    "Download question set": "Λήψη συνόλου ερωτήσεων",
    "Download selected files": "Λήψη επιλεγμένων αρχείων",
    "Download sequence": "Λήψη ακολουθίας",
    "Download specification": "Λήψη προδιαγραφών",
    "Drawings": "Σχέδια",
    "Duplicate": "Αντιγραφή",
    "Duplicates": "Αντίγραφα",
    "Edit": "Επεξεργασία",
    "Edit Spec Configuration": "Επεξεργασία διαμορφώσιμων προδιαγραφών",
    "Edit menu item": "Επεξεργασία στοιχείου μενού",
    "Edit menu item name": "Επεξεργασία ονόματος στοιχείου μενού",
    "Edit name": "Επεξεργασία ονόματος",
    "Edit point": "Επεξεργασία σημείου",
    "Equipment Schematics": "Σχέδια εξοπλισμού",
    "File ID": "ID αρχείου",
    "File Name": "Ονομα αρχείου",
    "File is not uploaded": "Το αρχείο δεν μεταφορτώνεται",
    "Files Repository": "Αποθετήριο αρχείων",
    "Header": "Επικεφαλίδα",
    "Header label": "Ετικέτα επικεφαλίδας",
    "Hello": "Χαίρετε",
    "Hide empty sections": "Απόκρυψη κενών τμημάτων",
    "History": "Ιστορικό",
    "Home": "Αρχική σελίδα",
    "Invalid": "Μη έγκυρο",
    "Invalid Lines": "Μη έγκυρες γραμμές",
    "Invalid Question set": "Μη έγκυρο σύνολο ερωτήσεων",
    "Json Preview": "Προεπισκόπηση Json",
    "Label": "Επιγραφή",
    "Language": "Γλώσσα",
    "Language:": "Γλώσσα:",
    "Languages": "Γλώσσες",
    "Last Updated": "Τελευταία ενημέρωση",
    "Legend": "Μύθος",
    "Logic": "Λογική",
    "Login": "Σύνδεση",
    "Logout": "Αποσύνδεση",
    "Model Number": "Αριθμός μοντέλου",
    "Name": "Όνομα  ",
    "Name is required": "Το όνομα απαιτείται",
    "New Project": "Νέο Έργο",
    "Open": "Άνοιγμα",
    "Open project": "Ανοίγμα έργου",
    "Original": "Πρωτότυπο",
    "Params": "Παράμετροι",
    "Part. No": "Αριθμ. ανταλλακτικού",
    "Pending Registrations": "Εκκρεμείς Εγγραφές",
    "Point Lists": "Λίστες σημείων",
    "PreSelected": "Προεπιλεγμένα",
    "Preview": "Προεπισκόπηση",
    "Preview answers": "Προεπισκόπηση απαντήσεων",
    "Preview file": "Προεπισκόπηση αρχείου",
    "Preview latest version": "Προεπισκόπηση της τελευταίας έκδοσης",
    "Preview original": "Προεπισκόπηση πρωτότυπου",
    "Preview processed": "Προεπισκόπηση επεξεργασίας",
    "Preview question set": "Προεπισκόπηση σετ ερωτήσεων",
    "Price": "Τιμή",
    "Product": "Προϊόν",
    "Product:": "Προϊόν:",
    "Projects": "Έργα",
    "Projects Count": "Καταμέτρηση έργων",
    "Publish": "Δημοσίευση",
    "Publish Spec Configuration": "Δημοσίευση διαμορφωμένων προδιαγραφών",
    "Published": "Δημοσιεύθηκε",
    "Quantity": "Ποσότητα",
    "Question Sets": "Σύνολα ερωτήσεων",
    "Questions in tree": "Ερωτήσεις σε δενδροδιάγραμμα",
    "Referred Files": "Αναφερόμενα Αρχεία",
    "Referred by ": "Παραπομπή από",
    "Register": "Εγγραφή",
    "Restore unsaved answers drafts?": "Επαναφορά των μη αποθηκευμένων πρόχειρων απαντήσεων;",
    "Result": "Αποτέλεσμα",
    "Save Changes": "Αποθήκευση αλλαγών",
    "Save point": "Αποθήκευση σημείου",
    "Save project as new": "Αποθηκεύστε το έργο ως νέο",
    "Seems project is deleted from other user, drop if resave it?": "Το έργο προφανώς διαγράφηκε από άλλο χρήστη. Απόρριψη και αποθήκευση;",
    "Select": "Επιλογή  ",
    "Select Language": "Επιλέξτε γλώσσα",
    "Select tag": "Επιλέξτε ετικέτα",
    "Selected files:": "Επιλεγμένα αρχεία:",
    "Send": "Αποστολή",
    "Sequences": "Ακολουθίες",
    "Server": "Διακομιστής",
    "Settings": "Ρυθμίσεις",
    "Show configuration details": "Εμφάνιση λεπτομερειών διαμόρφωσης",
    "Show file history": "Εμφάνιση ιστορικού αρχείων",
    "Show missing first": "Εμφάνιση πρώτα αυτών που λείπουν",
    "Show questions JSON representation": "Εμφάνιση ερωτήσεων ως αναπαράσταση JSON",
    "Snapshots": "Στιγμιότυπα",
    "Something went wrong, please try again": "Κάτι δεν πήγε καλά. Παρακαλώ ξαναπροσπαθήστε",
    "Spec Configs": "Ρυθμίσεις προδιαγραφών",
    "Spec Information": "Πληροφορίες Προδιαγραφών",
    "Specifications": "Προδιαγραφές",
    "Status": "Κατάσταση",
    "Suffix": "Κατάληξη",
    "Tags": "Ετικέτες",
    "Test Coverage Reports": "Εκθέσεις πεδίου δοκιμής",
    "Test if processable": "Δοκιμάστε εάν είναι δυνατή η επεξεργασία",
    "The name you entered is already in use, please enter a different name.": "Το όνομα που εισαγάγατε χρησιμοποιείται ήδη. Εισαγάγετε ένα διαφορετικό όνομα.",
    "There are conflict between project versions, how to solve it?": "Σύγκρουση μεταξύ των εκδόσεων του έργου. Πώς θα θέλατε να το λύσετε;",
    "Token is not valid, go to your settings page and try change email again": "Το διακριτικό δεν είναι έγκυρο, μεταβείτε στη σελίδα ρυθμίσεων και δοκιμάστε να αλλάξετε ξανά το email",
    "Translations": "Μεταφράσεις",
    "Type": "Πληκτρολογήστε",
    "Type Name": "Πληκτρολογήστε Όνομα",
    "UnitPrice": "Τιμή μονάδας",
    "Unpublish": "Κατάργηση δημοσίευσης",
    "Updated by": "Ενημερώθηκε από",
    "Upload": "Μεταφόρτωση",
    "Upload file": "Μεταφόρτωση αρχείου",
    "Upload file with different name": "Μεταφόρτωση αρχείου με διαφορετικό όνομα",
    "Uploaded": "Μεταφορτώθηκε",
    "Uploaded at": "Μεταφορτώθηκε στις",
    "Uploaded by": "Μεταφορτώθηκε από",
    "Uploading": "Μεταφόρτωση",
    "Users": "Χρήστες",
    "Version": "Έκδοση",
    "available": "διαθέσιμο",
    "create new spec config": "δημιουργία νέων προδιαγραφών",
    "delete answers set": "διαγράψτε το σύνολο των απαντήσεων",
    "delete point": "διαγραφή σημείου",
    "delete snapshot": "διαγραφή στιγμιότυπου",
    "download question set": "λήψη του συνόλου ερωτήσεων",
    "edit menu": "επεξεργασία μενού",
    "preview compliance": "προεπισκόπηση συμμόρφωσης",
    "preview consistency": "προεπισκόπηση συνοχής",
    "preview data sheet": "προεπισκόπηση τεχνικού φυλλαδίου",
    "preview drawing": "προεπισκόπηση σχεδίου",
    "preview point list": "προεπισκόπηση της λίστας σημείων",
    "preview question set": "προεπισκόπηση σετ ερωτήσεων",
    "preview sequence": "προεπισκόπηση ακολουθίας",
    "preview spec config": "Προεπισκόπηση διαμορφώσιμων προδιαγραφών",
    "preview specification": "Προεπισκόπηση προδιαγραφών",
    "project name": "όνομα έργου",
    "revert question set": "επαναφορά συνόλου ερωτήσεων",
    "select country": "επιλέξτε χώρα",
    "select language": "επιλέξτε γλώσσα",
    "select menu item": "επιλέξτε το στοιχείο μενού",
    "select product": "επιλέξτε προϊόν",
    "select project": "επιλέξτε έργο",
    "select spec": "επιλέξτε προδιαγραφή",
    "set active snapshot": "ορισμός ενεργού στιγμιότυπου",
    "translate": "μετάφραση",
    "upload mandatory question set": "μεταφόρτωση υποχρεωτικού συνόλου ερωτήσεων",
    "upload new compliance": "μεταφόρτωση νέας συμμόρφωσης",
    "upload new consistency": "μεταφόρτωση νέας συνέπειας",
    "upload new data sheet": "μεταφόρτωση νέου τεχνικού φυλλαδίου",
    "upload new drawing": "μεταφόρτωση νέου σχεδίου",
    "upload new file": "μεταφόρτωση νέου αρχείου",
    "upload new point list": "μεταφόρτωση νέας λίστας σημείων",
    "upload new question set": "μεταφόρτωση νέου συνόλου ερωτήσεων",
    "view answers set": "δείτε το σύνολο των απαντήσεων",
    "Level": "Επίπεδο",
    "Date Created": "Ημερομηνία Δημιουργίας",
    "Rename": "Μετονομασία",
    "Create specification": "Δημιουργία προδιαγραφής",
    "download files": "λήψη αρχείων",
    "get sharable link": "Λήψη συνδέσμου με δυνατότητα κοινής χρήσης",
    "General Project information": "Γενικές πληροφορίες έργου",
    "Equipment and systems,": "Συστήματα και εξοπλισμός,",
    "specification Options": "Επιλογές προδιαγραφών",
    "Proposal requirements": "Απαιτήσεις πρότασης",
    "Software and User Interfaces": "Λογισμικό και διεπαφές χρήστη",
    "Network Architecture": "Αρχιτεκτονική Δικτύων",
    "Protocols and integration": "Πρωτόκολλα και ολοκλήρωση",
    "Graphic options": "Επιλογές γραφικών",
    "Project Execution": "Εκτέλεση Έργου",
    "Documents": "Έγγραφα",
    "Fire": "Φωτιά",
    "Security": "Ασφάλεια",
    "Building Automation": "Αυτοματισμός Κτιρίου",
    "Test only": "Μόνο δοκιμή",
    "Next": "Επόμενο",
    "Add sub folder": "Προσθήκη υποφακέλου",
    "not available": "μη διαθέσιμο",
    "Rename specification": "Μετονομασία προδιαγραφής",
    "Progress": "Πρόοδος",
    "Search": "Αναζήτηση",
    "Last": "Τελευταίο",
    "Previous": "Προηγούμενο",
    "First": "Πρώτο",
    "Show 10 Entries": "Εμφάνιση 10 καταχωρήσεων",
    "Showing 1 to 3 of 3 entries": "Εμφάνιση 1 έως 3 από τις 3 καταχωρήσεις",
    "Project Sharing": "Κοινή χρήση έργου",
    "Specification Name": "Ονομασία προδιαγραφών",
    "undefined": "Επεξεργασία αρχείου"
  });
  gettextCatalog.setStrings("tr", {
    "Select file to upload...": "Yüklenecek Dosyayı Seçin ",
    "Add country": "Ülke Ekleyin ",
    "Edit country information": "Ülke Bilgisi Düzenleyin",
    "Edit file": "Dosya Bilgisi Düzenleyin",
    "Enter equipment name": "Ekipman Bilgisi girin ",
    "Rename Project": "Proje İsmi Değiştirin ",
    "Restore Unsaved Answers": "Kayıtlı Olmayan Cevaplayın Kaydedin ",
    "Saving conflict": "Çakışmaları Kaydet ",
    "Select item and enter name": "Konuyu Seçin ve İisim Girin ",
    "Set copy name": "Kopya İsmi girin ",
    "Upload entry question set...": "Giriş Sorusunu Yükleyin ",
    "Back": "Geri ",
    "Cancel": "İptal",
    "Close": "Kapat",
    "Decline all": "Hepsini Reddet",
    "Drop": "Bırakın ",
    "File history": "Dosya Geçmişi ",
    "No": "Hayır ",
    "Question set configuration history": "Soru Seti ",
    "Replace all": "Hepsini Yer Değiştir",
    "Resave": "Tekrar Kaydet ",
    "Save": "Kaydet",
    "Save As Copy": "Kopya Olarak Kaydet ",
    "Save project": "Projeyi Kaydet ",
    "Solve replace conflicts": "Değiştirilmiş Çakışmaları Çöz ",
    "Unpublish Spec Configuration": "Şartname Konfigürasyonunu yayınlama",
    "Use Mine": "Benimkini Kullan ",
    "Use Newer": "Yenilenmiş Kullan ",
    "Yes": "Evet",
    "(select language)": "Dil Seçin ",
    "Actions": "Aksiyonlar ",
    "Activate": "Aktive et",
    "Add": "Ekle ",
    "Add Configuration": "Konfigürasyon Ekle",
    "Add Country": "Ülke Ekleyin ",
    "Add new": "Yeni Ekle ",
    "Add new point": "Yeni Nokta Ekle ",
    "Add translation": "Çeviri Ekle ",
    "Admin": "Kullanıcı ",
    "All / None": "Hepsi / Hiçbiri ",
    "Are you sure you want to unpublish spec configuration": "Şartname Konfigürasyonunu yayınlamamak istediğinizden emin misiniz ?",
    "Bill of Materials": "Materyal Dökümü ",
    "Cannot create spec configuration": "Konfigürasyon Özelliği Oluşturulamaz",
    "Cannot upload": "Yüklenemez ",
    "Cannot upload file": "Dosya Yüklenemez ",
    "Cannot upload question set configuration": "Konfigürasyon Soru Seti Yüklenemez ",
    "Client": "Müşteri ",
    "Column": "Kolon ",
    "Comments": "Yorumlar ",
    "Completed": "Tamamlanmış ",
    "Compliances": "Uygunluklar",
    "Consistences": "Kıvamlar",
    "Contact Us": "Bizimle İletişim Kurun ",
    "Copy": "Kopyala",
    "Copy menu item": "Menü Öğesini Kopyalayın ",
    "Counter": "Sayıcı ",
    "Countries": "Ülkeler ",
    "Country": "Ülke ",
    "Country Code (ISO 2)": "Ülke Kodu (ISO 2)",
    "Country:": "Ülke:",
    "Create": "Oluştur ",
    "Create By": "Tarafından Oluşturuldu",
    "Create New Project": "Yeni Proje Oluştur",
    "Create spec configuration": "Konfigürasyon Özelliği Oluştur",
    "Created By": "Oluşturan",
    "Currency": "Para Birimi ",
    "Data Sheets": "Veri Sayfaları ",
    "DataSheets": "Verisayfaları ",
    "Decline files replace:": "Dosya Değiştirmeyi Reddet ",
    "Delete": "Sil ",
    "Delete compliance": "Uyumluluğu Sil ",
    "Delete consistency": "Tutarlılığı Sil ",
    "Delete data sheet": "Veri Sayfalarını Sil ",
    "Delete drawing": "Çizimi Sil ",
    "Delete file": "Dosyayı Sil ",
    "Delete menu item": "Menü Öğesini Sil ",
    "Delete point list": "Nokta Listesini Sil ",
    "Delete question set": "Soru Setini Sil ",
    "Delete sequence": "Diziyi Sil ",
    "Delete spec configuration": "Şartname Konfigürasyonunu Sil ",
    "Delete specification": "Şartnameyi Sil ",
    "Description": "Açıklama ",
    "Display": "Görüntüleme ",
    "Download": "İndirme ",
    "Download Full Spec as Zip": "Tam Özelliği Sıkıştırılmış İndir ",
    "Download compliance": "Uyumluluğu İndir ",
    "Download configuration data": "Konfigürasyon Bilgisini İndir ",
    "Download consistency": "Tutarlılığı İndir ",
    "Download data sheet": "Veri Sayfalarını İndir ",
    "Download drawing": "Çizimi İndir ",
    "Download file": "Dosyayı İndir ",
    "Download latest version": "Son Versiyonu İndir ",
    "Download original": "Orjinalini İndir ",
    "Download point list": "Nokta Listesini İndir ",
    "Download processed": "İndirme İşlendi ",
    "Download question set": "Soru Seti İndir ",
    "Download selected files": "Seçili Dosyaları İndir ",
    "Download sequence": "Diziyi İndir ",
    "Download specification": "Şartnameyi indir ",
    "Drawings": "Çizimler ",
    "Duplicate": "Kopya",
    "Duplicates": "Koplayalar",
    "Edit": "Düzenle",
    "Edit Spec Configuration": "Şartname Konfigürasyonunu Düzenle",
    "Edit menu item": "Menü Öğesini Düzenle",
    "Edit menu item name": "Menü Adı Öğesini Düzenle",
    "Edit name": "İisim Düzenle",
    "Edit point": "Nokta Düzenle",
    "Equipment Schematics": "Ekipman Şemaları ",
    "File ID": "Dosya Kimlik No ",
    "File Name": "Dosya Adı ",
    "File is not uploaded": "Dosya Yüklenmedi ",
    "Files Repository": "Dosya Deposu",
    "Header": "Başlık ",
    "Header label": "Başlık Etiketi ",
    "Hello": "Merhaba",
    "Hide empty sections": "Boş Bölümleri Sakla ",
    "History": "Geçmiş ",
    "Home": "Ana Sayfa",
    "Invalid": "Geçersiz",
    "Invalid Lines": "Geçersiz Satırlar",
    "Invalid Question set": "Geçersiz Soru Seti ",
    "Json Preview": "Json Önizlemesi ",
    "Label": "Etiket ",
    "Language": "Dil ",
    "Language:": "Dil:",
    "Languages": "Diller ",
    "Last Updated": "Son Güncellene",
    "Legend": "Efsane ",
    "Logic": "Mantık ",
    "Login": "Giriş ",
    "Logout": "Çıkış ",
    "Model Number": "Model Numarası ",
    "Name": "İisim ",
    "Name is required": "İisim Gerekli ",
    "New Project": "Yeni Proje",
    "Open": "Açık ",
    "Open project": "Açık Proje",
    "Original": "Orjinal ",
    "Params": "Parametreler ",
    "Part. No": "Bölüm Numarası ",
    "Pending Registrations": "Bekleyen Kayıtlar ",
    "Point Lists": "Nokta Listeleri ",
    "PreSelected": "Önceden Seçilmiş ",
    "Preview": "Önizleme",
    "Preview answers": "Yanıtları Önizleme",
    "Preview file": "Dosya Önizleme",
    "Preview latest version": "Son Versiyon Önizleme",
    "Preview original": "Orjinal Önizleme",
    "Preview processed": "Önizleme İşlenmiş",
    "Preview question set": "Soru Seti Önizleme",
    "Price": "Fiyat",
    "Product": "Ürün ",
    "Product:": "Ürün:",
    "Projects": "Projeler",
    "Projects Count": "Proje Sayısı",
    "Publish": "Yayınla",
    "Publish Spec Configuration": "Şartname Konfigürasyonu yayınla ",
    "Published": "Yayınlanmış ",
    "Quantity": "Miktar",
    "Question Sets": "Soru Setleri",
    "Questions in tree": "Ağaçtaki Sorular",
    "Referred Files": "Başvuru Dosyaları ",
    "Referred by ": "Tarafından Yönlendirildi",
    "Register": "Kayıt Ol",
    "Restore unsaved answers drafts?": "Kaydedilmeyen Yanıtları Geri Yükle",
    "Result": "Sonuç",
    "Save Changes": "Değişiklikleri Kaydet",
    "Save point": "Nokta Kaydet ",
    "Save project as new": "Projeyi Yeni Olarak Kaydet",
    "Seems project is deleted from other user, drop if resave it?": "Proje Diğer Kullanıcı Tarafından Silinmiş Görünüyor. Kurtarmak İsteniyor ise Bırakın",
    "Select": "Seç",
    "Select Language": "Dil Seç ",
    "Select tag": "Başlık Seç",
    "Selected files:": "Seçilmiş Dosyalar:",
    "Send": "Gönder ",
    "Sequences": "Dizi ",
    "Server": "Sunucu",
    "Settings": "Ayarlar",
    "Show configuration details": "Konfigürasyon Detaylarını Gösterin",
    "Show file history": "Dosya Geçmişi Göster",
    "Show missing first": "İlk Kaybolanı Göster",
    "Show questions JSON representation": "Json Gösterimi Soruları Göster",
    "Snapshots": "Anlık Görüntüler ",
    "Something went wrong, please try again": "Birşeyler Yanlış Oldu, Tekrar Deneyin ",
    "Spec Configs": "Şartname Konfigürasyonu ",
    "Spec Information": "Şartname Bilgisi",
    "Specifications": "Şartnameler ",
    "Status": "Statü ",
    "Suffix": "Son Ek ",
    "Tags": "Etiketler",
    "Test Coverage Reports": "Test Kapsamı Raporları ",
    "Test if processable": "İşlenebilir Olup, Olmadığını Test Edin ",
    "The name you entered is already in use, please enter a different name.": "Girmiş Olduğunuz İsim Mevcuttur, Değişik İisim Giriniz.",
    "There are conflict between project versions, how to solve it?": "Proje Sürümleri Arasında Çelişki Var, Nasıl Çözülür?",
    "Token is not valid, go to your settings page and try change email again": "Belirtilen geçerli değildir, ayarlar sayfasına gidin ve e-mail değiştirmeyi tekrar deneyin ",
    "Translations": "Çeviriler ",
    "Type": "Tip",
    "Type Name": "Tip Adı ",
    "UnitPrice": "Birim Fiyat",
    "Unpublish": "Yayından kaldır",
    "Updated by": "Tarafından Güncellenmiş",
    "Upload": "Yükle",
    "Upload file": "Dosya Yükle ",
    "Upload file with different name": "Farklı isim ile dosya yükle ",
    "Uploaded": "Yüklenmiş ",
    "Uploaded at": "Şuraya Yüklendi ",
    "Uploaded by": "Tarafından Yüklenmiş ",
    "Uploading": "Yükleniyor",
    "Users": "Kullanıcılar",
    "Version": "Versiyon ",
    "available": "Mevcut ",
    "create new spec config": "Yeni Şartname Konfigürasyonu Oluştur",
    "delete answers set": "Cevap Setini Sil ",
    "delete point": "Nokta Sil ",
    "delete snapshot": "Anlık Görüntüyü Sil ",
    "download question set": "Soru Seti İndir ",
    "edit menu": "Menüyü Düzenle",
    "preview compliance": "Uyumluluk Önizleme ",
    "preview consistency": "Tutarlılık Önizleme ",
    "preview data sheet": "Veri Sayfaları Önizleme ",
    "preview drawing": "Çizim Önizleme ",
    "preview point list": "Nokta Listesi Önizleme ",
    "preview question set": "Soru Seti Önizleme",
    "preview sequence": "Dizin Önizleme ",
    "preview spec config": "Şartname Konfigürasyonu Önizleme ",
    "preview specification": "Şartname Önizleme ",
    "project name": "Proje Adı ",
    "revert question set": "Soru Setini Geri Al",
    "select country": "Ülke Seç ",
    "select language": "Dil Seç ",
    "select menu item": "Menü Öğesini Seç ",
    "select product": "Ürün Seç",
    "select project": "Proje Seç ",
    "select spec": "Şartname Seç ",
    "set active snapshot": "Aktif Anlık Görüntü Ayarlayın ",
    "translate": "Çevir",
    "upload mandatory question set": "Soru Seti Yükleme Zorunlu ",
    "upload new compliance": "Yeni Uyumluluk Yükle ",
    "upload new consistency": "Yeni Tutarlılık Yükle ",
    "upload new data sheet": "Yeni Veri Sayfası Yükle ",
    "upload new drawing": "Yeni Çizim Yükle ",
    "upload new file": "Yeni Dosya Yükle ",
    "upload new point list": "Yeni Nokta Listesi Yükle ",
    "upload new question set": "Yeni Soru Seti Yükle ",
    "view answers set": "Cevap Seti Görüntüle ",
    "Level": "Seviye",
    "Date Created": "Tarih Oluşturuldu ",
    "Rename": "Yeniden Adlandır",
    "Create specification": "Şartname Oluştur ",
    "download files": "Dosyaları İndir ",
    "get sharable link": "Paylaşılabilir linki al",
    "General Project information": "Genel Proje Bilgisi",
    "Equipment and systems,": "Ekipman ve Sistemler ",
    "specification Options": "Şartname Seçenekleri ",
    "Proposal requirements": "Teklif Talepleri",
    "Software and User Interfaces": "Yazılım ve Kullanıcı Arayüzleri ",
    "Network Architecture": "Ağ Mimarisi",
    "Protocols and integration": "Protokoller ve Entegrasyon ",
    "Graphic options": "Grafik Seçenekleri ",
    "Project Execution": "Proje Yürütme ",
    "Documents": "Belgeler ",
    "Fire": "Yangın ",
    "Security": "Güvenlik ",
    "Building Automation": "Bina Otomasyonu ",
    "Test only": "Sadece Test ",
    "Next": "Sonraki ",
    "Add sub folder": "Alt Klasör Ekle ",
    "not available": "Mevcut Değil ",
    "Rename specification": "Şartnameyi Yeniden Adlandır ",
    "Progress": "Gelişim ",
    "Search": "Araştır",
    "Last": "Son ",
    "Previous": "Önceki ",
    "First": "İlk ",
    "Show 10 Entries": "10 Girdinin Gösterimi ",
    "Showing 1 to 3 of 3 entries": "3 Girdinin 1 den 3'e kadar Gösterimi ",
    "Project Sharing": "Proje Paylaşımı ",
    "Specification Name": "Şartname Adı ",
    "undefined": "Dosya Bilgisi Düzenleyin"
  });
  gettextCatalog.setStrings("fr_fr", {
    "Select file to upload...": "Sélectionner un fichier à télécharger...",
    "Add country": "Ajouter un pays",
    "Edit country information": "Modifier les informations du pays",
    "Edit file": "Modifier le fichier",
    "Enter equipment name": "Entrer le nom de l’équipement",
    "Rename Project": "Renommer le projet",
    "Restore Unsaved Answers": "Restaurer les réponses non enregistrées",
    "Saving conflict": "Enregistrement du conflit en cours",
    "Select item and enter name": "Sélectionner l’élément et entrer le nom",
    "Set copy name": "Définir le nom de la copie",
    "Upload entry question set...": "Télécharger l’ensemble de questions de saisie",
    "Back": "Retour",
    "Cancel": "Annuler",
    "Close": "Fermer",
    "Decline all": "Refuser tout",
    "Drop": "Abandonner",
    "File history": "Historique des fichiers",
    "No": "Non",
    "Question set configuration history": "Historique de la configuration de l’ensemble de questions",
    "Replace all": "Remplacer tout",
    "Resave": "Enregistrer à nouveau",
    "Save": "Enregistrer",
    "Save As Copy": "Enregistrer une copie",
    "Save project": "Enregistrer le projet",
    "Solve replace conflicts": "Résoudre les conflits de remplacement",
    "Unpublish Spec Configuration": "Annuler la publication de la configuration des spécifications",
    "Use Mine": "Utiliser le mien",
    "Use Newer": "Utiliser le plus récent",
    "Yes": "Oui",
    "(select language)": "(Sélectionner la langue)",
    "Actions": "Actions",
    "Activate": "Activer",
    "Add": "Ajouter",
    "Add Configuration": "Ajouter la configuration",
    "Add Country": "Ajouter un pays",
    "Add new": "Ajouter nouveau",
    "Add new point": "Ajouter un nouveau point",
    "Add translation": "Ajouter la traduction",
    "Admin": "Admin.",
    "All / None": "Tous / Aucun",
    "Are you sure you want to unpublish spec configuration": "Voulez-vous vraiment annuler la publication de la configuration des spécifications?",
    "Bill of Materials": "Nomenclatures",
    "Cannot create spec configuration": "Impossible de créer la configuration des spécifications",
    "Cannot upload": "Impossible de télécharger",
    "Cannot upload file": "Impossible de télécharger le fichier",
    "Cannot upload question set configuration": "Impossible de télécharger la configuration de l'ensemble de questions",
    "Client": "Client",
    "Column": "Colonne",
    "Comments": "Commentaires",
    "Completed": "Terminé",
    "Compliances": "Conformité",
    "Consistences": "Cohérence",
    "Contact Us": "Pour nous contacter",
    "Copy": "Copier",
    "Copy menu item": "Copier l’élément de menu",
    "Counter": "Compteur",
    "Countries": "Pays",
    "Country": "Pays",
    "Country Code (ISO 2)": "Code du pays (ISO 2)",
    "Country:": "Pays :",
    "Create": "Créer",
    "Create By": "Créé par :",
    "Create New Project": "Créer un nouveau projet",
    "Create spec configuration": "Créer une configuration des spécifications",
    "Created By": "Créateur",
    "Currency": "Devise",
    "Data Sheets": "Fiches techniques",
    "DataSheets": "Fiches techniques",
    "Decline files replace:": "Refuser de remplacer les fichiers :",
    "Delete": "Supprimer",
    "Delete compliance": "Supprimer la conformité",
    "Delete consistency": "Supprimer la cohérence",
    "Delete data sheet": "Supprimer la fiche technique",
    "Delete drawing": "Supprimer le dessin",
    "Delete file": "Supprimer le fichier",
    "Delete menu item": "Supprimer l’élément de menu",
    "Delete point list": "Supprimer la liste de points",
    "Delete question set": "Supprimer l'ensemble de questions",
    "Delete sequence": "Supprimer une séquence",
    "Delete spec configuration": "Supprimer une configuration des spécifications",
    "Delete specification": "Supprimer la spécification",
    "Description": "Description",
    "Display": "Afficher",
    "Download": "Télécharger",
    "Download Full Spec as Zip": "Télécharger la spécification complète sous zip",
    "Download compliance": "Télécharger la conformité",
    "Download configuration data": "Télécharger les données de configuration",
    "Download consistency": "Télécharger la cohérence",
    "Download data sheet": "Télécharger la fiche technique",
    "Download drawing": "Télécharger le dessin",
    "Download file": "Télécharger le fichier",
    "Download latest version": "Télécharger la dernière version",
    "Download original": "Télécharger l’originale",
    "Download point list": "Télécharger la liste de points",
    "Download processed": "Télécharger les éléments traités",
    "Download question set": "Télécharger l'ensemble de questions",
    "Download selected files": "Télécharger les fichiers sélectionnés",
    "Download sequence": "Télécharger la séquence",
    "Download specification": "Télécharger la spécification",
    "Drawings": "Dessins",
    "Duplicate": "Doublon",
    "Duplicates": "Doublons",
    "Edit": "Modifier",
    "Edit Spec Configuration": "Modifier la configuration des spécifications",
    "Edit menu item": "Modifier l’élément de menu",
    "Edit menu item name": "Modifier le nom de l’élément de menu",
    "Edit name": "Modifier le nom",
    "Edit point": "Modifier le point",
    "Equipment Schematics": "Schéma de l’équipement",
    "File ID": "ID du fichier",
    "File Name": "Nom de fichier",
    "File is not uploaded": "Fichier n’a pas été téléchargé",
    "Files Repository": "Référentiel de fichiers",
    "Header": "En-tête",
    "Header label": "Étiquette de l'en-tête",
    "Hello": "Bonjour",
    "Hide empty sections": "Masquer les sections vides",
    "History": "Historique",
    "Home": "Accueil",
    "Invalid": "Non valide",
    "Invalid Lines": "Lignes non valides",
    "Invalid Question set": "Ensemble de questions non valide",
    "Json Preview": "Aperçu de Json",
    "Label": "Étiquette",
    "Language": "Langue",
    "Language:": "Langue :",
    "Languages": "Langues",
    "Last Updated": "Date de la dernière mise à jour",
    "Legend": "Légende",
    "Logic": "Logique",
    "Login": "Connexion",
    "Logout": "Déconnexion",
    "Model Number": "Numéro de modèle",
    "Name": "Nom",
    "Name is required": "Le nom est obligatoire",
    "New Project": "Nouveau projet",
    "Open": "Ouvrir",
    "Open project": "Ouvrir le projet",
    "Original": "Original",
    "Params": "Param.",
    "Part. No": "Nº de pièce",
    "Pending Registrations": "En attente des enregistrements",
    "Point Lists": "Listes de points",
    "PreSelected": "Présélectionné",
    "Preview": "Aperçu",
    "Preview answers": "Aperçu des réponses",
    "Preview file": "Aperçu du fichier",
    "Preview latest version": "Aperçu de la dernière version",
    "Preview original": "Aperçu de l’originale",
    "Preview processed": "Aperçu de l’élément traité",
    "Preview question set": "Aperçu de l'ensemble de questions",
    "Price": "Prix",
    "Product": "Produit",
    "Product:": "Produit :",
    "Projects": "Projets",
    "Projects Count": "Nombre de projets",
    "Publish": "Publier",
    "Publish Spec Configuration": "Publier la configuration des spécifications",
    "Published": "Publiée",
    "Quantity": "Quantité",
    "Question Sets": "Ensembles de questions",
    "Questions in tree": "Questions dans l’arborescence",
    "Referred Files": "Fichiers référencés",
    "Referred by ": "Référé par ",
    "Register": "Enregistrer",
    "Restore unsaved answers drafts?": "Restaurer les ébauches de réponses non enregistrées?",
    "Result": "Résultat",
    "Save Changes": "Enregistrer les modifications",
    "Save point": "Enregistrer le point",
    "Save project as new": "Enregistrer le projet comme nouveau",
    "Seems project is deleted from other user, drop if resave it?": "Le projet semble avoir été supprimé par un autre utilisateur; l’abandonner s’il est enregistré à nouveau?",
    "Select": "Sélectionner",
    "Select Language": "Sélectionner la langue",
    "Select tag": "Sélectionner la balise",
    "Selected files:": "Fichiers sélectionnés :",
    "Send": "Envoyer",
    "Sequences": "Séquences",
    "Server": "Serveur",
    "Settings": "Paramètres",
    "Show configuration details": "Afficher les détails de configuration",
    "Show file history": "Afficher l'historique des fichiers",
    "Show missing first": "Afficher manquant d’abord",
    "Show questions JSON representation": "Afficher la représentation JSON des questions",
    "Snapshots": "Instantanés",
    "Something went wrong, please try again": "Un problème s’est produit, essayez à nouveau",
    "Spec Configs": "Configuratoin des spécifications",
    "Spec Information": "Informations sur les spécifications",
    "Specifications": "Spécifications",
    "Status": "État",
    "Suffix": "Suffixe",
    "Tags": "Balises",
    "Test Coverage Reports": "Tester les rapports de couverture",
    "Test if processable": "Tester si traitable",
    "The name you entered is already in use, please enter a different name.": "Le nom saisi est déjà utilisé; veuillez entrer un nom différent.",
    "There are conflict between project versions, how to solve it?": "Il y a des conflits entre les versions de projet; comment les résoudre?",
    "Token is not valid, go to your settings page and try change email again": "Le jeton n’est pas valide; allez à votre page de paramètres et tentez de changer l’adresse courriel à nouveau.",
    "Translations": "Traductions",
    "Type": "Type",
    "Type Name": "Nom type",
    "UnitPrice": "PrixUnitaire",
    "Unpublish": "Annuler la publication",
    "Updated by": "Mis à jour par",
    "Upload": "Télécharger",
    "Upload file": "Télécharger un fichier",
    "Upload file with different name": "Télécharger le fichier sous un nom différent",
    "Uploaded": "Téléchargé",
    "Uploaded at": "Téléchargé à",
    "Uploaded by": "Téléchargé par",
    "Uploading": "Téléchargement...",
    "Users": "Utilisateurs",
    "Version": "Version",
    "available": "disponible",
    "create new spec config": "créer une nouvelle config des spécifications",
    "delete answers set": "supprimer l'ensemble de questions",
    "delete point": "supprimer point",
    "delete snapshot": "supprimer l’instantané",
    "download question set": "télécharger l'ensemble de questions",
    "edit menu": "menu edition",
    "preview compliance": "aperçu de la conformité",
    "preview consistency": "aperçu de la cohérence",
    "preview data sheet": "aperçu de la fiche technique",
    "preview drawing": "aperçu du dessin",
    "preview point list": "aperçu de la liste de points",
    "preview question set": "aperçu de l'ensemble de questions",
    "preview sequence": "aperçu de la séquence",
    "preview spec config": "aperçu de la config. des spécifications",
    "preview specification": "aperçu de la spécification",
    "project name": "nom du projet",
    "revert question set": "rétablir l'ensemble de questions",
    "select country": "sélectionner le pays",
    "select language": "sélectionner la langue",
    "select menu item": "sélectionner l’élément de menu",
    "select product": "sélectionner le produit",
    "select project": "sélectionner le projet",
    "select spec": "sélectionner la spécification",
    "set active snapshot": "définir l’instantané actif",
    "translate": "traduire",
    "upload mandatory question set": "télécharger l’ensemble de questions obligatoires",
    "upload new compliance": "télécharger une nouvelle conformité",
    "upload new consistency": "télécharger une nouvelle cohérence",
    "upload new data sheet": "télécharger une nouvelle fiche technique",
    "upload new drawing": "télécharger un nouveau dessin",
    "upload new file": "télécharger un nouveau fichier",
    "upload new point list": "télécharger une nouvelle liste de points",
    "upload new question set": "télécharger le nouvel ensemble de questions",
    "view answers set": "afficher l'ensemble de questions",
    "Level": "Niveau",
    "Date Created": "Date créée",
    "Rename": "Renommer",
    "Create specification": "Créer une spécification",
    "download files": "Télécharger les fichiers",
    "get sharable link": "Obtenir un lien partageable",
    "General Project information": "Renseignements généraux sur le projet",
    "Equipment and systems,": "Équipement et systèmes,",
    "specification Options": "Options de la spécification",
    "Proposal requirements": "Exigences de la proposition",
    "Software and User Interfaces": "Logiciel et interfaces utilisateur",
    "Network Architecture": "Architecture de réseau",
    "Protocols and integration": "Protocoles et intégration",
    "Graphic options": "Options graphiques",
    "Project Execution": "Exécution de projets",
    "Documents": "Documents",
    "Fire": "Incendie",
    "Security": "Sécurité",
    "Building Automation": "Immotique",
    "Test only": "Essai seulement",
    "Next": "Suivant",
    "Add sub folder": "Ajouter sous-dossier",
    "not available": "Non disponible",
    "Rename specification": "Renommer la spécification",
    "Progress": "Progression",
    "Search": "Recherche",
    "Last": "Dernier",
    "Previous": "Précédent",
    "First": "Premier",
    "Show 10 Entries": "Montrer 10 entrées",
    "Showing 1 to 3 of 3 entries": "Montrant 1 à 3 de 3 entrées",
    "Project Sharing": "Partage de projet",
    "Specification Name": "nom de la spécification"
  });
}]);

"use strict";

angular.module("swolApp")
  .factory("Auth", ["$location", "$rootScope", "$http", "User", "$q", "$window", function Auth($location, $rootScope, $http, User, $q, $window) {
    var currentUser = {};
    var sessionPromise;

    function loadSession() {
      currentUser = {};
      sessionPromise = $http.get("/api/auth/session").then(function (response) {
        currentUser = response.data;
        currentUser.$promise = sessionPromise;
        return currentUser;
      }, function (err) {
        currentUser = {};
        currentUser.$promise = sessionPromise;
        return $q.reject(err);
      });
      currentUser.$promise = sessionPromise;
      return currentUser;
    }

    function submitLogout() {
      $window.location.assign("/auth/logout");
    }

    loadSession();

    return {

      /**
       * Authenticate user and save token
       *
       * @param  {Object}   user     - login info
       * @param  {Function} callback - optional
       * @return {Promise}
       */
      login: function () {
        var returnTo = $location.search().returnTo || "/";
        $window.location.href = "/auth/login?returnTo=" + encodeURIComponent(returnTo);
      },

      isNotification: function () {
        return $http.get("/api/notifications/report/my/all");
      },
      /**
       * Delete access token and user info
       *
       * @param  {Function}
       */
      logout: function () {
        currentUser = {};
        submitLogout();
      },

      /**
       * Create a new user
       *
       * @param  {Object}   user     - user info
       * @param  {Function} callback - optional
       * @return {Promise}
       */
      createUser: function (user, callback) {
        var cb = callback || angular.noop;
        var err = { message: "Signup is disabled." };

        cb(err);
        return $q.reject(err);
      },

      /**
       * Change password
       *
       * @param  {String}   oldPassword
       * @param  {String}   newPassword
       * @param  {Function} callback    - optional
       * @return {Promise}
       */
      changePassword: function (oldPassword, newPassword, callback) {
        var cb = callback || angular.noop;

        return User.changePassword({ id: currentUser._id }, {
          oldPassword: oldPassword,
          newPassword: newPassword
        }, function (user) {
          return cb(user);
        }, function (err) {
          return cb(err);
        }).$promise;
      },

      /**
       * Send email with link to reset password
       *
       * @param  {String}   email
       * @param  {Function} callback    - optional
       * @return {Promise}
       */
      forgotPassword: function (email) {
        return $http.put("/api/users/forgot-password/" + email);
      },

      /**
       * Validates reset password token
       *
       * @param  {String}   token
       * @param  {Function} callback    - optional
       * @return {Promise}
       */
      resetPasswordValidate: function (token) {
        return $http.put("/api/users/reset-password-validate/" + token);
      },

      /**
       * Reset password with token and new Password
       *
       * @param  {String}   token
       * @param  {String}   password
       * @param  {Function} callback    - optional
       * @return {Promise}
       */
      resetPassword: function (token, password) {
        return $http.post("/api/users/reset-password", {
          token: token,
          password: password
        });
      },

      /**
       * Remove social provider from the current user
       *
       * @param  {String}   provider
       * @param  {String}   id
       * @param  {Function} callback    - optional
       * @return {Promise}
       */
      removeOAuthAccount: function (provider, id, callback) {
        var cb = callback || angular.noop;
        return User.update({ id: currentUser._id }, {
          operation: "removeOAuthAccount",
          provider: provider,
          providerId: id
        }, function (user) {
          return cb(user);
        }, function (err) {
          return cb(err);
        }).$promise;
      },

      updateUser: function (user, callback) {
        var cb = callback || angular.noop;

        return User.update({ id: currentUser._id }, {
          operation: "changeData",
          user: user
        }, function (user) {
          return cb(user);
        }, function (err) {
          return cb(err);
        }).$promise;
      },

      validateChangeEmailToken: function (token, callback) {
        if (callback) callback(false);
        return $q.reject({ message: "Email changes are disabled." });
      },

      /**
       * Refresh all available info on authenticated user
       *
       * @return {Object} user
       */
      refreshCurrentUser: function () {
        return loadSession();
      },

      /**
       * Gets all available info on authenticated user
       *
       * @return {Object} user
       */
      getCurrentUser: function () {
        // if (!currentUser) $location.path("/login");
        return currentUser;
      },

      /**
       * Check if a user is logged in
       *
       * @return {Boolean}
       */
      isLoggedIn: function () {
        return currentUser.hasOwnProperty("role");
      },

      /**
       * Waits for currentUser to resolve before checking if user is logged in
       */
      isLoggedInAsync: function (cb) {
        if (sessionPromise) {
          sessionPromise.then(function () {
            cb(currentUser.hasOwnProperty("role"));
          }).catch(function () {
            cb(false);
          });
        } else if (currentUser.hasOwnProperty("role")) {
          cb(true);
        } else {
          cb(false);
        }
      },

      /**
       * Check if a user is an admin
       *
       * @return {Boolean}
       */
      isAdmin: function () {
        return currentUser.role === "admin";
      },

      /**
       * Check if a user is an admin
       *
       * @return {Boolean}
       */

      /**
       * Check if a user is a master
       *
       * @return {Boolean}
       */

      isMaster: function () {
        return currentUser.role === "master";
      },

      isInRole: function () {
        var args = Array.isArray(arguments[0]) ? arguments[0] :
          Array.prototype.slice.call(arguments);

        return args.indexOf(currentUser.role) >= 0;
      },

      hasAccess: function (project) {
        return project.createdBy.id === currentUser._id ||
          currentUser.role === "admin" ||
          currentUser.role === "master" ||
          currentUser.role === "tester" ||
          (project.access || []).find(function (x) { return x === currentUser._id; });
      }
    };
  }]);

"use strict";

angular.module("swolApp")
  .factory("User", ["$resource", function ($resource) {

    return $resource("/api/users/:id/:controller", {
      id: "@_id"
    },
    {
      changePassword: {
        method: "PUT",
        params: {
          controller: "password"
        }
      },
      get: {
        method: "GET",
        params: {
          id: "me"
        }
      },
      update: {
        method: "PUT",
        params: {
          controller: "update"
        }
      }
    });
  }]);

"use strict";

app.controller("BillOfMaterialDirectiveCtrl", function () {

});

"use strict";

app.directive("billOfMaterial", ["Evaluator", "ProjectService", function (Evaluator, ProjectService) {
  return {
    restrict: "E",
    templateUrl: "components/bill-of-materials/bill-of-material.html",

    scope: {
      billOfMaterial: "=source",
      question: "=question"
    },

    link: function (scope) {
      var abc = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      scope.current = ProjectService.current;

      scope.$watch("billOfMaterial", function () {
        if (!scope.billOfMaterial || !scope.billOfMaterial.materials) return;
        scope.additionalDataHeader = [];
        var normCol = 0;
        var maxCol = 0;

        scope.billOfMaterial.materials.forEach(function (material) {
          normCol = Object.keys(material).length - 2;
          var keys = Object.keys(material.additionalData).length;
          if (keys > maxCol) maxCol = keys;

          if (scope.current.project.answers && scope.question && scope.current.project.answers[scope.question.id]) {
            var answers = scope.current.project.answers[scope.question.id];
            Object.getOwnPropertyNames(answers).forEach(function (name) {
              if (material._id === name) {
                var current = answers[name];
                material.quantity = current.quantity;
                material.unitPrice = current.unitPrice;
              }
            });
          }
        });

        for (var i = normCol; i < maxCol + normCol; i++) {
          scope.additionalDataHeader.push(abc[i]);
        }

      });

      scope.inputChanged = function (material) {
        if (!material.quantity || !material.unitPrice) return;

        if (!scope.current.project.answers[scope.question.id]) scope.current.project.answers[scope.question.id] = {};

        scope.current.project.answers[scope.question.id][material._id] = {
          quantity: material.quantity,
          unitPrice: material.unitPrice
        };
      };

      scope.displayBOM = function (material) {
        if (scope.current.showConfig) return true;

        return Evaluator.evaluate(scope.current.answers(), material.swCode);
      };
    }
  };
}]);

"use strict";

app.service("BillOfMaterialService", ["$http", "$upload", "$q", "Utils", "Evaluator", function ($http, $upload, $q, Utils, Evaluator) {

  var instance = {

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/boms/",
        method: "POST",
        file: file,
        data: {
          specConfigID: specID,
          bomID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/boms/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/boms/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/boms/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadByPages: function (pages, specConfigID) {
      var boms = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "BOM" && question.fileFunction) {
            instance.fetchByName(specConfigID, question.fileFunction).then(function (response) {
              boms.push({
                bom: response,
                question: question
              });
            });
          }
        });
      });

      return boms;
    },

    loadManyByPages: function (pages, specConfigID, models) {
      var data = {
        specID: specConfigID,
        names: []
      };

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "BOM" && question.fileFunction) {
            if (models && Evaluator.evaluate(models, question.controlLogic))
              data.names.push(question.fileFunction);
          }
        });
      });

      return $q(function (resolve) {
        $http.post("/api/boms/load/names/", data).then(function (response) {
          if (response.data && response.data.length) {
            var results = [];

            response.data.forEach(function (item) {
              results.push({
                question: instance.getQuestionByFileFunction(pages, item.name),
                bom: item
              });
            });

            return resolve(results);
          } else return resolve(response.data);
        });
      });
    },

    namesByPages: function (pages) {
      var names = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "BOM" && question.fileFunction) {
            names.push(question.fileFunction);
          }
        });
      });

      return names;
    },

    getQuestionByFileFunction: function (pages, name) {
      for (var i = 0; i < pages.length; i++) {
        var page = pages[i];

        var question = _.find(page.questions, function (question) {
          return question.fileFunction === name;
        });

        if (question) return question;
      }
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/boms/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/boms/rename", data);
    },

    transformToTreeData: function (boms) {
      var result = {
        selectedNode: "",
        bomsData: [],

        nodeSelected: function (node) {
          this.selectedNode = node.data ? JSON.stringify(
            Utils.stripEmptyProperties(node.data),
            null, 2) : "";
        }
      };

      boms.materials.forEach(function (material) {
        var materialData = {
          class: "fa fa-list-alt text-warning",
          text: material.productPartNo,
          type: "material",
          folder: true,
          id: material.productPartNo,
          data: material
        };

        result.bomsData.push(materialData);
      });

      return result;
    }
  };

  return instance;
}]);

"use strict";

app.directive("breadcrumb", ["$stateParams", "$rootScope", "ProjectService", function ($stateParams, $rootScope, ProjectService) {
  return {
    restrict: "E",
    templateUrl: "components/breadcrumb/breadcrumb.html",

    scope: { },

    link: function (scope) {
      scope.current = ProjectService.current;
      scope.showEditName = false;
      scope.event = null;

      scope.navigateTo = function (node) {
        if (node.isDisabled) return;
        if (event) scope.event = event;

        if (scope.current.menuItem && (node.type === "MenuItem" || node.path.length > 1)) {
          var current = node;

          while (current.type !== "MenuItem") {
            current = current.parent;
          }

          if (scope.current.menuItem.id.toString() === current.id.toString()) {
            if (node.type === "MenuItem") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0].children[0] });
            if (node.type === "Group") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0] });
            if (node.type === "Label") $rootScope.$broadcast("qs:navigate:label", { label: node });
            if (node.type === "Question") $rootScope.$broadcast("qs:navigate:question", { question: node });

            scope.event.stopPropagation();
            return;
          }
        }

        switch (node.type) {
          case "Group":
            // Navigate to group first label
            if (node.children && node.children.length) {
              var labelNode = node.children[0];
              scope.navigateTo(labelNode);
            }
            break;

          case "Menu":
            // Go to menu tab
            $rootScope.$broadcast("qs:navigate:menu", { id: node.id, tab: "menu" });
            break;

          case "MenuItem":
            $rootScope.$broadcast("qs:navigate:menu:item", { menuItem: node });
            break;

          case "Label":
            if (node.path.length > 0) {
              // Navigate to menu item if is in m enu
              scope.navigateTo(node.parent.parent);
            }

            // Go to label start page
            $rootScope.$broadcast("qs:navigate:label", { label: node });
            break;

          case "Question":
            if (node.path.length > 1) {
              // Navigate to menu item if is in menu
              scope.navigateTo(node.parent.parent.parent);
            }

            // Go to question page
            $rootScope.$broadcast("qs:navigate:question", { question: node });
            break;
        }
      };

      scope.switchShowEditName = function (value) {
        scope.showEditName = value;
      };

      scope.editMenItemName = function (name) {
        $rootScope.$broadcast("qs:edit:menu:name", { name: name });
      };
    }
  };
}]);

app.directive("datatableFix", ["$document", function ($document) {

    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        elem.addBtn = attrs.addbtn === "true";

        scope.$watch(function () { return elem[0].childNodes.length; }, function () {
          // fix search box styles
          var arr = $(".dataTables_filter");

          if (arr.length) {
            var el = arr[0];

            el.firstChild.className = "search-box";
            if (el.firstChild.children.length) {
              el.firstChild.children[0].placeholder = "Search...";
            }
            var i = document.createElement("i");
            i.innerHTML = "<i class=\"fa fa-search search-box-icon\"></i>";
            el.firstChild.appendChild(i);
          }

          // add create btn if required

          if (elem.addBtn) {

            var buttons = $("#tableAddBtn");
            var toAdd = $("#hiddenBtn");

            if (buttons.length && toAdd.length) {
              // console.log('running')
              var el = buttons[0];
              var el2 = toAdd[0];

              Array.from(el2.children).forEach(function (child) {

                el.appendChild(child);
              });
            }

          }

        });
      }
    };
  }
]);

app.directive("ieSelectFix", ["$document", "$window", function ($document, $window) {

    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attributes) {
        var isIE = $document[0] && $document[0].attachEvent;
        if (!isIE) return;

        var control = element[0];
        var userAgent = $window.navigator.userAgent;

        // if it's IE9 fix dropdown's duplicated arrow
        if (userAgent.indexOf("MSIE 9") > 0)
          control.className += " ie-select";

        // to fix IE8 issue with parent and detail controller, we need to depend on the parent controller
        scope.$watch(attributes.ieSelectFix, function () {
          // setTimeout is needed starting from angular 1.3+
          setTimeout(function () {
            // this will add and remove the options to trigger the rendering in IE8
            var option = document.createElement("option");
            control.add(option, null);
            control.remove(control.options.length - 1);
          }, 0);
        });
      }
    };
  }
]).directive("ie11BorderFix", ["$document", "$rootScope", function ($document, $rootScope) {
  return {
    restrict: "A",
    link: function (scope, element, attributes) {

      $(window).resize(function () {
        if ($rootScope.isIE11) {
          var h = $(window).height() - 170;
          $(element).css("height", h + "px");
        }
      });
    }
  };
}]);

"use strict";

app.service("ComplianceService", ["$http", "$upload", "$q", function ($http, $upload, $q) {
  var instance = {

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/compliance/",
        method: "POST",
        file: file,

        data: {
          specConfigID: specID,
          itemID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/compliance/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/compliance/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/compliance/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/compliance/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/compliance", data);
    }
  };

  return instance;
}]);

"use strict";

app.controller("ConfirmCtrl", ["$scope", "$modalInstance", "title", "text", function ($scope, $modalInstance, title, text) {
  $scope.title = title;
  $scope.text = text;

  $scope.yes = function () {
    $modalInstance.close(true);
  };

  $scope.no = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("Confirm", ["$modal", function ($modal) {
  this.open = function (text, title, size) {
    return $modal.open({
      templateUrl: "components/confirm/confirm.html",
      controller: "ConfirmCtrl",
      size: size || "sm",
      resolve: {
        title: function () { return title; },
        text: function () { return text; }
      }
    }).result;
  };
}]);

"use strict";

app.service("ConsistencyService", ["$http", "$upload", "$q", function ($http, $upload, $q) {
  var instance = {

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/consistency/",
        method: "POST",
        file: file,

        data: {
          specConfigID: specID,
          pointListID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/consistency/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/consistency/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/consistency/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/consistency/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/consistency", data);
    }
  };

  return instance;
}]);

"use strict";

app.service("CreateProjectDialog", ["$modal", function ($modal) {
  return {
    open: function (options) {
      return $modal.open({
        templateUrl: "components/create-project/create-project.html",
        controller: "CreateProjectDialogCtrl",
        size: "lg",
        resolve: {
          options: function () {
            return options;
          }
        }
      }).result;
    }
  };
}]);

"use strict";

app.controller("CreateProjectDialogCtrl", ["$scope", "$modalInstance", "$location", "$window", "Auth", "localStorageService", "options", "ProjectGroupingService", "$stateParams", "DTInstances", "Message", function ($scope, $modalInstance, $location, $window, Auth, localStorageService, options, ProjectGroupingService, $stateParams, DTInstances, Message) {
  $scope.options = options || {};
  $scope.project = $scope.options.project || { specID: $scope.options.spec ? $scope.options.spec._id : options.previous ? options.previous.specID : "" };
  $scope.project.asNew = $scope.options.isCopy;

  $scope.isCreate = options && !options.project;
  $scope.isAdmin = Auth.isAdmin;
  $scope.showingFolderSelector = false;
  $scope.options.folderName = "";

  $scope.options.key = $scope.options.spec ? $scope.options.spec.key : $scope.options.previous ? angular.copy($scope.options.previous.key) : {};
  $scope.options.selectSpec = !$scope.options.key.product;

  $scope.toggleFolderSelector = function () {
    $scope.showingFolderSelector = !$scope.showingFolderSelector;
    console.log($scope.showingFolderSelector);
  };

  $scope.save = function () {
    if (!$scope.inputsIsValid()) return;
    var response = {};

    // if project is creating save project info into storage and open new tab
    if ($scope.isCreate) {
      // generate UUID
      var uuid = generateUUID();
      $scope.project.folderName = $scope.options.folderName;
      $scope.project.folderId = $scope.options.folderId;
      $scope.project.forNewFolder = Boolean($scope.options.folderName);

      var compareName = $scope.project.folderName || $scope.project.name;

      DTInstances.getLast().then(function (data) {
        var rows = data.DataTable && data.DataTable.data() || [];

        for (var i = 0; i < rows.length; i++) {
          var name = rows[i].name;

          if (name.trim() === compareName) {
            Message.open("duplicate folder name " + compareName, "duplicate name", "md", "error");
            return;
          }
        }

        if (!$scope.project.name && $scope.project.folderName) {
          return ProjectGroupingService.addRootFolder($scope.project.folderName).then(function (res) {
            options.table.instance.reloadData();
            $modalInstance.close(null);
          });
        } else {
          localStorageService.set(uuid, $scope.project);

          // $location.path('/admin/project/create/' + uuid);

          // generate url
          var url = "/";
          // if IE9 build url with hash

          if ($window.location.hash.indexOf("#") === 0) {
            url = $window.location.protocol + "//";
            url += $window.location.host + "/#/";
          }

          url += "admin/project/create/" + uuid;
          $window.location.href = url;

          // open url into new tab
          // $window.open(url);
        }
      });
    } else { // save updated project info, or save project as new
      response = $scope.project;
    }

    // close popup
    $modalInstance.close(response);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.inputsIsValid = function () {

    if (!$scope.isCreate) return $scope.project.name;

    return $scope.project && ($scope.options.folderId ? $scope.project.name : $scope.options.folderName) && $scope.project.specID
      && $scope.options.key.country && $scope.options.key.language
      && $scope.options.key.product;
  };

  // dropdowns
  $scope.displayCountry = function (item) {
    if (!$scope.options.specs || !$scope.options.specs.length) return true;

    for (var i = 0; i < $scope.options.specs.length; i++) {
      var current = $scope.options.specs[i];

      if (current.key.country === item.code) return true;
    }
  };

  $scope.displayProduct = function (item) {
    if (!$scope.options.specs || !$scope.options.specs.length) return true;

    for (var i = 0; i < $scope.options.specs.length; i++) {
      var current = $scope.options.specs[i];

      if ($scope.options.key.country === current.key.country
          && current.key.product === item.code) return true;
    }
  };

  $scope.displayLanguage = function (item) {
    if (!$scope.options.specs || !$scope.options.specs.length) return true;

    for (var j = 0; j < $scope.options.specs.length; j++) {
      var current = $scope.options.specs[j];

      if ($scope.options.key.country === current.key.country
        && $scope.options.key.product === current.key.product
        && current.key.language === item.code) return true;
    }
  };

  $scope.displaySpec = function (item) {
    return $scope.options.key.country === item.key.country
      && $scope.options.key.language === item.key.language
      && $scope.options.key.product === item.key.product;
  };

  $scope.countryChanged = function () {
    delete $scope.options.key.language;
    delete $scope.project.specID;

    var filtered = $scope.products.filter(function (current) {
      return $scope.displayProduct(current);
    });

    if (filtered.length === 1) {
      if ($scope.options.key.product === filtered[0].code) productChanged();
      else $scope.options.key.product = filtered[0].code;
    } else delete $scope.options.key.product;

    $scope.anyChanged();
  };

  $scope.anyChanged = function () {
    delete options.previous;
  };

  $scope.$watch("options.key.product", productChanged);

  $scope.$watch("options.key.language", languageChanged);

  function productChanged() {
    if (options.previous) return;
    if ($scope.options.spec) return;

    delete $scope.project.specID;

    var filtered = $scope.languages.filter(function (current) {
      return $scope.displayLanguage(current);
    });

    if (filtered.length === 1) {
      if ($scope.options.key.language === filtered[0].code) languageChanged();
      else $scope.options.key.language = filtered[0].code;
    } else if ($scope.options.specs) delete $scope.options.key.language;
  }

  function languageChanged() {
    if (options.previous) return;
    if (!$scope.options.specs) return;
    if ($scope.options.spec) return;

    delete $scope.project.specID;

    // find first available spec with selected keys and set to spec drop down...
    for (var i = 0; i < $scope.options.specs.length; i++) {
      var current = $scope.options.specs[i];

      if ($scope.displaySpec(current)) {
        $scope.project.specID = current._id;
        return;
      }
    }
  }

  function generateUUID() {
    var d = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }
}]);

"use strict";

app.controller("DataSheetDirectiveCtrl", function () {

});

"use strict";

app.directive("datasheet", ["Evaluator", "FilesRepositoryService", "OfficePreviewDialog", "ProjectService", function (Evaluator, FilesRepositoryService, OfficePreviewDialog, ProjectService) {
  return {
    restrict: "E",
    templateUrl: "components/data-sheets/data-sheet.html",

    scope: {
      dataSheet: "=source",
      question: "=question",
      showAll: "=showAll"
    },

    link: function (scope) {
      scope.checkAll = {};
      scope.current = ProjectService.current;

      scope.$watch("dataSheet", function (val) {
        if (!val || !val.legend) return;
        // bindLegendPreChecksOnLoad();
        // bindPreChecks();
      });

      scope.displayDataSheetSection = function (dataSheet) {
        return dataSheet.sheets.some(x => scope.displayDataSheet(x));
      };

      scope.displayDataSheet = function (sheet) {
        if (scope.showAll) return true;
        return Evaluator.evaluate(scope.current.answers(), sheet.controlLogic);
      };

      scope.isChecked = function (sheet) {
        if (scope.question && scope.current.project.answers[scope.question.id])
          return scope.current.project.answers[scope.question.id].sheets.indexOf(sheet.id) >= 0;
      };

      scope.legendIsChecked = function (key, legend) {
        if (!scope.question || !scope.current.project.answers[scope.question.id]) return;
        return scope.current.project.answers[scope.question.id].legends.indexOf(key) >= 0;
      };

      scope.bindCheck = function (sheet) {
        if (!scope.question) return;
        if (!scope.current.project.answers[scope.question.id]) createEmptyAnswer();

        var exists = scope.current.project.answers[scope.question.id].sheets.indexOf(sheet.id);
        if (exists >= 0) {
          scope.current.project.answers[scope.question.id].sheets.splice(exists, 1); // remove from selected
          addToUnChecked(sheet); // add to unChecked
          return;
        }

        if (scope.displayDataSheet(sheet) && scope.displaySheet(sheet)) {
          scope.current.project.answers[scope.question.id].sheets.push(sheet.id);
          addToHandChecked(sheet);
        }
      };

      function addToHandChecked(sheet) {
        // if sheet was checked by user click add it to checked
        scope.current.project.answers[scope.question.id].handChecked[sheet.id] = true;
      }

      function addToUnChecked(sheet) {
        // if sheet has preSelected and it's calculating after each answer click it must be added in unChecked object to be checked for next preSelected adding
        if (scope.displayDataSheet(sheet) && scope.displaySheet(sheet)) {
          scope.current.project.answers[scope.question.id].unChecked[sheet.id] = true;
        }
      }

      scope.bindLegendCheck = function (key) {
        if (!scope.question) return;
        if (!scope.current.project.answers[scope.question.id]) createEmptyAnswer();

        var exists = scope.current.project.answers[scope.question.id].legends.indexOf(key);
        if (exists >= 0) {
          scope.current.project.answers[scope.question.id].legends.splice(exists, 1);

          var tmpSheets = angular.copy(scope.current.project.answers[scope.question.id].sheets);

          tmpSheets.forEach(function (sheetID) {
            var sheet = _.find(scope.dataSheet.sheets, function (tmpSheet) {
              return tmpSheet.id === sheetID;
            });

            if (!sheet || !sheet.fileReferences[key]) return;

            var remove = true;

            for (var fileLegendKey in sheet.fileReferences) {
              if (fileLegendKey !== key && scope.current.project.answers[scope.question.id].legends.indexOf(fileLegendKey) >= 0) remove = false;
            }

            if (remove) {
              var index = scope.current.project.answers[scope.question.id].sheets.indexOf(sheetID);
              scope.current.project.answers[scope.question.id].sheets.splice(index, 1);
              addToUnChecked(sheet);
            }
          });

          return;
        }

        scope.current.project.answers[scope.question.id].legends.push(key);
      };

      scope.checkAllSheet = function () {
        if (!scope.question || !scope.current.project.answers[scope.question.id]) return;

        if (scope.checkAll.sheets) {
          angular.forEach(scope.dataSheet.sheets, function (sheet) {
            if (!scope.displayDataSheet(sheet) || !scope.displaySheet(sheet)) return;

            if (scope.current.project.answers[scope.question.id].sheets.indexOf(sheet.id) < 0) {
              scope.current.project.answers[scope.question.id].sheets.push(sheet.id);
              addToHandChecked(sheet);
            }
          });
        } else {
          scope.current.project.answers[scope.question.id].sheets.forEach(function (sheetID) {
            addToUnChecked(_.find(scope.checkAll.dataSheets, function (tmp) {
              return tmp.id === sheetID;
            }));
          });

          scope.current.project.answers[scope.question.id].sheets.length = 0;
        }
      };

      scope.sheetsHeaderChecked = function () {
        if (!scope.question || !scope.current.project.answers[scope.question.id] || !scope.checkAll.dataSheets) return;

        scope.checkAll.sheets = scope.checkAll.dataSheets.filter(function (sheet) {
          return scope.displayDataSheet(sheet) && scope.displaySheet(sheet);
        }).length === scope.current.project.answers[scope.question.id].sheets.length;
      };

      scope.checkAllLegend = function () {
        if (!scope.question || !scope.current.project.answers[scope.question.id]) return;

        if (scope.checkAll.legends) {
          for (var key in scope.dataSheet.legend) {
            if (scope.current.project.answers[scope.question.id].legends.indexOf(key) < 0) scope.current.project.answers[scope.question.id].legends.push(key);
          }
        } else {
          // clear legends array
          scope.current.project.answers[scope.question.id].legends.length = 0;

          // before remove all sheets add some of them into unChecked
          scope.current.project.answers[scope.question.id].sheets.forEach(function (sheetID) {
            var sheet = _.find(scope.dataSheet.sheets, function (tmpSheet) {
              return tmpSheet.id === sheetID;
            });

            if (!sheet || !sheet.fileReferences[key]) return;

            var remove = true;

            for (var fileLegendKey in sheet.fileReferences) {
              if (fileLegendKey !== key && scope.current.project.answers[scope.question.id].legends.indexOf(fileLegendKey) >= 0) remove = false;
            }

            if (remove) addToUnChecked(sheet);
          });

          scope.current.project.answers[scope.question.id].sheets.length = 0;
        }
      };

      scope.legendsHeaderChecked = function () {
        if (!scope.dataSheet || !scope.question || !scope.current.project.answers[scope.question.id]) return;
        scope.checkAll.legends = Object.keys(scope.dataSheet.legend).length === scope.current.project.answers[scope.question.id].legends.length;
        return scope.checkAll.legends;
      };

      scope.preview = function (item) {
        // item.fileID - this is actual fileID not stripped file name
        if (!item || !item.fileID || !item.historyID) return; // do nothing if file does not exists

        FilesRepositoryService.previewUrl(item.historyID, item.name + ".pdf").then(function (response) {
          OfficePreviewDialog.open(item.name, response, "pdf").then();
        });
      };

      scope.displaySheet = function (sheet) {
        for (const key in (sheet.fileReferences || {})) {
          if (scope.legendIsChecked(key, scope.legend)) return true;
        }
      };

      scope.displayLanguage = function (key) {
        if (!scope.current.project.answers[scope.question.id]) return;
        return scope.current.project.answers[scope.question.id].legends.indexOf(key) >= 0;
      };

      function createEmptyAnswer() {
        scope.current.project.answers[scope.question.id] = {
          sheets: [],
          legends: []
        };
      }
    }
  };
}]);

"use strict";

app.service("DataSheetsService", ["$http", "$upload", "$q", "Utils", "Evaluator", function ($http, $upload, $q, Utils, Evaluator) {
  function applyLegend(dataSheets) {
    angular.forEach(dataSheets.sheets, function (sheet) {
      var languages = sheet.languages;
      sheet.languages = {};
      angular.forEach(languages, function (language) {
        sheet.languages[language] = dataSheets.legend[language];
      });
    });
  }

  var instance = {
    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/datasheet/",
        method: "POST",
        file: file,
        data: {
          specConfigID: specID,
          dataSheetID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/datasheet/" + id).then(function (response) {
          applyLegend(response.data);
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/datasheet/spec/" + specID + "/" + name).then(function (response) {
          applyLegend(response.data);
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/datasheet/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadByPages: function (pages, specConfigID) {
      var dataSheets = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Datasheet" && question.fileFunction) {
            instance.fetchByName(specConfigID, question.fileFunction).then(function (response) {
              dataSheets.push({
                dataSheet: response,
                question: question
              });
            });
          }
        });
      });

      return dataSheets;
    },

    loadManyByPages: function (pages, specConfigID, models) {
      var data = {
        specID: specConfigID,
        names: []
      };

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Datasheet" && question.fileFunction) {
            if (models && Evaluator.evaluate(models, question.controlLogic))
              data.names.push(question.fileFunction);
          }
        });
      });

      return $q(function (resolve) {
        $http.post("/api/datasheet/load/names/", data).then(function (response) {
          if (response.data && response.data.length) {
            var results = [];

            response.data.forEach(function (item) {
              results.push({
                question: instance.getQuestionByFileFunction(pages, item.name),
                dataSheet: item
              });
            });

            return resolve(results);
          } else return resolve(response.data);
        });
      });
    },

    namesByPages: function (pages) {
      var names = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Datasheet" && question.fileFunction) {
            names.push(question.fileFunction);
          }
        });
      });

      return names;
    },

    getQuestionByFileFunction: function (pages, dataSheetName) {
      for (var i = 0; i < pages.length; i++) {
        var page = pages[i];

        var question = _.find(page.questions, function (question) {
          return question.fileFunction === dataSheetName;
        });

        if (question) return question;
      }
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/datasheet/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/datasheet/rename", data);
    },

    transformToTreeData: function (dataSheet) {
      var result = {
        selectedNode: "",
        dataSheetsData: [],

        nodeSelected: function (node) {
          this.selectedNode = node.data ? JSON.stringify(
            Utils.stripEmptyProperties(node.data),
            null, 2) : "";
        }
      };

      result.dataSheetsData.push({
        class: "fa fa-file-text-o text-warning",
        text: "legends",
        type: "legends",
        folder: true,
        id: "legends",
        data: dataSheet.legend
      });

      var sheets = {
        class: "fa fa-file-text-o text-warning",
        text: "sheets",
        type: "sheets",
        folder: true,
        id: "sheets",
        children: []
      };

      dataSheet.sheets.forEach(function (sheet) {
        var sheetData = {
          class: "fa fa-database text-info",
          text: sheet.modelNumber,
          type: "sheet",
          folder: true,
          id: sheet.modelNumber,
          data: sheet
        };

        sheets.children.push(sheetData);
      });

      result.dataSheetsData.push(sheets);

      return result;
    }
  };

  return instance;
}]);

"use strict";

app.controller("DataSheetsDialogCtrl", ["$scope", "$modalInstance", "$log", "ProjectService", "options", function ($scope, $modalInstance, $log, ProjectService, options) {
  $scope.current = ProjectService.current;
  $scope.options = options;

  $scope.current.dataSheets = ($scope.current.dataSheets || []).sort(
    function (a, b) { return a.question.id > b.question.id ? 1 : -1; }
  );

  $scope.close = function () {
    $modalInstance.close();
  };
}]);

"use strict";

app.service("DataSheetsDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/data-sheets/data-sheets-dialog/data-sheets-dialog.html",
      controller: "DataSheetsDialogCtrl",
      size: "sm",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };
}]);

"use strict";

app.directive("download", ["SpecConfigService", "DataSheetsService", "Evaluator", "OfficePreviewDialog", "SignatureService", "Message", "$stateParams", "ProjectService", "$window", "DataSheetsDialog", "SharableLinkDialog", "ListOfsharedDialog", function (SpecConfigService,
  DataSheetsService,
  Evaluator,
  OfficePreviewDialog,
  SignatureService,
  Message,
  $stateParams,
  ProjectService,
  $window,
  DataSheetsDialog,
  SharableLinkDialog,
  ListOfsharedDialog
) {
  return {
    restrict: "E",
    templateUrl: "components/download/download.html",

    scope: {},

    link: function (scope) {
      scope.current = ProjectService.current;
      scope.current.downloads = [];
      scope.drawings = [];

      scope.drawingTypes = [
        { type: "vdx", name: "Visio" },
        { type: "rvt", name: "Revit" },
        { type: "pdf", name: "PDF" },
        { type: "svg", name: "svg" }
      ];

      scope.dataSheetsCount = 0;
      scope.checkedDataSheetsCount = 0;

      scope.$watch("current.project.answers", function (val) {
        if (!val || scope.current.menuItem) return;

        buildGlobals();
        buildMenus();
        defineDrawings();
        defineDataSheets();
      }, true);

      scope.download = function () {
        save(function (id) { // id is project id after saving
          // SharableLinkDialog.open()
          var url = SpecConfigService.buildProcessUrl(id, scope.current.spec._id);
          $window.open(url);
        });
      };

      scope.emptyDownloads = function () {
        return scope.current.downloads.length === 0 && scope.current.progress.checkedDataSheetsCount === 0;
      };

      scope.getSharableLink = function () {
        SharableLinkDialog.open().then(function () {

        });
      };

      scope.getListOfShares = function () {
        ListOfsharedDialog.open().then(function () {

        });
      };

      scope.downloadItem = function (file) {
        save(function (id) {
          if (!file.hasFile && file.url) {
            $window.open(file.url);
          } else {
            SpecConfigService.officePreviewUrl(scope.current.spec._id, file.historyID, id, file.menuID).then(function (response) {
              $window.open(response);
            });
          }
        });
      };

      scope.downloadOriginal = function (file) {
        var url = !file.hasFile && file.url || SpecConfigService.buildDownloadUrl(file.historyID, file.name);
        $window.open(url);
      };

      scope.previewOriginal = function (file) {
        if (!file.hasFile && file.url) {
          OfficePreviewDialog.open(file.name, file.url, file.extension);
        } else {
          file.fileName = file.name;
          file._id = file.historyID;

          SignatureService.directUrl(file).then(function (response) {
            OfficePreviewDialog.open(file.name, response, file.extension);
          });
        }
      };

      scope.checkIfProcessable = function (file) {
        scope.current.nextLoading = true;
        save(function (id) {
          SpecConfigService.checkIfProcessable(scope.current.spec._id, file.historyID, id).then(showProcessableMessage, showProcessableMessage);
        });
      };

      function showProcessableMessage(response) {
        scope.current.nextLoading = false;
        var paramsLog = response.data && response.data.stream ? response.data.stream : response.data && response.data.log ? response.data : {};
        var log = paramsLog.log || {};
        var title = "";
        var message = response.data || response.statusText;
        var type = null;

        if (log.errors && log.errors.length > 0) {
          title = "File is not valid";
          message = "Please check logs for more details";
          type = "danger";
        } else {
          title = "File is valid";
          message = "Processing is able";
          if (log && !Object.keys(log).length) log = null;
        }

        var data = {
          params: paramsLog.params,
          log: log
        };

        Message.open(message, title, "lg", type, data).then();
      }

      scope.previewFile = function (file) {
        if (!file) return;

        save(function (id) {
          if (!file.hasFile && file.url) {
            OfficePreviewDialog.open((file.displayName || file.name), file.url, file.extension).then();
          } else {
            SpecConfigService.officePreviewUrl(scope.current.spec._id, file.historyID, id, file.menuID).then(function (response) {
              OfficePreviewDialog.open((file.displayName || file.name), response + "&timestamp=" + Date.now(), file.extension).then();
            });
          }
        });
      };

      scope.previewDrawing = function (item) {
        if (!item.specConfigID) return;

        if (item.url) {
          OfficePreviewDialog.open(item.name, item.url, item.extension).then();
        } else {
          SpecConfigService.officePreviewUrl(item.specConfigID, item.historyID).then(function (response) {
            OfficePreviewDialog.open(item.name, response, item.extension).then();
          });
        }
      };

      scope.isChecked = function (file) {
        return _.find(scope.current.downloads, function (item) {
          return file.path === item.path || !file.hasFile && file.url;
        });
      };

      scope.checkClick = function (item) {
        scope.current.addToDownloads(item);
      };

      scope.showDataSheets = function () {
        DataSheetsDialog.open().then(defineDataSheets, defineDataSheets);
      };

      function save(callback) {
        var data = {
          specConfigID: scope.current.spec._id,
          name: scope.current.project.name,
          id: scope.current.project._id,
          answers: scope.current.project.answers,
          download: scope.current.downloads,
          location: scope.current.project.location,
          progress: scope.current.project.progress,
          groupsProgress: scope.current.project.groupsProgress
        };

        ProjectService.save(data).then(function (response) {
          scope.current.project.version = response.version;
          callback(response.data._id);
        });
      }

      function buildGlobals() {
        scope.globals = {
          list: [],
          types: []
        };

        // remove previous downloads
        _.remove((scope.current.downloads || []), function (tmpItem) {
          return tmpItem.path && tmpItem.path.indexOf("Specifications/") === 0;
        });

        scope.current.project.answers.filteredFiles.forEach(function (item) {
          if (item.type === "Drawing") return;

          var displayName = item.displayName || item.name;

          var created = {
            name: item.name,
            displayName: displayName,
            historyID: item.historyID,
            hasFile: item.hasFile,
            url: item.url,
            type: item.type,
            path: "Specifications/" + item.type + "/" + displayName,
            extension: item.extension,
            key: item.type + "-" + item.name + "-" + item.controlLogic
          };

          var existing = _.find(scope.globals.list, function (tmpItem) {
            return created.key === tmpItem.key;
          });

          if (!existing) {
            scope.globals.list.push(created);

            if (created.historyID)
              scope.current.addToDownloads(created);
          }

          if (scope.globals.types.indexOf(item.type) === -1) scope.globals.types.push(item.type);
        });
      }

      function buildMenus() {
        scope.menuName = "";
        var menus = {};

        if (scope.current.questionSet && scope.current.questionSet.menus) {
          scope.current.questionSet.menus.forEach(function (tmp) {
            menus[tmp.id] = true;
            scope.menuName = tmp.name;
          });
        }

        scope.menus = {
          list: []
        };

        // remove previous downloads
        _.remove((scope.current.downloads || []), function (tmpItem) {
          return tmpItem.path && tmpItem.path.indexOf(scope.menuName + "/") === 0;
        });

        for (var menuKey in menus) {
          var menuAnswers = scope.current.project.answers[menuKey] || [];
          if (menuAnswers.length) {

            menuAnswers.forEach(function (menuItem) {
              menuItem.filteredFiles.forEach(function (item) {
                if (item.type === "Drawing") return;

                var eqName = (menuItem.name + " ").replace(/[\?:*/|<>/\\/"\+]/g, "").trim();

                var displayName = item.displayName || item.name;

                var created = {
                  name: item.name,
                  menuID: menuItem.id,
                  displayName: eqName + " - " + displayName,
                  historyID: item.historyID,
                  type: item.type,
                  path: scope.menuName + "/" + eqName + "/" + item.type + "/" + displayName,
                  extension: item.extension,
                  key: item.type + "-" + item.name + "-" + item.controlLogic
                };

                var existing = _.find(scope.menus.list, function (tmpItem) {
                  return created.path === tmpItem.path;
                });

                if (!existing) {
                  scope.menus.list.push(created);
                  if (created.historyID)
                    scope.current.addToDownloads(created, true);
                }
              });
            });
          }
        }
      }

      function defineDataSheets() {
        // remove existing data sheets from downloads
        _.remove((scope.current.downloads || []), function (tmpItem) {
          return tmpItem.path && tmpItem.path.indexOf("DataSheets/") === 0;
        });

        scope.current.dataSheets.forEach(function (dataSheet) {
          if (scope.current.displayQuestion(dataSheet)) {
            var answers = scope.current.project.answers[dataSheet.question.id];

            if (!answers) return;

            answers.sheets.forEach(function (sheetID) {
              var sheet = _.find(dataSheet.value.sheets, function (item) {
                return item.id === sheetID;
              });

              if (!sheet) return;
              var currentLegends = scope.current.project.answers[dataSheet.question.id].legends || [];

              _.forEach(currentLegends, function (legend) {
                var file = sheet.fileReferences[legend];

                if (file) {
                  file.isExternalFile = !!file.url;
                  file.isStaticFile = !file.isExternalFile;
                  file.path = "DataSheets/" + file.name;

                  if (dataSheet.value.urlMap && dataSheet.value.urlMap[file.url]) {
                    file.url = dataSheet.value.urlMap[file.url];
                  }

                  if (scope.current.project.answers[dataSheet.question.id].sheets.indexOf(sheet.id) === -1) {
                    scope.current.project.answers[dataSheet.question.id].sheets.push(sheet.id);
                    scope.current.project.answers[dataSheet.question.id].handChecked[sheet.id] = true;
                    scope.current.addToDownloads(file, true);
                  } else {
                    scope.current.addToDownloads(file, true);
                  }
                }
              });
            });
          }
        });

        // recalculate count
        scope.current.recalculateDownloadDataSheetsCount();
      }

      // Drawings Table
      function defineDrawings() {
        if (!scope.current.project || !scope.current.questionSet) return;

        var list = angular.copy(scope.current.project.answers.filteredFiles || []);
        var menus = scope.current.questionSet.menus;
        scope.drawings.length = 0;

        // remove previous downloads
        _.remove((scope.current.downloads || []), function (tmpItem) {
          return tmpItem.path && tmpItem.path.indexOf("Drawings/") === 0;
        });

        menus.forEach(function (menu) {
          var menuItems = scope.current.project.answers[menu.id];

          if (menuItems) {
            menuItems.forEach(function (menuItem, index) {
              menuItem.filteredFiles.forEach(function (eqTmpFile) {
                var eqFile = angular.copy(eqTmpFile);

                if (eqFile.type === "Drawing") {
                  eqFile.eqName = (menuItem.name + " ").replace(/[\?:*/|<>/\\/"\+]/g, "").trim();

                  var existing = _.find(list, function (tmpItem) {
                    return tmpItem.type === "Drawing" && tmpItem.eqName === eqFile.eqName;
                  });

                  if (existing) eqFile.eqName += "-" + index;

                  eqFile.name = eqFile.eqName;

                  for (var key in eqFile.files) {
                    var current = eqFile.files[key];

                    current.name = eqFile.eqName + "." + key;

                    var existingType = _.find(scope.drawingTypes, function (itm) {
                      return itm.type === key;
                    });

                    if (!existingType) scope.drawingTypes.push({
                      type: key,
                      name: key
                    });
                  }
                }
                list.push(eqFile);
              });
            });
          }
        });

        list.forEach(function (item) {
          if (item.type === "Drawing") {
            var existing = _.find(scope.drawings, function (drawing) {
              return item.name === drawing.name;
            });

            if (!existing && item.files && Object.keys(item.files).length !== -1) scope.drawings.push(angular.copy(item));
          }
        });
      }

      scope.showHeaderCheck = function (header) {
        for (var i = 0; i < scope.drawings.length; i++) {
          var current = scope.drawings[i];
          if (current.files && current.files[header.type]) return true;
        }
      };

      scope.headerIsChecked = function (header) {
        var valids = _.filter(scope.drawings, function (drawing) {
          return drawing.files[header.type];
        });

        var checkeds = _.filter(scope.current.downloads, function (item) {
          return item.path.indexOf("Drawings/") === 0 && item.extension === header.type;
        });

        header.isChecked = checkeds && checkeds.length === valids.length;
        return header.isChecked;
      };

      scope.drawingsHeaderClick = function (header) {
        if (header.isChecked) {
          scope.drawings.forEach(function (drawing) {
            var index = 0;

            var existing = _.find(scope.current.downloads, function (item, ind) {
              index = ind;
              return drawing.files[header.type] && item.path.indexOf("Drawings/") === 0 && drawing.files[header.type].name === item.name;
            });

            if (existing) scope.current.downloads.splice(index, 1);
          });
        } else {
          scope.drawings.forEach(function (drawing) {
            var existing = _.find(scope.current.downloads, function (item) {
              return drawing.files[header.type] && item.path.indexOf("Drawings/") === 0 && drawing.files[header.type].name === item.name;
            });

            if (existing) return;
            addDrawingToDownloads(drawing.files[header.type]);
          });
        }
        header.isChecked = !header.isChecked;
      };

      scope.drawingsCheckClick = function (file) {
        if (!file.path) file.path = "Drawings/" + file.name;

        var index = 0;

        var existing = _.find(scope.current.downloads, function (item, ind) {
          index = ind;
          return item.path === file.path;
        });

        if (existing) scope.current.downloads.splice(index, 1);
        else addDrawingToDownloads(file);
      };

      scope.drawingExistsInDownloads = function (file) {
        if (!file) return;

        return _.find(scope.current.downloads, function (item) {
          return item.path.indexOf("Drawings/") === 0 && file.name === item.name;
        });
      };

      function addDrawingToDownloads(file) {
        if (!file) return;

        if (!file.path) file.path = "Drawings/" + file.name;

        scope.current.downloads.push({
          id: file.historyID,
          extension: file.extension,
          name: file.name,
          path: file.path,
          needProcess: false
        });
      }
    }
  };
}]);

"use strict";

app.service("SharableLinkDialog", ["$modal", "$q", "$http", function ($modal, $q, $http) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/download/sharableLinkDialog/sharable-link-dialog.html",
      controller: "SharableLinkController",
      size: "lg",
      resolve: {
        options: function () {
          return options;
        }
      }
    }).result;
  };

  this.getShares = function (projectId, specId) {
    return $q(function (resolve) {
      return $http.get("/api/specs/get-shares/" + projectId + "/" + specId).then(function (response) {
        resolve(response.data);
      });
    });
  };

  this.removeShare = function (id) {
    return $q(function (resolve) {
      return $http.delete("/api/specs/remove-share/" + id).then(function (response) {
        resolve(response.data);
      });
    });
  };
}]);

"use strict";

app.controller("SharableLinkController", ["$scope", "$modalInstance", "ProjectService", "options", "SpecConfigService", "$stateParams", "SharableLinkDialog", "Confirm", function ($scope, $modalInstance, ProjectService, options, SpecConfigService, $stateParams, SharableLinkDialog, Confirm) {

  $scope.close = function () {
    $modalInstance.close();
  };

  $scope.shares = [];
  $scope.activeTab = "addSharing"; // viewSharing
  $scope.postData = {
    emails: "",
    expTime: "",
    projectId: $stateParams.projectID,
    specId: $stateParams.id
  };

  $scope.initShares = function () {
    SharableLinkDialog.getShares($stateParams.projectID, $stateParams.id).then(function (shares) {
      $scope.shares = shares.map(function (share) {
        var createdDate = new Date(share.created_at);
        share.dateShared = createdDate.getFullYear() + "/" + String(createdDate.getMonth() + 1).padStart(2, "0") + "/" + String(createdDate.getDate()).padStart(2, "0");

        if (share.expTime == 0) {
          share.expDate = "permanent";
          return share;
        } else {
          var date = new Date(share.created_at);

          var unixTimestamp = Number(date.getTime()) + Number(share.expTime) * 1000;
          var newDate = new Date(unixTimestamp);

          share.expDate = newDate.getFullYear() + "/" + String(newDate.getMonth() + 1).padStart(2, "0") + "/" + String(newDate.getDate()).padStart(2, "0");
          return share;
        }

      });
    });
  };
  $scope.initShares();

  $scope.isSharable = function () {
    return $scope.postData.emails.length > 0 && $scope.postData.expTime !== "";
  };

  $scope.sendShares = function () {
    SpecConfigService.sendSignedProcessUrl($scope.postData).then(function (data) {
      alert("specs shared successfully");
      $modalInstance.close();
    });
  };

  $scope.removeShare = function (id) {
    Confirm.open("Are you sure you want to delete share", "Delete share ", "md").then(function (yes) {
      if (yes) {
        SharableLinkDialog.removeShare(id).then(function (data) {
          $scope.initShares();
        });
      }
    });

  };

}]);

"use strict";

app.controller("ListOfSharedController", ["$scope", "$modalInstance", "ProjectService", "options", "SpecConfigService", function ($scope, $modalInstance, ProjectService, options, SpecConfigService) {
  $scope.projects = [];

  $scope.close = function () {
    $modalInstance.close();
  };

  $scope.invalidate = function (project) {
    SpecConfigService.removeSharedProject(project).then(function (result) {
      if (result) {
        _.remove($scope.projects, function (proj) {
          return proj.access_token === project.access_token;
        });

      }

    });

  };

  $scope.fetchShared = function () {
    SpecConfigService.getSharedProjects(ProjectService.current.spec._id,
      ProjectService.current.project._id)
      .then(function (projects) {
        $scope.projects = projects;
      });
  };

}]);

"use strict";

app.service("ListOfsharedDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/download/listOfSharesDialog/list-of-shared.html",
      controller: "ListOfSharedController",
      size: "s",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };
}]);

"use strict";

app.directive("drawingExtension", ["Evaluator", "ProjectService", function (Evaluator, ProjectService) {
  return {
    restrict: "E",
    templateUrl: "components/drawing-extension/drawing-extension.html",

    scope: {
      question: "=question",
      model: "=data"
    },

    link: function (scope) {
      scope.drawings = [];
      scope.current = ProjectService.current;

      scope.showHeaderCheck = function (header) {
        for (var i = 0; i < scope.drawings.length; i++) {
          var current = scope.drawings[i];
          if (current.files[header.fileFunction]) return true;
        }
      };

      scope.headerCheck = function (header) {
        var validCount = 0;
        var checkedCount = 0;

        scope.drawings.forEach(function (drawing) {
          if (drawing.files[header.fileFunction])
            validCount++;
          if (scope.current.project.answers.drawings[drawing.name] && scope.current.project.answers.drawings[drawing.name].indexOf(header.fileFunction) >= 0)
            checkedCount++;
        });

        if (validCount)
          header.isSelected = validCount === checkedCount;

        return header.isSelected;
      };

      scope.bindAll = function (header) {
        header.isSelected = !header.isSelected;

        scope.drawings.forEach(function (drawing) {
          if (!scope.current.project.answers.drawings[drawing.name]) scope.current.project.answers.drawings[drawing.name] = [];
          var index = scope.current.project.answers.drawings[drawing.name].indexOf(header.fileFunction);
          var exists = drawing.files[header.fileFunction];

          if (header.isSelected) {
            if (index !== -1) return;

            if (exists) scope.current.project.answers.drawings[drawing.name].push(header.fileFunction);
          } else {
            if (exists) scope.current.project.answers.drawings[drawing.name].splice(index, 1);
          }

          if (!scope.current.project.answers.drawings[drawing.name].length) delete scope.current.project.answers.drawings[drawing.name];
        });
      };

      scope.bindModel = function (drawing, answer) {
        if (!drawing.files[answer.fileFunction]) return;
        if (!scope.current.project.answers.drawings[drawing.name]) scope.current.project.answers.drawings[drawing.name] = [];

        var index = scope.current.project.answers.drawings[drawing.name].indexOf(answer.fileFunction);

        if (index >= 0) {
          scope.current.project.answers.drawings[drawing.name].splice(index, 1);
          if (!scope.current.project.answers.drawings[drawing.name].length) delete scope.current.project.answers.drawings[drawing.name];
        }
        else
          scope.current.project.answers.drawings[drawing.name].push(answer.fileFunction);
      };

      function refreshList() {
        if (scope.current.project) {
          scope.drawings = _.filter(scope.current.project.answers.filteredFiles, function (file) {
            return file.specConfigID && file.type === "Drawing";
          });

          if (!scope.drawings.length) delete scope.current.project.answers.drawings;
          else if (!scope.current.project.answers.drawings) scope.current.project.answers.drawings = {};
        }
      }
      refreshList();

      scope.$watch("current.project.answers.filteredFiles", function () {
        refreshList();
      }, true);
    }
  };
}]);

"use strict";

app.service("DrawingService", ["$http", "$upload", "$q", function ($http, $upload, $q) {
  var instance = {

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/drawing/",
        method: "POST",
        file: file,

        data: {
          specConfigID: specID,
          itemID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/drawing/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/drawing/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/drawing/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/drawing/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/drawing", data);
    }
  };

  return instance;
}]);

"use strict";

app.service("Evaluator", function () {
  var FUNCTION_CACHE = {};

  var EVALUATOR_INSTANCE = {
    model: [],

    existsMTg: function (menuId, tag) {
      var specificModel = this.model;

      var menu;

      for (var i = specificModel.length - 1; i >= 0; i--) {
        menu = specificModel[i][menuId];
        if (menu) break;
      }
      if (!menu) return false;

      return this._existsTag(menu, tag);
    },

    existsTg: function (tagName) {
      return this._existsTag(this.model, tagName);
    },

    _existsTag: function (specificModel, tagName) {
      var tags;

      for (var i = specificModel.length - 1; i >= 0; i--) {
        tags = specificModel[i]["filteredTags"];
        if (tags) {
          var tag = _.find(tags, function (tag) {
            return tag.name == tagName;
          });
          if (tag) {
            return true;
          }
        }
      }
      return false;
    },

    exists: function (value) {
      return this._exists(this.model, value);
    },

    _exists: function (specificModel, value) {
      var ids = value.split("-");

      var qID = ids[0];
      var aID = parseInt(ids[1]);

      var answer;

      for (var i = specificModel.length - 1; i >= 0; i--) {
        answer = specificModel[i][qID];
        if (answer) break;
      }

      if (!answer) return false;

      return Array.isArray(answer) ?
        answer.indexOf(aID.toString()) >= 0 : parseInt(answer) === aID;
    },

    all: function () {
      for (var i = 0; i < arguments.length; i++) {
        if (!this.exists(arguments[i])) return false;
      } return true;
    },

    any: function () {
      for (var i = 0; i < arguments.length; i++) {
        if (this.exists(arguments[i])) return true;
      } return false;
    }
  };

  // convert condition to javascript expression
  function normalizeCondition(condition) {
    var resultCondition = condition
      .replace(/OR/gi, "||")
      .replace(/AND/gi, "&&")
      .replace(/NOT/gi, "!")
      .replace(/QTAG/gi, "evaluator.existsTg")
      .replace(/MTAG/gi, "evaluator.existsMTg")
      .replace(/ALL/gi, "evaluator.all")
      .replace(/ANY/gi, "evaluator.any");

    // remove duplicated conditions
    var tmpArr = (resultCondition.match(/\d+\-\d+/g) || []);
    var toProcess = [];

    tmpArr.forEach(function (cond) {
      if (toProcess.indexOf(cond) === -1) toProcess.push(cond);
    });

    toProcess.forEach(function (m) {
      var regex = new RegExp("\\b" + m + "\\b", "g");
      resultCondition = resultCondition.replace(regex, "evaluator.exists(\"" + m + "\") ");
    });

    return resultCondition;
  }

  // get instance of object which will evaluate
  // javascript expression over model(s)
  function getEvaluatorInstance(model) {
    EVALUATOR_INSTANCE.model = Array.isArray(model) ? model : [model];
    return EVALUATOR_INSTANCE;
  }

  function getEvaluatorFunction(condition) {
    if (!FUNCTION_CACHE[condition]) {
      var parsedCondition = "return " + normalizeCondition(condition);
      FUNCTION_CACHE[condition] = new Function("evaluator", parsedCondition);
    }

    return FUNCTION_CACHE[condition];
  }

  return {
    evaluate: function (model, condition) {
      if (!condition) return true;

      try {
        var evaluatorInstance = getEvaluatorInstance(model);
        var evaluatorFunction = getEvaluatorFunction(condition);
        return evaluatorFunction(evaluatorInstance);
      } catch (err) {
        console.log("EXPRESSION EVALUATION ERROR:", condition, err);
        return false;
      }
    }
  };
});

"use strict";

app.service("ExchangeModal", ["$modal", function ($modal) {
  this.open = function (url, data, config) {
    if (!config.buttons || !config.buttons.length) config.buttons = [{
      class: "btn-primary",
      icon: "fa-save",
      text: "Save",
      action: "save",
    }, {
      class: "btn-danger",
      icon: "fa-times",
      text: "Cancel",
      action: "cancel",
    }];

    return $modal.open({
      templateUrl: "components/exchange-modal/exchange-modal.html",
      controller: "ExchangeModalCtrl",
      size: config.size || "md",
      resolve: {
        url: function () { return url; },
        data: function () { return data; },
        config: function () { return config; }
      }
    }).result.finally(function () {
      delete window.CURRENT_MODAL_INSTANCE;
      delete window.CURRENT_MODAL;
      delete window.CURRENT_MODAL_ORIGIN;
    });
  };
}]);

/* global app, window, document */
"use strict";

app.controller("ExchangeModalCtrl", ["$scope", "$sce", "$modalInstance", "Env", "url", "data", "config", function ($scope, $sce, $modalInstance, Env, url, data, config) {
  function getOrigin(targetUrl, fallbackOrigin) {
    if (!targetUrl) return fallbackOrigin;

    var anchor = document.createElement("a");
    anchor.href = targetUrl;

    if (!anchor.protocol || !anchor.host) return fallbackOrigin;
    return anchor.protocol + "//" + anchor.host;
  }

  window.CURRENT_MODAL_INSTANCE = $modalInstance;

  $scope.data = data;
  $scope.config = config || {};
  $scope.url = $sce.trustAsResourceUrl(Env.adminAppUrl + url);
  $scope.hide = $scope.url.toString().includes("referred");
  $scope.modalOrigin = window.CURRENT_MODAL_ORIGIN || getOrigin(Env.adminAppUrl, window.location.protocol + "//" + window.location.host);

  if ($scope.hide) {
    $scope.config = {
      buttons: [{
        action: "cancel",
        class: "btn-primary",
        icon: "fa-times",
        text: "close"
      }],
      icon: "fa fa-file",
      size: "lg",
      title: $scope.config.title
    };
  }

  $scope.action = function (action) {
    if (window.CURRENT_MODAL && $scope.modalOrigin) {
      window.CURRENT_MODAL.postMessage(action, $scope.modalOrigin);
    } else {
      $modalInstance.close(action);
    }
  };
}]);

"use strict";

app.directive("fancytree", function () {
  return {
    template: "<div></div>",
    restrict: "EA",

    link: function (scope, element, attrs) {
      var options = {};

      _.extend(options, scope.$eval(attrs.options));
      _.extend(options, { source: scope.$eval(attrs.data) });

      element.fancytree(options);
      var tree = element.fancytree("getTree");

      scope.$watch(
        function (scope) {
          return scope.$eval(attrs.data);
        },
        function (value) {
          tree.reload(value);
        },
        true
      );
    }
  };
});

"use strict";

app.controller("EditFilesCtrl", ["$scope", "$modalInstance", "$log", "FilesRepositoryService", "file", function ($scope, $modalInstance, $log, FilesRepositoryService, file) {
  $scope.files = [];
  $scope.file = angular.copy(file);
  $scope.availableTags = [];

  FilesRepositoryService.tags().then(function (data) {
    $scope.availableTags = data;
  });

  $scope.save = function () {
    if (!isValid()) return;

    $modalInstance.close({
      file: $scope.files,
      data: $scope.file,
      isRename: isInfoEdit()
    });
  };

  $scope.fileSelectChanged = function () {
    $scope.file.name = $scope.files[0] ? $scope.files[0].name : "";
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.removeFile = function (index) {
    $scope.files.splice(index, 1);
  };

  $scope.noChanges = function () {
    if (!$scope.file.name || !$scope.file.fileID || !$scope.file.language) return true;

    return !$scope.files.length && $scope.file.name === file.name
            && $scope.file.fileID === file.fileID && $scope.file.description === file.description
            && $scope.file.language === file.language && !tagsChanged();
  };

  function tagsChanged() {
    if ($scope.file.tags.length !== file.tags.length) return true;

    for (var i = 0; i < $scope.file.tags.length; i++) {
      var tag = $scope.file.tags[i];
      var index = file.tags.indexOf(tag);
      if (index < 0) return true;
    }
  }

  function isValid() {
    $scope.errors = [];
    if (!isInfoEdit && !$scope.files.length) $scope.errors.push("File is required");
    if (!$scope.file.name) $scope.errors.push("File name is required");
    return $scope.errors.length === 0;
  }

  function isInfoEdit() {
    return !$scope.files.length && ($scope.file.name !== file.name || $scope.file.fileID !== file.fileID || $scope.file.description !== file.description || $scope.file.language !== file.language || tagsChanged());
  }
}]);

"use strict";

app.service("EditFileDialog", ["$modal", function ($modal) {
  this.open = function (file) {
    return $modal.open({
      templateUrl: "components/files-repository/edit/edit.html",
      controller: "EditFilesCtrl",
      size: "md",
      resolve: {
        file: function () { return file; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("FilesRepositoryCtrl", ["$scope", "$stateParams", "$compile", "$filter", "Confirm", "Auth", "FilesRepositoryService", "SignatureService", "UploadFileDialog", "EditFileDialog", "FileHistoryDialog", "OfficePreviewDialog", "DTOptionsBuilder", "DTColumnBuilder", function (
  $scope,
  $stateParams,
  $compile,
  $filter,
  Confirm,
  Auth,
  FilesRepositoryService,
  SignatureService,
  UploadFileDialog,
  EditFileDialog,
  FileHistoryDialog,
  OfficePreviewDialog,
  DTOptionsBuilder,
  DTColumnBuilder
) {
  $scope.queue = FilesRepositoryService.uploadQueue;
  $scope.specConfigID = $stateParams.id;
  $scope.tableID = "files-data-table";
  $scope.dt = { instance: null };

  $scope.dtOptions = DTOptionsBuilder
    .fromFnPromise(function () {
      // return promise that resolves into array of rows for data table
      return FilesRepositoryService.list($scope.specConfigID);
    })
    // Add Bootstrap compatibility
    .withBootstrap()
    .withPaginationType("full_numbers")
    .withOption("createdRow", createdRow)
    .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-1\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

  if ($scope.specConfigID) {
    $scope.dtOptions.withDOM("tp");
  }

  function reloadData() {
    if ($scope.dt.instance) $scope.dt.instance.reloadData();
  }

  function createdRow(row, data, dataIndex) {
    // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
    var rowScope = $scope.$new(false);
    // set file with row data same way as it happns with ng-repeat
    rowScope.file = data;
    // mimic ng-repeat $index
    rowScope.$index = dataIndex;

    // Recompiling so we can bind Angular directive to the DT
    $compile(angular.element(row).contents())(rowScope);
  }

  $scope.dtColumns = [
    DTColumnBuilder.newColumn(null).withTitle("Actions").notSortable().renderWith(actionsHtml),
    DTColumnBuilder.newColumn("name").withTitle("File Name"),
    DTColumnBuilder.newColumn("extension").withTitle("Extension"),
    // DTColumnBuilder.newColumn("description").withTitle("Description"),
    DTColumnBuilder.newColumn(null).withTitle("Tags").renderWith(function (file, type) {
      var tagsStr = "";
      if (type === "display") {
        angular.forEach(file.tags || [], function (tag) {
          tagsStr += "<span class=\"badge\">" + tag + "</span>";
        });
        return tagsStr;
      }
      else
        return file.tags;
    }),
    DTColumnBuilder.newColumn(null).withTitle("Uploaded At").renderWith(function (file, type) {
      var uploaded = file.history && file.history[file.history.length - 1] && file.history[file.history.length - 1].uploaded;
      if (!uploaded) return "";

      if (type === "display") // formatted date for display
        return $filter("date")(uploaded, "medium");
      else
        return uploaded; // raw for the rest so sorting will work properly
    }),
    DTColumnBuilder.newColumn("uploadedBy.username").withTitle("Uploded By")
  ];

  function actionsHtml(data, type, full, meta) {
    // TODO get it from extenal compiled html file
    return "<div class=\"btn-group dropdown\"><a class=\"btn btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a><ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\"><li><a class=\"btn-lg\", ng-click=\"preview(file)\" title=\"Preview latest version\"><i class=\"fa fa-eye\"></i> Preview</a></li><li><a class=\"btn-lg\", ng-href=\"api/file/download/{{ file.history[file.history.length - 1]._id }}/{{ file.name }}.{{file.extension }}\" target=\"_blank\" title=\"Download latest version\"><i class=\"fa fa-download\"></i> Download</a></li><li><a class=\"btn-lg\", ng-click=\"history(file)\" title=\"Show file history\"><i class=\"fa fa-history\"></i> History</a></li><li><a class=\"btn-lg\", ng-click=\"edit(file, $index)\" title=\"Edit file\" ng-hide=\"selectedSpecConfig.isPublished\"><i class=\"fa fa-pencil\"></i> Edit</a></li><li><a class=\"btn-lg\", ng-click=\"delete(file)\" title=\"Delete file\" ng-hide=\"selectedSpecConfig.isPublished\"><i class=\"fa fa-trash-o\"></i> Delete</a></li></ul></div>";
  }

  $scope.delete = function (file) {
    Confirm.open("Are you sure you want to delete file?", "Delete File", "md").then(
      function (result) {
        if (result) FilesRepositoryService.delete(file._id).then(function () {
          reloadData();
        });
      }
    );
  };

  $scope.upload = function () {
    $scope.hideErrors();

    UploadFileDialog.open().then(function (result) {
      FilesRepositoryService.upload(
        null,
        result.files,
        result.tags,
        result.name || "",
        result.description || "",
        $scope.specConfigID
      );
    });
  };

  $scope.cancelUpload = function (item) {
    FilesRepositoryService.cancelUpload(item);
  };

  $scope.edit = function (file, index) {
    var self = this;
    EditFileDialog.open(file).then(function (result) {
      if (result.isRename)
        FilesRepositoryService.editInfo(result.data).then(reloadData);
      else
        FilesRepositoryService.upload(file._id, result.file, result.data.tags, result.data.name, result.data.description)
          .then(function (data) {
            reloadData();
          }, uploadError);
    });
  };

  $scope.history = function (file) {
    FileHistoryDialog.open(file);
  };

  $scope.preview = function (file) {
    var historyItem = file.history[file.history.length - 1];
    SignatureService.directUrl(historyItem).then(function (response) {
      OfficePreviewDialog.open(historyItem.fileName, response, historyItem.extension).then();
    });
  };

  $scope.filterUploading = function (item) {
    return item.data.specConfigID === $scope.specConfigID ||
      !item.data.specConfigID && !$scope.specConfigID;
  };

  $scope.hideErrors = function () {
    $scope.errors = {};
  };

  $scope.$on("file:upload:dialog", function () {
    $scope.upload();
  });

  $scope.$on("upload:all", function (e, a) {
    reloadData();
  });

}]);

"use strict";

app.service("FilesRepositoryService", ["$rootScope", "$http", "$location", "$log", "$q", "$upload", "Auth", function ($rootScope, $http, $location, $log, $q, $upload, Auth) {
  var instance = {
    uploadQueue: [],
    batchSize: 1,
    uploading: 0,

    upload: function (id, files, tags, name, description, specID) {
      var self = this;
      if (!Array.isArray(files)) files = [files];

      files.forEach(function (file) {
        self.uploadQueue.push({
          file: file,

          data: {
            id: id,
            tags: tags,
            name: name,
            description: description,
            specConfigID: specID
          }
        });
      });

      this.doUpload();
    },

    doUpload: function () {
      var self = this;

      // return if current upload is in progress or no items in queue
      if (self.uploading > 0 || self.uploadQueue.length == 0) return;

      // end upload handler
      function endUpload(item) {
        // find and remove uploaded item from queue
        // var index = self.uploadQueue.indexOf(item);
        self.uploadQueue.shift();

        // decrease current uploading counter
        self.uploading--;

        // broadcast upload:all event if queue is empty
        if (!self.uploadQueue.length) $rootScope.$broadcast("upload:all");

        // do upload again if noting is uploading and there are still items in queue...
        else if (!self.uploading) self.doUpload();
      }

      // for each items from batch size...
      var item = self.uploadQueue[0];
      if (!item) return;

      // increase uploading counter
      self.uploading++;

      // call upload endpoint
      item.uploader = $upload.upload({
        url: "/api/files/",
        method: "POST",
        file: item.file,
        data: item.data
      }).progress(function (evt) {
        item.progress = parseInt(100.0 * evt.loaded / evt.total);
        $rootScope.$broadcast("upload:progress", item);
      }).then(function (data) {
        endUpload(item);
        $rootScope.$broadcast("upload:success", data);
      }, function (err) {
        endUpload(item);
        $rootScope.$broadcast("upload:error", err);
      });
    },

    cancelUpload: function (item) {
      var index = this.uploadQueue.indexOf(item);
      if (index < 0) return;

      if (item.uploader) item.uploader.abort();
      this.uploadQueue.splice(index, 1);
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/files/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    list: function (specID) {
      var req = {
        specConfigID: specID
      };

      return $q(function (resolve) {
        $http.post("/api/files/load", req).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    editInfo: function (data) {
      return $http.put("/api/files", data);
    },

    delete: function (id) {
      return $http.delete("/api/files/" + id);
    },

    previewUrl: function (hID, filename) {
      var data = {
        url: $location.protocol() + "://" + $location.host()
      };

      if ($location.host() === "localhost") data.url += ":" + $location.port();

      if (filename.indexOf(".pdf") != -1) {
        // PDFJS is outside Angular, but same-origin session cookies are sent automatically.
        data.url += "/api/file/download/" + hID + "/" + filename;
        return $q(function (resolve) {
          return resolve(data.url);
        });
      } else {
        data.url += "/api/file/preview/" + hID + "/" + filename;
        return $q(function (resolve) {
          $http.put("/api/sign", data).then(function (response) {
            return resolve(response.data);
          });
        });
      }

    },

    tags: function () {
      return $q(function (resolve) {
        $http.get("/api/files/tags").then(function (response) {
          return resolve(response.data);
        });
      });
    }
  };

  return instance;
}]);

"use strict";

app.controller("FileHistoryCtrl", ["$scope", "$modalInstance", "$log", "FilesRepositoryService", "OfficePreviewDialog", "SignatureService", "file", function ($scope, $modalInstance, $log, FilesRepositoryService, OfficePreviewDialog, SignatureService, file) {
  $scope.file = file;
  $scope.history = file.history;

  $scope.preview = function (item) {
    var fileName = $scope.file.name + "." + file.extension;

    SignatureService.directUrl(item).then(function (response) {
      OfficePreviewDialog.open(item.fileName, response, item.extension).then();
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.service("FileHistoryDialog", ["$modal", function ($modal) {
  this.open = function (file) {
    return $modal.open({
      templateUrl: "components/files-repository/history/history.html",
      controller: "FileHistoryCtrl",
      size: "sm",
      resolve: {
        file: function () { return file; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("UploadFilesCtrl", ["$scope", "$modalInstance", "$log", "FilesRepositoryService", function ($scope, $modalInstance, $log, FilesRepositoryService) {
  $scope.files = [];
  $scope.availableTags = [];
  $scope.isMultiple = false;

  FilesRepositoryService.tags().then(function (data) {
    $scope.availableTags = data;
    $scope.tags = {};
  });

  $scope.save = function () {
    if (!isValid()) return;

    $modalInstance.close({
      files: $scope.files,
      isMultiple: $scope.isMultiple,
      name: $scope.name,
      description: $scope.description,
      tags: $scope.tags.list
    });
  };

  $scope.fileSelectChanged = function () {
    $scope.isMultiple = $scope.files.length > 1;
    setName();
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.saveDisabled = function () {
    if ($scope.isMultiple) return false;
    return !$scope.name || !$scope.files.length;
  };

  $scope.removeFile = function (index) {
    $scope.files.splice(index, 1);
    $scope.isMultiple = $scope.files.length > 1;
    setName();
  };

  function setName() {
    if ($scope.isMultiple) {
      $scope.name = "";
      return;
    }

    $scope.name = $scope.files[0] ? $scope.files[0].name : "";
  }

  function isValid() {
    $scope.errors = [];
    if (!$scope.files.length) $scope.errors.push("File is required");
    if (!$scope.isMultiple && !$scope.name) $scope.errors.push("File name is required");
    return $scope.errors.length === 0;
  }
}]);

"use strict";

app.service("UploadFileDialog", ["$modal", function ($modal) {
  this.open = function () {
    return $modal.open({
      templateUrl: "components/files-repository/upload/upload.html",
      controller: "UploadFilesCtrl",
      size: "md",
      resolve: {
      }
    }).result;
  };
}]);

"use strict";

app.filter("htmlToPlaintext", function () {
  return function (text) {
    var element = $("<span>" + text + "</span>");
    return element.length ? element.text() : text;
  };
}).filter("rawHtml", ["$sce", function ($sce) {
  return function (val) {
    return $sce.trustAsHtml(val);
  };
}]).filter("filesize", function () {
  return function (size) {
    if (isNaN(size)) size = 0;

    if (size < 1024) return size + " B";
    size /= 1024;

    if (size < 1024) return size.toFixed(2) + " KB";
    size /= 1024;

    if (size < 1024) return size.toFixed(2) + " MB";
    size /= 1024;

    if (size < 1024) return size.toFixed(2) + " GB";
    size /= 1024;

    return size.toFixed(2) + " TB";
  };
});

"use strict";

app.directive("focusMe", ["$timeout", function ($timeout) {
  return {
    link: function (scope, element, attrs) {
      scope.$watch(attrs.focusMe, function (value) {
        if (value) {
          $timeout(function () {
            element[0].focus();
          });
        }
      });
    }
  };
}]);

(function () {
  angular
    .module("template/treeGrid/treeGrid.html", [])
    .run(["$templateCache", function ($templateCache) {
        $templateCache.put("template/treeGrid/treeGrid.html",
          "<div class=\"table-responsive\" style=\"height: calc(100vh - 258px) !important; overflow-y: auto;\">\n" +
          " <table class=\"table tree-grid\">\n" +
          "   <thead>\n" +
          "     <tr>\n" +
          "       <th>{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</th>\n" +
          "       <th ng-repeat=\"col in colDefinitions\">{{col.displayName || col.field}}</th>\n" +
          "     </tr>\n" +
          "   </thead>\n" +
          "   <tbody>\n" +
          "     <tr ng-click=\"on_user_click(row.branch)\" ng-repeat=\"row in tree_rows | filter:{visible:true} track by row.branch.uid\"\n" +
          "       ng-class=\"'level-' + {{ row.level }} + (row.branch.selected ? ' active':'')\" class=\"tree-grid-row\">\n" +
          "       <td><a ng-click=\"user_clicks_branch(row.branch); $event.stopPropagation();\"><i ng-class=\"row.tree_icon\"\n" +
          "              ng-click=\"row.branch.expanded = !row.branch.expanded\"\n" +
          "              class=\"indented tree-icon\"></i>\n" +
          "           </a><span class=\"indented tree-label\" ng-click=\"on_user_click(row.branch); $event.stopPropagation();\">\n" +
          "             {{row.branch[expandingProperty.field] || row.branch[expandingProperty]}}</span>\n" +
          "       </td>\n" +
          "       <td ng-repeat=\"col in colDefinitions\">\n" +
          "         <div ng-if=\"col.cellTemplate\" compile=\"col.cellTemplate\"></div>\n" +
          "         <div ng-if=\"!col.cellTemplate\">{{row.branch[col.field]}}</div>\n" +
          "       </td>\n" +
          "     </tr>\n" +
          "   </tbody>\n" +
          " </table>\n" +
          "</div>\n" +
          "");
      }]);

  angular
    .module("treeGrid", [
      "template/treeGrid/treeGrid.html"
    ])

    .directive("compile", ["$compile", function ($compile) {
        return {
          restrict: "A",
          link: function (scope, element, attrs) {
            // Watch for changes to expression.
            scope.$watch(attrs.compile, function (new_val) {
              /*
               * Compile creates a linking function
               * that can be used with any scope.
               */
              var link = $compile(new_val);

              /*
               * Executing the linking function
               * creates a new element.
               */
              var new_elem = link(scope);

              // Which we can then append to our DOM element.
              element.append(new_elem);
            });
          }
        };
      }])

    .directive("treeGrid", ["$timeout", "treegridTemplate", function ($timeout,
        treegridTemplate) {

        return {
          restrict: "E",
          templateUrl: function (tElement, tAttrs) {
            return tAttrs.templateUrl || treegridTemplate.getPath();
          },
          replace: true,
          scope: {
            treeData: "=",
            colDefs: "=",
            expandOn: "=",
            onSelect: "&",
            onClick: "&",
            initialSelection: "@",
            treeControl: "="
          },
          link: function (scope, element, attrs) {
            var error, expandingProperty,
              expand_all_parents, expand_level,
              for_all_ancestors, for_each_branch,
              get_parent, n, on_treeData_change,
              select_branch, selected_branch, tree;

            error = function (s) {
              console.log("ERROR:" + s);

              return void 0;
            };

            attrs.iconExpand = attrs.iconExpand ? attrs.iconExpand : "icon-plus  glyphicon glyphicon-plus  fa fa-plus";
            attrs.iconCollapse = attrs.iconCollapse ? attrs.iconCollapse : "icon-minus glyphicon glyphicon-minus fa fa-minus";
            attrs.iconLeaf = attrs.iconLeaf ? attrs.iconLeaf : "icon-file  glyphicon glyphicon-file  fa fa-file";
            attrs.expandLevel = attrs.expandLevel ? attrs.expandLevel : "3";
            expand_level = parseInt(attrs.expandLevel, 10);

            if (!scope.treeData) {
              alert("No data was defined for the tree, please define treeData!");
              return;
            }

            var getExpandingProperty = function getExpandingProperty() {
              if (attrs.expandOn) {
                expandingProperty = scope.expandOn;
                scope.expandingProperty = scope.expandOn;
              } else {
                if (scope.treeData.length) {
                  var _firstRow = scope.treeData[0],
                    _keys = Object.keys(_firstRow);
                  for (var i = 0, len = _keys.length; i < len; i++) {
                    if (typeof (_firstRow[_keys[i]]) === "string") {
                      expandingProperty = _keys[i];
                      break;
                    }
                  }
                  if (!expandingProperty) expandingProperty = _keys[0];
                  scope.expandingProperty = expandingProperty;
                }
              }
            };

            getExpandingProperty();

            if (!attrs.colDefs) {
              if (scope.treeData.length) {
                var _col_defs = [],
                  _firstRow = scope.treeData[0],
                  _unwantedColumn = ["children", "level", "expanded", expandingProperty];
                for (var idx in _firstRow) {
                  if (_unwantedColumn.indexOf(idx) === -1) {
                    _col_defs.push({
                      field: idx
                    });
                  }
                }
                scope.colDefinitions = _col_defs;
              }
            } else {
              scope.colDefinitions = scope.colDefs;
            }

            for_each_branch = function (f) {
              var do_f, root_branch, _i, _len, _ref, _results;
              do_f = function (branch, level) {
                var child, _i, _len, _ref, _results;
                f(branch, level);
                if (branch.children != null) {
                  _ref = branch.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    _results.push(do_f(child, level + 1));
                  }
                  return _results;
                }
              };
              _ref = scope.treeData;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                root_branch = _ref[_i];
                _results.push(do_f(root_branch, 1));
              }
              return _results;
            };
            selected_branch = null;
            select_branch = function (branch) {
              if (!branch) {
                if (selected_branch != null) {
                  selected_branch.selected = false;
                }
                selected_branch = null;
                return;
              }
              if (branch !== selected_branch) {
                if (selected_branch != null) {
                  selected_branch.selected = false;
                }
                branch.selected = true;
                selected_branch = branch;
                expand_all_parents(branch);
                if (branch.onSelect != null) {
                  return $timeout(function () {
                    return branch.onSelect(branch);
                  });
                } else {
                  if (scope.onSelect != null) {
                    return $timeout(function () {
                      return scope.onSelect({
                        branch: branch
                      });
                    });
                  }
                }
              }
            };
            scope.on_user_click = function (branch) {
              if (scope.onClick) {
                scope.onClick({
                  branch: branch
                });
              }
            };
            scope.user_clicks_branch = function (branch) {
              if (branch !== selected_branch) {
                return select_branch(branch);
              }
            };
            get_parent = function (child) {
              var parent;
              parent = void 0;
              if (child.parent_uid) {
                for_each_branch(function (b) {
                  if (b.uid === child.parent_uid) {
                    return parent = b;
                  }
                });
              }
              return parent;
            };
            for_all_ancestors = function (child, fn) {
              var parent;
              parent = get_parent(child);
              if (parent != null) {
                fn(parent);
                return for_all_ancestors(parent, fn);
              }
            };
            expand_all_parents = function (child) {
              return for_all_ancestors(child, function (b) {
                return b.expanded = true;
              });
            };

            scope.tree_rows = [];

            on_treeData_change = function () {
              getExpandingProperty();

              var add_branch_to_list, root_branch, _i, _len, _ref, _results;
              for_each_branch(function (b, level) {
                if (!b.uid) {
                  return b.uid = "" + Math.random();
                }
              });
              for_each_branch(function (b) {
                var child, _i, _len, _ref, _results;
                if (angular.isArray(b.children)) {
                  _ref = b.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    _results.push(child.parent_uid = b.uid);
                  }
                  return _results;
                }
              });
              scope.tree_rows = [];
              for_each_branch(function (branch) {
                var child, f;
                if (branch.children) {
                  if (branch.children.length > 0) {
                    f = function (e) {
                      if (typeof e === "string") {
                        return {
                          label: e,
                          children: []
                        };
                      } else {
                        return e;
                      }
                    };
                    return branch.children = (function () {
                      var _i, _len, _ref, _results;
                      _ref = branch.children;
                      _results = [];
                      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        child = _ref[_i];
                        _results.push(f(child));
                      }
                      return _results;
                    })();
                  }
                } else {
                  return branch.children = [];
                }
              });
              add_branch_to_list = function (level, branch, visible) {
                var child, child_visible, tree_icon, _i, _len, _ref, _results;
                if (branch.expanded == null) {
                  branch.expanded = false;
                }
                if (!branch.children || branch.children.length === 0) {
                  tree_icon = attrs.iconLeaf;
                } else {
                  if (branch.expanded) {
                    tree_icon = attrs.iconCollapse;
                  } else {
                    tree_icon = attrs.iconExpand;
                  }
                }
                branch.level = level;
                scope.tree_rows.push({
                  level: level,
                  branch: branch,
                  label: branch[expandingProperty],
                  tree_icon: tree_icon,
                  visible: visible
                });
                if (branch.children != null) {
                  _ref = branch.children;
                  _results = [];
                  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    child = _ref[_i];
                    child_visible = visible && branch.expanded;
                    _results.push(add_branch_to_list(level + 1, child, child_visible));
                  }
                  return _results;
                }
              };
              _ref = scope.treeData;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                root_branch = _ref[_i];
                _results.push(add_branch_to_list(1, root_branch, true));
              }
              return _results;
            };

            scope.$watch("treeData", on_treeData_change, true);

            if (attrs.initialSelection != null) {
              for_each_branch(function (b) {
                if (b.label === attrs.initialSelection) {
                  return $timeout(function () {
                    return select_branch(b);
                  });
                }
              });
            }
            n = scope.treeData.length;
            for_each_branch(function (b, level) {
              b.level = level;
              return b.expanded = b.level < expand_level;
            });
            if (scope.treeControl != null) {
              if (angular.isObject(scope.treeControl)) {
                tree = scope.treeControl;
                tree.expand_all = function () {
                  return for_each_branch(function (b, level) {
                    return b.expanded = true;
                  });
                };
                tree.collapse_all = function () {
                  return for_each_branch(function (b, level) {
                    return b.expanded = false;
                  });
                };
                tree.get_first_branch = function () {
                  n = scope.treeData.length;
                  if (n > 0) {
                    return scope.treeData[0];
                  }
                };
                tree.select_first_branch = function () {
                  var b;
                  b = tree.get_first_branch();
                  return tree.select_branch(b);
                };
                tree.get_selected_branch = function () {
                  return selected_branch;
                };
                tree.get_parent_branch = function (b) {
                  return get_parent(b);
                };
                tree.select_branch = function (b) {
                  select_branch(b);
                  return b;
                };
                tree.get_children = function (b) {
                  return b.children;
                };
                tree.select_parent_branch = function (b) {
                  var p;
                  if (b == null) {
                    b = tree.get_selected_branch();
                  }
                  if (b != null) {
                    p = tree.get_parent_branch(b);
                    if (p != null) {
                      tree.select_branch(p);
                      return p;
                    }
                  }
                };
                tree.add_branch = function (parent, new_branch) {
                  if (parent != null) {
                    parent.children.push(new_branch);
                    parent.expanded = true;
                  } else {
                    scope.treeData.push(new_branch);
                  }
                  return new_branch;
                };
                tree.add_root_branch = function (new_branch) {
                  tree.add_branch(null, new_branch);
                  return new_branch;
                };
                tree.expand_branch = function (b) {
                  if (b == null) {
                    b = tree.get_selected_branch();
                  }
                  if (b != null) {
                    b.expanded = true;
                    return b;
                  }
                };
                tree.collapse_branch = function (b) {
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    b.expanded = false;
                    return b;
                  }
                };
                tree.get_siblings = function (b) {
                  var p, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    p = tree.get_parent_branch(b);
                    if (p) {
                      siblings = p.children;
                    } else {
                      siblings = scope.treeData;
                    }
                    return siblings;
                  }
                };
                tree.get_next_sibling = function (b) {
                  var i, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    siblings = tree.get_siblings(b);
                    n = siblings.length;
                    i = siblings.indexOf(b);
                    if (i < n) {
                      return siblings[i + 1];
                    }
                  }
                };
                tree.get_prev_sibling = function (b) {
                  var i, siblings;
                  if (b == null) {
                    b = selected_branch;
                  }
                  siblings = tree.get_siblings(b);
                  n = siblings.length;
                  i = siblings.indexOf(b);
                  if (i > 0) {
                    return siblings[i - 1];
                  }
                };
                tree.select_next_sibling = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_next_sibling(b);
                    if (next != null) {
                      return tree.select_branch(next);
                    }
                  }
                };
                tree.select_prev_sibling = function (b) {
                  var prev;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev = tree.get_prev_sibling(b);
                    if (prev != null) {
                      return tree.select_branch(prev);
                    }
                  }
                };
                tree.get_first_child = function (b) {
                  var _ref;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    if (((_ref = b.children) != null ? _ref.length : void 0) > 0) {
                      return b.children[0];
                    }
                  }
                };
                tree.get_closest_ancestor_next_sibling = function (b) {
                  var next, parent;
                  next = tree.get_next_sibling(b);
                  if (next != null) {
                    return next;
                  } else {
                    parent = tree.get_parent_branch(b);
                    return tree.get_closest_ancestor_next_sibling(parent);
                  }
                };
                tree.get_next_branch = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_first_child(b);
                    if (next != null) {
                      return next;
                    } else {
                      next = tree.get_closest_ancestor_next_sibling(b);
                      return next;
                    }
                  }
                };
                tree.select_next_branch = function (b) {
                  var next;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    next = tree.get_next_branch(b);
                    if (next != null) {
                      tree.select_branch(next);
                      return next;
                    }
                  }
                };
                tree.last_descendant = function (b) {
                  var last_child;
                  if (b == null) {

                  }
                  n = b.children.length;
                  if (n === 0) {
                    return b;
                  } else {
                    last_child = b.children[n - 1];
                    return tree.last_descendant(last_child);
                  }
                };
                tree.get_prev_branch = function (b) {
                  var parent, prev_sibling;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev_sibling = tree.get_prev_sibling(b);
                    if (prev_sibling != null) {
                      return tree.last_descendant(prev_sibling);
                    } else {
                      parent = tree.get_parent_branch(b);
                      return parent;
                    }
                  }
                };
                return tree.select_prev_branch = function (b) {
                  var prev;
                  if (b == null) {
                    b = selected_branch;
                  }
                  if (b != null) {
                    prev = tree.get_prev_branch(b);
                    if (prev != null) {
                      tree.select_branch(prev);
                      return prev;
                    }
                  }
                };
              }
            }
          }
        };
      }
    ])

    .provider("treegridTemplate", function () {
      var templatePath = "template/treeGrid/treeGrid.html";

      this.setPath = function (path) {
        templatePath = path;
      };

      this.$get = function () {
        return {
          getPath: function () {
            return templatePath;
          }
        };
      };
    });
}).call(window);

"use strict";

app.controller("QuestionSetDirectiveCtrl", ["$scope", "Auth", "ProjectService", "LanguageService", function ($scope, Auth, ProjectService, LanguageService) {
  $scope.current = ProjectService.current;
  $scope.isAdmin = Auth.isAdmin;

  $scope.currentLang = function () { return LanguageService.getCurrentLanguage()["key"]; };
}]);

"use strict";

app.factory("HttpEventsInterceptor", ["$rootScope", "$q", function ($rootScope, $q) {
  $rootScope.$httpRequestsInProgress = 0;

  return {
    request: function (request) {
      if ($rootScope.$httpRequestsInProgress++ === 0)
        $rootScope.$broadcast("http:startedAll");

      $rootScope.$broadcast("http:started", request);
      return request;
    },

    response: function (response) {
      if (--$rootScope.$httpRequestsInProgress === 0)
        $rootScope.$broadcast("http:completedAll");

      $rootScope.$broadcast("http:completed", response);
      return response;
    },

    responseError: function (response) {
      if (--$rootScope.$httpRequestsInProgress === 0)
        $rootScope.$broadcast("http:completedAll");

      $rootScope.$broadcast("http:completed", response);
      return $q.reject(response);
    }
  };
}]).config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push("HttpEventsInterceptor");
}]);

"use strict";

app.service("LanguageService", ["$http", "Storage", "gettextCatalog", "Lookups", "Auth", "$timeout", function ($http, Storage, gettextCatalog, Lookups, Auth, $timeout) {
  var cookies = Storage.cookies;

  var LANGUAGES;
  var LANGUAGE_CODE_HEADER = "Language-Code";
  var LANGUAGE_COOKIES_KEY = "language";

  var instance = {
    loadLanguages: function () {
      return Lookups.languages().then(function (data) {
        return LANGUAGES = data;
      });
    },

    getCurrentLanguage: function () {
      // Auth.getCurrentUser()
      var language = cookies.get(LANGUAGE_COOKIES_KEY);

      // console.log('lang from cookies', JSON.parse(JSON.stringify(language)))

      if (!language) language = Auth.getCurrentUser().language || "en_us";

      if (language === "en") { // backwards compatibility
        language = "en_us";
      }

      language = _.find(LANGUAGES, function (l) {
        return l.code === language;
      }) || {};

      return { key: language.code, name: language.name };
    },

    switchLanguage: function (language) {
      cookies.del(LANGUAGE_COOKIES_KEY);
      cookies.set(LANGUAGE_COOKIES_KEY, language, { expires: 30 });
      $http.defaults.headers.common[LANGUAGE_CODE_HEADER] = language;
      gettextCatalog.setCurrentLanguage(language);
    },

    getKeyValuePair: function () {
      return LANGUAGES.filter(function (lang) {
        return { key: lang.code, name: lang.name };
      });
    }
  };

  return instance;
}]);

"use strict";

app.directive("loading", function () {
  return {
    restrict: "E",
    templateUrl: "components/loading/loading.html",
    replace: true,

    scope: {
      show: "=show"
    },

    link: function (scope) {}
  };
});

"use strict";

app.service("LocalStorage", ["$http", "$q", "localStorageService", function ($http, $q, localStorageService) {
  var keys = {
    specs: "specs",
    questionSets: "questionSets",
    pointLists: "pointLists",
    dataSheets: "dataSheets",
    boms: "boms"
  };

  return {
    fetch: function (type, id) {
      var values = localStorageService.get(type) || {};

      return values[id];
    },

    load: function (type) {
      var values = localStorageService.get(type) || {};
      var result = values;

      if (!Array.isArray(result)) {
        result = [];

        for (var key in values) {
          var current = values[key];

          result.push(current);
        }
      }

      return result;
    },

    save: function (type, data, asArray) {
      if (!Array.isArray(data)) data = [data];

      var toSave = data;

      // if asArray is not defined store as object
      if (!asArray) {
        toSave = {};

        data.forEach(function (item) {
          toSave[item._id] = item;
        });
      }

      localStorageService.set(type, toSave);
    },

    delete: function (type, id) {
      var values = localStorageService.get(type) || {};

      delete values[id];

      localStorageService.set(type, values);
    },

    clear: function (type) {
      localStorageService.remove(type);
    },

    applicationCache: function () {
      var self = this;

      return $q(function (resolve) {
        $http.get("/api/specs/").then(function (response) {
          var specs = response.data || [];

          // save specs into local cache
          self.save(keys.specs, specs);

          $http.get("/api/questions").then(function (response) {
            var questionSets = response.data || [];

            // save question sets into local cache
            self.save(keys.questionSets, questionSets);

            $http.get("/api/pointlists").then(function (response) {
              var pointLists = response.data || [];

              // save point lists into local cache
              self.save(keys.pointLists, pointLists);

              $http.get("/api/datasheet").then(function (response) {
                var dataSheets = response.data || [];

                // save data sheets into local cache
                self.save(keys.dataSheets, dataSheets);

                $http.get("/api/boms").then(function (response) {
                  var boms = response.data || [];

                  // save boms into local cache
                  self.save(keys.boms, boms);
                  resolve();
                });
              });
            });
          });
        });
      });
    }
  };
}]);

"use strict";

app.service("Lookups", ["$http", "$q", function ($http, $q) {
  var groups = null;
  var countries = null;
  var languages = null;
  var products = null;

  function getName(list, code) {
    for (var i = 0; i < list.length; i++)
      if (list[i].code === code)
        return list[i].name;
    return "(unknown)";
  }

  var instance = {
    userGroups: function (reload) {
      return $q(function (resolve) {
        if (groups && !reload) return resolve(groups);

        $http.get("/api/lookups/groups").then(function (response) {
          groups = response.data;
          return resolve(groups);
        });
      });
    },

    countries: function (reload) {
      return $q(function (resolve) {
        if (countries && !reload) return resolve(countries);

        $http.get("/api/lookups/countries").then(function (response) {
          countries = response.data;
          countries.getName = function (code) { return getName(countries, code); };
          return resolve(countries);
        });
      });
    },

    languages: function (reload) {
      return $q(function (resolve) {
        if (languages && !reload) return resolve(languages);

        $http.get("/api/lookups/languages").then(function (response) {
          languages = response.data;
          languages.getName = function (code) { return getName(languages, code); };
          return resolve(languages);
        });
      });
    },

    products: function (reload) {
      return $q(function (resolve) {
        if (products && !reload) return resolve(products);

        $http.get("/api/lookups/products").then(function (response) {
          products = response.data;
          products.getName = function (code) { return getName(products, code); };
          return resolve(products);
        });
      });
    },

    // COUNTRY MANAGEMENT
    saveCountry: function (data) {
      return $q(function (resolve) {
        $http.post("/api/lookups/country", data).then(function (response) {
          console.log("response is ", response);
          return resolve(response.data);
        });
      });
    },

    deleteCountry: function (id) {
      return $http.delete("/api/lookups/country/" + id);
    },

    // LANGUAGE MANAGEMENT
    saveLanguage: function (data) {
      return $q(function (resolve) {
        $http.post("/api/lookups/language", data).then(function (response) {
          console.log("response is ", response);
          return resolve(response.data);
        });
      });
    },

    deleteLanguage: function (id) {
      return $http.delete("/api/lookups/language/" + id);
    },

    // PRODUCT MANAGEMENT
    saveProduct: function (data) {
      return $q(function (resolve) {
        $http.post("/api/lookups/product", data).then(function (response) {
          console.log("response is ", response);
          return resolve(response.data);
        });
      });
    },

    deleteProduct: function (id) {
      return $http.delete("/api/lookups/product/" + id);
    }
  };

  return instance;
}]);

"use strict";

app.controller("MessageCtrl", ["$scope", "$modalInstance", "title", "text", "type", "data", function ($scope, $modalInstance, title, text, type, data) {
  $scope.title = title;
  $scope.text = text;
  $scope.type = type;
  $scope.data = data;

  $scope.close = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("Message", ["$modal", function ($modal) {
  this.open = function (text, title, size, type, data) {
    return $modal.open({
      templateUrl: "components/message/message.html",
      controller: "MessageCtrl",
      size: size || "sm",
      resolve: {
        title: function () { return title; },
        text: function () { return text; },
        type: function () { return type; },
        data: function () { return data; }
      }
    }).result;
  };
}]);

"use strict";

angular.module("swolApp")
  .factory("Modal", ["$rootScope", "$modal", function ($rootScope, $modal) {
    /**
     * Opens a modal
     * @param  {Object} scope      - an object to be merged with modal's scope
     * @param  {String} modalClass - (optional) class(es) to be applied to the modal
     * @return {Object}            - the instance $modal.open() returns
     */
    function openModal(scope, modalClass) {
      var modalScope = $rootScope.$new();
      scope = scope || {};
      modalClass = modalClass || "modal-default";

      angular.extend(modalScope, scope);

      return $modal.open({
        templateUrl: "components/modal/modal.html",
        windowClass: modalClass,
        scope: modalScope
      });
    }

    // Public API here
    return {

      /* Confirmation modals */
      confirm: {

        /**
         * Create a function to open a delete confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
         * @param  {Function} del - callback, ran when delete is confirmed
         * @return {Function}     - the function to open the modal (ex. myModalFn)
         */
        delete: function (del) {
          del = del || angular.noop;

          /**
           * Open a delete confirmation modal
           * @param  {String} name   - name or info to show on modal
           * @param  {All}           - any additional args are passed staight to del callback
           */
          return function () {
            var args = Array.prototype.slice.call(arguments),
              name = args.shift(),
              deleteModal;

            deleteModal = openModal({
              modal: {
                dismissable: true,
                title: "Confirm Delete",
                html: "<p>Are you sure you want to delete <strong>" + name + "</strong> ?</p>",
                buttons: [{
                  classes: "btn-danger",
                  text: "Delete",
                  click: function (e) {
                    deleteModal.close(e);
                  }
                }, {
                  classes: "btn-default",
                  text: "Cancel",
                  click: function (e) {
                    deleteModal.dismiss(e);
                  }
                }]
              }
            }, "modal-danger");

            deleteModal.result.then(function (event) {
              del.apply(event, args);
            });
          };
        }
      }
    };
  }]);

"use strict";

/**
 * Removes server error when user updates input
 */
angular.module("swolApp")
  .directive("mongooseError", function () {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {
        element.on("keydown", function () {
          return ngModel.$setValidity("mongoose", true);
        });
      }
    };
  });

"use strict";

app.controller("NavbarCtrl", ["$scope", "$location", "Auth", "LanguageService", "Config", "gettextCatalog", "$rootScope", function ($scope, $location, Auth, LanguageService, Config, gettextCatalog, $rootScope) {
  $scope.menu = [{
    "title": "Home",
    "link": "/"
  }];
  $scope.isCollapsed = true;
  $scope.isLoggedIn = Auth.isLoggedIn;
  $scope.isAdmin = Auth.isAdmin;
  $scope.isMaster = Auth.isMaster;
  $scope.getCurrentUser = Auth.getCurrentUser;
  $scope.isNotification = false;
  $scope.notificationQuantity = 0;
  $scope.logout = function () {
    Auth.logout();
  };

  $scope.isActive = function (route) {
    return route === $location.path();
  };

  $scope.switchLanguage = function (lang) {
    LanguageService.switchLanguage(lang);
    $scope.currentLanguage = LanguageService.getCurrentLanguage();
    $scope.$emit("lang-changed");
  };

  $scope.getNotifications = function () {
    if(Auth.isLoggedIn()) {
      Auth.isNotification().then(res => {
        if(res.data.length > 0){
          res.data.forEach(report => {
            if(report.status === "unread"){
              $scope.notificationQuantity ++;
              $scope.isNotification = true;
            }
          })
        }
      });
    }
  }

  $scope.loadLanguages = function () {
    LanguageService.loadLanguages().then(function (langs) {
      // $scope.languages = LanguageService.getKeyValuePair()
      $scope.currentLanguage = LanguageService.getCurrentLanguage();

      gettextCatalog.setCurrentLanguage($scope.currentLanguage.key);
      $scope.languages = langs.map(function (l) { return { key: l.code, name: l.name }; });
    });
  };

  $scope.getNotifications();
  $scope.loadLanguages();
}]);

/**
 * @preserve AngularJS PDF viewer directive using pdf.js.
 *
 * https://github.com/akrennmair/ng-pdfviewer
 *
 * MIT license
 */

angular.module("ngPDFViewer", []).
  directive("pdfviewer", ["$parse", function ($parse) {
    var canvas = null;
    var instance_id = null;

    return {
      restrict: "E",
      template: "<canvas></canvas>",
      scope: {
        onPageLoad: "&",
        loadProgress: "&",
        src: "@",
        id: "=",
        scale: "="
      },
      controller: ["$scope", function ($scope) {
        $scope.pageNum = 1;
        $scope.pdfDoc = null;
        // $scope.scale = 1.0;
        $scope.documentProgress = function (progressData) {
          if ($scope.loadProgress) {
            $scope.loadProgress({ state: "loading", loaded: progressData.loaded, total: progressData.total });
          }
        };

        $scope.loadPDF = function (path) {
          PDFJS.getDocument(path, null, null, $scope.documentProgress).then(function (_pdfDoc) {
            $scope.pdfDoc = _pdfDoc;
            $scope.renderPage($scope.pageNum, function (success) {
              if ($scope.loadProgress) {
                $scope.loadProgress({ state: "finished", loaded: 0, total: 0 });
              }
            });
          }, function (message, exception) {
            console.log("PDF load error: " + message);
            if ($scope.loadProgress) {
              $scope.loadProgress({ state: "error", loaded: 0, total: 0 });
            }
          });
        };

        $scope.renderPage = function (num, callback) {
          if (!$scope.pdfDoc) return;

          $scope.pdfDoc.getPage(num).then(function (page) {
            var container = angular.element(canvas).parent().parent()[0];
            var scale = 1.0;
            // $scope.scale='fit-height';
            var viewport100 = page.getViewport(1.0);
            if (angular.isNumber($scope.scale)) {
              scale = $scope.scale;
            } else if ($scope.scale == "fit-width") {
              scale = container.offsetWidth / viewport100.width;

            } else if ($scope.scale == "fit-height") {
              scale = container.offsetHeight / viewport100.height;
            }

            var viewport = page.getViewport(scale);

            var ctx = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            if (canvas.width < container.offsetWidth) {
              angular.element(canvas)[0].style.marginLeft = (container.offsetWidth - canvas.width) / 2 + "px";
            } else {
              angular.element(canvas)[0].style.marginLeft = "";
            }

            page.render({ canvasContext: ctx, viewport: viewport }).then(
              function () {
                if (callback) {
                  callback(true);
                }
                $scope.$apply(function () {
                  $scope.onPageLoad({ page: $scope.pageNum, total: $scope.pdfDoc.numPages });
                });
              },
              function () {
                if (callback) {
                  callback(false);
                }
              }
            );
          });
        };

        $scope.$on("pdfviewer.nextPage", function (evt, id) {
          if (id !== instance_id) {
            return;
          }

          if ($scope.pageNum < $scope.pdfDoc.numPages) {
            $scope.pageNum++;
            $scope.renderPage($scope.pageNum);
          }
        });

        $scope.$on("pdfviewer.prevPage", function (evt, id) {
          if (id !== instance_id) {
            return;
          }

          if ($scope.pageNum > 1) {
            $scope.pageNum--;
            $scope.renderPage($scope.pageNum);
          }
        });

        $scope.$on("pdfviewer.gotoPage", function (evt, id, page) {
          if (id !== instance_id) {
            return;
          }

          if (page >= 1 && page <= $scope.pdfDoc.numPages) {
            $scope.pageNum = page;
            $scope.renderPage($scope.pageNum);
          }
        });
        $scope.$watch("scale", function (v) {
          if (v !== undefined && v !== null && v !== "") {
            $scope.renderPage($scope.pageNum);
          }
        });
      } ],
      link: function (scope, iElement, iAttr) {
        canvas = iElement.find("canvas")[0];
        instance_id = iAttr.id;

        iAttr.$observe("src", function (v) {
          if (v !== undefined && v !== null && v !== "") {
            scope.pageNum = 1;
            scope.loadPDF(scope.src);
          }
        });

      }
    };
  }]).
  service("PDFViewerService", ["$rootScope", function ($rootScope) {

    var svc = { };
    svc.nextPage = function () {
      $rootScope.$broadcast("pdfviewer.nextPage");
    };

    svc.prevPage = function () {
      $rootScope.$broadcast("pdfviewer.prevPage");
    };

    svc.Instance = function (id) {
      var instance_id = id;

      return {
        prevPage: function () {
          $rootScope.$broadcast("pdfviewer.prevPage", instance_id);
        },
        nextPage: function () {
          $rootScope.$broadcast("pdfviewer.nextPage", instance_id);
        },
        gotoPage: function (page) {
          $rootScope.$broadcast("pdfviewer.gotoPage", instance_id, page);
        }
      };
    };

    return svc;
  }]);

"use strict";

app.controller("OfficePreviewCtrl", ["$scope", "$sce", "$modalInstance", "$log", "title", "viewUrl", "type", "message", "PDFViewerService", function ($scope, $sce, $modalInstance, $log, title, viewUrl, type, message, PDFViewerService) {
  $scope.title = title;
  $scope.viewUrl = viewUrl;
  $scope.type = type;
  $scope.message = message;
  $scope.msOfficeTypes = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];
  $scope.msOfficeUrl = "https://view.officeapps.live.com/op/view.aspx?src=";
  $scope.accusoftUrl = "http://api.accusoft.com/v1/viewer/?key=K5032015162524&viewerwidth=100%&document=";

  $scope.isIframe = (["svg", "png"].indexOf($scope.type)) === -1;

  $scope.trustSrc = function () {
    if (!$scope.isIframe) return null; // prevent from loading iframe with incorrect urls

    var url = $scope.msOfficeUrl;
    if ($scope.type === "pdf") url = "/assets/pdf-viewer/web/viewer.html?file=";
    console.log("viewUrl", $scope.viewUrl);

    var trusted = url + encodeURIComponent($scope.viewUrl);
    console.log("trusted uri for preview is ", trusted);

    var finalUrl = $sce.trustAsResourceUrl(trusted);
    return finalUrl;
  };

  $scope.showImage = function () {
    return (type === "svg" || type === "png") && !message;
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.service("OfficePreviewDialog", ["$modal", function ($modal) {
  this.open = function (title, viewUrl, type, message) {
    return $modal.open({
      templateUrl: "components/office-preview/office-preview-dialog/office-preview-dialog.html",
      controller: "OfficePreviewCtrl",
      size: "sm",
      windowClass: "office-preview",
      resolve: {
        title: function () { return title; },
        viewUrl: function () { return viewUrl; },
        type: function () { return type; },
        message: function () { return message; }
      }
    }).result;
  };
}]);

"use strict";

app.directive("officePreview", ["orderByFilter", "SpecConfigService", "OfficePreviewDialog", "SignatureService", function (orderByFilter, SpecConfigService, OfficePreviewDialog, SignatureService) {
  return {
    restrict: "E",
    templateUrl: "components/office-preview/office-preview.html",
    replace: true,

    scope: {
      specConfig: "=specConfig",
      specItem: "=specItem"
    },

    link: function (scope) {
      if (!scope.specConfig || !scope.specItem) return;

      var tmpList = [];
      angular.forEach(scope.specConfig.history, function (history) {
        if (history.refID === scope.specItem._id) tmpList.push(history);
      });
      scope.current = orderByFilter(tmpList, "-uploaded")[0];


      // this is the place where we define the url for the preview
      scope.preview = function () {
        if (!scope.current) return;

        if(!scope.specItem.url){
          SignatureService.directUrl(scope.current).then(function (response) {
            OfficePreviewDialog.open(scope.current.fileName, response, scope.current.extension).then();
          });
        } else {
            OfficePreviewDialog.open(scope.current.fileName, scope.current.url, scope.current.extension).then();
        }
        
      };
    }
  };
}]);
"use strict";

app.controller("PointListDirectiveCtrl", ["$scope", "ProjectService", "Confirm", "PointListService", function ($scope, ProjectService, Confirm, PointListService) {

  $scope.current = ProjectService.current;
  $scope.originalPoints = angular.copy($scope.list.points);

  $scope.undoAvailable = function () {
    var a = PointListService.undoAvailableFor($scope.current.menuItem.id);

    return a;

  };
  $scope.addPoint = function () {

    $scope.addedPointItem = {
      text: "",
      values: [],
      texts: {},
      isEditing: true,
      tempID: new Date().getTime()
    };

    $scope.list.points.push($scope.addedPointItem);
  };

  $scope.cancelAdding = function (point) {
    if (!$scope.addedPointItem && !$scope.editPointItem) return;
    var index = $scope.list.points.indexOf($scope.addedPointItem);

    $scope.addedPointItem = null;
    $scope.editPointItem = null;
    $scope.list.points.splice(index, 1);
  };

  $scope.savePoint = function (point) {
    angular.forEach(point.values, function (value) {
      if (typeof value === "object")
        point.values[point.values.indexOf(value)] = value.checked;
    });

    if (!$scope.current.project.answers[$scope.question.id]) {
      $scope.current.project.answers[$scope.question.id] = [point];
    } else {
      var index = $scope.current.project.answers[$scope.question.id].indexOf(point);

      if (index !== -1) $scope.current.project.answers[$scope.question.id][index] = point;
      else $scope.current.project.answers[$scope.question.id].push(point);
    }

    delete point.isEditing;
    $scope.addedPointItem = null;
    $scope.editPointItem = null;
  };

  $scope.editPoint = function (point, isCustom) {
    // might need to disable customOrderReverse when editing or adding new
    if ($scope.editPointItem) return;
    if (isCustom) {
      point.isEditing = true;
      point.id = new Date().getTime();

      $scope.editPointItem = angular.copy(point);
    } else {
      // let savePoint = angular.copy(point);
      // delete savePoint._id;

      ProjectService.addExcludedPoint(point).then(function (res, err) {
        if (err) throw err;
        $scope.current.project.removedPoints = res.data.removedPoints;
        $scope.addPoint();
        $scope.addedPointItem.text = point.text;
        $scope.addedPointItem.texts.Description = point.texts.Description;
        $scope.current.setProjectVersion(res.data.version);
      });
    }
  };

  $scope.filterKeyword;

  $scope.filterPointList = function () {

    $scope.list.points = $scope.originalPoints.filter(function (point) {
      if ($scope.filterKeyword) {
        if (point.text.toLowerCase().indexOf($scope.filterKeyword.toLowerCase()) !== -1 || point.texts.Description.toLowerCase().indexOf($scope.filterKeyword.toLowerCase()) !== -1) {
          return true;
        }
      }
    });

    if (!$scope.filterKeyword) {
      $scope.list.points = $scope.originalPoints;
    }
  };

  $scope.undoPointRemoval = function () {

    var undoPoinst = PointListService.byMenuId(ProjectService.current.menuItem.id);
    var undoPoint = undoPoinst.pop();
    debugger;
    if (undoPoint.type === "custom") {
      $scope.savePoint(undoPoint.point);
      $scope.list.points.push(undoPoint.point);
      PointListService.removeFromUndo(ProjectService.current.menuItem.id, undoPoint.point, "custom").then(function (data) {

        $scope.current.project.undoQueue = data.undoQueue;
      });
    } else if (undoPoint.type === "default") {
      ProjectService.removeExcludedPoint(undoPoint.point).then(function (res, err) {
        if (err) {
          throw err;
        }

        $scope.current.setProjectVersion(res.data.version);
        $scope.current.project.removedPoints = res.data.removedPoints;

        PointListService.removeFromUndo(ProjectService.current.menuItem.id, undoPoint.point, "default").then(function (data) {

          $scope.current.project.undoQueue = data.undoQueue;
        });
      });
    }

    // PointListService.clearUndoFor(ProjectService.current.menuItem.id)

  };

  $scope.deletePoint = function (point, isCustom) {

    // isCustom tells if point is added manually for this particular project, or it's comming from spec config excel file
    Confirm.open("Are you sure you want to delete point?", "Delete Point", "md").then(
      function (result) {
        if (!result) return;
        // remove from answers
        if (isCustom) {
          var list = $scope.current.project.answers[$scope.question.id];
          var index = list.indexOf(point);

          $scope.current.project.answers[$scope.question.id].splice(index, 1); // removes from db

          // remove from list

          var listIndex = $scope.list.points.indexOf(point);
          $scope.list.points.splice(listIndex, 1);

          if (!$scope.current.project.answers[$scope.question.id].length) {
            delete $scope.current.project.answers[$scope.question.id];
          }
          PointListService.addToUndo(ProjectService.current.menuItem.id, point, "custom").then(function (data) {
            debugger;
            $scope.current.project.undoQueue = data.undoQueue;
          });

        } else {
          ProjectService.addExcludedPoint(point).then(function (res, err) {
            if (err) throw err;
            $scope.current.project.removedPoints = res.data.removedPoints;
            $scope.current.setProjectVersion(res.data.version);

            PointListService.addToUndo(ProjectService.current.menuItem.id, point, "default").then(function (data) {

              $scope.current.project.undoQueue = data.undoQueue;
            });

          });
        }

        $scope.addedPointItem = null;
        $scope.editPointItem = null;
      }
    );
  };

  $scope.restorePoint = function (point) {
    Confirm.open("Are you sure you want to restore this point?", "Restore Point", "md").then(function (result) {
      if (!result) return;

      ProjectService.removeExcludedPoint(point).then(function (res, err) {
        if (err) {
          throw err;
        }

        $scope.current.setProjectVersion(res.data.version);
        $scope.current.project.removedPoints = res.data.removedPoints;

        PointListService.removeFromUndo(ProjectService.current.menuItem.id, point, "default").then(function (data) {

          $scope.current.project.undoQueue = data.undoQueue;
        });
      });
    });
  };

  $scope.bindCheck = function (point, option) {
    if (option.fieldType === "Check") {
      var index = point.values.indexOf(option.option.name);
      if (index !== -1) point.values.splice(index, 1);
      else point.values.push(option.option.name);
      return;
    }

    var exists = false;

    for (var i = 0; i < point.values.length; i++) {
      var value = point.values[i];

      if (getCheckGroup(value) === option.fieldName) {
        if (value === option.option.name) point.values.splice(point.values.indexOf(value), 1);
        else point.values[i] = option.option.name;
        exists = true;
      }
    }

    if (!exists) point.values.push(option.option.name);
  };

  $scope.pointIsValid = function (point) {
    if (!point.text) return false;

    return true;
  };

  function getCheckGroup(check) {
    for (var i = 0; i < $scope.allOptions.length; i++) {
      var current = $scope.allOptions[i];

      if (current.option.name === check)
        return current.fieldName;
    }
  }
}]);

"use strict";

app.directive("pointList", ["Evaluator", "ProjectService", "Auth", function (Evaluator, ProjectService, Auth) {

  return {
    restrict: "E",
    templateUrl: "components/point-lists/point-list.html",

    scope: {
      list: "=source",
      question: "=question",
      showAll: "=showAll",
      allowAdd: "=allowAdd"
    },

    link: function (scope) {
      scope.excludeSort = [
        "Hardware Points",
        "Software Points",
        "Miscellaneous",
      ];

      scope.current = ProjectService.current;

      scope.isAdmin = Auth.isAdmin;
      scope.allOptions = [];
      scope.tmp = {};

      scope.$on("qs:refresh:ui", function (e) {
        init();
      });

      scope.$watch("list", function () {
        if (!scope.list) return;
        init();
      });

      function init() {
        scope.showingRemovedPoints = false;
        scope.allOptions = [];
        scope.addedCels = [];
        scope.userPoints = scope.current.project ? scope.current.project.answers[scope.question.id] : null;

        if (scope.userPoints) {
          angular.forEach(scope.userPoints, function (point, index) {
            point.tempID = new Date().getTime() + index;
            if (scope.list.points.indexOf(point) === -1)
              scope.list.points.push(point);
          });
        } else {
          angular.forEach(scope.list.points, function (point, index) {
            if (point.tempID) scope.list.points.splice(index, 1);
          });
        }

        var i = 0;

        scope.list.fields.forEach(function (field) {
          field.fieldOptions.forEach(function (option) {
            scope.allOptions.push({
              fieldType: field.fieldType,
              type: field.typeName,
              option: option,
              fieldIndex: i,
              fieldName: field.name
            });
          });
          i++;
        });
      }

      scope.checkHighlight = function (type) {
        return scope.list.highlights[type];
      };

      scope.countChecks = function (option) {
        var excluded = scope.getExcludedPointsForThisList();

        if (!scope.tmp.filteredPoints) return;

        var res = 0;

        scope.tmp.filteredPoints.forEach(function (point) {
          if (option) {
            if (excluded.map(function (point) {
              return point._id;
            }).indexOf(point._id) > -1) return;

            if (option.fieldType === "Radio" || option.fieldType === "Check") {
              if (point.values.length && point.values[point.values.indexOf(option.option.name)])
                res++;
            } else if (option.fieldType === "Text" || option.fieldType === "Number") {
              if (point.texts && point.texts[option.option.name])
                res++;
            }
          } else {
            if (excluded.map(function (point) {
              return point._id;
            }).indexOf(point._id) > -1) return;
            if (point.text) res++;
          }
        });

        return res;
      };

      scope.getExcludedPointsForThisList = function () {
        var excluded = angular.copy(scope.current.project.removedPoints);
        var thisExcluded = [];

        //
        var filteredPoints = scope.list.points.filter(function (point) {
          if (scope.showAll || scope.current.showConfig) return true;

          if (!point.controlLogic || point.controlLogic === "Header") return true;
          return Evaluator.evaluate(scope.current.answers(), point.controlLogic);
        });

        if (filteredPoints) {
          filteredPoints.forEach(function (point) {
            if (excluded.indexOf(point._id) > -1) {
              thisExcluded.push(point);
            }
          });

          return thisExcluded;
        } else {
          return [];
        }

      };

      scope.sortTable = function (type, text) {
        if (scope.excludeSort.indexOf(text) !== -1) {
          return;
        }
        // console.log(type, text)
        scope.customOrder = text;
        // scope.prevCustomOrder = scope.prevCustomOrder || scope.customOrder
        scope.customOrderRev = !scope.customOrderRev;

      };

      scope.customOrderRev = false; // reverse true or false
      scope.customOrder = "";
      // scope.prevCustomOrder = ''

      scope.restoreTableOrder = function () {
        scope.customOrder = "";
        scope.customOrderRev = false;
      };

      scope.getPointOrder = function (point) {
        if (point.isEditing) return 0;

        if (scope.customOrder) {
          var res = 0;

          if (scope.customOrder == "Point Name") {
            return point.text;
          } else if (scope.customOrder == "Description") {
            return point.texts.Description;
          } else {
            scope.allOptions.forEach(function (option) {
              var optionName = option.option.name;

              if (scope.customOrder == optionName) {
                // console.log(optionName)
                if (point.values.indexOf(optionName) !== -1) {
                  res = -1;
                } else {
                  res = 1;
                }
              }
            });
            // console.log(res)
            // scope.prevCustomOrder = scope.customOrder;
            return res;
          }
        } else {
          var result = "";
          var p = point;
          var index = scope.list.points.indexOf(p);
          var i = index;

          while (p.controlLogic === "Header") {
            if (i === scope.list.points.length - 1) i--;
            else i++;
            p = scope.list.points[i];
          }

          scope.allOptions.forEach(function (option) {
            var isChecked = p.values.indexOf(option.option.name) >= 0;
            if (isChecked) result += "0"; else result += "1";
          });

          return result + ((index + 1) / 10000);
        }
      };

      scope.displayPoint = function (point) {

        // if show all is true or show configuration is true show all point
        if (!scope.showingRemovedPoints) {
          if (scope.current.project.removedPoints.indexOf(point._id) !== -1) {
            return false;
          }

        }

        if (scope.showAll || scope.current.showConfig) return true;

        if (!point.controlLogic || point.controlLogic === "Header") return true;
        return Evaluator.evaluate(scope.current.answers(), point.controlLogic);
      };

      scope.displayHeader = function (point) {
        if (point.controlLogic !== "Header") return true;
        var index = scope.tmp.filteredPoints.indexOf(point);
        if (index === scope.tmp.filteredPoints.length - 1) return false;
        return scope.tmp.filteredPoints[index + 1].controlLogic !== "Header";
      };

      scope.setLoading = function (first, last) {
        if (first) scope.current.readyToShow = false;
        if (last) scope.current.readyToShow = true;
      };
    }
  };
}]);

"use strict";

app.service("PointListService", ["$http", "$upload", "$q", "Utils", "Evaluator", "$injector", function ($http, $upload, $q, Utils, Evaluator, $injector) {
  var instance = {

    popUndo: function (menuItemId) {
      if (this.undo[menuItemId].length > 0) {
        this.undo[menuItemId].pop();
      }
    },

    addToUndo: function (menuItemId, point, type) {
      // if (this.undo[menuItemId]) {
      //   this.undo[menuItemId].push(point)
      // } else {
      //   this.undo[menuItemId] = [point]
      // }
      var projectService = $injector.get("ProjectService");

      return $q(function (resolve) {
        $http.put("/api/pointlists/add-to-undo/" + projectService.current.project._id, { point: point, type: type, menuItemId: menuItemId }).then(function (response) {
          return resolve(response.data);
        });
      });

    },
    removeFromUndo: function (menuItemId, point, type) {
      var projectService = $injector.get("ProjectService");
      return $q(function (resolve) {
        $http.put("/api/pointlists/remove-from-undo/" + projectService.current.project._id, { point: point, type: type, menuItemId: menuItemId }).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    byMenuId: function (menuItemId) {
      var ProjectService = $injector.get("ProjectService");

      return ProjectService.current.project.undoQueue.filter(function (p) { return p.menuItemId === menuItemId; });
    },

    clearUndoFor: function (menuItemId) {
      var ProjectService = $injector.get("ProjectService");
      return $q(function (resolve) {
        $http.delete("/api/pointlists/clear-undo-for/" + ProjectService.current.project._id + "/" + menuItemId).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    undoAvailableFor: function (menuItemId) {
      var ProjectService = $injector.get("ProjectService");
      var ret = ProjectService.current.project.undoQueue.filter(function (p) { return p.menuItemId === menuItemId; }).length > 0;

      return ret;
    },

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/pointlists/",
        method: "POST",
        file: file,

        data: {
          specConfigID: specID,
          pointListID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/pointlists/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/pointlists/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/pointlists/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadByPages: function (pages, specConfigID) {
      var pointLists = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Points List" && question.fileFunction) {
            var splittedFileName = question.fileFunction.split("#");
            var sourceFileName = splittedFileName[0].trim();

            instance.fetchByName(specConfigID, sourceFileName).then(function (response) {
              if (!response) return;
              var listID = splittedFileName.length > 1 ? splittedFileName[1] : 0;

              if (listID) {
                angular.forEach(response.lists, function (list) {
                  if (list.id === listID)
                    pointLists.push({
                      list: list,
                      question: question,
                      fileName: sourceFileName
                    });
                });
              } else {
                pointLists.push({
                  list: response.lists[0],
                  question: question,
                  fileName: sourceFileName
                });
              }
            });
          }
        });
      });

      return pointLists;
    },

    namesByPages: function (pages) {
      var names = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Points List" && question.fileFunction) {
            var splittedFileName = question.fileFunction.split("#");
            var sourceFileName = splittedFileName[0].trim();

            if (names.indexOf(sourceFileName) < 0) names.push(sourceFileName);
          }
        });
      });

      return names;
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/pointlists/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/pointlists/rename", data);
    },

    transformToTreeData: function (pointList) {
      var result = {
        selectedNode: "",
        pointListData: [],

        nodeSelected: function (node) {
          this.selectedNode = node.data ? JSON.stringify(
            Utils.stripEmptyProperties(node.data),
            null, 2) : "";
        }
      };

      pointList.lists.forEach(function (list) {
        var listData = {
          class: "fa fa-file-text-o text-warning",
          text: "point list #" + list.id,
          type: "list",
          folder: true,
          id: list.id,
          children: [{
            class: "fa fa-list-alt text-warning",
            text: "fields",
            type: "fields",
            folder: true,
            id: list.id,
            children: []
          }, {
            class: "fa fa-list-alt text-warning",
            text: "points",
            type: "points",
            folder: true,
            id: list.id,
            children: []
          }]
        };

        list.fields.forEach(function (field) {
          var tmp = angular.copy(field);
          delete tmp.fieldOptions;
          delete tmp._id;

          var fieldData = {
            class: "fa text-info " + (field.fieldType === "Check" ? "fa-check-square-o" : "fa-check-circle-o"),
            text: field.name,
            type: "field",
            folder: true,
            data: tmp,
            children: []
          };

          field.fieldOptions.forEach(function (option) {
            var tmp = angular.copy(option);
            delete tmp._id;

            var optionData = {
              class: "fa fa-check",
              text: option.name,
              type: "option",
              folder: false,
              data: tmp
            };

            fieldData.children.push(optionData);
          });

          listData.children[0].children.push(fieldData);
        });

        list.points.forEach(function (point) {
          var tmp = angular.copy(point);
          delete tmp._id;

          var pointData = {
            class: "fa fa-dot-circle-o",
            text: point.text,
            type: "point",
            folder: true,
            data: tmp,
            children: []
          };

          point.values.forEach(function (val) {
            var valData = {
              class: "fa fa-check",
              text: val,
              type: "value",
              folder: false
            };

            pointData.children.push(valData);
          });

          listData.children[1].children.push(pointData);
        });

        result.pointListData.push(listData);
      });

      return result;
    }
  };

  return instance;
}]);

"use strict";

var QUESTION_GLOBAL_INDEX_SPEC_CONFIG_ID = "";
var QUESTION_GLOBAL_INDEX_REGISTRY = null;
var QUESTION_GLOBAL_LIST = null;

var BASE_URL_NOTIFICATION = "/api/notifications";

function getQuestionGlobalIndexRegistry(qs, specConfigID) {
  if (QUESTION_GLOBAL_INDEX_REGISTRY && QUESTION_GLOBAL_INDEX_SPEC_CONFIG_ID === specConfigID) {
    return QUESTION_GLOBAL_INDEX_REGISTRY;
  }

  QUESTION_GLOBAL_INDEX_SPEC_CONFIG_ID = specConfigID;
  QUESTION_GLOBAL_INDEX_REGISTRY = {};
  QUESTION_GLOBAL_LIST = [];
  var i = 0;

  qs.questions.pages.forEach(function (p) {
    p.questions.forEach(function (q) {
      QUESTION_GLOBAL_INDEX_REGISTRY[q.id.toString()] = i++;
      QUESTION_GLOBAL_LIST.push(q);
    });
  });

  return QUESTION_GLOBAL_INDEX_REGISTRY;
}

function getQuestionGlobalIndex(qs, specConfigID, question) {
  return getQuestionGlobalIndexRegistry(qs, specConfigID)[(question && question.id || question || "").toString()] || -1;
}

function getAllQuestionsAfter(qs, specConfigID, question) {
  var index = getQuestionGlobalIndex(qs, specConfigID, question);
  return QUESTION_GLOBAL_LIST.slice(index + 1);
}

app.service("ProjectService", ["$timeout", "$http", "$upload", "$q", "$rootScope", "orderByFilter", "Evaluator", "QuestionSetService", "PointListService", "DataSheetsService", "BillOfMaterialService", "localStorageService", "ProjectGroupingService", "$stateParams", function ($timeout, $http, $upload, $q, $rootScope, orderByFilter, Evaluator, QuestionSetService, PointListService, DataSheetsService, BillOfMaterialService, localStorageService, ProjectGroupingService, $stateParams) {
  var instance = {
    current: {
      spec: null,
      project: null,
      folder: null,
      navigation: null,
      fullNavigation: [],
      questionSet: null,
      questionSets: null,
      pointLists: [],
      dataSheets: [],
      boms: [],
      workingFiles: {},
      referredFiles: [],
      referredTags: [],
      referredPointLists: [],
      downloads: [],
      progress: {},
      menu: null,
      menuItem: null,
      readyToShow: false,
      nextLoading: false,
      showQuestions: false,
      answersPreview: {},
      page: "Questions",

      prev: function () {
        var self = this;
        var currentNav;
        var currentGroup;
        var prevGroup;

        // if prev clicked from menu page, get prev groups last label and navigate to it
        if (self.page === "MenuItems") {
          currentGroup = self.progress.navigationPath[0];

          for (var i = (self.navigation.length - 1); i > 0; i--) {
            currentNav = self.navigation[i];

            if (currentGroup.id === currentNav.id) {
              prevGroup = self.navigation[i - 1];

              $rootScope.$broadcast("qs:navigate:label", { label: prevGroup.children[prevGroup.children.length - 1] });
              self.nextLoading = false;
              return;
            }
          }
        }

        // check if prev group is menu
        // first check if we are leaving group
        var prevPage = self.questionSet.questions.pages[self.project.answers.pageIndex - 1];
        currentGroup = self.progress.navigationPath[0];

        if (!self.menuItem && prevPage && currentGroup && currentGroup.pages.indexOf(prevPage.id.toString()) === -1) {
          for (var i = (self.navigation.length - 1); i > 0; i--) {
            currentNav = self.navigation[i];

            if (currentGroup.id === currentNav.id) {
              prevGroup = self.navigation[i - 1];

              if (prevGroup && prevGroup.type === "Menu") {
                $rootScope.$broadcast("qs:navigate:menu", { id: prevGroup.id, tab: "menu" });
                self.nextLoading = false;
                return;
              }
            }
          }
        }

        // if it's last page go to previous qs
        if (self.project.answers.pageIndex <= 0) {
          self.goToPrevQuestionSet();
          return;
        }

        self.project.answers.pageIndex--;
      },

      next: function (step) {
        step = step || 1;
        var self = this;
        var currentNav;
        var currentGroup;
        var nextGroup;

        if (self.page === "MenuItems") {
          currentGroup = self.progress.navigationPath[0];

          for (var i = 0; i < self.navigation.length; i++) {
            currentNav = self.navigation[i];

            if (currentGroup.id === currentNav.id) {
              nextGroup = self.navigation[i + 1];

              var navs = self.navigation.slice(i + 1); // get navs the might be the next one

              for (var k = 0; k < navs.length; k++) {
                var nav = navs[k];

                if (nav.progress.total === nav.progress.reached) {
                  if (k + 1 === navs.length) {
                    nextGroup = navs[k];
                  }
                  continue;
                }
                else {
                  nextGroup = navs[k];
                  break;
                }
              }

              var gotoChild;

              for (var j = 0; j < nextGroup.children.length; j++) {
                var child = nextGroup.children[j];
                if (child.isDisabled) {
                  if (j == 0) {
                    gotoChild = nextGroup.children[0];
                  } else {
                    gotoChild = nextGroup.children[j - 1];
                  }
                  break;
                }
              }

              if (!gotoChild) {
                gotoChild = nextGroup.children.slice(-1)[0];
              }

              $rootScope.$broadcast("qs:navigate:label", {
                label: gotoChild,
                options: { updateVisited: true }
              });

              return;
            }
          }
        }

        // check if next group is menu
        // first check if we are leaving group
        var nextPage = self.questionSet.questions.pages[self.project.answers.pageIndex + 1];
        currentGroup = self.progress.navigationPath[0];

        if (!self.menuItem && nextPage && currentGroup && currentGroup.pages.indexOf(nextPage.id.toString()) === -1) {
          for (var i = 0; i < self.navigation.length; i++) {
            currentNav = self.navigation[i];

            if (currentGroup.id === currentNav.id) {
              nextGroup = self.navigation[i + 1];

              if (nextGroup && nextGroup.type === "Menu") {
                $rootScope.$broadcast("qs:navigate:menu", { id: nextGroup.id, tab: "menu" });
                self.nextLoading = false;
                return;
              }
            }
          }
        }

        // if it's menu's last page go to menu items page
        if (self.menuItem && self.project.answers.pageIndex === self.menu.pages.length - 1) {
          var savedMenuID = angular.copy(self.menu.id);

          // collapse current equipment
          _.remove(self.progress.expandedNodes, function (expEq) {
            if (expEq.id === self.menuItem.id) {
              expEq.exp = false;
              return true;
            } else return false;
          });

          // activate menu items tab
          $rootScope.$broadcast("qs:navigate:menu", { id: savedMenuID, tab: "Menu" });
          self.nextLoading = false;
          return;
        }

        // if it's last page go to previous qs
        if (self.project.answers.pageIndex >= (self.questionSet.questions.pages.length - 1)) {
          self.goToNextQuestionSet();
          return;
        }

        self.project.answers.pageIndex += step;
      },

      answers: function (menuItemID) {
        var self = this;

        // collect all existing answers array
        var response = angular.copy(self.progress.answers); // copy will not work because changes on it will not be stored later
        // var response = [];
        // self.progress.answers.forEach(function(oneAnswersSet){
        //  response.push(oneAnswersSet);
        // });

        // if menu item id exists include answers
        if (menuItemID && menuItemID.length && menuItemID.indexOf("_") > 0) {
          var menuID = menuItemID.split("_")[0];
          var menuAnswers = self.progress.answers && self.progress.answers.length ? self.progress.answers[0][menuID] : self.project.answers[menuID] || [];

          var answers = _.find(menuAnswers, function (item) {
            return item.id === menuItemID;
          });

          if (answers) response.push(answers);
        } else {
          response.push(self.project.answers);
        }

        return response;
      },

      setProjectVersion: function (value) {
        if (!value) return;
        this.project.version = value;
      },

      /*
      * sets this.questionSet
      * */
      switchToQuestionSet: function (qsID, resetPageIndex, checkLocation) {
        console.log("switching to qs", qsID);

        var self = this;

        if (resetPageIndex)
          self.project.answers.pageIndex = 0;

        // get question set by ID from question sets
        var qs = typeof qsID === "string" ? _.find(this.questionSets, function (item) {
          return item._id === qsID;
        }) : qsID;

        console.log("this menu is", this.menu, this.menuItem);
        if (this.menu && this.menuItem)
          this.goToPrevQuestionSet();

        // if (!self.project.answers.questionSets)
        //   this.goToPrevQuestionSet();

        // if doesn't exists add question set id into ongoings
        var currentQS = qs.questions ? qs.questions : qs;

        if (!self.project.answers.questionSets) self.project.answers.questionSets = [];
        if (self.project.answers.questionSets.indexOf(currentQS._id) < 0) {
          self.project.answers.questionSets.push(currentQS._id);
        }

        // if not exists, set current question set
        if (!this.questionSet) {

          this.questionSet = {
            questions: qs,
            menus: qs.menus
          };

          // initialize project progress if it's not restored from draft
          if (this.project.progress.total > 0) {
            this.declineInitProgress = true;
          } else {
            this.initializeProjectProgress();

          }

          this.updateNavigation();

          this.updateNavPath();
          this.initializeGroupsProgress();
          this.calculateGroupsProgress();
          this.updateFullProgress();

          return;
        }

        var fullPath = this.progress.questionSets.concat(
          [this.questionSet]
        ).concat(this.progress.questionSetsNext);

        var qsIndex = qs.questions ? fullPath.indexOf(qs) : -1;

        if (qsIndex < 0) {
          for (var i = 0; i < fullPath.length; i++) {
            var item = fullPath[i];

            if (item.questions._id === qs._id) {
              qsIndex = i;
              break;
            }
          }
        }

        if (qsIndex < 0) {

          // push current question set to backs
          this.progress.questionSets.push(this.questionSet);

          // set qs to current question set
          this.questionSet = {
            questions: qs.questions ? qs.questions : qs,
            menus: qs.menus
          };

          // empty next answers
          this.removeCurrentAnswers();

          // empty next
          this.progress.questionSetsNext = [];

          // initialize project progress if it's not restored from draft
          if (!self.declineInitProgress)
            self.initializeProjectProgress();

          delete self.declineInitProgress;

          this.updateNavigation();
          this.updateNavPath();
          this.updateFullProgress();

          if (checkLocation && this.project.location.menuItemID) {
            var menuItemIDArr = this.project.location.menuItemID.split("_");
            var menuID = menuItemIDArr[0];
            var itemID = this.project.location.menuItemID;

            var menu = _.find(this.questionSet.menus, function (m) {
              return m.id.toString() === menuID;
            });
            var menuAnswers = this.project.answers[menuID];
            var menuItem = _.find(menuAnswers, function (mItem) {
              return mItem.id.toString() === itemID;
            });

            this.editMenuItem(menu, menuItem);
          }

          return;
        }

        this.progress.questionSets = [];
        this.progress.questionSetsNext = [];

        for (var i = 0; i < fullPath.length; i++) {
          qs = fullPath[i];

          if (i == qsIndex) this.questionSet = qs;
          else if (i < qsIndex) this.progress.questionSets.push(qs);
          else if (i > qsIndex) this.progress.questionSetsNext.push(qs);
        }

        // do other fancy things...

        // set progress for current question set
        if (self.progress.info) {
          self.project.answers.progress.total = self.progress.info.total;
          self.project.answers.progress.reached = self.progress.info.reached;
        }

        this.readyToShow = false;

        this.updateNavigation();
        this.updateNavPath();
        this.updateFullProgress();
      },

      switchToMenu: function (menu) {
        // set current menu
        this.menu = menu;

        // push current question set to on going question sets
        this.progress.questionSets.push(this.questionSet);

        // set menu as current question set
        this.questionSet = {
          questions: menu,
          menus: []
        };
        this.readyToShow = false;
      },

      removeCurrentAnswers: function () {
        var self = this;

        self.progress.questionSetsNext.forEach(function (nextQs) {
          var qs = _.find(self.questionSets, function (item) {
            return item._id === nextQs.questions._id;
          });

          if (!qs) return;

          // remove question sets progress from project's progress
          self.project.progress.total -= self.progress.info.total;
          self.project.progress.reached -= self.progress.info.reached;

          // remove groups progress
          self.project.groupsProgress = {};

          // remove qsID from ongoing question sets
          var ongoingIndex = self.project.answers.questionSets.indexOf(qs._id);
          if (ongoingIndex >= 0) self.project.answers.questionSets.splice(ongoingIndex, 1);

          // reset answers progress
          self.project.answers.progress.total = 0;
          self.project.answers.progress.reached = 0;

          // remove all answers
          angular.forEach(qs.pages, function (page) {
            angular.forEach(page.questions, function (question) {
              // if menu has answers remove them progress form project's progress
              if (question.type === "Menu") {
                var menuItems = self.project.answers[question.id] || [];

                menuItems.forEach(function (item) {
                  self.project.progress.total -= item.progress.total;
                  self.project.progress.reached -= item.progress.reached;
                });
              }

              delete self.project.answers[question.id];
            });
          });
        });
      },

      updateNavigation: function () {
        var self = this;

        // copy question set navigation to project navigation
        self.navigation = self.questionSet.questions.navigation;

        // add menu items to menu nodes
        // copy menu.navigation to each item
        self.navigation.forEach(function (menu) {
          // expand groups
          var index = self.progress.expandedNodes.indexOf(menu);
          if (index < 0) self.progress.expandedNodes.push(menu);
          else self.progress.expandedNodes.splice(index, 1);
          menu.exp = !menu.exp;

          if (menu.type !== "Menu") return;

          if (menu.navigation && menu.navigation.length) menu.styles = menu.navigation[0].styles;
          var menuItems = self.project.answers[menu.id];
          menu.children = [];
          menu.isDisabled = false;

          if (menuItems) {
            menuItems.forEach(function (item) {
              var navItem = {
                id: item.id,
                name: item.name,
                type: "MenuItem",
                styles: menu.styles,
                children: angular.copy(menu.navigation),
                progress: item.progress
              };

              menu.children.push(navItem);
            });
          }
        });

      },

      updateHighlight: function () {
        var self = this;

        self.progress.navigationPath.forEach(function (node) {
          node.isSelected = true;

          if (!node.exp) {
            node.exp = true;
            self.progress.expandedNodes.push(node);
          }
        });
      },

      switchOffAllSelected: function () {
        this.progress.navigationPath.forEach(function (node) {
          node.isSelected = false;
        });
      },

      updateNavPath: function (isNext) {
        var self = this;

        if (isNext) self.updateVisitedLabels();

        var page = self.questionSet.questions.pages[self.project.answers.pageIndex];
        if (!page) return;
        var currentPagesLast = null;

        for (var i = page.questions.length; i > 0; i--) {
          var current = page.questions[i - 1];

          if (current.type !== "Menu") {
            currentPagesLast = current;
            break;
          }
        }

        if (!currentPagesLast) return;

        self.switchOffAllSelected();
        self.buildNavPath(currentPagesLast.id);
        self.updateHighlight();
      },

      buildNavPath: function (id, nodes) {
        var self = this;
        var node;

        if (!nodes) {
          nodes = self.navigation;
          self.progress.navigationPath = [];

          if (self.menuItem) {
            for (var i = 0; i < nodes.length; i++) {
              node = nodes[i];

              if (node.type === "Menu" && node.id.toString() === self.menu.id.toString()) {
                self.progress.navigationPath.push(node);

                for (var j = 0; j < node.children.length; j++) {
                  var childNode = node.children[j];

                  if (childNode.id.toString() === self.menuItem.id.toString()) {
                    self.progress.navigationPath.push(childNode);

                    nodes = childNode.children;
                    break;
                  }
                }

                if (self.progress.navigationPath === 2) break;
              }
            }
          }
        }

        for (var k = 0; k < nodes.length; k++) {
          node = nodes[k];

          self.progress.navigationPath.push(node);

          if (node.type === "Question" && node.id.toString() === id.toString()) {
            self.progress.navigationPath.done = true;
            self.progress.navigationPath.pop();
            return;
          } else if (node.children) {
            self.buildNavPath(id, node.children);
            if (self.progress.navigationPath.done) return;
          }

          self.progress.navigationPath.pop();
        }
      },

      menuNavPath: function (id) {
        var self = this;
        self.progress.navigationPath = [];
        var node;

        for (var k = 0; k < self.navigation.length; k++) {
          node = self.navigation[k];

          if (node.id && node.id.toString() === id.toString()) {
            self.progress.navigationPath.push(node);
            self.progress.navigationPath.done = true;
            break;
          }
        }
      },

      addMenuItemToNavigation: function (menuID, item) {
        for (var i = 0; i < this.navigation.length; i++) {
          var menu = this.navigation[i];

          if (menu.type === "Menu" && menu.id.toString() === menuID.toString()) {
            var navItem = {
              id: item.id,
              name: item.name,
              type: "MenuItem",
              styles: menu.styles,
              children: angular.copy(menu.navigation),
              progress: item.progress
            };

            menu.children.push(navItem);
            return;
          }
        }
      },

      createMenuItem: function (menu, name, switchToMenu, qas) {
        switchToMenu = switchToMenu !== undefined ? switchToMenu : true;
        var self = this;

        // if menu answers doesn't exist create it
        if (!self.project.answers[menu.id]) self.project.answers[menu.id] = [];

        // generate unique id for menu item, id contains parent menu id and if it's first item parentID+0 else parentID + incremented menu answers last item id by one
        var id = menu.id + "_";
        if (self.project.answers[menu.id].length)
          id += (parseInt(self.project.answers[menu.id][self.project.answers[menu.id].length - 1].id.split("_")[1]) + 1).toString();
        else id += "0";

        // create new menu item
        var menuItem = {
          name: name,
          id: id,
          pageIndex: 0,
          filteredTags: [],
          filteredPointLists: [],
          filteredFiles: [],
          progress: {
            total: menu.pages.length,
            reached: 0
          },
          labelsProgress: {
            groupIndex: 0,
            labelIndex: 0
          },
        };

        // increase project progress total
        self.project.progress.total += menuItem.progress.total;
        self.project.progress.reached += 1;

        // increase menu's progress
        self.project.groupsProgress[menu.id].total += menuItem.progress.total;
        self.project.groupsProgress[menu.id].reached += 2;

        // push it to menu answers
        self.project.answers[menu.id].push(menuItem);

        // add menu item to navigation
        self.addMenuItemToNavigation(menu.id, menuItem);

        // switch to menu

        if (switchToMenu) {
          self.switchToMenu(menu);

          // set menu item as current answers
          self.setMenuItem(menuItem);

          // activate questions tab

          $rootScope.$broadcast("qs:navigate:tab", { type: "Questions" });
        }

        console.log("menuitem is ", menuItem);

      },

      copyMenuItem: function (menu, item, name) {
        var self = this;

        // if menu answers doesn't exist create it
        if (!self.project.answers[menu.id]) self.project.answers[menu.id] = [];

        // generate unique id for menu item, id contains parent menu id and if it's first item parentID+0 else parentID + incremented menu answers last item id by one
        var id = menu.id + "_";
        if (self.project.answers[menu.id].length)
          id += (parseInt(self.project.answers[menu.id][self.project.answers[menu.id].length - 1].id.split("_")[1]) + 1).toString();
        else id += "0";

        // create menu item to new
        var menuItem = angular.copy(item);

        // set new id and name to copied item
        menuItem.id = id;
        if (name) menuItem.name = name;

        // increase project progress total
        self.project.progress.total += menuItem.progress.total;
        self.project.progress.reached += menuItem.progress.reached;

        // increase menu's progress
        self.project.groupsProgress[menu.id].total += menuItem.progress.total;
        self.project.groupsProgress[menu.id].reached += menuItem.progress.reached;

        // push it to menu answers
        self.project.answers[menu.id].push(menuItem);

        // add menu item to navigation
        self.addMenuItemToNavigation(menu.id, menuItem);

        // switch to menu
        self.switchToMenu(menu);

        // set menu item as current answers
        self.setMenuItem(menuItem);

        // activate questions tab
        $rootScope.$broadcast("qs:navigate:tab", { type: "Questions" });
      },

      editMenuItem: function (menu, item) {
        console.log("editing", item);

        var self = this;

        // switch to menu
        self.switchToMenu(menu);

        // set menu item as current answers
        self.setMenuItem(item);

        self.readyToShow = true;

        // if all questions are answered, then go to first page

        $rootScope.$broadcast("qs:navigate:tab", { type: "Questions" });

        if (item.progress.reached === item.progress.total) {
          item.pageIndex = 0;
        } else {
          if (item.progress.reached === 0) {
            $timeout(function () {
              self.next(2);
            });
          }

        }
        // $timeout(function () {
        //   self.next(item.progress.reached); // to to first unanswered question
        //
        // }, 0);

        // self.next(2)
      },

      setMenuItem: function (item) {
        this.menuItem = item;

        // store current item it to location
        this.project.location.menuItemID = item.id;

        this.progress.answers.push(this.project.answers);
        this.project.answers = item;
      },

      editMenuItemName: function (menuID, itemID, name) {
        var self = this;

        for (var i = 0; i < self.navigation.length; i++) {
          var group = self.navigation[i];

          if (group.type === "Menu" && group.id === menuID) {
            for (var j = 0; j < group.children.length; j++) {
              var item = group.children[j];

              if (item.id === itemID) {
                item.name = name;
                break;
              }
            }
          }
        }
      },

      deleteMenuItem: function (menuID, itemID) {
        var self = this;

        for (var i = 0; i < self.navigation.length; i++) {
          var group = self.navigation[i];

          if (group.type === "Menu" && group.id === menuID) {
            for (var j = 0; j < group.children.length; j++) {
              var item = group.children[j];

              if (item.id === itemID) {
                // remove item from tree
                group.children.splice(j, 1);

                // remove from answers
                self.project.answers[menuID].splice(j, 1);

                // remove from project progress
                self.project.progress.total -= item.progress.total;
                self.project.progress.reached -= item.progress.reached;

                // remove from project group's progress
                self.project.groupsProgress[group.id].total -= item.progress.total;
                self.project.groupsProgress[group.id].reached -= item.progress.reached;
                self.project.groupsProgress[group.id].lastPage = "";

                break;
              }
            }
          }
        }
      },

      refreshNavigation: function () {
        var self = this;

        if (!self.navigation || !self.navigation.length) return;

        var menuNode = null;
        var nextGroup;
        var answers;

        self.navigation.forEach(function (groupNode, index) {
          if (groupNode.type === "Menu") {
            menuNode = groupNode;

            var baseAnswers = self.menuItem ? self.progress.answers[0] : self.project.answers;

            menuNode.isDisabled = self.page === "MenuItems" ? false : (!baseAnswers[menuNode.id] || !baseAnswers[menuNode.id].length);
            if (baseAnswers.labelsProgress.groupIndex >= index) menuNode.isDisabled = false;
            var prev = self.navigation[index - 1];
            if (prev) {
              if (prev.children && prev.children[prev.children.length - 1].isDisabled) menuNode.isDisabled = true;
            }

            for (var i = 0; i < groupNode.children.length; i++) {
              var menuItemNode = groupNode.children[i];
              menuItemNode.isDisabled = menuNode.isDisabled;

              answers = _.find(baseAnswers[groupNode.id], function (item) {
                return item.id === menuItemNode.id;
              });

              if (!answers) return;

              nextGroup = answers.labelsProgress.groupIndex > index;

              menuItemNode.children.forEach(function (labelNode, labelIndex) {
                var val = nextGroup ? false : answers.labelsProgress.labelIndex < labelIndex;
                labelNode.isDisabled = menuItemNode.isDisabled || val;

                for (var i = 0; i < labelNode.children.length; i++) {
                  var question = labelNode.children[i];

                  if (self.displayQuestion(question, menuItemNode.id)) {
                    labelNode.isHided = false;
                    break;
                  }

                  labelNode.isHided = i === labelNode.children.length - 1;
                }
              });
            }
          } else {
            answers = !self.menu ? self.project.answers :
              self.progress.answers[self.progress.answers.length - 1];

            groupNode.isDisabled = answers.labelsProgress.groupIndex < index;

            nextGroup = answers.labelsProgress.groupIndex > index;

            groupNode.children.forEach(function (labelNode, labelIndex) {
              var val = groupNode.isDisabled ? true : nextGroup ? false : (answers.labelsProgress.labelIndex < labelIndex);
              labelNode.isDisabled = val;

              for (var i = 0; i < labelNode.children.length; i++) {
                var question = labelNode.children[i];

                if (self.displayQuestion(question)) {
                  labelNode.isHided = false;
                  break;
                }

                labelNode.isHided = i === labelNode.children.length - 1;
              }
            });
          }
        });
      },

      updateVisitedLabels: function () {
        var self = this;
        var page = self.questionSet.questions.pages[self.project.answers.pageIndex];
        if (!page) return;
        var currentPageLastQuestion = page.questions[page.questions.length - 1];

        for (var i = 0; i < self.navigation.length; i++) {
          var group = self.navigation[i];

          if (group.type === "Menu") {
            if (self.menuItem) {
              for (var k = 0; k < group.children.length; k++) {
                var menuItem = group.children[k];

                for (var x = 0; x < menuItem.children.length; x++) {
                  var menuLabel = menuItem.children[x];

                  for (var p = 0; p < menuLabel.children.length; p++) {
                    var question = menuLabel.children[p];

                    if (question.id.toString() === currentPageLastQuestion.id.toString()) {
                      var oldGroupIndex = angular.copy(self.project.answers.labelsProgress.groupIndex);

                      if (k > self.project.answers.labelsProgress.groupIndex)
                        self.project.answers.labelsProgress.groupIndex = k;
                      if (k >= oldGroupIndex && x > self.project.answers.labelsProgress.labelIndex)
                        self.project.answers.labelsProgress.labelIndex = x;

                      return;
                    }
                  }
                }
                // }
              }
            }
          } else {
            for (var j = 0; j < group.children.length; j++) {
              var label = group.children[j];

              for (var n = 0; n < label.children.length; n++) {
                var currentQuestion = label.children[n];

                if (currentQuestion.id.toString() === currentPageLastQuestion.id.toString()) {
                  var oldGroupIndex = angular.copy(self.project.answers.labelsProgress.groupIndex);

                  if (i > self.project.answers.labelsProgress.groupIndex)
                    self.project.answers.labelsProgress.groupIndex = i;
                  if (i >= oldGroupIndex && j > self.project.answers.labelsProgress.labelIndex)
                    self.project.answers.labelsProgress.labelIndex = j;

                  return;
                }
              }
            }
          }
        }
      },

      loadWorkingFile: function () {
        var self = this;

        // update referred items
        self.referredFiles = QuestionSetService.filesByPages(self.questionSet.questions.pages, self.spec);
        self.referredTags = QuestionSetService.tagsByPages(self.questionSet.questions.pages, self.spec);
        self.referredPointLists = QuestionSetService.pointListsByPages(self.questionSet.questions.pages, self.spec);

        // get current questionSet/menu ID
        var currentID = self.menu ? self.menu.id : self.questionSet.questions._id;

        // fetch current files
        var current = self.workingFiles[currentID];

        // if exists set it to current working files and stop function executing
        if (current) {
          addToCurrent(current);
          return;
        }

        // if not exists current fetch from server
        var data = {
          PointList: PointListService.namesByPages(self.questionSet.questions.pages),
          DataSheet: DataSheetsService.namesByPages(self.questionSet.questions.pages),
          BillOfMaterial: BillOfMaterialService.namesByPages(self.questionSet.questions.pages)
        };

        return $q(function (resolve) {
          $http.post("/api/specs/" + self.spec._id + "/files", data).then(function (response) {
            // normalize working files
            var result = QuestionSetService.normalizeWorkingFiles(self.questionSet.questions.pages, response.data);

            // save into cache
            self.workingFiles[currentID] = result;

            // set to current fils
            addToCurrent(result);

            // recalculate data sheets for first load
            self.recalculateDataSheets(true);

            resolve();
          });
        });

        function addToCurrent(items) {
          for (var key in items) {
            var item = items[key];

            switch (key) {
              case "PointList":
                self.pointLists = angular.copy(item);
                break;

              case "DataSheet":
                self.dataSheets = angular.copy(item);
                break;

              case "BillOfMaterial":
                self.boms = angular.copy(item);
                break;
            }
          }
        }
      },

      updateReferredAndTags: function () {
        var self = this;
        var answers = this.answers();

        // process referred files
        self.project.answers.filteredFiles.length = 0; // empty array preserving original reference
        self.referredFiles.forEach(function (file) {
          if (Evaluator.evaluate(answers, file.controlLogic))
            self.project.answers.filteredFiles.push(file);
        });

        // process referred tags
        self.project.answers.filteredTags.length = 0; // empty array preserving original reference
        self.referredTags.forEach(function (tag) {
          if (Evaluator.evaluate(answers, tag.controlLogic)) {
            self.project.answers.filteredTags.push(tag);
          }
        });

        // process referred point lists
        self.project.answers.filteredPointLists = self.project.answers.filteredPointLists || [];
        self.project.answers.filteredPointLists.length = 0; // empty array preserving original reference
        self.referredPointLists.forEach(function (pl) {
          if (Evaluator.evaluate(answers, pl.controlLogic)) {
            self.project.answers.filteredPointLists.push(pl);
          }
        });

        self.answersPreview = angular.toJson(self.project.answers, true);
      },

      goToPrevQuestionSet: function () {
        var self = this;

        // remove last entries from navigation stacks
        if (!self.menu) {
          // save next question sets answers progress
          self.saveLatestProgressInfo();

          var lastQS = self.progress.questionSets[self.progress.questionSets.length - 1];
          self.switchToQuestionSet(lastQS, true);

          // set previous question sets answers progress
          self.project.answers.progress.total = self.questionSet.questions.pages.length;
          self.project.answers.progress.reached = self.questionSet.questions.pages.length;

          return;
        }

        if (self.progress.answers.length)
          self.project.answers = self.progress.answers.pop();

        self.questionSet = self.progress.questionSets.pop();

        // save menu id before set menu null to activate Menu tab
        var menuID = angular.copy(self.menu.id);

        self.menu = null;
        self.menuItem = null;

        self.project.location.menuItemID = null;

        self.updateNavPath();
        // $rootScope.$broadcast('qs:navigate:tab', { type : 'Menu', id: menuID});

        self.readyToShow = false;
      },

      goToNextQuestionSet: function () {
        // remove last entries from navigation stacks
        if (!this.menu && this.progress.questionSetsNext.length) {
          var nextQS = this.progress.questionSetsNext[0];
          this.switchToQuestionSet(nextQS, true);
        }
      },

      saveLatestProgressInfo: function () {
        var self = this;

        // save latest progress info
        self.progress.info = {
          total: self.project.answers.progress.total,
          reached: self.project.answers.progress.reached
        };
      },

      setCurrentQuestionSet: function () {
        var self = this;

        // check if we have ongoing question sets
        var length = self.project.answers.questionSets.length;
        // if we have more than main question set into ongoing then set it to current
        if (length > 1) {
          var current = self.project.answers.questionSets[length - 1];

          self.switchToQuestionSet(current, false, true, true);
        }
      },

      initializeProjectProgress: function () {
        var self = this;

        // initialize project progress total
        self.project.progress.total += self.questionSet.questions.pages.length;

        // increment with 1 project progress reached
        self.project.progress.reached += 1;

        // init answers progress
        self.project.answers.progress.total = self.questionSet.questions.pages.length;
        self.project.answers.progress.reached = 1;
      },

      initializeGroupsProgress: function () {
        var self = this;

        if (!self.navigation) return;

        if (!self.project.groupsProgress) self.project.groupsProgress = {};

        self.navigation.forEach(function (item) {
          if (self.project.groupsProgress[item.id]) {
            item.progress = self.project.groupsProgress[item.id];
            return;
          }

          self.project.groupsProgress[item.id] = {
            total: item.type !== "Menu" ? item.pages.length : 0,
            reached: 0,
            lastPage: ""
          };

          item.progress = self.project.groupsProgress[item.id];
        });
      },

      calculateGroupsProgress: function (value, prev) {
        var self = this;
        var pages = self.questionSet.questions.pages;
        var page = pages[self.project.answers.pageIndex];
        var inc = value && prev ? value - prev : 1;

        if (!page) return;

        self.navigation.forEach(function (item) {
          if (item.pages.indexOf(page.id.toString()) >= 0) {
            var lastPage = self.menuItem ? (self.menuItem.progress.lastPage || 0) : self.project.groupsProgress[item.id].lastPage;

            if (lastPage === page.id) return;
            if (lastPage && item.pages.indexOf(lastPage.toString()) > item.pages.indexOf(page.id.toString())) return;
            if (self.project.groupsProgress[item.id].total === self.project.groupsProgress[item.id].reached) return;
            if (item.type === "Menu" && !self.menuItem) return;

            self.project.groupsProgress[item.id].reached += inc;
            self.project.groupsProgress[item.id].lastPage = item.pages[self.project.groupsProgress[item.id].reached - 1];
            if (self.menuItem) self.menuItem.progress.lastPage = page.id;
          }
        });
      },

      setCurrentGroupProgress: function (nav, value) {
        var self = this;
        var pages = self.questionSet.questions.pages;
        var page = pages[self.project.answers.pageIndex];
        if (!page) return;
        var pageIndex = nav.pages.indexOf(page.id.toString());

        if (pageIndex === -1) return;

        nav.progress.reached = pageIndex + (self.menuItem ? 1 : 2);
        nav.progress.lastPage = page.id;
        if (self.menuItem) self.menuItem.progress.lastPage = page.id;
      },

      recalculateGroupProgress: function (id, value) {
        var self = this;
        value.total = 0;
        value.reached = 0;

        var eqs = self.project.answers[id] || [];

        eqs.forEach(function (eq) {
          value.total += eq.progress.total;
          value.reached += eq.progress.reached;
        });
      },

      updateFullProgress: function () {
        var self = this;
        self.fullNavigation = [];
        var full = [];

        full = full.concat(self.progress.questionSets).concat([self.questionSet]).concat(self.progress.questionSetsNext);

        full.forEach(function (item) {
          if (item.questions && item.questions.navigation) {
            item.questions.navigation.forEach(function (nav) {
              nav.questionSetID = item.questions._id;

              self.fullNavigation.push(nav);
            });
          }
        });
      },

      resetNextAnswers: function (question, answer) {
        var self = this;
        var answeredQuestionID = parseInt(question.id) || null;
        var answeredQuestionIndex = self.getQuestionIndex(question);
        var removeAll = false;
        var currentPage = null;
        var questionID = null;
        var updateNextNavigation = false;

        if (!answeredQuestionID) return;

        self.questionSet.questions.pages.forEach(function (tmpPage) {
          tmpPage.questions.forEach(function (tmpQs) {
            var tmpQsID = parseInt(tmpQs.id) || 0;
            var tmpQsIndex = self.getQuestionIndex(tmpQs);

            if (!questionID && tmpQsIndex > answeredQuestionIndex && tmpQs.controlLogic) {
              if (tmpQs.controlLogic.indexOf(answeredQuestionID) !== -1) {
                questionID = tmpQsID;
                currentPage = tmpPage;
              }
            }

            if (!updateNextNavigation) {
              tmpQs.answers.forEach(function (tmpAnswer) {
                if (tmpAnswer.actionType === "Questionnaire" && tmpAnswer.controlLogic && tmpAnswer.controlLogic.indexOf(answeredQuestionID) !== -1) {
                  updateNextNavigation = true;
                }
              });
            }
          });
        });

        // return if there are no changes
        if (!questionID && !updateNextNavigation) return;

        if (updateNextNavigation) {
          self.progress.questionSetsNext.forEach(function (item) {
            item.questions.navigation.forEach(function (navGroup) {
              navGroup.isDisabled = true;
              navGroup.children.forEach(function (navLabel) {
                navLabel.isDisabled = true;
              });
            });
          });
        }

        if (questionID) {
          var questionGlobalIndex = self.getQuestionIndex(questionID);

          Object.getOwnPropertyNames(self.project.answers).forEach(function (answerKey, index) {
            var answer = self.project.answers[answerKey];
            var currentQsID = parseInt(answerKey) || null;

            var currentQsGlobalIndex = self.getQuestionIndex(currentQsID);

            if (removeAll) {
              if (currentQsID && !isMenuID(currentQsID)) delete self.project.answers[answerKey];
              else removeAdditional();
            } else {
              if (currentQsID && currentQsGlobalIndex >= questionGlobalIndex) {
                if (!isMenuID(currentQsID)) {
                  delete self.project.answers[answerKey];
                  // removeAll = true;
                }
              }
            }
          });

          $rootScope.$broadcast("qs:refresh:ui");

          var disable = false;
          var currentGroup = null;

          for (var i = 0; i < self.progress.navigationPath.length; i++) {
            var group = self.progress.navigationPath[i];

            if (group.pages && group.pages.indexOf(currentPage.id.toString()) !== -1) {
              currentGroup = group;
              break;
            }
          }

          if (!currentGroup) return;

          self.updateVisitedLabels();
          self.refreshNavigation();
        }

        function isMenuID(id) {
          return _.find((self.questionSet.menus || []), function (item) {
            return item.id === id;
          });
        }

        function removeAdditional() {
          self.project.answers.filteredFiles.length = 0;
          self.project.answers.filteredTags.length = 0;
          self.project.answers.filteredPointLists.length = 0;
          self.project.answers.answerTextsOverride = {};
        }
      },

      recalculateDataSheets: function (firstLoad) {
        var self = this;
        var answers = self.answers();
        self.progress.dataSheetsCount = 0;

        (self.dataSheets || []).forEach(function (item) {
          if (!Evaluator.evaluate(answers, item.question.controlLogic)) return;

          item.value.sheets.forEach(function (sheet) {
            if (Evaluator.evaluate(answers, sheet.controlLogic))
              self.progress.dataSheetsCount++;
          });

          var dataSheet = item.value;

          // if it's first run create answers object
          if (!self.project.answers[item.question.id]) {
            self.project.answers[item.question.id] = {
              sheets: [],
              legends: [],
              unChecked: {}
            };

            for (var key in dataSheet.legend) {
              var value = dataSheet.legend[key];

              if (value.preSelected && self.project.answers[item.question.id].legends.indexOf(key) === -1)
                self.project.answers[item.question.id].legends.push(key);
            }
          }

          if (self.project.answers[item.question.id] && !self.project.answers[item.question.id].unChecked) self.project.answers[item.question.id].unChecked = {};
          if (self.project.answers[item.question.id] && !self.project.answers[item.question.id].handChecked) self.project.answers[item.question.id].handChecked = {};

          angular.forEach(dataSheet.sheets, function (sheet) {
            // if sheet has not preSelected or it's not able to show by controlLogic or not able to check with preSelect then return
            if (!sheet.preSelected || !Evaluator.evaluate(answers, sheet.controlLogic)) return;

            var needRemove = !Evaluator.evaluate(answers, sheet.preSelected);
            var isHandChecked = self.project.answers[item.question.id].handChecked[sheet.id];

            if (!isHandChecked && needRemove) {
              var index = self.project.answers[item.question.id].sheets.indexOf(sheet.id);

              if (index >= 0) {
                self.project.answers[item.question.id].sheets.splice(index, 1);
              } else return;

              for (var flKey in sheet.fileReferences) {
                var tmpFile = sheet.fileReferences[flKey];
                self.removeFromDownloads(tmpFile);
              }

              return;
            } else if (isHandChecked) return;

            var currentLegends = self.project.answers[item.question.id].legends || [];

            currentLegends.forEach(function (legend) {
              var file = sheet.fileReferences[legend];

              if (file) {
                if (self.project.answers[item.question.id].unChecked[sheet.id]) {
                  self.removeFromDownloads(file);
                  return;
                }

                file.isStaticFile = true;
                file.path = "DataSheets/" + file.name;

                // if sheet doesn't exists add it to selected sheets
                if (self.project.answers[item.question.id].sheets.indexOf(sheet.id) === -1) {
                  self.project.answers[item.question.id].sheets.push(sheet.id);
                  self.addToDownloads(file, true);
                } else { // else remove
                  self.addToDownloads(file, true);
                }
              }
            });
          });
        });

        // recalculate count in downloads
        self.recalculateDownloadDataSheetsCount();
      },

      recalculateDownloadDataSheetsCount: function () {
        var self = this;
        self.progress.checkedDataSheetsCount = 0;

        for (var key in self.project.answers) {
          var val = self.project.answers[key];

          if (val.sheets && Array.isArray(val.sheets)) self.progress.checkedDataSheetsCount += val.sheets.length;
        }
      },

      addToDownloads: function (file, stay) {
        var needProcessing = {
          "Specification": true,
          "Sequence": true,
          "Compliance": true,
          "Consistency": true
        };
        var self = this;

        var processFile = _.find(self.downloads, function (item) {
          return file.path === item.path;
        });

        if (!processFile) {
          self.downloads.push({
            id: file.historyID,
            url: file.url,
            name: file.name,
            path: file.path,
            menuID: file.menuID,
            needProcess: needProcessing[file.type],
            isStaticFile: file.isStaticFile,
            isExternalFile: file.isExternalFile
          });
        } else if (!stay) {
          _.remove(self.downloads, function (item) {
            return item.id === file.historyID;
          });
        }
      },

      removeFromDownloads: function (file) {
        var self = this;

        _.remove(self.downloads, function (item) {
          return item.id === file.historyID;
        });
      },

      // filters
      displayQuestion: function (question, menuItemID) {
        var self = instance.current;

        return Evaluator.evaluate(self.answers(menuItemID), question.controlLogic);
      },

      preCheck: function (precheck) {
        var self = instance.current;

        if (precheck) return Evaluator.evaluate(self.answers(), precheck);
        else return false;
      },

      getQuestionIndex: function (q) {
        return getQuestionGlobalIndex(instance.current.questionSet, instance.current.project.specConfigID, q);
      },

      getQuestionsAfter(q) {
        return getAllQuestionsAfter(instance.current.questionSet, instance.current.project.specConfigID, q);
      }
    },

    create: function (data) {
      return $q(function (resolve) {
        $http.post("/api/project", data).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    addExcludedPoint: function (point) {
      return $http.put("api/project/excluded-points/", { _id: point._id, projectId: instance.current.project._id });
    },

    removeExcludedPoint: function (point) {
      return $http.delete("api/project/excluded-points/" + point._id + "/" + instance.current.project._id);
    },

    removeExcludedPoints: function (pointsArray) {
      return $http.post("api/project/excluded-points/many", {
        points: pointsArray.map(function (point) {
          return point._id;
        }),
        projectId: instance.current.project._id
      });
    },

    update: function (id, data) {
      return $http.put("/api/project/" + id + "/update", data);
    },

    save: function (projectData, asNew) {
      console.log("saving project", projectData);

      var data = {
        results: projectData,
        saveAsNew: asNew,
        override: projectData.override,
        version: instance.current.project.version
      };

      return $http.put("/api/project", data);
    },

    saveDraft: function (override) {
      var self = this;

      // if it is menu save main answers
      var toSave = self.current.menuItem ? self.current.progress.answers[0] : self.current.project.answers;

      var data = {
        id: self.current.project._id,
        specConfigID: self.current.spec._id,
        answers: toSave,
        location: self.current.project.location,
        progress: self.current.project.progress,
        groupsProgress: self.current.project.groupsProgress,
        override: override
      };

      return instance.save(data);
    },

    copy: function (id, name) {
      var data = {
        name: name,
        folderId: $stateParams.folderId
      };
      return $http.put("/api/project/" + id + "/copy", data);
    },

    rename: function (id, name) {
      var data = {
        name: name
      };

      return $http.put("/api/project/" + id + "/rename", data);
    },

    invite: function () {
      return $http.get("/api/admin/users");
    },

    shareToUsers: function (project, userIds, flag) {
      return $http.post("/api/project/" + project._id, { userIds, flag });
    },

    getSharedNotification: function (notification) {
      return $http.post(BASE_URL_NOTIFICATION + "/send-email", notification);
    },

    getSpecHistory: function (id) {
      return $http.get("/api/project-change-log/" + id);
    },

    getDetailedHistory: function (id) {
      return $http.get("/api/project-change-log/details/" + id);
    },

    delete: function (id, folderId) {

      return $q(function (resolve) {
        $http.delete("/api/project/" + id + "/" + folderId).then(function (response) {
          return resolve(response);
        });
      });
    },

    adminDelete: function (userId, folderId, projectId) {
      return $q(function (resolve) {
        $http.delete("/api/project/" + userId + "/" + folderId + "/" + projectId).then(function (response) {
          return resolve(response);
        });
      });
    },

    fetch: function (id) {
      var self = this;
      self.current.progress = {
        questionSets: [],
        questionSetsNext: [],
        answers: [],
        navigationPath: [],
        expandedNodes: []
      };

      return $q(function (resolve) {
        if (self.current.project && self.current.project._id === id)
          return resolve();

        $http.get("/api/project/" + id).then(function (response) {
          self.current.project = response.data;

          $http.get("/api/specs/" + response.data.specConfigID).then(function (response) {
            var spec = response.data;

            // order history on load so we don't need to sort it every time when we need it.
            spec.history = orderByFilter(spec.history, "-uploaded");

            // create files property with actual files that can be referrenced like spec.files[fileType][refID]
            spec.files = {};

            angular.forEach(spec.history, function (file) {
              // initialize type property if not exists
              spec.files[file.entity] = spec.files[file.entity] || {};

              // set file if it is first occurrence
              if (!spec.files[file.entity][file.refID]) {
                spec.files[file.entity][file.refID] = file;
              }
            });

            self.current.spec = spec;

            $http.get("/api/questions/spec/" + self.current.spec._id).then(function (response) {
              self.current.questionSets = response.data.questionSets;

              ProjectGroupingService.folderByProjectId(id).then(function (folder) {
                // set entry question set as current
                self.current.switchToQuestionSet(response.data.entryQuestionSet, false, true, true);
                self.current.folder = folder;
                resolve();
              });
            });
          });
        });
      });
    },

    load: function () {
      return $q(function (resolve) {
        $http.get("/api/project/").then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadBySpec: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/project/load/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadByProduct: function (product) {
      return $q(function (resolve) {
        $http.get("/api/project/load/product/" + product).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchById: function (id) {
      return $q(function (resolve) {
        $http.get("/api/project/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    loadShared: function (userId) {
      return $q(function (resolve) {
        $http.get("/api/project-grouping/projects/" + userId).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    leaveSpecTeam: function (projectId) {
      return $q(function (resolve) {
        $http.put("/api/project/" + projectId + "/leave").then(function (response) {
          return resolve(response.data);
        });
      });
    }

  };

  return instance;
}]);

"use strict";

app.controller("SaveConflictCtrl", ["$scope", "$modalInstance", "ProjectService", "CreateProjectDialog", "options", function ($scope, $modalInstance, ProjectService, CreateProjectDialog, options) {
  $scope.current = ProjectService.current;
  $scope.options = options;

  $scope.useMine = function () {
    var result = {
      code: 1
    };

    $modalInstance.close(result);
  };

  $scope.useNewer = function () {
    var result = {
      code: 2
    };

    $modalInstance.close(result);
  };

  $scope.saveAsCopy = function () {
    var dialogOptions = {
      spec: $scope.current.spec,
      project: $scope.current.project,
      isCopy: true
    };

    CreateProjectDialog.open(dialogOptions).then(function (result) {
      result.code = 3;

      $modalInstance.close(result);
    });
  };

  $scope.drop = function () {
    var result = {
      code: 4
    };

    $modalInstance.close(result);
  };

  $scope.reSave = function () {
    var result = {
      code: 5
    };

    $modalInstance.close(result);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };
}]);

"use strict";

app.service("SaveConflictDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/project/save-conflict/save-conflict.html",
      controller: "SaveConflictCtrl",
      size: "md",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };
}]);

"use strict";

app.directive("help", ["Evaluator", "ProjectService", "Auth", function (Evaluator, ProjectService, Auth) {
  return {
    restrict: "E",
    templateUrl: "components/question-sets/help/help.html",

    scope: {
      item: "=item"
    },

    link: function (scope) {}
  };
}]);

"use strict";

app.controller("MenuExternalCopyCtrl", ["$scope", "$modalInstance", "names", "projects", function ($scope, $modalInstance, names, projects) {
  $scope.names = names || [];
  $scope.projects = projects || [];
  $scope.menuItems = [];
  $scope.select = {};

  $scope.projectChanged = function () {
    $scope.menuItems = [];
    $scope.menuItem = null;
    $scope.select.item = "";

    if (!$scope.select.project) return;

    var project = _.find($scope.projects, function (item) {
      return item._id === $scope.select.project;
    });

    if (!project) return;

    for (var key in project.answers) {
      var value = project.answers[key];

      if (!Array.isArray(value)) continue;

      for (var i = 0; i < value.length; i++) {
        var current = value[i];

        if (current.name && current.id.indexOf("_") > 0) {
          $scope.menuItems = $scope.menuItems.concat(value);
          break;
        }
      }
    }
  };

  $scope.itemChanged = function () {
    if (!$scope.select.item) {
      $scope.menuItem = null;
      return;
    }

    $scope.menuItem = angular.copy(_.find($scope.menuItems, function (item) {
      return item.id === $scope.select.item;
    }));
  };

  $scope.save = function () {
    if ($scope.disableSave()) return;

    $modalInstance.close($scope.menuItem);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.disableSave = function () {
    $scope.hasError = false;

    if (!$scope.select.project || !$scope.menuItem) return true;
    if (!$scope.menuItem.name) return true;

    if ($scope.names.indexOf($scope.menuItem.name) >= 0) {
      $scope.hasError = true;
      return true;
    }
  };
}]);

"use strict";

app.service("MenuExternalCopyDialog", ["$modal", function ($modal) {
  this.open = function (names, projects) {
    return $modal.open({
      templateUrl: "components/question-sets/menu-copy-external/menu-copy-external.html",
      controller: "MenuExternalCopyCtrl",
      size: "md",
      resolve: {
        names: function () { return names; },
        projects: function () { return projects; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("MenuNameCtrl", ["$scope", "$modalInstance", "name", "names", function ($scope, $modalInstance, name, names) {
  $scope.name = name;
  $scope.names = names || [];

  $scope.save = function () {
    if ($scope.disableSave()) return;

    $modalInstance.close($scope.name);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  $scope.disableSave = function () {
    $scope.hasError = false;

    if (!$scope.name) return true;

    if ($scope.names.indexOf($scope.name) >= 0) {
      $scope.hasError = true;
      return true;
    }
  };

  $scope.resetErrors = function () {
    $scope.hasError = false;
  };
}]);

"use strict";

app.service("MenuNameDialog", ["$modal", function ($modal) {
  this.open = function (name, names) {
    return $modal.open({
      templateUrl: "components/question-sets/menu-name/menu-name.html",
      controller: "MenuNameCtrl",
      size: "md",
      resolve: {
        name: function () { return name; },
        names: function () { return names; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("QuestionSetDirectiveCtrl", ["$scope", "Confirm", "ProjectService", "PointListService", "DataSheetsService", function ($scope, Confirm, /* MenuCreateDialog,*/ ProjectService, PointListService, DataSheetsService) {
  $scope.current = ProjectService.current;

  $scope.nodeSelected = function (node) {
    if (!$scope.baseQuestionSet) $scope.baseQuestionSet = angular.copy($scope.questionSet);

    $scope.questionSetTree.nodeSelected(node);

    if (node.type === "questionSet") $scope.switchQuestionSet();
  };

  $scope.createMenu = function (id) {
    var menu = getMenu(id);
    $scope.switchQuestionSet(menu);

    /* MenuCreateDialog.open(menu, null, $scope.questionSet).then(function(result){
      if(!$scope.model[$scope.question.id]) $scope.model[$scope.question.id] = [result];
      else $scope.model[$scope.question.id].push(result);

      $scope.menus.push(result);
    });*/
  };

  $scope.switchQuestionSet = function (questionSet) {
    $scope.isMenu = questionSet || false;
    $scope.questionSet = questionSet || $scope.baseQuestionSet;

    $scope.pointLists = PointListService.loadByPages($scope.questionSet.pages, $scope.baseQuestionSet.specConfigID);
    $scope.dataSheets = DataSheetsService.loadByPages($scope.questionSet.pages, $scope.baseQuestionSet.specConfigID);
  };

  $scope.deleteMenu = function (item) {
    Confirm.open("Are you sure you want to delete menu results?", "Delete Menu", "md").then(
      function (result) {
        if (!result) return;
        $scope.menus.splice($scope.menus.indexOf(item), 1);
        $scope.current.project.answers[$scope.question.id].splice($scope.current.project.answers[$scope.question.id].indexOf(item), 1);
      }
    );
  };

  // $scope.editMenu = function(item){
  //  var menu = getMenu($scope.question.id);
  //  var menuAnswers = getMenuAnswers($scope.question.id, item.name);
  //
  //  MenuCreateDialog.open(menu, menuAnswers, $scope.questionSet).then(function(result){
  //    $scope.current.project.answers[$scope.question.id][$scope.current.project.answers[$scope.question.id].indexOf(item)] = result;
  //    $scope.menus[$scope.menus.indexOf(item)] = result;
  //  });
  // };

  function getMenu(id) {
    var menu = null;
    angular.forEach($scope.questionSet.menus, function (item) {
      if (item.id === id)
        menu = angular.copy(item);
    });
    return menu;
  }

  function getMenuAnswers(id, name) {
    var menu = null;
    angular.forEach($scope.current.project.answers[id], function (item) {
      if (item.name === name)
        menu = angular.copy(item);
    });
    return menu;
  }
}]);

"use strict";

app.directive("questionSet", ["$log", "$http", "$stateParams", "$location", "$window", "$rootScope", "$timeout", "$interval", "Auth", "Utils", "Evaluator", "Confirm", "SpecConfigService", "QuestionSetService", "PointListService", "DataSheetsService", "SaveProjectDialog", "CreateProjectDialog", "ProjectService", "BillOfMaterialService", "MenuNameDialog", "OfficePreviewDialog", "SaveConflictDialog", "MenuExternalCopyDialog", function (
  $log,
  $http,
  $stateParams,
  $location,
  $window,
  $rootScope,
  $timeout,
  $interval,
  Auth,
  Utils,
  Evaluator,
  Confirm,
  SpecConfigService,
  QuestionSetService,
  PointListService,
  DataSheetsService,
  SaveProjectDialog,
  CreateProjectDialog,
  ProjectService,
  BillOfMaterialService,
  MenuNameDialog,
  OfficePreviewDialog,
  SaveConflictDialog,
  MenuExternalCopyDialog
) {
  return {
    restrict: "E",
    templateUrl: "components/question-sets/question-set.html",

    scope: {},

    link: function (scope) {
      var skipSave = false;
      var isDirty = false;

      scope.current = ProjectService.current;
      scope.user = Auth.getCurrentUser();

      $interval(function () {
        if (!isDirty || skipSave) return;
        saveDraft();
      }, 1000);

      scope.current = ProjectService.current;

      // user access filter
      if (!Auth.hasAccess(scope.current.project)) {
        scope.current.navigation = scope.current.navigation.filter(navItem => scope.current.questionSet.questions.userAccess.some(a => a.id === navItem.id));
        scope.current.fullNavigation = scope.current.navigation;
        let filteredPages = [...scope.current.navigation.flatMap(nav => nav.pages.map(p => parseInt(p)))];
        scope.current.questionSet.questions.pages = scope.current.questionSet.questions.pages.filter(p => filteredPages.includes(p.id));
      }

      scope.isAdmin = Auth.isAdmin;
      scope.filtered = {};

      var firstLoad = true;

      // back-next flags
      scope.disableBackBtn = false;
      scope.disableNextBtn = false;

      scope.drawingQuestion = {};

      scope.treeOptions = {
        dirSelectable: false
      };

      scope.$on("answerSelected", function (e, answer) {
        if (!answer) return;

        switch (answer.actionType) {
          case "Questionnaire":
            ProjectService.current.questionSets.forEach(function (item) {
              if (item.name.toLowerCase() === answer.fileFunction.toLowerCase()) {
                ProjectService.current.switchToQuestionSet(item._id, true);
              }
            });
            break;
        }
      });

      scope.save = function () {
        $rootScope.$broadcast("qs:save");
      };

      // watch question set changes to update working files and resources and tags (first time)
      scope.$watch("current.questionSet", function (val) {
        if (!val) return;

        // set false to next page loading flag
        scope.current.nextLoading = false;

        // load working files
        scope.current.loadWorkingFile();

        // update referred/filtered files and tags
        scope.current.updateReferredAndTags();

        // initialize groups progress
        scope.current.initializeGroupsProgress();

        // calculate groups progress
        scope.current.calculateGroupsProgress();

        // if question set is menu update navigation
        if (scope.current.menuItem) scope.current.updateNavPath();

        // define menu ids
        if (!scope.current.progress.menuIDs) scope.current.progress.menuIDs = {};
        (val.menus || []).forEach(function (menu) {
          scope.current.progress.menuIDs[menu.id] = true;
        });
      });

      scope.$watch("current.project.answers", function (val) {
        if (!val || !Object.keys(val).length) return;

        // refresh navigation
        scope.current.refreshNavigation();

        // update referred/filtered files and tags
        scope.current.updateReferredAndTags();

        if (!scope.current.menuItem) {
          // check if menu progress has issue and fix it
          for (var key in scope.current.progress.menuIDs) {
            var value = scope.current.project.groupsProgress[key];
            scope.current.recalculateGroupProgress(key, value);
          }
        }

        // save drafts, decline save drafts on first load of project
        if (!firstLoad) {
          // saveDraftsDelayed();
          isDirty = true;

          // recalculate data sheets
          scope.current.recalculateDataSheets();
        }

        firstLoad = false;
      }, true);

      function getPageFirstVisibleQuestion(page) {
        if (typeof page === "number") {
          return getPageFirstVisibleQuestion(scope.current.questionSet.questions.pages[page]);
        }

        return page.questions && page.questions.length && page.questions.find(function (question) {
          return isAvailableType(question.type || question.actionType, true)
            && Evaluator.evaluate(scope.current.project.answers, question.controlLogic);
        });
      }

      // watch page index to process questions page change and skip to next/prev if page is empty
      scope.$watch("current.project.answers.pageIndex", function (val, prev) {
        if (!scope.current.questionSet) return;

        // set false to next page loading flag
        scope.current.nextLoading = false;

        if (scope.current.progress.from === "MenItem") {
          scope.current.progress.from = null;
          return;
        }

        var pagesCount = scope.current.questionSet.questions.pages.length;

        // do nothing of page index is out of range
        if (!scope.current.questionSet || !scope.current.questionSet.questions) return;
        if (val < 0 || val > (pagesCount - 1)) return;

        // get page index difference 1 or -1
        var diff = ((val || 0) - (prev || 0)) || 1;

        // get new page
        var page = scope.current.questionSet.questions.pages[val];

        // define if it is next click
        var isNext = prev < val;

        // if Next click update progress reached
        if (isNext) updateProgressReached(val + 1, prev + 1);

        // check if page has visible questions
        var question = getPageFirstVisibleQuestion(page);

        if (question) {
          // update navigation path
          if (!isActiveMenuTab()) {
            scope.current.updateNavPath(isNext);
          }

          scope.showCurrentPage(question);
          updateProgressReached();
          return;
        }

        var nextVal = val;

        while (!question) {
          nextVal = nextVal + diff;
          question = getPageFirstVisibleQuestion(nextVal);

          // check if next value is more than pages count then return
          if (nextVal >= pagesCount || nextVal <= 0) return;
        }

        // go top next/prev page if there are no visible questions
        scope.current.project.answers.pageIndex = nextVal;

        // update navigation path
        scope.current.updateNavPath(isNext);

        // show current page
        page = scope.current.questionSet.questions.pages[scope.current.project.answers.pageIndex];
        if (page) scope.showCurrentPage(page.questions[0]);
      });

      scope.$watch("filtered.questions", function (val) {
        if (!val || !val.length) return;

        var i = 0;

        while (scope.filtered.questions[i].type === "Title") {
          i++;
        }

        scope.filtered.questions[i].focusMe = true;

        // manage focuses
        // console.log(scope.filtered.questions)
      }, true);

      function updateProgressReached(value, prev) {
        scope.current.calculateGroupsProgress(value, prev);

        if (scope.current.project.answers.progress.reached < value) {
          scope.current.project.answers.progress.reached = value;
          scope.current.project.progress.reached += value - prev;
        }
      }

      scope.getBorderStyle = function () {
        if (scope.current.progress && scope.current.progress.navigationPath && scope.current.progress.navigationPath.length) {
          var style = { "border-color": "#F8C8B4" };

          if ($rootScope.isIE11) {
            style.height = window.innerHeight - 170;
          }

          return style;
        }
      };

      scope.displayQuestion = function (question) {
        if (!scope.current.showConfig && question.type === "Tag") return false;
        return Evaluator.evaluate(scope.current.answers(), question.controlLogic);
      };

      scope.displayAnswer = function (answer) {
        return Evaluator.evaluate(scope.current.answers(), answer.controlLogic);
      };

      scope.precheckAnswers = function (question) {
        if (scope.current.project.answers[question.id] || !question.answers) return;

        question.answers.forEach(function (answer) {
          if (!answer.preCheck || !Evaluator.evaluate(scope.current.progress.answers, answer.preCheck)) return;

          if (question.type === "At Least One") {
            var arr = scope.current.project.answers[question.id] || [];
            arr.push(answer.id);
            scope.current.project.answers[question.id] = arr;
          } else {
            scope.current.project.answers[question.id] = answer.id;
          }
        });
      };

      scope.questionAnswerGroups = [];

      scope.createNewEq = function (el, ui) {
        if (!scope.displayPage("MenuItems")) return;
        var menu = scope.current.questionSet.menus[0];
        var questsAndAnswers = scope.questionAnswerGroups[ui.draggable.context.dataset.qa];

        var names = getMenuItemNames(menu);

        MenuNameDialog.open(questsAndAnswers.a2.text, names).then(function (name) {
          scope.current.createMenuItem(menu, name, false, questsAndAnswers);
        });
      };

      scope.questionJson = function (question) {
        var tmp = Utils.stripEmptyProperties(question);
        tmp.globalIndex = ProjectService.current.getQuestionIndex(question);
        return JSON.stringify(tmp, null, 2);
      };

      // PREV-NEXT buttons

      scope.goBack = function () {
        scope.disableBackBtn = true;

        // set false to next page loading flag
        scope.current.nextLoading = true;

        $timeout(function () {
          scope.current.prev();
          scope.disableBackBtn = false;
        }, 0);
      };

      scope.goNext = function () {
        scope.disableNextBtn = true;

        // set false to next page loading flag
        scope.current.nextLoading = true;

        $timeout(function () {
          scope.current.next();
          scope.disableNextBtn = false;
        }, 0);
      };

      scope.goHome = function () {
        $location.path("/");
      };

      scope.disablePrev = function () {
        if (!scope.current.project || !scope.current.questionSet) return;

        if (scope.disableBackBtn) return true;

        return scope.current.project.answers.pageIndex === 0 && scope.current.progress.questionSets.length === 0;
      };

      scope.disableNext = function () {
        if (!scope.current.project || !scope.current.questionSet) return;
        // if show configuration is turned on always enable next
        if (scope.current.showConfig) return false;

        // if disable next is turned on then return true
        if (scope.disableNextBtn) return true;

        // check if menu page is activated

        if (!scope.current.menuItem) {

          // check if menu page is active and some menu item need to be completed
          var currentGroup = scope.current.progress.navigationPath[0];

          if (currentGroup && currentGroup.type === "Menu") {

            // if (!currentGroup.progress.total) return true;
            //
            // return currentGroup.progress.total !== currentGroup.progress.reached;
            return false;
          }
        }

        if (!scope.current.showConfig) {
          // DISABLE NEXT if page questions is unanswered
          var answerable = {
            "Only One": true,
            "At Least One": true,
            "Pull Down": true,
            "List Box": true,
            "Text": true,
            "Text Area": true,
            "Text Box": true
            // 'Table': true
            // 'BOM': true,
            // 'Points List': true,
          };

          var currentPage = scope.current.questionSet.questions.pages[scope.current.project.answers.pageIndex];

          if (currentPage) {
            for (var i = 0; i < currentPage.questions.length; i++) {
              var question = currentPage.questions[i];

              // if questions is appears on page, it is answerable and has not answered then return true
              if (scope.displayQuestion(question) && answerable[question.type] && !scope.current.project.answers[question.id]) return true;
            }
          }
        }

        // if it's menu item and it's last page enable next
        if (scope.current.menuItem && scope.current.project.answers.pageIndex === (scope.current.questionSet.questions.pages.length - 1)) return false;

        return scope.current.project.answers.pageIndex >= (scope.current.questionSet.questions.pages.length - 1)
          && scope.current.progress.questionSetsNext.length === 0;
      };

      scope.showNext = function () {
        if (!scope.current.project || !scope.current.questionSet) return;
        if (scope.current.menuItem || scope.current.page === "MenuItems") return true;

        return scope.current.project.answers.pageIndex < scope.current.questionSet.questions.pages.length - 1;
      };

      // SAVE ANSWERS

      scope.$on("qs:save", function () {
        var dialogOptions = {
          spec: ProjectService.current.spec,
          project: ProjectService.current.project
        };

        CreateProjectDialog.open(dialogOptions).then(function (results) {
          // console.log(results)
          scope.saveProjects(results, function () {
            if (results.asNew)
              $location.path("/admin/specs/build/" + ProjectService.current.spec._id + "/" + scope.current.project._id);
          });
        });
      });

      scope.saveProjects = function (project, callback) {
        if (!callback) callback = project;

        var data = dataToSave();
        data.name = project.name;
        data.comments = project.comments;

        ProjectService.save(data, project.asNew).then(function (response) {

          if (project.asNew) redirectTo(response.data._id);

          // set latest version to current project
          scope.current.setProjectVersion(response.data.version);

          if (typeof callback === "function") callback();
        }, function (err) {
          if (err.data && err.data === "version" || err.data === "project not found") {
            var options = {
              isDeleted: err.data === "project not found"
            };

            SaveConflictDialog.open(options).then(function (result) {
              switch (result.code) {
                case 1: // use mine
                  data.override = true;

                  ProjectService.save(data).then(function (response) {

                    // set latest version to current project
                    scope.current.setProjectVersion(response.data.version);

                    if (typeof callback === "function") callback();
                  });
                  break;
                case 2: // load newer
                  $window.location.reload();
                  break;
                case 3: // save as copy
                  data.name = result.name;
                  data.comments = result.comments;

                  ProjectService.save(data, true).then(function (response) {
                    // redirect to copied project
                    redirectTo(response.data._id);
                  });
                  break;
                case 4: // drop
                  $window.location.href = "/";
                  break;
                case 5: // save as copy
                  data.name = scope.current.project.name;
                  data.comments = scope.current.project.comments;

                  ProjectService.save(data, true).then(function (response) {
                    // redirect to copied project
                    redirectTo(response.data._id);
                  });
                  break;
              }
            });
          }
        });
      };

      function dataToSave() {
        // if it is menu save main answers
        var toSave = scope.current.menuItem ? scope.current.progress.answers[0] : scope.current.project.answers;

        var data = {
          id: scope.current.project._id,
          specConfigID: scope.current.spec._id,
          answers: toSave,
          location: scope.current.project.location,
          progress: scope.current.project.progress,
          groupsProgress: scope.current.project.groupsProgress
        };

        return data;
      }

      function saveDraft() {
        skipSave = true;
        isDirty = false;

        ProjectService.saveDraft().then(function (response) {
          scope.current.setProjectVersion(response.data.version);

          var lastNav = scope.current.fullNavigation.slice(-1).pop();
          // console.log('parent is', scope.current.parent)
          // console.log('saving, current page is', scope.current.page)

          // console.log(scope.current.menu, scope.current.menuItem)

          if (lastNav.progress.total === lastNav.progress.reached && !scope.current.menuItem) {
            var data = {
              specConfigID: scope.current.spec._id,
              name: scope.current.project.name,
              id: scope.current.project._id,
              answers: scope.current.project.answers,
              download: scope.current.downloads,
              location: scope.current.project.location,
              progress: scope.current.project.progress,
              groupsProgress: scope.current.project.groupsProgress
            };

            ProjectService.save(data).then(function (response) {
              scope.current.project.version = response.version;
              // callback(response.data._id);
            });
          }

          skipSave = false;
        }, function (err) {
          if (err.data && err.data === "version" || err.data === "project not found") {
            var options = {
              isDeleted: err.data === "project not found"
            };

            SaveConflictDialog.open(options).then(function (result) {
              switch (result.code) {
                case 1: // use mine
                  ProjectService.saveDraft(true).then(function (response) {
                    // set latest version to current project
                    scope.current.setProjectVersion(response.data.version);
                  });
                  break;
                case 2: // load newer
                  $window.location.reload();
                  break;
                case 3: // save as copy
                  var data = dataToSave();
                  data.name = result.name;
                  data.comments = result.comments;

                  ProjectService.save(data, true).then(function (response) {
                    // redirect to copied project
                    redirectTo(response.data._id);
                  });
                  break;
                case 4: // drop
                  $window.location.href = "/";
                  break;
                case 5: // save as copy
                  var data = dataToSave();
                  data.name = scope.current.project.name;
                  data.comments = scope.current.project.comments;

                  ProjectService.save(data, true).then(function (response) {
                    // redirect to copied project
                    redirectTo(response.data._id);
                  });
                  break;
              }
            });
          }

          skipSave = false;
        });
      }

      function redirectTo(projectID) {
        $window.location.href = "/admin/project/open/" + projectID;
      }

      // MENU ITEMS MAINTENANCE

      scope.$on("qs:menu:create", function (e, a) {
        if (!a || !a.menuID) return;

        var menu = null;

        // if in menu get last question set which contains menus
        if (scope.current.menu) {
          var qs = scope.current.questionSets[scope.current.questionSets.length - 1];

          if (qs.menus) {
            menu = _.find(qs.menus, function (item) {
              return item.id.toString() === a.menuID.toString();
            });
          }
        } else {
          if (scope.current.questionSet.menus) {
            menu = _.find(scope.current.questionSet.menus, function (item) {
              return item.id.toString() === a.menuID.toString();
            });
          }
        }

        if (menu)
          scope.createMenuItem(menu);
      });

      scope.createMenuItem = function (menu) {
        var names = getMenuItemNames(menu);

        MenuNameDialog.open(null, names).then(function (name) {
          scope.current.createMenuItem(menu, name);
        });
      };

      scope.$on("qs:edit:menu:name", function (e, a) {
        if (!a || !a.name) return;

        scope.editMenuItemName(scope.current.menu, scope.current.menuItem);
      });

      scope.editMenuItemName = function (menu, item) {
        var currentMenu = scope.current.menu || menu;
        var names = getMenuItemNames(currentMenu, item.name);

        MenuNameDialog.open(item.name, names).then(function (newName) {
          item.name = newName;
          scope.current.editMenuItemName(currentMenu.id, item.id, newName);
        });
      };

      scope.deleteMenuItem = function (menu, item) {
        Confirm.open("Are you sure you want to delete menu results?", "Delete Menu", "md").then(
          function (result) {
            if (!result) return;
            scope.current.deleteMenuItem(menu.id, item.id);
            PointListService.clearUndoFor(item.id).then(function () { /* ...*/
            });
          }
        );
      };

      scope.copyMenuItem = function (menu, item) {
        var names = getMenuItemNames(menu);

        MenuNameDialog.open(item.name, names).then(function (newName) {
          scope.current.copyMenuItem(menu, item, newName);
        });
      };

      scope.copyExternalMenuItem = function (menu) {
        var names = getMenuItemNames(menu);

        ProjectService.loadBySpec(scope.current.spec._id).then(function (projects) {
          projects = _.filter(projects, function (project) {
            return project._id !== scope.current.project._id;
          });

          MenuExternalCopyDialog.open(names, projects).then(function (menuItem) {

            var menuID = menuItem.id.split("_")[0];
            var menu = _.find(scope.current.questionSet.menus, function (menu) {
              return menu.id.toString() === menuID;
            });

            scope.current.copyMenuItem(menu, menuItem);
          });
        });
      };

      function getMenuItemNames(menu, name) {
        var currentAnswers = scope.current.menuItem ? scope.current.progress.answers[0] : scope.current.project.answers;
        var menuItems = currentAnswers[menu.id];
        var names = [];

        if (menuItems)
          menuItems.forEach(function (item) {
            names.push(item.name);
          });

        var existingName = scope.current.menuItem ? scope.current.menuItem.name : name;

        if (existingName) {
          var index = names.indexOf(existingName);
          if (index >= 0) names.splice(index, 1);
        }

        return names;
      }

      // NAVIGATION EVENTS...

      scope.$on("qs:navigate:root", function () {
        showQuestionsPage(true);

        if (scope.current.menuItem) scope.current.goToPrevQuestionSet();
      });

      scope.$on("qs:navigate:menu", function (e, a) {
        if (scope.current.menuItem) {
          scope.current.progress.from = "MenItem";
          scope.current.goToPrevQuestionSet();
        }

        // show page
        showMenuItemsPage(a.id);

        scope.current.refreshNavigation();
      });

      scope.$on("qs:navigate:menu:item", function (e, a) {
        // if(scope.current.menu) scope.goToPrevQuestionSet();
        if (!a || !a.menuItem) return;

        if (scope.current.menu) {
          scope.current.goToPrevQuestionSet();
        }

        var menu = _.find(scope.current.questionSet.menus, function (m) {
          return m.id.toString() === a.menuItem.parent.id.toString();
        });
        var menuAnswers = scope.current.project.answers[a.menuItem.parent.id];
        var menuItem = _.find(menuAnswers, function (item) {
          return item.id === a.menuItem.id;
        });

        if (menu && menuItem) scope.current.editMenuItem(menu, menuItem);
      });

      scope.$on("qs:navigate:label", function (e, a) {
        if (!a.label) return;

        if (scope.current.menuItem && (!a.label.parent || (a.label.parent && a.label.parent.id !== scope.current.menuItem.id))) {
          scope.current.goToPrevQuestionSet();
        }

        var pageNo = parseInt(a.label.pageNo);
        var index = 0;

        for (var i = 0; i < scope.current.questionSet.questions.pages.length; i++) {
          var current = scope.current.questionSet.questions.pages[i];
          if (current.id === pageNo) index = i;
        }

        // disable nav buttons
        scope.disableBackBtn = true;
        scope.disableNextBtn = true;

        // set false to next page loading flag
        scope.current.nextLoading = true;

        $timeout(function () {
          if (scope.current.project.answers.pageIndex === index) scope.current.nextLoading = false;

          scope.current.project.answers.pageIndex = index;

          scope.disableBackBtn = false;
          scope.disableNextBtn = false;

          // update navigation path
          scope.current.updateNavPath();

          // update visited if next clicked on menu items page after reset answers
          if (a.options && a.options.updateVisited) scope.current.updateVisitedLabels();

          scope.showCurrentPage(a.label.children[0]);
        }, 0);
      });

      scope.$on("qs:navigate:question", function (e, a) {
        if (!a.question) return;

        if (scope.current.menuItem && (!a.question.parent.parent.parent || (a.question.parent.parent.parent && a.question.parent.parent.parent.id !== scope.current.menuItem.id))) {
          scope.current.goToPrevQuestionSet();
          scope.current.updateNavPath();
          showQuestionsPage(true);
        }

        // var
        var index = 0;

        for (var i = 0; i < scope.current.questionSet.questions.pages.length; i++) {
          var currentPage = scope.current.questionSet.questions.pages[i];

          var currentQuestion = _.find(currentPage.questions, function (item) {
            return item.id === a.question.id;
          });

          if (currentQuestion) {
            index = i;
            break;
          }
        }

        scope.current.project.answers.pageIndex = index;
        showQuestionsPage(true);
      });

      // TABS
      scope.$on("qs:navigate:tab", function (e, a) {
        if (!a) return;

        switch (a.type) {
          case "Questions":
            showQuestionsPage(true);
            break;
          case "Menu":
            showMenuItemsPage(a.id);
            break;
        }
      });

      scope.menuTabSwitch = function (menu) {
        scope.current.switchOffAllSelected();
        scope.current.menuNavPath(menu.id);
        scope.current.updateHighlight();
      };

      scope.questionsTabSwitch = function () {
        showQuestionsPage(true);
        scope.current.updateNavPath();
      };

      // show/hide pages
      scope.$on("http:completedAll", function (e) {
        scope.current.readyToShow = true;
      });

      scope.displayPage = function (page) {
        if (page === "MenuItems") {
          return false;
        }
        return scope.current.page === page;
      };

      scope.showCurrentPage = function (question) {
        if (!question) return;
        var type = question.actionType || question.type;

        if (type === "Download" || type === "Preview") {
          scope.showDownloadPage();
        } else showQuestionsPage();
      };

      function showQuestionsPage(show) {
        scope.current.page = "Questions";
      }

      function showMenuItemsPage(id) {
        scope.current.page = "MenuItems";

        scope.current.switchOffAllSelected();
        scope.current.menuNavPath(id);
        scope.current.updateHighlight();
      }

      scope.showDownloadPage = function () {
        scope.current.page = "Download";
      };

      function isActiveMenuTab() {
        for (var i = 0; i < scope.current.questionSet.menus.length; i++) {
          var menu = scope.current.questionSet.menus[i];
          if (menu.isActive) return true;
        }
      }

      // REFERRED FILES
      scope.preview = function (item, processed) {
        if (!item.specConfigID && (item.type !== "Drawing" && !item.historyID)) return; // do nothing if file does not exists

        var answersID = null;

        if (item.type === "Drawing") {
          if (item.files && item.files.svg) {
            doPreview(item.files.svg);
          } else {
            OfficePreviewDialog.open((item.displayName || item.name), "", "", "Please upload SVG file").then();
          }
        } else if (processed) {
          scope.saveProjects(function () {
            answersID = scope.current.project._id;
            doPreview(item, answersID);
          });
        } else {
          doPreview(item);
        }
      };

      scope.download = function (item, processed) {
        if (!item.specConfigID || !item.historyID) return; // do nothing if file does not exists
        var answersID = null;

        if (processed) {
          scope.saveProjects(function () {
            answersID = scope.current.project._id;
            doDownload(item, answersID);
          });
        } else {
          doDownload(item);
        }
      };

      scope.downloadTemplate = function (item) {
        if (!item || !item.historyID) return;
        var url = SpecConfigService.buildDownloadUrl(item.historyID, item.name);
        return url;
      };

      function doPreview(item, answersID) {
        var menuID = scope.current.project.answers.id || "";
        SpecConfigService.officePreviewUrl(item.specConfigID, item.historyID, answersID, menuID).then(function (response) {
          OfficePreviewDialog.open((item.displayName || item.name), response, item.extension).then();
        });
      }

      function doDownload(item, answersID) {
        var menuID = scope.current.project.answers.id || "";
        SpecConfigService.officePreviewUrl(item.specConfigID, item.historyID, answersID, menuID).then(function (response) {
          $window.open(response);
        });
      }

      // find and update question type of type DrawingExtension
      function updateDrawingExtension() {
        if (!scope.current.questionSet.questions || !scope.current.questionSet.questions.pages) return;

        for (var i = 0; i < scope.current.questionSet.questions.pages.length; i++) {
          var page = scope.current.questionSet.questions.pages[i];
          scope.drawingQuestion = _.find(page.questions, function (question) {
            return question.type === "DrawingExtension";
          });

          if (scope.drawingQuestion) break;
        }

        if (!scope.drawingQuestion && scope.current.questionSet.menus) {
          for (var i = 0; i < scope.current.questionSet.menus.length; i++) {
            var menu = scope.current.questionSet.menus[i];
            for (var j = 0; j < menu.pages.length; j++) {
              var page = menu.pages[j];
              scope.drawingQuestion = _.find(page.questions, function (question) {
                return question.type === "DrawingExtension";
              });

              if (scope.drawingQuestion) break;
            }
          }
        }

        // if (!scope.drawingQuestion) scope.drawingQuestion = {};
      }

      function isAvailableType(type) {
        if (type === "Sequence") return scope.current.menuItem || scope.current.showConfig;

        return type === "Only One"
          || type === "At Least One"
          || type === "Pull Down"
          || type === "List Box"
          || type === "Text Box"
          || type === "BOM"
          || type === "Points List"
          || type === "Table"
          || type === "Button"
          || type === "Drawing"
          || type === "DrawingExtension"
          || type === "Title"
          || type === "Download"
          || type === "Preview";
        // || type === 'Sequence'
        // || type === 'Compliance'
        // || type === 'Specification'
        // || type === 'Consistency'
      }

      // load all referred projects
      // function loadReferredProjects(){
      //  if(scope.current.spec) {
      //    ProjectService.loadBySpec(scope.current.spec._id).then(function (response) {
      //      scope.referredProjects = response;
      //    });
      //  }
      // } loadReferredProjects();
    }
  };
}]).constant("implementedQuestionTypes", [
  "Only One",
  "At Least One",
  "Pull Down",
  "List Box",
  "Text",
  "Text Area",
  "Title",
  "Text Box",
  "Hide",
  "Line",
  "Points List",
  "Datasheet",
  "Menu",
  "BOM",
  "BOM Show",
  "Drawing",
  "Sequence",
  "Compliance",
  "Consistency",
  "Specification",
  "Table",
  "DrawingExtension",
  "Download",
  "Preview",
  "Button"
]).filter("getQuestionController", ["implementedQuestionTypes", function (implementedQuestionTypes) {
  return function (text) {
    var name = implementedQuestionTypes.indexOf(text) === -1 ?
      "NotImplemented" : text.replace(/\s+/g, "");
    return "Q_" + name + "Ctrl";
  };
}]).filter("getQuestionTemplate", ["implementedQuestionTypes", function (implementedQuestionTypes) {
  return function (text) {
    var name = implementedQuestionTypes.indexOf(text) === -1 ?
      "not-implemented" : text.replace(/\s+/g, "-").toLowerCase();
    return "components/question-sets/question-types/" + name + "/" + name + ".html";
  };
}]);

"use strict";

app.service("QuestionSetService", ["$http", "$upload", "$q", "Utils", "orderByFilter", function ($http, $upload, $q, Utils, orderByFilter) {
  var instance = {

    upload: function (specID, id, isEntry, name, file) {
      return $upload.upload({
        url: "/api/questions/",
        method: "POST",
        file: file,

        data: {
          isEntry: isEntry,
          specConfigID: specID,
          questionSetID: id,
          name: name
        }
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/questions/rename", data);
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/questions/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/questions/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/questions/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/questions/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    revert: function (id, hid, file) {
      return $q(function (resolve) {
        $http.put("/api/questions/" + id + "/" + hid + "/" + file).then(function (response) {
          return resolve(response);
        });
      });
    },

    forget: function (id, hid) {
      return $q(function (resolve) {
        $http.delete("/api/questions/" + id + "/" + hid).then(function (response) {
          return resolve(response);
        });
      });
    },

    transformToTreeData: function (questionSet) {
      var result = {
        selectedNode: "",
        questionSetData: [],

        nodeSelected: function (node) {
          this.selectedNode = node.data ? JSON.stringify(
            Utils.stripEmptyProperties(node.data),
            null, 2) : "";
        }
      };

      questionSet.pages.forEach(function (page) {
        var pageData = {
          class: "fa fa-list-alt text-warning",
          text: "Page " + page.id,
          type: "page",
          folder: true,
          id: page.id,
          children: []
        };

        page.questions.forEach(function (question) {
          var tmp = angular.copy(question);
          delete tmp.answers;
          delete tmp._id;

          var questionData = {
            class: "fa fa-question-circle text-info",
            text: question.text,
            type: "question",
            folder: true,
            data: tmp,
            children: []
          };

          question.answers.forEach(function (answer) {
            var tmp = angular.copy(answer);
            delete tmp._id;

            var answerData = {
              class: "fa fa-check-circle-o",
              text: answer.text,
              type: "answer",
              folder: false,
              data: tmp
            };

            questionData.children.push(answerData);
          });

          pageData.children.push(questionData);
        });

        result.questionSetData.push(pageData);
      });

      return result;
    },

    filesByPages: function (pages, spec) {
      var fileTypes = ["Drawing", "Sequence", "Compliance", "Specification", "Consistency"];
      var files = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (fileTypes.indexOf(question.type) >= 0 && question.fileFunction) {
            if (question.type === "Drawing") {
              var file = {
                specConfigID: spec._id,
                controlLogic: question.controlLogic,
                type: question.type,
                name: question.fileFunction,
                url: question.fileUrl,
                files: {}
              };

              // get all files with the same name but different extensions
              angular.forEach(spec.drawings, function (drawing) {
                // drawing.name match referred file name
                if (drawing.name === file.name.toLowerCase()) {
                  // get file
                  var drawingFile = spec.files[question.type] ? spec.files[question.type][drawing._id] : null;
                  // file exists
                  if (drawingFile) {
                    file.files[drawing.extension] = {
                      id: drawingFile.refID,
                      historyID: drawingFile._id,
                      specConfigID: spec._id,
                      name: file.name + "." + drawingFile.extension,
                      extension: drawingFile.extension
                    };
                  } else {
                    file.files[drawing.extension] = {
                      id: drawing._id,
                      name: file.name + "." + drawingFile.extension
                    };
                  }
                }
              });

              files.push(file);
            } else {
              // fist occurrence is last one as we have history already sorted
              var file = _.find(spec.files[question.type], function (file) {
                return file.fileName === question.fileFunction;
              });

              if (file) {
                files.push({
                  id: file.refID,
                  historyID: file._id,
                  specConfigID: spec._id,
                  controlLogic: question.controlLogic,
                  type: question.type,
                  name: question.fileFunction,
                  displayName: question.text,
                  extension: file.extension,
                  url: question.fileUrl,
                  hasFile: true,
                });
              } else {
                files.push({
                  // specConfigID: spec._id,
                  controlLogic: question.controlLogic,
                  type: question.type,
                  name: question.fileFunction,
                  url: question.fileUrl,
                  hasFile: false,
                });
              }
            }
          }
        });
      });

      return files;
    },

    tagsByPages: function (pages, spec) {
      var tags = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Tag" && question.fileFunction) {

            tags.push({
              id: question.id,
              // specConfigID: spec._id,
              controlLogic: question.controlLogic,
              name: question.fileFunction
            });
          }
        });
      });

      return tags;
    },

    pointListsByPages: function (pages, spec) {
      var pls = [];

      angular.forEach(pages, function (page) {
        angular.forEach(page.questions, function (question) {
          if (question.type === "Points List" && question.fileFunction) {
            var fileFunctionComponents = _.map(question.fileFunction.split("#"), function (component) { return component.trim();});
            pls.push({
              id: question.id,
              // specConfigID: spec._id,
              controlLogic: question.controlLogic,
              pointListFile: fileFunctionComponents.length > 0 ? fileFunctionComponents[0] : null,
              pointListID: fileFunctionComponents.length > 1 ? fileFunctionComponents[1] : null
            });
          }
        });
      });

      return pls;
    },

    questionByFileFunction: function (pages, name) {
      for (var i = 0; i < pages.length; i++) {
        var page = pages[i];

        var question = _.find(page.questions, function (question) {
          return question.fileFunction && question.fileFunction.toLowerCase() === name.toLowerCase();
        });

        if (question) return question;
      }
    },

    normalizeWorkingFiles: function (pages, data) {
      for (var key in data) {
        var values = data[key];
        var results = [];

        if (key === "PointList") {
          angular.forEach(pages, function (page) {
            angular.forEach(page.questions, function (question) {
              if (question.type !== "Points List" || !question.fileFunction) return;

              var value = _.find(values, function (item) {
                return question.fileFunction.indexOf(item.name) === 0;
              });
              if (!value) return;

              var nameIDArr = question.fileFunction.split("#");
              var list = null;

              if (nameIDArr.length === 2) {
                var listID = nameIDArr[1];
                var list = _.find(value.lists, function (item) {
                  return item.id.toString() === listID;
                });
              } else {
                value.lists[0];
              }

              if (!list) return;

              results.push({
                list: list,
                question: question,
                controlLogic: question.controlLogic
              });
            });
          });
        } else {
          values.forEach(function (value) {
            var question = instance.questionByFileFunction(pages, value.name);
            if (!question) return;

            results.push({
              value: value,
              question: question,
              controlLogic: question.controlLogic
            });
          });
        }

        data[key] = results;
      }

      return data;
    }
  };

  return instance;
}]);

"use strict";

app.controller("Q_AtLeastOneCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.all = {
    filteredAnswers: [],
    select: false
  };

  angular.forEach($scope.question.answers, function (answer) {
    answer.isSelected = $scope.current.project.answers[$scope.question.id] && $scope.current.project.answers[$scope.question.id].indexOf(answer.id) >= 0;

    // bind preChecks
    if ($scope.current.preCheck(answer.preCheck) && $scope.displayAnswer(answer)) {
      if (!$scope.current.project.answers[$scope.question.id]) $scope.current.project.answers[$scope.question.id] = [];

      var existing = _.find($scope.current.project.answers[$scope.question.id], function (tmp) {
        return tmp === answer.id;
      });

      if (!existing) $scope.current.project.answers[$scope.question.id].push(answer.id);
    }
  });

  $scope.bindModel = function (answer) {
    if (answer.actionType === "Text" && !$scope.current.project.answers.answerTextsOverride) $scope.current.project.answers.answerTextsOverride = {};

    var selectedAnswers = [];

    angular.forEach($scope.question.answers, function (answer) {
      if (answer.isSelected) {
        selectedAnswers.push(answer.id);
        $scope.$emit("answerSelected", answer);
      }
    });

    if (selectedAnswers.length) {
      $scope.current.project.answers[$scope.question.id] = selectedAnswers;

      if (selectedAnswers.indexOf(answer.id) < 0) {
        answer.focusMe = false;

        if ($scope.current.project.answers.answerTextsOverride)
          delete $scope.current.project.answers.answerTextsOverride[$scope.question.id][answer.id];
      }
      else if (answer.actionType === "Text") {
        answer.focusMe = true;
      }
    }
    else {
      delete $scope.current.project.answers[$scope.question.id];

      if ($scope.current.project.answers.answerTextsOverride)
        delete $scope.current.project.answers.answerTextsOverride[$scope.question.id];
    }

    // reset next answers

    $scope.current.resetNextAnswers($scope.question);
  };

  $scope.focusLost = function (answer) {
    var qsModel = $scope.current.project.answers.answerTextsOverride[$scope.question.id] || {};
    var index = $scope.current.project.answers[$scope.question.id].indexOf(answer.id);
    answer.focusMe = false;

    if (!qsModel[answer.id]) {
      $scope.current.project.answers[$scope.question.id].splice(index, 1);
      delete qsModel[answer.id];

      answer.isSelected = false;
    }
  };

  $scope.showCheckAll = function () {

    for (var i = 0; i < $scope.all.filteredAnswers.length; i++) {
      var answer = $scope.question.answers[i];
      if (answer.actionType === "Text") return false;
    }

    return $scope.all.filteredAnswers.length >= 2;
  };

  $scope.allChecked = function () {
    var selectedCount = 0;

    angular.forEach($scope.all.filteredAnswers, function (answer) {
      if (answer.isSelected) selectedCount ++;
    });

    $scope.all.select = $scope.all.filteredAnswers.length === selectedCount;
  };

  $scope.checkAllClick = function () {
      // THIS EXECUTES IF ANY QUESTION IS NOT SELECTED !!! IT SELECTS ALL
      $scope.all.filteredAnswers.forEach(function (answer) {
        if (!answer.isSelected) {
          answer.isSelected = true;
          $scope.bindModel(answer);
        }
      });

  };
  $scope.checkNoneClick = function () {
    delete $scope.current.project.answers[$scope.question.id];

      $scope.all.filteredAnswers.forEach(function (answer) {
        answer.isSelected = false;
      });
  };
}]);

"use strict";

app.controller("Q_BOMCtrl", ["$rootScope", "$scope", "ProjectService", function ($rootScope, $scope, ProjectService) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.current = ProjectService.current;
}]);

"use strict";

app.controller("Q_ButtonCtrl", ["$rootScope", "$scope", "ProjectService", "Evaluator", function ($rootScope, $scope, ProjectService, Evaluator) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.current = ProjectService.current;

  $scope.activatePointListTab = function () {
    var answers = $scope.current.progress.answers.concat([$scope.current.project.answers]);

    $scope.current.pointLists.forEach(function (item) {
      if (!Evaluator.evaluate(answers, item.controlLogic)) return;

      item.isActive = true;
    });
  };
}]);

"use strict";

app.controller("Q_ComplianceCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
}]);

"use strict";

app.controller("Q_ConsistencyCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
}]);

"use strict";

app.controller("Q_DataSheetCtrl", ["$rootScope", "$scope", "ProjectService", function ($rootScope, $scope, ProjectService) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.current = ProjectService.current;
}]);

"use strict";

app.controller("Q_DownloadCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.showDownloadPage();
}]);

"use strict";

app.controller("Q_DrawingCtrl", ["$rootScope", "$scope", "SpecConfigService", "ProjectService", function ($rootScope, $scope, SpecConfigService, ProjectService) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.current = ProjectService.current;

  $scope.$watch("current.project.answers.filteredFiles", function (val) {
    if (!$scope.current.project.answers.filteredFiles) return;

    $scope.drawings = [];

    val.forEach(function (fileItem) {
      var item = angular.copy(fileItem);

      if (item.specConfigID && item.type === "Drawing" && item.files && item.files.svg && item.name.toLowerCase() === $scope.question.fileFunction.toLowerCase()) {
        SpecConfigService.officePreviewUrl(item.files.svg.specConfigID, item.files.svg.historyID).then(function (response) {
          item.thumbnailUrl = response;

          var existing = _.find($scope.drawings, function (drItem) {
            return drItem.files.svg.historyID === item.files.svg.historyID;
          });

          if (!existing)
            $scope.drawings.push(item);
        });
      }
    });
  });
}]);

"use strict";

app.controller("Q_DrawingExtensionCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
}]);

"use strict";

app.controller("Q_ListBoxCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.changed = function () {
    // reset next answers
    $scope.current.resetNextAnswers($scope.question);
  };
}]);

"use strict";

app.controller("MenuCreateCtrl", ["$scope", "$modalInstance", "$log", "PointListService", "menuQuestions", "data", "questionSet", function ($scope, $modalInstance, $log, PointListService, menuQuestions, data, questionSet) {
  $scope.action = "Create";
  $scope.questionSet = questionSet;
  $scope.menuQuestions = menuQuestions;
  $scope.name = data ? data.name : "";
  $scope.pointLists = PointListService.loadByPages(menuQuestions.pages, $scope.questionSet.specConfigID);

  $scope.renderPreview = {
    doc: data ? data : {},
    pageIndex: 0,

    prev: function () {
      this.pageIndex--;
    },

    next: function () {
      this.pageIndex++;
    }
  };

  $scope.save = function () {
    if (!isValid()) return;

    $scope.renderPreview.doc.name = $scope.name;
    $modalInstance.close($scope.renderPreview.doc);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel");
  };

  function isValid() {
    $scope.nameIsNotValid = !$scope.name.length;

    return !$scope.nameIsNotValid;
  }
}]);

"use strict";

app.service("MenuCreateDialog", ["$modal", function ($modal) {
  this.open = function (menuQuestions, data, questionSet) {
    return $modal.open({
      templateUrl: "components/question-sets/question-types/menu/create/create.html",
      controller: "MenuCreateCtrl",
      size: "lg",
      resolve: {
        menuQuestions: function () { return menuQuestions; },
        data: function () { return data;},
        questionSet: function () { return questionSet; }
      }
    }).result;
  };
}]);

"use strict";

app.controller("Q_MenuCtrl", ["$rootScope", "$scope", "$log", "Confirm", "MenuCreateDialog", function ($rootScope, $scope, $log, Confirm, MenuCreateDialog) {
  $scope.asHtml = $rootScope.asHtml;
}]);

"use strict";

app.controller("Q_OnlyOneCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  // if only one answer automatically select or bind preChecks
  if ($scope.question.answers.length === 1 && $scope.displayAnswer($scope.question.answers[0]))
    $scope.current.project.answers[$scope.question.id] = $scope.question.answers[0].id;
  else {
    angular.forEach($scope.question.answers, function (answer) {
      if ($scope.current.preCheck(answer.preCheck) && $scope.displayAnswer(answer))
        $scope.current.project.answers[$scope.question.id] = answer.id;
    });
  }

  $scope.bindModel = function (selectedAnswer) {
    if (selectedAnswer) {
      $scope.current.project.answers[$scope.question.id] = selectedAnswer.id;
      // reset next answers
      if (selectedAnswer.actionType !== "Questionnaire") {
        $scope.current.resetNextAnswers($scope.question, selectedAnswer);
      }

      $scope.$emit("answerSelected", selectedAnswer);
    } else {
      delete $scope.current.project.answers[$scope.question.id];
    }
  };
}]);

"use strict";

app.controller("Q_PointsListCtrl", ["$rootScope", "$scope", "ProjectService", function ($rootScope, $scope, ProjectService) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.current = ProjectService.current;
}]);

"use strict";

app.controller("Q_PreviewCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
  $scope.showDownloadPage();
}]);

"use strict";

app.controller("Q_PullDownCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.answerSelected = function () {
    var id = $scope.current.project.answers[$scope.question.id];
    if (!id) return;

    for (var i = 0; i < $scope.question.answers.length; i++) {
      var answer = $scope.question.answers[i];
      if (answer.id === id) {

        // reset next answers

        $scope.current.resetNextAnswers($scope.question, answer);

        $scope.$emit("answerSelected", answer);
        return;
      }
    }
  };
}]);

"use strict";

app.controller("Q_SequenceCtrl", ["$rootScope", "$scope", "$window", "$sce", "ProjectService", "SpecConfigService", "SignatureService", "OfficePreviewDialog", "Message", function ($rootScope, $scope, $window, $sce, ProjectService, SpecConfigService, SignatureService, OfficePreviewDialog, Message) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.current = ProjectService.current;
  $scope.msOfficeUrl = "https://view.officeapps.live.com/op/view.aspx?src=";

  $scope.$watch("current.project.answers.filteredFiles", function (val) {
    if (!val || !val.length || !$scope.current.menuItem) return;

    $scope.sequences = [];

    $scope.saveProjects(function () {
      val.forEach(function (item) {
        if (item.type === "Sequence" && item.name === $scope.question.fileFunction) {
          var copyItem = angular.copy(item);
          copyItem.fileName = copyItem.name;
          copyItem._id = copyItem.historyID;
          copyItem.displayName = ($scope.question.text || copyItem.name);

          var menuID = $scope.current.project.answers.id || "";

          SpecConfigService.officePreviewUrl($scope.current.spec._id, copyItem.historyID, $scope.current.project._id, menuID).then(function (response) {
            copyItem.url = response;
            $scope.sequences.push(copyItem);
          });
        }
      });

    });
  }, true);

  $scope.downloadOriginal = function (file) {
    var url = SpecConfigService.buildDownloadUrl(file.historyID, file.name);
    $window.open(url);
  };

  $scope.previewOriginal = function (file) {
    SignatureService.directUrl(file).then(function (response) {
      OfficePreviewDialog.open(file.name, response, file.extension);
    });
  };

  $scope.trustSrc = function (file) {

    var trusted = $scope.msOfficeUrl + encodeURIComponent(file.url);

    return $sce.trustAsResourceUrl(trusted);
  };

  $scope.checkIfProcessable = function (file) {
    $scope.current.nextLoading = true;
    save(function (id) {
      SpecConfigService.checkIfProcessable($scope.current.spec._id, file.historyID, id).then(showProcessableMessage, showProcessableMessage);
    });
  };

  function showProcessableMessage(response) {
    $scope.current.nextLoading = false;
    var log = response.data && response.data.log ? response.data.log : {};
    var title = "";
    var message = response.data || response.statusText;
    var type = null;

    if (log.errors && log.errors.length > 0) {
      title = "File is not valid";
      message = "Please check logs for more details";
      type = "danger";
    } else {
      title = "File is valid";
      message = "Processing is able";
      if (log && !Object.keys(log).length) log = null;
    }

    var data = {
      params: response.data ? response.data.params : null,
      log: log
    };

    Message.open(message, title, "md", type, data).then();
  }

  function save(callback) {
    var data = {
      specConfigID: $scope.current.spec._id,
      name: $scope.current.project.name,
      id: $scope.current.project._id,
      answers: $scope.current.progress.answers[0],
      download: $scope.current.downloads,
      location: $scope.current.project.location,
      progress: $scope.current.project.progress,
      groupsProgress: $scope.current.project.groupsProgress
    };

    ProjectService.save(data).then(function (response) {
      $scope.current.project.version = response.version;
      callback(response.data._id);
    });
  }
}]);

"use strict";

app.controller("Q_SpecificationCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;
}]);

"use strict";

app.controller("Q_TableCtrl", ["$rootScope", "$scope", "ProjectService", function ($rootScope, $scope, ProjectService) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.current = ProjectService.current;
  $scope.columns = [];
  $scope.savedAnswers = [];
  $scope.originalQuestion = angular.copy($scope.question);

  $scope.$on("qs:refresh:ui", function (e) {
    init();
  });

  function init() {
    $scope.savedAnswers = $scope.current.project.answers[$scope.question.id];

    if (!$scope.savedAnswers) $scope.question = angular.copy($scope.originalQuestion);

    $scope.button = angular.copy($scope.question.answers[$scope.question.answers.length - 1]);

    if (($scope.question.text || "").indexOf("{") != -1) {
      $scope.headers = $scope.question.text.substring(1, $scope.question.text.length - 1).split("}{");
    } else if ($scope.question.text && $scope.question.text.length > 0) {
      $scope.headers = [$scope.question.text];
    } else {
      $scope.headers = [""];
    }

    var cols = $scope.question.fileFunction.split(",");

    if (cols.length !== $scope.headers.length && $scope.headers.length === 1) {
      $scope.headerColSpan = cols.length + 1;
    } else {
      $scope.headerColSpan = 1;
    }

    $scope.footerColSpan = cols.length + 1;
  } init();

  $scope.getColumns = function (answer) {
    if (!answer.columns) convertAnswerToColumns(answer);

    var answers = $scope.current.project.answers[$scope.question.id] || [];

    var existing = _.find(answers, function (ans) {
      return ans.id === answer.id;
    });
    if (!existing && answer.actionType !== "Button") {
      (answer.columns || []).forEach(function (col) {
        $scope.bindChange(answer, col, true);
      });
    }

    return answer.columns;
  };

  $scope.bindChange = function (item, cell, force) {
    if ((!cell.changed || cell.type === "text" && !cell.value) && !force) return;
    if (cell.numbs && cell.numbs.val) validateNumbs(cell);

    if (!$scope.current.project.answers[$scope.question.id]) $scope.current.project.answers[$scope.question.id] = [];
    var answers = $scope.current.project.answers[$scope.question.id];
    var done = false;

    angular.forEach(answers, function (answer) {
      var match = false;
      if (item.id === answer.id) {
        answer.columns = answer.columns || answer.values || []; // update answers.columns with existing values
        angular.forEach(answer.columns, function (value) {
          if (cell.index === value.index) {
            match = true;
          }
        });

        if (!match) answer.columns.push(cell);
        done = true;
      }
    });

    if (!done) {
      answers.push({
        id: item.id,
        columns: [cell]
      });
    }
  };

  $scope.changed = function (cell) {
    cell.changed = true;
  };

  $scope.bindClick = function (item, cell) {
    if (cell.type === "text") return;
    $scope.bindChange(item, cell);
  };

  $scope.addLine = function (columns) {
    var toAdd = angular.copy($scope.button);
    toAdd.actionType = "Table";
    toAdd.added = true;
    toAdd.id = $scope.question.answers.length + 1;
    if (columns) {
      convertAnswerToColumns(toAdd);
      angular.forEach(toAdd.columns, function (col) {
        angular.forEach(columns, function (saved) {
          if (col.index !== saved.index) col = saved;
        });
      });
    }

    toAdd.text = "";
    toAdd.focusMe = true;
    $scope.question.answers.push(toAdd);
  };

  $scope.removeLine = function (index, id) {
    $scope.question.answers.splice(index, 1);

    var answers = $scope.current.project.answers[$scope.question.id];

    angular.forEach(answers, function (answer) {
      if (answer.id === id) {
        answers.splice(answers.indexOf(answer), 1);
        if (!answers.length) {
          delete $scope.current.project.answers[$scope.question.id];
        }
      }
    });
  };

  $scope.displayAnswer = function (item) {
    if ($scope.current.showConfig) return true;

    return $scope.current.displayQuestion(item);
  };

  function convertAnswerToColumns(answer) {
    var cols = answer.fileFunction.split(",");
    var cutFrom = answer.text.indexOf("{") === 0 ? 1 : 0;
    var texts = answer.text.substring(cutFrom, answer.text.length - 1).split("}{");
    answer.columns = [];

    for (var i = 0; i < cols.length; i++) {
      var cell = {
        type: cols[i].split("(")[0].toLowerCase().trim(),
        text: texts[i] || "",
        index: i
      };

      if (answer.added) cell.added = true;

      cell.value = cell.text;

      if (cell.text === "On" || cell.text === "Off") cell.value = cell.text === "On";

      if (cell.type !== "checkbox" && cell.type !== "text") cell.type = "";

      if (cell.type === "text") {
        cell.style = {
          "width": "100%" // cols[i].toLowerCase().replace('text(','').replace(')','')
        };
      } else {
        cell.style = {};
      }

      angular.forEach($scope.savedAnswers, function (item) {
        if (item.id === answer.id) {
          angular.forEach(item.columns || item.values, function (value) {
            if (cell.index === value.index) cell = value;
          });
        }
      });

      answer.columns.push(cell);
    }
  }

  function validateNumbs(cell) {
    if (!cell.value) cell.value = cell.numbs.val;
    cell.value = cell.value.toString();
    cell.numbs.max = cell.numbs.max.toString();
    cell.numbs.min = cell.numbs.min.toString();

    cell.value = cell.value.indexOf(".") ? parseFloat(cell.value) : parseInt(cell.value);
    cell.numbs.max = cell.numbs.max.indexOf(".") ? parseFloat(cell.numbs.max) : parseInt(cell.numbs.max);
    cell.numbs.min = cell.numbs.min.indexOf(".") ? parseFloat(cell.numbs.min) : parseInt(cell.numbs.min);

    if (cell.value > cell.numbs.max) cell.value = cell.numbs.max;
    if (cell.value < cell.numbs.min) cell.value = cell.numbs.min;
  }

  angular.forEach($scope.savedAnswers, function (saved) {
    var exists = false;
    angular.forEach($scope.question.answers, function (answer) {
      exists = exists || saved.id === answer.id;
    });

    if (!exists) $scope.addLine(saved.columns);
  });
}]);

"use strict";

app.controller("Q_TextAreaCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.focus = function (e) {
    $scope.currentValue = e.currentTarget.value;
  };

  $scope.blur = function (e) {
    // do nothing if value not changed
    var newValue = e.currentTarget.value;
    if ($scope.currentValue === newValue) return;

    // reset next answers
    $scope.currentValue = newValue;
    $scope.current.resetNextAnswers($scope.question);
  };
}]);

"use strict";

app.controller("Q_TextBoxCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  function init() {
    $scope.question.answers.forEach(function (answer) {
      answer.prefix = "";
      answer.parts = [];

      var i = 0;

      answer.text.split(/(?=\{)/).forEach(function (word) {
        word = word.trim();
        if (!word) return;

        if (word[0] !== "{") {
          answer.prefix = word;
        } else {
          var tmp = word.split("}");
          var txt = tmp[0].split("{")[1] || "";
          var val = txt.split("(")[0].trim();
          var range = txt.split(")")[0].split("(")[1];

          var part = {
            val: val || "",
            range: range ? range.split("-").map(function (x) { return x.replace(/\s/g, ""); }) : [],
            suffix: tmp.length > 1 ? tmp[1] : ""
          };

          if (part.range.length && part.val && part.val.match(/^\d+(\.\d+)?$/)) {
            part.val = parseFloat(part.val);
          }

          setDefaultValue($scope.question.id, answer.id, i, part.val);
          answer.parts.push(part);
          i++;
        }
      });

      function setDefaultValue(qid, aid, index, val) {
        if (!val) return;
        var model = $scope.current.project.answers; // model is answers

        if (!_.isObjectLike(model[qid])) model[qid] = {}; // reset question answers
        model = model[qid]; // model is answer

        if (!_.isObjectLike(model[aid])) model[aid] = {}; // reset answer value
        model = model[aid]; // model is answer value

        if (!model[i]) model[i] = val;
      }
    });
  }

  init();

  $scope.$on("qs:refresh:ui", init);

  $scope.focus = function (e) {
    $scope.currentValue = e.currentTarget.value;
  };

  $scope.blur = function (e, answer, part, index) {
    // do nothing if value not changed
    var newValue = e.currentTarget.value;
    if ($scope.currentValue === newValue) return;
    var isNumeric = part.range && part.range.length;

    if (isNumeric) {
      var hasMin = part.range && part.range.length > 0;
      var min = new Number(part.range && part.range.length > 0 ? part.range[0] : "");

      var hasMax = part.range && part.range.length > 1;
      var max = new Number(part.range && part.range.length > 1 ? part.range[1] : "");

      var val = new Number(e.currentTarget.value);
      if (hasMin && val < min) $scope.current.project.answers[$scope.question.id][answer.id][index] = min.toString();
      if (hasMax && val > max) $scope.current.project.answers[$scope.question.id][answer.id][index] = max.toString();
      e.currentTarget.value = $scope.current.project.answers[$scope.question.id][answer.id][index];
    }

    // reset next answers
    $scope.currentValue = newValue;
    $scope.current.resetNextAnswers($scope.question);
  };
}]);

"use strict";

app.controller("Q_TextCtrl", ["$rootScope", "$scope", function ($rootScope, $scope) {
  $scope.asHtml = $rootScope.asHtml;

  $scope.focus = function (e) {
    $scope.currentValue = e.currentTarget.value;
  };

  $scope.blur = function (e) {
    // do nothing if value not changed
    var newValue = e.currentTarget.value;
    if ($scope.currentValue === newValue) return;

    // reset next answers
    $scope.currentValue = newValue;
    $scope.current.resetNextAnswers($scope.question);
  };
}]);

"use strict";

app.controller("RestoreDraftCtrl", ["$scope", "$modalInstance", "data", function ($scope, $modalInstance, data) {
  $scope.data = data;

  $scope.restore = function () {
    $modalInstance.close(true);
  };

  $scope.cancel = function () {
    $modalInstance.close(false);
  };
}]);

"use strict";

app.service("RestoreDraftDialog", ["$modal", function ($modal) {
  this.open = function (data) {
    return $modal.open({
      templateUrl: "components/restore-draft/restore-draft.html",
      controller: "RestoreDraftCtrl",
      size: "md",
      resolve: {
        data: function () { return data; }
      }
    }).result;
  };
}]);

"use strict";

app.service("SequenceService", ["$http", "$upload", "$q", function ($http, $upload, $q) {
  var instance = {

    upload: function (specID, id, name, file) {
      return $upload.upload({
        url: "/api/sequence/",
        method: "POST",
        file: file,

        data: {
          specConfigID: specID,
          itemID: id,
          name: name
        }
      });
    },

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/sequence/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/sequence/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/sequence/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/sequence/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/sequence", data);
    }
  };

  return instance;
}]);

"use strict";

app.service("SignatureService", ["$http", "$upload", "$q", "$location", function ($http, $upload, $q, $location) {
  var instance = {

    directUrl: function (item) {
      var fileName = "";
      if (item.fileName.indexOf(".") > 0) fileName = item.fileName;
      else fileName = item.fileName + "." + item.extension;

      return $q(function (resolve) {
        $http.get("/api/file/url/" + item._id + "/" + fileName).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    previewUrl: function (item) {
      var data = {
        url: $location.protocol() + "://" + $location.host()
      };
      var fileName = "";

      if ($location.host() === "localhost") data.url += ":" + $location.port();

      if (item.fileName.indexOf(".") > 0) fileName = item.fileName;
      else fileName = item.fileName + "." + item.extension;

      data.url += "/api/file/preview/" + item._id + "/" + fileName;

      return $q(function (resolve) {
        $http.put("/api/sign", data).then(function (response) {
          return resolve(response.data);
        });
      });
    }
  };

  return instance;
}]);

"use strict";

app.service("Signup", ["$http", function ($http) {
  return {
    sendRequest: function (email, provider) {
      return $http.put("/api/signup/" + email + "/" + provider);
    },

    validateToken: function (token) {
      return $http.get("/api/signup/" + token);
    },

    createUser: function (token, user, callback) {
      var cb = callback || angular.noop;

      return $http.post("/api/signup/" + token, user).then(
        function (response) {
          return cb(user);
        }, function (data, status, headers, config) {
          // this.logout();
          return cb(data, status, headers, config);
        });
    },

    validateUsername: function (username) {
      return $http.get("/api/signup/username/" + username);
    }
  };
}]);

"use strict";

app.directive("specBuilder", ["$rootScope", "$log", "QuestionSetService", "ProjectService", function ($rootScope, $log, QuestionSetService, ProjectService) {

  return {
    restrict: "E",
    replace: true,
    templateUrl: "components/spec-builder/spec-builder.html",

    scope: { },

    link: function (scope) {
      scope.current = ProjectService.current;
      // lookups
      scope.countries = $rootScope.countries;
      scope.languages = $rootScope.languages;
      scope.products = $rootScope.products;
    }
  };
}]);

"use strict";

app.directive("specNavigator", ["$rootScope", "$log", "Auth", "Config", "ProjectService", "Evaluator", function ($rootScope, $log, Auth, Config, ProjectService, Evaluator) {
  return {
    restrict: "E",
    templateUrl: "components/spec-builder/spec-navigator.html",

    scope: {
      treeOptions: "="
    },

    link: function (scope) {
      scope.current = ProjectService.current;

      scope.event = null;
      scope.selectedNode = {};

      scope.user = Auth.getCurrentUser();
      scope.userAccess = scope.current.questionSet.questions.userAccess.filter(access => access.userId === scope.user._id);

      scope.switchExpand = function (node, event) {
        if (node.isDisabled) return;

        var index = scope.current.progress.expandedNodes.indexOf(node);
        if (index < 0) scope.current.progress.expandedNodes.push(node);
        else scope.current.progress.expandedNodes.splice(index, 1);
        node.exp = !node.exp;

        event.stopPropagation();
      };

      scope.displayNode = function (node) {
        // access control
        if (!Auth.hasAccess(scope.current.project)) {
          if (scope.userAccess.length > 0) {
            return true;
          } else {
            node.isDisabled = true;
            node.isHided = true;
          }
        }

        if (node.isHided) return false;
        if (node.actionType === "Tag") return false;
        if (!node.name && !node.text && !node.fileFunction) return false;
        if (node.type !== "Question") return true;
        if (!scope.current.showQuestions) return false;

        var answers = scope.current.progress.answers;

        if (node.path && node.path.length > 1) {
          if (scope.current.menuItem && scope.current.menuItem.id === node.parent.parent.parent.id) {
            answers = answers.concat([scope.current.project.answers]);
          } else {
            var baseAnswers = scope.current.menuItem ? scope.current.progress.answers[0] : scope.current.project.answers;
            var menuAnswers = baseAnswers[node.parent.parent.parent.parent.id];

            var currentAnswers = _.find(menuAnswers, function (item) {
              return item.id === node.parent.parent.parent.id;
            });

            answers = answers.concat([currentAnswers]);
          }
        } else {
          answers = answers.concat([scope.current.project.answers]);
        }

        return Evaluator.evaluate(answers, node.controlLogic);
      };

      scope.filterBacks = function (qs) {
        if (!scope.current.menuItem) return true;
        return scope.current.progress.questionSets.indexOf(qs) <
          scope.current.progress.questionSets.length - 1;
      };

      scope.navigateTo = function (node, questionSet, event) {
        if (node.isDisabled) return;
        if (event) scope.event = event;

        $rootScope.tabletIsOpen = false;

        if (questionSet && questionSet.questions._id !== scope.current.questionSet.questions._id) {
          // save latest progress
          scope.current.saveLatestProgressInfo();

          // switch to question set
          scope.current.switchToQuestionSet(questionSet, true);
        }

        if (scope.current.menuItem && (node.type === "MenuItem" || node.path.length > 1)) {
          var current = node;

          while (current.type !== "MenuItem") {
            current = current.parent;
          }

          if (scope.current.menuItem.id.toString() === current.id.toString()) {

            if (node.type === "MenuItem") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0] });
            if (node.type === "Group") $rootScope.$broadcast("qs:navigate:label", { label: node.children[0] });
            if (node.type === "Label") $rootScope.$broadcast("qs:navigate:label", { label: node });
            if (node.type === "Question") $rootScope.$broadcast("qs:navigate:question", { question: node });

            scope.event.stopPropagation();
            return;
          }
        }

        switch (node.type) {
          case "Group":
            // Navigate to group first label
            if (node.children && node.children.length) {
              var labelNode = node.children[0];

              if (!labelNode.parent)
                scope.setPath(labelNode, node);

              scope.navigateTo(labelNode);
            }
            break;

          case "Menu":
            // Go to menu tab
            $rootScope.$broadcast("qs:navigate:menu", { id: node.id, tab: "menu" });
            break;

          case "MenuItem":
            $rootScope.$broadcast("qs:navigate:menu:item", { menuItem: node });
            break;

          case "Label":
            if (node.path.length > 0) {
              // Navigate to menu item if is in m enu
              scope.navigateTo(node.parent);
            }

            // Go to label start page
            $rootScope.$broadcast("qs:navigate:label", { label: node });
            break;

          case "Question":
            if (node.path.length > 1) {
              // Navigate to menu item if is in menu
              scope.navigateTo(node.parent.parent.parent);
            }

            // Go to question page
            $rootScope.$broadcast("qs:navigate:question", { question: node });
            break;
        }
      };

      scope.navigateToRoot = function () {
        $rootScope.$broadcast("qs:navigate:root");
      };

      scope.createMenuItem = function (node, qs) {
        if (node.isDisabled) return;

        if (qs && qs.questions._id !== scope.current.questionSet.questions._id) {
          // save latest progress
          scope.current.saveLatestProgressInfo();

          // switch to question set
          scope.current.switchToQuestionSet(qs, true);
        }

        $rootScope.$broadcast("qs:menu:create", { menuID: node.id });
      };

      scope.setPath = function (node, parentNode) {
        node.parent = {};

        angular.forEach(parentNode, function (val, key) {
          if (parentNode.type !== "MenuItem" && key === "children") return;
          node.parent[key] = val;
        });

        node.path = node.type === "Menu" ? [node.id] : [];
        if (parentNode) node.path = node.path.concat(parentNode.path);
        return "";
      };

      scope.getName = function (node) {
        // if it's not Table Header just return name
        if (node.actionType !== "Table Header" && node.actionType !== "Tag") return (node.name || node.text || node.fileFunction);

        // else modify and then return

        var name = node.name;

        // remove {}
        var reg1 = new RegExp("{}", "g");
        name = name.replace(reg1, "");

        // replace }{ with -
        var reg2 = new RegExp("}{", "g");
        name = name.replace(reg2, "-");

        // remove {
        var reg3 = new RegExp("{", "g");
        name = name.replace(reg3, "");

        // remove }
        var reg4 = new RegExp("}", "g");
        name = name.replace(reg4, "");

        return name;
      };

      scope.calculatePercentage = function (progress) {
        return Math.round((progress.reached / progress.total) * 100);
      };

      scope.setTreeNodeClass = function (node, parentNode, index) {
        if (node.type === "Group" || node.type === "Menu" && !parentNode) {
          index = index % Config.treeColors;
          index += 1;
          node.index = index;
          // node.class = 't-group-' + node.index;
        }

        if (parentNode && (parentNode.type === "Menu" || parentNode.type === "MenuItem")) node.index = parentNode.index;
        else if (!parentNode) return " t-group-space";

        if (parentNode) node.class = parentNode.class;
        if (node.type === "Question") return " t-max";
        if (node.type === "MenuItem") return " t-menu-item-max";

        return node.class;
      };

      scope.setNodeClass = function (node, parentNode) {
        if (!parentNode) return;
        if (node.type === "Question" && node.path && node.path.length === 1) return;

        if (node.path && node.path.length > 0) {
          if (node.type === "MenuItem") return "t-menu-item";
          else if (node.type === "Label") return "t-menu-item-content";
          // else if(node.parent.type === 'Label') return 't-menu-item-q';

        } else if (node.type === "Label") return " t-label";
        // else if(node.type === 'Question') return ' t-label-q';
      };

      scope.setPaddingClass = function (node, parent) {
        if ((node.type === "Label" && parent.type === "Group") || node.type === "MenuItem") return "t-lvl-1";
        if (node.type === "Label" && parent.type === "MenuItem") return "t-lvl-2";
        if (node.type === "Menu") return "t-menu-node";
      };

      scope.setTreeLabelStartClass = function (node, parentNode) {
        if (node.type !== "Label" || !parentNode) return;
        return "t-label-start-" + parentNode.index;
      };

      scope.getStyles = function (node, parentNode) {
        if (node.type === "Question") node.styles = parentNode.styles;
        if (!node.styles) return;

        var state = node.isDisabled ? "disabled" : "enabled";

        var style = {
          "background-color": node.styles[state].background,
          "color": node.styles[state].foreground
        };

        if (node.type === "Menu") style["display"] = "block";

        return style;
      };

      scope.getStartsStyles = function (node) {
        if (!node.styles) return;

        return {
          "background-color": node.styles.enabled.background
        };
      };

      scope.displayCaret = function (node) {
        return node.type === "Label" && !scope.current.showQuestions;
      };

      scope.displayStart = function (node) {
        return node.type === "Label";
      };

      scope.displayAngle = function (node) {
        var last = scope.current.progress.navigationPath[scope.current.progress.navigationPath.length - 1];
        return last && angular.equals(node, last);
      };
    }
  };
}]);

"use strict";

app.service("SpecConfigFileUploadService", ["$http", "$upload", "$rootScope", "$q", function ($http, $upload, $rootScope, $q) {
  var instance = {
    // upload queues
    questionsSetQueue: [],
    pointListQueue: [],
    bomQueue: [],
    dataSheetQueue: [],
    drawingQueue: [],
    sequenceQueue: [],
    complianceQueue: [],
    consistencyQueue: [],
    specificationQueue: [],

    // currents
    uploadQueue: null,
    uploadType: "",
    batchSize: 1,
    uploading: 0,

    upload: function (id, files, name, specID, type, isEntry, reference) {
      // return if type is empty
      if (!type) return;

      var self = this;
      if (!Array.isArray(files)) files = [files];

      // set currents
      self.setCurrents(type);

      // return if current queue is not valid
      if (!self.uploadQueue) return;

      files.forEach(function (file) {
        self.uploadQueue.push({
          file: file,

          data: {
            id: id,
            name: name,
            type: type,
            specConfigID: specID,
            isEntry: isEntry,
            referenceName: reference && reference.name,
            referenceQuestionSetID: reference && reference.questionSetID
          }
        });
      });

      this.doUpload(type);
    },

    doUpload: function () {
      var self = this;

      // return if current upload is in progress or no items in queue
      if (self.uploading > 0 || self.uploadQueue.length == 0) return;

      // end upload handler
      function endUpload(item) {
        // find and remove uploaded item from queue
        // var index = self.uploadQueue.indexOf(item);
        self.uploadQueue.shift();

        // decrease current uploading counter
        self.uploading--;

        // broadcast upload:all event if queue is empty
        if (!self.uploadQueue.length) $rootScope.$broadcast("upload:all:" + self.uploadType);

        // do upload again if noting is uploading and there are still items in queue...
        else if (!self.uploading) self.doUpload();
      }

      // for each items from batch size...
      var item = self.uploadQueue[0];
      if (!item) return;

      // increase uploading counter
      self.uploading++;

      // call upload endpoint
      item.uploader = $upload.upload({
        url: "/api/specs-file/",
        method: "POST",
        file: item.file,
        data: item.data
      }).progress(function (evt) {
        item.progress = parseInt(100.0 * evt.loaded / evt.total);
        $rootScope.$broadcast("upload:progress:" + self.uploadType, item);
      }).then(function (data) {
        endUpload(item);
        $rootScope.$broadcast("upload:success:" + self.uploadType, data);
      }, function (err) {
        endUpload(item);
        $rootScope.$broadcast("upload:error:" + self.uploadType, err);
      });
    },

    cancelUpload: function (item) {
      // set currents
      this.setCurrents(item.type);

      var index = this.uploadQueue.indexOf(item);
      if (index < 0) return;

      if (item.uploader) item.uploader.abort();
      this.uploadQueue.splice(index, 1);
    },

    setCurrents: function (type) {
      var self = this;
      self.uploadType = type;

      // set current upload queue
      switch (type) {
        case "questionsSet":
          self.uploadQueue = self.questionsSetQueue;
          break;
        case "pointList":
          self.uploadQueue = self.pointListQueue;
          break;
        case "bom":
          self.uploadQueue = self.bomQueue;
          break;
        case "dataSheet":
          self.uploadQueue = self.dataSheetQueue;
          break;
        case "drawing":
          self.uploadQueue = self.drawingQueue;
          break;
        case "sequence":
          self.uploadQueue = self.sequenceQueue;
          break;
        case "compliance":
          self.uploadQueue = self.complianceQueue;
          break;
        case "consistency":
          self.uploadQueue = self.consistencyQueue;
          break;
        case "specification":
          self.uploadQueue = self.specificationQueue;
          break;
      }
    }

  };

  return instance;
}]);

"use strict";

app.service("SpecConfigService", ["$http", "$upload", "$q", "$location", "Auth", "orderByFilter", function ($http, $upload, $q, $location, Auth, orderByFilter) {

  var instance = {
    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/specs/" + id).then(function (response) {
          var spec = response.data;

          // order history on load so we don't need to sort it every time when we need it.
          spec.history = orderByFilter(spec.history, "-uploaded");
          // create files property with actual files that can be referrenced like spec.files[fileType][refID]
          spec.files = {};
          angular.forEach(spec.history, function (file) {
            // initialise type property if not exists
            spec.files[file.entity] = spec.files[file.entity] || {};
            // set file if it is first occurrence
            if (!spec.files[file.entity][file.refID]) {
              spec.files[file.entity][file.refID] = file;
            }
          });

          return resolve(spec);
        });
      });
    },

    list: function () {
      return $q(function (resolve) {
        $http.get("/api/specs/").then(function (response) {
          return resolve(response.data);
        });
      });
    },

    create: function (data) {
      return $http.post("/api/specs", data);
    },

    edit: function (data) {
      return $http.post("/api/specs/edit", data);
    },

    delete: function (id) {
      return $http.delete("/api/specs/" + id);
    },

    publish: function (id) {
      return $q(function (resolve) {
        $http.put("/api/specs/publish/" + id).then(function (response) {
          return resolve(response.data);
        });
      });

    },

    unpublish: function (id, keepActive) {
      return $q(function (resolve) {
        $http.put("/api/specs/unpublish/" + id + "/" + (keepActive ? "true" : "false")).then(function (response) {
          return resolve(response.data);
        });
      });

    },

    loadSnapshots: function (id) {
      return $q(function (resolve) {
        $http.get("/api/specs/" + id + "/snapshots").then(function (response) {
          return resolve(response.data);
        });
      });
    },

    setActiveSnapshot: function (id) {
      return $http.put("/api/specs/snapshot/" + id + "/set-active");
    },

    deleteSnapshot: function (id) {
      return $http.delete("/api/specs/switch/snapshot/" + id);
    },

    revert: function (id, hid, file) {
      return $q(function (resolve) {
        $http.put("/api/questions/" + id + "/" + hid + "/" + file).then(function (response) {
          return resolve(response);
        });
      });
    },

    forget: function (id, hid) {
      return $q(function (resolve) {
        $http.delete("/api/questions/" + id + "/" + hid).then(function (response) {
          return resolve(response);
        });
      });
    },

    officePreviewUrl: function (specID, hID, answersID, menuID) {
      var url = "/api/specs/sign/" + specID + "/" + hID;
      if (answersID) url += "/" + answersID;
      if (answersID && menuID) url += "/" + menuID;

      return $q(function (resolve) {
        $http.put(url).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    checkIfProcessable: function (specID, hID, answersID) {
      var url = "/api/specs/check/" + specID + "/" + hID;
      if (answersID) url += "/" + answersID;

      return $http.put(url);
    },

    referredFiles: function (id) {
      return $q(function (resolve) {
        $http.get("/api/specs/" + id + "/referred").then(function (response) {
          return resolve(response.data);
        });
      });
    },

    itemDownloadUrl: function (spec, itemID) {
      if (!spec) return;
      var list = [];

      angular.forEach(spec.history, function (history) {
        if (history.refID === itemID) list.push(history);
      });

      if (!list.length) return;

      var current = orderByFilter(list, "-uploaded")[0];
      var fileName = "";

      if (current.fileName.indexOf(".") > 0) fileName = current.fileName;
      else fileName = current.fileName + "." + current.extension;

      return this.buildDownloadUrl(current._id, fileName);
    },

    buildDownloadUrl: function (id, name) {
      return "api/file/download/" + id + "/" + name;
    },

    process: function (data) {
      return $q(function (resolve) {
        $http.post("/api/specs/process", data).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    buildProcessUrl: function (answersID, specID) {
      var url = $location.protocol() + "://" + $location.host();
      if ($location.host() === "localhost") url += ":" + $location.port();
      url += "/api/specs/process/" + specID + "/" + answersID;
      return url;
    },

    sendSignedProcessUrl: function (data) {
      return $q(function (resolve) {
        $http.post("/api/specs/send-signed-process-url/", data).then(function (res) {
          resolve(res.data);

        });

      });
    },

    getSharedProjects: function (specID, projectID) {
      return $q(function (resolve) {
        $http.get("/api/specs/get-shared-projects/" + specID + "/" + projectID).then(function (res) {
          if (res.status == 200) {
            resolve(res.data);
          }
        });

      });
    },

    removeSharedProject: function (project) {
      return $q(function (resolve) {
        // sent request her
        $http.delete("/api/specs/remove-shared-project/" + project._id).then(function (res) {
          resolve(res);
        });
      });
    },

    buildDownloadZipUrl: function (specID) {
      var url = $location.protocol() + "://" + $location.host();

      if ($location.host() === "localhost") url += ":" + $location.port();

      url += "/api/specs/" + specID + "/zip";

      return url;
    }
  };

  return instance;
}]);

"use strict";

app.directive("specHeader", ["Lookups", "ProjectService", function (Lookups, ProjectService) {
  return {
    restrict: "EA",
    templateUrl: "components/spec-header/spec-header.html",

    scope: { },

    link: function (scope) {
      scope.current = ProjectService.current;

      Lookups.countries().then(function (data) { scope.countries = data; });
      Lookups.languages().then(function (data) {
        scope.languages = data;
      });
      Lookups.products().then(function (data) { scope.products = data; });
    }
  };
}]);

"use strict";

app.service("SpecificationService", ["$http", "$upload", "$q", function ($http, $upload, $q) {
  var instance = {

    fetch: function (id) {
      return $q(function (resolve) {
        $http.get("/api/specification/" + id).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    fetchByName: function (specID, name) {
      return $q(function (resolve) {
        $http.get("/api/specification/spec/" + specID + "/" + name).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    load: function (specID) {
      return $q(function (resolve) {
        $http.get("/api/specification/spec/" + specID).then(function (response) {
          return resolve(response.data);
        });
      });
    },

    delete: function (id) {
      return $q(function (resolve) {
        $http.delete("/api/specification/" + id).then(function (response) {
          return resolve(response);
        });
      });
    },

    rename: function (id, name) {
      var data = {
        id: id,
        name: name
      };
      return $http.put("/api/specification", data);
    }
  };

  return instance;
}]);

"use strict";

app.service("Storage", ["$cookieStore", "$cookies", "$kookies", function ($cookieStore, $cookies, $kookies) {
  return {
    cookies: {
      get: function (name) {
        // return $cookieStore.get(name);

        var value = $kookies.get(name);
        if (!value) return value;

        if (value.match(/^\{[\s\S]*\}$/))
          value = JSON.parse(value);

        return value;
      },

      set: function (name, value, options) {
        // $cookieStore.put(name, value);

        if (typeof value === "object")
          value = JSON.stringify(value);

        $kookies.set(name, value, options);
        this[name] = value;
      },

      del: function (name) {
        // $cookieStore.remove(name);

        $kookies.remove(name);
        delete this[name];
      }
    },

  };
}]);

/* !
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.11.2 - 2015-03-17T04:08:46.474Z
 * License: MIT
 */

(function () {
  "use strict";

  var KEY = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    HOME: 36,
    END: 35,
    BACKSPACE: 8,
    DELETE: 46,
    COMMAND: 91,

    MAP: { 91: "COMMAND", 8: "BACKSPACE", 9: "TAB", 13: "ENTER", 16: "SHIFT", 17: "CTRL", 18: "ALT", 19: "PAUSEBREAK", 20: "CAPSLOCK", 27: "ESC", 32: "SPACE", 33: "PAGE_UP", 34: "PAGE_DOWN", 35: "END", 36: "HOME", 37: "LEFT", 38: "UP", 39: "RIGHT", 40: "DOWN", 43: "+", 44: "PRINTSCREEN", 45: "INSERT", 46: "DELETE", 48: "0", 49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 59: ";", 61: "=", 65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M", 78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NUMLOCK", 145: "SCROLLLOCK", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
    },

    isControl: function (e) {
      var k = e.which;
      switch (k) {
        case KEY.COMMAND:
        case KEY.SHIFT:
        case KEY.CTRL:
        case KEY.ALT:
          return true;
      }

      if (e.metaKey) return true;

      return false;
    },
    isFunctionKey: function (k) {
      k = k.which ? k.which : k;
      return k >= 112 && k <= 123;
    },
    isVerticalMovement: function (k) {
      return ~[KEY.UP, KEY.DOWN].indexOf(k);
    },
    isHorizontalMovement: function (k) {
      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
    }
  };

  /**
 * Add querySelectorAll() to jqLite.
 *
 * jqLite find() is limited to lookups by tag name.
 * TODO This will change with future versions of AngularJS, to be removed when this happens
 *
 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
 */
  if (angular.element.prototype.querySelectorAll === undefined) {
    angular.element.prototype.querySelectorAll = function (selector) {
      return angular.element(this[0].querySelectorAll(selector));
    };
  }

  /**
 * Add closest() to jqLite.
 */
  if (angular.element.prototype.closest === undefined) {
    angular.element.prototype.closest = function ( selector) {
      var elem = this[0];
      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;

      while (elem) {
        if (matchesSelector.bind(elem)(selector)) {
          return elem;
        } else {
          elem = elem.parentElement;
        }
      }
      return false;
    };
  }

  var latestId = 0;

  var uis = angular.module("ui.select", [])

    .constant("uiSelectConfig", {
      theme: "bootstrap",
      searchEnabled: true,
      sortable: false,
      placeholder: "", // Empty by default, like HTML tag <select>
      refreshDelay: 1000, // In milliseconds
      closeOnSelect: true,
      generateId: function () {
        return latestId++;
      },
      appendToBody: false
    })

  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
    .service("uiSelectMinErr", function () {
      var minErr = angular.$$minErr("ui.select");
      return function () {
        var error = minErr.apply(this, arguments);
        var message = error.message.replace(new RegExp("\nhttp://errors.angularjs.org/.*"), "");
        return new Error(message);
      };
    })

  // Recreates old behavior of ng-transclude. Used internally.
    .directive("uisTranscludeAppend", function () {
      return {
        link: function (scope, element, attrs, ctrl, transclude) {
          transclude(scope, function (clone) {
            element.append(clone);
          });
        }
      };
    })

  /**
 * Highlights text that matches $select.search.
 *
 * Taken from AngularUI Bootstrap Typeahead
 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
 */
    .filter("highlight", function () {
      function escapeRegexp(queryToEscape) {
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
      }

      return function (matchItem, query) {
        return query && matchItem ? matchItem.replace(new RegExp(escapeRegexp(query), "gi"), "<span class=\"ui-select-highlight\">$&</span>") : matchItem;
      };
    })

  /**
 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
 *
 * Taken from AngularUI Bootstrap Position:
 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
 */
    .factory("uisOffset",
      ["$document", "$window", function ($document, $window) {

          return function (element) {
            var boundingClientRect = element[0].getBoundingClientRect();
            return {
              width: boundingClientRect.width || element.prop("offsetWidth"),
              height: boundingClientRect.height || element.prop("offsetHeight"),
              top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
              left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
            };
          };
        }]);

  uis.directive("uiSelectChoices",
    ["uiSelectConfig", "RepeatParser", "uiSelectMinErr", "$compile", function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile) {

        return {
          restrict: "EA",
          require: "^uiSelect",
          replace: true,
          transclude: true,
          templateUrl: function (tElement) {
            // Gets theme attribute from parent (ui-select)
            var theme = tElement.parent().attr("theme") || uiSelectConfig.theme;
            return theme + "/choices.tpl.html";
          },

          compile: function (tElement, tAttrs) {

            if (!tAttrs.repeat) throw uiSelectMinErr("repeat", "Expected 'repeat' expression.");

            return function link(scope, element, attrs, $select, transcludeFn) {

              // var repeat = RepeatParser.parse(attrs.repeat);
              var groupByExp = attrs.groupBy;

              $select.parseRepeatAttr(attrs.repeat, groupByExp); // Result ready at $select.parserResult

              $select.disableChoiceExpression = attrs.uiDisableChoice;
              $select.onHighlightCallback = attrs.onHighlight;

              if (groupByExp) {
                var groups = element.querySelectorAll(".ui-select-choices-group");
                if (groups.length !== 1) throw uiSelectMinErr("rows", "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
                groups.attr("ng-repeat", RepeatParser.getGroupNgRepeatExpression());
              }

              var choices = element.querySelectorAll(".ui-select-choices-row");
              if (choices.length !== 1) {
                throw uiSelectMinErr("rows", "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
              }

              choices.attr("ng-repeat", RepeatParser.getNgRepeatExpression($select.parserResult.itemName, "$select.items", $select.parserResult.trackByExp, groupByExp))
                .attr("ng-if", "$select.open") // Prevent unnecessary watches when dropdown is closed
                .attr("ng-mouseenter", "$select.setActiveItem(" + $select.parserResult.itemName + ")")
                .attr("ng-click", "$select.select(" + $select.parserResult.itemName + ",false,$event)");

              var rowsInner = element.querySelectorAll(".ui-select-choices-row-inner");
              if (rowsInner.length !== 1) throw uiSelectMinErr("rows", "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
              rowsInner.attr("uis-transclude-append", ""); // Adding uisTranscludeAppend directive to row element after choices element has ngRepeat

              $compile(element, transcludeFn)(scope); // Passing current transcludeFn to be able to append elements correctly from uisTranscludeAppend

              scope.$watch("$select.search", function (newValue) {
                if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
                $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
                $select.refresh(attrs.refresh);
              });

              attrs.$observe("refreshDelay", function () {
                // $eval() is needed otherwise we get a string instead of a number
                var refreshDelay = scope.$eval(attrs.refreshDelay);
                $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
              });
            };
          }
        };
      }]);

  /**
 * Contains ui-select "intelligence".
 *
 * The goal is to limit dependency on the DOM whenever possible and
 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
 */
  uis.controller("uiSelectCtrl",
    ["$scope", "$element", "$timeout", "$filter", "RepeatParser", "uiSelectMinErr", "uiSelectConfig", function ($scope, $element, $timeout, $filter, RepeatParser, uiSelectMinErr, uiSelectConfig) {

        var ctrl = this;

        var EMPTY_SEARCH = "";

        ctrl.placeholder = uiSelectConfig.placeholder;
        ctrl.searchEnabled = uiSelectConfig.searchEnabled;
        ctrl.sortable = uiSelectConfig.sortable;
        ctrl.refreshDelay = uiSelectConfig.refreshDelay;

        ctrl.removeSelected = false; // If selected item(s) should be removed from dropdown list
        ctrl.closeOnSelect = true; // Initialized inside uiSelect directive link function
        ctrl.search = EMPTY_SEARCH;

        ctrl.activeIndex = 0; // Dropdown of choices
        ctrl.items = []; // All available choices

        ctrl.open = false;
        ctrl.focus = false;
        ctrl.disabled = false;
        ctrl.selected = undefined;

        ctrl.focusser = undefined; // Reference to input element used to handle focus events
        ctrl.resetSearchInput = true;
        ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
        ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
        ctrl.tagging = { isActivated: false, fct: undefined };
        ctrl.taggingTokens = { isActivated: false, tokens: undefined };
        ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
        ctrl.clickTriggeredSelect = false;
        ctrl.$filter = $filter;

        ctrl.searchInput = $element.querySelectorAll("input.ui-select-search");
        if (ctrl.searchInput.length !== 1) {
          throw uiSelectMinErr("searchInput", "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
        }

        ctrl.isEmpty = function () {
          return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === "";
        };

        // Most of the time the user does not want to empty the search input when in typeahead mode
        function _resetSearchInput() {
          if (ctrl.resetSearchInput || (ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput)) {
            ctrl.search = EMPTY_SEARCH;
            // reset activeIndex
            if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
              ctrl.activeIndex = ctrl.items.indexOf(ctrl.selected);
            }
          }
        }

        // When the user clicks on ui-select, displays the dropdown list
        ctrl.activate = function (initSearchValue, avoidReset) {
          if (!ctrl.disabled && !ctrl.open) {
            if (!avoidReset) _resetSearchInput();

            $scope.$broadcast("uis:activate");

            ctrl.open = true;

            ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;

            // ensure that the index is set to zero for tagging variants
            // that where first option is auto-selected
            if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
              ctrl.activeIndex = 0;
            }

            // Give it time to appear before focus
            $timeout(function () {
              ctrl.search = initSearchValue || ctrl.search;
              ctrl.searchInput[0].focus();
            });
          }
        };

        ctrl.findGroupByName = function (name) {
          return ctrl.groups && ctrl.groups.filter(function (group) {
            return group.name === name;
          })[0];
        };

        ctrl.parseRepeatAttr = function (repeatAttr, groupByExp) {
          function updateGroups(items) {
            ctrl.groups = [];
            angular.forEach(items, function (item) {
              var groupFn = $scope.$eval(groupByExp);
              var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
              var group = ctrl.findGroupByName(groupName);
              if (group) {
                group.items.push(item);
              }
              else {
                ctrl.groups.push({ name: groupName, items: [item] });
              }
            });
            ctrl.items = [];
            ctrl.groups.forEach(function (group) {
              ctrl.items = ctrl.items.concat(group.items);
            });
          }

          function setPlainItems(items) {
            ctrl.items = items;
          }

          ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;

          ctrl.parserResult = RepeatParser.parse(repeatAttr);

          ctrl.isGrouped = !!groupByExp;
          ctrl.itemProperty = ctrl.parserResult.itemName;

          ctrl.refreshItems = function (data) {
            data = data || ctrl.parserResult.source($scope);
            var selectedItems = ctrl.selected;
            // TODO should implement for single mode removeSelected
            if ((angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.removeSelected) {
              ctrl.setItemsFn(data);
            } else {
              if ( data !== undefined ) {
                var filteredItems = data.filter(function (i) {return selectedItems.indexOf(i) < 0;});
                ctrl.setItemsFn(filteredItems);
              }
            }
          };

          // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
          $scope.$watchCollection(ctrl.parserResult.source, function (items) {
            if (items === undefined || items === null) {
              // If the user specifies undefined or null => reset the collection
              // Special case: items can be undefined if the user did not initialized the collection on the scope
              // i.e $scope.addresses = [] is missing
              ctrl.items = [];
            } else {
              if (!angular.isArray(items)) {
                throw uiSelectMinErr("items", "Expected an array but got '{0}'.", items);
              } else {
                // Remove already selected items (ex: while searching)
                // TODO Should add a test
                ctrl.refreshItems(items);
                ctrl.ngModel.$modelValue = null; // Force scope model value and ngModel value to be out of sync to re-run formatters
              }
            }
          });

        };

        var _refreshDelayPromise;

        /**
   * Typeahead mode: lets the user refresh the collection using his own function.
   *
   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
   */
        ctrl.refresh = function (refreshAttr) {
          if (refreshAttr !== undefined) {

            // Debounce
            // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
            // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
            if (_refreshDelayPromise) {
              $timeout.cancel(_refreshDelayPromise);
            }
            _refreshDelayPromise = $timeout(function () {
              $scope.$eval(refreshAttr);
            }, ctrl.refreshDelay);
          }
        };

        ctrl.setActiveItem = function (item) {
          ctrl.activeIndex = ctrl.items.indexOf(item);
        };

        ctrl.isActive = function (itemScope) {
          if ( !ctrl.open ) {
            return false;
          }
          var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
          var isActive = itemIndex === ctrl.activeIndex;

          if ( !isActive || ( itemIndex < 0 && ctrl.taggingLabel !== false ) || ( itemIndex < 0 && ctrl.taggingLabel === false) ) {
            return false;
          }

          if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
            itemScope.$eval(ctrl.onHighlightCallback);
          }

          return isActive;
        };

        ctrl.isDisabled = function (itemScope) {

          if (!ctrl.open) return;

          var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
          var isDisabled = false;
          var item;

          if (itemIndex >= 0 && !angular.isUndefined(ctrl.disableChoiceExpression)) {
            item = ctrl.items[itemIndex];
            isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression)); // force the boolean value
            item._uiSelectChoiceDisabled = isDisabled; // store this for later reference
          }

          return isDisabled;
        };

        // When the user selects an item with ENTER or clicks the dropdown
        ctrl.select = function (item, skipFocusser, $event) {
          if (item === undefined || !item._uiSelectChoiceDisabled) {

            if ( ! ctrl.items && ! ctrl.search ) return;

            if (!item || !item._uiSelectChoiceDisabled) {
              if (ctrl.tagging.isActivated) {
                // if taggingLabel is disabled, we pull from ctrl.search val
                if ( ctrl.taggingLabel === false ) {
                  if ( ctrl.activeIndex < 0 ) {
                    item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
                    if (!item || angular.equals( ctrl.items[0], item ) ) {
                      return;
                    }
                  } else {
                    // keyboard nav happened first, user selected from dropdown
                    item = ctrl.items[ctrl.activeIndex];
                  }
                } else {
                  // tagging always operates at index zero, taggingLabel === false pushes
                  // the ctrl.search value without having it injected
                  if ( ctrl.activeIndex === 0 ) {
                    // ctrl.tagging pushes items to ctrl.items, so we only have empty val
                    // for `item` if it is a detected duplicate
                    if ( item === undefined ) return;

                    // create new item on the fly if we don't already have one;
                    // use tagging function if we have one
                    if ( ctrl.tagging.fct !== undefined && typeof item === "string" ) {
                      item = ctrl.tagging.fct(ctrl.search);
                      if (!item) return;
                      // if item type is 'string', apply the tagging label
                    } else if ( typeof item === "string" ) {
                      // trim the trailing space
                      item = item.replace(ctrl.taggingLabel, "").trim();
                    }
                  }
                }
                // search ctrl.selected for dupes potentially caused by tagging and return early if found
                if ( ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter( function (selection) { return angular.equals(selection, item); }).length > 0 ) {
                  ctrl.close(skipFocusser);
                  return;
                }
              }

              $scope.$broadcast("uis:select", item);

              var locals = {};
              locals[ctrl.parserResult.itemName] = item;

              $timeout(function () {
                ctrl.onSelectCallback($scope, {
                  $item: item,
                  $model: ctrl.parserResult.modelMapper($scope, locals)
                });
              });

              if (ctrl.closeOnSelect) {
                ctrl.close(skipFocusser);
              }
              if ($event && $event.type === "click") {
                ctrl.clickTriggeredSelect = true;
              }
            }
          }
        };

        // Closes the dropdown
        ctrl.close = function (skipFocusser) {
          if (!ctrl.open) return;
          if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
          _resetSearchInput();
          ctrl.open = false;

          $scope.$broadcast("uis:close", skipFocusser);

        };

        ctrl.setFocus = function () {
          if (!ctrl.focus) ctrl.focusInput[0].focus();
        };

        ctrl.clear = function ($event) {
          ctrl.select(undefined);
          $event.stopPropagation();
          ctrl.focusser[0].focus();
        };

        // Toggle dropdown
        ctrl.toggle = function (e) {
          if (ctrl.open) {
            ctrl.close();
            e.preventDefault();
            e.stopPropagation();
          } else {
            ctrl.activate();
          }
        };

        ctrl.isLocked = function (itemScope, itemIndex) {
          var isLocked, item = ctrl.selected[itemIndex];

          if (item && !angular.isUndefined(ctrl.lockChoiceExpression)) {
            isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression)); // force the boolean value
            item._uiSelectChoiceLocked = isLocked; // store this for later reference
          }

          return isLocked;
        };

        var sizeWatch = null;
        ctrl.sizeSearchInput = function () {

          var input = ctrl.searchInput[0],
            container = ctrl.searchInput.parent().parent()[0],
            calculateContainerWidth = function () {
              // Return the container width only if the search input is visible
              return container.clientWidth * !!input.offsetParent;
            },
            updateIfVisible = function (containerWidth) {
              if (containerWidth === 0) {
                return false;
              }
              var inputWidth = containerWidth - input.offsetLeft - 10;
              if (inputWidth < 50) inputWidth = containerWidth;
              ctrl.searchInput.css("width", inputWidth + "px");
              return true;
            };

          ctrl.searchInput.css("width", "10px");
          $timeout(function () { // Give tags time to render correctly
            if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
              sizeWatch = $scope.$watch(calculateContainerWidth, function (containerWidth) {
                if (updateIfVisible(containerWidth)) {
                  sizeWatch();
                  sizeWatch = null;
                }
              });
            }
          });
        };

        function _handleDropDownSelection(key) {
          var processed = true;
          switch (key) {
            case KEY.DOWN:
              if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); // In case its the search input in 'multiple' mode
              else if (ctrl.activeIndex < ctrl.items.length - 1) { ctrl.activeIndex++; }
              break;
            case KEY.UP:
              if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); // In case its the search input in 'multiple' mode
              else if (ctrl.activeIndex > 0 || (ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1)) { ctrl.activeIndex--; }
              break;
            case KEY.TAB:
              if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
              break;
            case KEY.ENTER:
              if (ctrl.open && ctrl.activeIndex >= 0) {
                ctrl.select(ctrl.items[ctrl.activeIndex]); // Make sure at least one dropdown item is highlighted before adding.
              } else {
                ctrl.activate(false, true); // In case its the search input in 'multiple' mode
              }
              break;
            case KEY.ESC:
              ctrl.close();
              break;
            default:
              processed = false;
          }
          return processed;
        }

        // Bind to keyboard shortcuts
        ctrl.searchInput.on("keydown", function (e) {
          var key = e.which;
          $scope.$apply(function () {
            var tagged = false;

            if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
              _handleDropDownSelection(key);
              if ( ctrl.taggingTokens.isActivated ) {
                for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
                  if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
                    // make sure there is a new value to push via tagging
                    if ( ctrl.search.length > 0 ) {
                      tagged = true;
                    }
                  }
                }
                if ( tagged ) {
                  $timeout(function () {
                    ctrl.searchInput.triggerHandler("tagged");
                    var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], "").trim();
                    if ( ctrl.tagging.fct ) {
                      newItem = ctrl.tagging.fct( newItem );
                    }
                    if (newItem) ctrl.select(newItem, true);
                  });
                }
              }
            }

          });

          if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
            _ensureHighlightVisible();
          }

        });

        // If tagging try to split by tokens and add items
        ctrl.searchInput.on("paste", function (e) {
          var data = e.originalEvent.clipboardData.getData("text/plain");
          if (data && data.length > 0 && ctrl.taggingTokens.isActivated && ctrl.tagging.fct) {
            var items = data.split(ctrl.taggingTokens.tokens[0]); // split by first token only
            if (items && items.length > 0) {
              angular.forEach(items, function (item) {
                var newItem = ctrl.tagging.fct(item);
                if (newItem) {
                  ctrl.select(newItem, true);
                }
              });
              e.preventDefault();
              e.stopPropagation();
            }
          }
        });

        ctrl.searchInput.on("tagged", function () {
          $timeout(function () {
            _resetSearchInput();
          });
        });

        // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
        function _ensureHighlightVisible() {
          var container = $element.querySelectorAll(".ui-select-choices-content");
          var choices = container.querySelectorAll(".ui-select-choices-row");
          if (choices.length < 1) {
            throw uiSelectMinErr("choices", "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
          }

          if (ctrl.activeIndex < 0) {
            return;
          }

          var highlighted = choices[ctrl.activeIndex];
          var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
          var height = container[0].offsetHeight;

          if (posY > height) {
            container[0].scrollTop += posY - height;
          } else if (posY < highlighted.clientHeight) {
            if (ctrl.isGrouped && ctrl.activeIndex === 0)
              container[0].scrollTop = 0; // To make group header visible when going all the way up
            else
              container[0].scrollTop -= highlighted.clientHeight - posY;
          }
        }

        $scope.$on("$destroy", function () {
          ctrl.searchInput.off("keyup keydown tagged blur paste");
        });

      }]);

  uis.directive("uiSelect",
    ["$document", "uiSelectConfig", "uiSelectMinErr", "uisOffset", "$compile", "$parse", "$timeout", function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {

        return {
          restrict: "EA",
          templateUrl: function (tElement, tAttrs) {
            var theme = tAttrs.theme || uiSelectConfig.theme;
            return theme + (angular.isDefined(tAttrs.multiple) ? "/select-multiple.tpl.html" : "/select.tpl.html");
          },
          replace: true,
          transclude: true,
          require: ["uiSelect", "^ngModel"],
          scope: true,

          controller: "uiSelectCtrl",
          controllerAs: "$select",
          compile: function (tElement, tAttrs) {

            // Multiple or Single depending if multiple attribute presence
            if (angular.isDefined(tAttrs.multiple))
              tElement.append("<ui-select-multiple/>").removeAttr("multiple");
            else
              tElement.append("<ui-select-single/>");

            return function (scope, element, attrs, ctrls, transcludeFn) {

              var $select = ctrls[0];
              var ngModel = ctrls[1];

              $select.generatedId = uiSelectConfig.generateId();
              $select.baseTitle = attrs.title || "Select box";
              $select.focusserTitle = $select.baseTitle + " focus";
              $select.focusserId = "focusser-" + $select.generatedId;

              $select.closeOnSelect = function () {
                if (angular.isDefined(attrs.closeOnSelect)) {
                  return $parse(attrs.closeOnSelect)();
                } else {
                  return uiSelectConfig.closeOnSelect;
                }
              }();

              $select.onSelectCallback = $parse(attrs.onSelect);
              $select.onRemoveCallback = $parse(attrs.onRemove);

              // Set reference to ngModel from uiSelectCtrl
              $select.ngModel = ngModel;

              $select.choiceGrouped = function (group) {
                return $select.isGrouped && group && group.name;
              };

              if (attrs.tabindex) {
                attrs.$observe("tabindex", function (value) {
                  $select.focusInput.attr("tabindex", value);
                  element.removeAttr("tabindex");
                });
              }

              scope.$watch("searchEnabled", function () {
                var searchEnabled = scope.$eval(attrs.searchEnabled);
                $select.searchEnabled = searchEnabled !== undefined ? searchEnabled : uiSelectConfig.searchEnabled;
              });

              scope.$watch("sortable", function () {
                var sortable = scope.$eval(attrs.sortable);
                $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
              });

              attrs.$observe("disabled", function () {
                // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
                $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
              });

              attrs.$observe("resetSearchInput", function () {
                // $eval() is needed otherwise we get a string instead of a boolean
                var resetSearchInput = scope.$eval(attrs.resetSearchInput);
                $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
              });

              attrs.$observe("tagging", function () {
                if (attrs.tagging !== undefined)
                {
                  // $eval() is needed otherwise we get a string instead of a boolean
                  var taggingEval = scope.$eval(attrs.tagging);
                  $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
                }
                else
                {
                  $select.tagging = { isActivated: false, fct: undefined };
                }
              });

              attrs.$observe("taggingLabel", function () {
                if (attrs.tagging !== undefined )
                {
                  // check eval for FALSE, in this case, we disable the labels
                  // associated with tagging
                  if ( attrs.taggingLabel === "false" ) {
                    $select.taggingLabel = false;
                  }
                  else
                  {
                    $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : "(new)";
                  }
                }
              });

              attrs.$observe("taggingTokens", function () {
                if (attrs.tagging !== undefined) {
                  var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split("|") : [",", "ENTER"];
                  $select.taggingTokens = { isActivated: true, tokens: tokens };
                }
              });

              // Automatically gets focus when loaded
              if (angular.isDefined(attrs.autofocus)) {
                $timeout(function () {
                  $select.setFocus();
                });
              }

              // Gets focus based on scope event name (e.g. focus-on='SomeEventName')
              if (angular.isDefined(attrs.focusOn)) {
                scope.$on(attrs.focusOn, function () {
                  $timeout(function () {
                    $select.setFocus();
                  });
                });
              }

              function onDocumentClick(e) {
                if (!$select.open) return; // Skip it if dropdown is close

                var contains = false;

                if (window.jQuery) {
                  // Firefox 3.6 does not support element.contains()
                  // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
                  contains = window.jQuery.contains(element[0], e.target);
                } else {
                  contains = element[0].contains(e.target);
                }

                if (!contains && !$select.clickTriggeredSelect) {
                  // Will lose focus only with certain targets
                  var focusableControls = ["input", "button", "textarea"];
                  var targetScope = angular.element(e.target).scope(); // To check if target is other ui-select
                  var skipFocusser = targetScope && targetScope.$select && targetScope.$select !== $select; // To check if target is other ui-select
                  if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); // Check if target is input, button or textarea
                  $select.close(skipFocusser);
                  scope.$digest();
                }
                $select.clickTriggeredSelect = false;
              }

              // See Click everywhere but here event http://stackoverflow.com/questions/12931369
              $document.on("click", onDocumentClick);

              scope.$on("$destroy", function () {
                $document.off("click", onDocumentClick);
              });

              // Move transcluded elements to their correct position in main template
              transcludeFn(scope, function (clone) {
                // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

                // One day jqLite will be replaced by jQuery and we will be able to write:
                // var transcludedElement = clone.filter('.my-class')
                // instead of creating a hackish DOM element:
                var transcluded = angular.element("<div>").append(clone);

                var transcludedMatch = transcluded.querySelectorAll(".ui-select-match");
                transcludedMatch.removeAttr("ui-select-match"); // To avoid loop in case directive as attr
                transcludedMatch.removeAttr("data-ui-select-match"); // Properly handle HTML5 data-attributes
                if (transcludedMatch.length !== 1) {
                  throw uiSelectMinErr("transcluded", "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
                }
                element.querySelectorAll(".ui-select-match").replaceWith(transcludedMatch);

                var transcludedChoices = transcluded.querySelectorAll(".ui-select-choices");
                transcludedChoices.removeAttr("ui-select-choices"); // To avoid loop in case directive as attr
                transcludedChoices.removeAttr("data-ui-select-choices"); // Properly handle HTML5 data-attributes
                if (transcludedChoices.length !== 1) {
                  throw uiSelectMinErr("transcluded", "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
                }
                element.querySelectorAll(".ui-select-choices").replaceWith(transcludedChoices);
              });

              // Support for appending the select field to the body when its open
              var appendToBody = scope.$eval(attrs.appendToBody);
              if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
                scope.$watch("$select.open", function (isOpen) {
                  if (isOpen) {
                    positionDropdown();
                  } else {
                    resetDropdown();
                  }
                });

                // Move the dropdown back to its original location when the scope is destroyed. Otherwise
                // it might stick around when the user routes away or the select field is otherwise removed
                scope.$on("$destroy", function () {
                  resetDropdown();
                });
              }

              // Hold on to a reference to the .ui-select-container element for appendToBody support
              var placeholder = null,
                originalWidth = "";

              function positionDropdown() {
                // Remember the absolute position of the element
                var offset = uisOffset(element);

                // Clone the element into a placeholder element to take its original place in the DOM
                placeholder = angular.element("<div class=\"ui-select-placeholder\"></div>");
                placeholder[0].style.width = offset.width + "px";
                placeholder[0].style.height = offset.height + "px";
                element.after(placeholder);

                // Remember the original value of the element width inline style, so it can be restored
                // when the dropdown is closed
                originalWidth = element[0].style.width;

                // Now move the actual dropdown element to the end of the body
                $document.find("body").append(element);

                element[0].style.position = "absolute";
                element[0].style.left = offset.left + "px";
                element[0].style.top = offset.top + "px";
                element[0].style.width = offset.width + "px";
              }

              function resetDropdown() {
                if (placeholder === null) {
                  // The dropdown has not actually been display yet, so there's nothing to reset
                  return;
                }

                // Move the dropdown element back to its original location in the DOM
                placeholder.replaceWith(element);
                placeholder = null;

                element[0].style.position = "";
                element[0].style.left = "";
                element[0].style.top = "";
                element[0].style.width = originalWidth;
              }
            };
          }
        };
      }]);

  uis.directive("uiSelectMatch", ["uiSelectConfig", function (uiSelectConfig) {
    return {
      restrict: "EA",
      require: "^uiSelect",
      replace: true,
      transclude: true,
      templateUrl: function (tElement) {
      // Gets theme attribute from parent (ui-select)
        var theme = tElement.parent().attr("theme") || uiSelectConfig.theme;
        var multi = tElement.parent().attr("multiple");
        return theme + (multi ? "/match-multiple.tpl.html" : "/match.tpl.html");
      },
      link: function (scope, element, attrs, $select) {
        $select.lockChoiceExpression = attrs.uiLockChoice;
        attrs.$observe("placeholder", function (placeholder) {
          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
        });

        function setAllowClear(allow) {
          $select.allowClear = (angular.isDefined(allow)) ? (allow === "") ? true : (allow.toLowerCase() === "true") : false;
        }

        attrs.$observe("allowClear", setAllowClear);
        setAllowClear(attrs.allowClear);

        if ($select.multiple) {
          $select.sizeSearchInput();
        }

      }
    };
  }]);

  uis.directive("uiSelectMultiple", ["uiSelectMinErr", "$timeout", function (uiSelectMinErr, $timeout) {
    return {
      restrict: "EA",
      require: ["^uiSelect", "^ngModel"],

      controller: ["$scope", "$timeout", function ($scope, $timeout) {

        var ctrl = this,
          $select = $scope.$select,
          ngModel;

        // Wait for link fn to inject it
        $scope.$evalAsync(function () { ngModel = $scope.ngModel; });

        ctrl.activeMatchIndex = -1;

        ctrl.updateModel = function () {
          ngModel.$setViewValue(Date.now()); // Set timestamp as a unique string to force changes
          ctrl.refreshComponent();
        };

        ctrl.refreshComponent = function () {
        // Remove already selected items
        // e.g. When user clicks on a selection, the selected array changes and
        // the dropdown should remove that item
          $select.refreshItems();
          $select.sizeSearchInput();
        };

        // Remove item from multiple select
        ctrl.removeChoice = function (index) {

          var removedChoice = $select.selected[index];

          // if the choice is locked, can't remove it
          if (removedChoice._uiSelectChoiceLocked) return;

          var locals = {};
          locals[$select.parserResult.itemName] = removedChoice;

          $select.selected.splice(index, 1);
          ctrl.activeMatchIndex = -1;
          $select.sizeSearchInput();

          // Give some time for scope propagation.
          $timeout(function () {
            $select.onRemoveCallback($scope, {
              $item: removedChoice,
              $model: $select.parserResult.modelMapper($scope, locals)
            });
          });

          ctrl.updateModel();

        };

        ctrl.getPlaceholder = function () {
        // Refactor single?
          if ($select.selected.length) return;
          return $select.placeholder;
        };

      }],
      controllerAs: "$selectMultiple",

      link: function (scope, element, attrs, ctrls) {

        var $select = ctrls[0];
        var ngModel = scope.ngModel = ctrls[1];
        var $selectMultiple = scope.$selectMultiple;

        // $select.selected = raw selected objects (ignoring any property binding)

        $select.multiple = true;
        $select.removeSelected = true;

        // Input that will handle focus
        $select.focusInput = $select.searchInput;

        // From view --> model
        ngModel.$parsers.unshift(function () {
          var locals = {},
            result,
            resultMultiple = [];
          for (var j = $select.selected.length - 1; j >= 0; j--) {
            locals = {};
            locals[$select.parserResult.itemName] = $select.selected[j];
            result = $select.parserResult.modelMapper(scope, locals);
            resultMultiple.unshift(result);
          }
          return resultMultiple;
        });

        // From model --> view
        ngModel.$formatters.unshift(function (inputValue) {
          var data = $select.parserResult.source (scope, { $select: { search: "" } }), // Overwrite $search
            locals = {},
            result;
          if (!data) return inputValue;
          var resultMultiple = [];
          var checkFnMultiple = function (list, value) {
            if (!list || !list.length) return;
            for (var p = list.length - 1; p >= 0; p--) {
              locals[$select.parserResult.itemName] = list[p];
              result = $select.parserResult.modelMapper(scope, locals);
              if ($select.parserResult.trackByExp) {
                var matches = /\.(.+)/.exec($select.parserResult.trackByExp);
                if (matches.length > 0 && result[matches[1]] == value[matches[1]]) {
                  resultMultiple.unshift(list[p]);
                  return true;
                }
              }
              if (angular.equals(result, value)) {
                resultMultiple.unshift(list[p]);
                return true;
              }
            }
            return false;
          };
          if (!inputValue) return resultMultiple; // If ngModel was undefined
          for (var k = inputValue.length - 1; k >= 0; k--) {
          // Check model array of currently selected items
            if (!checkFnMultiple($select.selected, inputValue[k])) {
            // Check model array of all items available
              if (!checkFnMultiple(data, inputValue[k])) {
              // If not found on previous lists, just add it directly to resultMultiple
                resultMultiple.unshift(inputValue[k]);
              }
            }
          }
          return resultMultiple;
        });

        // Watch for external model changes
        scope.$watchCollection(function () { return ngModel.$modelValue; }, function (newValue, oldValue) {
          if (oldValue != newValue) {
            ngModel.$modelValue = null; // Force scope model value and ngModel value to be out of sync to re-run formatters
            $selectMultiple.refreshComponent();
          }
        });

        ngModel.$render = function () {
        // Make sure that model value is array
          if (!angular.isArray(ngModel.$viewValue)) {
          // Have tolerance for null or undefined values
            if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null) {
              $select.selected = [];
            } else {
              throw uiSelectMinErr("multiarr", "Expected model value to be array but got '{0}'", ngModel.$viewValue);
            }
          }
          $select.selected = ngModel.$viewValue;
          scope.$evalAsync(); // To force $digest
        };

        scope.$on("uis:select", function (event, item) {
          $select.selected.push(item);
          $selectMultiple.updateModel();
        });

        scope.$on("uis:activate", function () {
          $selectMultiple.activeMatchIndex = -1;
        });

        scope.$watch("$select.disabled", function (newValue, oldValue) {
        // As the search input field may now become visible, it may be necessary to recompute its size
          if (oldValue && !newValue) $select.sizeSearchInput();
        });

        $select.searchInput.on("keydown", function (e) {
          var key = e.which;
          scope.$apply(function () {
            var processed = false;
            // var tagged = false; //Checkme
            if (KEY.isHorizontalMovement(key)) {
              processed = _handleMatchSelection(key);
            }
            if (processed && key != KEY.TAB) {
            // TODO Check si el tab selecciona aun correctamente
            // Crear test
              e.preventDefault();
              e.stopPropagation();
            }
          });
        });
        function _getCaretPosition(el) {
          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
          else return el.value.length;
        }
        // Handles selected options in "multiple" mode
        function _handleMatchSelection(key) {
          var caretPosition = _getCaretPosition($select.searchInput[0]),
            length = $select.selected.length,
            // none  = -1,
            first = 0,
            last = length - 1,
            curr = $selectMultiple.activeMatchIndex,
            next = $selectMultiple.activeMatchIndex + 1,
            prev = $selectMultiple.activeMatchIndex - 1,
            newIndex = curr;

          if (caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;

          $select.close();

          function getNewActiveMatchIndex() {
            switch (key) {
              case KEY.LEFT:
              // Select previous/first item
                if (~$selectMultiple.activeMatchIndex) return prev;
                // Select last item
                else return last;
                break;
              case KEY.RIGHT:
              // Open drop-down
                if (!~$selectMultiple.activeMatchIndex || curr === last) {
                  $select.activate();
                  return false;
                }
                // Select next/last item
                else return next;
                break;
              case KEY.BACKSPACE:
              // Remove selected item and select previous/first
                if (~$selectMultiple.activeMatchIndex) {
                  $selectMultiple.removeChoice(curr);
                  return prev;
                }
                // Select last item
                else return last;
                break;
              case KEY.DELETE:
              // Remove selected item and select next item
                if (~$selectMultiple.activeMatchIndex) {
                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
                  return curr;
                }
                else return false;
            }
          }

          newIndex = getNewActiveMatchIndex();

          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
          else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));

          return true;
        }

        $select.searchInput.on("keyup", function (e) {

          if ( ! KEY.isVerticalMovement(e.which) ) {
            scope.$evalAsync( function () {
              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
            });
          }
          // Push a "create new" item into array if there is a search string
          if ( $select.tagging.isActivated && $select.search.length > 0 ) {

            // return early with these keys
            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
              return;
            }
            // always reset the activeIndex to the first item when tagging
            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
            // taggingLabel === false bypasses all of this
            if ($select.taggingLabel === false) return;

            var items = angular.copy( $select.items );
            var stashArr = angular.copy( $select.items );
            var newItem;
            var item;
            var hasTag = false;
            var dupeIndex = -1;
            var tagItems;
            var tagItem;

            // case for object tagging via transform `$select.tagging.fct` function
            if ( $select.tagging.fct !== undefined) {
              tagItems = $select.$filter("filter")(items, { "isTag": true });
              if ( tagItems.length > 0 ) {
                tagItem = tagItems[0];
              }
              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
              if ( items.length > 0 && tagItem ) {
                hasTag = true;
                items = items.slice(1, items.length);
                stashArr = stashArr.slice(1, stashArr.length);
              }
              newItem = $select.tagging.fct($select.search);
              newItem.isTag = true;
              // verify the the tag doesn't match the value of an existing item
              if ( stashArr.filter( function (origItem) { return angular.equals( origItem, $select.tagging.fct($select.search) ); } ).length > 0 ) {
                return;
              }
              newItem.isTag = true;
              // handle newItem string and stripping dupes in tagging string context
            } else {
            // find any tagging items already in the $select.items array and store them
              tagItems = $select.$filter("filter")(items, function (item) {
                return item.match($select.taggingLabel);
              });
              if ( tagItems.length > 0 ) {
                tagItem = tagItems[0];
              }
              item = items[0];
              // remove existing tag item if found (should only ever be one tag item)
              if ( item !== undefined && items.length > 0 && tagItem ) {
                hasTag = true;
                items = items.slice(1, items.length);
                stashArr = stashArr.slice(1, stashArr.length);
              }
              newItem = $select.search + " " + $select.taggingLabel;
              if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
                return;
              }
              // verify the the tag doesn't match the value of an existing item from
              // the searched data set or the items already selected
              if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
              // if there is a tag from prev iteration, strip it / queue the change
              // and return early
                if ( hasTag ) {
                  items = stashArr;
                  scope.$evalAsync( function () {
                    $select.activeIndex = 0;
                    $select.items = items;
                  });
                }
                return;
              }
              if ( _findCaseInsensitiveDupe(stashArr) ) {
              // if there is a tag from prev iteration, strip it
                if ( hasTag ) {
                  $select.items = stashArr.slice(1, stashArr.length);
                }
                return;
              }
            }
            if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
            // dupe found, shave the first item
            if ( dupeIndex > -1 ) {
              items = items.slice(dupeIndex + 1, items.length - 1);
            } else {
              items = [];
              items.push(newItem);
              items = items.concat(stashArr);
            }
            scope.$evalAsync( function () {
              $select.activeIndex = 0;
              $select.items = items;
            });
          }
        });
        function _findCaseInsensitiveDupe(arr) {
          if ( arr === undefined || $select.search === undefined ) {
            return false;
          }
          var hasDupe = arr.filter( function (origItem) {
            if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
              return false;
            }
            return origItem.toUpperCase() === $select.search.toUpperCase();
          }).length > 0;

          return hasDupe;
        }
        function _findApproxDupe(haystack, needle) {
          var dupeIndex = -1;
          if (angular.isArray(haystack)) {
            var tempArr = angular.copy(haystack);
            for (var i = 0; i < tempArr.length; i++) {
            // handle the simple string version of tagging
              if ( $select.tagging.fct === undefined ) {
              // search the array for the match
                if ( tempArr[i] + " " + $select.taggingLabel === needle ) {
                  dupeIndex = i;
                }
                // handle the object tagging implementation
              } else {
                var mockObj = tempArr[i];
                mockObj.isTag = true;
                if ( angular.equals(mockObj, needle) ) {
                  dupeIndex = i;
                }
              }
            }
          }
          return dupeIndex;
        }

        $select.searchInput.on("blur", function () {
          $timeout(function () {
            $selectMultiple.activeMatchIndex = -1;
          });
        });

      }
    };
  }]);
  uis.directive("uiSelectSingle", ["$timeout", "$compile", function ($timeout, $compile) {
    return {
      restrict: "EA",
      require: ["^uiSelect", "^ngModel"],
      link: function (scope, element, attrs, ctrls) {

        var $select = ctrls[0];
        var ngModel = ctrls[1];

        // From view --> model
        ngModel.$parsers.unshift(function (inputValue) {
          var locals = {},
            result;
          locals[$select.parserResult.itemName] = inputValue;
          result = $select.parserResult.modelMapper(scope, locals);
          return result;
        });

        // From model --> view
        ngModel.$formatters.unshift(function (inputValue) {
          var data = $select.parserResult.source (scope, { $select: { search: "" } }), // Overwrite $search
            locals = {},
            result;
          if (data) {
            var checkFnSingle = function (d) {
              locals[$select.parserResult.itemName] = d;
              result = $select.parserResult.modelMapper(scope, locals);
              return result == inputValue;
            };
            // If possible pass same object stored in $select.selected
            if ($select.selected && checkFnSingle($select.selected)) {
              return $select.selected;
            }
            for (var i = data.length - 1; i >= 0; i--) {
              if (checkFnSingle(data[i])) return data[i];
            }
          }
          return inputValue;
        });

        // Update viewValue if model change
        scope.$watch("$select.selected", function (newValue) {
          if (ngModel.$viewValue !== newValue) {
            ngModel.$setViewValue(newValue);
          }
        });

        ngModel.$render = function () {
          $select.selected = ngModel.$viewValue;
        };

        scope.$on("uis:select", function (event, item) {
          $select.selected = item;
        });

        scope.$on("uis:close", function (event, skipFocusser) {
          $timeout(function () {
            $select.focusser.prop("disabled", false);
            if (!skipFocusser) $select.focusser[0].focus();
          }, 0, false);
        });

        scope.$on("uis:activate", function () {
          focusser.prop("disabled", true); // Will reactivate it on .close()
        });

        // Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
        $compile(focusser)(scope);
        $select.focusser = focusser;

        // Input that will handle focus
        $select.focusInput = focusser;

        element.parent().append(focusser);
        focusser.bind("focus", function () {
          scope.$evalAsync(function () {
            $select.focus = true;
          });
        });
        focusser.bind("blur", function () {
          scope.$evalAsync(function () {
            $select.focus = false;
          });
        });
        focusser.bind("keydown", function (e) {

          if (e.which === KEY.BACKSPACE) {
            e.preventDefault();
            e.stopPropagation();
            $select.select(undefined);
            scope.$apply();
            return;
          }

          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
            return;
          }

          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
            e.preventDefault();
            e.stopPropagation();
            $select.activate();
          }

          scope.$digest();
        });

        focusser.bind("keyup input", function (e) {

          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
            return;
          }

          $select.activate(focusser.val()); // User pressed some regular key, so we pass it to the search input
          focusser.val("");
          scope.$digest();

        });

      }
    };
  }]);
  // Make multiple matches sortable
  uis.directive("uiSelectSort", ["$timeout", "uiSelectConfig", "uiSelectMinErr", function ($timeout, uiSelectConfig, uiSelectMinErr) {
    return {
      require: "^uiSelect",
      link: function (scope, element, attrs, $select) {
        if (scope[attrs.uiSelectSort] === null) {
          throw uiSelectMinErr("sort", "Expected a list to sort");
        }

        var options = angular.extend({
          axis: "horizontal"
        },
        scope.$eval(attrs.uiSelectSortOptions));

        var axis = options.axis,
          draggingClassName = "dragging",
          droppingClassName = "dropping",
          droppingBeforeClassName = "dropping-before",
          droppingAfterClassName = "dropping-after";

        scope.$watch(function () {
          return $select.sortable;
        }, function (n) {
          if (n) {
            element.attr("draggable", true);
          } else {
            element.removeAttr("draggable");
          }
        });

        element.on("dragstart", function (e) {
          element.addClass(draggingClassName);

          (e.dataTransfer || e.originalEvent.dataTransfer).setData("text/plain", scope.$index);
        });

        element.on("dragend", function () {
          element.removeClass(draggingClassName);
        });

        var move = function (from, to) {
        /* jshint validthis: true */
          this.splice(to, 0, this.splice(from, 1)[0]);
        };

        var dragOverHandler = function (e) {
          e.preventDefault();

          var offset = axis === "vertical" ? e.offsetY || e.layerY || (e.originalEvent ? e.originalEvent.offsetY : 0) : e.offsetX || e.layerX || (e.originalEvent ? e.originalEvent.offsetX : 0);

          if (offset < (this[axis === "vertical" ? "offsetHeight" : "offsetWidth"] / 2)) {
            element.removeClass(droppingAfterClassName);
            element.addClass(droppingBeforeClassName);

          } else {
            element.removeClass(droppingBeforeClassName);
            element.addClass(droppingAfterClassName);
          }
        };

        var dropTimeout;

        var dropHandler = function (e) {
          e.preventDefault();

          var droppedItemIndex = parseInt((e.dataTransfer || e.originalEvent.dataTransfer).getData("text/plain"), 10);

          // prevent event firing multiple times in firefox
          $timeout.cancel(dropTimeout);
          dropTimeout = $timeout(function () {
            _dropHandler(droppedItemIndex);
          }, 20);
        };

        var _dropHandler = function (droppedItemIndex) {
          var theList = scope.$eval(attrs.uiSelectSort),
            itemToMove = theList[droppedItemIndex],
            newIndex = null;

          if (element.hasClass(droppingBeforeClassName)) {
            if (droppedItemIndex < scope.$index) {
              newIndex = scope.$index - 1;
            } else {
              newIndex = scope.$index;
            }
          } else {
            if (droppedItemIndex < scope.$index) {
              newIndex = scope.$index;
            } else {
              newIndex = scope.$index + 1;
            }
          }

          move.apply(theList, [droppedItemIndex, newIndex]);

          scope.$apply(function () {
            scope.$emit("uiSelectSort:change", {
              array: theList,
              item: itemToMove,
              from: droppedItemIndex,
              to: newIndex
            });
          });

          element.removeClass(droppingClassName);
          element.removeClass(droppingBeforeClassName);
          element.removeClass(droppingAfterClassName);

          element.off("drop", dropHandler);
        };

        element.on("dragenter", function () {
          if (element.hasClass(draggingClassName)) {
            return;
          }

          element.addClass(droppingClassName);

          element.on("dragover", dragOverHandler);
          element.on("drop", dropHandler);
        });

        element.on("dragleave", function (e) {
          if (e.target != element) {
            return;
          }
          element.removeClass(droppingClassName);
          element.removeClass(droppingBeforeClassName);
          element.removeClass(droppingAfterClassName);

          element.off("dragover", dragOverHandler);
          element.off("drop", dropHandler);
        });
      }
    };
  }]);

  /**
 * Parses "repeat" attribute.
 *
 * Taken from AngularJS ngRepeat source code
 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
 *
 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
 */

  uis.service("uisRepeatParser", ["uiSelectMinErr", "$parse", function (uiSelectMinErr, $parse) {
    var self = this;

    /**
   * Example:
   * expression = "address in addresses | filter: {street: $select.search} track by $index"
   * itemName = "address",
   * source = "addresses | filter: {street: $select.search}",
   * trackByExp = "$index",
   */
    self.parse = function (expression) {

      var match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?([\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw uiSelectMinErr("iexp", "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
          expression);
      }

      return {
        itemName: match[2], // (lhs) Left-hand side,
        source: $parse(match[3]),
        trackByExp: match[4],
        modelMapper: $parse(match[1] || match[2])
      };

    };

    self.getGroupNgRepeatExpression = function () {
      return "$group in $select.groups";
    };

    self.getNgRepeatExpression = function (itemName, source, trackByExp, grouped) {
      var expression = itemName + " in " + (grouped ? "$group.items" : source);
      if (trackByExp) {
        expression += " track by " + trackByExp;
      }
      return expression;
    };
  }]);

}());
angular.module("ui.select").run(["$templateCache", function ($templateCache) {$templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content dropdown-menu\" role=\"listbox\" ng-show=\"$select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><a href=\"javascript:void(0)\" class=\"ui-select-choices-row-inner\"></a></div></li></ul>");
  $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected\"><span class=\"ui-select-match-item btn btn-primary btn-xs\" style=\"padding: 5px 5px 4px !important\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" style=\"padding: 5px 5px 4px !important\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
  $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-primary-focus\':$select.focus}\" style=\"padding: 5px 5px 4px !important\"><span tabindex=\"-1\" class=\"btn btn-primary form-control ui-select-toggle\" style=\"padding: 5px 5px 4px !important\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty()\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
  $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div></div>");
  $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><input type=\"text\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"form-control ui-select-search\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.searchEnabled && $select.open\"><div class=\"ui-select-choices\"></div></div>");
  $templateCache.put("select2/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
  $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
  $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
  $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"ui-select-choices\"></div></div></div>");
  $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div></div></div>");
  $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
  $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"($select.open || $select.isEmpty())\" class=\"ui-select-match\" ng-transclude=\"\"></div>");
  $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.activate()\"><div class=\"ui-select-match\"></div><input type=\"text\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.searchEnabled || ($select.selected && !$select.open)\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div></div>");}]);

"use strict";

app.service("UsersService", ["$http", "$upload", "$q", function ($http, $upload, $q) {

  var instance = {

    list: function () {
      return $q(function (resolve) {
        $http.get("/api/users").then(function (response) {
          return resolve(response.data);
        });
      });
    },

    update: function (user) {
      return $q(function (resolve) {
        $http.put("/api/users", user).then(function (response) {
          return resolve(response.data);
        });
      });
    }
  };

  return instance;
}]);

"use strict";

app.service("Utils", function () {
  function stripEmptyProperties(obj) {
    if (typeof obj === "string") return obj;

    var tmp = {};

    angular.forEach(obj, function (value, key) {
      if (key[0] === "$" || key[0] === "_" || !value) return;

      if (Array.isArray(value)) {
        if (value.length) tmp[key] = [];

        value.forEach(function (val) {
          tmp[key].push(stripEmptyProperties(val));
        });

      } else if (typeof value === "object") {
        tmp[key] = stripEmptyProperties(value);
      } else tmp[key] = value;
    });

    return tmp;
  }

  return {
    stripEmptyProperties: stripEmptyProperties
  };
});

"use strict";

app.directive("validNumber", function () {
  return {
    require: "?ngModel",
    link: function (scope, element, attrs, ngModelCtrl) {
      if (!ngModelCtrl) {
        return;
      }

      ngModelCtrl.$parsers.push(function (val) {
        if (angular.isUndefined(val)) {
          // var val = '';
        }
        var clean = val.replace(/[^0-9\.]/g, "");
        var decimalCheck = clean.split(".");

        if (!angular.isUndefined(decimalCheck[1])) {
          decimalCheck[1] = decimalCheck[1].slice(0, 2);
          clean = decimalCheck[0] + "." + decimalCheck[1];
        }

        if (val !== clean) {
          ngModelCtrl.$setViewValue(clean);
          ngModelCtrl.$render();
        }
        return clean;
      });

      element.bind("keypress", function (event) {
        if (event.keyCode === 32) {
          event.preventDefault();
        }
      });
    }
  };
});

"use strict";

app.directive("setErrorStyle", function () {
  return {
    restrict: "A",

    link: function (scope, element) {
      var formName = element.parents("form").attr("name");
      var inputName = element.children("[ng-model]").attr("name");

      scope.$watch(formName + ".$submitted", function (submitted) {
        scope.$watch(formName + "." + inputName + ".$valid", function (valid) {
          if (!submitted) return;

          element.removeClass("has-error").removeClass("has-success")
            .addClass(valid ? "has-success" : "has-error");
        });
      });
    }
  };
}).directive("errorMessage", ["$log", function ($log) {
  return {
    restrict: "E",

    link: function (scope, element, attrs) {
      element.hide();

      var formName = element.parents("form").attr("name");
      var inputName = element.parents(".form-group").children("[ng-model]").attr("name");

      scope.$watch(formName + ".$submitted", function (submitted) {
        scope.$watch(formName + "." + inputName + ".$error", function (error) {
          var hasError = Object.getOwnPropertyNames(error).length;

          var show = submitted && hasError;
          if (show && attrs.on) show = show && error[attrs.on];
          if (show) element.show(); else element.hide();
        }, true);
      });
    }
  };
}]);

app.controller("FolderListController", ["$scope", "$compile", "$stateParams", "$location", "$window", "orderByFilter", "Confirm", "Lookups", "Auth", "ProjectService", "ProjectGroupingService", "SpecConfigService", "CreateProjectDialog", "ProjectNameDialog", "ProjectSharingDialog", "SpecHistoryDialog", "DTOptionsBuilder", "DTColumnBuilder", "SharedLinkService", "gettextCatalog", "$rootScope", function (
  $scope,
  $compile,
  $stateParams,
  $location,
  $window,
  orderByFilter,
  Confirm,
  Lookups,
  Auth,
  ProjectService,
  ProjectGroupingService,
  SpecConfigService,
  CreateProjectDialog,
  ProjectNameDialog,
  ProjectSharingDialog,
  SpecHistoryDialog,
  DTOptionsBuilder,
  DTColumnBuilder,
  SharedLinkService,
  gettextCatalog,
  $rootScope
) {
  $scope.folderId = $stateParams.folderId || "shared-specs";
  $scope.teamSpecificationFlag = $scope.folderId === "shared-specs";

  $scope.tableID = "newspecs-data-table";
  $scope.specConfigs = null;

  $scope.breadCrumbs = [];

  $scope.users = [];

  $scope.sharedProjects = [];

  $scope.enableTeamSpecification = function () {
    $scope.teamSpecificationFlag = true;
    $scope.dt.instance.reloadData();
  };

  $scope.disableTeamSpecification = function () {
    $scope.teamSpecificationFlag = false;
    $scope.dt.instance.reloadData();
  };

  $scope.getTeamNames = function (project) {
    $scope.names = [];
    project.access.forEach(function (userId) {
      $scope.users.find(function (user) {
        if (user._id == userId) {
          $scope.names.push(user.username);
        }
      });
      project.team = $scope.names;
    });
  };

  $scope.manageProjects = function () {
    $location.path("/");
  };

  $scope.$on("side-tree:init-finished", function (event, data) {
    $scope.initBreadCrumbs(data.tree);

  });
  $scope.$on("side-tree:node-moved", function (event, data) {
    $scope.dt.instance.reloadData();
  });

  ProjectGroupingService.loadFolder($stateParams.folderId).then(function (folder) {
    $scope.folderName = folder.name;
  });

  $scope.initBreadCrumbs = function (tree) {
    var path = ProjectGroupingService.getNodePath(tree, $stateParams.folderId);
    var breadCrumbs = [];
    var current = tree[path.shift()];

    breadCrumbs.push({
      name: current.name,
      url: $window.location.origin + "/folder/" + current._id
    });

    path.forEach(function (index, i) {
      breadCrumbs.push({
        name: current.nodes[index].name,
        url: i + 1 !== path.length ? $window.location.origin + "/folder/" + current.nodes[index]._id : ""
      });

      current = current.nodes[index];
    });
    if (breadCrumbs.length === 1) {
      breadCrumbs[0].url = "";
    }

    $scope.breadCrumbs = breadCrumbs;
  };

  $scope.downloadFiles = function () {
    $scope.$broadcast("download-files-for-for-folder", { folderId: $stateParams.folderId });
  };

  $scope.createSpec = function () {
    var folderId = $stateParams.folderId;

    ProjectService.load().then(function (list) {
      var options = {
        specs: $scope.specConfigs,
        folderId: folderId
      };

      if (list && list.length) {
        $scope.latestProject = orderByFilter(list, "-created")[0];

        var latestSpec = _.find($scope.specConfigs, function (item) {
          return item._id === $scope.latestProject.specConfigID;
        });

        if (latestSpec)
          options.previous = {
            specID: latestSpec._id,
            key: latestSpec.key
          };
      }

      CreateProjectDialog.open(options).then();
    });
  };

  $scope.getShareableLink = function () {
    SharedLinkService.open();
  };

  SpecConfigService.list().then(function (data) {
    $scope.specConfigs = data;

    Lookups.countries().then(function (data) {
      $scope.countries = data;

      Lookups.languages().then(function (data) {
        $scope.languages = data;

        Lookups.products().then(function (data) {
          $scope.products = data;
          $scope.dt = { instance: null };

          $scope.copy = function (project) {
            ProjectNameDialog.open(project.name).then(function (result) {
              ProjectService.copy(project._id, result).then(function () {
                reloadData();
              });
            });
          };

          $scope.rename = function (project) {
            ProjectNameDialog.open(project.name).then(function (result) {
              ProjectService.rename(project._id, result).then(function () {
                $scope.$broadcast("folder-list:update-view");
                reloadData();
              });
            });
          };

          $scope.invite = function (project) {
            ProjectSharingDialog.open(project).then(function () {
              reloadData();
            });
          };

          $scope.loadShared = function () {
            var user = Auth.getCurrentUser();
            return ProjectService.loadShared(user._id);
          };

          $scope.delete = function (item) {
            Confirm.open("Are you sure you want to delete specification ?", "Delete Specification", "md").then(
              function (result) {
                if (!result) return;

                ProjectService.delete(item._id, $stateParams.folderId).then(function () {
                  $scope.$broadcast("folder-list:update-view");
                  reloadData();
                });
              }
            );
          };

          $scope.leaveTeam = function (item) {
            ProjectService.leaveSpecTeam(item._id).then(function () { }).then(function () {
              reloadData();
            });
          };

          $scope.create = function () {
            ProjectService.load().then(function (list) {
              var options = {
                specs: $scope.specConfigs
              };

              if (list && list.length) {
                $scope.latestProject = orderByFilter(list, "-created")[0];

                var latestSpec = _.find($scope.specConfigs, function (item) {
                  return item._id === $scope.latestProject.specConfigID;
                });

                if (latestSpec)
                  options.previous = {
                    specID: latestSpec._id,
                    key: latestSpec.key
                  };
              }

              CreateProjectDialog.open(options).then();
            });
          };

          $scope.history = function (project) {
            SpecHistoryDialog.open(project);
          };

          $scope.open = function (project) {
            // $location.path('/folder/' + project._id)
            $window.location.href = "/admin/project/open/" + project._id;
          };

          function reloadData() {
            if ($scope.dt.instance) $scope.dt.instance.reloadData();
          }
        });

        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
          // return promise that resolves into array of rows for data table
          if ($scope.teamSpecificationFlag) {
            return $scope.loadShared().then(function (data) {
              $scope.sharedProjects = data;
              return data;
            });
          } else {
            return ProjectGroupingService.getFolderChildren($stateParams.folderId).then(function (nodes) {
              return nodes
                .filter(function (node) { return node.project; })
                .map(function (node) { return node.project; });
            });
          }
        }).withBootstrap() // Add Bootstrap compatibility
          .withPaginationType("full_numbers")
          .withOption("createdRow", createdRow)
          .withOption("order", [1, "asc"])
          .withDOM("<\"top\"<\"#tableAddBtn.col col-lg-1\">f>rt<\"bottom\"pl<\"text-center\"i>><\"clear\">");

        function createdRow(row, data, dataIndex) {
          // create new row scope from $scope. false means not isolated so row scope will have access to controller scope
          var rowScope = $scope.$new(false);
          // set file with row data same way as it happens with ng-repeat
          rowScope.project = data;
          // mimic ng-repeat $index
          rowScope.$index = dataIndex;

          // Recompiling so we can bind Angular directive to the DT
          $compile(angular.element(row).contents())(rowScope);
        }

        $scope.dtColumns = [
          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Actions")).notSortable().renderWith(actionsHtml),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Specification name")).renderWith(function (project, type) {
            return "<a ng-click=\"open(project)\" href=\"#\">" + project.name + "</a>";
          }),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Progress")).renderWith(function (project, type) {
            if (!project.progress) return;
            return (project.progress.reached + "/" + project.progress.total);
          }),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Country")).renderWith(function (project, type) {
            return (getSpecInfo(project) || {}).country || gettextCatalog.getString("not available");
          }),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Product")).renderWith(function (project, type) {
            return (getSpecInfo(project) || {}).product || gettextCatalog.getString("not available");
          }),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Language")).renderWith(function (project, type) {
            return (getSpecInfo(project) || {}).language || gettextCatalog.getString("not available");
          }),

          DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Team")).renderWith(function (project, type) {
            if (project.access && project.access.length > 0) {
              var emails = project.access.map(function (accessObj) {
                return accessObj.email;
              });

              return emails.join("<br />");
            } else {
              return gettextCatalog.getString("not available");
            }
          })
        ];

        // if it's admin show spec alias in table
        if (Auth.isAdmin() || Auth.isInRole("master") || Auth.isInRole("tester")) {
          $scope.dtColumns.push(DTColumnBuilder.newColumn(null).withTitle(gettextCatalog.getString("Spec")).renderWith(function (project, type) {
            return (getSpecInfo(project) || {}).alias || gettextCatalog.getString("not available");
          }));
        }

        function actionsHtml() {
          return "<div class=\"btn-group dropdown\">" +
            "<a class=\"btn btn-default btn-primary dropdown-toggle\"> " +
            "<span translate >Actions</span> <i class=\"fa fa-caret-down\"></i>" +
            " </a>" +
            "<ul role=\"menu\" class=\"dropdown-menu dropdown-menu-left\">" +
            "<li><a class=\"btn-lg\" ng-click=\"open(project)\" title=\"Open Project\"><i class=\"fa fa-folder-open-o\"></i> <span translate >Open</span></a></li>" +
            "<li ng-hide=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"copy(project)\" title=\"Copy Project\"><i class=\"fa fa-copy\"></i> <span translate >Copy</span></a></li>" +
            "<li ng-show=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"copy(project)\" title=\"Copy to My Specifications\"><i class=\"fa fa-copy\"></i> <span translate >Copy to My Specifications</span></a></li>" +
            "<li><a class=\"btn-lg\" ng-click=\"history(project)\" title=\"History\"><i class=\"fa fa-history\"></i> <span translate >History</span></a></li>" +
            "<li ng-hide=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"rename(project)\" title=\"Rename Project\"><i class=\"fa fa-pencil\"></i> <span translate>Rename spec</span></a></li>" +
            "<li ng-hide=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"invite(project)\" title=\"Invite Team\"><i class=\"fa fa-share-alt\"></i> <span translate>Invite Team</span></a></li>" +
            "<li ng-hide=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"delete(project, $index)\" title=\"Delete Project\"><i class=\"fa fa-trash-o\"></i> <span translate> Delete</span></a></li>" +
            "<li ng-show=\"teamSpecificationFlag\"><a class=\"btn-lg\" ng-click=\"leaveTeam(project)\" title=\"Delete (Leave team)\"><i class=\"fa fa-trash-o\"></i> <span translate>Delete (Leave team)</span></a></li>" +
            "</ul>" +
            "</div>";
        }

        function getSpecInfo(project) {
          for (var i = 0; i < $scope.specConfigs.length; i++) {
            var spec = $scope.specConfigs[i];

            if (project.specConfigID === spec._id) {
              var data = {
                alias: spec.alias,
                country: $scope.countries.getName(spec.key.country),
                language: $scope.languages.getName(spec.key.language),
                product: $scope.products.getName(spec.key.product),
              };

              return data;
            }
          }
        }
      });
    });
  });
}]);

app.directive("sideTreeDirective", ["ProjectGroupingService", "$window", "$stateParams", "NewSubfolderDialog", "localStorageService", "Message", "ProjectNameDialog", "ProjectService", "$state", "$location", function (
  ProjectGroupingService,
  $window,
  $stateParams,
  NewSubfolderDialog,
  localStorageService,
  Message,
  ProjectNameDialog,
  ProjectService,
  $state,
  $location
) {
  return {
    restrict: "E",
    templateUrl: "components/project-grouping/side-tree.directive.html",

    scope: true,

    link: function (scope) {
      scope.current = ProjectService.current;

      scope.$on("folder-list:update-view", function () {
        init();
      });

      scope.$on("download-files-for-for-folder", function (e, args) {
        var folderId = args.folderId;

        ProjectGroupingService.getFolderChildren(folderId).then(function (projects) {
          downloadFiles({ nodes: projects }).then(function (result) {
            $window.open(result.data); // data is a url  actually downloads
          });
        });
      });

      scope.dropOutside = function (e, ui) {
        if (!scope.options.movingFromNode.isFolder) {
          Message.open("you can't move project outside of folder", "Move denied", "md", "error");
          return false;
        }

        scope.tree.forEach(function (branch, i) {
          if (branch._id == scope.options.movingFromNode) {
            scope.tree.splice(i, 1);
          } else {
            ProjectGroupingService.removeFromNode(branch, scope.options.movingFromNode);
          }
        });

        scope.tree.push(scope.options.movingFromNode);

        ProjectGroupingService.updateFolders(scope.tree).then(function (res) {
          init();
          scope.$emit("side-tree:node-moved");
        });
      };

      scope.rename = function (node) {
        ProjectNameDialog.open(node.name).then(function (newName) {
          var path = ProjectGroupingService.getNodePath(scope.tree, node._id).slice(0, -1);
          var target = scope.tree[path.shift()]; // get first depth and remove firs element fom path

          path.forEach(function (p) {
            target = target.nodes[p];
          });

          if (target) {
            for (var ti = 0; ti < target.nodes.length; ti++) {
              var n = target.nodes[ti];

              if (n.name === newName) {
                Message.open("duplicate name " + newName, "folder creating denied", "md", "error");
                return;
              }
            }
          }

          ProjectGroupingService.rename(node._id, newName).then(function () {
            init();
          });
        });
      };

      scope.delete = function (node) {
        // node is a node to remove
        if (node.nodes && node.nodes instanceof Array && node.nodes.length > 0) {
          Message.open("This folder is not empty", "Removal denied", "md", "error");
          return false;
        }

        if (node._id === $stateParams.folderId) {
          Message.open("You have to leave this folder before removing it", "Removal denied", "md", "error");
          return false;
        }

        scope.tree.forEach(function (branch, i) {
          if (branch._id === node._id) {
            scope.tree.splice(i, 1);
          } else {
            ProjectGroupingService.removeFromNode(branch, node);
          }
        });

        ProjectGroupingService.updateFolders(scope.tree).then(function (res) {
          init();
        });

      };

      scope.addSubFolder = function () {
        NewSubfolderDialog.open().then(function (name) {
          if (name) {
            var path = ProjectGroupingService.getNodePath(scope.tree, scope.current.folder._id);
            var target = scope.tree[path.shift()]; // get first depth and remove firs element fom path

            path.forEach(function (p) {
              target = target.nodes[p];
            });

            for (var ti = 0; ti < target.nodes.length; ti++) {
              var n = target.nodes[ti];

              if (n.name === name) {
                Message.open("duplicate name " + name, "folder creating denied", "md", "error");
                return;
              }
            }

            ProjectGroupingService.addSubFolder(scope.current.folder._id, name).then(function (folder) {
              $window.setTimeout(function () {
                $location.path("/folder/" + folder._id);
              }, 0);
            });
          }
        });
      };

      scope.nodeIsSelected = function (node) {
        return node.isFolder && (
          $state.current.name === "folder_list" && node._id === $stateParams.folderId
        ) || (
          $state.current.name === "admin_project_build" && scope.current.folder._id
        ) || !node.isFolder && node.project._id === $stateParams.projectID;
      };

      scope.getNodeChildren = function (node) {
        return node.isFolder && scope.nodeIsExpanded(node) && node.nodes || [];
      };

      scope.nodeIsExpanded = function (node) {
        return node.isFolder && scope.expandedNodes[node._id];
      };

      scope.toggleNodeExpand = function (node) {
        if (!node.isFolder) return;
        scope.expandedNodes[node._id] = !scope.expandedNodes[node._id];
        localStorageService.set("expandedFolderNodes", JSON.stringify(scope.expandedNodes));
      };

      scope.toggleTree = function () {
        scope.treeClosed = !scope.treeClosed;
        localStorageService.set("treeClosed", scope.treeClosed);
      };

      scope.tree = [];
      scope.expandedNodes = {};
      scope.treeLoaded = false;

      init();

      function init() {
        ProjectGroupingService.loadPopulated().then(function (data) {
          console.log(data);

          scope.treeLoaded = true;
          scope.tree = data.sort(function (a, b) {
            return String(a.name).localeCompare(String(b.name));
          });

          scope.expandedNodes = JSON.parse(
            localStorageService.get("expandedFolderNodes") || "{}"
          );

          scope.treeClosed = localStorageService.get("treeClosed") !== undefined ? localStorageService.get("treeClosed") : true;
          scope.$emit("side-tree:init-finished", { tree: data });
        });
      }

      function downloadFiles(folder) {
        $("html").append("<div id=\"spinning\"></div>");

        return ProjectGroupingService.downloadFiles(folder).then(function (result) {
          $("#spinning").remove();
          return result;
        });
      }

      scope.openProject = function (projectId) {
        $window.location.href = $window.location.protocol + "//" + $window.location.host + "/" + "admin/project/open/" + projectId;
      };

      scope.sidebarWidth = function () {
        return $("#sidebar").width();
      };

      function initResize() {
        $("#sidebar").resizable();
      }

      initResize();
    }
  };
}]);

app.service("ProjectGroupingService", ["$http", "$q", function ($http, $q) {
  var instance = {
    populatedTree: null,

    /**
     * get data row
     * @returns {*}
     */
    load: function () {

      return $q(function (resolve) {
        return $http.get("/api/xzproject-grouping/get-all").then(function (res) {

          return resolve(res.data);
        });
      });
    },

    loadFolder: function (id) {
      return $q(function (resolve) {
        return $http.get("/api/project-grouping/folder/" + id).then(function (res) {

          return resolve(res.data);
        });
      });
    },

    loadPopulated: function (existing) {
      existing = !!existing;
      var self = this;
      if (existing && self.populatedTree) {
        console.log("loading existing populated tree");
        return self.populatedTree;
      } else {
        return $q(function (resolve) {
          return $http.get("/api/project-grouping/get-all-populated").then(function (res) {
            self.populatedTree = res.data;
            return resolve(res.data);
          });
        });
      }

    },

    createForProject: function (projectId, forNewFolder, folderName, folderId) {
      return $q(function (resolve) {
        return $http.post("/api/project-grouping/create-new-for-project/" + projectId, {
          forNewFolder: forNewFolder,
          folderName: folderName,
          folderId: folderId
        }).then(function (res) {
          return resolve(res.data);
        });
      });
    },

    /*
    *   clear node tree from removed projects
    * */
    removeDeleted: function (node, projects) {
      var that = this;
      var ids = projects.map(function (proj) {
        return proj.id;
      });

      if (node.isFolder) {
        node.nodes.forEach(function (n) {
          if (n.isFolder) {
            that.removeDeleted(n, projects);
          } else {
            if (ids.indexOf(n.projectId) === -1) {
              // console.log('to be removed', node.nodes)
              node.nodes.splice(4, 1);
            }
          }
        });
      } else {
        if (ids.indexOf(node.projectId) === -1) {
          // console.log('to be removed', node.projectId)
          node = null;
        }
      }

    },

    removeRootFolder: function (folderId) {
      return $q(function (resolve) {
        return $http.delete("/api/project-grouping/remove-root-folder/" + folderId).then(function (data) {
          resolve(data);
        });
      });
    },

    /*
    *
    * downloads all project files
    * */
    downloadFiles: function (node) {
      return $q(function (resolve) {
        return $http.post("/api/project-grouping/get-download-link", { node: node }).then(function (data) {
          resolve(data);
        });
      });
    },

    getNodePath: function (folders, folderId) {
      var self = this;
      if (folders && folders.length > 0) {

        for (var i = 0; i < folders.length; i++) {
          var path = [i];
          var folder = folders[i];

          if (folder._id == folderId) {
            return path;
          } else {
            var otherPath = self.getNodePath(folder.nodes, folderId);
            if (otherPath.length > 0) {
              return path.concat(otherPath);
            }
          }
        }
        return [];
      }

      return [];

    },

    getSharableLinkForFolder: function (folderId) {
      return $q(function (resolve) {
        return $http.get("/api/project-grouping/get-sharable-link-for-folder/" + folderId).then(function (result) {

          resolve(result.data);
        });
      });
    },

    removeFromNode: function (root, node) {
      var self = this;
      var nodes = Array.isArray(root.nodes) ? root.nodes : [];

      for (var i = 0; i < nodes.length; i++) {
        var n = root.nodes[i];

        if (n == node) {
          root.nodes.splice(i, 1);
          return true;
        } else {
          self.removeFromNode(n, node);
        }
      }
    },

    updateFolders: function (folders) {
      function unpopulateRecursively(folders) {

        folders.forEach(function (node) {
          if (!node.isFolder && node.project) {

            node.project = node.project._id;
          } else {
            unpopulateRecursively(node.nodes || []);
          }
        });
      }

      unpopulateRecursively(folders);

      return $q(function (resolve) {
        return $http.post("/api/project-grouping/update-folders", { folders: folders }).then(function (data) {
          resolve(data);
        });
      });
    },

    /*
    * collects all projects in node and subnodes
    * returns array
    * */
    collectChildren: function (node, children) {

      var that = this;
      children = children || [];
      if (!node.nodes || (node.nodes instanceof Array && node.nodes.length === 0)) { // node has no children left
        return children;
      } else {
        node.nodes.forEach(function (node) {
          if (!node.isFolder) { // if node is project
            children.push(node);
          } else {
            return that.collectChildren(node, children);
          }
        });
        return children;
      }
    }
    ,

    addSubFolder: function (folderId, name) {
      return $q(function (resolve) {
        return $http.post("/api/project-grouping/add-sub-folder/" + folderId, { name: name }).then(function (response) {

          resolve(response.data);
        });
      });
    },

    addRootFolder: function (name) {
      return $q(function (resolve) {
        return $http.post("/api/project-grouping/add-root-folder/", { name: name }).then(function (response) {
          resolve(response.data);
        });
      });
    },

    mongoObjectId: function () {
      var m = arguments.length <= 0 || arguments[0] === undefined ? Math : arguments[0];
      var d = arguments.length <= 1 || arguments[1] === undefined ? Date : arguments[1];
      var h = arguments.length <= 2 || arguments[2] === undefined ? 16 : arguments[2];
      var s = arguments.length <= 3 || arguments[3] === undefined ? function (s) {
        return m.floor(s).toString(h);
      } : arguments[3];
      return s(d.now() / 1000) + " ".repeat(h).replace(/./g, function () {
        return s(m.random() * h);
      });
    },

    removeKey: function (node, key) {
      var that = this;

      if (key in node) {
        console.log(key);
        delete node[key];
      }
      if (node.nodes && (Array.isArray(node.nodes) && node.nodes.length > 0)) {
        node.nodes.forEach(function (n) {
          that.removeKey(n, "downloadable");
        });
      }

    },

    getFolderChildren: function (folderId) {
      return $q(function (resolve) {
        return $http.get("/api/project-grouping/get-folder-children/" + folderId).then(function (response) {
          resolve(response.data);
        });
      });

    },

    rename: function (id, newName) {
      return $q(function (resolve) {
        return $http.post("/api/project-grouping/rename/" + id, { newName: newName }).then(function (response) {
          resolve(response.data);
        });
      });
    },

    folderByProjectId: function (id) {
      return $q(function (resolve) {
        return $http.get("/api/project-grouping/load-by-project/" + id).then(function (response) {
          resolve(response.data);
        });
      });
    },

    folderByProjectAndUserId: function (userId, id) {
      return $q(function (resolve) {
        return $http.get("/api/project-grouping/load-by-project/" + userId + "/" + id).then(function (response) {
          resolve(response.data);
        });
      });

    }

  };
  return instance;
}]);

"use strict";

app.controller("newSubfolderDialogCtrl", ["$scope", "$modalInstance", function ($scope, $modalInstance) {

  $scope.name = "";

  $scope.close = function () {
    $modalInstance.close();
  };

  $scope.disableSave = function () {
    return !$scope.name;
  };

  $scope.save = function () {
    if ($scope.disableSave()) return;
    $modalInstance.close($scope.name);
  };

}]);

"use strict";

app.service("NewSubfolderDialog", ["$modal", function ($modal) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/project-grouping/new-sub-folder-dialog.html",
      controller: "newSubfolderDialogCtrl",
      size: "s",
      resolve: {
        options: function () { return options; }
      }
    }).result;
  };

}]);

"use strict";

app.service("SharedLinkService", ["$modal", "$http", "$q", function ($modal, $http, $q) {
  this.open = function (options) {
    return $modal.open({
      templateUrl: "components/project-grouping/shared-link.html",
      controller: "SharedLinkController",
      size: "lg",
      resolve: {
        options: function () {
          return options;
        }
      }
    }).result;
  };

  this.sendShares = function (postData) {
    return $q(function (resolve) {
      return $http.post("/api/project-sharing/send-shares", postData).then(function (response) {
        resolve(response.data);
      });
    });
  };
  this.getFolderSahres = function (folderId) {
    return $q(function (resolve) {
      return $http.get("/api/project-sharing/get-shares/" + folderId).then(function (response) {
        resolve(response.data);
      });
    });
  };

  this.removeShare = function (id) {
    return $q(function (resolve) {
      return $http.delete("/api/project-sharing/remove-share/" + id).then(function (response) {
        resolve(response.data);
      });
    });
  };

}]);

"use strict";

app.controller("SharedLinkController", ["$scope", "$modalInstance", "$document", "options", "$stateParams", "SharedLinkService", "ProjectGroupingService", "$window", "Confirm", function ($scope, $modalInstance, $document, options, $stateParams, SharedLinkService, ProjectGroupingService, $window, Confirm) {

  // $scope.url = options.url

  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.sharableProjects = [];
  $scope.shares = [];
  $scope.activeTab = "addSharing"; // viewSharing

  $scope.init = function () {
    ProjectGroupingService.getFolderChildren($stateParams.folderId).then(function (data) {
      console.log("data is", data);
      $scope.sharableProjects = data.filter(function (f) {
        return !f.isFolder;
      }).map(function (p) {
        if (Array.isArray(p.project.download)) {
          if (p.project.download.length > 0) {
            p.project.downloadable = true;
          } else {
            p.project.downloadable = false;
          }
        } else {
          p.project.downloadable = false;
        }
        return p;
      });
      //   .filter(function (f) {
      //   return Array.isArray(f.project.download) && f.project.download.length > 0
      // })
      console.log($scope.sharableProjects);

    });
  };
  $scope.initShares = function () {
    console.log("here");
    SharedLinkService.getFolderSahres($stateParams.folderId).then(function (data) {
      $scope.shares = data.map(function (share) {
        if (share.expTime == 0) {
          share.expDate = "permanent";
          return share;
        } else {
          var date = new Date(share.created_at);
          var unixTimestamp = Number(date.getTime()) + Number(share.expTime) * 1000;
          var newDate = new Date(unixTimestamp);
          share.expDate = newDate.getFullYear() + "/" + String(newDate.getMonth() + 1).padStart(2, "0") + "/" + String(newDate.getDate()).padStart(2, "0");
          return share;
        }

      });
    });
  };
  $scope.init();
  $scope.initShares();

  $scope.postData = {
    folderId: $stateParams.folderId,
    shares: {},
    expTime: "",
    emails: ""
  };

  $scope.isSharable = function () {

    return $scope.sharableProjects.length && $scope.postData.emails && $scope.postData.expTime !== "";
  };

  $scope.sendShares = function () {

    console.log("posting post data", $scope.postData);
    SharedLinkService.sendShares($scope.postData).then(function (data) {
      console.log("just sent shares, got data", data);
      alert("project successfully shared");
      $scope.initShares();
      $scope.close();

    });

  };
  $scope.removeShare = function (id) {
    Confirm.open("Are you sure you want to remove share?", "Remove Share", "md").then(function (yes) {
      if (yes) {
        SharedLinkService.removeShare(id).then(function (data) {
          $scope.initShares();

        });
      }
    });

  };

  $scope.toggleShow = function (id) {
    $("#" + id).toggle();
    $(".specs-list:not(#" + id + ")").hide();

  };
  $scope.openProject = function (project) {
    $window.location.href = "/admin/project/open/" + project._id;
  };

}]);

"use strict";

app.controller("HeaderController", ["$scope", "LanguageService", function ($scope, LanguageService ) {

  $scope.currentLang = function () { return LanguageService.getCurrentLanguage()["key"]; };

}]);

angular.module("swolApp").run(["$templateCache", function($templateCache) {
$templateCache.put("components/spec-header/spec-header.html", "<div><div><span translate=\"translate\"> Country</span><b>&nbsp;{{ countries.getName(current.spec.key.country) }}</b></div><div><span translate=\"translate\">Product</span><b>&nbsp;{{ products.getName(current.spec.key.product) }}</b></div><div><span translate=\"translate\">Language</span><b>&nbsp;{{ languages.getName(current.spec.key.language) }}</b></div></div>");
$templateCache.put("components/spec-builder/spec-navigator.html", "<div class=\"spec-builder-tree spec-navigation-menu-tree\"><treecontrol class=\"tree-classic non-selectable\" ng-repeat=\"qs in current.progress.questionSets | filter: filterBacks\" tree-model=\"qs.questions.navigation\" expanded-nodes=\"current.progress.expandedNodes\"><div class=\"{{setNodeClass(node, $parentNode)}}\" ng-show=\"displayNode(node)\"><div class=\"t-label-start\" ng-show=\"displayStart(node)\" ng-style=\"getStartsStyles(node)\">&nbsp;</div><div class=\"tree-item {{setTreeNodeClass(node, $parentNode, $index)}}\" ng-click=\"navigateTo(node, qs)\" ng-style=\"getStyles(node, $parentNode)\"><span class=\"{{setPaddingClass(node, $parentNode)}}\"><span class=\"fa\" ng-click=\"switchExpand(node, $event)\" ng-hide=\"displayCaret(node)\" ng-class=\"{ \'fa-caret-right\': node.children &amp;&amp; !node.exp, \'fa-caret-down\': node.children &amp;&amp; node.exp, \'fa-file-text-o\': !node.children }\" ng-style=\"{\'margin-left\' : node.type === \'Menu\' ? \'0px\' : \'\'}\">&nbsp;</span><span ng-class=\"{\'node-selected\': (node.isSelected) }\">{{ getName(node) }} {{ setPath(node, $parentNode) }}<span ng-if=\"node.type === \'Menu\'\"></span></span></span><span class=\"pull-right\" ng-if=\"node.type === \'Menu\'\"><div class=\"fa fa-plus t-menu-create\" ng-click=\"createMenuItem(node, qs)\"></div>&nbsp;<div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total &gt; 0 &amp;&amp; node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt;= 0 &amp;&amp; node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span><span class=\"pull-right\" ng-if=\"node.type === \'MenuItem\'\"><div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span></div></div></treecontrol><treecontrol class=\"tree-classic non-selectable\" tree-model=\"current.navigation\" expanded-nodes=\"current.progress.expandedNodes\"><div class=\"{{setNodeClass(node, $parentNode)}}\" ng-show=\"displayNode(node)\"><div class=\"t-label-start\" ng-show=\"displayStart(node)\" ng-style=\"getStartsStyles(node)\">&nbsp;</div><div class=\"tree-item {{setTreeNodeClass(node, $parentNode, $index)}}\" ng-click=\"navigateTo(node, current.questionSet, $event)\" ng-style=\"getStyles(node, $parentNode)\"><i class=\"t-angle\" ng-show=\"displayAngle(node)\"></i>&nbsp;<span class=\"{{setPaddingClass(node, $parentNode)}}\"><span class=\"fa\" ng-click=\"switchExpand(node, $event)\" ng-hide=\"displayCaret(node)\" ng-class=\"{ \'fa-caret-right\': node.children &amp;&amp; !node.exp, \'fa-caret-down\': node.children &amp;&amp; node.exp, \'fa-file-text-o\': !node.children }\" ng-style=\"{\'margin-left\' : node.type === \'Menu\' ? \'0px\' : \'\'}\">&nbsp;</span><span ng-class=\"{\'node-selected\': (node.isSelected) }\">{{ getName(node) }} {{ setPath(node, $parentNode) }}</span></span><span class=\"pull-right t-mozila-fix\" ng-if=\"node.type === \'Menu\'\"><div class=\"fa fa-plus t-menu-create\" ng-click=\"createMenuItem(node, current.questionSet)\"></div>&nbsp;<div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total &gt; 0 &amp;&amp; node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt;= 0 &amp;&amp; node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span><span class=\"pull-right t-mozila-fix\" ng-if=\"node.type === \'MenuItem\'\"><div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span></div></div></treecontrol><treecontrol class=\"tree-classic non-selectable\" ng-repeat=\"qs in current.progress.questionSetsNext\" tree-model=\"qs.questions.navigation\" expanded-nodes=\"current.progress.expandedNodes\"><div class=\"{{setNodeClass(node, $parentNode)}}\" ng-show=\"displayNode(node)\"><div class=\"t-label-start\" ng-show=\"displayStart(node)\" ng-style=\"getStartsStyles(node)\">&nbsp;</div><div class=\"tree-item {{setTreeNodeClass(node, $parentNode, $index)}}\" ng-click=\"navigateTo(node, qs)\" ng-style=\"getStyles(node, $parentNode)\"><span class=\"{{setPaddingClass(node, $parentNode)}}\"><span class=\"fa\" ng-click=\"switchExpand(node, $event)\" ng-hide=\"displayCaret(node)\" ng-class=\"{ \'fa-caret-right\': node.children &amp;&amp; !node.exp, \'fa-caret-down\': node.children &amp;&amp; node.exp, \'fa-file-text-o\': !node.children }\" ng-style=\"{\'margin-left\' : node.type === \'Menu\' ? \'0px\' : \'\'}\">&nbsp;</span><span ng-class=\"{\'node-selected\': (node.isSelected) }\">{{ getName(node) }} {{ setPath(node, $parentNode) }}</span></span><span class=\"pull-right\" ng-if=\"node.type === \'Menu\'\"><div class=\"fa fa-plus t-menu-create\" ng-click=\"createMenuItem(node, qs)\"></div>&nbsp;<div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total &gt; 0 &amp;&amp; node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt;= 0 &amp;&amp; node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span><span class=\"pull-right\" ng-if=\"node.type === \'MenuItem\'\"><div class=\"fa fa-check-circle-o t-menu-item-completed\" ng-show=\"node.progress.total === node.progress.reached\"></div><div class=\"t-progress-circle\" ng-show=\"node.progress.total &gt; node.progress.reached\" round-progress=\"round-progress\" max=\"1\" current=\"node.progress.reached / node.progress.total\" color=\"#FCB912\" bgcolor=\"#557E67\" radius=\"10\" stroke=\"10\" duration=\"800\" animation=\"easeInOutQuart\"></div></span></div></div></treecontrol></div>");
$templateCache.put("components/spec-builder/spec-builder.html", "<div class=\"builder wrapper\"><side-tree-directive></side-tree-directive><div id=\"content\"><div class=\"navigation\"><div class=\"overflow\"><spec-navigator tree-options=\"treeOptions\"></spec-navigator><json-formatter json=\"current.project.answers\" open=\"1\" ng-show=\"current.showConfig\"></json-formatter></div></div><div><question-set></question-set></div></div></div>");
$templateCache.put("components/restore-draft/restore-draft.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-question-circle\"></i> <span translate=\"translate\">Restore Unsaved Answers</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><a4 translate=\"translate\">Restore unsaved answers drafts?</a4></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"restore()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Yes</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">No</span></button></div>");
$templateCache.put("components/question-sets/question-types/title/title.html", "<label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label>");
$templateCache.put("components/question-sets/question-types/text/text.html", "<div ng-controller=\"Q_TextCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><input class=\"form-control\" type=\"text\" name=\"Q_{{ question.id }}\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-model=\"current.project.answers[question.id]\" ng-focus=\"focus($event)\" ng-blur=\"blur($event)\"/></div>");
$templateCache.put("components/question-sets/question-types/text-box/text-box.html", "<div ng-controller=\"Q_TextBoxCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><div class=\"form-inline\" ng-repeat=\"answer in question.answers track by $index\">{{ answer.prefix }} <span ng-repeat=\"part in answer.parts track by $index\"><input class=\"form-control\" type=\"{{ part.range.length ? \'number\' : \'text\' }}\" focus-me=\"$first &amp;&amp; question.focusMe\" min=\"{{ part.range.length &gt; 0 ? part.range[0] : \'\' }}\" max=\"{{ part.range.length &gt; 1 ? part.range[1] : \'\' }}\" step=\"{{ part.range.length &gt; 2 ? part.range[2] : \'\' }}\" ng-trim=\"true\" ng-focus=\"focus($event)\" ng-blur=\"blur($event, answer, part, $index)\" ng-model=\"current.project.answers[question.id][answer.id][$index]\" style=\"min-width: 200px;\"/> {{ part.suffix }} </span><br/><br/></div></div>");
$templateCache.put("components/question-sets/question-types/text-area/text-area.html", "<div ng-controller=\"Q_TextAreaCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><textarea class=\"form-control\" name=\"Q_{{ question.id }}\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-model=\"current.project.answers[question.id]\" ng-focus=\"focus($event)\" ng-blur=\"blur($event)\"></textarea></div>");
$templateCache.put("components/question-sets/question-types/table/table.html", "<div ng-controller=\"Q_TableCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Table - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div><br/><table class=\"point-list\" border=\"1\"><tr><th ng-repeat=\"header in headers\" colspan=\"{{headerColSpan}}\">{{ header }}</th><th ng-if=\"headerColSpan==1\">&nbsp;&nbsp;&nbsp;</th></tr><tr ng-repeat=\"row in question.answers | filter: displayAnswer\" ng-show=\"row.actionType === \'Table\'\"><th ng-repeat=\"col in getColumns(row)\"><span class=\"text-danger\" ng-show=\"current.showConfig\" ng-if=\"$first\">{{ row.id }} &nbsp;</span><input type=\"{{ col.type }}\" ng-show=\"col.type &amp;&amp; !col.numbs\" ng-class=\"{ \'form-control\': col.type === \'text\' }\" ng-checked=\"col.value\" ng-blur=\"bindChange(row, col)\" ng-change=\"changed(col)\" ng-model=\"col.value\" size=\"{{col.value.length+1}}\" focus-me=\"($first &amp;&amp; row.focusMe) || ($parent.$first &amp;&amp; $first &amp;&amp; question.focusMe)\"/><input type=\"{{ col.type }}\" ng-show=\"col.type &amp;&amp; col.numbs\" ng-class=\"{ \'form-control\': col.type === \'text\' }\" ng-blur=\"bindChange(row, col)\" ng-model=\"col.value\" ng-change=\"changed(col)\" valid-number=\"valid-number\" size=\"{{col.value.length+1}}\"/><span ng-hide=\"col.type\">{{ col.text }} &nbsp;</span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; row.controlLogic\" ng-if=\"$first\">&nbsp; {{ row.controlLogic }}</span></th><th style=\"width:20px;\"><a class=\"btn btn-danger btn-sm\" ng-click=\"removeLine($index, row.id)\" ng-show=\"row.added\"><i class=\"fa fa-trash-o\"></i></a></th></tr><tr><th colspan=\"{{ footerColSpan }}\"><button class=\"btn btn-primary btn-table-add\" ng-click=\"addLine()\" tabindex=\"0\"><i class=\"fa fa-plus\"></i> {{ button.label || \'Add\' | translate }}</button></th></tr></table></div>");
$templateCache.put("components/question-sets/question-types/specification/specification.html", "<div ng-controller=\"Q_ConsistencyCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Specification - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/sequence/sequence.html", "<div ng-controller=\"Q_SequenceCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{\'Sequence - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div><br/><div ng-if=\"current.menuItem\" ng-repeat=\"sequence in sequences\"><div style=\"max-width: {{ current.showConfig ? 600 : 300 }}px;\"><span>&nbsp; {{sequence.displayName || question.fileFunction}} &nbsp;</span><span ng-show=\"current.showConfig\">({{sequence.name}}) &nbsp;</span><i class=\"fa fa-md fa-question-circle text-danger\" ng-if=\"!sequence.historyID\" tooltip=\"{{ \'File is not uploaded\'|translate }}\"></i>&nbsp; &nbsp;<span class=\"pull-right\"><a class=\"btn btn-primary btn-sm\" ng-click=\"preview(sequence, true)\" title=\"{{\'Preview processed\'|translate}}\" ng-disabled=\"!sequence.historyID\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"download(sequence, true)\" title=\"{{\'Download processed\'|translate}}\" ng-disabled=\"!sequence.historyID\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"downloadOriginal(sequence)\" title=\"{{\'Download original\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!sequence.historyID\"><i class=\"fa fa-cloud-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"previewOriginal(sequence)\" title=\"{{\'Preview original\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!sequence.historyID\"><i class=\"fa fa-eye-slash\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"checkIfProcessable(sequence)\" title=\"{{\'Test if processable\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!sequence.historyID\"><i class=\"fa fa-question\"></i></a></span></div><br/><iframe ng-show=\"sequence.url\" width=\"100%\" height=\"100%\" style=\"min-height: 730px;\" frameborder=\"0\" ng-src=\"{{trustSrc(sequence)}}\" allowtransparency=\"true\"></iframe></div></div>");
$templateCache.put("components/question-sets/question-types/pull-down/pull-down.html", "<div ng-controller=\"Q_PullDownCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><select class=\"form-control\" name=\"Q_{{ question.id }}\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-model=\"current.project.answers[question.id]\" ng-change=\"answerSelected()\" ng-options=\"x.id as (current.showConfig ? (x.id + \' - \' + x.text + \' - \' + x.controlLogic) : x.text) for x in question.answers | filter: displayAnswer\" ie-select-fix=\"ie-select-fix\"></select></div>");
$templateCache.put("components/question-sets/question-types/preview/preview.html", "<div ng-controller=\"Q_PreviewCtrl\"><a class=\"btn btn-primary\" ng-click=\"showDownloadPage()\" title=\"{{\'Download configuration data\'|translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div>");
$templateCache.put("components/question-sets/question-types/points-list/points-list.html", "<div ng-controller=\"Q_PointsListCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Point List - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div><br/><div ng-repeat=\"pointList in current.pointLists | filter: displayQuestion\"><point-list source=\"pointList.list\" question=\"pointList.question\" show-all=\"false\" allow-add=\"true\"></point-list></div></div>");
$templateCache.put("components/question-sets/question-types/only-one/only-one.html", "<div ng-controller=\"Q_OnlyOneCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><div class=\"radio group-item\" name=\"Q_{{ question.id }}\" ng-repeat=\"answer in question.answers | filter: displayAnswer\" ng-click=\"bindModel(answer)\">&nbsp;&nbsp;<span class=\"text-danger\" ng-show=\"current.showConfig\">{{ answer.id }} &nbsp;</span><label><input type=\"radio\" name=\"answerOf_{{question.id}}\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-checked=\"current.project.answers[question.id] === answer.id\"/><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(answer.text)\"></span><help item=\"answer\"></help></label><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; answer.controlLogic\">&nbsp; {{ answer.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/not-implemented/not-implemented.html", "<!--b {{ question.text }}--><!--.text-muted(ng-show=\"question.type\") (\"{{ question.type }}\" template is not implemented...)--><!--.text-muted(ng-hide=\"question.type\") (question type is empty...)--><!---->");
$templateCache.put("components/question-sets/question-types/menu/menu.html", "<div ng-controller=\"Q_MenuCtrl\"><!--.row--><!--  .col-lg-8--><!--    .text-muted Menu: {{ question.text }}--><!----><!--  .col-lg-4.text-right--><!--    a.btn.btn-primary(ng-click=\"create()\", title=\"create new menu\")--><!--      i.fa.fa-plus--><!----><!--hr--><!--section(ng-repeat=\"item in menus\")--><!--  hr(ng-hide=\"$first\")--><!----><!--  .row--><!--    .col-md-8--><!--      label.default {{ item.name }}--><!----><!--    .col-md-4.text-right--><!--        a.btn.btn-info(ng-click=\"edit(item)\", title=\"edit menu\")--><!--          i.fa.fa-pencil--><!--        = \' \'--><!--        a.btn.btn-danger(ng-click=\"delete(item)\", title=\"delete menu\")--><!--          i.fa.fa-trash-o--></div>");
$templateCache.put("components/question-sets/question-types/menu/create/create.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-plus\"></i>  {{ action }} Menu</div></div><div class=\"modal-body\"><label>Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" focus-me=\"true\"/><p class=\"text-danger\" ng-show=\"nameIsNotValid\" translate=\"translate\">Name is required</p><br/><question-set source=\"menuQuestions\" main-question-set=\"questionSet\" point-lists=\"pointLists\" destination=\"renderPreview.doc\" page=\"renderPreview.pageIndex\" show-config=\"renderPreview.showConfig\"></question-set></div><div class=\"modal-footer\"><div class=\"pull-left\"><button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"renderPreview.prev()\" ng-disabled=\"!(renderPreview.pageIndex &gt; 0)\"><i class=\"fa fa-arrow-left\"></i> <span translate=\"translate\">Prev</span></button> <button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"renderPreview.next()\" ng-disabled=\"!(renderPreview.pageIndex &lt; menuQuestions.pages.length - 1)\"><span translate=\"translate\">Next</span> <i class=\"fa fa-arrow-right\"></i></button></div><div class=\"pull-right\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div></div>");
$templateCache.put("components/question-sets/question-types/list-box/list-box.html", "<div ng-controller=\"Q_ListBoxCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp;{{ question.controlLogic }}</span><help item=\"question\"></help></label><select class=\"form-control\" name=\"Q_{{ question.id }}\" multiple=\"multiple\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-model=\"current.project.answers[question.id]\" ng-change=\"changed()\" ng-options=\"x.id as (current.showConfig ? (x.id + \' - \' + x.text + \' - \' + x.controlLogic) : x.text) for x in question.answers | filter: displayAnswer\" ie-select-fix=\"ie-select-fix\"></select></div>");
$templateCache.put("components/question-sets/question-types/line/line.html", "<hr/>");
$templateCache.put("components/question-sets/question-types/hide/hide.html", "");
$templateCache.put("components/question-sets/question-types/drawingextension/drawingextension.html", "<div ng-controller=\"Q_DrawingExtensionCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Drawing Extension - \' +  question.text }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/drawing/drawing.html", "<div class=\"row\" ng-controller=\"Q_DrawingCtrl\"><div class=\"col-md-12\" ng-repeat=\"item in drawings\"><div class=\"thumbnail\"><a ng-click=\"preview(item, true)\"><img src=\"{{item.thumbnailUrl}}\"/><div class=\"caption\"><p class=\"pull-left\"></p><a ng-class=\"{ \'text-muted\': !item.specConfigID }\" ng-click=\"preview(item, true)\"><span>{{item.name}}</span></a><span class=\"text-info\" ng-repeat=\"(ext,file) in item.files\">&nbsp; {{ext}}</span><div class=\"btn-group dropdown pull-right\"><a class=\"btn btn-primary dropdown-toggle\" ng-disabled=\"item.type !== \'Drawing\' &amp;&amp; !item.historyID\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\" ng-show=\"item.type === \'Drawing\'\"><li ng-repeat=\"(ext,file) in item.files\"><a ng-click=\"download(item.files[ext])\" title=\"{{\'Download\'|translate}} {{ext.toUpperCase()}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span><span>{{ ext.toUpperCase() }}</span></a></li><li><a ng-click=\"preview(item)\" title=\"{{\'Preview\' | translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a></li></ul></div></div></a><div class=\"clearfix\"></div></div></div></div>");
$templateCache.put("components/question-sets/question-types/download/download.html", "<div ng-controller=\"Q_DownloadCtrl\"><a class=\"btn btn-primary\" ng-click=\"showDownloadPage()\" title=\"Download configuration data\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div>");
$templateCache.put("components/question-sets/question-types/datasheet/datasheet.html", "<div ng-controller=\"Q_DataSheetCtrl\"><!--.text-muted {{ \'Data sheet -\' +  question.fileFunction }}--><!--.col-md-12(ng-repeat=\"item in current.dataSheets | filter: displayQuestion\")--><!--  datasheet(source=\"item.value\", answer-sets=\"answerSets\", question=\"item.question\", show-all=\"false\", show-config=\"current.showConfig\")--><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Data sheet - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/consistency/consistency.html", "<div ng-controller=\"Q_ConsistencyCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Consistency  - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/compliance/compliance.html", "<div ng-controller=\"Q_ComplianceCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Compliance - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/button/button.html", "<div ng-controller=\"Q_ButtonCtrl\"><!--a.btn.btn-primary(ng-click=\"activatePointListTab()\", title=\"Append points to current point list\")--><!--  i.fa.fa-plus &nbsp;--><!--  span {{ question.text }}--><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Button - \' + question.text }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div></div>");
$templateCache.put("components/question-sets/question-types/bom/bom.html", "<div ng-controller=\"Q_BOMCtrl\"><div ng-show=\"current.showConfig\"><span class=\"text-danger\">{{ question.id }} &nbsp;</span><span class=\"text-info\">{{ \'Bill of Material - \' +  question.fileFunction }}</span><span class=\"text-danger\" ng-show=\"question.controlLogic\">&nbsp; {{ question.controlLogic }}</span></div><br/><div ng-repeat=\"item in current.boms | filter: displayQuestion\"><bill-of-material source=\"item.value\" question=\"item.question\"></bill-of-material></div></div>");
$templateCache.put("components/question-sets/question-types/at-least-one/at-least-one.html", "<div ng-controller=\"Q_AtLeastOneCtrl\"><label class=\"default\"><span class=\"text-danger\" ng-show=\"current.showConfig\">{{ question.id }} &nbsp;</span><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(question.text)\"></span><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; question.controlLogic\">&nbsp; {{ question.controlLogic }}</span><help item=\"question\"></help></label><div class=\"group-item\" name=\"Q_{{ question.id }}\" ng-repeat=\"answer in all.filteredAnswers = (question.answers | filter: displayAnswer)\"><hr class=\"line\" ng-show=\"answer.actionType === \'Line\'\"/><div class=\"checkbox\" ng-hide=\"answer.actionType === \'Line\'\">&nbsp;&nbsp;<span class=\"text-danger\" ng-show=\"current.showConfig\">{{ answer.id }} &nbsp;</span><label><input type=\"checkbox\" name=\"answerOf_{{question.id}}\" ng-model=\"answer.isSelected\" focus-me=\"$first &amp;&amp; question.focusMe\" ng-disabled=\"answer.focusMe\" ng-click=\"bindModel(answer)\" ng-checked=\"current.project.answers[question.id].indexOf(answer.id) &gt;= 0\"/><div class=\"check-label\" ng-if=\"!answer.actionType\"><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(answer.text)\"></span></div><help item=\"answer\"></help></label><input type=\"text\" ng-if=\"answer.actionType === \'Text\'\" focus-me=\"answer.focusMe\" name=\"answerOf_{{question.id}}\" ng-blur=\"focusLost(answer)\" ng-model=\"current.project.answers.answerTextsOverride[question.id][answer.id]\" ng-disabled=\"!current.project.answers[question.id] || current.project.answers[question.id].indexOf(answer.id) === -1\"/><span class=\"text-danger\" ng-show=\"current.showConfig &amp;&amp; answer.controlLogic\">&nbsp; {{ answer.controlLogic }}</span></div><br ng-if=\"showCheckAll() &amp;&amp; $last\"/><a ng-if=\"showCheckAll() &amp;&amp; $last\" ng-click=\"checkAllClick()\" ng-class=\"allChecked()\" translate=\"translate\">Select All &nbsp;&nbsp; /</a><a ng-if=\"showCheckAll() &amp;&amp; $last\" ng-click=\"checkNoneClick()\" ng-class=\"allChecked()\" translate=\"translate\">&nbsp;&nbsp; Select None</a></div></div>");
$templateCache.put("components/question-sets/question-set.html", "<div class=\"q-border\" ng-style=\"getBorderStyle()\" ie11-border-fix=\"ie11-border-fix\" ng-attr-data-drop=\"{{ displayPage(\'MenuItems\') ? \'true\' : undefined }}\" ng-attr-data-jqyoui-options=\"{{ displayPage(\'MenuItems\') ? \'\' : undefined }}\" jqyoui-droppable=\"{onDrop: \'createNewEq(menu)\'}\"><div class=\"q-fade\" ng-click=\"$root.toggleTabletSide()\" ng-show=\"$root.tabletIsOpen\"></div><div class=\"modal-backdrop fade  in\" modal-backdrop=\"\" style=\"z-index: 1040; opacity: 0.1; !important\" ng-show=\"!current.readyToShow\"></div><loading class=\"next-loading\" show=\"!current.readyToShow\"></loading><div class=\"canvas c\" ng-show=\"current.readyToShow\" style=\"position:relative; display:inline-block; width:83.33333%\" ng-class=\"{\'col-lg-10 col-sm-10 col-md-10\' : true, \'dropdiv\' : displayPage(\'MenuItems\')}\"><div class=\"modal-backdrop fade  in\" modal-backdrop=\"\" style=\"z-index: 1040; opacity: 0.1; !important\" ng-show=\"current.nextLoading\"></div><loading class=\"next-loading\" show=\"current.nextLoading\"></loading><div ng-show=\"displayPage(\'Questions\')\"><div class=\"questions\"><div ng-show=\"current.showConfig\"><h5 class=\"pull-left\">Screen {{ current.questionSet.questions.pages[current.project.answers.pageIndex].id }} - {{ current.project.answers.pageIndex + 1 }} of {{ current.questionSet.questions.pages.length }}</h5><div class=\"clearfix\"></div><progressbar max=\"1\" value=\"current.project.answers.progress.reached / current.project.answers.progress.total\"><span style=\"color:white; white-space:nowrap;\">{{current.project.answers.progress.reached}} / {{current.project.answers.progress.total}}</span></progressbar></div><div class=\"clearfix\"></div><div class=\"question row\" ng-repeat=\"question in filtered.questions = (current.questionSet.questions.pages[current.project.answers.pageIndex].questions | filter: displayQuestion)\"><div class=\"col-md-1\" ng-show=\"current.showConfig\"><div class=\"dropdown\"><a class=\"btn btn-xs btn-primary dropdown-toggle\"><span>{...}&nbsp;</span><i class=\"fa fa-caret-down\"></i></a><pre class=\"dropdown-menu\">{{ questionJson(question) }}</pre></div></div><div class=\"{{ current.showConfig ? \'col-md-11\' : \'col-md-12\' }}\"><ng-include src=\"question.type | getQuestionTemplate\"></ng-include></div></div></div></div><div class=\"eq-and-sys-container\" ng-repeat=\"menu in current.questionSet.menus\" ng-show=\"displayPage(\'MenuItems\')\"><div class=\"pull-left\">{{ menu.name }}</div><div class=\"clearfix\"></div><hr/><section ng-repeat=\"item in current.project.answers[menu.id]\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-8\"><a ng-click=\"current.editMenuItem(menu, item)\" title=\"{{\'edit menu\'|translate}}\">{{ item.name }}</a></div><div class=\"col-md-4 text-right\"><div class=\"btn-group dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li><a ng-click=\"current.editMenuItem(menu, item)\" title=\"{{\'Edit menu item\'|translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Open</span></a></li><li><a ng-click=\"copyMenuItem(menu, item)\" title=\"{{\'Copy menu item\'|translate}}\"><i class=\"fa fa-copy\"></i> <span translate=\"translate\">Copy</span></a></li><li><a ng-click=\"editMenuItemName(menu, item)\" title=\"{{\'Edit menu item name\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit name</span></a></li><li><a ng-click=\"deleteMenuItem(menu, item)\" title=\"{{\'Delete menu item\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></section></div><div ng-show=\"displayPage(\'Download\')\"><download></download></div></div><div class=\"col-lg-2 col-sm-2 col-md-10\" ng-if=\"displayPage(\'MenuItems\')\" style=\"position:relative; display:inline-block; margin-bottom:20px\"><eq-and-sys-qst-tree></eq-and-sys-qst-tree></div></div><div class=\"questions-footer\"><div class=\"pull-left text-nowrap\"><button class=\"btn btn-primary back-next\" ng-click=\"save()\" type=\"button\" tabindex=\"999\" ng-if=\"isAdmin() &amp;&amp; current.showConfig\"><span><i class=\"fa fa-save\">&nbsp;</i></span>{{\'Save Changes\'|translate}}</button><div ng-if=\"isAdmin() &amp;&amp; current.showConfig\" style=\"display: inline-block;\">{{\'Questions in tree\'|translate}} <i class=\"fa fa-lg fa-toggle-on text-success\" ng-show=\"current.showQuestions\" ng-click=\"current.showQuestions = !current.showQuestions\"></i><i class=\"fa fa-lg fa-toggle-off text-info\" ng-hide=\"current.showQuestions\" ng-click=\"current.showQuestions = !current.showQuestions\"></i></div><div ng-if=\"isAdmin()\" style=\"display: inline-block;\">&nbsp;&nbsp; {{\'Show configuration details\'|translate}} <i class=\"fa fa-lg fa-toggle-on text-primary\" ng-show=\"current.showConfig\" ng-click=\"current.showConfig = !current.showConfig\"></i><i class=\"fa fa-lg fa-toggle-off text-info\" ng-hide=\"current.showConfig\" ng-click=\"current.showConfig = !current.showConfig\"></i></div></div><div class=\"pull-right text-nowrap\"><button class=\"btn btn-primary back-next\" ng-click=\"goBack()\" ng-disabled=\"disablePrev()\" type=\"button\" tabindex=\"99\"><i class=\"fa fa-angle-left\"></i> <span translate=\"translate\">Back</span></button> <button class=\"btn btn-primary back-next\" ng-click=\"goNext()\" ng-disabled=\"disableNext()\" ng-show=\"showNext()\" type=\"button\" tabindex=\"0\"><span translate=\"translate\">Next</span> <i class=\"fa fa-angle-right\"></i></button><button class=\"btn btn-primary back-next\" ng-click=\"goHome()\" ng-hide=\"showNext()\" type=\"button\" tabindex=\"0\">Finish / Home</button></div></div><div class=\"clearfix\"></div>");
$templateCache.put("components/question-sets/menu-name/menu-name.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Enter equipment name</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"name\" style=\"height: 29px\" focus-me=\"true\"/><p class=\"error-block\" ng-show=\"hasError\" translate=\"translate\">The name you entered is already in use, please enter a different name.</p></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/question-sets/menu-copy-external/menu-copy-external.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-copy\"></i> <span translate=\"translate\">Select item and enter name</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-6\"><select class=\"form-control\" ng-model=\"select.project\" ng-change=\"projectChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select project</option><option ng-repeat=\"x in projects\" value=\"{{x._id}}\">{{ x.name }}</option></select></div><div class=\"col-md-6\"><select class=\"form-control\" ng-model=\"select.item\" ng-disabled=\"!select.project\" ng-change=\"itemChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select menu item</option><option ng-repeat=\"x in menuItems\" value=\"{{x.id}}\">{{ x.name }}</option></select></div></div><br/><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"menuItem.name\" ng-disabled=\"!select.item\" focus-me=\"select.item\"/><p class=\"error-block\" ng-show=\"hasError\" translate=\"translate\">The name you entered is already in use, please enter a different name.</p></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/question-sets/help/help.html", "&nbsp;<i class=\"fa fa-lg fa-question-circle text-gray\" ng-if=\"item.help\" title=\"{{ item.help }}\"></i>");
$templateCache.put("components/project/save-conflict/save-conflict.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Saving conflict</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><a4 ng-hide=\"options.isDeleted\" translate=\"translate\">There are conflict between project versions, how to solve it?</a4><a4 ng-show=\"options.isDeleted\" translate=\"translate\">Accept the deletion, or override the deletion and restore the project?</a4></div></div></div><div class=\"modal-footer\"><div ng-hide=\"options.isDeleted\"><button class=\"btn btn-primary btn-s\" ng-click=\"useMine()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Use Mine</span></button><button class=\"btn btn-primary btn-s\" ng-click=\"useNewer()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Use Newer</span></button><button class=\"btn btn-primary btn-s\" ng-click=\"saveAsCopy()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save As Copy</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div><div ng-show=\"options.isDeleted\"><button class=\"btn btn-primary btn-s\" ng-click=\"drop()\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Drop</span></button><button class=\"btn btn-primary btn-s\" ng-click=\"reSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Resave</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div></div>");
$templateCache.put("components/project-grouping/side-tree.directive.html", "<div class=\"side-tree-directive hidden-sm hidden-xs\" ng-show=\"treeLoaded\"><nav id=\"sidebar\" ng-class=\"{ \'\' : !treeClosed, \'active\': treeClosed }\"><div class=\"sidebar-header\"><button class=\"btn btn-primary essential\" style=\"display:inline-block;\" ng-click=\"addSubFolder()\" translate=\"translate\">Add sub-folder</button><div class=\"pull-right\"><i class=\"arrow-right\" id=\"closer-button\" ng-click=\"toggleTree()\" ng-if=\"treeClosed\">&nbsp;</i><i class=\"arrow-left\" id=\"closer-button\" ng-click=\"toggleTree()\" ng-if=\"!treeClosed\">&nbsp;</i></div><div class=\"clearfix\"></div></div><hr ng-if=\"!treeClosed\"/><div ng-if=\"tree &amp;&amp; !treeClosed\"><div ng-repeat=\"node in tree\"><ng-include src=\"\'components/project-grouping/side-tree-node.html\'\"></ng-include></div></div><div data-drop=\"true\" data-jqyoui-options=\"data-jqyoui-options\" jqyoui-droppable=\"{ onDrop: \'dropOutside()\' }\" style=\"width:100%;\"></div></nav></div>");
$templateCache.put("components/project-grouping/side-tree-node.html", "<div style=\"padding: 7px; padding-right: 0; border-bottom: 1px solid black; font-family: SiemensSans_Prof_Black; font-size: 13px;\"><img src=\"/assets/images/tree-plus.png\" ng-if=\"node.isFolder &amp;&amp; !nodeIsExpanded(node)\" style=\"cursor: pointer; width: 18px; height: 18px;\" ng-click=\"toggleNodeExpand(node)\"/><img src=\"/assets/images/tree-minus.png\" ng-if=\"node.isFolder &amp;&amp; nodeIsExpanded(node)\" style=\"cursor: pointer; width: 18px; height: 18px;\" ng-click=\"toggleNodeExpand(node)\"/><img src=\"/assets/images/tree-file.png\" ng-if=\"!node.isFolder\" style=\" width: 15px; height: 15px;\"/> <a ng-if=\"node.isFolder\" href=\"/folder/{{ node._id }}\" ng-style=\"{ color: nodeIsSelected(node) ? \'#24879e !important\' : \'inherit\' }\"><span ng-if=\"node.name.length &gt; 25 &amp;&amp; sidebarWidth() &lt; 400\" tooltip=\"{{ node.name }}\">{{ node.name | limitTo:25 }}...</span><span ng-if=\"node.name.length &lt;= 25 || sidebarWidth() &gt; 400\">{{ node.name }}</span></a><div class=\"pull-right\" ng-if=\"node.isFolder\"><i class=\"pull-right fa fa-trash-o text-danger folder-action-icon\" ng-click=\"delete(node)\" aria-hidden=\"true\"></i><i class=\"pull-right fa fa-pencil folder-action-icon\" ng-click=\"rename(node)\"></i></div><div class=\"clearfix\" ng-if=\"node.isFolder\"></div><a ng-if=\"!node.isFolder\" ng-click=\"openProject(node.project._id)\" ng-style=\"{ color: nodeIsSelected(node) ? \'#24879e !important\' : \'inherit\' }\"><span ng-if=\"node.project.name.length &gt; 25 &amp;&amp; sidebarWidth() &lt; 400\" tooltip=\"{{ node.project.name }}\">{{ node.project.name | limitTo:25 }}...</span><span ng-if=\"node.project.name.length &lt;= 25 || sidebarWidth() &gt; 400\">{{ node.project.name }}</span></a></div><div ng-repeat=\"node in getNodeChildren(node)\" style=\"padding-left: 8px;\"><ng-include src=\"\'components/project-grouping/side-tree-node.html\'\"></ng-include></div>");
$templateCache.put("components/project-grouping/shared-link.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Share project specifications</span></div></div><div class=\"modal-body\" id=\"shared-link\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active : activeTab === \'addSharing\'}\"><a ng-click=\"activeTab = \'addSharing\'\">Add Sharing</a></li><li ng-class=\"{active : activeTab === \'viewSharing\'}\"><a ng-click=\"activeTab = \'viewSharing\'\">View current Sharing</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane fade\" ng-class=\"{ active : activeTab === \'addSharing\', in : activeTab === \'addSharing\'}\"><div class=\"form-group\"><label>email</label><span style=\"margin-left:6px\">(To add multiple email ids, separate the ids by commas)</span><input class=\"form-control\" type=\"text\" ng-model=\"postData.emails\"/></div><div class=\"docs-to-share\" ng-if=\"!!sharableProjects.length\"><h3>Select Project documents to share</h3><section ng-repeat=\"node in sharableProjects\"><h4 ng-class=\"{\'not-downloadable\' : !node.project.downloadable }\">{{ node.project.name }}</h4><h4 ng-if=\"!node.project.downloadable\" style=\"display:inline; margin-left:10px\">(Incomplete)</h4><!-- will not check if project has downloads because they are filtered after fetch--><ul ng-if=\"node.project.downloadable\"><li ng-repeat=\"file in node.project.download\"><div class=\"checkbox d-checkbox\"><label>{{ file.name }}<input type=\"checkbox\" ng-model=\"postData.shares[node.project._id][file._id]\"/></label></div></li></ul></section></div><div class=\"form-group\" style=\"margin-top:30px;\"><div class=\"row\"><div class=\"col-md-10\"><label>Select expiration time</label><select class=\"form-control col-md-12 col-lg-12\" ng-model=\"postData.expTime\"><option value=\"{{ 60 * 60 * 24 }}\">1 day</option><option value=\"{{ 60 * 60 * 24 * 7 }}\">1 week</option><option value=\"{{ 60 * 60 * 24 * 30  }}\">1 month</option><option value=\"0\">Permanent</option></select></div><div class=\"col-md-2\"><button class=\"btn btn-primary\" style=\"margin-top:19px;\" ng-disabled=\"!isSharable()\" ng-click=\"sendShares()\">Send link</button></div></div></div></div><div class=\"tab-pane fade\" ng-class=\"{ active : activeTab === \'viewSharing\', in : activeTab === \'viewSharing\'}\"><table class=\"table\" ng-if=\"shares\"><thead><tr><th>Email</th><th>Specification</th><th>Expiration</th><th style=\"text-align:center\">Remove Sharing</th></tr></thead><tbody><tr ng-repeat=\"share in shares\"><td>{{ share.email }}</td><td><span ng-click=\"toggleShow(\'shares_\' + share._id)\" style=\"cursor:pointer; color: #328ed0\">Shared specs</span><div class=\"specs-list\" id=\"shares_{{ share._id }}\"><ul style=\"padding-left: 0px;\"><li ng-repeat=\"(id, project) in share.shares\" style=\"padding:2px\"><a ng-click=\"openProject(project)\">{{ project.name }}</a></li></ul></div></td><td>{{ share.expDate }}</td><td style=\"text-align:center\"><a class=\"btn btn-danger\" ng-click=\"removeShare(share._id)\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/project-grouping/new-sub-folder-dialog.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Enter folder name</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"name\" style=\"height: 29px\" focus-me=\"true\"/></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/project-grouping/folder-list.html", "<div class=\"spec-wrapper\" ng-class=\"{ open: $root.tabletIsOpen }\"><div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"progressbar\" ng-if=\"nav\"><div><a class=\"project-progress-header\" ng-repeat=\"nav in current.fullNavigation\" ng-click=\"navigateTo(nav, $event)\"><sp>an.progress-text {{ nav.name }}</sp><progressbar class=\"project-progress-bar\" progressbar-helper=\"progressbar-helper\" color=\"{{getProgressColor(nav)}}\" ng-style=\"{\'background-color\': nav.styles.disabled.background}\" max=\"1\" value=\"getProgressValue(nav)\"></progressbar></a></div></div><div class=\"wrapper\" style=\"top:-23px; position:relative\"><side-tree-directive></side-tree-directive><div style=\"width:100%; margin: 8px;\"><div ng-if=\"folderId !== \'shared-specs\'\" ng-show=\"breadCrumbs &amp;&amp; breadCrumbs.length\"><h3 style=\"display:inline-block\"><ng-container ng-repeat=\"path in breadCrumbs\" ng-switch=\"!!path.url\"><a href=\"{{path.url}}\" ng-switch-when=\"true\" ng-style=\"\" style=\"margin: 0px 5px\">{{path.name}}</a><span ng-switch-when=\"false\" style=\"margin: 0px 5px\">{{path.name}}</span><span ng-hide=\"$index + 1 === breadCrumbs.length\">&gt;</span></ng-container></h3><hr/><div ng-if=\"folderId !== \'shared-specs\'\" style=\"display: inline-block;position: relative;top: -6px; margin-left:5px; width: 65%;\"><button class=\"btn btn-primary essential\" type=\"button\" style=\"margin: 0px 5px\" ng-click=\"createSpec()\" translate=\"translate\">Create specification</button><a class=\"btn btn-primary essential\" ng-click=\"getShareableLink()\" title=\"Project Sharing\"><i class=\"fa fa-share\"></i> <span translate=\"translate\">Project Sharing</span></a></div><hr ng-if=\"folderId !== \'shared-specs\'\"/><div class=\"div\" ng-if=\"folderId !== \'shared-specs\'\" style=\"display: flex;\"><h5 style=\"cursor: pointer;\" ng-click=\"disableTeamSpecification()\">My Specifications<hr ng-class=\"{\'highlight\': !teamSpecificationFlag}\"/></h5><h5>&nbsp;</h5><h5 style=\"cursor: pointer; margin-left: 2%;\" ng-click=\"enableTeamSpecification()\">Team Specifications<hr ng-class=\"{\'highlight\': teamSpecificationFlag}\"/></h5></div></div><table class=\"table\" id=\"{{tableID}}\" ng-if=\"specConfigs\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"dtColumns\" dt-instance=\"dt.instance\" addBtn=\"true\" datatable-fix=\"datatable-fix\" style=\"width:100%;\"></table></div></div></div>");
$templateCache.put("components/point-lists/point-list.html", "<div ng-controller=\"PointListDirectiveCtrl\" style=\"width:81%\"><div class=\"point-list-table-controls\"><div style=\"display:inline-block\"><label class=\"search-box\"><input class=\"form-control input-sm\" type=\"search\" style=\"display:inline-block\" ng-model=\"filterKeyword\" ng-change=\"filterPointList()\" placeholder=\"{{&quot;Filter&quot;|translate}}...\" aria-controls=\"projects-data-table\"/><i><i class=\"fa fa-search search-box-icon\"></i></i></label></div><div style=\"display:inline-block\" tooltip=\"Enter text then tap the magnifying glass to filter the points list. Only points that contain the text you enter will be displayed in the points list. Delete the text in the filter and click the magnifying glass to view all points again\"><label class=\"point-list-hit-label\" style=\"margin: 0px 5px\"><i class=\"fa fa-lg fa-question-circle text-gray\"></i></label></div><div style=\"display:inline-block; position:relative; top:-3px\"><button class=\"btn btn-primary\" style=\"margin-left:5px\" ng-click=\"restoreTableOrder()\">Restore default order</button><button class=\"btn btn-primary\" style=\"margin-left:5px\" ng-click=\"undoPointRemoval()\" ng-disabled=\"!undoAvailable()\">Undo Point removal</button></div><div class=\"checkbox removed-points-hider\"><label><input type=\"checkbox\" ng-model=\"$parent.showingRemovedPoints\" ng-change=\"showRemovedPoints()\"/>show excluded default points</label></div></div><div class=\"clearfix\"></div><small>Click a column to sort by that column</small><table class=\"point-list\" border=\"1\"><tr ng-show=\"current.showConfig &amp;&amp; list.headers[0]\"><th class=\"text-center\" ng-repeat=\"header in list.headers[0]\" colspan=\"{{ header.colSpan }}\" style=\"background-color: {{ checkHighlight(header.type) ? \'whitesmoke\' : \'white\' }};\">{{ header.type }}</th><th>&nbsp;</th><td translate=\"translate\">Type Name</td></tr><tr ng-repeat=\"headerRow in list.headers\"><th class=\"text-center\" ng-class=\"{\'point-list-narrow-header\': !!$parent.$index}\" ng-repeat=\"header in headerRow\" rowspan=\"{{ header.rowSpan }}\" ng-click=\"sortTable(header.type, header.text)\" colspan=\"{{ header.colSpan }}\" style=\"background-color: {{ checkHighlight(header.type) ? \'whitesmoke\' : \'white\' }};\">{{ header.text }}<i class=\"fa\" ng-if=\"header.text === customOrder &amp;&amp; excludeSort.indexOf(header.text) === -1\" style=\"display:block\" ng-class=\"{\'fa-sort-asc\' : !customOrderRev, \'fa-sort-desc\' : customOrderRev }\"></i></th><th ng-show=\"$first\" rowspan=\"{{ current.showConfig ? (list.headers.length + 3) : (list.headers.length) }}\"><a class=\"btn btn-primary btn-table-add\" ng-click=\"addPoint()\" ng-disabled=\"addedPointItem || editPointItem\" title=\"{{\'Add new point\' | translate}}\"><i class=\"fa fa-plus\"></i>&nbsp; {{\'Add\' | translate}}</a></th><td ng-show=\"current.showConfig\" translate=\"translate\">Header</td></tr><tr ng-show=\"current.showConfig\"><th>&nbsp;</th><th class=\"text-center\" ng-repeat=\"option in allOptions\" style=\"background-color: {{ checkHighlight(option.type) ? \'whitesmoke\' : \'white\' }};\">{{ option.option.label  }}</th><td ng-show=\"current.showConfig\" translate=\"translate\">Header label</td></tr><tr ng-show=\"current.showConfig\"><th>&nbsp;</th><th class=\"text-center\" ng-repeat=\"option in allOptions\" style=\"background-color: {{ checkHighlight(option.type) ? \'whitesmoke\' : \'white\' }};\">{{ option.option.name }}</th><td translate=\"translate\">Label</td></tr><tr><th class=\"text-center\">{{ countChecks()  }}</th><th class=\"text-center\" ng-repeat=\"option in allOptions\" style=\"background-color: {{ checkHighlight(option.type) ? \'whitesmoke\' : \'white\' }};\">{{ countChecks(option) }}</th><th class=\"text-center\" style=\"background-color: {{ checkHighlight(option.type) ? \'whitesmoke\' : \'white\' }}; width:10%\">Point Count</th><td ng-show=\"current.showConfig\" translate=\"translate\">Counter</td></tr><tr ng-repeat=\"point in tmp.filteredPoints = (list.points | orderBy: getPointOrder:customOrderRev | filter: displayPoint) | filter: displayHeader\" ng-class=\"{ strikeout: current.project.removedPoints.indexOf(point._id) &gt;=0}\"><td ng-hide=\"point.controlLogic === \'Header\'\"><span ng-hide=\"point.tempID &amp;&amp; point.isEditing\">{{ point.text }}</span><input type=\"text\" ng-show=\"point.tempID &amp;&amp; point.isEditing\" ng-model=\"point.text\" ng-disabled=\"!point.isEditing\"/></td><th ng-show=\"point.controlLogic === \'Header\'\" colspan=\"{{ allOptions.length + (current.showConfig ? 2 : 1) }}\">{{ point.text }}</th><td class=\"text-center\" ng-hide=\"point.controlLogic === \'Header\'\" ng-repeat=\"option in allOptions\" style=\"background-color: {{ checkHighlight(option.type) ? \'whitesmoke\' : \'white\' }};\"><input type=\"{{ option.fieldType === \'Check\' ? \'checkbox\' : \'radio\' }}\" ng-hide=\"option.fieldType === \'Text\' || option.fieldType === \'Number\'\" ng-disabled=\"!point.tempID || !point.isEditing\" ng-click=\"bindCheck(point, option)\" ng-checked=\"point.values.indexOf(option.option.name) &gt;= 0\"/><span ng-show=\"option.fieldType === \'Text\' &amp;&amp; (!point.tempID || !point.isEditing)\">{{ point.texts[option.option.name] }}</span><input type=\"text\" ng-show=\"option.fieldType === \'Text\' &amp;&amp; (point.tempID &amp;&amp; point.isEditing)\" ng-model=\"point.texts[option.option.name]\"/><span ng-show=\"option.fieldType === \'Number\' &amp;&amp; (!point.tempID || !point.isEditing)\">{{ point.texts[option.option.name] }}</span><input class=\"form-control input-xs\" type=\"text\" ng-show=\"option.fieldType === \'Number\' &amp;&amp; (point.tempID &amp;&amp; point.isEditing)\" ng-model=\"point.texts[option.option.name]\" valid-number=\"valid-number\"/></td><td ng-show=\"current.showConfig &amp;&amp; point.controlLogic !== \'Header\'\">{{ point.controlLogic }}</td><td ng-show=\"allowAdd\">&nbsp;<div style=\"width: 75px; margin-top: -14px; margin-left:3px\"><span ng-show=\"(addedPointItem &amp;&amp; addedPointItem.tempID === point.tempID) || (editPointItem &amp;&amp; editPointItem.tempID === point.tempID)\"><a class=\"btn btn-primary\" ng-click=\"savePoint(point)\" ng-show=\"(addedPointItem &amp;&amp; addedPointItem.tempID === point.tempID) || (editPointItem &amp;&amp; editPointItem.tempID === point.tempID)\" ng-disabled=\"!pointIsValid(point)\" title=\"{{\'Save point\'|translate}}\"><i class=\"fa fa-save\"></i></a> <a class=\"btn btn-warning\" ng-click=\"cancelAdding(point)\" ng-show=\"(addedPointItem &amp;&amp; addedPointItem.tempID === point.tempID) || (editPointItem &amp;&amp; editPointItem.tempID === point.tempID)\" title=\"Cancel\"><i class=\"fa fa-times\"></i></a></span><span ng-hide=\"addedPointItem || editPointItem\"><a class=\"btn btn-primary\" ng-click=\"editPoint(point, point.tempID ? true : false)\" title=\"{{\'Edit point\'|translate}}\"><i class=\"fa fa-pencil\"></i></a> <a class=\"btn btn-danger\" ng-click=\"deletePoint(point, point.tempID ? true : false)\" ng-hide=\"(point._id &amp;&amp; current.project.removedPoints.indexOf(point._id) &gt;=0) || addedPointItem &amp;&amp; addedPointItem.tempID === point.tempID\" title=\"{{\'delete point\'|translate}}\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn btn-success\" ng-click=\"restorePoint(point)\" ng-show=\"point._id &amp;&amp; current.project.removedPoints.indexOf(point._id) &gt;=0\" title=\"{{\'restore point\'|translate}}\" style=\"width:35px\"><i class=\"fa fa-arrow-up\"></i></a></span></div></td></tr></table></div><!--ng-hide=\"(addedPointItem && addedPointItem.tempID === point.tempID) || (editPointItem && editPointItem.tempID === point.tempID)\"--><!--ng-hide=\"addedPointItem && addedPointItem.tempID === point.tempID\"--><!--(ng-show=\"(addedPointItem && addedPointItem.tempID === point.tempID) || (editPointItem && editPointItem.tempID === point.tempID)\")--><!--(ng-hide=\"(addedPointItem && addedPointItem.tempID === point.tempID) || (editPointItem && editPointItem.tempID === point.tempID)\")-->");
$templateCache.put("components/office-preview/office-preview.html", "<a ng-click=\"preview()\" title=\"{{\'Preview\' | translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a>");
$templateCache.put("components/office-preview/office-preview-dialog/office-preview-dialog.html", "<div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"modal-title\"><i class=\"fa fa-eye\"></i> Preview: {{ title }}</div></div></div></div><div class=\"modal-body modal-full\"><iframe ng-show=\"isIframe &amp;&amp; !message\" width=\"100%\" height=\"100%\" frameborder=\"0\" ng-src=\"{{trustSrc()}}\" allowtransparency=\"true\"></iframe><div ng-show=\"showImage()\" style=\"overflow:scroll;  height:100%;\"><img ng-src=\"{{viewUrl}}\" style=\"width:100%;\"/></div><div class=\"alert alert-info\" ng-show=\"message\" style=\"text-align:center\"><h3>{{ message }}</h3></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/navbar/navbar.html", "<div class=\"navbar navbar-default navbar-static-top hidden-sm hidden-xs\" ng-controller=\"NavbarCtrl\"><div class=\"navbar-header\"></div><div id=\"navbar-main\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in menu\" ng-class=\"{active: isActive(item.link)}\"><a ng-href=\"{{ item.link }}\">{{item.title | translate}}</a></li><li ng-show=\"isLoggedIn()\"><a href=\"/admin/manual\" translate=\"translate\">Manuals</a></li><li class=\"dropdown\" ng-show=\"isLoggedIn()\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><translate>Video Tutorials</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"/tutorial/registration\" translate=\"translate\">SpecWriter Registration</a></li><li><a href=\"/tutorial/marketing\" translate=\"translate\">SpecWriter Marketing</a></li><li class=\"divider\"></li><li><a href=\"/tutorial/fire\" translate=\"translate\">Fire Tutorial - Overview</a></li><li><a href=\"/tutorial/building-automation\" translate=\"translate\">Building Automation Tutorial - Overview</a></li><li><a href=\"/tutorial/power-distribution/create-spec\" translate=\"translate\">Power Distribution – Creating a Spec</a></li><li><a href=\"/tutorial/power-distribution/share-spec\" translate=\"translate\">Power Distribution – Sharing a Spec</a></li><li class=\"divider\"></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/ui-walk-through\" translate=\"translate\">Admin – UI Walk Through</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/control-logic\" translate=\"translate\">Admin – Control Logic Tutorial</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/tags\" translate=\"translate\">Admin – Tags Tutorial</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/product-data-sheets\" translate=\"translate\">Admin – Working with Product Data Sheets</a></li></ul></li><li class=\"dropdown\" ng-show=\"isAdmin() || isMaster()\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><translate>Admin</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\" ng-show=\"isAdmin()\"><li><a href=\"/admin/specs\" translate=\"translate\">Spec Configs</a></li><li><a href=\"/admin/files\" translate=\"translate\">Files Repository</a></li><li><a href=\"/admin/users\" translate=\"translate\">Users</a></li><li><a href=\"/admin/notifications\" translate=\"translate\">Notifications</a></li><li><a href=\"/admin/countries\" translate=\"translate\">Countries</a></li><li><a href=\"/admin/languages\" translate=\"translate\">Languages</a></li><li><a href=\"/admin/product-lines\" translate=\"translate\">Product Lines</a></li><li><a href=\"/admin/abandoned-registrations\" translate=\"translate\">Pending Registrations</a></li><li><a href=\"/tutorial/admin/word-plugin\" translate=\"translate\">MS Word Validator</a></li></ul><ul class=\"dropdown-menu\" role=\"menu\" ng-show=\"isMaster()\"><li><a href=\"/admin/specs\" translate=\"translate\">Spec Configs</a></li></ul></li><li class=\"dropdown\" ng-show=\"isAdmin() || isMaster()\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><translate>Reports</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"/admin/dashboard\" translate=\"translate\">Dashboard</a></li><li><a href=\"/admin/usage-report\" translate=\"translate\">Usage Report</a></li><li><a href=\"/admin/user-activity\" translate=\"translate\">User Activity</a></li><li><a href=\"/admin/specification-report\" translate=\"translate\">Specification Report</a></li><!--lia(href=\'/test/client/coverage/reports/lcov-report\', target=\"_blank\", translate) Client--><!--lia(href=\'/test/server/coverage/reports/lcov-report\', target=\"_blank\", translate) Server\n--></ul></li></ul><ul class=\"nav navbar-nav pull-right\"><li ng-hide=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/login&quot;)}\"><a href=\"/login\" translate=\"translate\">Login</a></li><li ng-show=\"isLoggedIn()\"><p class=\"navbar-text\">{{\'Hello\'|translate}} {{ getCurrentUser().forename +\' \'+ getCurrentUser().surname }}</p></li><li ng-show=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/settings&quot;)}\"><a href=\"/settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li><li ng-show=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/logout&quot;)}\"><a href=\"/auth/logout\" target=\"_self\" translate=\"translate\">Logout</a></li><li ng-class=\"{active: isActive(&quot;/logout&quot;)}\"><a ng-show=\"isLoggedIn()\" href=\"mailto:specwriter.si@siemens.com\" translate=\"translate\" target=\"_blank\">Contact Us</a><a ng-show=\"!isLoggedIn()\" href=\"/contact-us\" translate=\"translate\">Contact Us</a></li><li ng-show=\"!isAdmin() &amp;&amp; isLoggedIn()\"><a href=\"/admin/user/notifications\">Notifications<span class=\"dot\" ng-if=\"isNotification\"> {{ notificationQuantity }}</span></a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><i class=\"switcher-lang switcher-lang-{{ currentLanguage.key }}\"></i><span style=\"position:relative; bottom:3px\">{{currentLanguage.name}}</span><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"lang in languages\"><a ng-click=\"switchLanguage(lang.key)\"><i class=\"switcher-lang switcher-lang-{{lang.key}}\"></i>{{lang.name}}</a></li></ul></li></ul></div></div><!-- responsive navbar for small screens --><nav class=\"navbar navbar-expand-lg navbar-light bg-light hidden-lg hidden-md\" ng-controller=\"NavbarCtrl\" style=\"background-color: #999999;\"><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" style=\"margin left: 0\"><i class=\"fa fa-align-justify\"></i></button><div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\" style=\"background-color: #ffffff;\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in menu\" ng-class=\"{active: isActive(item.link)}\"><a ng-href=\"{{ item.link }}\">{{item.title | translate}}</a></li><li ng-show=\"isLoggedIn()\"><a href=\"/admin/manual\" translate=\"translate\">Manuals</a></li><li class=\"dropdown\" ng-show=\"isLoggedIn()\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><translate>Video Tutorials</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"/tutorial/registration\" translate=\"translate\">SpecWriter Registration</a></li><li><a href=\"/tutorial/marketing\" translate=\"translate\">SpecWriter Marketing</a></li><li class=\"divider\"></li><li><a href=\"/tutorial/fire\" translate=\"translate\">Fire Tutorial - Overview</a></li><li><a href=\"/tutorial/building-automation\" translate=\"translate\">Building Automation Tutorial - Overview</a></li><li><a href=\"/tutorial/power-distribution/create-spec\" translate=\"translate\">Power Distribution – Creating a Spec</a></li><li><a href=\"/tutorial/power-distribution/share-spec\" translate=\"translate\">Power Distribution – Sharing a Spec</a></li><li class=\"divider\"></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/ui-walk-through\" translate=\"translate\">Admin – UI Walk Through</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/control-logic\" translate=\"translate\">Admin – Control Logic Tutorial</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/tags\" translate=\"translate\">Admin – Tags Tutorial</a></li><li ng-show=\"isAdmin()\"><a href=\"/tutorial/admin/product-data-sheets\" translate=\"translate\">Admin – Working with Product Data Sheets</a></li></ul></li><li class=\"dropdown\" ng-show=\"isAdmin() || isMaster()\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><translate>Admin</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\" ng-show=\"isAdmin()\"><li><a href=\"/admin/specs\" translate=\"translate\">Spec Configs</a></li><li><a href=\"/admin/files\" translate=\"translate\">Files Repository</a></li><li><a href=\"/admin/users\" translate=\"translate\">Users</a></li><li><a href=\"/admin/notifications\" translate=\"translate\">Notifications</a></li><li><a href=\"/admin/countries\" translate=\"translate\">Countries</a></li><li><a href=\"/admin/product-lines\" translate=\"translate\">Product Lines</a></li><li><a href=\"/admin/abandoned-registrations\" translate=\"translate\">Pending Registrations</a></li><li><a href=\"/tutorial/admin/word-plugin\" translate=\"translate\">MS Word Validator</a></li></ul><ul class=\"dropdown-menu\" role=\"menu\" ng-show=\"isMaster()\"><li><a href=\"/admin/specs\" translate=\"translate\">Spec Configs</a></li></ul></li><li class=\"dropdown\" ng-show=\"isAdmin()\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><translate>Reports</translate><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a href=\"/admin/usage-report\" translate=\"translate\">Usage Report</a></li><!--lia(href=\'/test/client/coverage/reports/lcov-report\', target=\"_blank\", translate) Client--><!--lia(href=\'/test/server/coverage/reports/lcov-report\', target=\"_blank\", translate) Server\n--></ul></li></ul><ul class=\"nav navbar-nav\"><li ng-hide=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/login&quot;)}\"><a href=\"/login\" translate=\"translate\">Login</a></li><li ng-show=\"isLoggedIn()\"><p class=\"navbar-text\">{{\'Hello\'|translate}} {{ getCurrentUser().forename +\' \'+ getCurrentUser().surname }}</p></li><li ng-show=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/settings&quot;)}\"><a href=\"/settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li><li ng-show=\"isLoggedIn()\" ng-class=\"{active: isActive(&quot;/logout&quot;)}\"><a href=\"/auth/logout\" target=\"_self\" translate=\"translate\">Logout</a></li><li ng-class=\"{active: isActive(&quot;/logout&quot;)}\"><a ng-show=\"isLoggedIn()\" href=\"mailto:specwriter.si@siemens.com\" translate=\"translate\" target=\"_blank\">Contact Us</a><a ng-show=\"!isLoggedIn()\" href=\"/contact-us\" translate=\"translate\">Contact Us</a></li><li ng-show=\"!isAdmin() &amp;&amp; isLoggedIn()\"><a href=\"/admin/user/notifications\">Notifications<span class=\"dot\" ng-if=\"isNotification\"> {{ notificationQuantity }}</span></a></li><li class=\"dropdown\"><a class=\"dropdown-toggle\" href=\"\" data-toggle=\"dropdown\"><i class=\"switcher-lang switcher-lang-{{ currentLanguage.key }}\"></i><span style=\"position:relative; bottom:3px\">{{currentLanguage.name}}</span><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"lang in languages\"><a ng-click=\"switchLanguage(lang.key)\"><i class=\"switcher-lang switcher-lang-{{lang.key}}\"></i>{{lang.name}}</a></li></ul></li></ul></div></nav>");
$templateCache.put("components/modal/modal.html", "<div class=\"modal-header\"><h4 class=\"modal-title\" ng-if=\"modal.title\" ng-bind=\"modal.title\"></h4></div><div class=\"modal-body\"><p ng-if=\"modal.text\" ng-bind=\"modal.text\"></p><div ng-if=\"modal.html\" ng-bind-html=\"modal.html\"></div></div><div class=\"modal-footer\"><button class=\"btn\" ng-repeat=\"button in modal.buttons\" ng-class=\"button.classes\" ng-click=\"button.click($event)\" ng-bind=\"button.text\"></button></div>");
$templateCache.put("components/message/message.html", "<div class=\"modal-header\"><h3 class=\"modal-title text-info {{type ? \'text-\' + type : \'\'}}\"><i class=\"fa fa-info-circle\"></i> {{ title }}</h3></div><div class=\"modal-body scrollable-content\" ng-show=\"text\">{{ text }}<br/><br/><label class=\"info\" ng-if=\"data.log\" translate=\"translate\">Result</label><json-formatter ng-if=\"data.log\" json=\"data.log\" open=\"1\"></json-formatter><br/><label class=\"info\" ng-if=\"data.params\" translate=\"translate\">Params</label><json-formatter ng-if=\"data.params\" json=\"data.params\" open=\"0\"></json-formatter></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Close</span></button></div>");
$templateCache.put("components/loading/loading.html", "<div ng-show=\"show\"><img src=\"assets/images/loader.gif\"/></div>");
$templateCache.put("components/header/header-type-content-4.html", "<header class=\"header type_content_3 container\" ng-controller=\"HeaderController\"><div class=\"visual_area\"><a class=\"logo-lines-small-{{currentLang()}}\" href=\"/\"></a></div><div class=\"mobile-nav\"><i class=\"fa\" ng-class=\"$root.tabletIsOpen ? \'fa-times\' : \'fa-bars\'\" ng-click=\"$root.toggleTabletSide()\"></i></div><div class=\"slogan_area\"><div class=\"typography a1 product-name\">SpecWriter Online</div><div class=\"project-name\">{{ current.project.name }}</div></div><div class=\"spec-info pull-right hide-mobile\" style=\"height:130px\"><div class=\"typography a1\"></div></div></header>");
$templateCache.put("components/header/header-type-content-3.html", "<header class=\"header type_content_3 container\" ng-controller=\"HeaderController\"><div class=\"visual_area\"><div class=\"header-texts\"><div class=\"company\"><img src=\"assets/images/siemens.png\" style=\"width: 150px;\"/></div><div class=\"typography a1\">SpecWriter Online</div></div></div><div class=\"project-name\" style=\"color: white; width: 50%; margin-left: 0.5%;\">{{ current.project.name }}</div><div class=\"mobile-nav\"><i class=\"fa\" ng-class=\"$root.tabletIsOpen ? \'fa-times\' : \'fa-bars\'\" ng-click=\"$root.toggleTabletSide()\"></i></div><div class=\"spec-info pull-right hide-mobile\"><div class=\"typography a1\" style=\"color: white; margin-top: -15%;\"><spec-header></spec-header></div></div></header>");
$templateCache.put("components/header/header-type-content-2.html", "<header class=\"header type_content_2 container\" ng-controller=\"HeaderController\"><div class=\"visual_area\"><div class=\"header-texts\"><div class=\"company\"><img src=\"assets/images/siemens.png\" style=\"width: 150px;\"/></div><div class=\"typography a1\">SpecWriter Online</div></div></div></header>");
$templateCache.put("components/header/header-type-content-1.html", "<header class=\"header type_content_1 container\"><div class=\"visual_area\" style=\"display: inline-block;\"><a class=\"logo-lines-{{currentLang()}}\" href=\"/\"></a></div><div style=\"display: inline-block;\"><div class=\"slogan_area\"><div class=\"typography a1 product-name\">SpecWriter Online</div></div><div class=\"project-name\">{{ current.project.name }}</div></div><div class=\"spec-info\" style=\"display: inline-block;\"><spec-header></spec-header></div><div class=\"show-config\" ng-if=\"isAdmin()\">Show configuration details <i class=\"fa fa-lg fa-toggle-on text-primary\" ng-show=\"current.showConfig\" ng-click=\"current.showConfig = !current.showConfig\"></i><i class=\"fa fa-lg fa-toggle-off text-info\" ng-hide=\"current.showConfig\" ng-click=\"current.showConfig = !current.showConfig\"></i></div></header>");
$templateCache.put("components/header/header-type-application.html", "<header class=\"header type_application container\"><a class=\"logo\" href=\"/\"></a></header>");
$templateCache.put("components/header/header-type-3.html", "<header class=\"header type_3 container\" ng-controller=\"HeaderController\"><div class=\"header-texts\"><div class=\"company\"><img src=\"assets/images/siemens.png\" style=\"width: 150px; margin-left: 45px;\"/></div><div class=\"typography a1\">SpecWriter Online</div></div></header>");
$templateCache.put("components/header/header-type-2.html", "<header class=\"header type_2 container\" ng-controller=\"HeaderController\"><div class=\"visual_area\"><a class=\"logo-lines-{{currentLang()}}\" href=\"/\"></a></div><div class=\"slogan_area\"><div class=\"typography a\">SpecWriter Online</div></div></header>");
$templateCache.put("components/header/header-type-1.html", "<header class=\"header type_1 container\" ng-controller=\"HeaderController\"><div class=\"visual_area\"><a class=\"logo-lines-{{currentLang()}}\" href=\"/\"></a></div><div class=\"slogan_area\"><div class=\"typography a\">SpecWriter Online</div></div></header>");
$templateCache.put("components/files-repository/upload/upload.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Upload file</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" ng-disabled=\"isMultiple\" focus-me=\"true\" ui-keypress=\"{13: \'save()\'}\"/><br/><label translate=\"translate\">Description</label><textarea class=\"form-control\" type=\"text\" name=\"description\" ng-model=\"description\" ng-disabled=\"isMultiple\" ui-keypress=\"{13: \'save()\'}\"></textarea></div></div><hr/><div><button class=\"btn btn-primary\" ng-file-select=\"ng-file-select\" ng-model=\"files\" ng-change=\"fileSelectChanged()\" ng-multiple=\"true\" resetOnClick=\"true\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Select file to upload...</span></button><div ng-show=\"files.length\"><br/><label translate=\"translate\">Selected files:</label><br/><ul class=\"list-group\" style=\"max-height: 300px; overflow: auto;\"><li class=\"list-group-item list-group-item-info\" ng-repeat=\"item in files\">{{ item.name }}<a class=\"btn btn-danger btn-sm btn-conflict\" ng-click=\"removeFile($index)\"><i class=\"fa fa-trash-o\"></i></a></li></ul></div></div><hr ng-show=\"errors.length\"/><alert ng-show=\"errors.length\" type=\"danger\"><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload file</strong><ul><li ng-repeat=\"error in errors\">{{ error }}</li></ul></alert></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"saveDisabled()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/files-repository/history/history.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">File history</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6\" translate=\"translate\">Name</div><div class=\"col-md-3\" translate=\"translate\">Uploaded</div><div class=\"col-md-2\" translate=\"translate\">Uploaded by</div><div class=\"col-md-1\">&nbsp;</div></div><hr/><section ng-repeat=\"item in history | orderBy: \'-uploaded\'\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-6\">{{ item.fileName }}</div><div class=\"col-md-3\">{{ item.uploaded | date:\'dd MMM yyyy HH:mm:ss\' }}</div><div class=\"col-md-2\">{{ item.uploadedBy.username }}</div><div class=\"col-md-1 text-right\"><div class=\"btn-group dropdown\"><a class=\"btn btn-primary dropdown-toggle\">Actions <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li><a ng-click=\"preview(item)\" title=\"{{\'Preview file\' | translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a></li><li><a ng-href=\"api/file/download/{{ item._id }}/{{ item.fileName }}.{{item.extension }}\" title=\"{{\'Download file\' | translate}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li></ul></div></div></div></section></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/files-repository/files-repository.html", "<div ng-controller=\"FilesRepositoryCtrl\"><div class=\"row\" ng-hide=\"specConfigID\"><div class=\"col-lg-6\"><h3 style=\"margin: 0;\" translate=\"translate\">Files Repository</h3></div><div class=\"col-lg-6 text-right form-inline hidden\" id=\"hiddenBtn\"><a class=\"btn btn-primary btn-big\" ng-click=\"upload()\" title=\"{{\'upload new file\' | translate}}\" ng-hide=\"selectedSpecConfig.isPublished\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Upload</span></a></div></div><hr ng-hide=\"specConfigID\"/><div class=\"row\" ng-hide=\"queue.length\"><div class=\"col-sm-12\" style=\"height: calc(100vh - 300px); overflow-y: auto;\"><table class=\"table\" id=\"{{tableID}}\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"dtColumns\" dt-instance=\"dt.instance\" addBtn=\"true\" datatable-fix=\"datatable-fix\"></table></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue \"><hr/><div class=\"col-md-3\">{{ item.file.name }}</div><div class=\"col-md-3\">{{ item.data.description }}</div><div class=\"col-md-3\">{{\'Uploading\' | translate }}: {{ item.file.size | filesize }}</div><div class=\"col-md-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></div>");
$templateCache.put("components/files-repository/files-repository-actions.html", "<div class=\"btn-group dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li><a ng-click=\"preview(file)\" title=\"{{\'Preview latest version\' | translate }}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a></li><li><a ng-href=\"api/files/{{file._id}}/{{ file.history[file.history.length - 1]._id }}\" title=\"{{\'Download latest version\' | translate}}\" target=\"_blank\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"history(file)\" title=\"{{\'Show file history\' | translate}}\"><i class=\"fa fa-history\"></i> <span translate=\"translate\">History</span></a></li><li><a ng-click=\"edit(file, $index)\" title=\"{{\'Edit file\' | translate}}\" ng-hide=\"selectedSpecConfig.isPublished\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><a ng-click=\"delete(file)\" title=\"{{\'Delete file\' | translate}}\" ng-hide=\"selectedSpecConfig.isPublished\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div>");
$templateCache.put("components/files-repository/edit/edit.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Edit file</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"file.name\" focus-me=\"true\" ui-keypress=\"{13: \'save()\'}\"/><br/><label translate=\"translate\">File ID</label><input class=\"form-control\" type=\"text\" name=\"fileID\" ng-model=\"file.fileID\" ui-keypress=\"{13: \'save()\'}\"/><br/><label translate=\"translate\">Description</label><textarea class=\"form-control\" type=\"text\" name=\"description\" ng-model=\"file.description\" ui-keypress=\"{13: \'save()\'}\"></textarea><br/><label translate=\"translate\">Language</label><select class=\"form-control\" ng-model=\"file.language\" ng-options=\"x.code as x.name for x in languages\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">(select language)</option></select></div></div><hr/><div><button class=\"btn btn-primary\" ng-file-select=\"ng-file-select\" ng-model=\"files\" ng-change=\"fileSelectChanged()\" resetOnClick=\"true\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Select file to upload...</span></button><div ng-show=\"files.length\"><br/><label translate=\"translate\">Selected files:</label><br/><ul class=\"list-group\"><li class=\"list-group-item list-group-item-info\" ng-repeat=\"item in files\">{{ item.name }}<a class=\"btn btn-danger btn-sm btn-conflict\" ng-click=\"removeFile($index)\"><i class=\"fa fa-trash-o\"></i></a></li></ul></div></div><hr ng-show=\"errors.length\"/><alert ng-show=\"errors.length\" type=\"danger\"><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload file</strong><ul><li ng-repeat=\"error in errors\">{{ error }}</li></ul></alert></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"noChanges()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/exchange-modal/exchange-modal.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa {{ config.icon || \'fa-bars\' }}\"></i> {{ config.title || \"\" }}</div></div><div class=\"modal-body\"><iframe ng-src=\"{{ url }}\"></iframe></div><div class=\"modal-footer\"><button class=\"btn {{ button.class || \'btn-default\' }}\" ng-repeat=\"button in config.buttons\" ng-click=\"action(button.action || \'ok\')\"><i class=\"fa {{ button.icon || \'fa-check\' }}\"></i> <span translate=\"translate\">{{ button.text || \'OK\' }}</span></button></div>");
$templateCache.put("components/eq-and-sys-qst-tree/eq-and-sys-qst-tree.html", "<div ng-repeat=\"tree in trees\"><h4 class=\"tree-title\">Add equipment</h4><accordion close-others=\"true\"><accordion-group ng-class=\"{\'panel-no-border-rad\':true}\" ng-repeat=\"answer in tree.answers\"><accordion-heading>&nbsp;<span class=\"answer-text\" style=\"left:20px\">{{answer.text}}</span></accordion-heading><ul class=\"list-group\" ng-repeat=\"subanswer in answer.subQuestion.answers\"><li class=\"list-group-item\" data-drag=\"true\" data-drop=\"true\" jqyoui-draggable=\"{animate: true}\" data-jqyoui-options=\"{revert: \'invalid\', appendTo : \'body\', helper: \'clone\', cursor:\'move\'}\" data-qa=\"{{ &quot;(&quot; + tree.id + &quot;-&quot; + answer.id +&quot;)&quot; + &quot;(&quot; + answer.subQuestion.id+&quot;-&quot;+subanswer.id+&quot;)&quot; }}\" data-multyans=\"{{ answer.subQuestion.type === \'At Least One\' ? \'true\' : \'false\'}}\"><i class=\"fa fa-arrows drag-answer\"></i><div class=\"answer-text\">{{subanswer.text}}</div></li></ul></accordion-group></accordion></div>");
$templateCache.put("components/drawing-extension/drawing-extension.html", "<label class=\"default\">{{ question.text }}</label><table class=\"table-bordered\"><tr><th valign=\"top\" translate=\"translate\">Description</th><th ng-repeat=\"answer in question.answers\"><span class=\"ql-editor ql-editor-reset\" ng-bind-html=\"asHtml(answer.text)\"></span><div class=\"checkbox check-header\"><label><input type=\"checkbox\" name=\"checkOf_{{question.id}}_{{answer.id}}\" ng-show=\"showHeaderCheck(answer)\" ng-click=\"bindAll(answer)\" ng-checked=\"headerCheck(answer)\"/></label></div></th></tr><tr ng-repeat=\"drawing in drawings\"><td>{{ drawing.name }}</td><td ng-repeat=\"item in question.answers\"><div class=\"checkbox check-row\" name=\"Q_{{ question.id }}\" ng-show=\"drawing.files[item.fileFunction]\"><label><input type=\"checkbox\" name=\"answerOf_{{question.id}}\" ng-click=\"bindModel(drawing, item)\" ng-checked=\"model.drawings[drawing.name].indexOf(item.fileFunction) &gt;= 0\"/></label></div></td></tr></table>");
$templateCache.put("components/download/sharableLinkDialog/sharable-link-dialog.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Share Specification Document</span></div></div><div class=\"modal-body\" id=\"shared-spec\"><div class=\"row\"><div class=\"col-md-12\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active : activeTab === \'addSharing\'}\"><a ng-click=\"activeTab = \'addSharing\'\">Add Sharing</a></li><li ng-class=\"{active : activeTab === \'viewSharing\'}\"><a ng-click=\"activeTab = \'viewSharing\'\">View current Sharing</a></li></ul><div class=\"tab-content\"><div class=\"tab-pane fade\" ng-class=\"{ active : activeTab === \'addSharing\', in : activeTab === \'addSharing\'}\"><div class=\"form-group\"><label>email</label><span style=\"margin-left:6px\">(To add multiple email ids, separate the ids by commas)</span><input class=\"form-control\" type=\"text\" ng-model=\"postData.emails\"/></div><div class=\"form-group\" style=\"margin-top:30px;\"><div class=\"row\"><div class=\"col-md-10\"><label>Select expiration time</label><select class=\"form-control col-md-12 col-lg-12\" ng-model=\"postData.expTime\"><option value=\"{{ 60 * 60 * 24 }}\">1 day</option><option value=\"{{ 60 * 60 * 24 * 7 }}\">1 week</option><option value=\"{{ 60 * 60 * 24 * 30  }}\">1 month</option><option value=\"0\">Permanent</option></select></div><div class=\"col-md-2\"><button class=\"btn btn-primary\" style=\"margin-top:19px;\" ng-disabled=\"!isSharable()\" ng-click=\"sendShares()\">Send link</button></div></div></div></div><div class=\"tab-pane fade\" ng-class=\"{ active : activeTab === \'viewSharing\', in : activeTab === \'viewSharing\'}\"><table class=\"table\" ng-if=\"shares\"><thead><tr><th>Email</th><th>Date shared</th><th>Expiration</th><th style=\"text-align:center\">Remove Sharing</th></tr></thead><tbody><tr ng-repeat=\"share in shares\"><td>{{ share.email }}</td><td>{{ share.dateShared }}</td><td>{{ share.expDate }}</td><td style=\"text-align:center\"><a class=\"btn btn-danger\" ng-click=\"removeShare(share._id)\"><i class=\"fa fa-trash-o\"></i></a></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("components/download/listOfSharesDialog/list-of-shared.html", "<div class=\"modal-content list-of-shared-modal\" ng-init=\"fetchShared()\"><div class=\"modal-header\"><button class=\"close\" type=\"button\" ng-click=\"close()\">×</button><h4 class=\"modal-title\" translate=\"translate\">Invalidate urls</h4></div><div class=\"modal-body\"><table class=\"table\" ng-if=\"projects.length &gt; 0\"><thead><tr><th>#</th><th>Email</th><th class=\"text-center\">invalidate</th></tr></thead><tbody ng-repeat=\"project in projects\"><tr><th scope=\"row\">1</th><td>{{project.email}}</td><td class=\"text-center\"><i class=\"fa fa-times\" ng-click=\"invalidate(project)\" style=\"cursor:pointer\"></i></td></tr></tbody></table><h2 ng-if=\"projects.length == 0\">This project is not shared to anyone</h2></div></div>");
$templateCache.put("components/download/download.html", "<div ng-show=\"globals.list.length\"><h4>Documents</h4><section style=\"padding-left: 5px;\"><table class=\"data-sheet\"><tr ng-repeat=\"item in globals.list\" ng-show=\"item.hasFile || item.url || current.showConfig\"><td><div class=\"checkbox d-checkbox\"><label><input type=\"checkbox\" name=\"globalCheckOf_{{item.type}}\" ng-click=\"checkClick(item)\" ng-checked=\"isChecked(item)\" ng-disabled=\"!item.historyID\"/></label></div></td><td><span>&nbsp; {{ item.displayName || item.name }} &nbsp;</span><span ng-show=\"current.showConfig\">({{ item.type + \' - \' + item.name }}) &nbsp;</span><i class=\"fa fa-md fa-link text-muted\" ng-if=\"!item.hasFile &amp;&amp; item.url\" tooltip=\"{{\'Item is an external link\'|translate }}\"></i><i class=\"fa fa-md fa-question-circle text-danger\" ng-if=\"!item.hasFile &amp;&amp; !item.url\" tooltip=\"{{\'File is not uploaded\'|translate }}\"></i></td><td><a class=\"btn btn-primary btn-sm\" ng-click=\"previewFile(item)\" title=\"{{\'Preview processed\'|translate}}\" ng-disabled=\"!item.hasFile &amp;&amp; !item.url\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"downloadItem(item)\" title=\"{{\'Download processed\'|translate}}\" ng-disabled=\"!item.hasFile &amp;&amp; !item.url\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"downloadOriginal(item)\" title=\"{{\'Download original\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.hasFile &amp;&amp; !item.url\"><i class=\"fa fa-cloud-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"previewOriginal(item)\" title=\"{{\'Preview original\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.hasFile &amp;&amp; !item.url\"><i class=\"fa fa-eye-slash\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"checkIfProcessable(item)\" title=\"{{\'Test if processable\'|translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.hasFile\"><i class=\"fa fa-question\"></i></a></td></tr></table></section></div><div class=\"clearfix\"></div><br/><div ng-show=\"menus.list.length\"><h4>{{ menuName }}</h4><section style=\"padding-left: 5px;\"><table class=\"data-sheet\"><tr ng-repeat=\"item in menus.list\" ng-show=\"item.historyID || current.showConfig\"><td><div class=\"checkbox d-checkbox\"><label><input type=\"checkbox\" name=\"globalCheckOf_{{item.type}}\" ng-click=\"checkClick(item)\" ng-checked=\"isChecked(item)\" ng-disabled=\"!item.historyID\"/></label></div></td><td><span>{{ item.displayName }}</span><span ng-show=\"current.showConfig\">&nbsp; ({{item.name}}) &nbsp;</span><i class=\"fa fa-md fa-question-circle text-danger\" ng-if=\"!item.historyID\" tooltip=\"{{ \'File is not uploaded\' | translate }}\"></i></td><td><a class=\"btn btn-primary btn-sm\" ng-click=\"previewFile(item)\" title=\"{{\'Preview processed\' | translate }}\" ng-disabled=\"!item.historyID\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"downloadItem(item)\" title=\"{{\'Download processed\' | translate }}\" ng-disabled=\"!item.historyID\"><i class=\"fa fa-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"downloadOriginal(item)\" title=\"{{\'Download original\' | translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.historyID\"><i class=\"fa fa-cloud-download\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"previewOriginal(item)\" title=\"{{\'Preview original\' | translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.historyID\"><i class=\"fa fa-eye-slash\"></i></a> <a class=\"btn btn-primary btn-sm\" ng-click=\"checkIfProcessable(item)\" title=\"{{\'Test if processable\' | translate}}\" ng-if=\"current.showConfig\" style=\"margin:0;\" ng-disabled=\"!item.historyID\"><i class=\"fa fa-question\"></i></a></td></tr></table><div class=\"clearfix\"></div><br/><table class=\"table-bordered\" ng-show=\"drawings.length\"><tr><th valign=\"top\" translate=\"translate\">Equipment Schematics</th><th ng-repeat=\"item in drawingTypes\" ng-if=\"showHeaderCheck(item)\">{{ item.name }}</th></tr><tr><th>&nbsp;</th><th ng-repeat=\"item in drawingTypes\" ng-if=\"showHeaderCheck(item)\"><div class=\"checkbox check-header\"><label><input type=\"checkbox\" name=\"checkOf_{{item.type}}\" ng-click=\"drawingsHeaderClick(item)\" ng-checked=\"headerIsChecked(item)\"/></label></div></th></tr><tr ng-repeat=\"drawing in drawings\" ng-class=\"{\'table-row\': $even}\"><td><a ng-class=\"\" ng-click=\"previewDrawing(drawing.files[\'svg\'])\" ng-disabled=\"!drawing.files[\'svg\']\"><i class=\"fa fa-eye\"></i></a>&nbsp; {{ drawing.name }}</td><td ng-repeat=\"item in drawingTypes\" ng-if=\"showHeaderCheck(item)\"><div class=\"checkbox check-row\" name=\"Q_{{ question.id }}\" ng-if=\"drawing.files[item.type]\"><label><input type=\"checkbox\" name=\"answerOf_{{item.type}}\" ng-click=\"drawingsCheckClick(drawing.files[item.type])\" ng-checked=\"drawingExistsInDownloads(drawing.files[item.type])\"/></label></div></td></tr></table><div class=\"clearfix\"></div><br/><br/></section></div><a class=\"btn btn-primary\" ng-click=\"showDataSheets()\" ng-show=\"current.progress.dataSheetsCount &gt; 0\" style=\"margin-left: 5px;\">{{ \'DataSheets\' | translate }} {{current.progress.checkedDataSheetsCount + \' of \' + (current.progress.dataSheetsCount > current.progress.checkedDataSheetsCount ? current.progress.dataSheetsCount : current.progress.checkedDataSheetsCount)}} {{\'selected\' | translate}}</a><div class=\"clearfix\"></div><br ng-show=\"current.progress.dataSheetsCount &gt; 0\"/><div class=\"row\" style=\"padding-left:20px\"><a class=\"btn btn-primary\" ng-click=\"download()\" ng-class=\"{disabled: emptyDownloads()}\" style=\"margin-right:3px\" title=\"{{\'Download\' | translate }}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download selected files</span></a><a class=\"btn btn-primary\" ng-click=\"getSharableLink()\" ng-class=\"{disabled: emptyDownloads()}\" style=\"margin-left:3px; margin-right:3px\" title=\"{{\'Get sharable link\' | translate }}\"><i class=\"fa fa-share\"></i> <span translate=\"translate\">Specification Sharing</span></a></div><div class=\"clearfix\"></div>");
$templateCache.put("components/data-sheets/data-sheets-dialog/data-sheets-dialog.html", "<div class=\"modal-header\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"modal-title\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">DataSheets</span></div></div></div></div><div class=\"modal-body\" style=\"overflow: auto;\"><div ng-repeat=\"item in current.dataSheets | filter: current.displayQuestion\"><datasheet source=\"item.value\" answer-sets=\"answerSets\" question=\"item.question\" show-all=\"false\"></datasheet></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Close</span></button></div>");
$templateCache.put("components/data-sheets/data-sheet.html", "<ng-container ng-controller=\"DataSheetDirectiveCtrl\"><div ng-show=\"displayDataSheetSection(dataSheet)\"><h4>{{ dataSheet.name }}</h4><table><tr><th translate=\"translate\">Languages:</th><td ng-repeat=\"(key,legend) in dataSheet.legend\" style=\"padding-left: 15px; padding-right: 15px;\"><input type=\"checkbox\" ng-click=\"bindLegendCheck(key)\" ng-checked=\"legendIsChecked(key, legend)\"/> {{legend.display}}</td></tr></table><br/><table class=\"table table-bordered\"><tr><th ng-show=\"current.showConfig\">ID</th><th style=\"width: 25px\"><input type=\"checkbox\" ng-change=\"checkAllSheet()\" ng-model=\"checkAll.sheets\" ng-checked=\"sheetsHeaderChecked()\"/></th><th ng-show=\"current.showConfig\" translate=\"translate\">Logic</th><th ng-show=\"current.showConfig\" translate=\"translate\">PreSelected</th><th translate=\"translate\" style=\"width:300px\">Model Number</th><th translate=\"translate\">Description</th><th class=\"nowrap\" translate=\"translate\" style=\"width:150px\">Languages</th></tr><tr ng-repeat=\"sheet in checkAll.dataSheets = (dataSheet.sheets | filter: displayDataSheet)\" ng-show=\"displaySheet(sheet)\"><td ng-show=\"current.showConfig\">{{ sheet.id }}</td><td style=\"width: 25px\"><input type=\"checkbox\" ng-click=\"bindCheck(sheet)\" ng-checked=\"isChecked(sheet)\"/></td><td ng-show=\"current.showConfig\">{{ sheet.controlLogic }}</td><td ng-show=\"current.showConfig\">{{ sheet.preSelected }}</td><td style=\"width:300px\">{{ sheet.modelNumber }}</td><td>{{ sheet.description }}</td><td class=\"nowrap\" style=\"width:150px\"><a class=\"{{ !sheet.fileReferences[key] ? \'text-danger\' : sheet.fileReferences[key].isSpecFile ? \'text-success\' : \'text-warning\' }}\" ng-repeat=\"key in sheet.languages\" ng-show=\"displayLanguage(key)\" ng-click=\"preview(sheet.fileReferences[key])\">{{key}} &nbsp;</a></td></tr></table><div class=\"clearfix\"></div><hr/></div></ng-container>");
$templateCache.put("components/create-project/create-project.html", "<div class=\"create-project\"><div class=\"modal-header\"><div class=\"modal-title\"><span ng-show=\"isCreate &amp;&amp; !options.isCopy\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Create Specification</span></span><span ng-hide=\"isCreate || options.isCopy\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save project as</span></span><span ng-show=\"options.isCopy\"><i class=\"fa fa-copy\"></i> <span translate=\"translate\">Save project as copy</span></span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\" ng-hide=\"options.folderId\"><div class=\"col-md-12\"><span style=\"display:block; margin-bottom:16px\">Create a new project folder with the option of starting a new specification. To only create a project folder, enter the project folder name then click the “Create” button</span><div class=\"form-group\"><label>Project Information</label><input class=\"form-control\" type=\"text\" ng-model=\"options.folderName\" placeholder=\"Project name\"/></div></div></div><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control\" ng-model=\"options.key.country\" ng-disabled=\"options.spec\" ng-change=\"countryChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select country</option><option ng-repeat=\"x in countries | filter: displayCountry\" value=\"{{x.code}}\" ng-selected=\"x.code === options.key.country\">{{ x.name }}</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-model=\"options.key.product\" ng-disabled=\"options.spec || !options.key.country\" ng-change=\"anyChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select product</option><option ng-repeat=\"x in products | filter: displayProduct\" value=\"{{ x.code }}\" ng-selected=\"x.code === options.key.product\">{{ x.name }}</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-model=\"options.key.language\" ng-disabled=\"options.spec || !options.key.product\" ng-change=\"anyChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select language</option><option ng-repeat=\"x in languages | filter: displayLanguage\" value=\"{{ x.code }}\" ng-selected=\"x.code === options.key.language\">{{ x.name }}</option></select></div><div class=\"col-md-3\" ng-show=\"isAdmin() || isInRole(\'tester\') || true\"><select class=\"form-control\" ng-model=\"project.specID\" ng-disabled=\"options.spec || !options.key.language\" ng-show=\"options.specs &amp;&amp; !options.spec\" ng-change=\"anyChanged()\" ie-select-fix=\"ie-select-fix\"><option value=\"\" translate=\"translate\">select spec</option><option ng-repeat=\"x in options.specs | filter: displaySpec\" value=\"{{x._id}}\" ng-selected=\"x._id === options.previous.specID || x._id === project.specID\">{{ x.alias }}</option></select><input class=\"form-control\" ng-model=\"options.spec.alias\" ng-disabled=\"true\" ng-hide=\"options.specs &amp;&amp; !options.spec\"/></div></div><hr/><div class=\"row\"><div class=\"col-md-12\"><label>Name</label><input class=\"input-primary form-control\" ng-model=\"project.name\" placeholder=\"{{\'Specification name\' | translate }}\" focus-me=\"project.specID || options.project\"/></div></div><!--br--><!--.row--><!--  .col-md-12--><!--    label Comments--><!--    textarea.form-control(ng-model=\"project.comments\")--><div class=\"checkbox\" ng-hide=\"isCreate\"><br/><label><input type=\"checkbox\" ng-model=\"project.asNew\" ng-disabled=\"options.isCopy\" translate=\"translate\"/>Save project as new</label></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"!inputsIsValid()\"><i class=\"fa fa-save\"></i> <span ng-show=\"isCreate\" translate=\"translate\">Create</span><span ng-hide=\"isCreate\" translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div></div>");
$templateCache.put("components/confirm/confirm.html", "<div class=\"modal-header\"><h3 class=\"modal-title text-info\"><i class=\"fa fa-question-circle\"></i> {{ title }}</h3></div><div class=\"modal-body\" ng-show=\"text\">{{ text }}</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"yes()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Yes</span></button><button class=\"btn btn-danger\" ng-click=\"no()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">No</span></button></div>");
$templateCache.put("components/breadcrumb/breadcrumb.html", "<div><div class=\"bc-title\" ng-repeat=\"item in current.progress.navigationPath\"> <i class=\"fa fa-long-arrow-right\" ng-hide=\"$first\"></i> <a ng-click=\"navigateTo(item, $event)\" ng-hide=\"$last || item.type === \'MenuItem\'\">{{ item.name }}</a><h3 ng-show=\"item.type === \'MenuItem\'\" style=\"display: inline-block;\" ng-mouseover=\"switchShowEditName(true)\" ng-mouseleave=\"switchShowEditName(false)\"><a ng-click=\"navigateTo(item, $event)\">{{ item.name }}</a><a class=\"edit-icon\" ng-click=\"editMenItemName(item.name)\" title=\"Edit menu name\" ng-show=\"showEditName\"><i class=\"fa fa-pencil\"></i></a>&nbsp;</h3><span ng-show=\"$last\">{{ item.name }}</span></div></div>");
$templateCache.put("components/bill-of-materials/bill-of-material.html", "<div ng-controller=\"BillOfMaterialDirectiveCtrl\"><table class=\"bill-of-material\" border=\"1\"><tr><th ng-show=\"current.showConfig\">SWCode</th><th translate=\"translate\">Part. No</th><th translate=\"translate\">Type</th><th translate=\"translate\">Description</th><th translate=\"translate\">Quantity</th><th translate=\"translate\">Unit&nbsp;Price</th><th translate=\"translate\">Price</th><th><div translate=\"translate\">Currency</div></th><th ng-repeat=\"header in additionalDataHeader\"><div class=\"rotated\">{{\'Column\'|translate}} {{header}}</div></th></tr><tr ng-repeat=\"material in billOfMaterial.materials | filter: displayBOM\"><td valign=\"top\" ng-show=\"current.showConfig\">{{ material.swCode }}</td><td valign=\"top\">{{ material.productPartNo }}</td><td valign=\"top\">{{ material.type }}</td><td valign=\"top\">{{ material.description }}</td><td valign=\"top\"><input class=\"form-control input-xs\" type=\"text\" ng-model=\"material.quantity\" ng-change=\"inputChanged(material)\" valid-number=\"valid-number\"/></td><td valign=\"top\"><input class=\"form-control input-xs\" type=\"text\" ng-model=\"material.unitPrice\" ng-change=\"inputChanged(material)\" valid-number=\"valid-number\"/></td><td valign=\"top\">{{ material.price = ((material.quantity * material.unitPrice).toFixed(2)) }}</td><td valign=\"top\">{{ material.currency }}</td><td valign=\"top\" ng-repeat=\"header in additionalDataHeader\">{{ material.additionalData[header] }}</td></tr></table></div>");
$templateCache.put("app/tutorial/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Video Tutorials</h3></div>");
$templateCache.put("app/tutorial/registration/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">SpecWriter Registration</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/swol-registration.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/power/share-spec/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Power Distribution - Sharing a Spec</h3><hr/><iframe src=\"https://www.brainshark.com/siemenscorp2/specwritereditsend\" frameborder=\"0\" style=\"width: 1200px; height: 600px;\"></iframe></div>");
$templateCache.put("app/tutorial/power/create-spec/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Power Distribution - Creating a Spec</h3><hr/><iframe src=\"https://www.brainshark.com/siemenscorp2/specwritercreate\" frameborder=\"0\" style=\"width: 1200px; height: 600px;\"></iframe></div>");
$templateCache.put("app/tutorial/marketing/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">SpecWriter Marketing</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/swol-marketing.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/fire/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Fire - Overview</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/siemens+swol+ii+fire+tutorial+video+10-28-18.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/automation/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Building Automation - Overview</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/siemens+swol+ii+tutorial+video+10-28-18.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/admin/word-plugin/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\" style=\"overflow-y: auto; height: calc(100vh - 220px);\"><h3 class=\"page-title\" translate=\"translate\">Install Word Plugin</h3><br/><br/>Download and unpack installation scripts from following link: <a href=\"https://media-content.siemens-specwriter.com/word-plugin/install-specwriter-word-plugin.zip\" target=\"_blank\">install-specwriter-word-plugin.zip</a><br/><br/><h4>Windows</h4><ul><li>Double click on the <code>install.bat</code> file to run installation script.</li><li>It may require administrative privileges to install the plugin.</li></ul><br/><h4>MacOS</h4><ul><li>Open Terminal app</li><li>Navigate to the folder where you unpacked the installation scripts</li><li>Run the following command:<code>bash install.sh</code></li></ul><hr/><h3 class=\"page-title\" translate=\"translate\">Load Plugin in MS Word</h3><br/><br/><b>Step 1</b><br/><img src=\"https://media-content.siemens-specwriter.com/word-plugin/step-1.png\" style=\"width: 900px;\"/><br/><br/><b>Step 2</b><br/><img src=\"https://media-content.siemens-specwriter.com/word-plugin/step-2.png\" style=\"width: 900px;\"/><br/><br/><b>Step 3</b><br/><img src=\"https://media-content.siemens-specwriter.com/word-plugin/step-3.png\" style=\"width: 900px;\"/><br/><br/><b>Step 4</b><br/><img src=\"https://media-content.siemens-specwriter.com/word-plugin/step-4.png\" style=\"width: 900px;\"/><br/><br/><b>Step 5</b><br/><img src=\"https://media-content.siemens-specwriter.com/word-plugin/step-5.png\" style=\"width: 900px;\"/><br/><br/></div>");
$templateCache.put("app/tutorial/admin/ui-walk-through/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Admin – UI Walk Through</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/admin/siemens-specwriter-admin-ui.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/admin/tags/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Admin – Tags Tutorial</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/admin/siemens-specwriter-tags.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/admin/product-data-sheets/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Admin – Working with Product Data Sheets</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/admin/siemens-specwriter-product-data-sheets.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/tutorial/admin/control-logic/tutorial.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><h3 class=\"page-title\" translate=\"translate\">Admin – Control Logic Tutorial</h3><hr/><video class=\"video-js\" id=\"my-video\" controls=\"controls\" preload=\"auto\" width=\"800\" height=\"450\"><source src=\"https://media-content.siemens-specwriter.com/admin/siemens-specwriter-control-logic.mp4\" type=\"video/mp4\"/></video></div>");
$templateCache.put("app/main/spec-history/spec-history.html", "<div class=\"modal-header\"><div class=\"modal-title\"></div><h3>Specification history</h3></div><div class=\"modal-body\"><table><tr ng-repeat=\"history in projectHistory\" style=\"cursor:pointer; display: grid;\" ng-click=\"fetch(history)\"><td style=\"font-weight: bold; font-size: large;\">{{ history.user.username }} - {{ history.timestamp }}</td><td ng-show=\"history.expanded\" ng-repeat=\"pair in finalResult\">{{ pair }}</td></tr></table></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/main/rename-project/rename-project.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span ng-hide=\"isNewName\" ng-show=\"isRename\" translate=\"translate\">Rename Project</span><span ng-hide=\"isRename\" translate=\"translate\">Set copy name</span><span ng-show=\"isNewName\" translate=\"translate\"> enter new name</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" focus-me=\"true\"/></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/main/main.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h3 class=\"page-title\" translate=\"translate\">Projects</h3></div></div><hr/><div class=\"row\"><div class=\"col-lg-12 hidden\" id=\"hiddenBtn\"><a class=\"btn btn-primary btn-lg essential\" ng-click=\"create()\" title=\"{{\'Create New Project\' | translate }}\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Create</span></a><a class=\"btn btn-primary btn-lg essential\" ng-href=\"shared-specs\" ng-hide=\"teamFlag\" title=\"{{\'Load team specifications\' | translate }}\"><i class=\"fa fa-users\"></i> <span translate=\"translate\">Team Specifications</span></a><!--a.btn.btn-primary.btn-lg(ng-click=\"addRootFolder()\", style=\"margin-left:5px\" title=\"{{\'add root folder\' | translate }}\")--><!--  i.fa.fa-plus--><!--  = \' \'--><!--  span(translate) Add root folder--></div></div><div class=\"row\"><div class=\"col-lg-12\" style=\"overflow-y: auto; height: calc(100vh - 260px);\"><table class=\"table\" id=\"{{tableID}}\" ng-if=\"specConfigs\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"dtColumns\" dt-instance=\"dt.instance\" addBtn=\"true\" datatable-fix=\"datatable-fix\"></table></div></div></div>");
$templateCache.put("app/main/invite-team/invite-team.html", "<div class=\"modal-header\"><div class=\"modal-title\"><div class=\"div\" style=\"display: flex;\"><i class=\"fa fa-share-alt\"></i> <span style=\"font-size: 15px; cursor: pointer; width:40%;\" ng-click=\"disableModifyTeam()\">Invite Team Members<hr ng-class=\"{\'highlight\': !modifyFlag}\"/></span><span style=\"font-size: 15px; cursor: pointer; width: 40%; margin-left: 20%\" ng-click=\"enableModifyTeam()\" ng-style=\"{\'pointer-events\': modifyTab ? \'auto\' : \'none\', \'opacity\': modifyTab ? \'1\' : \'0.5\'}\">Modify Team<hr ng-class=\"{\'highlight\': modifyFlag}\"/></span></div><hr ng-hide=\"modifyFlag\"/><div class=\"invite-content\" ng-hide=\"modifyFlag\"><span>Share {{ project.name }} with: <span ng-repeat=\"selectedUser in selectedUsers\">{{ selectedUser.username  }} <span ng-hide=\"$last\">, </span></span></span><hr/></div><div class=\"row\"><div class=\"pull-left\"><input class=\"form-control\" type=\"text\" ng-model=\"search\" ng-change=\"filter()\" ng-hide=\"modifyFlag\" placeholder=\"Search...\" style=\"margin-left: 10px; margin-bottom: 10px; overflow: hidden;\"/></div></div></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\" style=\"height: 90%; max-height: 500px; overflow-x: hidden;\"><div class=\"row\"><table><thead><tr ng-repeat=\"user in filteredUsers\"><th><div class=\"checkbox\" style=\"margin-left: 10px\"><label><input type=\"checkbox\" ng-model=\"user.isSelected\" ng-change=\"select()\"/></label></div></th><th>{{ user.username }}</th></tr></thead></table></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/users/edit/edit.html", "<div class=\"modal-header\" ng-init=\"updateValues()\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit user information</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><form class=\"form\" name=\"editForm\" novalidate=\"\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label>First Name</label><input class=\"form-control\" type=\"text\" name=\"forename\" ng-model=\"userCopy.forename\" focus-me=\"true\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Last Name</label><input class=\"form-control\" type=\"text\" name=\"surname\" ng-model=\"userCopy.surname\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Midname</label><input class=\"form-control\" type=\"text\" name=\"midname\" ng-model=\"userCopy.midname\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>E-mail</label><input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"userCopy.email\" required=\"required\" duplicate=\"duplicate\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Username</label><input class=\"form-control\" type=\"text\" name=\"username\" ng-model=\"userCopy.username\" required=\"required\" duplicate=\"duplicate\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Company</label><input class=\"form-control\" type=\"text\" name=\"company\" ng-model=\"userCopy.company\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Country</label><select class=\"form-control\" name=\"country\" ng-model=\"userCopy.country\" ng-options=\"x.code as x.name for x in countries | orderBy:\'name\'\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select></div><div class=\"form-group\" set-error-style=\"set-error-style\" ng-if=\"userCopy.role===\'master\'\"><label ng-click=\"logger()\">Countries</label><div class=\"form-check\" ng-repeat=\"x in countries | orderBy:\'name\'\"><input class=\"form-check-input\" type=\"checkbox\" ng-model=\"managedCountriesObj[x.code]\"/><label class=\"form-check-label\">{{ x.name }}</label></div></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Language</label><select class=\"form-control\" name=\"language\" ng-model=\"userCopy.language\" ng-options=\"x.code as x.name for x in languages\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Role</label><select class=\"form-control\" name=\"role\" ng-model=\"userCopy.role\" ng-options=\"x for x in roles\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>New Password</label><input class=\"form-control\" type=\"password\" ng-model=\"userCopy.password\" ng-minlength=\"3\"/></div></form></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave(editForm)\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/spec-configs/upload/upload.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Upload</span> <span translate=\"translate\">{{ title }}(s)</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" ng-disabled=\"isReferred || isMultiple\" focus-me=\"true\"/></div></div><hr/><div><button class=\"btn btn-primary\" ng-file-select=\"ng-file-select\" ng-model=\"files\" ng-change=\"fileSelectChanged()\" ng-multiple=\"enableMultiple\" accept=\"*\" resetOnClick=\"true\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Select file to upload...</span></button><div ng-show=\"files.length\"><br/><label translate=\"translate\">Selected files:</label><br/><ul class=\"list-group\" style=\"max-height: 300px; overflow: auto;\"><li class=\"list-group-item list-group-item-info\" ng-repeat=\"item in files\">{{ item.name }}<a class=\"btn btn-danger btn-sm btn-conflict\" ng-click=\"removeFile($index)\"><i class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div><div class=\"modal-footer\"><div class=\"checkbox pull-left\" ng-if=\"showAgreeName()\" style=\"margin: 0;\"><label><input type=\"checkbox\" ng-model=\"agreement.accepted\"/><span translate=\"translate\">Upload file with different name</span></label></div><div class=\"pull-right text-nowrap\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"saveDisabled()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div></div>");
$templateCache.put("app/admin/spec-configs/unpublish/unpublish-spec.html", "<div class=\"modal-header\"><h3 class=\"modal-title text-info\"><i class=\"fa fa-question-circle\"></i> <span translate=\"translate\">Unpublish Spec Configuration</span></h3></div><div class=\"modal-body\">{{\'Are you sure you want to unpublish spec configuration\'|translate}}?<br/><br/><div class=\"checkbox\"><label></label><input type=\"checkbox\" ng-model=\"keepActive\" translate=\"translate\"/>Keep spec config active to create projects</div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"yes()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Yes</span></button><button class=\"btn btn-danger\" ng-click=\"no()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">No</span></button></div>");
$templateCache.put("app/admin/spec-configs/specification/specification.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"upload new specification\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Specifications</span> <span class=\"badge\">{{ list.length }}</span></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in list | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-6\"><a ng-href=\"\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Specification\')}\" title=\"{{\'preview specification\'|translate}}\">{{ item.name }}</a></div><div class=\"col-xs-1\"><a ng-click=\"showReferred(item)\"><i class=\"fa fa-file\"></i></a></div><div class=\"col-xs-1\"><a ng-click=\"validateTags(item)\"><i class=\"fa fa-tag\"></i></a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download specification\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete specification\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/spec-config.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4 text-left\"><a class=\"btn btn-primary essential\" ng-click=\"create()\" title=\"{{\'create new spec config\'|translate}}\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Add Configuration</span></a> <a class=\"btn btn-primary essential\" ng-click=\"createProject()\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Create New Project\'|translate}}\"><i class=\"fa fa-play\"></i> <span translate=\"translate\">New Project</span></a></div><div class=\"col-md-8\"><div ng-show=\"selectedSpecConfig\"><div class=\"pull-left\" style=\"margin-top: 5px; font-size: 16px;\">{{ selectedSpecConfig.alias || \'(unnamed spec config)\' }}:&nbsp;<label translate=\"translate\">Country</label>&nbsp;{{ countries.getName(selectedSpecConfig.key.country) }}\n&nbsp;/&nbsp;<label translate=\"translate\">Product</label>&nbsp;{{ products.getName(selectedSpecConfig.key.product) }}\n&nbsp;/&nbsp;<label translate=\"translate\">Language</label>&nbsp;{{ languages.getName(selectedSpecConfig.key.language) }}</div><div class=\"pull-right\"><div class=\"btn-group dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li><a ng-click=\"downloadZip()\" title=\"{{\'Download Full Spec as Zip\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><!--lia(ng-click=\"edit()\", ng-hide=\"selectedSpecConfig.isPublished\", title=\"{{\'Edit Spec Configuration\'|translate}}\")\n  i.fa.fa-pencil\n  = \' \'\n  span(translate) Edit--><li><a ng-click=\"delete(selectedSpecConfig)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete spec configuration\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li><li><a ng-click=\"publish()\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Publish Spec Configuration\'|translate}}\"><i class=\"fa fa-cloud-upload\"></i> <span translate=\"translate\">Publish</span></a></li><li><a ng-click=\"unpublish()\" ng-show=\"selectedSpecConfig.isPublished\" title=\"Unpublish Configuration\"><i class=\"fa fa-cloud-download\"></i> <span translate=\"translate\">Unpublish</span></a></li></ul></div></div></div></div></div><hr/></div><div class=\"container-fluid\" ng-style=\"{ \'padding-left\': sidebarCollapsed ? \'40px\' : \'15px\' }\"><div class=\"row\"><div class=\"col-md-4\" ng-hide=\"sidebarCollapsed\" style=\"position: relative;\"><div ng-show=\"showTree &amp;&amp; selectedSpecConfig\" style=\"position: absolute; right: 0; top: 0\"><a ng-click=\"sidebarCollapsed = true;\" title=\"collapse side bar\"><i class=\"double-left-arrow text-muted\"></i></a></div><loading show=\"!showTree\"></loading><tree-grid ng-show=\"showTree\" tree-data=\"treeData\" col-defs=\"colDefs\" icon-leaf=\"fa fa-file-text\" on-select=\"tableNodeClick(branch)\" on-click=\"tableNodeClick(branch)\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></tree-grid></div><div class=\"div\" ng-class=\"{ \'col-md-8\': !sidebarCollapsed, \'col-md-12\': sidebarCollapsed }\" style=\"position: relative;\"><div style=\"position: absolute; left: -10px; top: 0\" ng-show=\"sidebarCollapsed\"><a ng-click=\"sidebarCollapsed = false;\" title=\"show side bar\"><i class=\"double-right-arrow text-muted\"></i></a></div><loading show=\"!readyToShow\"></loading><ul class=\"nav nav-tabs\" ng-show=\"selectedSpecConfig &amp;&amp; readyToShow\"><li ng-class=\"{ active: showTab === \'config\' }\"><a href=\"#\" ng-click=\"showTab = \'config\'\" style=\"padding: 10px 15px;\">Questionnaire</a></li><li ng-class=\"{ active: showTab === \'sheets\' }\"><a href=\"#\" ng-click=\"showTab = \'sheets\'\" style=\"padding: 10px 15px;\">Data Sheets</a></li><li ng-class=\"{ active: showTab === \'logic\' }\"><a href=\"#\" ng-click=\"showTab = \'logic\'\" style=\"padding: 10px 15px;\">Control Logic</a></li><li ng-class=\"{ active: showTab === \'users\' }\"><a href=\"#\" ng-click=\"showTab = \'users\'\" style=\"padding: 10px 15px;\">Users</a></li><li ng-class=\"{ active: showTab === \'content\' }\"><a href=\"#\" ng-click=\"showTab = \'content\'\" style=\"padding: 10px 15px;\">Configuration Content</a></li><li ng-class=\"{ active: showTab === \'reports\' }\"><a href=\"#\" ng-click=\"showTab = \'reports\'\" style=\"padding: 10px 15px;\">Tags</a></li></ul><br/><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'config\' &amp;&amp; specConfigUrl\"><iframe ng-src=\"{{ specConfigUrl }}\" style=\"border: none; height: calc(100vh - 300px);\"></iframe></section><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'sheets\' &amp;&amp; specConfigDataSheetsUrl\"><iframe ng-src=\"{{ specConfigDataSheetsUrl }}\" style=\"border: none; height: calc(100vh - 300px);\"></iframe></section><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'logic\' &amp;&amp; specConfigLogicUrl\"><iframe ng-src=\"{{ specConfigLogicUrl }}\" style=\"border: none; height: calc(100vh - 300px);\"></iframe></section><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'users\' &amp;&amp; specConfigUsersUrl\"><iframe ng-src=\"{{ specConfigUsersUrl }}\" style=\"border: none; height: calc(100vh - 300px);\"></iframe></section><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'content\'\"><label translate=\"translate\">Hide empty sections&nbsp;</label><input type=\"checkbox\" ng-model=\"hideEmptyAccordions\"/><div class=\"col-md-12\" style=\"padding: 0; height: calc(100vh - 330px) !important; overflow-y: auto !important;\"><accordion close-others=\"false\"><accordion-group><div ng-include=\"\'app/admin/spec-configs/question-sets/question-sets.html\'\" ng-controller=\"QuestionSetsTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.pointLists.length\"><div ng-include=\"\'app/admin/spec-configs/point-lists/point-lists.html\'\" ng-controller=\"PointListsTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.boms.length\"><div ng-include=\"\'app/admin/spec-configs/boms/boms.html\'\" ng-controller=\"BomsTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.drawings.length\"><div ng-include=\"\'app/admin/spec-configs/drawing/drawing.html\'\" ng-controller=\"DrawingTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.sequences.length\"><div ng-include=\"\'app/admin/spec-configs/sequence/sequence.html\'\" ng-controller=\"SequenceTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.compliances.length\"><div ng-include=\"\'app/admin/spec-configs/compliance/compliance.html\'\" ng-controller=\"ComplianceTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.consistencies.length\"><div ng-include=\"\'app/admin/spec-configs/consistency/consistency.html\'\" ng-controller=\"ConsistencyTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !selectedSpecConfig.specifications.length\"><div ng-include=\"\'app/admin/spec-configs/specification/specification.html\'\" ng-controller=\"SpecificationTabCtrl\"></div></accordion-group><accordion-group ng-hide=\"hideEmptyAccordions &amp;&amp; !filesCount\"><accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"uploadFile(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"upload new drawing\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span>Spec Files</span> <span class=\"badge\">{{ filesCount }}</span></div></div></accordion-heading><div ng-include=\"\'components/files-repository/files-repository.html\'\"></div></accordion-group><accordion-group><div ng-include=\"\'app/admin/spec-configs/referred-files/referred-files.html\'\" ng-controller=\"ReferredFilesTabCtrl\"></div></accordion-group><accordion-group><div ng-include=\"\'app/admin/spec-configs/snapshots/snapshots.html\'\" ng-controller=\"SnapshotsTabCtrl\"></div></accordion-group><accordion-group><div ng-include=\"\'app/admin/spec-configs/project/project.html\'\" ng-controller=\"ProjectTabCtrl\"></div></accordion-group><accordion-group><accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><span>History</span> <span class=\"badge\">{{ selectedSpecConfig.history.length }}</span></div></div></accordion-heading><div class=\"row\"><div class=\"col-md-4\" translate=\"translate\">File Name</div><div class=\"col-md-2\" translate=\"translate\">Type</div><div class=\"col-md-2\" translate=\"translate\">Uploaded at</div><div class=\"col-md-2\" translate=\"translate\">Uploaded by</div><div class=\"col-md-2\">&nbsp;</div></div><hr/><section ng-repeat=\"history in selectedSpecConfig.history | orderBy: \'uploaded\': true\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-4\">{{ history.fileName }} <i class=\"fa fa-exclamation-triangle invalid-qs\" ng-show=\"history.notCompleted\" title=\"Invalid Question set\"></i></div><div class=\"col-md-2\">{{ history.entity }}</div><div class=\"col-md-2\">{{ history.uploaded | date: \'yyyy-MM-dd HH:mm:ss\' }}</div><div class=\"col-md-2\">{{ history.uploadedBy.username }}</div><div class=\"col-md-2 text-right\"><div class=\"btn-group\"><a class=\"btn btn-primary\" href=\"{{getHistoryLink(history)}}\" target=\"_blank\" title=\"Download spec history item\"><i class=\"fa fa-download\"></i></a></div></div></div></section></accordion-group><accordion-group><accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><span translate=\"translate\">Spec Information</span></div></div></accordion-heading><section><strong>{{\'Name\'|translate}} - {{ selectedSpecConfig.alias || \'(unnamed spec config)\' }}</strong><br/><br/><strong>{{\'Country\'|translate}} - {{ countries.getName(selectedSpecConfig.key.country) }}</strong><br/><br/><strong>{{\'Product\'|translate}} - {{ products.getName(selectedSpecConfig.key.product) }}</strong><br/><br/><strong>{{\'Language\'|translate}} - {{ languages.getName(selectedSpecConfig.key.language) }}</strong><br/><br/><strong>{{\'Created by\'|translate}} {{selectedSpecConfig.createdBy.username }}, at {{selectedSpecConfig.created | date: \'yyyy-MM-dd HH:mm:ss\' }}</strong><br ng-if=\"selectedSpecConfig.updatedBy\"/><br ng-if=\"selectedSpecConfig.updatedBy\"/><strong ng-if=\"selectedSpecConfig.updatedBy\">{{\'Updated by\'|translate}} {{selectedSpecConfig.updatedBy.username }}, at {{selectedSpecConfig.updated | date: \'yyyy-MM-dd HH:mm:ss\' }}</strong><br/><br/><strong>{{\'Projects Count\'|translate}} - {{ selectedSpecConfig.projectCount }}</strong><br/><br/><strong>{{\'Published\'|translate}} - {{ selectedSpecConfig.isPublished ? \'Yes\': \'No\' }}</strong></section></accordion-group></accordion></div></section><section ng-if=\"selectedSpecConfig &amp;&amp; readyToShow &amp;&amp; showTab === \'reports\' &amp;&amp; specConfigReportsUrl\"><iframe ng-src=\"{{ specConfigReportsUrl }}\" style=\"border: none; height: calc(100vh - 300px);\"></iframe></section></div></div></div>");
$templateCache.put("app/admin/spec-configs/snapshots/snapshots.html", "<accordion-heading><div class=\"row\"><div class=\"col-sm-12\"><span translate=\"translate\">Snapshots</span> <span class=\"badge\">{{ snapshots.length }}</span></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"row\"><div class=\"col-md-1\" translate=\"translate\"></div><div class=\"col-md-4\" translate=\"translate\">Name</div><div class=\"col-md-3 text-center\" translate=\"translate\">Projects</div><div class=\"col-md-2 text-center\" translate=\"translate\">Version</div><div class=\"col-md-1 text-center\" translate=\"translate\">Activate</div><div class=\"col-md-1 text-right\" translate=\"translate\">Delete</div></div><hr/><div class=\"section-wrapper\" ng-repeat=\"item in snapshots\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-1\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"/></div></div><div class=\"col-md-4\">{{ item.created | date:\'dd MMM yyyy HH:mm\' + \' - v\' + item.version }}</div><div class=\"col-md-3 text-center\">{{ item.projectCount }}</div><div class=\"col-md-2 text-center\">{{ item.version }}</div><div class=\"col-md-1 text-center\"><div class=\"btn-group\"><i class=\"fa fa-lg fa-check-circle text-success\" ng-show=\"item.isActive\"></i><a ng-click=\"activate(item)\" ng-show=\"!item.isActive\" title=\"{{\'set active snapshot\'|translate}}\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><i class=\"fa fa-lg fa-circle-thin\"></i></a></div></div><div class=\"col-md-1 text-right\"><div class=\"btn-group\"><a class=\"btn btn-danger\" ng-click=\"delete(item)\" ng-disabled=\"item.isActive\" title=\"{{\'delete snapshot\'|translate}}\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><i class=\"fa fa-trash-o\"></i></a></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/sequence/sequence.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"upload new sequence\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Sequences</span> <span class=\"badge\">{{ list.length }}</span></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">Uploading: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in list | orderBy:\'name\'\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-7\"><a ng-href=\"\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Sequence\')}\" title=\"{{\'preview sequence\'|translate}}\">{{ item.name }}</a></div><div class=\"col-xs-1\"><a ng-click=\"validateTags(item)\"><i class=\"fa fa-tag\"></i></a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download sequence\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete sequence\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/referred-files/referred-files.html", "<accordion-heading><div class=\"row\"><div class=\"col-sm-12\"><span translate=\"translate\">Referred Files</span> <span class=\"badge\">{{ referredFiles.length }}</span></div><!--.col-sm-4.text-right--><!--  button.btn.btn-primary(ng-click=\"resetSort(); $event.stopPropagation();\")--><!--    i.fa.fa-refresh--><!--    | &nbsp; Reset--></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-4\"><a ng-click=\"sortBy(\'fileName\')\" translate=\"translate\">Name&nbsp;</a><span ng-show=\"order.fields.indexOf(\'fileName\') &gt;= 0\"><i class=\"fa fa-caret-down\" ng-show=\"order.isDesc\"></i><i class=\"fa fa-caret-up\" ng-hide=\"order.isDesc\"></i></span></div><div class=\"col-md-3\"><a ng-click=\"sortBy(\'referredBy\')\" translate=\"translate\">Referred by &nbsp;</a><span ng-show=\"order.fields.indexOf(\'referredBy\') &gt;= 0\"><i class=\"fa fa-caret-down\" ng-show=\"order.isDesc\"></i><i class=\"fa fa-caret-up\" ng-hide=\"order.isDesc\"></i></span></div><div class=\"col-md-1\"><a ng-click=\"sortBy(\'type\')\" translate=\"translate\">Type&nbsp;</a><span ng-show=\"order.fields.indexOf(\'type\') &gt;= 0\"><i class=\"fa fa-caret-down\" ng-show=\"order.isDesc\"></i><i class=\"fa fa-caret-up\" ng-hide=\"order.isDesc\"></i></span></div><div class=\"col-md-3 text-right\"><div class=\"checkbox\" style=\"margin:0;\"><label><input type=\"checkbox\" ng-model=\"order.showMissing\" ng-change=\"showMissingChanged()\"/>{{\'Show missing first\'|translate}}</label></div></div></div><hr/><div class=\"section-wrapper\" ng-repeat=\"item in referredFiles | orderBy : order.fields\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-sm-1\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"/></div></div><div class=\"col-sm-4 col-xs-12 {{ item.exists ? \'\' : \'text-danger\' }}\">{{ item.fileName }}</div><div class=\"col-sm-3 col-xs-6 {{ item.exists ? \'\' : \'text-danger\' }}\">{{ item.referredBy }}</div><div class=\"col-sm-1 col-xs-3 {{ item.exists ? \'\' : \'text-danger\' }}\">{{ item.type }}</div><div class=\"col-sm-3 col-xs-3 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\" ng-disabled=\"selectedSpecConfig.isPublished &amp;&amp; !item.exists\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li><a ng-click=\"upload(item)\" ng-hide=\"item.exists || selectedSpecConfig.isPublished\" title=\"{{\'Upload\'|translate}}\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Upload</span></a></li><li><a ng-click=\"preview(item)\" ng-show=\"item.exists\" title=\"{{\'Preview\'|translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a></li><li><a href=\"{{ getDownloadLink(item.id) }}\" target=\"_blank\" ng-show=\"item.exists\" title=\"{{\'Download\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"edit(item)\" ng-show=\"item.exists &amp;&amp; !selectedSpecConfig.isPublished\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><a ng-click=\"delete(item)\" ng-show=\"item.exists &amp;&amp; !selectedSpecConfig.isPublished\" title=\"{{\'Delete\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/question-sets/question-sets.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><div class=\"row\"><div class=\"col-sm-10\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(1); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished || entryQuestionSet\" title=\"{{\'upload mandatory question set\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload entry question set...</span></a> <a class=\"btn btn-primary\" ng-click=\"export()\"><img src=\"/assets/images/download.svg\"/> <span>Export</span></a><span translate=\"translate\">Question Sets</span> <span class=\"badge\">{{entryQuestionSet ? 1 : 0}}</span></div></div></div></div><div class=\"row\" ng-show=\"errors\"><div class=\"col-sm-12\"><br/><alert type=\"danger\"><a class=\"close\" ng-click=\"hideErrors(); $event.stopPropagation();\">&times</a><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload question set configuration</strong><ul><li><pre class=\"text-danger\">{{ errors }}</pre></li></ul></alert></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><div class=\"row\"><div class=\"col-xs-10\"><!--a.btn.btn-primary(ng-click=\"edit(entryQuestionSet)\", ng-show=\"!selectedSpecConfig.isPublished && entryQuestionSet\", title=\"edit entry question set\")--><!--  i.fa.fa-pencil--><!--= \' \'--><a ng-href=\"admin/specs/preview/question-set/{{ entryQuestionSet._id }}\" ng-show=\"entryQuestionSet\" title=\"{{\'preview spec config\'|translate}}\" target=\"_blank\"><b>{{ entryQuestionSet.name }}</b> <i class=\"fa fa-exclamation-triangle invalid-qs\" ng-hide=\"entryQuestionSet.isCompleted\" title=\"{{\'Invalid Question set\'|translate}}\"></i></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\" ng-show=\"entryQuestionSet\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished &amp;&amp; entryQuestionSet\"><a ng-click=\"edit(entryQuestionSet)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><a ng-click=\"previewEntry()\" title=\"{{\'Preview\'|translate}}\"><i class=\"fa fa-eye\"></i> <span translate=\"translate\">Preview</span></a></li><li><a href=\"{{ getDownloadLink(entryQuestionSet._id) }}\" ng-show=\"entryQuestionSet\" target=\"_blank\" title=\"{{\'download question set\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li></ul></div></div></div>");
$templateCache.put("app/admin/spec-configs/question-sets/preview/preview-question-set.html", "<div ng-include=\"&quot;components/header/header-type-content-1.html&quot;\"></div><br/><div class=\"container\"><div>{{ specConfig.alias || \'(unnamed spec config)\' }}:&nbsp;<label translate=\"translate\">Country:</label>&nbsp;{{ countries.getName(specConfig.key.country) }}\n&nbsp;/&nbsp;<label translate=\"translate\">Product:</label>&nbsp;{{ products.getName(specConfig.key.product) }}\n&nbsp;/&nbsp;<label translate=\"translate\">Language:</label>&nbsp;{{ languages.getName(specConfig.key.language) }}<br/><br/></div><tabset><tab heading=\"{{\'Status\'|translate}}\"><h3 ng-if=\"questionSet.isCompleted\"><div class=\"label label-success\" translate=\"translate\">Completed</div></h3><h3 ng-if=\"!questionSet.isCompleted\"><div class=\"label label-danger\" translate=\"translate\">Invalid</div></h3></tab><tab ng-show=\"!questionSet.isCompleted &amp;&amp; questionSet.validationError\"><tab-heading>Errors &nbsp;<i class=\"fa fa-exclamation-triangle invalid-qs\"></i></tab-heading><br/><div class=\"row\"><div class=\"col-md-12\"><json-formatter json=\"errorsPreview\" open=\"1\"></json-formatter></div></div></tab><tab heading=\"{{\'Json Preview\'|translate}}\" ng-show=\"questionSet.isCompleted\"><div class=\"row\"><div class=\"col-md-12\"><json-formatter json=\"questionSet\" open=\"1\"></json-formatter></div></div></tab><tab ng-show=\"questionSet.nonParsed.length &gt; 0\"><tab-heading>{{\'Invalid Lines\'|translate}} &nbsp;<i class=\"fa fa-exclamation-triangle invalid-qs\"></i></tab-heading><br/><div class=\"row\"><div class=\"col-md-12\"><json-formatter json=\"questionSet.nonParsed\" open=\"1\"></json-formatter></div></div></tab><tab ng-show=\"questionSet.duplicates.length &gt; 0\"><tab-heading>{{\'Duplicates\'|translate}} &nbsp;<i class=\"fa fa-exclamation-triangle invalid-qs\"></i></tab-heading><br/><div class=\"row\"><div class=\"col-md-3\" translate=\"translate\">Type</div><div class=\"col-md-3\">ID</div><div class=\"col-md-3\" translate=\"translate\">Original</div><div class=\"col-md-3\" translate=\"translate\">Duplicate</div></div><hr/><section ng-repeat=\"item in questionSet.duplicates\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-3\">{{ item.type }}</div><div class=\"col-md-3\">{{ item.id }}</div><div class=\"col-md-3\">{{ item.original }}</div><div class=\"col-md-3\">{{ item.duplicate }}</div></div></section></tab></tabset></div>");
$templateCache.put("app/admin/spec-configs/project/save-project/save-project.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save project</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Comments</label><textarea class=\"form-control\" name=\"comments\" ng-model=\"comments\" focus-me=\"true\"></textarea></div></div><br/><div class=\"checkbox\" ng-show=\"answers\"><label><input type=\"checkbox\" ng-model=\"asNew\"/>{{\'Save project as new\'|translate}}</label></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/spec-configs/project/project.html", "<accordion-heading><div class=\"row\"><div class=\"col-sm-12\"><span translate=\"translate\">Projects</span> <span class=\"badge\">{{ projects.length }}</span></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"row\"><div class=\"col-md-1\"></div><div class=\"col-md-2\" translate=\"translate\">Name</div><div class=\"col-md-2\" translate=\"translate\">Last Updated</div><div class=\"col-md-1\" translate=\"translate\">Created By</div><div class=\"col-md-4\" translate=\"translate\">Comments</div><div class=\"col-md-2\">&nbsp;</div></div><hr/><div class=\"section-wrapper\" ng-repeat=\"item in projects\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-sm-12\"><hr/></div></div><div class=\"row\"><div class=\"col-md-1\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"/></div></div><div class=\"col-md-2\"><a ng-click=\"open(item)\">{{ item.name}}</a></div><div class=\"col-md-2\">{{ item.updated | date:\'dd MMM yyyy HH:mm\'}}</div><div class=\"col-md-1\">{{ item.createdBy.username }}</div><div class=\"col-md-4\">{{ item.comments }}</div><div class=\"col-md-2 text-right\"><a class=\"btn btn-primary\" ng-click=\"open(item)\" title=\"{{\'Open project\'|translate}}\"><i class=\"fa fa-eye\"></i></a> <a class=\"btn btn-danger\" ng-click=\"delete(item)\" title=\"Delete project\"><i class=\"fa fa-trash-o\"></i></a></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/preview/preview-spec-config.html", "<div ng-include=\"&quot;components/header/header-type-content-1.html&quot;\"></div><br/><div class=\"container\"><div>{{ spec.alias || \'(unnamed spec config)\' }}:&nbsp;<label>Country:</label>&nbsp;{{ countries.getName(spec.key.country) }}\n&nbsp;/&nbsp;<label>Product:</label>&nbsp;{{ products.getName(spec.key.product) }}\n&nbsp;/&nbsp;<label>Language:</label>&nbsp;{{ languages.getName(spec.key.language) }}<br/><br/></div><tabset><tab heading=\"{{\'Preview question set\'|translate}}\"><br/><div class=\"row\"><div class=\"col-md-8\"><div class=\"pull-left\"><i class=\"fa fa-lg fa-toggle-on text-success\" ng-show=\"renderPreview.showConfig\" ng-click=\"renderPreview.showConfig = !renderPreview.showConfig\"></i><i class=\"fa fa-lg fa-toggle-off text-info\" ng-hide=\"renderPreview.showConfig\" ng-click=\"renderPreview.showConfig = !renderPreview.showConfig\"></i> {{\'Show questions JSON representation\'|translate}}</div><div class=\"pull-right text-nowrap\"><button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"back()\" ng-show=\"path.length &gt; 1\"><i class=\"fa fa-angle-double-left\"></i> <span translate=\"translate\">Back</span></button> <button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"renderPreview.prev()\" ng-disabled=\"!(renderPreview.pageIndex &gt; 0)\"><i class=\"fa fa-angle-left\"></i> <span translate=\"translate\">Prev</span></button> <button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"renderPreview.next()\" ng-disabled=\"!(renderPreview.pageIndex &lt; questionSet.pages.length - 1)\"><span translate=\"translate\">Next</span> <i class=\"fa fa-angle-right\"></i></button> <button class=\"btn btn-xs btn-primary btn-s\" ng-click=\"renderPreview.save()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button>{{renderPreview.docIsEmpty}}</div><div class=\"clearfix\"></div><hr/><question-set source=\"questionSet\" destination=\"renderPreview.doc\" point-lists=\"pointLists\" ds-items=\"dataSheets\" page=\"renderPreview.pageIndex\" show-config=\"renderPreview.showConfig\"></question-set></div><div class=\"col-md-4\"><pre>{{ renderPreview.docStr }}</pre></div></div></tab><tab heading=\"{{\'Preview answers\'|translate}}\"><br/><div class=\"row\"><div class=\"col-md-3\" translate=\"translate\">Last Updated</div><div class=\"col-md-2\" translate=\"translate\">Created By</div><div class=\"col-md-6\" translate=\"translate\">Comments</div><div class=\"col-md-1\">&nbsp;</div></div><hr/><section ng-repeat=\"item in answerSets\"><hr ng-hide=\"$first\"/><div class=\"row\"><div class=\"col-md-3\"><a ng-href=\"admin/specs/preview/{{ spec._id }}/{{ item._id }}\">{{ item.updated | date:\'dd MMM yyyy HH:mm\'}}</a></div><div class=\"col-md-2\">{{ item.createdByUsername }}</div><div class=\"col-md-6\">{{ item.comments }}</div><div class=\"col-md-1 text-right\"><div class=\"btn-group\"><a class=\"btn btn-primary\" ng-href=\"admin/specs/preview/{{ spec._id }}/{{ item._id }}\" title=\"{{\'view answers set\'|translate}}\"><i class=\"fa fa-eye\"></i></a><a class=\"btn btn-danger\" ng-click=\"deleteAnswersSet(item)\" title=\"{{\'delete answers set\'|translate}}\"><i class=\"fa fa-trash-o\"></i></a></div></div></div></section></tab></tabset></div>");
$templateCache.put("app/admin/spec-configs/point-lists/preview/preview-point-list.html", "<div ng-include=\"&quot;components/header/header-type-content-1.html&quot;\"></div><br/><div class=\"container\"><div spec-header=\"spec-header\" spec=\"specConfig\"></div><tabset><tab heading=\"{{ \'#\' + list.id }}\" ng-repeat=\"list in pointList.lists\" active=\"$first\"><br/></tab><div class=\"row\"><div class=\"col-md-12\"><point-list source=\"list\" show-all=\"true\" show-config=\"true\"></point-list></div></div><tab heading=\"{{\'Preview Invalid Lines\'|translate}}\" ng-show=\"pointList.nonParsed.length &gt; 0\"><br/><div class=\"row\"><div class=\"col-md-12\"><pre>{{ nonParsedPreview }}</pre></div></div></tab><tab heading=\"{{ pointList.name }}\"><div class=\"row\"><div class=\"col-md-12\"><json-formatter json=\"pointList\" open=\"1\"></json-formatter></div></div></tab></tabset></div>");
$templateCache.put("app/admin/spec-configs/point-lists/point-lists.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'upload new point list\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Point Lists</span> <span class=\"badge\">{{pointLists.length}}</span></div></div><div class=\"row\" ng-show=\"errors\"><div class=\"col-sm-12\"><br/><alert type=\"danger\"><a class=\"close\" ng-click=\"hideErrors(); $event.stopPropagation();\">&times</a><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload question set configuration</strong><ul><li><pre class=\"text-danger\">{{ errors }}</pre></li></ul></alert></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in pointLists | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-8\"><a ng-href=\"admin/specs/preview/point-list/{{ item._id }}\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Points List\')}\" title=\"{{\'preview point list\'|translate}}\" target=\"_blank\">{{ item.name }}</a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download point list\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete point list\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/open-project/open-project.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div ng-show=\"showError\">{{\'Something went wrong, please try again.\'}}</div>");
$templateCache.put("app/admin/spec-configs/history/history.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-list\"></i> <span translate=\"translate\">Question set configuration history</span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-5\">File name<!--a(ng-click=\"sortBy = [\'fileName\', \'uploaded\']\")--></div><div class=\"col-md-5\">Uploaded<!--a(ng-click=\"sortBy = [\'uploaded\', \'fileName\']\")--></div><div class=\"col-md-2 text-right\"></div></div><section ng-repeat=\"history in questionSet.history | orderBy: \'uploaded\': true\"><hr/><div class=\"row\" ng-class=\"{ \'text-bold\': $first }\"><div class=\"col-md-5\"><a href=\"api/questions/{{ questionSet._id }}/{{ history._id }}/{{ history.fileName }}\">{{ history.fileName }}</a></div><div class=\"col-md-5\">{{ history.uploaded | date: \'yyyy-MM-dd HH:mm:ss\' }}</div><div class=\"col-md-2 text-right\"><div class=\"btn-group\"><a class=\"btn btn-primary fa fa-retweet\" ng-click=\"revert(history)\" ng-disabled=\"$first\" title=\"{{\'revert question set\'|translate}}\"></a><a class=\"btn btn-primary fa fa-download\" href=\"api/questions/{{ questionSet._id }}/{{ history._id }}/{{ history.fileName }}\" target=\"_blank\" title=\"download question set\"></a><!--a.btn.btn-danger.fa.fa-trash(ng-click=\"delete(history)\", ng-hide=\"true\", title=\"delete question set upload history\")--></div></div></div></section></div><div class=\"modal-footer\"><button class=\"btn btn-danger btn-s\" ng-click=\"close()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Close</span></button></div>");
$templateCache.put("app/admin/spec-configs/edit/edit.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> {{ \'Upload\' | translate }} {{ title }}(s)</div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"name\" ng-disabled=\"isMultiple\" focus-me=\"true\"/></div></div><hr/><div><button class=\"btn btn-primary\" ng-file-select=\"ng-file-select\" ng-model=\"files\" ng-change=\"fileSelectChanged()\" accept=\"*\" resetOnClick=\"true\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Select file to upload...</span></button> <button class=\"btn btn-primary\" ng-click=\"setName()\" ng-show=\"showCopyName()\"><i class=\"fa fa-copy\"></i> <span translate=\"translate\">Copy name</span></button><div ng-show=\"files.length\"><br/><label translate=\"translate\">Selected files:</label><br/><ul class=\"list-group\" style=\"max-height: 300px; overflow: auto;\"><li class=\"list-group-item list-group-item-info\" ng-repeat=\"item in files\">{{ item.name }}<a class=\"btn btn-danger btn-sm btn-conflict\" ng-click=\"removeFile($index)\"><i class=\"fa fa-trash-o\"></i></a></li></ul></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-success btn-s\" ng-click=\"save()\" ng-disabled=\"saveDisabled()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/spec-configs/drawing/drawing.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'upload new drawing\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Drawings</span> <span class=\"badge\">{{ list.length }}</span></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in list | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-8\"><a ng-href=\"\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Drawing\')}\" title=\"{{ \'preview drawing\'|translate }}\">{{ item.fileName || (item.name+\'.\'+item.extension)  }}</a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink( item ) }}\" target=\"_blank\" title=\"\'Download drawing\'|translate\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete drawing\'|translate}}\"><i class=\"fa fa-trash\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/data-sheets/preview/preview-data-sheet.html", "<div ng-include=\"&quot;components/header/header-type-content-1.html&quot;\"></div><div class=\"container\"><div spec-header=\"spec-header\" spec=\"specConfig\"></div><tabset class=\"panel\"><tab heading=\"{{ dataSheets.name }}\"><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-6\"><table class=\"table\"><tr><th translate=\"translate\">Legend</th><th translate=\"translate\">Display</th><th translate=\"translate\">Suffix</th></tr><tr ng-repeat=\"(key,legend) in dataSheets.legend\"><td>{{key}}</td><td>{{legend.display}}</td><td>{{legend.suffix}}</td></tr></table></div></div><div class=\"row\"><div class=\"col-md-12\"><datasheet source=\"dataSheets\" data=\"[]\" question=\"[]\" answers=\"[]\" show-all=\"true\" show-config=\"true\"></datasheet></div></div></tab><tab heading=\"JSON\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"qs-tree-content\"><treecontrol class=\"tree-classic\" tree-model=\"jsonPreview.dataSheetsData\" options=\"treeOptions\" order-by=\"id\"><span class=\"{{ node.class }}\" ng-click=\"jsonPreview.nodeSelected(node)\">&nbsp;{{ node.text }}</span></treecontrol><div class=\"col-md-8\" ng-show=\"jsonPreview.selectedNode\"></div></div><pre>{{ jsonPreview.selectedNode }}</pre></div></div></tab></tabset></div>");
$templateCache.put("app/admin/spec-configs/data-sheets/data-sheets.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'upload new data sheet\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Data Sheets</span> <span class=\"badge\">{{ dataSheets.length }}</span></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div><div class=\"row\" ng-show=\"errors\"><div class=\"col-xs-12\"><br/><alert type=\"danger\"><a class=\"close\" ng-click=\"hideErrors(); $event.stopPropagation();\">&times</a><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload</strong><ul><li><pre class=\"text-danger\">{{ errors }}</pre></li></ul></alert></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in dataSheets | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-9\"><a ng-href=\"admin/specs/preview/data-sheet/{{ item._id }}\" title=\"{{\'preview data sheet\'|translate}}\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Datasheet\')}\" target=\"_blank\">{{ item.name }}</a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download data sheet\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete data sheet\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/create/create.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Create spec configuration</span></div></div><div class=\"modal-body\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control\" ng-model=\"data.key.country\" ng-options=\"x.code as x.name for x in countries\" ie-select-fix=\"ie-select-fix\" required=\"required\"><option value=\"\">(select country)</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"languages\" ng-model=\"data.key.language\"><option value=\"\">(select language)</option><option ng-repeat=\"language in languages\" ng-value=\"language.code\">{{ language.name }}</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"products\" ng-model=\"data.key.product\"><option value=\"\">(select product)</option><option ng-repeat=\"product in products\" ng-value=\"product.code\">{{ product.name }}</option></select></div><div class=\"col-md-3\"><select class=\"form-control\" ng-if=\"groups\" ng-model=\"data.group\"><option value=\"\">(for all users)</option><option ng-repeat=\"group in groups\" ng-value=\"group._id\">{{ group.name }}</option></select></div></div><br/><div class=\"row\"><div class=\"col-md-12\"><input class=\"form-control\" ng-model=\"data.alias\" placeholder=\"spec alias\"/></div></div><hr ng-show=\"errors.length\"/><alert ng-show=\"errors.length\" type=\"danger\"><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot create spec configuration</strong><ul><li ng-repeat=\"error in errors\">{{ error }}</li></ul></alert></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/spec-configs/create-project/create-project.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div ng-show=\"errorMessage\">{{\'Something went wrong, please try again\'|translate}}.</div><loading class=\"next-loading\" show=\"!errorMessage\"></loading>");
$templateCache.put("app/admin/spec-configs/consistency/consistency.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'upload new consistency\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Consistences</span> <span class=\"badge\">{{ list.length }}</span></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in list | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-7\"><a ng-href=\"\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Consistency\')}\" title=\"{{\'preview consistency\'|translate}}\">{{ item.name }}</a></div><div class=\"col-xs-1\"><a ng-click=\"validateTags(item)\"><i class=\"fa fa-tag\"></i></a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download consistency\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete consistency\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/conflicts/conflicts.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-upload\"></i> <span translate=\"translate\">Solve replace conflicts</span></div></div><div class=\"modal-body\"><label translate=\"translate\">Decline files replace:</label><br/><ul class=\"list-group\" style=\"max-height: 300px; overflow: auto;\"><li class=\"list-group-item list-group-item-info\" ng-repeat=\"item in files\">{{ item.name }}<a class=\"btn btn-danger btn-sm btn-conflict\" ng-click=\"decline($index)\"><i class=\"fa fa-trash-o\"></i></a></li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"replaceAll()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Replace all</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"declineAll()\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Decline all</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/spec-configs/compliance/compliance.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'upload new compliance\'|translate}}\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Compliances</span> <span class=\"badge\">{{ list.length }}</span></div><div class=\"col-xs-4 text-right\"></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in list | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-7\"><a ng-href=\"\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'Compliance\')}\" title=\"{{\'preview compliance\'|translate}}\">{{ item.name }}</a></div><div class=\"col-xs-1\"><a ng-click=\"validateTags(item)\"><i class=\"fa fa-tag\"></i></a></div><div class=\"col-xs-1\"><a ng-click=\"openModal(item)\"><img ng-class=\"{\'cl-active\': item.controlLogic.cl, \'cl-passive\': !item.controlLogic.cl}\" src=\"assets/images/control-logic.svg\" title=\"control logic\"/></a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"{{\'Edit\'|translate}}\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"{{\'Download compliance\'|translate}}\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"{{\'Delete compliance\'|translate}}\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/spec-configs/build/build-spec-config.html", "<div class=\"spec-wrapper\" ng-class=\"{open: $root.tabletIsOpen}\"><div ng-include=\"&quot;components/header/header-type-content-3.html&quot;\"></div><div class=\"top-bar\"><div class=\"left\"><a class=\"btn pull-left manage-projects\" ng-click=\"manageProjects()\"><i class=\"fa fa-caret-left\"></i> <span translate=\"translate\">Home</span></a><a class=\"btn pull-left manage-projects\" ng-click=\"goToFolder()\"><i class=\"fa fa-caret-left\"></i> <span translate=\"translate\">{{ current.folder.name }}</span></a></div><div class=\"progressbar\"><div><a class=\"project-progress-header\" ng-repeat=\"nav in current.fullNavigation\" ng-click=\"navigateTo(nav, $event)\"><span class=\"progress-text\">{{ nav.name }}</span><progressbar class=\"project-progress-bar\" progressbar-helper=\"progressbar-helper\" color=\"{{getProgressColor(nav)}}\" ng-style=\"{\'background-color\': nav.styles.disabled.background}\" max=\"1\" value=\"getProgressValue(nav)\"></progressbar></a></div></div></div><spec-builder></spec-builder></div>");
$templateCache.put("app/admin/spec-configs/boms/preview/preview-boms.html", "<div ng-include=\"&quot;components/header/header-type-content-1.html&quot;\"></div><br/><div class=\"container\"><div spec-header=\"spec-header\" spec=\"specConfig\"></div><tabset><tab heading=\"BOM:{{ billOfMaterials.name }}\"><br/><div class=\"row\"><div class=\"col-md-12\"><bill-of-material source=\"billOfMaterials\" data=\"{}\" show-config=\"false\" show-all=\"true\"></bill-of-material></div></div></tab><tab heading=\"JSON\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"qs-tree-content\"><treecontrol class=\"tree-classic\" tree-model=\"jsonPreview.bomsData\" options=\"treeOptions\" order-by=\"id\"><span class=\"{{ node.class }}\" ng-click=\"jsonPreview.nodeSelected(node)\">&nbsp;{{ node.text }}</span></treecontrol></div></div><div class=\"col-md-8\" ng-show=\"jsonPreview.selectedNode\"><pre>{{ jsonPreview.selectedNode }}</pre></div></div></tab></tabset></div>");
$templateCache.put("app/admin/spec-configs/boms/boms.html", "<accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><i class=\"fa fa-plus\" style=\"margin-right: 2%;\"></i><a class=\"btn btn-primary\" ng-click=\"upload(); $event.stopPropagation();\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"upload new point list\"><img src=\"/assets/images/upload-gm.svg\"/> <span translate=\"translate\">Upload</span></a><span translate=\"translate\">Bill of Materials</span> <span class=\"badge\">{{ bomItemsList.length }}</span></div></div><div class=\"row\" ng-show=\"errors\"><div class=\"col-sm-12\"><br/><alert type=\"danger\"><a class=\"close\" ng-click=\"hideErrors(); $event.stopPropagation();\">&times</a><i class=\"fa fa-warning text-danger\"></i> <strong translate=\"translate\">Cannot upload question set configuration</strong><ul><li><pre class=\"text-danger\">{{ errors }}</pre></li></ul></alert></div></div><div class=\"row text-muted\" ng-repeat=\"item in queue\"><hr/><div class=\"col-xs-7\">{{ item.file.name }}</div><div class=\"col-xs-2\">{{\'Uploading\'|translate}}: {{ item.file.size | filesize }}</div><div class=\"col-xs-3 text-right\"><div class=\"progress pull-left\" style=\"width: 90%;\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{ item.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{ item.progress }}%;\"><span ng-show=\"item.progress\">{{ item.progress }}%</span></div></div><a class=\"pull-right text-danger\" ng-click=\"cancelUpload(item)\"><i class=\"fa fa-trash-o\"></i></a><div class=\"clearfix\"></div></div></div></accordion-heading><section><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><a class=\"btn btn-primary spec-select-all\" ng-click=\"selectAll()\"><span>Select All</span></a><a class=\"btn btn-danger spec-delete-selected\" ng-click=\"deleteSelected()\"><span>Delete Selected Files</span></a></div></div><div class=\"section-wrapper\" ng-repeat=\"item in bomItemsList | orderBy:\'name\'\"><div class=\"row\" ng-hide=\"$first\"><div class=\"col-xs-12\"><hr/></div></div><div class=\"row\"><div class=\"col-xs-1\" ng-class=\"{\'read-only\': selectedSpecConfig.isPublished}\"><div class=\"config-checkbox\" style=\"margin: 0;\"><input ng-click=\"selectFile(item)\" ng-model=\"item.isSelected\" type=\"checkbox\"/></div></div><div class=\"col-xs-9\"><a ng-href=\"admin/specs/preview/boms/{{ item._id }}\" title=\"preview bill of material\" ng-class=\"{\'text-muted\': !isReferredItem(item, \'BOM\')}\" target=\"_blank\">{{ item.name }}</a></div><div class=\"col-xs-2 text-right\"><div class=\"dropdown\"><a class=\"btn btn-primary dropdown-toggle\"><span translate=\"translate\">Actions</span> <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\"><li ng-hide=\"selectedSpecConfig.isPublished\"><a ng-click=\"edit(item)\" title=\"Edit\"><i class=\"fa fa-pencil\"></i> <span translate=\"translate\">Edit</span></a></li><li><office-preview spec-config=\"selectedSpecConfig\" spec-item=\"item\"></office-preview></li><li><a href=\"{{ getDownloadLink(item._id) }}\" target=\"_blank\" title=\"Download bill of material\"><i class=\"fa fa-download\"></i> <span translate=\"translate\">Download</span></a></li><li><a ng-click=\"delete(item)\" ng-hide=\"selectedSpecConfig.isPublished\" title=\"Delete bill of material\"><i class=\"fa fa-trash-o\"></i> <span translate=\"translate\">Delete</span></a></li></ul></div></div></div></div></section>");
$templateCache.put("app/admin/product-lines/save/save.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span ng-if=\"!isEdit\" translate=\"translate\">Add product line</span><span ng-if=\"isEdit\" translate=\"translate\">Edit product line</span></div></div><div class=\"modal-body save-dialog\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><form class=\"form\" name=\"saveForm\" novalidate=\"\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"product.name\" focus-me=\"true\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Product Line Code</label><input class=\"form-control\" type=\"text\" ng-minlength=\"2\" ng-model=\"product.code\" required=\"required\"/></div><h4 translate=\"translate\">Translations</h4><div ng-repeat=\"translation in product.translations\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" set-error-style=\"set-error-style\"><input class=\"form-control\" type=\"text\" placeholder=\"{{\'Name\'|translate}}\" ng-model=\"translation.name\" focus-me=\"($last &amp;&amp; autoFocusName)\" required=\"required\"/></div></div><div class=\"col-md-4 country-language\"><div class=\"form-group\" set-error-style=\"set-error-style\"><input class=\"form-control\" ng-model=\"translation.lang\" placeholder=\"{{\'Language\'|translate}}\" ng-blur=\"languageBlur(translation)\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onLanguageSelected($item, translation)\" typeahead=\"language as language.name for language in languageList | filter:{$:$viewValue} \" required=\"required\"/></div></div><div class=\"col-md-2 text-right\"><a class=\"btn btn-danger\" ng-click=\"deleteTranslation($index)\" title=\"{{\'Delete\'|translate}}\"><i class=\"fa fa-trash-o\"></i></a></div></div></div><div><div class=\"row\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-primary\" ng-click=\"addTranslation()\" title=\"{{\'Add translation\'|translate}}\" style=\"margin-right: 1px;\"><i class=\"fa fa-plus\"></i></a></div></div></div></form></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave(saveForm)\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/product-lines/product-lines.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h3 class=\"page-title\" translate=\"translate\">Product Lines</h3></div></div><div class=\"row\"><div class=\"col-lg-12 hidden\" id=\"hiddenBtn\"><div class=\"pull-left\"><a class=\"btn btn-primary btn-lg\" ng-click=\"save()\" title=\"{{ \'Add Product Line\' | translate }}\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Add</span></a>&nbsp;&nbsp;&nbsp;<a class=\"btn btn-primary btn-lg\" ng-if=\"deletedItems.length\" ng-click=\"undo()\" title=\"{{ \'Undo Product Line\' | translate }}\"><i class=\"fa fa-undo\"></i> <span translate=\"translate\">Undo</span></a></div></div></div><hr/><div class=\"row\"><div class=\"col-lg-12\" style=\"height: calc(100vh - 300px); overflow-y: auto;\"><table class=\"table\" id=\"{{tableID}}\" datatable=\"\" dt-options=\"dtOptions\" addBtn=\"true\" dt-columns=\"dtColumns\" datatable-fix=\"datatable-fix\"></table></div></div></div>");
$templateCache.put("app/admin/languages/save/save.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span ng-if=\"!isEdit\" translate=\"translate\">Add language</span><span ng-if=\"isEdit\" translate=\"translate\">Edit language</span></div></div><div class=\"modal-body save-dialog\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><form class=\"form\" name=\"saveForm\" novalidate=\"\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"language.name\" focus-me=\"true\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Native Name</label><input class=\"form-control\" type=\"text\" ng-model=\"language.nativeName\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Code</label><input class=\"form-control\" type=\"text\" ng-minlength=\"2\" ng-model=\"language.code\" required=\"required\"/></div></form></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave(saveForm)\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/languages/languages.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h3 class=\"page-title\" translate=\"translate\">Languages</h3></div></div><div class=\"row\"><div class=\"col-lg-12 hidden\" id=\"hiddenBtn\"><a class=\"btn btn-primary btn-lg\" ng-click=\"save()\" title=\"{{ \'Add Language\' | translate }}\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Add</span></a></div></div><hr/><div class=\"row\"><div class=\"col-lg-12\" style=\"height: calc(100vh - 300px); overflow-y: auto;\"><table class=\"table\" id=\"{{tableID}}\" datatable=\"\" dt-options=\"dtOptions\" addBtn=\"true\" dt-columns=\"dtColumns\" datatable-fix=\"datatable-fix\"></table></div></div></div>");
$templateCache.put("app/admin/files-repository/files-repository.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div ng-include=\"\'components/files-repository/files-repository.html\'\"></div></div>");
$templateCache.put("app/admin/countries/save/save.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-pencil\"></i> <span ng-if=\"!isEdit\" translate=\"translate\">Add country</span><span ng-if=\"isEdit\" translate=\"translate\">Edit country information</span></div></div><div class=\"modal-body save-dialog\" ui-keypress=\"{13: \'save()\'}\"><div class=\"row\"><div class=\"col-md-12\"><form class=\"form\" name=\"saveForm\" novalidate=\"\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Name</label><input class=\"form-control\" type=\"text\" ng-model=\"country.name\" focus-me=\"true\" required=\"required\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label translate=\"translate\">Country Code (ISO 2)</label><input class=\"form-control\" type=\"text\" ng-minlength=\"2\" ng-model=\"country.code\" required=\"required\"/></div><h4 translate=\"translate\">Translations</h4><div ng-repeat=\"translation in country.translations\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" set-error-style=\"set-error-style\"><input class=\"form-control\" type=\"text\" placeholder=\"{{\'Name\'|translate}}\" ng-model=\"translation.name\" focus-me=\"($last &amp;&amp; autoFocusName)\" required=\"required\"/></div></div><div class=\"col-md-4 country-language\"><div class=\"form-group\" set-error-style=\"set-error-style\"><input class=\"form-control\" ng-model=\"translation.lang\" placeholder=\"{{\'Language\'|translate}}\" ng-blur=\"languageBlur(translation)\" typeahead-editable=\"false\" typeahead-min-length=\"0\" typeahead-on-select=\"onLanguageSelected($item, translation)\" typeahead=\"language as language.name for language in languageList | filter:{$:$viewValue} \" required=\"required\"/></div></div><div class=\"col-md-2 text-right\"><a class=\"btn btn-danger\" ng-click=\"deleteTranslation($index)\" title=\"{{\'Delete\'|translate}}\"><i class=\"fa fa-trash-o\"></i></a></div></div></div><div><div class=\"row\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-primary\" ng-click=\"addTranslation()\" title=\"{{\'Add translation\'|translate}}\" style=\"margin-right: 1px;\"><i class=\"fa fa-plus\"></i></a></div></div></div></form></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"save()\" ng-disabled=\"disableSave(saveForm)\"><i class=\"fa fa-save\"></i> <span translate=\"translate\">Save</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Cancel</span></button></div>");
$templateCache.put("app/admin/countries/countries.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h3 class=\"page-title\" translate=\"translate\">Countries</h3></div></div><div class=\"row\"><div class=\"col-lg-12 hidden\" id=\"hiddenBtn\"><a class=\"btn btn-primary btn-lg\" ng-click=\"save()\" title=\"{{ \'Add Country\' | translate }}\"><i class=\"fa fa-plus\"></i> <span translate=\"translate\">Add</span></a></div></div><hr/><div class=\"row\"><div class=\"col-lg-12\" style=\"height: calc(100vh - 300px); overflow-y: auto;\"><table class=\"table\" id=\"{{tableID}}\" datatable=\"\" dt-options=\"dtOptions\" addBtn=\"true\" dt-columns=\"dtColumns\" datatable-fix=\"datatable-fix\"></table></div></div></div>");
$templateCache.put("app/admin/admin.html", "<div ng-include=\"&quot;components/header/header-type-application.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><p>The delete user and user index api routes are restricted to users with the \'admin\' role.</p><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"user in users\"><strong>{{user.name}}</strong><br/><span class=\"text-muted\">{{user.email}}</span><a class=\"trash\" ng-click=\"delete(user)\"><span class=\"glyphicon glyphicon-trash pull-right\"></span></a></li></ul></div>");
$templateCache.put("app/admin/admin-ext.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><iframe ng-src=\"{{ url }}\" style=\"border: none; height: calc(100vh - 200px);\"></iframe>");
$templateCache.put("app/admin/abandoned-registrations/abandoned-registrations.html", "<div ng-include=\"&quot;components/header/header-type-content-2.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6\"><h3 class=\"page-title\" translate=\"translate\">Pending Registrations</h3></div><div class=\"col-lg-6 text-right\"><a class=\"btn btn-primary\" ng-show=\"data\" ng-click=\"downloadAsCsv()\"><i class=\"fa fa-download\"></i> Download as .CSV</a><a class=\"btn btn-danger\" ng-show=\"data\" ng-click=\"deleteSelected()\" style=\"margin-left: 5px;\"><i class=\"fa fa-trash\"></i> Delete selected</a></div></div><hr/><div class=\"row\"><div class=\"col-lg-12\" style=\"height: calc(100vh - 300px); overflow-y: auto;\"><table class=\"table\" id=\"{{tableID}}\" datatable=\"\" dt-options=\"dtOptions\" dt-columns=\"dtColumns\" dt-instance=\"dt.instance\" datatable-fix=\"datatable-fix\"></table></div></div></div>");
$templateCache.put("app/account/video-tutorial/video-tutorial.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-sm-8 col-sm-offset-2\"><h3>SpecWriter Online Tutorial</h3><!--img(src=\"/assets/images/000-video-button.png\", width=\"100%\")--></div></div><div class=\"row\" ng-if=\"params.video==\'000\'\"><div class=\"col-sm-8 col-sm-offset-2\"><video class=\"video-js vjs-default-skin vjs-big-play-centered\" id=\"video-dialog-1\" controls=\"controls\" height=\"auto\" width=\"100%\" poster=\"/assets/images/000-video-button.png\"><source src=\"//tutorials.siemens-specwriter.com/Siemens-SWOL-BA-Tutorial/Siemens-SWOL-BA-Tutorial.m3u8\" type=\"application/x-mpegURL\"/><source src=\"//tutorials.siemens-specwriter.com/Siemens-SWOL-BA-Tutorial/Siemens-SWOL-BA-Tutorial-1080.mp4\"/></video></div></div><div class=\"row\" ng-if=\"params.video==\'001\'\"><div class=\"col-sm-8 col-sm-offset-2\"><video class=\"video-js vjs-default-skin vjs-big-play-centered\" id=\"video-dialog-2\" controls=\"controls\" height=\"auto\" width=\"100%\" poster=\"/assets/images/001-video-button.png\"><source src=\"//tutorials.siemens-specwriter.com/Siemens-SWOL-FIRE-Tutorial/Siemens-SWOL-FIRE-Tutorial.m3u8\" type=\"application/x-mpegURL\"/><source src=\"//tutorials.siemens-specwriter.com/Siemens-SWOL-FIRE-Tutorial/Siemens-SWOL-FIRE-Tutorial.mp4\"/></video></div></div></div>");
$templateCache.put("app/account/signup/terms-of-use/terms-of-use.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-file-text-o\"></i> <span translate=\"translate\">Terms of use</span></div></div><div class=\"modal-body term-of-use-modal\"><div><p><strong>TERMS OF USE</strong></p><p><strong></strong></p><p>This Terms of Use Agreement (this \"Agreement\") is a legal agreement between you, either individually or on behalf of your corporation, partnership,\nsole proprietor, or other business entity (\"you\" or \"your\") and Siemens Industry, Inc., its affiliates, and each of their respective successors and\nassigns (collectively, \"SIEMENS\") governing (i) your use of SIEMENS\'s online software tool branded \"SpecWriter\" for creating custom specifications for\nSIEMENS\' products and other services, accessible at siemens-specwriter.com or another designated web site or IP address, (ii) the content contained\ntherein, and (iii) any offline components provided by SIEMENS or its licensors (including DScape Interactive, LLC, SIEMENS\'s service provider) for use\nin connection therewith (collectively, the \"SpecWriter Service\").</p><p>BY DOWNLOADING, INSTALLING, ACTIVATING OR OTHERWISE USING THE SPECWRITER SERVICE, YOU ARE AGREEING THAT YOU HAVE READ, AND AGREE TO COMPLY WITH AND BE\nBOUND BY, THE TERMS OF THIS AGREEMENT IN THEIR ENTIRETY WITHOUT LIMITATION OR QUALIFICATION AS WELL AS ALL APPLICABLE LAWS AND REGULATIONS. IF YOU DO\nNOT AGREE TO BE BOUND BY THE TERMS AND CONDITIONS OF THIS AGREEMENT AND TO FOLLOW ALL APPLICABLE LAWS, DO NOT CLICK THE \"ACCEPT\" BUTTON OR ACCESS OR\nUSE THE SPECWRITER SERVICE.</p><p><strong></strong></p><p><strong>1. License Grant</strong></p><p>Subject to the terms and conditions of this Agreement, SIEMENS hereby grants you a limited, non-exclusive, non-transferable, license to access and use\nthe SpecWriter Service solely on a server controlled by SIEMENS and/or its service provider and solely for your own internal business purposes. All\nrights not expressly granted to you are reserved by SIEMENS and its licensors. The license granted herein is conditioned on your continued compliance\nwith the terms and conditions of this Agreement.</p><p><strong>2. Restrictions on License Grant</strong></p><p>Your use of the SpecWriter Service is limited to the scope of the license granted in this Agreement and this Agreement does not permit you to use the\nSpecWriter Service other than as provided herein. You acknowledge that the SpecWriter Service constitutes valuable trade secrets and/or the\nconfidential information of SIEMENS or its licensors. You acknowledge and agree that except as otherwise authorized under this Agreement or otherwise\nspecified in writing between the parties:<a name=\"grid_6\"></a></p><p>a. You shall not license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, grant a security interest in, or otherwise transfer any\nrights to, or commercially exploit, the SpecWriter Service or any information, documents, software, products and services contained or made available\nto you in the course of using the SpecWriter Service (the \"Content\") or use the SpecWriter Service to run or as part of a service bureau, outsourced,\nor managed services arrangement;</p><p>b. You shall not copy, reproduce, republish, upload, post, transmit or distribute the SpecWriter Service or the Content in any way;</p><p>c. You shall not modify, translate, alter, adapt, decompile, disassemble (except to the extent applicable laws specifically prohibit such restriction),\nreproduce, distribute or display, or create derivative works, compilations or collective works based on the SpecWriter Service or the Content;</p><p>d. You shall not knowingly or negligently permit other individuals or entities to use or copy the SpecWriter Service, or create Internet \"links\" to the\nSpecWriter Service or \"frame\" or \"mirror\" the SpecWriter Service on any other server or wireless or Internet-based device;</p><p>e. You shall not access the SpecWriter Service for any reason, including without limitation, in order to (a) build a competitive product or service,\n(b) build a product using similar ideas, features, functions or graphics of the SpecWriter Service, (c) copy any ideas, features, functions or graphics\nof the SpecWriter Service, (d) monitor its availability, performance or functionality, or (e) for any other benchmarking or competitive purposes;</p><p>f. You shall not access the SpecWriter Service if you sell or provide any service, software, or product that may compete with SIEMENS\'s services,\nsoftware, or products, which include, but are not limited to, the sale or service of (i) building automation systems or equipment; (ii) fire safety\nsystems or equipment; (iii) energy management and control systems, (iv) remote monitoring of energy management systems, (v) demand response services,\n(vi) equipment monitoring services, (vii) energy information services, or (viii) design or manufacture of software or hardware for any of the foregoing\n(a \"Competitor\");</p><p>g. You shall not attempt to use or gain unauthorized access to data, accounts, hosts, systems or networks of SIEMENS, SIEMENS\'s service provider or any\nof its customers or suppliers, or those of any other party; breach the security of another user or system, or attempt to circumvent the user\nauthentication or security of any host, network, or account, including, without limitation, accessing data not intended for you or logging into or\nmaking use of a server or account you are not expressly authorized to access;</p><p>h. You shall not attempt to probe, scan or test the vulnerability of a system, account or network of SIEMENS, SIEMENS\'s service provider or any of its\ncustomers or suppliers, any SIEMENS product or service, or those of any other party;</p><p>i. You shall not interfere, or attempt to interfere, with service to any user, host or network including, without limitation, mail-bombing, flooding,\nand attempting to deliberately overload the system or distribute programs that \"crack,\" or make unauthorized changes to, the software;</p><p>j. You shall not forge any TCP-IP packet header or any part of any header information, falsify, alter or remove address information or other\nmodification of e-mail headers; collect responses from unsolicited bulk messages, falsify references to the SpecWriter Service, by name or other\nidentifier, in messages; impersonate any person or entity, engage in sender address falsification, forge anyone else\'s digital or manual signature, or\nperform any other similar fraudulent activity;</p><p>k. You shall not restrict, inhibit, or otherwise interfere with the ability of any other person, regardless of intent, purpose or knowledge, to use or\nenjoy the SpecWriter Service (except for tools for safety and security functions), including, without limitation, posting or transmitting any\ninformation or software which contains a worm, virus, or other harmful feature, or generating levels of traffic sufficient to impede others\' ability to\nuse, send, or retrieve information;</p><p>l. You shall not restrict, inhibit, interfere with, or otherwise disrupt or cause a performance degradation, regardless of intent, purpose or\nknowledge, to the SpecWriter Service or any SIEMENS (or SIEMENS\'s service provider or supplier) host, server, backbone network, node or service, or\notherwise cause a performance degradation to any SIEMENS (or SIEMENS\'s service provider or supplier) facilities used to deliver the SpecWriter Service;</p><p>m. You shall not create or use any program, tags, markers, bots, mousetraps, highjackers or other similar computer routines or sub-routines to\nautomatically access or manipulate the SpecWriter Service; and</p><p>n. When using the SpecWriter Service to send or transmit information, you shall not: (i) send spam or otherwise duplicative or unsolicited messages in\nviolation of applicable laws; or (ii) send or store infringing, obscene, threatening, libelous, or otherwise unlawful or tortious material, including\nmaterial harmful to children or violative of third party privacy rights.</p><p><strong>3. Customer Communications; Disclosure</strong></p><p>From time-to-time SIEMENS may ask whether or not you wish to receive marketing and other non-critical SpecWriter Service-related communications. You\nmay elect not to receive such communications at that time or opt-out of receiving such communications at any subsequent time by notifying SIEMENS.\nBecause the SpecWriter Service is a hosted, online application, SIEMENS may need to notify all users of the SpecWriter Service (whether or not they\nhave opted out as described above) of important announcements regarding the operation of the SpecWriter Service. SIEMENS reserves the right to disclose\nthat you are a user of the SpecWriter Service.</p><p><strong>4. Your Obligations</strong></p><p>You are responsible for all activity occurring when the SpecWriter Service is accessed through your password and you shall abide by all applicable\nlocal, state, national and foreign laws, treaties and regulations in connection with your use of the SpecWriter Service, including those related to\ndata privacy, international communications and the transmission of technical or personal data. You shall: (i) notify SIEMENS immediately of any\nunauthorized use of any password or account or any other known or suspected breach of security; (ii) report to SIEMENS immediately and use reasonable\nefforts to stop immediately any copying or distribution of Content that is known or suspected by you; (iii) notify SIEMENS when you no longer require\naccess to the SpecWriter Service; and (v) Keep all of your profile information current.</p><p><strong></strong></p><p><strong>5. Account Information and Data</strong></p><p>In connection with your use of the SpecWriter Service, it may be necessary for SIEMENS (or SIEMENS\'s service provider or supplier) to obtain, receive\nor collect data or information, including system-specific data or information, from you as part of the SpecWriter Service. In such cases, you hereby\ngrant SIEMENS (and SIEMENS\'s service provider or supplier when acting on SIEMENS behalf) a non-exclusive, worldwide, royalty-free, perpetual,\nnon-revocable license under your copyrights and other intellectual property rights, if any, in all material and content provided to SIEMENS (or\nSIEMENS\'s service provider or supplier) to compile, use, distribute, display, store, process, reproduce, and create derivative works from such material\nand content, including without limitation comparative data sets, statistical analyses, reports and related services utilizing aggregated data derived\nfrom data obtained from you, other SIEMENS customers and other sources, in any and all media and display in any manner and on any SIEMENS property to\nthe extent necessary to provide the SpecWriter Service to you and as a service to its customers and future customers and in the development of products\nand services (the \"Data\"). You also grant SIEMENS the right to copy and maintain such material and content on SIEMENS\'s servers (or the servers of its\nservice provider or suppliers) during the term of this Agreement. You represent and warrant that you have obtained all rights, permissions and consents\nnecessary to upload your Data as part of the SpecWriter Service, and permit SIEMENS to exercise all of its rights under this Agreement. You, not\nSIEMENS nor SIEMENS\'s service provider or supplier, shall have sole responsibility for the accuracy, quality, integrity, legality, reliability, and\nappropriateness, of all of your Data. Neither SIEMENS nor SIEMENS\'s service provider or supplier shall be responsible or liable for the deletion,\ncorrection, destruction, damage, loss or failure to store any of your Data. In the event this Agreement is terminated (other than by reason of your\nbreach), SIEMENS will make available to you a file containing your Data within 30 days of termination if you so request in writing at the time of\ntermination. SIEMENS reserves the right to withhold, remove and/or discard SIEMENS Data without notice for any breach, including, without limitation,\nnon-payment. Upon termination for cause, your right to access or use SIEMENS Data immediately ceases, and SIEMENS shall have no obligation to maintain\nor forward any of SIEMENS Data to you.</p><p><strong>6. Intellectual Property Ownership</strong></p><p>All right, title and interest in the SpecWriter Service, including technology and trade secrets embodied therein and any custom developments created or\nprovided in connection with or related to this Agreement, including all copyrights, patents, trade secrets, trade dress and other proprietary rights,\nand any derivative works thereof, shall belong solely and exclusively to SIEMENS or its licensors, and you shall have no rights whatsoever in any of\nthe foregoing. You acknowledge that the SpecWriter Service constitutes a valuable trade secret and/or is the confidential information of SIEMENS or its\nlicensors. Nothing in this Agreement or otherwise will be deemed to grant to you an ownership interest in the SpecWriter Service, in whole or in part.\nAll content and materials included as part of the SpecWriter Service, such as text, graphics, logos, button icons, images, audio clips, information,\ndata, photographs, graphs, videos, typefaces, graphics, music, sounds, and other material, and software (the \"Materials\") are the property of SIEMENS\nor its content suppliers and is protected by copyrights, trademarks, trade secrets, or other proprietary rights and these rights are valid and\nprotected in all forms, media and technologies existing now or hereinafter developed. All Materials are copyrighted as individual works and as a\ncollective work under the U.S. copyright laws (17 U.S.C. Section 101, et. seq.) and international treaty provisions, and SIEMENS owns a copyright in\nthe selection, coordination, arrangement and enhancement thereof. You may not modify, remove, delete, augment, add to, publish, transmit, adapt,\ntranslate, participate in the transfer or sale of, create derivative works from, or in any way exploit any of the Materials, in whole or in part. Any\nuse other than as contemplated herein, including the reproduction, modification, distribution, transmission, adaptations, translation, republication,\ndisplay, or performance, of the Materials, except as specifically permitted herein, is strictly prohibited. You understand and acknowledge that\nunauthorized disclosure, use or copying of the proprietary products and services provided pursuant to this Agreement may cause SIEMENS and its\nlicensors irreparable injury, which may not be remedied at law, and you agree that SIEMENS and its licensors\' remedies for breach of this Agreement may\nbe in equity by way of injunctive or other equitable relief.</p><p><a name=\"grid_21\"></a></p><p><strong>7. Trademarks</strong></p><p>The SIEMENS name, logo, other related names, design marks, product names, feature names and related logos are trademarks of SIEMENS and may not be\nused, copied or imitated, in whole or in part, without the express prior written permission of SIEMENS. In addition, the look and feel of the\nSpecWriter Service (including all page headers, custom graphics, button icons, and scripts) constitutes the service mark, trademark and/or trade dress\nof SIEMENS or its licensors, and may not be copied imitated or used, in whole or in part, without the express prior written permission of SIEMENS.</p><p><a name=\"grid_22\"></a><strong></strong></p><p><strong>8. Term; Termination; Suspension of SpecWriter Service</strong></p><p>The term of this Agreement commences on your first use of the SpecWriter Service and continues through any subsequent use of the SpecWriter Service\nthereafter. Any unauthorized use of the SpecWriter Service will be deemed a material breach of this Agreement. SIEMENS, in its sole discretion, may\nterminate your password, account or use of the SpecWriter Service if you breach or otherwise fail to comply with this Agreement. In addition, SIEMENS\nmay terminate a free account at any time in its sole discretion. You agree and acknowledge that SIEMENS has no obligation to retain your Data, and may\ndelete such data, if you have materially breached this Agreement, including but not limited to failure to pay any payments due to SIEMENS under this or\nany other agreement, and such breach has not been cured within 15 days of notice of such breach. Because of the difficulty associated with quantifying\ndamages, in addition to any other damages to which SIEMENS may be entitled, if actual damages cannot be reasonably calculated then you agree to pay\nSIEMENS liquidated damages of $250 for each violation of the Section 2 or the maximum liquidated damages permitted under law, whichever is greater;\notherwise you agree to pay SIEMENS\'s actual damages, to the extent such actual damages can be reasonably calculated.</p><p><strong>9. Representations & Warranties</strong></p><p>Each party represents and warrants that it has the legal power and authority to enter into this Agreement. You represent and warrant that you have not\nfalsely identified yourself nor provided any false information to gain access to\nthe SpecWriter Service. If you are entering into this Agreement on\nbehalf of a company or other legal entity, you represent that you have the authority to bind such entity to these terms and conditions, in which case\nthe terms \"you\" or \"your\" shall refer to such entity. If you do not have such authority, you must immediately stop using the SpecWriter Service.</p><p><strong>10. Indemnification</strong></p><p>You shall indemnify and hold SIEMENS, its licensors and each such party\'s parent organizations, subsidiaries, affiliates, officers, directors,\nemployees, attorneys and agents harmless from and against any and all claims, costs, damages, losses, liabilities and expenses (including attorneys\'\nfees and costs) arising out of or in connection with: (i) a claim alleging that use of your Data infringes the rights of, or has caused harm to, a\nthird party; (ii) a claim, which if true, would constitute a violation by you of your representations and warranties; or (iii) a claim arising from the\nbreach by you of this Agreement or a violation of any law or regulation, provided in any such case that SIEMENS (a) gives written notice of the claim\npromptly to you; and (b) gives you sole control of the defense and settlement of the claim (provided that you may not settle or defend any claim unless\nyou unconditionally release SIEMENS of all liability and such settlement does not affect SIEMENS\'s business or SpecWriter Service).</p><p><strong>11. Disclaimer of Warranties</strong></p><p>EXCEPT AS OTHERWISE EXPRESSLY PROVIDED IN THIS AGREEMENT, (A) THE SPECWRITER SERVICE IS PROVIDED \"AS-IS\" AND \"WITH ALL FAULTS\", AND, TO THE MAXIMUM\nEXTENT PERMITTED BY APPLICABLE LAW, SIEMENS, INCLUDING ITS AFFILIATES, SUBSIDIARIES, LICENSORS, SUBCONTRACTORS, DISTRIBUTORS, SERVICES PARTNERS AND\nPROVIDERS, AGENTS AND MARKETING PARTNERS) AND EACH OF THEIR RESPECTIVE EMPLOYEES, DIRECTORS AND OFFICERS (COLLECTIVELY, THE \"SIEMENS PARTY(IES)\")\nDISCLAIM ALL REPRESENTATIONS, WARRANTIES AND CONDITIONS OF ANY KIND, EXPRESS OR IMPLIED, REGARDING THE SPECWRITER SERVICE, OR OTHERWISE RELATING TO\nTHIS AGREEMENT, INCLUDING WARRANTIES AND CONDITIONS OF FITNESS FOR A PARTICULAR PURPOSE, MERCHANTABILITY, MERCHANTABLE QUALITY, NON-INFRINGEMENT AND\nACCURACY AND NON-INTERFERENCE; (B) NEITHER SIEMENS NOR ANY SIEMENS PARTY WARRANTS THAT (i) THE SPECWRITER SERVICE IS OR WILL BE SECURE, ACCURATE,\nCOMPLETE, UNINTERRUPTED, WITHOUT ERROR, OR FREE OF VIRUSES, WORMS, OTHER HARMFUL COMPONENTS, OR OTHER PROGRAM LIMITATIONS, (ii) THE SPECWRITER SERVICE\nWILL MEET YOUR REQUIREMENTS, (iii) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SPECWRITER SERVICE WILL BE ACCURATE OR RELIABLE, (iv) ANY\nERRORS IN THE SPECWRITER SERVICE WILL BE CORRECTED; (C) YOU ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION OF PROBLEMS CAUSED\nBY VIRUSES OR OTHER HARMFUL COMPONENTS, UNLESS SUCH ERRORS OR VIRUSES ARE THE DIRECT RESULT OF SIEMENS\'S GROSS NEGLIGENCE OR WILLFUL MISCONDUCT; (D)\nSIEMENS AND THE SIEMENS PARTIES, JOINTLY AND SEVERALLY, DISCLAIM AND MAKE NO WARRANTIES OR REPRESENTATIONS AS TO THE ACCURACY, QUALITY, RELIABILITY,\nSUITABILITY, COMPLETENESS, TRUTHFULNESS, USEFULNESS, OR EFFECTIVENESS OF THE REPORTS, DATA, RESULTS OR OTHER INFORMATION OBTAINED, GENERATED OR\nOTHERWISE RECEIVED BY YOU FROM ACCESSING AND/OR USING THE SPECWRITER SERVICE OR OTHERWISE RELATING TO THIS AGREEMENT, AND (E) USE OF THE SPECWRITER\nSERVICE IS ENTIRELY AT YOUR OWN RISK AND NEITHER SIEMENS NOR ANY OF THE SIEMENS PARTIES SHALL HAVE ANY LIABILITY OR RESPONSIBILITY THEREFOR.</p><p><strong>12. Interruption of SpecWriter Service</strong></p><p>YOU AGREE THAT THE OPERATION AND AVAILABILITY OF THE SYSTEMS USED FOR ACCESSING AND INTERACTING WITH THE SPECWRITER SERVICE, INCLUDING, THE PUBLIC\nTELEPHONE, COMPUTER NETWORKS AND THE INTERNET OR TO TRANSMIT INFORMATION, WHETHER OR NOT SUPPLIED BY YOU OR SIEMENS, CAN BE UNPREDICTABLE AND MAY, FROM\nTIME TO TIME, INTERFERE WITH OR PREVENT THE ACCESS TO AND/OR THE USE OR OPERATION OF THE SPECWRITER SERVICE. NEITHER SIEMENS NOR ANY OF THE SIEMENS\nPARTIES SHALL BE LIABILE FOR ANY INTERFERENCE WITH OR PREVENTION OF YOUR ACCESS TO AND/OR USE OF THE SPECWRITER SERVICE.</p><p><strong>13. Limitation of Liability</strong></p><p>IN NO EVENT SHALL SIEMENS AND/OR ANY OF THE SIEMENS PARTIES BE LIABLE FOR ANY LOSS OF PROFITS, LOSS OF BUSINESS, LOSS OF USE OR OF DATA, WORK STOPPAGE,\nCOMPUTER FAILURE OR MALFUNCTION, INTERRUPTION OF BUSINESS, OR FOR INDIRECT, SPECIAL, INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES OF ANY KIND WHETHER\nUNDER THIS AGREEMENT OR OTHERWISE, EVEN IF SIEMENS HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, OR FOR ANY CLAIM AGAINST YOU BY ANY OTHER\nPARTY. IN NO CASE WILL SIEMENS AND/OR ANY OF THE SIEMENS PARTIES BE LIABLE FOR ANY REPRESENTATION OR WARRANTY MADE TO YOU BY ANY THIRD PARTY. EXCEPT\nFOR CLAIMS THAT THE SPECWRITER SERVICE CAUSED BODILY INJURY (INCLUDING DEATH) DUE TO SIEMENS\'S NEGLIGENCE OR WILLFUL MISCONDUCT, SIEMENS AND THE\nSIEMENS PARTIES\' CUMULATIVE LIABILITY TO YOU FOR ALL CLAIMS OF DAMAGES ARISING OUT OF OR RELATED TO THIS AGREEMENT AND REGARDLESS OF WHETHER THE CLAIM\nFOR SUCH DAMAGES IS BASED IN CONTRACT, STRICT LIABILITY, NEGLIGENCE OR TORT, SHALL NOT EXCEED THE AMOUNT OF THE PAYMENTS MADE TO SIEMENS FOR THE\nSPECIFIC SERVICE(S) GIVING RISE TO SUCH CLAIM IN THE SIX (6) MONTHS PRIOR TO SUCH CLAIM. YOU ACKNOWLEDGE THAT THESE LIMITATIONS APPLY EVEN IF THE\nREMEDIES FAIL OF THEIR ESSENTIAL PURPOSE AND THAT, WITHOUT THESE LIMITATIONS, YOU WOULD HAVE PAID A HIGHER FEE FOR THE SPECWRITER SERVICE PROVIDED\nHEREUNDER. Certain states and/or jurisdictions do not allow the exclusion of implied warranties or limitation of liability for incidental,\nconsequential or certain other types of damages, so the exclusions set forth above may not apply to you.</p><p><strong>14. Account Access</strong></p><p>Where use of the SpecWriter Service is contingent on you and your users accessing an \"account\" and/or inserting a \"user-identification\" and/or\n\"password\", you agree that you will be solely responsible for the user-ids and passwords that are provided to you (as such passwords may be changed\nfrom time to time in accordance with features of the SpecWriter Service) to log-in to the password protected SpecWriter Service. If non-authorized\nindividuals have access to your systems or to your users\' user-id and password, they may be able to use the SpecWriter Service. you and your users\nshall keep any correspondence you receive relating to or through the use of the SpecWriter Service (including, but not limited to, your user-id,\npasswords, and other registration or sign-in information) confidential and in a safe place and not disclose it to any third party. You will be\nresponsible and liable for all communications and actions that take place through the use of your user-ids, including without limitation, any actions\nthat occur without your authorization. Accordingly, it is your responsibility to take appropriate actions immediately if any password has been stolen,\nleaked, compromised or otherwise used without proper consent.</p><p><strong>15. Local Laws and Export Control</strong></p><p>You acknowledge that the SpecWriter Service, which may include technology and software, are subject to the customs and export control laws and\nregulations of the United States and may also be subject to the customs and export laws and regulations of the country in which the SpecWriter Service\nis rendered and/or received. You agree to abide by those laws and regulations. You are solely responsible for obtaining any specific licenses relating\nto the export of software if a license is needed. SIEMENS\'s agreement to provide the SpecWriter Service is contingent upon the issuance of any\napplicable export license required by the United States Government; SIEMENS is not liable for delays or failure to deliver SpecWriter Service or a\nproduct resulting from your failure to obtain such license or to provide such certification.</p><p><strong>16. Notice</strong></p><p>SIEMENS may give notice by means of a general notice on the SpecWriter Service, electronic mail to your e-mail address on record in SIEMENS\'s account\ninformation, or by written communication sent by first class mail or pre-paid post to your address on record in SIEMENS\'s account information. Such\nnotice shall be deemed to have been given upon the expiration of 48 hours after mailing or posting (if sent by first class mail or pre-paid post) or 12\nhours after sending (if sent by email). You may give notice to SIEMENS (such notice shall be deemed given when received by SIEMENS) at any time by any\nof the following: letter sent by confirmed facsimile to SIEMENS at the following fax number: (866) 699-0036; letter delivered by nationally recognized\novernight delivery service or first class postage prepaid mail to Siemens Industry, Inc. Building Technologies Division, 1000 Deerfield Parkway,\nBuffalo Grove, Illinois addressed to the attention of: Contracts Compliance Officer.</p><p><strong></strong></p><p><strong>17. Modification to Terms</strong></p><p>SIEMENS reserves the right to modify the terms and conditions of this Agreement or its policies relating to the SpecWriter Service at any time,\neffective upon posting of an updated version of this Agreement on the SpecWriter Service. You are responsible for regularly reviewing this Agreement.\nContinued use of the SpecWriter Service after any such changes shall constitute your consent to such changes.</p><p><strong></strong></p><p><strong>18. Assignment; Change in Control</strong></p><p>This Agreement may not be assigned by you without the prior written approval of SIEMENS but may be assigned without your consent by SIEMENS to (i) a\nparent or subsidiary, (ii) an acquirer of assets, or (iii) a successor by merger. Any purported assignment in violation of this section shall be void.\nAny actual or proposed change in control of you that results or would result in a Competitor of SIEMENS directly or indirectly owning or controlling\n50% or more of you shall entitle SIEMENS to terminate this Agreement for cause immediately upon written notice.</p><p><strong>19. General</strong></p><p>a. This Agreement shall be governed by Illinois law and controlling United States federal law, without regard to the choice or conflicts of law\nprovisions of any jurisdiction or the United Nations Convention on the International Sale of Goods, and any disputes, actions, claims or causes of\naction arising out of or in connection with this Agreement or the SpecWriter Service shall be subject to the exclusive jurisdiction of the state and\nfederal courts located in Illinois.</p><p>b. Any cause of action you may have with respect to your use of the SpecWriter Service must be commenced within one (1) year after the claim or cause\nof action arises.</p><p>c. If any provision of this Agreement is held by a court of competent jurisdiction to be invalid or unenforceable, then such provisions shall be\nconstrued, as nearly as possible, to reflect the intentions of the invalid or unenforceable provisions, with all other provisions remaining in full\nforce and effect.</p><p>d. It may be necessary for SIEMENS (or SIEMENS\'s service provider or supplier acting on SIEMENS behalf) to perform scheduled or unscheduled repairs,\nmaintenance, or upgrades and such activities may temporarily degrade the quality of the SpecWriter Service or result in a partial or complete outage of\nthe SpecWriter Service. SIEMENS provides no assurance that you will receive advance notification of such activities or that the SpecWriter Service will\nbe uninterrupted or error-free. Any degradation or interruption in the SpecWriter Service shall not give rise to a refund or credit of any fees paid by\nyou.</p><p>e. No joint venture, partnership, employment, or agency relationship exists between you and SIEMENS as a result of this agreement or use of the\nSpecWriter Service. The failure of SIEMENS to enforce any right or provision in this Agreement shall not constitute a waiver of such right or provision\nunless acknowledged and agreed to by SIEMENS in writing.</p><p>f. Neither party shall be liable to the other party for any failure to perform any of its obligations (except payment obligations if any) under this\nAgreement during any period in which such performance is delayed by circumstances beyond its reasonable control including, but not limited to, fire,\nflood, war, embargo, strike, riot or the intervention of any governmental authority (a \"Force Majeure\"). The delayed party\'s time for performance will\nbe excused for the duration of the Force Majeure, but if the Force Majeure events lasts longer than thirty (30) days, the other party may immediately\nterminate the applicable SpecWriter Service by giving written notice to the delayed party.</p><p>g. If you have not entered into another agreement with SIEMENS regarding the subject matter contained herein, then this Agreement comprises the entire\nagreement between you and SIEMENS and supersedes all prior or contemporaneous negotiations, discussions or agreements, whether written or oral, between\nthe parties regarding such subject matter. However, if you and SIEMENS have entered into another agreement regarding the subject matter set forth\nherein, then this Agreement should be read and interpreted in conjunction with such agreement and, in the event of a conflict between this Agreement\nand a written, signed agreement between the parties, the written, signed agreement shall govern and control.</p><p><strong>Questions or Additional Information:</strong></p><p>If you have questions regarding this Agreement or wish to obtain additional information, please send an e-mail to&nbsp;<a href=\"mailto:specwriter.si@siemens.com\">specwriter.si@siemens.com</a>.</p></div><strong><br clear=\"all\"/></strong></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"accept()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Accept</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Reject</span></button></div>");
$templateCache.put("app/account/signup/signup.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"guest container\"><h3>Register</h3><div ng-show=\"!isSocialSignup &amp;&amp; !done\"><div class=\"checkbox\"><label><input type=\"checkbox\" name=\"terms-of-use\" ng-model=\"user.termsClickAccepted\" ng-click=\"termsOfUseOpen($event)\" ng-checked=\"user.termsAccepted\"/><div class=\"check-label\">Accept &nbsp;<a ng-click=\"termsOfUseOpen($event)\">Terms of use</a></div></label></div></div><br/><form class=\"form\" name=\"form\" ng-submit=\"register(form)\" novalidate=\"\" ng-hide=\"done\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label>E-mail</label><input class=\"input-primary form-control\" type=\"email\" name=\"email\" ng-model=\"user.email\" required=\"required\" mongoose-error=\"mongoose-error\"/><p class=\"help-block\"><error-message on=\"email\">Doesn\'t look like a valid email.</error-message><error-message on=\"required\">What\'s your email address?</error-message><error-message on=\"mongoose\">{{ errors.email }}</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Confirm E-mail</label><input class=\"input-primary form-control\" type=\"text\" name=\"emailConfirm\" ng-model=\"user.emailConfirm\" required=\"required\" ng-pattern=\"{{ user.email }}\"/><p class=\"help-block\"><error-message>E-mail does not match.</error-message></p></div><div class=\"alert alert-danger\" ng-show=\"errors.emailExists\">E-mail already exists, please try login</div><div class=\"text-center\"><button class=\"btn btn-primary btn-lg btn-login\" type=\"submit\" ng-disabled=\"!user.termsAccepted\">Register</button> </div></form><div class=\"text-center\" ng-hide=\"true\"><div>Register using your social account instead</div><br/><a class=\"fa-stack fa-lg\" ng-click=\"loginOauth(\'facebook\')\" ng-style=\"disableSocials()\"><i class=\"fa fa-circle fa-stack-2x color-facebook\" ng-style=\"disableSocials()\"></i><i class=\"fa fa-facebook fa-stack-1x fa-inverse\"></i></a>&nbsp;&nbsp;&nbsp;<a class=\"fa-stack fa-lg\" ng-click=\"loginOauth(\'twitter\')\" ng-style=\"disableSocials()\"><i class=\"fa fa-circle fa-stack-2x color-twitter\" ng-style=\"disableSocials()\"></i><i class=\"fa fa-twitter fa-stack-1x fa-inverse\"></i></a>&nbsp;&nbsp;&nbsp;<a class=\"fa-stack fa-lg\" ng-click=\"loginOauth(\'google\')\" ng-style=\"disableSocials()\"><i class=\"fa fa-circle fa-stack-2x color-google\" ng-style=\"disableSocials()\"></i><i class=\"fa fa-google fa-stack-1x fa-inverse\"></i></a>&nbsp;&nbsp;&nbsp;<a class=\"fa-stack fa-lg\" ng-click=\"loginOauth(\'linkedin\')\" ng-style=\"disableSocials()\"><i class=\"fa fa-circle fa-stack-2x color-linkedin\" ng-style=\"disableSocials()\"></i><i class=\"fa fa-linkedin fa-stack-1x fa-inverse\"></i></a></div><div ng-show=\"done\"><br/><div class=\"register-success\"><p>You should have received an email from siemens-specwriter.com with a confirmation link that will allow you to continue the registration process. If you have not received the registration email:</p><ul><li>Check your email spam or junk email folder</li><li>If you or your company uses spam filtering software, add noreply@siemens-specwriter.com to the \"white list\" so you can receive email from siemens-specwriter.com.</li><li>Once noreply@siemens-specwriter.com has been added to the white list, sign up again at siemens-specwriter.com so you can receive a new email with the registration confirmation link.</li></ul><p>Thank you for using Siemens SpecWriter Online!</p></div></div></div>");
$templateCache.put("app/account/settings/settings.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\" style=\"height: calc(100vh - 258px) !important; overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-4\"><h3>Update user</h3><form class=\"form\" name=\"createForm\" ng-submit=\"updateUser(createForm)\" novalidate=\"\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label>First Name</label><input class=\"form-control\" type=\"text\" name=\"forename\" ng-model=\"userCopy.forename\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">First Name is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Last Name</label><input class=\"form-control\" type=\"text\" name=\"surname\" ng-model=\"userCopy.surname\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">Last Name is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Midname</label><input class=\"form-control\" type=\"text\" name=\"midname\" ng-model=\"userCopy.midname\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>E-mail</label><input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"userCopy.email\" required=\"required\" duplicate=\"duplicate\" readonly=\"readonly\"/><p class=\"help-block\"><error-message on=\"email\">Doesn\'t look like a valid email.</error-message><error-message on=\"required\">E-mail address is requred.</error-message><error-message on=\"mongoose\">{{ errors.email }}</error-message></p><p class=\"help-block\">Email changes are disabled.</p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Username</label><input class=\"form-control\" type=\"text\" name=\"username\" ng-model=\"userCopy.username\" required=\"required\" duplicate=\"duplicate\"/><p class=\"help-block\"><error-message on=\"required\">Username is required.</error-message><error-message on=\"mongoose\">{{ errors.username }}</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Company</label><input class=\"form-control\" type=\"text\" name=\"company\" ng-model=\"userCopy.company\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">Company is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Country</label><select class=\"form-control\" name=\"country\" ng-model=\"userCopy.country\" ng-options=\"x.code as x.name for x in countries\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select><p class=\"help-block\"><error-message on=\"required\">Country is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Language Code</label><select class=\"form-control\" name=\"language\" ng-model=\"userCopy.language\" ng-options=\"x.code as x.name for x in languages\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select><p class=\"help-block\"><error-message on=\"required\">Language is required.</error-message></p></div><button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button></form></div></div><hr/><div class=\"row\"><div class=\"col-sm-4\"><h3>Change Password</h3><form class=\"form\" name=\"form\" ng-submit=\"changePassword(form)\" novalidate=\"\"><div class=\"form-group\"><label>Current Password</label><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"user.oldPassword\" mongoose-error=\"\"/><p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">{{ errors.other }}</p></div><div class=\"form-group\"><label>New Password</label><input class=\"form-control\" type=\"password\" name=\"newPassword\" ng-model=\"user.newPassword\" ng-minlength=\"3\" required=\"\"/><p class=\"help-block\" ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) &amp;&amp; (form.newPassword.$dirty || submitted)\">Password must be at least 3 characters.</p></div><p class=\"help-block\"> {{ message }}</p><button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button></form></div></div><div class=\"row\" ng-show=\"false\"><hr/><div class=\"col-sm-12\"><h3>Link to your social accounts</h3></div><div class=\"col-sm-12\"><div><a class=\"btn btn-facebook\" href=\"\" ng-disabled=\"OAuth.facebook.length &gt; 0\" ng-click=\"addSocialAccount(&quot;facebook&quot;)\"><i class=\"fa fa-facebook\"></i> Connect with Facebook</a> <a class=\"btn btn-google-plus\" href=\"\" ng-disabled=\"OAuth.google.length &gt; 0\" ng-click=\"addSocialAccount(&quot;google&quot;)\"><i class=\"fa fa-google-plus\"></i> Connect with Google+</a> <a class=\"btn btn-twitter\" href=\"\" ng-disabled=\"OAuth.twitter.length &gt; 0\" ng-click=\"addSocialAccount(&quot;twitter&quot;)\"><i class=\"fa fa-twitter\"></i> Connect with Twitter</a> <a class=\"btn btn-linkedin\" href=\"\" ng-disabled=\"OAuth.linkedin.length &gt; 0\" ng-click=\"addSocialAccount(&quot;linkedin&quot;)\"><i class=\"fa fa-linkedin\"></i> Connect with LinkedIn</a></div></div></div><div class=\"row\" ng-show=\"hasSocialAccounts &amp;&amp; false\"><hr/><div class=\"col-sm-4\"><h3>Remove social account</h3><div><a class=\"btn btn-block btn-danger\" ng-click=\"removeSocialAccount(u)\" ng-repeat=\"u in OAuth.twitter\"><i class=\"icon-twitter icon-large\">Twitter - @{{u.username}}</i></a><a class=\"btn btn-block btn-danger\" ng-click=\"removeSocialAccount(u)\" ng-repeat=\"u in OAuth.facebook\"><i class=\"icon-facebook-sign icon-large\">Facebook - {{u.username}}</i></a><a class=\"btn btn-block btn-danger\" ng-click=\"removeSocialAccount(u)\" ng-repeat=\"u in OAuth.google\"><i class=\"fa fa-google fa-lg\">{{u.emails[0].value}}</i></a><a class=\"btn btn-block btn-danger\" ng-click=\"removeSocialAccount(u)\" ng-repeat=\"u in OAuth.linkedin\"><i class=\"icon-linkedin-sign icon-large\">Linkedin - {{u.displayName}}</i></a></div></div></div><hr ng-show=\"hasSocialAccounts &amp;&amp; false\"/></div>");
$templateCache.put("app/account/reset-password/reset-password.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><section class=\"text-center\" ng-hide=\"tokenIsValid\"><h3>Something went wrong</h3><a class=\"btn btn-link\" href=\"/login/forgot-password\">Do password reset again.</a></section><form class=\"form\" name=\"form\" ng-submit=\"resetPassword(form)\" novalidate=\"\" ng-show=\"tokenIsValid\"><div class=\"col-sm-6\"><h1><i class=\"fa text-info\">Hey {{userForeName}}</i><h5>Please enter and confirm the new password you\'d like to use.</h5></h1><div class=\"form-group\" set-error-style=\"set-error-style\"><label>New Password</label><input class=\"form-control\" type=\"password\" name=\"newPassword\" ng-model=\"newPassword\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">What\'s your new password?</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Confirm Password</label><input class=\"form-control\" type=\"password\" name=\"confirmPassword\" ng-model=\"confirmPassword\" required=\"required\" ng-pattern=\"{{ newPassword }}\"/><p class=\"help-block\"><error-message>Password does not match.</error-message></p></div><div><button class=\"btn btn-primary btn-lg btn-login\" type=\"submit\">Save Password</button></div></div></form></div></div>");
$templateCache.put("app/account/login/login.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"guest container\"><form class=\"form\" ng-submit=\"login()\"><div class=\"form-group has-error\" ng-if=\"authError\"><p class=\"help-block text-center\">Authentication failed. Please try again.</p></div><div class=\"text-center\"><button class=\"btn btn-primary btn-lg btn-login\" type=\"submit\">Access Admin UI</button></div></form></div>");
$templateCache.put("app/account/forgot-password/forgot-password.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><form class=\"form\" name=\"form\" ng-submit=\"forgotPassword(form)\" novalidate=\"\" ng-hide=\"message\"><div class=\"col-sm-8\"><h1><i class=\"fa fa-question-circle text-info\"></i>&nbsp;Forgot Password<h3></h3><div class=\"form-group\">No problem. Please give us the primary email address connected to your account.</div></h1><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Email</label><input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"email\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">What\'s your email address?</error-message><error-message on=\"email\">Doesn\'t look like a valid email.</error-message></p></div><div><button class=\"btn btn-primary\" type=\"submit\">Reset Password</button></div></div></form><div class=\"alert alert-success\" ng-show=\"message\">{{ message }}</div></div></div>");
$templateCache.put("app/account/create/terms/terms.html", "<div class=\"modal-header\"><div class=\"modal-title\"><i class=\"fa fa-file-text-o\"></i> <span translate=\"translate\">Terms</span></div></div><div class=\"modal-body term-of-use-modal\"><div ng-bind-html=\"htmlBind\"></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary btn-s\" ng-click=\"accept()\"><i class=\"fa fa-check\"></i> <span translate=\"translate\">Accept</span></button><button class=\"btn btn-danger btn-s\" ng-click=\"cancel()\"><i class=\"fa fa-times\"></i> <span translate=\"translate\">Reject</span></button></div>");
$templateCache.put("app/account/create/create.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\" style=\"height: calc(100vh - 250px); overflow-y: auto;\"><div class=\"col-sm-4\"><form class=\"form\" name=\"createForm\" ng-submit=\"register(createForm)\" novalidate=\"\" ng-show=\"tokenIsValid\"><div class=\"form-group\" set-error-style=\"set-error-style\"><label>First Name</label><input class=\"form-control\" type=\"text\" name=\"forename\" ng-model=\"user.forename\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">First Name is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Last Name</label><input class=\"form-control\" type=\"text\" name=\"surname\" ng-model=\"user.surname\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">Last Name is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Midname</label><input class=\"form-control\" type=\"text\" name=\"midname\" ng-model=\"user.midname\"/></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>E-mail</label><input class=\"form-control\" type=\"text\" name=\"email\" ng-model=\"user.email\" ng-disabled=\"true\"/><p class=\"help-block\"><error-message on=\"email\">Doesn\'t look like a valid email.</error-message><error-message on=\"required\">What\'s your email address?</error-message><error-message on=\"mongoose\">{{ errors.email }}</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\" ng-hide=\"true\"><label>Username</label><input class=\"form-control\" type=\"text\" name=\"username\" ng-model=\"user.username\" required=\"required\" duplicate=\"duplicate\"/><p class=\"help-block\"><error-message on=\"required\">Username is required.</error-message><error-message on=\"mongoose\">{{ errors.username }}</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Company</label><input class=\"form-control\" type=\"text\" name=\"company\" ng-model=\"user.company\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">Company is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Country</label><select class=\"form-control\" name=\"country\" ng-model=\"user.country\" ng-options=\"x.code as x.name for x in countries\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select><p class=\"help-block\"><error-message on=\"required\">Country is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Language Code</label><select class=\"form-control\" name=\"language\" ng-model=\"user.language\" ng-options=\"x.code as x.name for x in languages\" ie-select-fix=\"ie-select-fix\" required=\"required\"></select><p class=\"help-block\"><error-message on=\"required\">Language is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Password</label><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"user.password\" ie-select-fix=\"ie-select-fix\" required=\"required\"/><p class=\"help-block\"><error-message on=\"required\">Password is required.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label>Confirm Password</label><input class=\"form-control\" type=\"password\" name=\"password1\" ng-model=\"user.password1\" ui-validate=\"{ same : \'$value == user.password\' }\" required=\"required\"/><p class=\"help-block\"><error-message>Password does not match.</error-message></p></div><div class=\"form-group\" set-error-style=\"set-error-style\"><label style=\"font-size:15px;\">Terms</label><input type=\"checkbox\" name=\"consent\" ng-model=\"user.consent\" style=\"margin-left:15px;\" ng-click=\"termsOfUseOpen($event)\" ng-checked=\"user.consent\"/></div><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"form.email.$error.required &amp;&amp; form.password.$error.required &amp;&amp; submitted\">Please enter your email and password.</p><p class=\"help-block\">{{ errors.other }}</p></div><button class=\"btn btn-primary btn-lg btn-login\" ng-show=\"tokenIsValid\">Submit</button></form></div><div class=\"alert alert-danger\" ng-hide=\"loading || tokenIsValid\">Token is not valid, please go to signup page and try again</div></div>");
$templateCache.put("app/account/contact-us/contact-us.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-sm-8 col-sm-offset-2\"><h3>Contact Us</h3><div class=\"alert {{\'alert-\' + (alert.type || \'success\')}}\" alert=\"\" ng-repeat=\"alert in alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div><br/><form class=\"form\" name=\"messageForm\" ng-submit=\"submit()\" novalidate=\"\"><div class=\"form-group\"><label>Name</label><input class=\"input-primary form-control\" type=\"text\" name=\"name\" ng-model=\"message.name\" required=\"\"/></div><div class=\"form-group\"><label>Email</label><input class=\"input-primary form-control\" type=\"text\" name=\"email\" ng-model=\"message.email\" required=\"\"/></div><div class=\"form-group\"><label>Company</label><input class=\"input-primary form-control\" type=\"text\" name=\"company\" ng-model=\"message.company\" required=\"\"/></div><div class=\"form-group\"><label>Job Title</label><input class=\"input-primary form-control\" type=\"text\" name=\"jobTitle\" ng-model=\"message.jobTitle\" required=\"\"/></div><div class=\"form-group\"><label>Phone</label><input class=\"input-primary form-control\" type=\"text\" name=\"phone\" ng-model=\"message.phone\" required=\"\"/></div><div class=\"form-group\"><label>Message</label><textarea class=\"input-primary form-control\" rows=\"5\" name=\"message\" ng-model=\"message.message\" required=\"\"></textarea></div><div class=\"form-group\"><div vc-recaptcha=\"vc-recaptcha\" theme=\"\'light\'\" key=\"model.key\" on-create=\"setWidgetId(widgetId)\" on-success=\"setResponse(response)\" on-expire=\"cbExpiration()\"></div></div><div class=\"form-group\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!response\" translate=\"translate\">Send</button></div></form></div></div></div>");
$templateCache.put("app/account/change-email/change-email.html", "<div ng-include=\"&quot;components/header/header-type-3.html&quot;\"></div><div ng-include=\"&quot;components/navbar/navbar.html&quot;\"></div><div class=\"container\"><div class=\"row\"><section class=\"text-center\" ng-show=\"tokenIsValid\"><h3 translate=\"translate\">Token is not valid, go to your settings page and try change email aganin</h3><a class=\"btn btn-link\" href=\"/settings\" translate=\"translate\">Settings</a></section></div></div>");
}]);